"use strict";
var ECP;
(function (ECP) {
    let EC_SortOrder;
    (function (EC_SortOrder) {
        EC_SortOrder[EC_SortOrder["Asc"] = 1] = "Asc";
        EC_SortOrder[EC_SortOrder["Desc"] = 2] = "Desc";
    })(EC_SortOrder = ECP.EC_SortOrder || (ECP.EC_SortOrder = {}));
    class EC_TableView {
        constructor(TableName) {
            this.TableName = TableName;
        }
        SetMaxRecords(MaxRecords) {
            this.SelectMaxRecords = MaxRecords;
        }
        SetSubTableMaxRecords(SubMaxRecords) {
            this.SubSelectMaxRecords = SubMaxRecords;
        }
        SetCurValue(CurValue) {
            this.CurValue = CurValue;
        }
        SetStartRecordCount(StartRecordCount) {
            this.StartRecordCount = StartRecordCount;
        }
        SetFormat(Format) {
            this.Format = Format;
        }
        SetTitleBar(TitleBar) {
            this.TitleBar = TitleBar;
        }
        SetUseJSLinks(useJSLinks) {
            this.useJSLinks = useJSLinks;
        }
        SetPagination(Pagination) {
            this.Pagination = Pagination;
        }
        SetRowActions(RowActions) {
            this.RowActions = RowActions;
        }
        SetEnableLogging(enableLogging) {
            this.EnableLogging = enableLogging;
        }
        SetSubTable(SubTable) {
            this.SubTable = SubTable;
        }
        SetDisableSingleRecordView(DisableSingleRecordView) {
            this.DisableSingleRecordView = DisableSingleRecordView;
        }
        AddColumn(ColumnName) {
            if (EC_Fmt.isNull(this.SelectDisplayInParent)) {
                this.SelectDisplayInParent = [];
            }
            if (this.SelectDisplayInParent.indexOf(ColumnName) === -1) {
                this.SelectDisplayInParent.push(ColumnName);
            }
            else {
                throw Error("Column '" + ColumnName + "' has already been added to this EC_TableView object, cannot add the same column twice.");
            }
        }
        AddSubTableJoinID(TableJoinID) {
            if (EC_Fmt.isNull(this.SubTableJoinIDArr)) {
                this.SubTableJoinIDArr = [];
            }
            if (this.SubTableJoinIDArr.indexOf(TableJoinID) === -1) {
                this.SubTableJoinIDArr.push(TableJoinID);
            }
            else {
                throw Error("TableJoinID '" + TableJoinID + "' has already been added to this EC_TableView object, cannot add the same sub-table twice.");
            }
        }
        AddSubTableColumn(TableJoinID, ColumnName) {
            if (typeof (this.SelectDisplayInSub) === "undefined") {
                this.SelectDisplayInSub = [];
            }
            if (EC_Fmt.isNull(this.SelectDisplayInSub[TableJoinID])) {
                this.SelectDisplayInSub[TableJoinID] = [];
            }
            if (this.SelectDisplayInSub[TableJoinID].indexOf(ColumnName) === -1) {
                this.SelectDisplayInSub[TableJoinID].push(ColumnName);
            }
            else {
                throw Error("TableJoinID '" + ColumnName + "' has already been added to this EC_TableView object for TableJoinID '" + TableJoinID + "', cannot add the same sub-table column twice.");
            }
        }
        AddSelectSort(FieldName, SortOrder) {
            if (EC_Fmt.isNull(this.SelectSort)) {
                this.SelectSort = [];
            }
            let sortString;
            if (SortOrder === EC_SortOrder.Desc) {
                sortString = FieldName + ".Desc";
            }
            else {
                sortString = FieldName;
            }
            if (this.SelectSort.indexOf(sortString) === -1) {
                this.SelectSort.push(sortString);
            }
        }
        AddFilter(Name, Value, Operator) {
            if (EC_Fmt.isNull(this.Filters)) {
                this.Filters = [];
            }
            if (this.Filters.filter(function (value) { return value.Name === Name; }).length > 0) {
                throw Error("Filter for '" + Name + "' has already been added to this EC_TableView object, cannot filter on the same column twice.");
            }
            else {
                this.Filters.push({
                    Name,
                    Value,
                    Verb: ECP.EC_Verb.Get,
                    Operator
                });
            }
        }
        GetResults() {
            if (EC_Fmt.isNull(this.TableName)) {
                throw Error("Table Name is a required value to use EC_TableView.");
            }
            if (this.SelectMaxRecords > 5000) {
                throw Error("Maximum number of records that can be returned from table view is 5000.");
            }
            if (this.SubSelectMaxRecords > 1000) {
                throw Error("Maximum number of records that can be returned in the sub-table of a table view is 1000");
            }
            this.myRequest = new ECP.EC_Request("TableView");
            this.myRequest.AddRequestVariable("TableName", this.TableName, ECP.EC_Verb.Get);
            if (!EC_Fmt.isNull(this.SelectMaxRecords)) {
                this.myRequest.AddRequestVariable("SelectMaxRecords", this.SelectMaxRecords.toString(), ECP.EC_Verb.Get);
            }
            if (!EC_Fmt.isNull(this.SubSelectMaxRecords)) {
                this.myRequest.AddRequestVariable("SubSelectMaxRecords", this.SubSelectMaxRecords.toString(), ECP.EC_Verb.Get);
            }
            if (!EC_Fmt.isNull(this.CurValue)) {
                this.myRequest.AddRequestVariable("CurValue", this.CurValue, ECP.EC_Verb.Get);
            }
            if (EC_Fmt.isNumber(this.StartRecordCount) && this.StartRecordCount > 0) {
                this.myRequest.AddRequestVariable("StartRecordCount", this.StartRecordCount.toString(), ECP.EC_Verb.Get);
            }
            if (EC_Fmt.isNull(this.Format)) {
                this.Format = "json";
            }
            this.myRequest.AddRequestVariable("Format", this.Format, ECP.EC_Verb.Get);
            if (this.TitleBar) {
                this.myRequest.AddRequestVariable("TitleBar", "1", ECP.EC_Verb.Get);
            }
            if (this.useJSLinks) {
                this.myRequest.AddRequestVariable("useJSLinks", "1", ECP.EC_Verb.Get);
            }
            if (this.Pagination) {
                this.myRequest.AddRequestVariable("Pagination", "1", ECP.EC_Verb.Get);
            }
            if (this.RowActions) {
                this.myRequest.AddRequestVariable("RowActions", "1", ECP.EC_Verb.Get);
            }
            if (this.DisableSingleRecordView) {
                this.myRequest.AddRequestVariable("DisableSingleRecordView", "1", ECP.EC_Verb.Get);
            }
            if (this.Format.toLowerCase() !== "json") {
                this.myRequest.ReturnType = ECP.EC_ReturnType.Text;
            }
            if (this.EnableLogging) {
                this.myRequest.ReturnType = ECP.EC_ReturnType.Text;
                this.myRequest.AddRequestVariable("EnableLogging", "True", ECP.EC_Verb.Get);
            }
            if (this.Embeded) {
                this.myRequest.AddRequestVariable("EmbededDialog", "True", ECP.EC_Verb.Get);
            }
            if (EC_Fmt.MultipleSelected(this.SelectDisplayInParent)) {
                this.myRequest.AddRequestVariable("SelectDisplayInParent", this.SelectDisplayInParent.join(","), ECP.EC_Verb.Get);
            }
            if (EC_Fmt.MultipleSelected(this.SubTableJoinIDArr)) {
                this.myRequest.AddRequestVariable("SubTableJoinID", this.SubTableJoinIDArr.join(","), ECP.EC_Verb.Get);
            }
            if (this.SubTable) {
                this.myRequest.AddRequestVariable("SubTable", this.SubTable, ECP.EC_Verb.Get);
            }
            let SelectDisplayInSubs = "";
            for (const TableName in this.SelectDisplayInSub) {
                if (SelectDisplayInSubs !== "") {
                    SelectDisplayInSubs += ",";
                }
                if (this.SelectDisplayInSub.hasOwnProperty(TableName)) {
                    SelectDisplayInSubs += `${TableName}|${this.SelectDisplayInSub[TableName].join("|")}`;
                }
            }
            if (SelectDisplayInSubs) {
                this.myRequest.AddRequestVariable("SelectDisplayInSubs", SelectDisplayInSubs, ECP.EC_Verb.Get);
            }
            if (EC_Fmt.MultipleSelected(this.SelectSort)) {
                this.myRequest.AddRequestVariable("SelectSort", this.SelectSort.join(","), ECP.EC_Verb.Get);
            }
            if (!EC_Fmt.isNull(this.Filters) && !EC_Fmt.isNull(this.Filters[0])) {
                this.myRequest.Parameters = this.Filters;
            }
            if (!EC_Fmt.isNull(this.QueryString)) {
                this.myRequest.QueryString = this.QueryString;
            }
            return this.myRequest.Submit();
        }
        Abort() {
            this.myRequest.Abort();
        }
        GetTableViewHTML() {
            const Me = this;
            return new Promise((resolve, reject) => {
                Me.Format = "SDK";
                Me.Embeded = true;
                Me.GetResults().then((data) => {
                    resolve(data.toString());
                }).catch((data) => {
                    reject(data.toString());
                });
            });
        }
        FillWithTableView(Container) {
            this.GetTableViewHTML().then((data) => {
                Container.innerHTML = data;
                const scripts = Array.from(Container.querySelectorAll("script"));
                EC_Fmt.ReLoadScripts(scripts, () => {
                    const NewTableView = Container.querySelector("#TableView,#TableEdit");
                    if (NewTableView && EWS && (!EWS.TableViews || !EWS.TableViews[NewTableView.getAttribute("tableName")])) {
                        if (!EWS.TableViews) {
                            EWS.TableViews = {};
                        }
                        EWS.TableViews[NewTableView.getAttribute("tableName")] = new TableView(NewTableView);
                    }
                });
            }).catch((error) => {
                ECP.Dialog.Alert(error);
            });
        }
    }
    ECP.EC_TableView = EC_TableView;
})(ECP || (ECP = {}));
function HTMLSafeScript(ScriptID, html) {
    if (document.currentScript) {
        document.currentScript.parentElement.innerHTML = html;
    }
    else {
        document.getElementById(ScriptID).parentElement.innerHTML = html;
    }
}
var ECP;
(function (ECP) {
    var _a;
    let DataType;
    (function (DataType) {
        DataType[DataType["_APICall"] = 5] = "_APICall";
        DataType[DataType["_AutoNumber"] = 10] = "_AutoNumber";
        DataType[DataType["_Barcode"] = 20] = "_Barcode";
        DataType[DataType["_BigInt"] = 30] = "_BigInt";
        DataType[DataType["_CaseBottle"] = 40] = "_CaseBottle";
        DataType[DataType["_Color"] = 50] = "_Color";
        DataType[DataType["_Currency"] = 60] = "_Currency";
        DataType[DataType["_Date"] = 70] = "_Date";
        DataType[DataType["_DateLocalTime"] = 80] = "_DateLocalTime";
        DataType[DataType["_DateMonthYear"] = 85] = "_DateMonthYear";
        DataType[DataType["_DateTime"] = 90] = "_DateTime";
        DataType[DataType["_DayOfWeek"] = 100] = "_DayOfWeek";
        DataType[DataType["_Decimal"] = 110] = "_Decimal";
        DataType[DataType["_DocumentURL"] = 120] = "_DocumentURL";
        DataType[DataType["_EAN13"] = 130] = "_EAN13";
        DataType[DataType["_Email"] = 140] = "_Email";
        DataType[DataType["_Encrypted"] = 145] = "_Encrypted";
        DataType[DataType["_File"] = 150] = "_File";
        DataType[DataType["_FileSize"] = 160] = "_FileSize";
        DataType[DataType["_GTIN"] = 170] = "_GTIN";
        DataType[DataType["_Hyperlink"] = 180] = "_Hyperlink";
        DataType[DataType["_HTML"] = 190] = "_HTML";
        DataType[DataType["_Identity"] = 200] = "_Identity";
        DataType[DataType["_Integer"] = 210] = "_Integer";
        DataType[DataType["_Link"] = 220] = "_Link";
        DataType[DataType["_LocalTime"] = 230] = "_LocalTime";
        DataType[DataType["_MapPolygon"] = 240] = "_MapPolygon";
        DataType[DataType["_MonthAbbr"] = 250] = "_MonthAbbr";
        DataType[DataType["_MonthDay"] = 260] = "_MonthDay";
        DataType[DataType["_MonthName"] = 270] = "_MonthName";
        DataType[DataType["_Months"] = 280] = "_Months";
        DataType[DataType["_None"] = 290] = "_None";
        DataType[DataType["_PalletsCases"] = 300] = "_PalletsCases";
        DataType[DataType["_Password"] = 310] = "_Password";
        DataType[DataType["_Phone"] = 320] = "_Phone";
        DataType[DataType["_PostalCode"] = 330] = "_PostalCode";
        DataType[DataType["_Percentage"] = 340] = "_Percentage";
        DataType[DataType["_Signature"] = 350] = "_Signature";
        DataType[DataType["_Time"] = 360] = "_Time";
        DataType[DataType["_Text"] = 370] = "_Text";
        DataType[DataType["_TextArea"] = 375] = "_TextArea";
        DataType[DataType["_TextDoubleSpace"] = 380] = "_TextDoubleSpace";
        DataType[DataType["_TextEncoded"] = 390] = "_TextEncoded";
        DataType[DataType["_TextNoSpace"] = 400] = "_TextNoSpace";
        DataType[DataType["_TimeZone"] = 410] = "_TimeZone";
        DataType[DataType["_UPC"] = 420] = "_UPC";
        DataType[DataType["_UPCA"] = 430] = "_UPCA";
        DataType[DataType["_UPCE"] = 440] = "_UPCE";
        DataType[DataType["_WeekLocalTime"] = 450] = "_WeekLocalTime";
        DataType[DataType["_YearMonth"] = 460] = "_YearMonth";
        DataType[DataType["_YesNo"] = 470] = "_YesNo";
        DataType[DataType["_RelativeTime"] = 480] = "_RelativeTime";
    })(DataType = ECP.DataType || (ECP.DataType = {}));
    let Browser;
    (function (Browser) {
        Browser[Browser["Chrome"] = 1] = "Chrome";
        Browser[Browser["Firefox"] = 2] = "Firefox";
        Browser[Browser["Opera"] = 3] = "Opera";
        Browser[Browser["IE"] = 4] = "IE";
        Browser[Browser["Safari"] = 5] = "Safari";
        Browser[Browser["Edge"] = 6] = "Edge";
        Browser[Browser["Unknown"] = 100] = "Unknown";
    })(Browser = ECP.Browser || (ECP.Browser = {}));
    class Format {
        constructor() {
            this.LocaleStrings = {};
            this._userDateFormat = -1;
            this._userTimeFormat = -1;
            this._userPhoneFormat = 0;
            this._userCurrencyDecimals = -1;
            this._pageParametersCache = null;
            this._pageParametersCacheKey = null;
            this._TaskIDRegex = /^(Task|EC|EM|OB|Ticket)[ -]#?[0-9]{2,9}/gi;
            this._KantataProjectRegex = /^Project [0-9]{3}-[A-Za-z0-9]{3,12} - .{5,}/gi;
        }
        get userLanguage() {
            if (this._userLanguage === undefined) {
                const myHtmlElement = document.getElementById("UserLanguage");
                if (this.isNull(myHtmlElement)) {
                    this._userLanguage = "";
                }
                else {
                    this._userLanguage = this.NullChk(myHtmlElement.value, "");
                }
                if (this._userLanguage === "") {
                    this._userLanguage = "EN";
                }
                this._userLanguage = this.Left(this._userLanguage, 2);
            }
            return this._userLanguage;
        }
        get userDateFormat() {
            if (this._userDateFormat === -1) {
                const myHtmlElement = document.getElementById("UserDateFormat");
                if (this.isNull(myHtmlElement)) {
                    this._userDateFormat = 0;
                }
                else {
                    this._userDateFormat = this.NullChk(Number(myHtmlElement.value), 0);
                }
            }
            return this._userDateFormat;
        }
        get userTimeFormat() {
            if (this._userTimeFormat === -1) {
                const myHtmlElement = document.getElementById("UserTimeFormat");
                if (this.isNull(myHtmlElement)) {
                    this._userTimeFormat = 0;
                }
                else {
                    this._userTimeFormat = this.NullChk(Number(myHtmlElement.value), 0);
                }
            }
            return this._userTimeFormat;
        }
        get userPhoneFormat() {
            if (this._userPhoneFormat === 0) {
                const myHtmlElement = document.getElementById("UserPhoneFormat");
                if (this.isNull(myHtmlElement)) {
                    this._userPhoneFormat = 0;
                }
                else {
                    this._userPhoneFormat = this.NullChk(Number(myHtmlElement.value), 0);
                }
            }
            return this._userPhoneFormat;
        }
        get userCurrencySymbol() {
            if (this._userCurrencySymbol === undefined) {
                const myHtmlElement = document.getElementById("UserCurrencySymbol");
                if (this.isNull(myHtmlElement)) {
                    this._userCurrencySymbol = "$";
                }
                else {
                    this._userCurrencySymbol = this.NullChk(myHtmlElement.value, "$");
                }
            }
            return this._userCurrencySymbol;
        }
        get userCurrencyDecimals() {
            if (this._userCurrencyDecimals === -1) {
                const myHtmlElement = document.getElementById("UserCurrencyDecimals");
                if (this.isNull(myHtmlElement)) {
                    this._userCurrencyDecimals = 2;
                }
                else {
                    this._userCurrencyDecimals = this.NullChk(Number(myHtmlElement.value), 2);
                }
            }
            return this._userCurrencyDecimals;
        }
        get userCurrencyGroupDigits() {
            if (this._userCurrencyGroupDigits === undefined) {
                const myHtmlElement = document.getElementById("UserCurrencyGroupDigits");
                if (this.isNull(myHtmlElement)) {
                    this._userCurrencyGroupDigits = true;
                }
                else {
                    this._userCurrencyGroupDigits = this.NullChk(myHtmlElement.value, true);
                }
            }
            return this._userCurrencyGroupDigits;
        }
        get userCurrencyUseParForNeg() {
            if (this._userCurrencyUseParForNeg === undefined) {
                const myHtmlElement = document.getElementById("UserCurrencyUseParForNeg");
                if (this.isNull(myHtmlElement)) {
                    this._userCurrencyUseParForNeg = true;
                }
                else {
                    this._userCurrencyUseParForNeg = this.NullChk(myHtmlElement.value, true);
                }
            }
            return this._userCurrencyUseParForNeg;
        }
        get MonthNames() {
            return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        }
        get Browser() {
            if (this._Browser === undefined) {
                const agent = navigator.userAgent.toLowerCase();
                if (/chrome/i.test(agent)) {
                    this._Browser = ECP.Browser.Chrome;
                }
                else if (/safari/i.test(agent)) {
                    this._Browser = ECP.Browser.Safari;
                }
                else if (/firefox/i.test(agent)) {
                    this._Browser = ECP.Browser.Firefox;
                }
                else {
                    this._Browser = ECP.Browser.Unknown;
                }
            }
            return this._Browser;
        }
        get BrowserVersion() {
            if (this._BrowserVersion === undefined) {
                let tmpVersion;
                switch (this.Browser) {
                    case ECP.Browser.Chrome:
                        tmpVersion = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
                        if (this.MultipleSelected(tmpVersion) && tmpVersion.length >= 3) {
                            this._BrowserVersion = tmpVersion[2];
                        }
                        else {
                            this._BrowserVersion = null;
                        }
                        break;
                    case ECP.Browser.Safari:
                        tmpVersion = navigator.userAgent.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//);
                        if (this.MultipleSelected(tmpVersion) && tmpVersion.length >= 2) {
                            this._BrowserVersion = tmpVersion[1];
                        }
                        else {
                            this._BrowserVersion = null;
                        }
                        break;
                    case ECP.Browser.Firefox:
                        const agentArr = navigator.userAgent.split("/");
                        this._BrowserVersion = agentArr[agentArr.length - 1];
                        break;
                    default:
                        this._BrowserVersion = null;
                        break;
                }
            }
            if (this._BrowserVersion === null) {
                const itemArr = navigator.userAgent.match(/version\/(\d+)/i);
                if (this.MultipleSelected(itemArr) && itemArr.length >= 2) {
                    this._BrowserVersion = itemArr[1];
                }
                else {
                    this._BrowserVersion = "";
                }
            }
            return this._BrowserVersion;
        }
        get isMobile() {
            if (this._isMobile === undefined) {
                const agent = navigator.userAgent.toLowerCase();
                if (/android|iphone|ipad|ipod/i.test(agent)) {
                    this._isMobile = true;
                }
                else {
                    this._isMobile = false;
                }
            }
            return this._isMobile;
        }
        get isIOS() {
            if (this._isIOS === undefined) {
                this._isIOS = /(iPad|iPhone|iPod)/.test(navigator.userAgent);
            }
            return this._isIOS;
        }
        get isIPad() {
            if (this._isIPad === undefined) {
                this._isIPad = /(iPad)/.test(navigator.userAgent) || (/(Macintosh)/.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
            }
            return this._isIPad;
        }
        get isMac() {
            if (this._isMac === undefined) {
                this._isMac = /(Macintosh)/.test(navigator.userAgent);
            }
            return this._isMac;
        }
        get isAndroid() {
            if (this._isAndroid === undefined) {
                this._isAndroid = /(Android)/g.test(navigator.userAgent);
            }
            return this._isAndroid;
        }
        DataTypeParse(DataTypeStr) {
            if (this.isNull(DataTypeStr)) {
                return DataType._None;
            }
            return DataType[`_${DataTypeStr.replace("_", "").replace("/", "")}`];
        }
        isNull(value) {
            if (value === undefined || value === null || value.toString().length === 0 || value.toString().toLowerCase() === "null") {
                return true;
            }
            else {
                return false;
            }
        }
        NullChk(value, replacement) {
            if (this.isNull(value)) {
                return replacement;
            }
            else {
                return value;
            }
        }
        NullChkStr(value, replacement) {
            return this.NullChk(value, replacement).toString();
        }
        Null2EmptyStr(value) {
            return this.NullChkStr(value, "");
        }
        Null2NullStr(value) {
            return this.NullChkStr(value, "Null");
        }
        Null2Zero(value) {
            return this.NullChkStr(value, "0");
        }
        Null2ZeroInt(value) {
            value = this.NullChkStr(value, "0");
            if (this.isInteger(value)) {
                return Number(this.CleanNumberStr(value));
            }
            return 0;
        }
        CDec(value) {
            if (typeof value === "number") {
                return value;
            }
            else if (this.isNumber(value)) {
                return parseFloat(this.CleanNumberStr(value));
            }
            else {
                return 0;
            }
        }
        isNumber(value) {
            if (this.isNull(value) || value.toString().trim() === "" || value !== value) {
                return false;
            }
            if (typeof value === "number") {
                return true;
            }
            if (this._containsAlphaCharacterPattern === undefined) {
                this._containsAlphaCharacterPattern = /[a-zABD-Z]/g;
                this._currencySymbolPattern = /[$£€¥￥₱]|(kr)/g;
            }
            if (value.match(this._containsAlphaCharacterPattern) && !value.match(this._currencySymbolPattern)) {
                return false;
            }
            return !isNaN(Number(this.CleanNumberStr(value.toString())));
        }
        CleanNumberStr(value) {
            if (value === null || value === undefined) {
                return undefined;
            }
            if (this._numberReplacePattern === undefined) {
                this._numberReplacePattern = /(NZ\$)|([ACRS]\$)|(US\$)|[$£€¥￥₱%,]|(kr)|(CHF)/gi;
                this._numberSurroundingParenthesesPattern = /^\(\d+\.?\d*\)$/;
                this._numberReplaceParenthesesPattern = /[\(\)]/g;
            }
            value = value.toString().replace(this._numberReplacePattern, "").trim();
            if (value.match(this._numberSurroundingParenthesesPattern)) {
                return `-${value.replace(this._numberReplaceParenthesesPattern, "")}`;
            }
            try {
                if (/[^0-9\s+*/.()-]/.test(value)) {
                    return value;
                }
                value = value.replace(/^(-?)0+(?=\d)/, "$1");
                const actionFn = new Function("return " + value);
                return actionFn().toString();
            }
            catch (err) {
                return value;
            }
        }
        isInteger(value) {
            if (!this.isNumber(value)) {
                return false;
            }
            if (Number(this.CleanNumberStr(value.toString())) % 1 === 0) {
                return true;
            }
            return false;
        }
        Round(value, decimalPlaces) {
            if (!this.isNumber(value)) {
                return undefined;
            }
            value = this.CleanNumberStr(value.toString());
            return Number(Number(value).toFixed(this.NullChk(decimalPlaces, 0)));
        }
        Left(value, n) {
            if (n <= 0) {
                return "";
            }
            else if (this.isNull(value)) {
                return "";
            }
            else if (n > value.toString().length) {
                return value.toString();
            }
            else {
                return value.toString().substring(0, n);
            }
        }
        Right(value, n) {
            if (n <= 0) {
                return "";
            }
            else if (this.isNull(value)) {
                return "";
            }
            else if (n > value.toString().length) {
                return value.toString();
            }
            else {
                const stringLength = value.toString().length;
                return value.toString().substring(stringLength, stringLength - n);
            }
        }
        ReplaceAll(value, find, replaceWith) {
            if (!value) {
                return "";
            }
            if (!find) {
                return value;
            }
            if (replaceWith === null || replaceWith === undefined) {
                replaceWith = "";
            }
            return value.replace(new RegExp(find.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, "\\$&"), "g"), replaceWith.replace(/\$/g, "$$$$"));
        }
        Split(value, characters) {
            for (let i = 1; i < characters.length; i++) {
                value = this.ReplaceAll(value, characters[i], characters[0]);
            }
            return value.split(characters[0]);
        }
        HtmlStrToElement(html) {
            const template = document.createElement("template");
            template.innerHTML = html.toString().trim();
            return template.content.firstChild;
        }
        SetLocalStorageValue(cacheKey, value, expiresInMinutes) {
            const expiry = expiresInMinutes ? (new Date()).getTime() + (expiresInMinutes * 60 * 1000) : null;
            try {
                localStorage.setItem(cacheKey, JSON.stringify({ value, expiry }));
                return true;
            }
            catch (err) {
                return false;
            }
        }
        GetLocalStorageValue(cacheKey) {
            const itemStr = localStorage.getItem(cacheKey);
            if (!itemStr) {
                return null;
            }
            const item = JSON.parse(itemStr);
            if (!item) {
                return null;
            }
            if (item.expiry && (new Date()).getTime() > item.expiry) {
                localStorage.removeItem(cacheKey);
                return null;
            }
            return item.value;
        }
        TriggerEvent(element, type, OtherAttributes_ForTheEvent) {
            let myEvent;
            OtherAttributes_ForTheEvent = Object.assign({
                bubbles: false,
                cancelable: true
            }, OtherAttributes_ForTheEvent);
            switch (type.toLowerCase()) {
                case "auxclick":
                case "click":
                case "contextmenu":
                case "dblclick":
                case "mousedown":
                case "mouseenter":
                case "mouseleave":
                case "mousemove":
                case "mouseover":
                case "mouseout":
                case "mouseup":
                case "pointerlockchange":
                case "pointerlockerror":
                case "select":
                case "wheel":
                    OtherAttributes_ForTheEvent.view = window;
                    myEvent = new MouseEvent(type, OtherAttributes_ForTheEvent);
                    break;
                case "keydown":
                case "keypress":
                case "keyup":
                    OtherAttributes_ForTheEvent.view = window;
                    myEvent = new KeyboardEvent(type, OtherAttributes_ForTheEvent);
                    break;
                case "cut":
                case "copy":
                case "paste":
                    myEvent = new ClipboardEvent(type, OtherAttributes_ForTheEvent);
                    break;
                case "resize":
                    OtherAttributes_ForTheEvent.view = window;
                    myEvent = new UIEvent(type, OtherAttributes_ForTheEvent);
                    break;
                case "transitionstart":
                case "transitioncancel":
                case "transitionend":
                case "transitionrun":
                    myEvent = new TransitionEvent(type, OtherAttributes_ForTheEvent);
                    break;
                case "animationstart":
                case "animationcancel":
                case "animationend":
                case "animationiteration":
                    myEvent = new AnimationEvent(type, OtherAttributes_ForTheEvent);
                    break;
                case "focus":
                case "blur":
                case "focusin":
                case "focusout":
                    OtherAttributes_ForTheEvent.view = window;
                    myEvent = new FocusEvent(type, OtherAttributes_ForTheEvent);
                    break;
                case "drag":
                case "dragend":
                case "dragenter":
                case "dragstart":
                case "dragleave":
                case "dragover":
                case "drop":
                    OtherAttributes_ForTheEvent.view = window;
                    myEvent = new DragEvent(type, OtherAttributes_ForTheEvent);
                    break;
                default:
                    myEvent = new Event(type, OtherAttributes_ForTheEvent);
                    break;
            }
            return element.dispatchEvent(myEvent);
        }
        OpenWithCtrlClickSupport(event, url, myWindow) {
            if (event.ctrlKey || event.metaKey) {
                window.open(url);
            }
            else if (event.shiftKey) {
                window.open(url, "_blank", "resizable,scrollbars,status");
            }
            else if (myWindow) {
                myWindow.location.href = url;
            }
            else {
                window.location.href = url;
            }
        }
        RemoveAllEventListeners(element) {
            const NewElement = element.cloneNode(true);
            element.parentElement.replaceChild(NewElement, element);
            element = NewElement;
            return element;
        }
        GetFullWidth(element, includeMargin) {
            const Style = window.getComputedStyle(element);
            const Width = element.offsetWidth;
            const Padding = parseFloat(Style.paddingLeft) + parseFloat(Style.paddingRight);
            const Border = parseFloat(Style.borderLeftWidth) + parseFloat(Style.borderRightWidth);
            let Margin;
            if (includeMargin) {
                Margin = parseFloat(Style.marginLeft) + parseFloat(Style.marginRight);
            }
            else {
                Margin = 0;
            }
            return (Width + Margin - Padding + Border);
        }
        GetFullHeight(element, includeMargin) {
            const Style = window.getComputedStyle(element);
            const Height = element.offsetHeight;
            const Padding = parseFloat(Style.paddingTop) + parseFloat(Style.paddingBottom);
            const Border = parseFloat(Style.borderTopWidth) + parseFloat(Style.borderBottomWidth);
            let Margin;
            if (includeMargin) {
                Margin = parseFloat(Style.marginTop) + parseFloat(Style.marginBottom);
            }
            else {
                Margin = 0;
            }
            return (Height + Margin - Padding + Border);
        }
        isVisible(element) {
            return element && element.offsetWidth > 0 && element.offsetHeight > 0;
        }
        ChkDate(value) {
            let isDate = (!isNaN(value) && value instanceof Date);
            if (!isDate && !this.isNull(value)) {
                const tmpDate = this.ToDate(value);
                if (!isNaN(tmpDate) && typeof tmpDate !== "undefined") {
                    isDate = true;
                }
            }
            return isDate;
        }
        ToDate(value) {
            if (value instanceof Date) {
                return value;
            }
            else {
                let myDate;
                let str = this.Null2EmptyStr(value);
                if (this._dotPattern === undefined) {
                    this._dotPattern = /^([0123]{0,1}\d)\.([01]{0,1}\d)\.(\d{4}(\d{2})?)(\s([012]{0,1}\d):([0-5]{0,1}\d)(:([0-5]{0,1}\d))?(\s[a,A,p,P][m,M])?)?$/;
                    this._slashPattern = /^([01]{0,1}\d)\/([0123]{0,1}\d)\/(\d{2}(\d{2})?)(\s([012]{0,1}\d):([0-5]{0,1}\d)(:([0-5]{0,1}\d))?(\s[a,A,p,P][m,M])?)?$/;
                    this._dashPattern = /^(\d{2}(\d{2})?)-([01]{0,1}\d)-([0123]{0,1}\d)([\s,T]([012]{0,1}\d):([0-5]{0,1}\d)(:([0-5]{0,1}\d))?((\s[a,A,p,P][m,M])?|Z)?)?$/;
                    this._noSpacesPattern = /^(\d{4})([01]\d)([0123]\d)(([012]\d)([0-5]\d)([0-5]\d)?)?$/;
                    this._PMPattern = /^\s[p,P][m,M]$/;
                }
                if (str.length >= 6 && str.length <= 23 && (str.indexOf(".") !== -1) && str.match(this._dotPattern)) {
                    const dateArray = this._dotPattern.exec(str);
                    if (dateArray[10] !== undefined && this.userTimeFormat !== 2) {
                        if (dateArray[10].match(this._PMPattern)) {
                            if (dateArray[6] !== "12") {
                                dateArray[6] = (Number(dateArray[6]) + 12).toString();
                            }
                        }
                        else {
                            if (dateArray[6] === "12") {
                                dateArray[6] = "0";
                            }
                        }
                    }
                    if (dateArray[3].length === 2) {
                        if (dateArray[3] === "00") {
                            dateArray[3] = "2000";
                        }
                        else if (this.CDec(dateArray[3]) > 50) {
                            dateArray[3] = "19" + dateArray[3];
                        }
                        else {
                            dateArray[3] = "20" + dateArray[3];
                        }
                    }
                    myDate = this.newDate(dateArray[3], dateArray[2], dateArray[1], dateArray[6], dateArray[7], dateArray[9]);
                }
                else if (str.length >= 6 && str.length <= 23 && str.indexOf("/") !== -1 && str.match(this._slashPattern)) {
                    const dateArray = this._slashPattern.exec(str);
                    if (dateArray[10] !== undefined && this.userTimeFormat !== 2) {
                        if (dateArray[10].match(this._PMPattern)) {
                            if (dateArray[6] !== "12") {
                                dateArray[6] = (Number(dateArray[6]) + 12).toString();
                            }
                        }
                        else {
                            if (dateArray[6] === "12") {
                                dateArray[6] = "0";
                            }
                        }
                    }
                    if (dateArray[3].length === 2) {
                        if (dateArray[3] === "00") {
                            dateArray[3] = "2000";
                        }
                        else if (this.CDec(dateArray[3]) > 50) {
                            dateArray[3] = "19" + dateArray[3];
                        }
                        else {
                            dateArray[3] = "20" + dateArray[3];
                        }
                    }
                    myDate = this.newDate(dateArray[3], dateArray[1], dateArray[2], dateArray[6], dateArray[7], dateArray[9]);
                }
                else if (str.length >= 6 && str.length <= 23 && str.indexOf("-") !== -1 && str.match(this._dashPattern)) {
                    const dateArray = this._dashPattern.exec(str);
                    if (dateArray[10] !== undefined && this.userTimeFormat !== 2) {
                        if (dateArray[10].match(this._PMPattern)) {
                            if (dateArray[6] !== "12") {
                                dateArray[6] = (Number(dateArray[6]) + 12).toString();
                            }
                        }
                        else {
                            if (dateArray[6] === "12") {
                                dateArray[6] = "0";
                            }
                        }
                    }
                    if (dateArray[1].length === 2) {
                        if (dateArray[1] === "00") {
                            dateArray[1] = "2000";
                        }
                        else if (this.CDec(dateArray[1]) > 50) {
                            dateArray[1] = "19" + dateArray[1];
                        }
                        else {
                            dateArray[1] = "20" + dateArray[1];
                        }
                    }
                    myDate = this.newDate(dateArray[1], dateArray[3], dateArray[4], dateArray[6], dateArray[7], dateArray[9]);
                }
                else if ((str.length === 8 || str.length === 12 || str.length === 14) && str.match(this._noSpacesPattern)) {
                    const dateArray = this._noSpacesPattern.exec(str);
                    myDate = this.newDate(dateArray[1], dateArray[2], dateArray[3], dateArray[5], dateArray[6], dateArray[7]);
                }
                else {
                    str = this.ReplaceAll(this.ReplaceAll(this.ReplaceAll(str, ".", ""), "/", ""), "-", "");
                    if (!this.isNumber(str)) {
                        myDate = new Date(value);
                        if (!(myDate instanceof Date) || isNaN(myDate.getTime())) {
                            myDate = undefined;
                        }
                    }
                }
                return myDate;
            }
        }
        newDate(year, month, day, hour, minutes, seconds, milliseconds) {
            if (!this.isInteger(year)) {
                throw new Error("Invalid Date sent to newDate, 'year' is required");
            }
            else if (this.CDec(year) < 100) {
                year = `20${this.CDec(year)}`;
            }
            if (!this.isInteger(month)) {
                throw new Error("Invalid Date sent to newDate, 'month' is required");
            }
            if (!this.isInteger(day)) {
                throw new Error("Invalid Date sent to newDate, 'day' is required");
            }
            return new Date(Number(this.CDec(year)), Number(this.CDec(month)) - 1, Number(this.CDec(day)), Number(this.CDec(hour)), Number(this.CDec(minutes)), Number(this.CDec(seconds)), Number(this.CDec(milliseconds)));
        }
        isEmail(email) {
            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regex.test(String(email).toLowerCase());
        }
        FileSizeConvert(bytes) {
            if (typeof bytes === "undefined") {
                return undefined;
            }
            const threshold = 1000;
            if (Math.abs(bytes) < threshold) {
                return bytes + " B";
            }
            const units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
            let u = -1;
            do {
                bytes /= threshold;
                ++u;
            } while (Math.abs(bytes) >= threshold && u < units.length - 1);
            return `${this.FormatNumber(bytes, 0, 4)} ${units[u]}`;
        }
        FormatNumber(value, minimumDigits, maximumDigits, addCommas) {
            if (!this.isNumber(value)) {
                return "";
            }
            value = this.CleanNumberStr(value.toString());
            minimumDigits = this.NullChk(minimumDigits, 0);
            maximumDigits = this.NullChk(maximumDigits, 6);
            if (maximumDigits >= 6 && (minimumDigits > 5 || this.Round(value, 5) !== this.Round(value, 6))) {
                value = Number(value).toFixed(6);
            }
            else if (maximumDigits >= 5 && (minimumDigits > 4 || this.Round(value, 4) !== this.Round(value, 5))) {
                value = Number(value).toFixed(5);
            }
            else if (maximumDigits >= 4 && (minimumDigits > 3 || this.Round(value, 3) !== this.Round(value, 4))) {
                value = Number(value).toFixed(4);
            }
            else if (maximumDigits >= 3 && (minimumDigits > 2 || this.Round(value, 2) !== this.Round(value, 3))) {
                value = Number(value).toFixed(3);
            }
            else if (maximumDigits >= 2 && (minimumDigits > 1 || this.Round(value, 1) !== this.Round(value, 2))) {
                value = Number(value).toFixed(2);
            }
            else if (maximumDigits >= 1 && (minimumDigits > 0 || this.Round(value) !== this.Round(value, 1))) {
                value = Number(value).toFixed(1);
            }
            else {
                value = Number(value).toFixed(0);
            }
            if (addCommas) {
                value = this.addThousandsSeparatorCommas(value);
            }
            return value;
        }
        IsImage(url) {
            if (this.Right(url, 5).toLowerCase() === ".jpeg") {
                return true;
            }
            switch (this.Right(url, 4).toLowerCase()) {
                case ".jpg":
                case ".png":
                case ".bmp":
                    return true;
            }
            return false;
        }
        HTMLEncode(value) {
            if (this.isNull(value)) {
                return "";
            }
            return value.toString()
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        }
        HTMLDecode(value) {
            if (this.isNull(value)) {
                return "";
            }
            return value.toString()
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&amp;/g, "&");
        }
        JSONEncode(value) {
            if (this.isNull(value)) {
                return "";
            }
            return value.toString()
                .replace(/[\\]/g, "\\\\")
                .replace(/[\"]/g, "\\\"")
                .replace(/[\/]/g, "\\/")
                .replace(/[\b]/g, "\\b")
                .replace(/[\f]/g, "\\f")
                .replace(/[\n]/g, "\\n")
                .replace(/[\r]/g, "\\r")
                .replace(/[\t]/g, "\\t");
        }
        TryDecodeURIComponent(URI) {
            let decodeURI;
            try {
                decodeURI = decodeURIComponent(URI);
            }
            catch {
                decodeURI = URI;
            }
            return decodeURI;
        }
        GetSelectValue(selectElement) {
            const result = [];
            const options = selectElement && selectElement.options;
            let opt;
            for (let i = 0, len = options.length; i < len; i++) {
                opt = options[i];
                if (opt.selected) {
                    result.push(opt.value || opt.text);
                }
            }
            return result;
        }
        GetPageParameter(ParameterName) {
            let CurrentParameterValue;
            const PageParams = this.GetPageParameters();
            const ParameterKeys = Object.keys(PageParams);
            const lowerParameterName = ParameterName.toLowerCase();
            for (let i = 0, len = ParameterKeys.length; i < len; i++) {
                if (ParameterKeys[i].toLowerCase() === lowerParameterName) {
                    CurrentParameterValue = PageParams[ParameterKeys[i]];
                    break;
                }
            }
            return CurrentParameterValue;
        }
        GetPageParameters() {
            const currentUrlKey = window.location.href;
            if (this._pageParametersCacheKey === currentUrlKey && this._pageParametersCache !== null) {
                return this._pageParametersCache;
            }
            let Parameters;
            if (window.PageParameters) {
                Parameters = this.GetDashboardParameters();
            }
            else {
                Parameters = this.GetURLParameters(window.location.search);
            }
            this._pageParametersCache = Parameters;
            this._pageParametersCacheKey = currentUrlKey;
            return Parameters;
        }
        GetDashboardParameters() {
            const Parameters = {};
            const searchKeys = Object.keys(PageParameters.Search);
            for (let i = 0, len = searchKeys.length; i < len; i++) {
                Parameters[searchKeys[i]] = PageParameters.Search[searchKeys[i]].join(",");
            }
            Parameters["Parameters"] = Object.keys(PageParameters.Parameters).map((key) => {
                const parameter = PageParameters.Parameters[key];
                const type = parameter.FieldStoreID ? "S" : "V";
                const value = parameter.FieldStoreID ? parameter.FieldStoreID : parameter.Value;
                return `F:${encodeURIComponent(parameter.Field)}~${type}:${encodeURIComponent(value)}~O:${parameter.Operater}`;
            }).join("|");
            return Parameters;
        }
        GetURLParameters(URL) {
            const Parameters = {};
            let vars;
            URL = URL.split("#")[0];
            if (URL.indexOf("?") !== -1) {
                vars = URL.split("?")[1].split("&");
            }
            else {
                vars = URL.split("&");
            }
            for (let i = 0; i < vars.length; i++) {
                const pair = vars[i].split("=");
                if (!this.isNull(pair[0])) {
                    if (this.isNull(Parameters[pair[0]])) {
                        Parameters[pair[0]] = this.TryDecodeURIComponent(this.Null2EmptyStr(pair[1]));
                    }
                    else {
                        Parameters[pair[0]] += `,${this.TryDecodeURIComponent(this.Null2EmptyStr(pair[1]))}`;
                    }
                }
            }
            return Parameters;
        }
        Get_QueryString(Exclude, Include, AllowParameters, AllowSearch, IncludeIsNull) {
            let QueryStringArr;
            if (window.PageParameters) {
                const PageParameters = this.GetPageParameters();
                QueryStringArr = Object.keys(PageParameters).map(key => `${key}=${(key === "Parameters" || key === "Search" ? PageParameters[key] : encodeURIComponent(PageParameters[key]))}`);
            }
            else {
                QueryStringArr = this.Null2EmptyStr(window.location.search).replace(/^\?|\&$/g, "").split("&");
            }
            return this.GetArr_QueryString(QueryStringArr, Exclude, Include, AllowParameters, AllowSearch, IncludeIsNull);
        }
        GetURL_QueryString(URL, Exclude, Include, AllowParameters, AllowSearch, IncludeIsNull) {
            let QueryStringArr;
            if (URL.indexOf("?") !== -1) {
                QueryStringArr = URL.split("?")[1].split("&");
            }
            else {
                QueryStringArr = URL.split("&");
            }
            return this.GetArr_QueryString(QueryStringArr, Exclude, Include, AllowParameters, AllowSearch, IncludeIsNull);
        }
        GetArr_QueryString(QueryStringArr, Exclude, Include, AllowParameters, AllowSearch, IncludeIsNull) {
            const arrayUnique = (array) => {
                const a = array.concat();
                for (let i = 0; i < a.length; ++i) {
                    for (let j = i + 1; j < a.length; ++j) {
                        if (a[i] === a[j]) {
                            a.splice(j--, 1);
                        }
                    }
                }
                return a;
            };
            AllowParameters = AllowParameters !== false;
            AllowSearch = AllowSearch !== false;
            const QueryString = {};
            const ExcludeArr = this.Null2EmptyStr(Exclude).split(";");
            const CheckExcludes = this.MultipleSelected(ExcludeArr);
            const IncludeArr = this.Null2EmptyStr(Include).split(";");
            const CheckIncludes = this.MultipleSelected(IncludeArr);
            let ParametersValue;
            let SearchValue;
            QueryStringArr.sort();
            for (let i = 0; i < QueryStringArr.length; i++) {
                QueryStringArr[i] = QueryStringArr[i].replace(/\+/g, "%20");
                if (!this.isNull(QueryStringArr[i]) && QueryStringArr[i].indexOf("=") !== -1) {
                    const ValueArr = QueryStringArr[i].split("=");
                    if (ValueArr.length === 2 && !this.isNull(ValueArr[0]) && (IncludeIsNull || !this.isNull(ValueArr[1]))) {
                        const parameterName = ValueArr[0];
                        const newValue = ValueArr[1];
                        if (parameterName !== "WebRequestID" && parameterName !== "RequestDashboardID") {
                            if (parameterName === "Parameters") {
                                if (AllowParameters) {
                                    ParametersValue = decodeURIComponent(newValue);
                                }
                            }
                            else if (parameterName === "Search") {
                                if (AllowSearch) {
                                    SearchValue = decodeURIComponent(newValue);
                                }
                            }
                            else if ((CheckExcludes && ExcludeArr.indexOf(parameterName) === -1)
                                || (CheckIncludes && IncludeArr.indexOf(parameterName) !== -1)) {
                                if (this.isNull(QueryString[parameterName])) {
                                    QueryString[parameterName] = newValue.split(",");
                                }
                                else {
                                    QueryString[parameterName] = arrayUnique([...QueryString[parameterName], ...newValue.split(",")]);
                                }
                            }
                        }
                    }
                }
            }
            if (ParametersValue && ExcludeArr.indexOf("Parameters") === -1) {
                const Params = ParametersValue.split("|");
                const NewParams = [];
                for (let i = 0, len = Params.length; i < len; i++) {
                    if (!this.isNull(Params[i]) && Params[i].split("~").length >= 2) {
                        const ParamName = Params[i].split("~")[0].split(":")[1];
                        const ParamValue = Params[i].split("~")[1].split(":")[1];
                        if (((CheckExcludes && ExcludeArr.indexOf(ParamName) === -1)
                            || (CheckIncludes && (IncludeArr.indexOf(ParamName) !== -1 || IncludeArr.indexOf("Parameters") !== -1))) && (IncludeIsNull || !this.isNull(ParamValue))) {
                            NewParams.push(encodeURIComponent(Params[i]));
                        }
                    }
                }
                if (NewParams.length > 0) {
                    ParametersValue = `Parameters=${NewParams.join("|")}&`;
                }
                else {
                    ParametersValue = "";
                }
            }
            else {
                ParametersValue = "";
            }
            if (SearchValue && ExcludeArr.indexOf("Search") === -1) {
                const Searches = SearchValue.split("|");
                const NewSearches = [];
                for (let i = 0, len = Searches.length; i < len; i++) {
                    if (!this.isNull(Searches[i])) {
                        const SearchName = Searches[i].split("~")[0];
                        if ((CheckExcludes && ExcludeArr.indexOf(SearchName) === -1)
                            || (CheckIncludes && (IncludeArr.indexOf(SearchName) !== -1 || IncludeArr.indexOf("Search") !== -1))) {
                            NewSearches.push(encodeURIComponent(Searches[i]));
                        }
                    }
                }
                if (NewSearches.length > 0) {
                    SearchValue = `Search=${NewSearches.join("|")}&`;
                }
                else {
                    SearchValue = "";
                }
            }
            else {
                SearchValue = "";
            }
            let ReturnString = "";
            for (const Property in QueryString) {
                const Values = QueryString[Property];
                if (!this.isNull(Values)) {
                    ReturnString += `${Property}=${Values.toString()}&`;
                }
            }
            if (ParametersValue) {
                ReturnString += ParametersValue;
            }
            if (SearchValue) {
                ReturnString += SearchValue;
            }
            return ReturnString;
        }
        LoadScript(src, onLoadFunction) {
            const srcArr = src.split("?");
            const srcPath = srcArr[0];
            let srcQueryString = "";
            if (srcArr.length > 1) {
                srcQueryString = srcArr[1];
            }
            let script;
            if (srcPath.endsWith(".css")) {
                const links = document.head.querySelectorAll("link[href]");
                for (let i = 0, len = links.length; i < len; i++) {
                    if (links[i].href.replace(".min.css", ".css").includes(srcPath)) {
                        script = links[i];
                        break;
                    }
                }
            }
            else {
                const scripts = document.head.querySelectorAll("script[src]");
                for (let i = 0, len = scripts.length; i < len; i++) {
                    if (scripts[i].src.replace(".min.js", ".js").includes(srcPath)) {
                        script = scripts[i];
                        break;
                    }
                }
            }
            if (srcQueryString) {
                src += "&";
            }
            else {
                src += "?";
            }
            if (!`&${srcQueryString}`.includes("&v=") && !srcQueryString.includes("FileSignatureMD5=")) {
                src += "v=" + ECPVersion;
            }
            if (!src.startsWith("http") && ReleasedCode) {
                if (srcPath.endsWith(".css")) {
                    src = src.replace(".min.css", ".css").replace(".css", ".min.css");
                }
                else {
                    src = src.replace(".min.js", ".js").replace(".js", ".min.js");
                }
            }
            return new Promise((resolve) => {
                if (!script) {
                    if (srcPath.endsWith(".css")) {
                        script = document.createElement("link");
                        script.rel = "stylesheet";
                        script.href = src;
                    }
                    else {
                        script = document.createElement("script");
                        script.src = src;
                    }
                    script.setAttribute("loaded", "false");
                    script.onload = () => {
                        script.setAttribute("loaded", "true");
                        if (onLoadFunction) {
                            onLoadFunction();
                        }
                        resolve();
                    };
                    document.head.appendChild(script);
                }
                else {
                    if (script.getAttribute("loaded") === "false") {
                        script.addEventListener("load", () => {
                            if (onLoadFunction) {
                                onLoadFunction();
                            }
                            resolve();
                        });
                    }
                    else {
                        if (onLoadFunction) {
                            onLoadFunction();
                        }
                        resolve();
                    }
                }
            });
        }
        ReLoadScripts(scripts, callback) {
            if (scripts && scripts.length > 0) {
                for (let i = 0; i < scripts.length; i++) {
                    let src = scripts[i].src;
                    if (!src) {
                        src = scripts[i].href;
                    }
                    if (!src) {
                        const currentScript = scripts[i];
                        if (currentScript.innerHTML.includes("\"use strict\"")) {
                            const tempScript = document.createElement("script");
                            tempScript.text = currentScript.innerHTML;
                            document.head.appendChild(tempScript).parentElement.removeChild(tempScript);
                        }
                        else {
                            const actionFn = new Function(currentScript.innerHTML);
                            const newContents = actionFn();
                            if (newContents && newContents !== "undefined") {
                                currentScript.outerHTML = newContents;
                            }
                        }
                    }
                    else {
                        ((index) => {
                            this.LoadScript(src, () => {
                                const currentScript = scripts[index];
                                currentScript.parentElement.removeChild(currentScript);
                            });
                        })(i);
                    }
                }
            }
            else if (callback) {
                callback();
            }
        }
        DownloadFileFromURL(url, FileName) {
            const a = document.createElement("a");
            a.href = url;
            if (!this.isNull(FileName)) {
                a.download = FileName;
            }
            else {
                a.download = "";
            }
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        AfterInput(InputElement, length, timeout, callback, executeOnEmptyInput = false) {
            const me = this;
            InputElement.typing = null;
            if (!this.isNumber(length) || length < 0) {
                length = 3;
            }
            if (!this.isNumber(timeout) || timeout < 0) {
                timeout = 500;
            }
            const onInputFunction = () => {
                clearTimeout(InputElement.typing);
                InputElement.typing = setTimeout(() => {
                    clearTimeout(InputElement.typing);
                    if (!me.isNull(callback) && ((executeOnEmptyInput && InputElement.value.length == 0) || InputElement.value.length >= length)) {
                        callback(InputElement, InputElement.value);
                    }
                }, timeout);
            };
            InputElement.addEventListener("input", onInputFunction);
            InputElement.addEventListener("paste", () => {
                requestAnimationFrame(() => {
                    onInputFunction();
                });
            });
            InputElement.addEventListener("blur", () => { clearTimeout(InputElement.typing); });
            return InputElement;
        }
        DateToDayOfWeek(value) {
            switch (value.getDay()) {
                case 0:
                    return "Sun";
                case 1:
                    return "Mon";
                case 2:
                    return "Tue";
                case 3:
                    return "Wed";
                case 4:
                    return "Thu";
                case 5:
                    return "Fri";
                case 6:
                    return "Sat";
            }
            return "";
        }
        IntToDayOfWeek(value) {
            switch (value) {
                case 0:
                    return "Sun";
                case 1:
                    return "Mon";
                case 2:
                    return "Tue";
                case 3:
                    return "Wed";
                case 4:
                    return "Thu";
                case 5:
                    return "Fri";
                case 6:
                    return "Sat";
                default:
                    throw new Error(`Encompass IntToDayOfWeek: value= '${value}' is not between 0 and 6 `);
            }
        }
        MultipleSelected(valueArr) {
            if (this.isNull(valueArr)) {
                return false;
            }
            else if (valueArr.length === 0) {
                return false;
            }
            else if (valueArr.length === 1 && (this.isNull(valueArr[0]) || valueArr[0] === "0")) {
                return false;
            }
            else {
                return true;
            }
        }
        RandomNum(strLength) {
            strLength = this.Null2ZeroInt(strLength);
            return this.Left((Math.random() * Math.pow(10, strLength)).toString(), strLength);
        }
        MathEval(mathExpression, defaultValue) {
            try {
                const code = mathExpression.trim();
                const actionFn = new Function(code.startsWith("return") ? code : `return ${code}`);
                return actionFn();
            }
            catch (err) {
                return defaultValue;
            }
        }
        ;
        Guid() {
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = "-";
            s[13] = "-";
            s[18] = "-";
            s[23] = "-";
            return s.join("");
        }
        getStringDataType(value) {
            if (this.isNull(value)) {
                return DataType._None;
            }
            else if (this.isInteger(value)) {
                return DataType._Integer;
            }
            else if (this.isNumber(value)) {
                return DataType._Decimal;
            }
            else if (this.ChkDate(value)) {
                return DataType._DateTime;
            }
            else {
                switch (value.toString().toLowerCase()) {
                    case "true":
                    case "false":
                    case "yes":
                    case "no":
                        return DataType._YesNo;
                }
            }
            return DataType._Text;
        }
        ArrayNumberToString(valueArr) {
            const returnArr = [];
            for (let i = 0; i < valueArr.length; i++) {
                returnArr.push(String(valueArr[i]));
            }
            return returnArr;
        }
        ArrayStringToNumber(valueArr) {
            const returnArr = [];
            for (let i = 0; i < valueArr.length; i++) {
                returnArr.push(Number(valueArr[i]));
            }
            return returnArr;
        }
        DateAdd(date, interval, units) {
            let result;
            if (date instanceof Date) {
                result = date;
            }
            else {
                result = new Date(date);
            }
            switch (interval.toLowerCase()) {
                case "year":
                    result.setFullYear(result.getFullYear() + units);
                    break;
                case "quarter":
                    result.setMonth(result.getMonth() + 3 * units);
                    break;
                case "month":
                    result.setMonth(result.getMonth() + units);
                    break;
                case "week":
                    result.setDate(result.getDate() + 7 * units);
                    break;
                case "day":
                    result.setDate(result.getDate() + units);
                    break;
                case "hour":
                    result.setTime(result.getTime() + units * 3600000);
                    break;
                case "minute":
                    result.setTime(result.getTime() + units * 60000);
                    break;
                case "second":
                    result.setTime(result.getTime() + units * 1000);
                    break;
                default:
                    result = undefined;
                    break;
            }
            return result;
        }
        GetCookie(cookieName) {
            const match = document.cookie.match(new RegExp(`(^| )${cookieName}=([^;]+)`));
            if (match) {
                return match[2];
            }
            else {
                return undefined;
            }
        }
        SetCookie(name, value, days) {
            let expires;
            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = `; expires=${date.toUTCString()}`;
            }
            else {
                expires = "";
            }
            document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/`;
        }
        DeleteCookie(cookieName) {
            this.SetCookie(cookieName, "", -1);
        }
        MD5(value) {
            if (this.myMD5 === undefined) {
                this.myMD5 = new Format.MD5Compute();
            }
            return this.myMD5.start().appendStr(value.toString()).end(false).toString();
        }
        File2Base64(File) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(File);
                reader.onload = () => {
                    resolve(reader.result.toString());
                };
                reader.onerror = (error) => {
                    reject(error);
                };
            });
        }
        GetLongitudeLatitude() {
            return new Promise((resolve, reject) => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((p) => {
                        resolve([p.coords.longitude.toString(), p.coords.latitude.toString()]);
                    }, (e) => {
                        reject(["error", e.code, e.message]);
                    });
                }
                else {
                    reject(["error", "000", "Browser now allowing access to Longitude and Latitude"]);
                }
            });
        }
        IsValidSupportTaskMemo(memo) {
            this._TaskIDRegex.lastIndex = 0;
            this._KantataProjectRegex.lastIndex = 0;
            return this._TaskIDRegex.test(memo) || this._KantataProjectRegex.test(memo);
        }
        FixSupportTaskMemo(memo) {
            console.warn('EC_Fmt.FixSupportTaskMemo() is deprecated, it provides no functionality');
            return memo;
        }
        CheckSupportTaskMemoInput(input, editMemoBtn, shake) {
            const memoValue = input.value;
            if (!this.IsValidSupportTaskMemo(memoValue)) {
                const lastEditMemo = this.GetLocalStorageValue("LastEditMemoValue");
                if (!this.IsValidSupportTaskMemo(lastEditMemo) || !this.isNull(memoValue)) {
                    ECP.Dialog.HideLoading();
                    if (editMemoBtn) {
                        setTimeout(() => {
                            if (!this.isVisible(input)) {
                                this.TriggerEvent(editMemoBtn, "click");
                            }
                        }, 100);
                    }
                    if (!memoValue) {
                        input.placeholder = "Required for Support Users on Production";
                    }
                    else {
                        input.placeholder = "Must Be: Task 1234, EC/OM/EM-1234, or Ticket #1234 {anything else}";
                    }
                    input.value = "";
                    input.focus();
                    input.parentElement.style.backgroundColor = "#ffb0b0";
                    if (shake) {
                        input.classList.add("ShakeToReject");
                        setTimeout(() => {
                            input.classList.remove("ShakeToReject");
                        }, 600);
                    }
                    return false;
                }
                else {
                    input.value = this.FixSupportTaskMemo(lastEditMemo);
                    return true;
                }
            }
            else {
                this.SetLocalStorageValue("LastEditMemoValue", this.FixSupportTaskMemo(memoValue), 180);
                return true;
            }
        }
        Color(rgb) {
            const rgbArr = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            return `#${this.Hex(rgbArr[1])}${this.Hex(rgbArr[2])}${this.Hex(rgbArr[3])}`;
        }
        DisableElements(Elements) {
            for (let i = 0, len = Elements.length; i < len; i++) {
                Elements[i].disabled = true;
                if (Elements[i].onclick) {
                    Elements[i].onclick_OLD = Elements[i].onclick;
                }
                Elements[i].onclick = function (event) { event.stopPropagation(); event.preventDefault(); return false; };
                switch (Elements[i].tagName) {
                    case "A":
                    case "DIV":
                        Elements[i].href_OLD = Elements[i].href;
                        Elements[i].href = "#";
                        break;
                }
                Elements[i].classList.add("Disabled");
            }
        }
        EnableElements(Elements) {
            for (let i = 0, len = Elements.length; i < len; i++) {
                Elements[i].disabled = false;
                if (Elements[i].onclick_OLD) {
                    Elements[i].onclick = Elements[i].onclick_OLD;
                }
                switch (Elements[i].tagName) {
                    case "A":
                    case "DIV":
                        if (Elements[i].href_OLD) {
                            Elements[i].href = Elements[i].href_OLD;
                        }
                        break;
                }
                Elements[i].classList.remove("Disabled");
            }
        }
        CombineFunctions(existingFunction, newFunctionToAdd, executeNewFunctionFirst) {
            const oldFunction = existingFunction;
            existingFunction = () => {
                if (executeNewFunctionFirst) {
                    newFunctionToAdd();
                }
                if (typeof oldFunction === "function") {
                    oldFunction();
                }
                if (!executeNewFunctionFirst) {
                    newFunctionToAdd();
                }
            };
            return existingFunction;
        }
        ScreenFmt(value, myDataType, decimalPlaces = -1, currencySymbol = undefined, currencyGroupDigits = undefined, currencyUseParForNeg = undefined) {
            let ReturnValue = "";
            value = this.NullChkStr(value, "");
            const OriginalDataType = myDataType;
            if (typeof myDataType === "string") {
                myDataType = this.DataTypeParse(myDataType.toString());
            }
            if (this.isNull(myDataType)) {
                console.log(`Invalid data type send to EC_Fmt.ScreenFmt() : '${this.Null2EmptyStr(OriginalDataType)}'`);
                myDataType = "Text";
            }
            switch (myDataType) {
                case DataType._Currency:
                    if (this.isNumber(value)) {
                        const myDec = this.CDec(value);
                        if (decimalPlaces <= -1) {
                            decimalPlaces = this.userCurrencyDecimals;
                        }
                        if (currencySymbol === undefined) {
                            currencySymbol = this.userCurrencySymbol;
                        }
                        if (currencyGroupDigits === undefined) {
                            currencyGroupDigits = this.userCurrencyGroupDigits;
                        }
                        if (currencyUseParForNeg === undefined) {
                            currencyUseParForNeg = this.userCurrencyUseParForNeg;
                        }
                        ReturnValue = this.FormatNumber(myDec, 2, decimalPlaces, currencyGroupDigits);
                        if (myDec < 0 && currencyUseParForNeg) {
                            if (currencyUseParForNeg) {
                                ReturnValue = `(${currencySymbol}${ReturnValue.replace(/^-/g, "")})`;
                            }
                            else {
                                ReturnValue = `-${currencySymbol}${ReturnValue.replace(/^-/g, "")}`;
                            }
                        }
                        else {
                            ReturnValue = currencySymbol + ReturnValue;
                        }
                    }
                    break;
                case DataType._Time:
                case DataType._LocalTime:
                    if (this.isNumber(value)) {
                        ReturnValue = this.Right(`0000${value}`, 4);
                        const LocalHour = Number(this.Left(ReturnValue, 2));
                        const LocalMinute = Number(this.Right(ReturnValue, 2));
                        if (LocalHour > 12) {
                            ReturnValue = `${(LocalHour - 12)}:${this.Right("0" + LocalMinute, 2)} PM`;
                        }
                        else if (LocalHour === 12) {
                            ReturnValue = `12:${this.Right("0" + LocalMinute, 2)} PM`;
                        }
                        else if (LocalHour === 0) {
                            ReturnValue = `12:${this.Right("0" + LocalMinute, 2)} AM`;
                        }
                        else {
                            ReturnValue = `${LocalHour}:${this.Right("0" + LocalMinute, 2)} AM`;
                        }
                    }
                    const TimeComponents = ReturnValue.split(" ");
                    const Time = TimeComponents[0];
                    let IsPm = false;
                    if (TimeComponents.length > 1 && TimeComponents[1] === "PM") {
                        IsPm = true;
                    }
                    const HoursMinutes = Time.split(":");
                    if (this.userTimeFormat === 2) {
                        if (HoursMinutes.length < 2) {
                            if (IsPm) {
                                ReturnValue = `${(Number(HoursMinutes[0]) + 12)}:00`;
                            }
                            else {
                                ReturnValue = `${HoursMinutes[0]}:00`;
                            }
                        }
                        else {
                            if (Number(HoursMinutes[0]) === 12) {
                                HoursMinutes[0] = "0";
                            }
                            if (IsPm) {
                                ReturnValue = `${(Number(HoursMinutes[0]) + 12)}:${HoursMinutes[1]}`;
                            }
                            else {
                                ReturnValue = `${HoursMinutes[0]}:${HoursMinutes[1]}`;
                            }
                        }
                    }
                    else {
                        if (HoursMinutes.length < 2) {
                            if (IsPm) {
                                ReturnValue = `${HoursMinutes[0]}:00 PM`;
                            }
                            else {
                                ReturnValue = `${HoursMinutes[0]}:00 AM`;
                            }
                        }
                        else {
                            if (IsPm) {
                                ReturnValue = `${HoursMinutes[0]}:${HoursMinutes[1]} PM`;
                            }
                            else {
                                ReturnValue = `${HoursMinutes[0]}:${HoursMinutes[1]} AM`;
                            }
                        }
                    }
                    break;
                case DataType._Date:
                case DataType._DateTime:
                case DataType._DateLocalTime:
                    let TmpTime = "";
                    const SearchValStr = value.split("^");
                    let tmpValStr;
                    let myDate;
                    let myHour;
                    let myMinute;
                    for (let i = 0; i < SearchValStr.length; i++) {
                        value = SearchValStr[i];
                        myDate = this.ToDate(value);
                        if (myDate === undefined) {
                            if (value.toUpperCase() === "IS NULL" || value.toUpperCase() === "NOT IS NULL") {
                                ReturnValue = value.toUpperCase();
                            }
                        }
                        else {
                            if (myDataType === DataType._DateTime || myDataType === DataType._DateLocalTime) {
                                myHour = myDate.getHours();
                                myMinute = myDate.getMinutes();
                                if (this.userTimeFormat === 2) {
                                    TmpTime = ` ${myHour}:${this.Right("0" + myMinute, 2)}`;
                                }
                                else {
                                    if (myHour > 12) {
                                        TmpTime = ` ${myHour - 12}:${this.Right("0" + myMinute, 2)} PM`;
                                    }
                                    else if (myHour === 12) {
                                        TmpTime = ` 12:${this.Right("0" + myMinute, 2)} PM`;
                                    }
                                    else if (myHour === 0) {
                                        TmpTime = ` 12:${this.Right("0" + myMinute, 2)} AM`;
                                    }
                                    else {
                                        TmpTime = ` ${myHour}:${this.Right("0" + myMinute, 2)} AM`;
                                    }
                                }
                            }
                            switch (this.userDateFormat) {
                                case 2:
                                    tmpValStr = `${myDate.getFullYear()}-${(myDate.getMonth() + 1)}-${myDate.getDate()}`;
                                    break;
                                case 3:
                                    tmpValStr = `${myDate.getDate()}.${(myDate.getMonth() + 1)}.${myDate.getFullYear()}`;
                                    break;
                                default:
                                    tmpValStr = `${(myDate.getMonth() + 1)}/${myDate.getDate()}/${myDate.getFullYear()}`;
                            }
                            ReturnValue = tmpValStr + TmpTime;
                            if (i !== (SearchValStr.length - 1)) {
                                ReturnValue += "^";
                            }
                        }
                    }
                    break;
                case DataType._RelativeTime:
                    {
                        const SearchValStr = value.split("^");
                        let startDate;
                        let endDate;
                        if (SearchValStr.length == 1) {
                            startDate = this.ToDate(SearchValStr[0]);
                            endDate = new Date();
                            ReturnValue = this.FormatRelativeTime(startDate, endDate);
                        }
                        else if (!this.ChkDate(SearchValStr[0]) || !this.ChkDate(SearchValStr[1])) {
                            ReturnValue = value;
                        }
                        else {
                            startDate = this.ToDate(SearchValStr[0]);
                            endDate = this.ToDate(SearchValStr[1]);
                            ReturnValue = this.FormatRelativeTime(startDate, endDate);
                        }
                        break;
                    }
                case DataType._MonthDay:
                    if (this.isInteger(this.ReplaceAll(value, "/", ""))) {
                        const TmpArr = value.split("/");
                        let MonthTmp = 0;
                        let myDay = 0;
                        if (TmpArr.length > 1) {
                            MonthTmp = Number(TmpArr[0]);
                            myDay = Number(TmpArr[1]);
                        }
                        else {
                            value = "0000" + this.ReplaceAll(value, "/", "");
                            MonthTmp = Number(this.Left(this.Right(value, 4), 2));
                            myDay = Number(this.Right(value, 2));
                        }
                        switch (this.userDateFormat) {
                            case 2:
                                ReturnValue = `${MonthTmp}-${myDay}`;
                                break;
                            case 3:
                                ReturnValue = `${myDay}.${MonthTmp}`;
                                break;
                            default:
                                ReturnValue = `${MonthTmp}/${myDay}`;
                        }
                    }
                    break;
                case DataType._Months:
                case DataType._MonthAbbr:
                case DataType._MonthName:
                    if (this.isInteger(value)) {
                        const monthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                        ReturnValue = monthNames[Number(this.CDec(value))];
                        if (myDataType === DataType._MonthAbbr) {
                            ReturnValue = ReturnValue.substring(0, 3);
                        }
                    }
                    else if (",January,Jan,February,Feb,March,Mar,April,Apr,May,May,June,Jun,July,Jul,August,Aug,September,Sep,October,Oct,November,Nov,December,Dec,".indexOf(`,${value},`) !== -1) {
                        ReturnValue = value;
                        if (myDataType === DataType._MonthAbbr) {
                            ReturnValue = ReturnValue.substring(0, 3);
                        }
                    }
                    else {
                        ReturnValue = "Is Null";
                    }
                    break;
                case DataType._YearMonth:
                case DataType._DateMonthYear:
                    let yearMonthArr;
                    let myMonth = 0;
                    let myYear = 0;
                    if (this.isInteger(this.ReplaceAll(value, " ", ""))) {
                        yearMonthArr = value.split(" ");
                        if (yearMonthArr.length > 1) {
                            myMonth = Number(yearMonthArr[0]);
                            myYear = Number(yearMonthArr[1]);
                        }
                        else {
                            value = "000000" + this.ReplaceAll(value, " ", "");
                            myMonth = Number(this.Right(value, 2));
                            myYear = Number(this.Left(this.Right(value, 6), 4));
                        }
                        ReturnValue = `${myYear} ${this.Right("0" + myMonth, 2)}`;
                    }
                    else if (this.isInteger(this.ReplaceAll(value, "/", ""))) {
                        yearMonthArr = value.split("/");
                        if (yearMonthArr.length > 1) {
                            myMonth = Number(yearMonthArr[0]);
                            myYear = Number(yearMonthArr[1]);
                        }
                        else {
                            value = "000000" + this.ReplaceAll(value, " ", "");
                            myMonth = Number(this.Right(value, 2));
                            myYear = Number(this.Left(this.Right(value, 6), 4));
                        }
                        switch (this.userDateFormat) {
                            case 2:
                                ReturnValue = `${myYear}-${myMonth}`;
                                break;
                            case 3:
                                ReturnValue = `${myMonth}.${myYear}`;
                                break;
                            default:
                                ReturnValue = `${myMonth}/${myYear}`;
                        }
                    }
                    break;
                case DataType._Email:
                    if (this.isEmail(value)) {
                        ReturnValue = value;
                    }
                    break;
                case DataType._Phone:
                    const Phone = this.ReplaceAll(this.ReplaceAll(this.ReplaceAll(this.ReplaceAll(this.ReplaceAll(value, "(", ""), ")", ""), "-", ""), " ", ""), ".", "");
                    ReturnValue = value;
                    if (this.isNumber(Phone)) {
                        switch (Phone.length) {
                            case 11:
                                if (this.userPhoneFormat === 3) {
                                    ReturnValue = `${Phone.substr(0, 3)}-${Phone.substr(3, 4)}-${Phone.substr(7, 4)}`;
                                }
                                else {
                                    ReturnValue = `${Phone.substr(0, 1)} (${Phone.substr(1, 3)}) ${Phone.substr(4, 3)}-${Phone.substr(7, 4)}`;
                                }
                                break;
                            case 10:
                                if (this.userPhoneFormat === 2) {
                                    if (Phone.substr(0, 2) === "04") {
                                        ReturnValue = `${Phone.substr(0, 4)} ${Phone.substr(4, 3)} ${Phone.substr(7, 3)}`;
                                    }
                                    else {
                                        ReturnValue = `(${Phone.substr(0, 2)}) ${Phone.substr(2, 4)}-${Phone.substr(6, 4)}`;
                                    }
                                }
                                else {
                                    ReturnValue = `(${Phone.substr(0, 3)}) ${Phone.substr(3, 3)}-${Phone.substr(6, 4)}`;
                                }
                                break;
                            case 9:
                                ReturnValue = `${Phone.substr(0, 3)}-${Phone.substr(3, 3)}-${Phone.substr(6, 3)}`;
                                break;
                            case 7:
                                ReturnValue = `${Phone.substr(0, 3)}-${Phone.substr(3, 4)}`;
                                break;
                        }
                    }
                    break;
                case DataType._PostalCode:
                    ReturnValue = this.ReplaceAll(this.ReplaceAll(this.ReplaceAll(value, "-", ""), " ", ""), ".", "");
                    break;
                case DataType._UPC:
                    const upc = this.ReplaceAll(value, "-", "").trim();
                    if (!this.isInteger(upc)) {
                        ReturnValue = value;
                    }
                    else {
                        switch (upc.length) {
                            case 12:
                                ReturnValue = `${upc.substr(0, 1)}-${upc.substr(1, 5)}-${upc.substr(6, 5)}-${upc.substr(11, 1)}`;
                                break;
                            case 11:
                                ReturnValue = `${upc.substr(0, 1)}-${upc.substr(1, 5)}-${upc.substr(6, 5)}`;
                                break;
                            case 10:
                                ReturnValue = `${upc.substr(0, 5)}-${upc.substr(5, 5)}`;
                                break;
                            case 8:
                                ReturnValue = `${upc.substr(0, 1)}-${upc.substr(1, 3)}-${upc.substr(4, 3)}-${upc.substr(7, 1)}`;
                                break;
                            case 14:
                                ReturnValue = `${upc.substr(0, 1)}-${upc.substr(1, 2)}-${upc.substr(3, 5)}-${upc.substr(8, 5)}-${upc.substr(13, 1)}`;
                                break;
                        }
                    }
                    break;
                case DataType._Decimal:
                case DataType._Integer:
                    if (!this.isNumber(value)) {
                        ReturnValue = "";
                    }
                    else {
                        if (decimalPlaces > -1) {
                            ReturnValue = this.FormatNumber(value, decimalPlaces, decimalPlaces, true);
                        }
                        else {
                            ReturnValue = this.FormatNumber(value, 0, 6, true);
                        }
                    }
                    break;
                case DataType._YesNo:
                    if (this.isInteger(value)) {
                        if (this.CDec(value) === 0) {
                            ReturnValue = "False";
                        }
                        else {
                            ReturnValue = "True";
                        }
                    }
                    else {
                        if (value.toLowerCase() === "true") {
                            ReturnValue = "True";
                        }
                        else if (value.toLowerCase() === "false") {
                            ReturnValue = "False";
                        }
                        else {
                            ReturnValue = value;
                        }
                    }
                    break;
                case DataType._Percentage:
                    value = this.ReplaceAll(value, "%", "");
                    ReturnValue = value;
                    if (this.isNumber(value)) {
                        const TmpDec = 100 * Number(value);
                        if (decimalPlaces > -1) {
                            ReturnValue = this.FormatNumber(TmpDec, decimalPlaces, decimalPlaces, true);
                        }
                        else {
                            ReturnValue = this.FormatNumber(TmpDec, 0, 4, true);
                        }
                        ReturnValue += "%";
                    }
                    break;
                case DataType._FileSize:
                    if (this.isNumber(value)) {
                        ReturnValue = this.FileSizeConvert(Number(value));
                    }
                    else {
                        ReturnValue = "0 B";
                    }
                    break;
                case DataType._Signature:
                    break;
                case DataType._DocumentURL:
                    if (value.toString().trim() !== "") {
                        const ValueArray = value.split("|");
                        if (ValueArray.length < 3) {
                            throw new Error(`Encompass Fmt: value= '${value}' must have ValueArray.length >= 3: DocumentID|FileName|DocumentURL|ThumbnailURL|MaxHeight `);
                        }
                        const FileName = ValueArray[1];
                        const DocumentURL = ValueArray[2];
                        let ThumbnailURL = "";
                        let MaxHeight = "";
                        if (ValueArray.length > 3) {
                            ThumbnailURL = ValueArray[3];
                        }
                        if (ValueArray.length > 4) {
                            MaxHeight = ` style='max-height:${ValueArray[4]}px;' `;
                        }
                        if (ThumbnailURL === "") {
                            ThumbnailURL = DocumentURL;
                        }
                        if (this.IsImage(DocumentURL)) {
                            ReturnValue = `<a href='${DocumentURL}'><img src='${ThumbnailURL}' ${MaxHeight}></a>`;
                        }
                        else {
                            ReturnValue = `<a href='${DocumentURL}'>${FileName}</a>`;
                        }
                    }
                    break;
                case DataType._Link:
                case DataType._TextEncoded:
                    if (value !== "") {
                        ReturnValue = `<xmp>${value}</xmp>`;
                    }
                    break;
                default:
                    ReturnValue = value;
            }
            return ReturnValue;
        }
        get_searchOp(Value) {
            if (this.isNull(Value)) {
                return "";
            }
            Value = Value.toString();
            let Operator = Value.substr(0, 3);
            if (Operator === "<>*") {
                return Operator;
            }
            Operator = Operator.substr(0, 2);
            switch (Operator) {
                case "<>":
                case ">=":
                case "<=":
                case "><":
                case "!=":
                    return Operator;
            }
            Operator = Operator.substr(0, 1);
            switch (Operator) {
                case ">":
                case "<":
                case "*":
                case "!":
                    return Operator;
            }
            const myValue = Value.trim().toUpperCase();
            switch (myValue) {
                case "IS NULL":
                case "NULL":
                    return "IS NULL";
                case "NOT IS NULL":
                case "NOT NULL":
                case "IS NOT NULL":
                    return "NOT IS NULL";
            }
            return "";
        }
        OperatorStrToEnum(operatorString) {
            switch (operatorString) {
                case "=":
                    return ECP.EC_Operator.Equals;
                case "*":
                    return ECP.EC_Operator.Like;
                case ">":
                    return ECP.EC_Operator.GreaterThan;
                case "<":
                    return ECP.EC_Operator.LessThan;
                case "<>":
                case "!=":
                case "!":
                    return ECP.EC_Operator.NotEquals;
                case "<>*":
                    return ECP.EC_Operator.NotLike;
                case "><":
                    return ECP.EC_Operator.Range;
                case ">=":
                    return ECP.EC_Operator.GreaterThanEquals;
                case "<=":
                    return ECP.EC_Operator.LessThanEquals;
            }
            return ECP.EC_Operator.Equals;
        }
        OperatorToURLOperator(Operator) {
            switch (Operator) {
                case ECP.EC_Operator.Equals:
                    return "E";
                case ECP.EC_Operator.GreaterThan:
                    return "G";
                case ECP.EC_Operator.GreaterThanEquals:
                    return "GE";
                case ECP.EC_Operator.LessThan:
                    return "L";
                case ECP.EC_Operator.LessThanEquals:
                    return "LE";
                case ECP.EC_Operator.NotEquals:
                    return "NE";
                case ECP.EC_Operator.Like:
                    return "LIKE";
                case ECP.EC_Operator.NotLike:
                    return "NOTLIKE";
                case ECP.EC_Operator.Range:
                    return "R";
                case ECP.EC_Operator.In:
                    return "IN";
            }
            return "E";
        }
        InputFmt(inputField, myDataType, length, required, isSearch, currencySymbol = undefined, currencyGroupDigits = undefined, currencyUseParForNeg = undefined) {
            let val;
            let inputValue = "";
            if (inputField instanceof HTMLInputElement) {
                val = inputField.value;
                inputValue = this.Null2EmptyStr(val);
            }
            else if (inputField instanceof HTMLTextAreaElement) {
                val = inputField.value;
                inputValue = this.Null2EmptyStr(val);
            }
            else {
                val = this.Null2EmptyStr(inputField);
            }
            const OriginalDataType = myDataType;
            myDataType = this.NullChk(myDataType, "Text");
            if (typeof myDataType === "string") {
                myDataType = this.DataTypeParse(myDataType.toString());
            }
            if (this.isNull(myDataType)) {
                console.log(`Invalid data type send to EC_Fmt.InputFmt(): '${this.Null2EmptyStr(OriginalDataType)}'`);
            }
            if (!this.isNumber(length)) {
                length = 10000;
            }
            if (this.isNull(required)) {
                required = false;
            }
            if (this.isNull(isSearch)) {
                isSearch = true;
            }
            let searchOp = "";
            if (isSearch) {
                searchOp = this.get_searchOp(val);
                if (searchOp === "NOT IS NULL" || searchOp === "IS NULL") {
                    val = "";
                }
                if (this.Left(val, searchOp.length) === searchOp) {
                    val = this.Right(val, val.length - searchOp.length);
                }
            }
            let valueArray = (isSearch) ? val.split("^") : [val];
            switch (searchOp) {
                case "><":
                    if (valueArray.length > 2) {
                        valueArray = valueArray.slice(0, 2);
                    }
                    break;
                case ">":
                case "<":
                case "<>":
                case ">=":
                case "<=":
                    valueArray = valueArray.slice(0, 1);
                    break;
            }
            for (let k = 0; k < valueArray.length; k++) {
                let value = this.NullChk(valueArray[k], "");
                switch (myDataType) {
                    case DataType._Currency:
                        if (currencySymbol === undefined) {
                            currencySymbol = this.userCurrencySymbol;
                        }
                        if (currencyGroupDigits === undefined) {
                            currencyGroupDigits = this.userCurrencyGroupDigits;
                        }
                        if (currencyUseParForNeg === undefined) {
                            currencyUseParForNeg = this.userCurrencyUseParForNeg;
                        }
                        if ((searchOp === "NOT IS NULL" || searchOp === "IS NULL") && value === "") {
                            break;
                        }
                        else if (!this.isNumber(value)) {
                            value = currencySymbol + "0";
                            break;
                        }
                        let num = this.CDec(value);
                        if (isNaN(num)) {
                            value = currencySymbol + "0";
                            break;
                        }
                        const isNegative = (num < 0);
                        num = Math.abs(Math.floor(num * 1000000 + 0.50000000001));
                        let cents = ((num % 1000000) / 1000000).toString();
                        value = Math.floor(num / 1000000).toString();
                        cents = cents.replace("0.", "");
                        if (cents.length < 2) {
                            cents += "0";
                        }
                        let mun1 = "";
                        if (currencyGroupDigits) {
                            let Count = Math.floor(value.length / 3);
                            if (value.length % 3 == 0) {
                                Count = Count - 1;
                            }
                            for (let i = 1; i <= Count; i++) {
                                const values = value.substring(value.length - 3 * i, value.length - 3 * (i - 1));
                                mun1 = `,${values}${mun1}`;
                            }
                            mun1 = value.substring(0, value.length - Count * 3) + mun1;
                        }
                        else {
                            mun1 = value;
                        }
                        if (isNegative) {
                            if (currencyUseParForNeg) {
                                value = `(${currencySymbol}${mun1}.${cents})`;
                            }
                            else {
                                value = `-${currencySymbol}${mun1}.${cents}`;
                            }
                        }
                        else {
                            value = `${currencySymbol}${mun1}.${cents}`;
                        }
                        break;
                    case DataType._Date:
                        if (this.isNull(value)) {
                            value = "";
                            break;
                        }
                        const originalDate = this.ToDate(value.trim());
                        if (originalDate !== undefined) {
                            value = `${originalDate.getMonth() + 1}/${originalDate.getDate()}/${originalDate.getFullYear()}`;
                        }
                        const tmp = value.replace(/^\s+|\s+$/g, "");
                        if (this.isNull(tmp)) {
                            value = "";
                        }
                        else {
                            if (this.isNull(value)) {
                                return undefined;
                            }
                            const DateTmp = this.DateParseFormat(value);
                            switch (this.userDateFormat) {
                                case 2:
                                    const tempDateArr = DateTmp.split("/");
                                    value = `${tempDateArr[2]}-${tempDateArr[0]}-${tempDateArr[1]}`;
                                    break;
                                case 3:
                                    const tmpDateArr = DateTmp.split("/");
                                    if (this.userLanguage === "ZH") {
                                        value = `${tmpDateArr[2]}.${tmpDateArr[0]}.${tmpDateArr[1]}`;
                                    }
                                    else {
                                        value = `${tmpDateArr[1]}.${tmpDateArr[0]}.${tmpDateArr[2]}`;
                                    }
                                    break;
                                default:
                                    value = DateTmp;
                                    break;
                            }
                        }
                        break;
                    case DataType._DateTime:
                    case DataType._DateLocalTime:
                        if (this.isNull(value)) {
                            value = "";
                            break;
                        }
                        const myDate = this.ToDate(value.trim());
                        if (myDate !== undefined) {
                            value = `${myDate.getMonth() + 1}/${myDate.getDate()}/${myDate.getFullYear()} ${this.Right("00" + myDate.getHours(), 2)}:${this.Right("00" + myDate.getMinutes(), 2)}:${this.Right("00" + myDate.getSeconds(), 2)}`;
                        }
                        const tmpArr = value.trim().split(" ");
                        let DateHour = "";
                        let DateMinute = "";
                        let mySecond = "";
                        let myAMPM = "";
                        if (tmpArr.length > 2) {
                            myAMPM = tmpArr[2].toUpperCase();
                            if (myAMPM !== "AM" && myAMPM !== "PM") {
                                myAMPM = "";
                            }
                        }
                        if (tmpArr.length > 1) {
                            const myArr = this.InputFmt(tmpArr[1], DataType._LocalTime, length, required, isSearch).split(":");
                            if (myArr.length > 1) {
                                DateHour = myArr[0];
                                DateMinute = myArr[1];
                                if (this.userTimeFormat === 1 && myArr[1].indexOf(" ") !== -1) {
                                    DateMinute = myArr[1].split(" ")[0];
                                    myAMPM = myAMPM || myArr[1].split(" ")[1];
                                }
                            }
                            if (myArr.length > 2) {
                                mySecond = myArr[2];
                            }
                        }
                        if (this.isNull(myAMPM)) {
                            myAMPM = "AM";
                        }
                        let tmpHour;
                        if (this.isInteger(DateHour)) {
                            tmpHour = this.CDec(DateHour);
                            if (tmpHour < 0 || tmpHour > 24) {
                                tmpHour = 0;
                            }
                        }
                        else {
                            tmpHour = (this.userTimeFormat === 1 ? 12 : 0);
                        }
                        let tmpMinute;
                        if (this.isInteger(DateMinute)) {
                            tmpMinute = this.CDec(DateMinute);
                            if (tmpMinute < 0 || tmpMinute > 59) {
                                tmpMinute = 0;
                            }
                        }
                        else {
                            tmpMinute = 0;
                        }
                        let tmpSecond;
                        if (this.isInteger(mySecond)) {
                            tmpSecond = this.CDec(mySecond);
                            if (tmpSecond < 0 || tmpSecond > 59) {
                                tmpSecond = 0;
                            }
                        }
                        else {
                            tmpSecond = 0;
                        }
                        DateMinute = this.Right("0" + tmpMinute, 2);
                        mySecond = this.Right("0" + tmpSecond, 2);
                        let tmpTime = `${tmpHour}:${DateMinute}`;
                        if (mySecond !== "00") {
                            tmpTime += ":" + mySecond;
                        }
                        let tmpDate = this.InputFmt(tmpArr[0], DataType._Date, length, required, isSearch);
                        switch (this.userTimeFormat) {
                            case 2:
                                if (tmpTime !== "00:00" && tmpTime !== "0:00" && tmpDate !== "") {
                                    tmpDate += " " + tmpTime;
                                }
                                break;
                            case 1:
                                if (tmpTime !== "12:00" || tmpDate !== "") {
                                    tmpDate += ` ${tmpTime} ${myAMPM}`;
                                }
                                break;
                        }
                        value = tmpDate;
                        break;
                    case DataType._Time:
                    case DataType._LocalTime:
                        if (this.isNull(value)) {
                            value = "";
                            break;
                        }
                        const timeStr = value.trim();
                        if (/^\d{1,2}:\d{2} (AM|PM)$/i.test(timeStr)) {
                            value = timeStr.toUpperCase();
                            break;
                        }
                        let IsPM = value.toUpperCase().indexOf("PM") > 0;
                        const IsAM = value.toUpperCase().indexOf("AM") > 0;
                        if (IsAM) {
                            IsPM = false;
                        }
                        let cleanTime = value.replace(/am/ig, "").replace(/pm/ig, "").trim();
                        let hour = 0;
                        let minute = 0;
                        if (cleanTime.includes(':')) {
                            const parts = cleanTime.split(':');
                            const hourPart = parts[0];
                            const minutePart = parts[1] ? parts[1].split(" ")[0] : "0";
                            if (!/^\d+$/.test(hourPart) || !/^\d+$/.test(minutePart)) {
                                value = "--:-- --";
                                break;
                            }
                            hour = parseInt(hourPart, 10);
                            minute = parseInt(minutePart, 10);
                        }
                        else if (cleanTime.length >= 3 && /^\d+$/.test(cleanTime)) {
                            if (cleanTime.length === 3) {
                                hour = parseInt(cleanTime.substring(0, 1), 10);
                                minute = parseInt(cleanTime.substring(1, 3), 10);
                            }
                            else {
                                hour = parseInt(cleanTime.substring(0, cleanTime.length - 2), 10);
                                minute = parseInt(cleanTime.substring(cleanTime.length - 2), 10);
                            }
                        }
                        else if ((cleanTime.length === 1 || cleanTime.length === 2) && /^\d+$/.test(cleanTime)) {
                            hour = parseInt(cleanTime, 10);
                            minute = 0;
                        }
                        else {
                            value = "--:-- --";
                            break;
                        }
                        if (hour < 0 || hour > 23 || minute < 0 || minute > 59) {
                            value = "--:-- --";
                            break;
                        }
                        if (hour === 0) {
                            hour = 12;
                            IsPM = false;
                        }
                        else if (hour >= 1 && hour <= 11) {
                            if (!IsAM && !IsPM) {
                                IsPM = false;
                            }
                        }
                        else if (hour === 12) {
                            if (!IsAM && !IsPM) {
                                IsPM = true;
                            }
                        }
                        else {
                            hour = hour - 12;
                            IsPM = true;
                        }
                        switch (this.userTimeFormat) {
                            case 2:
                                if (IsPM && hour !== 12) {
                                    value = `${this.Right("0" + (hour + 12), 2)}:${this.Right("0" + minute, 2)}`;
                                }
                                else if (!IsPM && hour === 12) {
                                    value = `00:${this.Right("0" + minute, 2)}`;
                                }
                                else {
                                    value = `${this.Right("0" + hour, 2)}:${this.Right("0" + minute, 2)}`;
                                }
                                break;
                            default:
                                if (IsPM) {
                                    value = `${hour}:${this.Right("0" + minute, 2)} PM`;
                                }
                                else {
                                    value = `${hour}:${this.Right("0" + minute, 2)} AM`;
                                }
                                break;
                        }
                        break;
                    case DataType._MonthDay:
                        if (this.isNull(value)) {
                            value = "";
                            break;
                        }
                        const originDate = this.ToDate(value.trim());
                        if (originDate !== undefined) {
                            value = `${originDate.getMonth() + 1}/${originDate.getDate()}/${originDate.getFullYear()}`;
                        }
                        switch (this.userDateFormat) {
                            case 2:
                                if (!originDate && value !== "") {
                                    if (value.indexOf("-") < 0) {
                                        value = "2000" + value;
                                    }
                                    else {
                                        value = "2000-" + value;
                                    }
                                }
                                const tmpArr1 = this.InputFmt(value, DataType._Date, length, required, isSearch).split("-");
                                if (tmpArr1.length > 1) {
                                    value = `${tmpArr1[1]}-${tmpArr1[2]}`;
                                }
                                else {
                                    value = "";
                                }
                                break;
                            case 3:
                                if (!originDate && value !== "") {
                                    if (value.indexOf(".") < 0) {
                                        value += "2000";
                                    }
                                    else {
                                        value += ".2000";
                                    }
                                }
                                const tmpArr2 = this.InputFmt(value, DataType._Date, length, required, isSearch).split(".");
                                if (tmpArr2.length > 1) {
                                    value = `${tmpArr2[0]}.${tmpArr2[1]}`;
                                }
                                else {
                                    value = "";
                                }
                                break;
                            default:
                                if (!originDate && value !== "") {
                                    if (value.indexOf("/") < 0) {
                                        value += "2000";
                                    }
                                    else {
                                        value += "/2000";
                                    }
                                }
                                const tmpArr3 = this.InputFmt(value, DataType._Date, length, required, isSearch).split("/");
                                if (tmpArr3.length > 1) {
                                    value = `${tmpArr3[0]}/${tmpArr3[1]}`;
                                }
                                else {
                                    value = "";
                                }
                                break;
                        }
                        break;
                    case DataType._DateMonthYear:
                        if (this.isNull(value)) {
                            value = "";
                            break;
                        }
                        if (searchOp !== "NOT IS NULL" && searchOp !== "IS NULL") {
                            const OriginDate = this.ToDate(value.trim());
                            if (OriginDate !== undefined) {
                                value = `${OriginDate.getMonth() + 1}/${OriginDate.getDate()}/${OriginDate.getFullYear()}`;
                            }
                            const TmpDateMonthYear = value.replace(/^\s+|\s+$/g, "");
                            if (TmpDateMonthYear === "") {
                                value = "";
                                break;
                            }
                            const tmpDateArr = this.Split(this.InputFmt(TmpDateMonthYear, DataType._Date, length, required, isSearch), ["/", "-", "."]);
                            const month = parseInt(tmpDateArr[0], 10);
                            const year = parseInt(tmpDateArr[2], 10);
                            switch (this.userDateFormat) {
                                case 2:
                                    value = `${year}-${month}`;
                                    break;
                                case 3:
                                    if (this.userLanguage === "ZH") {
                                        value = `${year}.${month}`;
                                    }
                                    else {
                                        value = `${month}.${year}`;
                                    }
                                    break;
                                default:
                                    value = `${month}/${year}`;
                                    break;
                            }
                        }
                        break;
                    case DataType._YearMonth:
                        value = value.replace(/(^\s+)|(\s+$)/g, '');
                        let valueArr = value.split(/(?:\/+|\.+|\s+|\-+)/);
                        valueArr = valueArr.filter(item => item);
                        if (/^\d+$/.test(value)) {
                            value = this.YearMonthFormat(value);
                        }
                        else if (valueArr.length === 2) {
                            if ((valueArr[0].length + valueArr[1].length) === 6) {
                                value = this.YearMonthFormat(valueArr[0] + valueArr[1]);
                            }
                            else if (parseInt(valueArr[1], 10) > 12) {
                                value = this.YearMonthFormat(valueArr[1] + ("00" + valueArr[0]).slice(-2));
                            }
                            else {
                                value = this.YearMonthFormat(valueArr[0] + ("00" + valueArr[1]).slice(-2));
                            }
                        }
                        else {
                            value = "";
                        }
                        break;
                    case DataType._Months:
                    case DataType._MonthAbbr:
                    case DataType._MonthName:
                        if (this.isNumber(value)) {
                            value = this.Round(value, 0).toString();
                            if (value.length > length) {
                                if (value.indexOf("-") >= 0) {
                                    value = value.substring(0, length + 1);
                                }
                                else {
                                    value = value.substring(0, length);
                                }
                            }
                        }
                        else {
                            value = value.substring(0, 3);
                            switch (value.toLowerCase()) {
                                case "jan":
                                    value = "1";
                                    break;
                                case "feb":
                                    value = "2";
                                    break;
                                case "mar":
                                    value = "3";
                                    break;
                                case "apr":
                                    value = "4";
                                    break;
                                case "may":
                                    value = "5";
                                    break;
                                case "jun":
                                    value = "6";
                                    break;
                                case "jul":
                                    value = "7";
                                    break;
                                case "aug":
                                    value = "8";
                                    break;
                                case "sep":
                                    value = "9";
                                    break;
                                case "oct":
                                    value = "10";
                                    break;
                                case "nov":
                                    value = "11";
                                    break;
                                case "dec":
                                    value = "12";
                                    break;
                                default:
                                    value = "";
                                    break;
                            }
                        }
                        break;
                    case DataType._AutoNumber:
                    case DataType._Identity:
                        if (this.isNumber(value)) {
                            value = this.Round(value, 0).toString();
                            if (value.length > length) {
                                if (value.indexOf("-") >= 0) {
                                    value = value.substring(0, length + 1);
                                }
                                else {
                                    value = value.substring(0, length);
                                }
                            }
                        }
                        break;
                    case DataType._BigInt:
                        value = this.Right(value.trim(), 18);
                        if (!this.isNumber(value)) {
                            value = "Null";
                        }
                        else {
                            value = this.Round(this.CDec(value)).toString();
                        }
                        break;
                    case DataType._Integer:
                        if (this.isNumber(value)) {
                            const myInt = this.Round(value, 0);
                            if (myInt < 10000) {
                                value = this.FormatNumber(myInt, 0, 0, false);
                            }
                            else {
                                value = this.FormatNumber(myInt, 0, 0, !this.isMobile);
                            }
                        }
                        else {
                            value = "";
                        }
                        break;
                    case DataType._Decimal:
                        value = this.FormatNumber(value, 0, 6, !this.isMobile);
                        break;
                    case DataType._Percentage:
                        value = value.replace("%", "");
                        if (this.isNumber(value)) {
                            value = this.Round(value, 6).toString() + "%";
                        }
                        else {
                            value = "";
                        }
                        break;
                    case DataType._Color:
                    case DataType._TextNoSpace:
                        value = this.ReplaceAll(value, " ", "");
                        value = this.ReplaceAll(value, "&", "");
                        value = this.ReplaceAll(value, "'", "");
                        value = this.ReplaceAll(value, "\n", "");
                    case DataType._Text:
                    case DataType._TextArea:
                        value = this.ReplaceAll(value, "  ", " ");
                        value = this.ReplaceAll(value, "\n ", "\n");
                        value = this.ReplaceAll(value, " \n", "\n");
                    case DataType._TextDoubleSpace:
                        value = this.ReplaceAll(value, "^", "&#94;");
                        value = this.ReplaceAll(value, "|", "&#124;");
                        value = this.ReplaceAll(value, "~", "&#126;");
                        value = this.ReplaceAll(value, "`", "&#96;");
                        value = this.ReplaceAll(value, "\"", "&#34;");
                        value = value.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
                        value = value.trim();
                        if (value.length > length && length > 100) {
                            if (inputField.parentElement.querySelector(".tool-tip")) {
                                ECP.HTML.ToolTip(inputField.parentElement.querySelector(".tool-tip"), `<i class="ews-icon-info" style="color:var(--text-error)"></i>`, `Text is longer than the maximum ${length} characters. Value truncated to ${length} characters.`, "right", 150);
                            }
                            else {
                                ECP.HTML.Snackbar(`Text is longer than the maximum ${length} characters. Value truncated to ${length} characters.`, "Error");
                            }
                        }
                        value = value.substring(0, length);
                        break;
                    case DataType._Email:
                        if (value !== "" && !this.isEmail(value)) {
                            if (inputField.parentElement.querySelector(".tool-tip")) {
                                ECP.HTML.ToolTip(inputField.parentElement.querySelector(".tool-tip"), `<i class="ews-icon-info" style="color:var(--text-error)"></i>`, value + " is not a valid email.", "right", 150);
                            }
                            else {
                                ECP.HTML.Snackbar(value + " is not a valid email. It must be in the form of 'username@domain.com'.", "Error");
                            }
                            value = "";
                        }
                        break;
                    case DataType._Phone:
                        value = this.ReplaceAll(value, "(", "");
                        value = this.ReplaceAll(value, ")", "");
                        value = this.ReplaceAll(value, "-", "");
                        value = this.ReplaceAll(value, " ", "");
                        value = this.ReplaceAll(value, ".", "");
                        if (this.isInteger(value)) {
                            switch (value.length) {
                                case 11:
                                    if (this.userPhoneFormat === 3) {
                                        value = `${value.substring(0, 3)}-${value.substring(3, 7)}-${value.substring(7, 11)}`;
                                    }
                                    else {
                                        value = `${value.substring(0, 1)} (${value.substring(1, 4)}) ${value.substring(4, 7)}-${value.substring(7, 11)}`;
                                    }
                                    break;
                                case 10:
                                    if (this.userPhoneFormat === 2) {
                                        if (value.substring(0, 2) === "04") {
                                            value = `${value.substring(0, 4)} ${value.substring(4, 7)}-${value.substring(7, 10)}`;
                                        }
                                        else {
                                            value = `(${value.substring(0, 2)}) ${value.substring(2, 6)}-${value.substring(6, 10)}`;
                                        }
                                    }
                                    else {
                                        value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6, 10)}`;
                                    }
                                    break;
                                case 7:
                                    value = `${value.substring(0, 3)}-${value.substring(3, 7)}`;
                                    break;
                            }
                        }
                        break;
                    case DataType._PostalCode:
                        value = this.ReplaceAll(this.ReplaceAll(this.ReplaceAll(value, "-", ""), " ", ""), ".", "");
                        if (this.isInteger(value)) {
                            if (value.length === 9) {
                                value = `${value.substring(0, 5)}-${value.substring(5, 9)}`;
                            }
                        }
                        else if (value.length === 6) {
                            value = `${value.substring(0, 3)} ${value.substring(3, 6)}`;
                        }
                        break;
                    case DataType._UPC:
                        value = this.ReplaceAll(value, " ", "");
                        value = this.ReplaceAll(value, "-", "");
                        if (this.isInteger(value)) {
                            switch (value.length) {
                                case 12:
                                    const A1 = value.substring(0, 1);
                                    const B1 = value.substring(1, 6);
                                    const C1 = value.substring(6, 11);
                                    const D1 = value.substring(11, 12);
                                    value = `${A1}-${B1}-${C1}-${D1}`;
                                    break;
                                case 11:
                                    const A2 = value.substring(0, 1);
                                    const B2 = value.substring(1, 6);
                                    const C2 = value.substring(6, 11);
                                    value = `${A2}-${B2}-${C2}`;
                                    break;
                                case 10:
                                    const B3 = value.substring(0, 5);
                                    const C3 = value.substring(5, 10);
                                    value = `${B3}-${C3}`;
                                    break;
                                case 14:
                                    const A4 = value.substring(0, 1);
                                    const B4 = value.substring(1, 3);
                                    const C4 = value.substring(3, 8);
                                    const D4 = value.substring(8, 13);
                                    const E4 = value.substring(13, 14);
                                    value = `${A4}-${B4}-${C4}-${D4}-${E4}`;
                                    break;
                            }
                        }
                        break;
                    case DataType._YesNo:
                        switch (value.toLowerCase().trim()) {
                            case "no":
                            case "0":
                            case "false":
                                value = "0";
                                break;
                            default:
                                value = "1";
                                break;
                        }
                        break;
                    case DataType._APICall:
                    case DataType._Hyperlink:
                    case DataType._TextEncoded:
                    case DataType._Password:
                    case DataType._Encrypted:
                    case DataType._Link:
                    case DataType._HTML:
                    case DataType._DocumentURL:
                        value = this.Left(value, length);
                        break;
                    default:
                        value = "";
                        break;
                }
                valueArray[k] = value;
            }
            val = valueArray.join("^");
            val = this.ReplaceAll(val, "^^", "^");
            if (val === "^") {
                val = "";
            }
            if (inputField instanceof HTMLElement) {
                const myElement = inputField;
                if (this.isNull(val)) {
                    if (!this.isNull(inputValue) && searchOp !== "NOT IS NULL" && searchOp !== "IS NULL") {
                        myElement.classList.add("ShakeToReject");
                        setTimeout(() => {
                            myElement.classList.remove("ShakeToReject");
                        }, 600);
                    }
                    if (required) {
                        let DisplayName = myElement.getAttribute("encDisplayName");
                        if (this.isNull(DisplayName)) {
                            DisplayName = myElement.getAttribute("name");
                        }
                        if (inputField.parentElement.querySelector(".tool-tip")) {
                            ECP.HTML.ToolTip(inputField.parentElement.querySelector(".tool-tip"), `<i class="ews-icon-info" style="color:var(--text-error)"></i>`, DisplayName + " is a required field. It must contain a valid value.", "right", 150);
                        }
                        else {
                            ECP.HTML.Snackbar(DisplayName + " is a required field. It must contain a valid value.", "Error");
                        }
                    }
                }
                if (!this.isNull(inputValue)) {
                    if (inputField instanceof HTMLInputElement) {
                        const myHTMLInputElement = inputField;
                        myHTMLInputElement.value = searchOp + val;
                    }
                    else if (inputField instanceof HTMLTextAreaElement) {
                        const myHTMLTextAreaElement = inputField;
                        myHTMLTextAreaElement.value = searchOp + val;
                    }
                }
            }
            return val;
        }
        YearMonthFormat(value) {
            const CurDate = new Date();
            switch (value.length) {
                case 1:
                    value = "0" + value;
                case 2:
                    value = CurDate.getFullYear() + value;
                    break;
                case 3:
                    value = "0" + value;
            }
            if (value.length === 4) {
                if (value.substr(0, 2) === "20" || value.substr(0, 2) === "19") {
                    value = value + ("0" + (CurDate.getMonth() + 1)).slice(-2);
                }
                else {
                    value = "20" + value;
                }
            }
            else if (value.length === 5) {
                value = `${value.substr(0, 4)}0${value.substr(4, 5)}`;
            }
            if (value.length > 6) {
                value = value.substr(0, 6);
            }
            if (parseInt(value.substr(0, 4), 10) > 2100 || parseInt(value.substr(0, 4), 10) < 1900) {
                value = CurDate.getFullYear() + value.substr(4, 6);
            }
            if (parseInt(value.substr(4, 6), 10) > 12 || parseInt(value.substr(4, 6), 10) < 1) {
                value = value.substr(0, 4) + ("0" + (CurDate.getMonth() + 1)).slice(-2);
            }
            value = `${value.substr(0, 4)} ${value.substr(4, 6)}`;
            return value;
        }
        DateParseFormat(value) {
            let myMonth = "";
            let myDate = "";
            let myYear = "";
            let tmp = value.toString().replace("\\", "/");
            if (tmp.indexOf("-", 0) !== -1) {
                const dateElementArr = tmp.split("-");
                if (dateElementArr.length > 2) {
                    if (dateElementArr[2].length !== 4) {
                        myYear = dateElementArr[0];
                        myMonth = dateElementArr[1];
                        myDate = dateElementArr[2];
                    }
                    else {
                        myYear = dateElementArr[2];
                        myMonth = dateElementArr[0];
                        myDate = dateElementArr[1];
                    }
                    tmp = `${myMonth}/${myDate}/${myYear}`;
                }
                else {
                    myMonth = dateElementArr[0];
                    myDate = dateElementArr[1];
                    tmp = `${myMonth}/${myDate}`;
                }
            }
            else if (tmp.indexOf(".", 0) !== -1) {
                const dateElementArr = tmp.split(".");
                if (dateElementArr.length > 2) {
                    switch (this.userLanguage) {
                        case "ZH":
                            if (dateElementArr[0].length === 4) {
                                myYear = dateElementArr[0];
                                myMonth = dateElementArr[1];
                                myDate = dateElementArr[2];
                            }
                            else {
                                myYear = dateElementArr[2];
                                myMonth = dateElementArr[1];
                                myDate = dateElementArr[0];
                            }
                            break;
                        case "EN":
                        case "FR":
                        case "AU":
                            myYear = dateElementArr[2];
                            myMonth = dateElementArr[1];
                            myDate = dateElementArr[0];
                            break;
                    }
                    tmp = `${myMonth}/${myDate}/${myYear}`;
                }
                else if (dateElementArr.length === 2) {
                    switch (this.userLanguage) {
                        case "ZH":
                            myMonth = dateElementArr[0];
                            myDate = dateElementArr[1];
                            break;
                        case "EN":
                        case "FR":
                        case "AU":
                            myMonth = dateElementArr[1];
                            myDate = dateElementArr[0];
                            break;
                    }
                    tmp = `${myMonth}/${myDate}`;
                }
            }
            else if (tmp.indexOf("/", 0) !== -1) {
                const dateElementArr = tmp.split("/");
                if (dateElementArr.length > 2) {
                    if (dateElementArr[0].length === 4) {
                        myYear = dateElementArr[0];
                        myMonth = dateElementArr[1];
                        myDate = dateElementArr[2];
                    }
                    else {
                        myYear = dateElementArr[2];
                        myMonth = dateElementArr[0];
                        myDate = dateElementArr[1];
                    }
                    tmp = `${myMonth}/${myDate}/${myYear}`;
                }
                else if (dateElementArr.length === 2) {
                    myMonth = dateElementArr[0];
                    myDate = dateElementArr[1];
                    tmp = `${myMonth}/${myDate}`;
                }
            }
            if (tmp.indexOf("/") === -1) {
                if (tmp.length > 8) {
                    tmp = tmp.substring(0, 8);
                }
                switch (this.userLanguage) {
                    case "ZH":
                        switch (tmp.length) {
                            case 3:
                                myMonth = tmp.substr(0, 1);
                                myDate = tmp.substr(1, 2);
                                break;
                            case 4:
                                myMonth = tmp.substr(0, 2);
                                myDate = tmp.substr(2, 2);
                                break;
                            case 5:
                                myMonth = tmp.substr(2, 1);
                                myDate = tmp.substr(3, 2);
                                myYear = tmp.substr(0, 2);
                                break;
                            case 6:
                                myYear = tmp.substr(0, 2);
                                myMonth = tmp.substr(2, 2);
                                myDate = tmp.substr(4, 2);
                                break;
                            case 7:
                                myMonth = tmp.substr(4, 1);
                                myDate = tmp.substr(5, 2);
                                myYear = tmp.substr(0, 4);
                                break;
                            case 8:
                                myYear = tmp.substr(0, 4);
                                myMonth = tmp.substr(4, 2);
                                myDate = tmp.substr(6, 2);
                                break;
                        }
                        break;
                    case "FR":
                    case "AU":
                    case "DE":
                    case "PT":
                        switch (tmp.length) {
                            case 3:
                                myMonth = tmp.substr(2, 1);
                                myDate = tmp.substr(0, 2);
                                break;
                            case 4:
                                myMonth = tmp.substr(2, 2);
                                myDate = tmp.substr(0, 2);
                                break;
                            case 5:
                                myYear = tmp.substr(3, 2);
                                myMonth = tmp.substr(2, 1);
                                myDate = tmp.substr(0, 2);
                                break;
                            case 6:
                                myYear = tmp.substr(4, 2);
                                myMonth = tmp.substr(2, 2);
                                myDate = tmp.substr(0, 2);
                                break;
                            case 7:
                                myYear = tmp.substr(3, 4);
                                myMonth = tmp.substr(2, 1);
                                myDate = tmp.substr(0, 2);
                                break;
                            case 8:
                                myYear = tmp.substr(4, 4);
                                myDate = tmp.substr(0, 2);
                                myMonth = tmp.substr(2, 2);
                                break;
                        }
                        break;
                    default:
                        switch (tmp.length) {
                            case 3:
                                myMonth = tmp.substr(0, 1);
                                myDate = tmp.substr(1, 2);
                                break;
                            case 4:
                                myMonth = tmp.substr(0, 2);
                                myDate = tmp.substr(2, 2);
                                break;
                            case 5:
                                myMonth = tmp.substr(0, 1);
                                myDate = tmp.substr(1, 2);
                                myYear = tmp.substr(3, 2);
                                break;
                            case 6:
                                myMonth = tmp.substr(0, 2);
                                myDate = tmp.substr(2, 2);
                                myYear = tmp.substr(4, 2);
                                break;
                            case 7:
                                myMonth = tmp.substr(0, 1);
                                myDate = tmp.substr(1, 2);
                                myYear = tmp.substr(5, 4);
                                break;
                            case 8:
                                myMonth = tmp.substr(0, 2);
                                myDate = tmp.substr(2, 2);
                                myYear = tmp.substr(4, 4);
                                break;
                        }
                        break;
                }
            }
            else {
                const tmpArr = tmp.split("/");
                myMonth = tmpArr[0];
                if (tmpArr.length > 1) {
                    myDate = tmpArr[1];
                }
                if (tmpArr.length > 2) {
                    myYear = tmpArr[2];
                }
            }
            const myDateObj = new Date();
            let year;
            if (this.isInteger(myYear)) {
                let yearInt = this.CDec(myYear);
                if (myYear.length === 5 && this.Right(myYear, 1) === this.Left(this.Right(myYear, 2), 1)) {
                    yearInt = this.CDec(this.Left(myYear, 4));
                }
                if (yearInt === 0) {
                    year = 2000;
                }
                else if (myYear.length == 1) {
                    year = yearInt + 2000;
                }
                else if (myYear.length == 2) {
                    if (yearInt > 50) {
                        year = this.CDec("19" + myYear.toString());
                    }
                    else {
                        year = yearInt + 2000;
                    }
                }
                else if (myYear.length === 3 || myYear.length >= 5) {
                    year = myDateObj.getFullYear();
                }
                else {
                    year = yearInt;
                }
            }
            else {
                year = myDateObj.getFullYear();
            }
            if (year < 1950) {
                year = 1950;
            }
            else if (year > 2050) {
                year = 2050;
            }
            let month;
            if (this.isInteger(myMonth)) {
                month = this.CDec(myMonth);
                if (month < 1 || month > 12) {
                    month = myDateObj.getMonth() + 1;
                }
            }
            else {
                month = myDateObj.getMonth() + 1;
            }
            let day;
            if (this.isInteger(myDate)) {
                day = this.CDec(myDate);
                if (day < 1) {
                    day = 1;
                }
                else if (day > 31) {
                    day = 31;
                }
            }
            else {
                day = myDateObj.getDate();
            }
            switch (month) {
                case 4:
                case 6:
                case 9:
                case 11:
                    if (day > 30) {
                        day = 30;
                    }
                    break;
                case 2:
                    const daysInFeb = new Date(year, 2, 0).getDate();
                    if (day > daysInFeb) {
                        day = daysInFeb;
                    }
                    break;
            }
            return `${month}/${day}/${year}`;
        }
        DateTimeParseFormat(value) {
            let TimeStr;
            if (value.toString().indexOf(" ") > 0) {
                const tmpDateArr = value.toString().split(" ");
                const DateStr = this.DateParseFormat(tmpDateArr[0]);
                if (tmpDateArr.length > 2) {
                    TimeStr = `${tmpDateArr[1]} ${tmpDateArr[2]}`;
                }
                else {
                    TimeStr = tmpDateArr[1];
                }
                value = `${DateStr} ${TimeStr}`;
            }
            const myDate = this.ToDate(value.toString());
            const myHour = myDate.getHours();
            const myMinute = myDate.getMinutes();
            const mySeconds = myDate.getSeconds();
            if (myHour > 12) {
                TimeStr = ` ${myHour - 12}:${this.Right("0" + myMinute, 2)}:${this.Right("0" + mySeconds, 2)} PM`;
            }
            else if (myHour === 12) {
                TimeStr = ` 12:${this.Right("0" + myMinute, 2)}:${this.Right("0" + mySeconds, 2)} PM`;
            }
            else if (myHour === 0) {
                TimeStr = ` 12:${this.Right("0" + myMinute, 2)}:${this.Right("0" + mySeconds, 2)} AM`;
            }
            else {
                TimeStr = ` ${myHour}:${this.Right("0" + myMinute, 2)}:${this.Right("0" + mySeconds, 2)} AM`;
            }
            return `${this.Right("0" + (myDate.getMonth() + 1), 2)}/${this.Right("0" + myDate.getDate(), 2)}/${myDate.getFullYear() + TimeStr}`;
        }
        CssEscape(value) {
            if (!value) {
                value = "";
            }
            else {
                value = value.toString();
            }
            const length = value.length;
            let index = -1;
            let codeUnit;
            let result = "";
            const firstCodeUnit = value.charCodeAt(0);
            while (++index < length) {
                codeUnit = value.charCodeAt(index);
                if (codeUnit === 0x0000) {
                    result += "\uFFFD";
                    continue;
                }
                if ((codeUnit >= 0x0001 && codeUnit <= 0x001F) ||
                    codeUnit === 0x007F ||
                    (index === 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039) ||
                    (index === 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit === 0x002D)) {
                    result += `\\${codeUnit.toString(16)} `;
                    continue;
                }
                if (index === 0 && length === 1 && codeUnit === 0x002D) {
                    result += "\\" + value.charAt(index);
                    continue;
                }
                if (codeUnit >= 0x0080 ||
                    codeUnit === 0x002D ||
                    codeUnit === 0x005F ||
                    codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
                    codeUnit >= 0x0041 && codeUnit <= 0x005A ||
                    codeUnit >= 0x0061 && codeUnit <= 0x007A) {
                    result += value.charAt(index);
                    continue;
                }
                result += "\\" + value.charAt(index);
            }
            return result;
        }
        RemoveHTMLFromStr(value) {
            return value.replace(/<(\"[^\"]*\"|'[^']*'|[^'\">])*>/g, "");
        }
        GetCellStyle(fieldObj, value) {
            let cellStyle = "";
            const dataType = this.DataTypeParse(fieldObj.DataType);
            if (fieldObj.Values && (typeof fieldObj.Values === "string" || (typeof fieldObj.Values === "object" && Object.keys(fieldObj.Values).length > 0)) && fieldObj.Aggregate === "") {
                cellStyle += "text-align:left;";
            }
            else {
                switch (dataType) {
                    case DataType._AutoNumber:
                    case DataType._Identity:
                    case DataType._Date:
                    case DataType._DateLocalTime:
                    case DataType._DateTime:
                    case DataType._LocalTime:
                    case DataType._Currency:
                    case DataType._Integer:
                    case DataType._Decimal:
                    case DataType._Phone:
                    case DataType._UPC:
                    case DataType._FileSize:
                        {
                            cellStyle += "text-align:right;";
                            break;
                        }
                    default:
                        {
                            cellStyle += "text-align:left;";
                            break;
                        }
                }
            }
            value = this.RemoveHTMLFromStr(value);
            if (dataType !== DataType._HTML) {
                if (fieldObj.Length > 4000) {
                    cellStyle += "max-width:max(40vw,800px);";
                }
                else if (fieldObj.Length > 2000) {
                    cellStyle += "max-width:max(35vw,700px);";
                }
                else {
                    cellStyle += "max-width:max(25vw,600px);";
                }
                if (value.length >= 100) {
                    let maxWorkLength = 0;
                    const Words = value.split(" ");
                    for (let i = 0, len = Words.length; i < len; i++) {
                        if (Words[i].length > maxWorkLength) {
                            maxWorkLength = Words[i].length;
                        }
                    }
                    if (maxWorkLength > 30) {
                        cellStyle += "word-wrap:break-word;";
                    }
                }
            }
            const widthThresholds = [[700, 500], [500, 400], [400, 300], [200, 200], [30, 90], [12, 60]];
            for (const [minLen, width] of widthThresholds) {
                if (value.length >= minLen) {
                    cellStyle += "min-width:" + width + "px;";
                    break;
                }
            }
            return cellStyle;
        }
        IsNumericDataType(dataType) {
            switch (dataType) {
                case DataType._AutoNumber:
                case DataType._BigInt:
                case DataType._Currency:
                case DataType._Decimal:
                case DataType._FileSize:
                case DataType._Identity:
                case DataType._Integer:
                case DataType._Months:
                case DataType._MonthAbbr:
                case DataType._MonthName:
                case DataType._Percentage:
                case DataType._UPC:
                case DataType._UPCA:
                case DataType._UPCE:
                    {
                        return true;
                    }
            }
            return false;
        }
        IsDateDataType(dataType) {
            switch (dataType) {
                case DataType._Date:
                case DataType._DateLocalTime:
                case DataType._DateTime:
                case DataType._LocalTime:
                case DataType._WeekLocalTime:
                    {
                        return true;
                    }
            }
            return false;
        }
        ReplaceState(stateObj, title, url) {
            if (this.isNull(url)) {
                url = window.location.href;
            }
            let hash;
            [url, ...hash] = url.split("#");
            const urlParams = this.GetURLParameters(url);
            const MissingDashboardID = (!this.isInteger(urlParams.DashboardID) && this.isInteger(EC_Fmt.GetPageParameter("DashboardID")));
            const TestDatabaseMissingEncompassID = (TestDatabase === true && this.isNull(urlParams.EncompassID) && !this.isNull(Distributor));
            if (!url.includes("?")) {
                url += "?";
            }
            if (MissingDashboardID) {
                url += `&DashboardID=${this.GetPageParameter("DashboardID")}`;
            }
            if (TestDatabaseMissingEncompassID) {
                url += `&EncompassID=${Distributor}`;
            }
            if (url.includes("&&")) {
                url = url.replace(/&{2,}/g, "&");
            }
            if (url.includes("?&")) {
                url = url.replace("?&", "?");
            }
            if (url[url.length - 1] === "&") {
                url = this.Left(url, url.length - 1);
            }
            if (hash && hash.length > 0) {
                url = url + "#" + hash.join("#");
            }
            window.history.replaceState(stateObj, title, url);
        }
        LoadAndPushToHistory(DataURL, HistoryURL, LoadingText, CoverSelector, callback, stateObj) {
            ECP.Dialog.ShowLoading(LoadingText, CoverSelector);
            if (this.isNull(stateObj)) {
                stateObj = {};
            }
            if (!stateObj["MD5Identifier"]) {
                const TmpDate = new Date();
                stateObj["MD5Identifier"] = this.MD5(`${DataURL}^${HistoryURL}^${callback}^${TmpDate.getTime()}`);
            }
            let LoadFunction;
            if (this.isNull(DataURL)) {
                LoadFunction = () => {
                    fetch(DataURL, {
                        credentials: "same-origin",
                    }).then((response) => response.text()).then((data) => {
                        ECP.Dialog.HideLoading();
                        history.pushState(stateObj, "", HistoryURL);
                        callback(data);
                    }).catch((error) => {
                        ECP.Dialog.HideLoading();
                        ECP.Dialog.Alert("Error Loading Results: " + error);
                    });
                };
            }
            else {
                LoadFunction = callback;
            }
            LoadFunction();
            window.addEventListener("popstate", (PopStateObj) => {
                if (PopStateObj["MD5Identifier"] === stateObj["MD5Identifier"]) {
                    ECP.Dialog.ShowLoading(LoadingText, CoverSelector);
                    LoadFunction();
                }
            });
        }
        addThousandsSeparatorCommas(numberString) {
            const x = numberString.toString().split(".");
            let x1 = x[0];
            const x2 = x.length > 1 ? `.${x[1]}` : "";
            const regex = /(\d+)(\d{3})/;
            while (regex.test(x1)) {
                x1 = x1.replace(regex, "$1,$2");
            }
            return x1 + x2;
        }
        Hex(x) {
            if (this.isNumber(x)) {
                const HexDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
                const num = Number(x);
                return HexDigits[(num - num % 16) / 16] + HexDigits[num % 16];
            }
            else {
                return "00";
            }
        }
        Trn(Value) {
            let TranslatedString = Value;
            if (this.userLanguage !== "EN" && this.LocaleStrings[Value]) {
                TranslatedString = this.LocaleStrings[Value];
            }
            return TranslatedString;
        }
        TranslateTrnElements(element) {
            let elementsToTranslate;
            if (element) {
                elementsToTranslate = [element];
            }
            else {
                elementsToTranslate = document.querySelectorAll("[trn]");
            }
            for (let i = 0, len = elementsToTranslate.length; i < len; i++) {
                const children = elementsToTranslate[i].children;
                if (children.length > 0) {
                    for (let j = 0, len2 = children.length; j < len2; j++) {
                        this.TranslateTrnElements(children[i]);
                    }
                }
                else {
                    elementsToTranslate[i].innerText = this.Trn(elementsToTranslate[i].innerText);
                }
                elementsToTranslate[i].removeAttribute("trn");
            }
        }
        CopyTextToClipboard(text, confirmationMessage) {
            const myNavigator = window.navigator;
            if (myNavigator.clipboard) {
                myNavigator.clipboard.writeText(text).then(() => {
                    if (confirmationMessage) {
                        ECP.HTML.Snackbar(confirmationMessage, "Success");
                    }
                }, () => {
                    this.CopyTextThroughTextArea(text, confirmationMessage);
                });
                return;
            }
            this.CopyTextThroughTextArea(text, confirmationMessage);
        }
        CopyTextThroughTextArea(text, confirmationMessage) {
            const tmpTextArea = document.createElement("textarea");
            tmpTextArea.style.position = "fixed";
            tmpTextArea.style.top = "-9999px";
            tmpTextArea.style.left = "0";
            document.body.appendChild(tmpTextArea);
            tmpTextArea.textContent = text;
            tmpTextArea.value = text;
            requestAnimationFrame(() => {
                this.BackupCopyTextToClipboard(tmpTextArea, confirmationMessage);
            });
        }
        BackupCopyTextToClipboard(tmpTextArea, confirmationMessage) {
            tmpTextArea.setSelectionRange(0, tmpTextArea.value.length);
            const selection = document.getSelection();
            const range = document.createRange();
            range.selectNode(tmpTextArea);
            selection.removeAllRanges();
            selection.addRange(range);
            try {
                if (document.execCommand("copy")) {
                    if (confirmationMessage) {
                        ECP.HTML.Snackbar(confirmationMessage, "Success");
                    }
                }
                else {
                    ECP.HTML.Snackbar("Your browser does not support copying to the clipboard.", "Error");
                }
            }
            catch (err) {
                ECP.HTML.Snackbar("Your browser does not support copying to the clipboard.", "Error");
            }
            selection.removeAllRanges();
            requestAnimationFrame(() => {
                document.body.removeChild(tmpTextArea);
            });
        }
        FormatRelativeTime(startDate, endDate) {
            const diffMilliseconds = endDate.getTime() - startDate.getTime();
            if (diffMilliseconds < 0)
                return "Invalid date";
            const diffSeconds = diffMilliseconds / 1000;
            const diffMinutes = diffSeconds / 60;
            const diffHours = diffMinutes / 60;
            const diffDays = diffHours / 24;
            if (diffSeconds < 60) {
                return "just now";
            }
            if (diffMinutes < 60) {
                const minutes = Math.floor(diffMinutes);
                return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
            }
            if (diffHours < 24) {
                const hours = Math.floor(diffHours);
                return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
            }
            if (diffDays < 7) {
                const days = Math.floor(diffDays);
                return `${days} day${days !== 1 ? 's' : ''} ago`;
            }
            if (diffDays < 35) {
                const weeks = Math.floor(diffDays / 7);
                return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
            }
            if (diffDays < 365) {
                const months = Math.floor(diffDays / 30.436875);
                return `${months} month${months !== 1 ? 's' : ''} ago`;
            }
            const years = Math.floor(diffDays / 365.25);
            return `${years} year${years !== 1 ? 's' : ''} ago`;
        }
    }
    Format.MD5Compute = (_a = class MD5Compute {
            static _hex(x) {
                const hc = Format.MD5Compute.hexChars;
                const ho = Format.MD5Compute.hexOut;
                for (let i = 0; i < 4; i++) {
                    const offset = i * 8;
                    let n = x[i];
                    for (let j = 0; j < 8; j += 2) {
                        ho[offset + 1 + j] = hc.charAt(n & 0x0F);
                        n >>>= 4;
                        ho[offset + 0 + j] = hc.charAt(n & 0x0F);
                        n >>>= 4;
                    }
                }
                return ho.join("");
            }
            static _md5cycle(x, k) {
                let a = x[0];
                let b = x[1];
                let c = x[2];
                let d = x[3];
                a += (b & c | ~b & d) + k[0] - 680876936 | 0;
                a = (a << 7 | a >>> 25) + b | 0;
                d += (a & b | ~a & c) + k[1] - 389564586 | 0;
                d = (d << 12 | d >>> 20) + a | 0;
                c += (d & a | ~d & b) + k[2] + 606105819 | 0;
                c = (c << 17 | c >>> 15) + d | 0;
                b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
                b = (b << 22 | b >>> 10) + c | 0;
                a += (b & c | ~b & d) + k[4] - 176418897 | 0;
                a = (a << 7 | a >>> 25) + b | 0;
                d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
                d = (d << 12 | d >>> 20) + a | 0;
                c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
                c = (c << 17 | c >>> 15) + d | 0;
                b += (c & d | ~c & a) + k[7] - 45705983 | 0;
                b = (b << 22 | b >>> 10) + c | 0;
                a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
                a = (a << 7 | a >>> 25) + b | 0;
                d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
                d = (d << 12 | d >>> 20) + a | 0;
                c += (d & a | ~d & b) + k[10] - 42063 | 0;
                c = (c << 17 | c >>> 15) + d | 0;
                b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
                b = (b << 22 | b >>> 10) + c | 0;
                a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
                a = (a << 7 | a >>> 25) + b | 0;
                d += (a & b | ~a & c) + k[13] - 40341101 | 0;
                d = (d << 12 | d >>> 20) + a | 0;
                c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
                c = (c << 17 | c >>> 15) + d | 0;
                b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
                b = (b << 22 | b >>> 10) + c | 0;
                a += (b & d | c & ~d) + k[1] - 165796510 | 0;
                a = (a << 5 | a >>> 27) + b | 0;
                d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
                d = (d << 9 | d >>> 23) + a | 0;
                c += (d & b | a & ~b) + k[11] + 643717713 | 0;
                c = (c << 14 | c >>> 18) + d | 0;
                b += (c & a | d & ~a) + k[0] - 373897302 | 0;
                b = (b << 20 | b >>> 12) + c | 0;
                a += (b & d | c & ~d) + k[5] - 701558691 | 0;
                a = (a << 5 | a >>> 27) + b | 0;
                d += (a & c | b & ~c) + k[10] + 38016083 | 0;
                d = (d << 9 | d >>> 23) + a | 0;
                c += (d & b | a & ~b) + k[15] - 660478335 | 0;
                c = (c << 14 | c >>> 18) + d | 0;
                b += (c & a | d & ~a) + k[4] - 405537848 | 0;
                b = (b << 20 | b >>> 12) + c | 0;
                a += (b & d | c & ~d) + k[9] + 568446438 | 0;
                a = (a << 5 | a >>> 27) + b | 0;
                d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
                d = (d << 9 | d >>> 23) + a | 0;
                c += (d & b | a & ~b) + k[3] - 187363961 | 0;
                c = (c << 14 | c >>> 18) + d | 0;
                b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
                b = (b << 20 | b >>> 12) + c | 0;
                a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
                a = (a << 5 | a >>> 27) + b | 0;
                d += (a & c | b & ~c) + k[2] - 51403784 | 0;
                d = (d << 9 | d >>> 23) + a | 0;
                c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
                c = (c << 14 | c >>> 18) + d | 0;
                b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
                b = (b << 20 | b >>> 12) + c | 0;
                a += (b ^ c ^ d) + k[5] - 378558 | 0;
                a = (a << 4 | a >>> 28) + b | 0;
                d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
                d = (d << 11 | d >>> 21) + a | 0;
                c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
                c = (c << 16 | c >>> 16) + d | 0;
                b += (c ^ d ^ a) + k[14] - 35309556 | 0;
                b = (b << 23 | b >>> 9) + c | 0;
                a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
                a = (a << 4 | a >>> 28) + b | 0;
                d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
                d = (d << 11 | d >>> 21) + a | 0;
                c += (d ^ a ^ b) + k[7] - 155497632 | 0;
                c = (c << 16 | c >>> 16) + d | 0;
                b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
                b = (b << 23 | b >>> 9) + c | 0;
                a += (b ^ c ^ d) + k[13] + 681279174 | 0;
                a = (a << 4 | a >>> 28) + b | 0;
                d += (a ^ b ^ c) + k[0] - 358537222 | 0;
                d = (d << 11 | d >>> 21) + a | 0;
                c += (d ^ a ^ b) + k[3] - 722521979 | 0;
                c = (c << 16 | c >>> 16) + d | 0;
                b += (c ^ d ^ a) + k[6] + 76029189 | 0;
                b = (b << 23 | b >>> 9) + c | 0;
                a += (b ^ c ^ d) + k[9] - 640364487 | 0;
                a = (a << 4 | a >>> 28) + b | 0;
                d += (a ^ b ^ c) + k[12] - 421815835 | 0;
                d = (d << 11 | d >>> 21) + a | 0;
                c += (d ^ a ^ b) + k[15] + 530742520 | 0;
                c = (c << 16 | c >>> 16) + d | 0;
                b += (c ^ d ^ a) + k[2] - 995338651 | 0;
                b = (b << 23 | b >>> 9) + c | 0;
                a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
                a = (a << 6 | a >>> 26) + b | 0;
                d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
                d = (d << 10 | d >>> 22) + a | 0;
                c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
                c = (c << 15 | c >>> 17) + d | 0;
                b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
                b = (b << 21 | b >>> 11) + c | 0;
                a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
                a = (a << 6 | a >>> 26) + b | 0;
                d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
                d = (d << 10 | d >>> 22) + a | 0;
                c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
                c = (c << 15 | c >>> 17) + d | 0;
                b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
                b = (b << 21 | b >>> 11) + c | 0;
                a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
                a = (a << 6 | a >>> 26) + b | 0;
                d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
                d = (d << 10 | d >>> 22) + a | 0;
                c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
                c = (c << 15 | c >>> 17) + d | 0;
                b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
                b = (b << 21 | b >>> 11) + c | 0;
                a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
                a = (a << 6 | a >>> 26) + b | 0;
                d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
                d = (d << 10 | d >>> 22) + a | 0;
                c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
                c = (c << 15 | c >>> 17) + d | 0;
                b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
                b = (b << 21 | b >>> 11) + c | 0;
                x[0] = a + x[0] | 0;
                x[1] = b + x[1] | 0;
                x[2] = c + x[2] | 0;
                x[3] = d + x[3] | 0;
            }
            constructor() {
                this._state = new Int32Array(4);
                this._buffer = new ArrayBuffer(68);
                this._buffer8 = new Uint8Array(this._buffer, 0, 68);
                this._buffer32 = new Uint32Array(this._buffer, 0, 17);
                this.start();
            }
            start() {
                this._dataLength = 0;
                this._bufferLength = 0;
                this._state.set(Format.MD5Compute.stateIdentity);
                return this;
            }
            appendStr(str) {
                const buf8 = this._buffer8;
                const buf32 = this._buffer32;
                let bufLen = this._bufferLength;
                for (let i = 0; i < str.length; i++) {
                    let code = str.charCodeAt(i);
                    if (code < 128) {
                        buf8[bufLen++] = code;
                    }
                    else if (code < 0x800) {
                        buf8[bufLen++] = (code >>> 6) + 0xC0;
                        buf8[bufLen++] = code & 0x3F | 0x80;
                    }
                    else if (code < 0xD800 || code > 0xDBFF) {
                        buf8[bufLen++] = (code >>> 12) + 0xE0;
                        buf8[bufLen++] = (code >>> 6 & 0x3F) | 0x80;
                        buf8[bufLen++] = (code & 0x3F) | 0x80;
                    }
                    else {
                        code = ((code - 0xD800) * 0x400) + (str.charCodeAt(++i) - 0xDC00) + 0x10000;
                        if (code > 0x10FFFF) {
                            throw new Error("Unicode standard supports code points up to U+10FFFF");
                        }
                        buf8[bufLen++] = (code >>> 18) + 0xF0;
                        buf8[bufLen++] = (code >>> 12 & 0x3F) | 0x80;
                        buf8[bufLen++] = (code >>> 6 & 0x3F) | 0x80;
                        buf8[bufLen++] = (code & 0x3F) | 0x80;
                    }
                    if (bufLen >= 64) {
                        this._dataLength += 64;
                        Format.MD5Compute._md5cycle(this._state, buf32);
                        bufLen -= 64;
                        buf32[0] = buf32[16];
                    }
                }
                this._bufferLength = bufLen;
                return this;
            }
            appendAsciiStr(str) {
                const buf8 = this._buffer8;
                const buf32 = this._buffer32;
                let bufLen = this._bufferLength;
                let i;
                let j = 0;
                while (true) {
                    i = Math.min(str.length - j, 64 - bufLen);
                    while (i--) {
                        buf8[bufLen++] = str.charCodeAt(j++);
                    }
                    if (bufLen < 64) {
                        break;
                    }
                    this._dataLength += 64;
                    Format.MD5Compute._md5cycle(this._state, buf32);
                    bufLen = 0;
                }
                this._bufferLength = bufLen;
                return this;
            }
            appendByteArray(input) {
                const buf8 = this._buffer8;
                const buf32 = this._buffer32;
                let bufLen = this._bufferLength;
                let i;
                let j = 0;
                while (true) {
                    i = Math.min(input.length - j, 64 - bufLen);
                    while (i--) {
                        buf8[bufLen++] = input[j++];
                    }
                    if (bufLen < 64) {
                        break;
                    }
                    this._dataLength += 64;
                    Format.MD5Compute._md5cycle(this._state, buf32);
                    bufLen = 0;
                }
                this._bufferLength = bufLen;
                return this;
            }
            getState() {
                const self = this;
                const s = self._state;
                return {
                    buffer: String.fromCharCode.apply(null, self._buffer8),
                    buflen: self._bufferLength,
                    length: self._dataLength,
                    state: [s[0], s[1], s[2], s[3]],
                };
            }
            setState(state) {
                const buf = state.buffer;
                const x = state.state;
                const s = this._state;
                this._dataLength = state.length;
                this._bufferLength = state.buflen;
                s[0] = x[0];
                s[1] = x[1];
                s[2] = x[2];
                s[3] = x[3];
                for (let i = 0; i < buf.length; i++) {
                    this._buffer8[i] = buf.charCodeAt(i);
                }
            }
            end(raw) {
                if (raw === undefined) {
                    raw = false;
                }
                const bufLen = this._bufferLength;
                const buf8 = this._buffer8;
                const buf32 = this._buffer32;
                const i = (bufLen >> 2) + 1;
                this._dataLength += bufLen;
                buf8[bufLen] = 0x80;
                buf8[bufLen + 1] = buf8[bufLen + 2] = buf8[bufLen + 3] = 0;
                buf32.set(Format.MD5Compute.buffer32Identity.subarray(i), i);
                if (bufLen > 55) {
                    Format.MD5Compute._md5cycle(this._state, buf32);
                    buf32.set(Format.MD5Compute.buffer32Identity);
                }
                const dataBitsLen = this._dataLength * 8;
                if (dataBitsLen <= 0xFFFFFFFF) {
                    buf32[14] = dataBitsLen;
                }
                else {
                    const matches = dataBitsLen.toString(16).match(/(.*?)(.{0,8})$/);
                    if (matches === null) {
                        return undefined;
                    }
                    const lo = parseInt(matches[2], 16);
                    const hi = parseInt(matches[1], 16) || 0;
                    buf32[14] = lo;
                    buf32[15] = hi;
                }
                Format.MD5Compute._md5cycle(this._state, buf32);
                return raw ? this._state : Format.MD5Compute._hex(this._state);
            }
        },
        _a.stateIdentity = new Int32Array([1732584193, -271733879, -1732584194, 271733878]),
        _a.buffer32Identity = new Int32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
        _a.hexChars = "0123456789abcdef",
        _a.hexOut = [],
        _a);
    ECP.Format = Format;
})(ECP || (ECP = {}));
const EC_Fmt = new ECP.Format();
var ECP;
(function (ECP) {
    class EC_Field {
        constructor() { }
    }
    ECP.EC_Field = EC_Field;
    let RecordStatus;
    (function (RecordStatus) {
        RecordStatus[RecordStatus["New"] = 1] = "New";
        RecordStatus[RecordStatus["Existing"] = 2] = "Existing";
        RecordStatus[RecordStatus["Changed"] = 3] = "Changed";
        RecordStatus[RecordStatus["Delete"] = 4] = "Delete";
    })(RecordStatus = ECP.RecordStatus || (ECP.RecordStatus = {}));
    class EC_Recordset {
        constructor(data) {
            if (!EC_Fmt.isNull(data)) {
                if (typeof data !== "object") {
                    data = JSON.parse(data);
                }
                if (typeof data === "object" && (typeof data.Export === "object" || typeof data.Table === "object")) {
                    if (typeof data.Table === "object") {
                        data = data.Table;
                    }
                    else if (typeof data.Export.Table === "object") {
                        data = data.Export.Table;
                    }
                    else {
                        data = data.Export.Report;
                    }
                    this.Fields = [];
                    if (data.Name) {
                        this.TableName = data.Name;
                    }
                    if (data.TableKey) {
                        this.TableKey = data.TableKey;
                    }
                    if (data.Field instanceof Array) {
                        let tmpField;
                        for (let i = 0, len = data.Field.length; i < len; i++) {
                            tmpField = data.Field[i];
                            const newField = new EC_Field();
                            newField.Name = tmpField.Name;
                            newField.Alias = EC_Fmt.NullChk(tmpField.Alias, tmpField.Name);
                            newField.Required = EC_Fmt.NullChk(tmpField.Required, false);
                            newField.Default = EC_Fmt.Null2EmptyStr(tmpField.Default);
                            newField.CanEdit = EC_Fmt.NullChk(tmpField.CanEdit, false);
                            newField.DataType = EC_Fmt.DataTypeParse(tmpField.DataType);
                            newField.Values = tmpField.Values;
                            newField.Sort = tmpField.Sort;
                            newField.Filter = tmpField.Filter;
                            this.Fields.push(newField);
                        }
                    }
                    else if (!EC_Fmt.isNull(data.Field)) {
                        const newField = new EC_Field();
                        newField.Name = data.Field.Name;
                        newField.Alias = EC_Fmt.NullChk(data.Field.Alias, data.Field.Name);
                        newField.Required = EC_Fmt.NullChk(data.Field.Required, false);
                        newField.Default = EC_Fmt.Null2EmptyStr(data.Field.Default);
                        newField.CanEdit = EC_Fmt.NullChk(data.Field.CanEdit, false);
                        newField.DataType = EC_Fmt.DataTypeParse(data.Field.DataType);
                        newField.Values = data.Field.Values;
                        newField.Sort = data.Field.Sort;
                        newField.Filter = data.Field.Filter;
                        this.Fields.push(newField);
                    }
                    if (data.Row instanceof Array) {
                        this.Records = data.Row;
                    }
                    else {
                        this.Records = [];
                        if (data.Row) {
                            this.Records.push(data.Row);
                        }
                    }
                    this.RecordCount = this.Records.length;
                    for (let i = 0; i < this.RecordCount; i++) {
                        if (!this.Records[i].__Status) {
                            this.Records[i].__Status = ECP.RecordStatus.Existing;
                        }
                    }
                }
                else {
                    throw Error("Invalid format of 'data' object sent to EC_Recordset()");
                }
            }
            else {
                this.RecordCount = 0;
            }
            this.Index = 0;
            this.EOF = true;
            this.BOF = true;
            if (this.RecordCount > 0) {
                this.EOF = false;
            }
        }
        ColumnExists(name) {
            for (let i = 0, len = this.Fields.length; i < len; i++) {
                if (this.Fields[i].Name.toLowerCase() === name.toLowerCase()) {
                    return true;
                }
            }
            return false;
        }
        RemoveAllRecords() {
            this.Records = [];
            this.RecordCount = 0;
            this.Index = 0;
            this.EOF = true;
            this.BOF = true;
        }
        MoveNext() {
            this.Index += 1;
            this.updateEOFAndBOF();
        }
        MovePrevious() {
            this.Index -= 1;
            this.updateEOFAndBOF();
        }
        MoveFirst() {
            this.Index = 0;
            this.updateEOFAndBOF();
        }
        updateEOFAndBOF() {
            if (this.Index <= 0) {
                this.Index = 0;
                this.BOF = true;
            }
            else {
                this.BOF = false;
            }
            if (this.Index >= this.Records.length) {
                if (this.Records.length > 0) {
                    this.Index = this.Records.length - 1;
                }
                else {
                    this.Index = 0;
                }
                this.EOF = true;
            }
            else {
                this.EOF = false;
            }
        }
        GetSubTableByName(tableName) {
            if (this.Records[this.Index]) {
                const subTables = this.Records[this.Index].SubTables;
                if (EC_Fmt.MultipleSelected(subTables)) {
                    for (let i = 0, len = subTables.length; i < len; i++) {
                        if (subTables[i].Table.Name === tableName) {
                            return subTables[i];
                        }
                    }
                }
            }
            return undefined;
        }
        GetSubTableRecordSet(tableName) {
            return new EC_Recordset(this.GetSubTableByName(tableName));
        }
        Item(key, dataType) {
            if (!this.Records[this.Index]) {
                return undefined;
            }
            if (dataType === undefined) {
                return this.Records[this.Index][key];
            }
            else if (typeof key === "number") {
                switch (dataType) {
                    case ECP.DataType._AutoNumber:
                    case ECP.DataType._Integer:
                    case ECP.DataType._BigInt:
                    case ECP.DataType._Identity:
                        return parseInt(this.Records[this.Index][this.Fields[key].Name], 10);
                    case ECP.DataType._Decimal:
                    case ECP.DataType._Currency:
                    case ECP.DataType._Percentage:
                        return parseFloat(this.Records[this.Index][this.Fields[key].Name]);
                    case ECP.DataType._YesNo:
                        const val = this.Records[this.Index][this.Fields[key].Name];
                        if (val === "1" || val.toLowerCase() === "true") {
                            return true;
                        }
                        return false;
                    default:
                        return this.Records[this.Index][this.Fields[key].Name];
                }
            }
            else {
                switch (dataType) {
                    case ECP.DataType._AutoNumber:
                    case ECP.DataType._Integer:
                    case ECP.DataType._BigInt:
                    case ECP.DataType._Identity:
                        return parseInt(this.Records[this.Index][key], 10);
                    case ECP.DataType._Decimal:
                    case ECP.DataType._Currency:
                    case ECP.DataType._Percentage:
                        return parseFloat(this.Records[this.Index][key]);
                    case ECP.DataType._YesNo:
                        const val = this.Records[this.Index][key];
                        if (val === "1" || val.toLowerCase() === "true") {
                            return true;
                        }
                        return false;
                    default:
                        return this.Records[this.Index][key];
                }
            }
        }
        ItemInt(key) {
            return this.Item(key, ECP.DataType._Integer);
        }
        ItemDec(key) {
            return this.Item(key, ECP.DataType._Decimal);
        }
        ItemBool(key) {
            return this.Item(key, ECP.DataType._YesNo);
        }
        ItemHTMLAttribute(key, AttributeName) {
            if (AttributeName === "FKValue") {
                return this.ItemDBValue(key);
            }
            const ItemText = this.Item(key, ECP.DataType._Text);
            if (ItemText.startsWith("<") && ItemText.endsWith(">")) {
                const ItemElement = EC_Fmt.HtmlStrToElement(ItemText);
                if (ItemElement.hasAttribute(AttributeName)) {
                    return ItemElement.getAttribute(AttributeName);
                }
            }
            return ItemText;
        }
        ItemDBValue(key) {
            let value;
            if (typeof key === "number") {
                key = this.Fields[key].Name;
            }
            if (this.Records[this.Index] && Object.prototype.hasOwnProperty.call(this.Records[this.Index], key + "_DBValue")) {
                value = this.Item(key + "_DBValue");
            }
            else {
                value = this.Item(key);
            }
            return value;
        }
        KeyValue() {
            let value = this.Item("enc-keyValue");
            if (EC_Fmt.isNull(value)) {
                value = this.ItemDBValue(this.TableKey);
            }
            return value;
        }
        SetItem(key, value) {
            if (!this.Records[this.Index]) {
                throw Error("Index location invalid in recordset. Did you try to set a value before adding any records or after the end of the list?");
            }
            this.Records[this.Index][key] = value;
            if (this.Records[this.Index][key + "_DBValue"] !== undefined) {
                this.Records[this.Index][key + "_DBValue"] = value;
            }
            if (key === this.TableKey) {
                this.Records[this.Index]["enc-keyValue"] = value;
            }
            if (this.Records[this.Index].__Status === ECP.RecordStatus.Existing) {
                this.Records[this.Index].__Status = ECP.RecordStatus.Changed;
            }
        }
        SetItem_SubTable(key, value, SubKeyValue, tableName) {
            const subTable = this.GetSubTableByName(tableName);
            const SubRowIndex = this.GetSubRowIndexByKeyValue(SubKeyValue, subTable);
            if (SubRowIndex !== -1) {
                subTable.Table.Row[SubRowIndex][key] = value;
                if (subTable.Table.Row[SubRowIndex][key + "_DBValue"] !== undefined) {
                    subTable.Table.Row[SubRowIndex][key + "_DBValue"] = value;
                }
                if (key === SubKeyValue) {
                    subTable.Table.Row[SubRowIndex]["enc-keyValue"] = value;
                }
                if (subTable.Table.Row[SubRowIndex].__Status === ECP.RecordStatus.Existing) {
                    subTable.Table.Row[SubRowIndex].__Status = ECP.RecordStatus.Changed;
                }
            }
        }
        GetSubRowIndexByKeyValue(SubKeyValue, subTable) {
            if (subTable.Table && subTable.Table.Row && subTable.Table.TableKey) {
                for (let i = 0, len = subTable.Table.Row.length; i < len; i++) {
                    if (subTable.Table.Row[i][subTable.Table.TableKey] == SubKeyValue) {
                        return i;
                    }
                }
                return -1;
            }
            else {
                throw Error("Invalid recordset structure, cannot use SetItem_SubTable() or DeleteRecord_SubTable() - Use EC_TableView structure for the recordset");
            }
        }
        AddRecord(newRecord) {
            newRecord["__Status"] = ECP.RecordStatus.New;
            if (!newRecord["enc-keyValue"]) {
                newRecord["enc-keyValue"] = newRecord[this.TableKey + "_DBValue"] || newRecord[this.TableKey];
            }
            this.Records.push(newRecord);
            this.RecordCount = this.Records.length;
        }
        AddRecord_SubTable(newRecord, tableName, subTableStructure) {
            let subTable = this.GetSubTableByName(tableName);
            if (!subTable) {
                if (!subTableStructure) {
                    const originalIndex = this.Index;
                    this.Index = 0;
                    for (; this.Index < this.RecordCount; this.Index++) {
                        subTableStructure = this.GetSubTableByName(tableName);
                        if (subTableStructure) {
                            break;
                        }
                    }
                    this.Index = originalIndex;
                }
                if (!subTableStructure) {
                    throw Error("Cannot add sub-table record, no other records in this recordset contain this sub-table. (structure must be copied from another record)");
                }
                else {
                    if (!this.Records[this.Index].SubTables) {
                        this.Records[this.Index].SubTables = [];
                    }
                    subTableStructure = JSON.parse(JSON.stringify(subTableStructure));
                    subTableStructure.Table.Row = [];
                    this.Records[this.Index].SubTables.push(subTableStructure);
                    subTable = this.GetSubTableByName(tableName);
                }
            }
            if (subTable.Table && subTable.Table.Row) {
                newRecord["__Status"] = ECP.RecordStatus.New;
                if (!newRecord["enc-keyValue"]) {
                    newRecord["enc-keyValue"] = newRecord[this.TableKey + "_DBValue"] || newRecord[this.TableKey];
                }
                subTable.Table.Row.push(newRecord);
            }
            else {
                throw Error("Invalid recordset structure, cannot use AddSubTableRecord() - Use EC_TableView structure for the recordset");
            }
        }
        DeleteRecord() {
            if (this.Records[this.Index].__Status === ECP.RecordStatus.New) {
                this.Records.splice(this.Index, 1);
            }
            else if (this.KeyValue() === undefined) {
                throw Error("Cannot call EC_Recordset.DeleteRecord() if the table key is not in the recordset.");
            }
            else {
                this.Records[this.Index].__Status = ECP.RecordStatus.Delete;
            }
        }
        DeleteRecord_SubTable(tableName, SubKeyValue) {
            const subTable = this.GetSubTableByName(tableName);
            const SubRowIndex = this.GetSubRowIndexByKeyValue(SubKeyValue, subTable);
            if (SubRowIndex !== -1) {
                if (subTable.Table.Row[SubRowIndex].__Status === ECP.RecordStatus.New) {
                    subTable.Table.Row.splice(SubRowIndex, 1);
                }
                else if (this.KeyValue() === undefined) {
                    throw Error("Cannot call DeleteRecord_SubTable() if the table key is not in the sub-table recordset.");
                }
                else {
                    subTable.Table.Row[SubRowIndex].__Status = ECP.RecordStatus.Delete;
                }
            }
        }
        GetStatus() {
            return this.Records[this.Index].__Status;
        }
        GetStatus_SubTable(tableName, SubKeyValue) {
            const subTable = this.GetSubTableByName(tableName);
            const SubRowIndex = this.GetSubRowIndexByKeyValue(SubKeyValue, subTable);
            if (SubRowIndex !== -1) {
                return subTable.Table.Row[SubRowIndex].__Status;
            }
            return undefined;
        }
        JumpToRowByKeyValue(SearchKeyValue) {
            if (this.KeyValue() === undefined) {
                throw Error("Cannot call EC_Recordset.JumpToRowByKeyValue() if the table key is not in the recordset.");
            }
            for (let i = 0; i < this.RecordCount; i++) {
                if (this.Records[i]["enc-keyValue"] == SearchKeyValue || this.Records[i][this.TableKey] == SearchKeyValue) {
                    this.Index = i;
                    break;
                }
            }
        }
    }
    ECP.EC_Recordset = EC_Recordset;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    ECP.WebRequestID = EC_Fmt.Guid();
    let EC_Verb;
    (function (EC_Verb) {
        EC_Verb[EC_Verb["Get"] = 1] = "Get";
        EC_Verb[EC_Verb["Post"] = 2] = "Post";
    })(EC_Verb = ECP.EC_Verb || (ECP.EC_Verb = {}));
    let EC_ReturnType;
    (function (EC_ReturnType) {
        EC_ReturnType[EC_ReturnType["Json"] = 1] = "Json";
        EC_ReturnType[EC_ReturnType["Text"] = 2] = "Text";
        EC_ReturnType[EC_ReturnType["Blob"] = 3] = "Blob";
    })(EC_ReturnType = ECP.EC_ReturnType || (ECP.EC_ReturnType = {}));
    let EC_Operator;
    (function (EC_Operator) {
        EC_Operator[EC_Operator["Equals"] = 1] = "Equals";
        EC_Operator[EC_Operator["NotEquals"] = 2] = "NotEquals";
        EC_Operator[EC_Operator["GreaterThan"] = 3] = "GreaterThan";
        EC_Operator[EC_Operator["GreaterThanEquals"] = 4] = "GreaterThanEquals";
        EC_Operator[EC_Operator["LessThan"] = 5] = "LessThan";
        EC_Operator[EC_Operator["LessThanEquals"] = 6] = "LessThanEquals";
        EC_Operator[EC_Operator["Like"] = 7] = "Like";
        EC_Operator[EC_Operator["Range"] = 8] = "Range";
        EC_Operator[EC_Operator["NotLike"] = 9] = "NotLike";
        EC_Operator[EC_Operator["In"] = 10] = "In";
    })(EC_Operator = ECP.EC_Operator || (ECP.EC_Operator = {}));
    class EC_Request {
        constructor(command) {
            this.Command = command;
            this.Public = false;
            this.Verb = EC_Verb.Get;
            this.ReturnType = EC_ReturnType.Json;
            this.ContentType = "application/x-www-form-urlencoded";
            this.EncompassID = "";
            this.APIHost = "";
            this.Parameters = [];
            this.Variables = [];
            this.Headers = [];
        }
        SetAPIToken(token) {
            this.APIToken = token;
            this.Public = true;
        }
        SetAPIHost(host) {
            this.APIHost = host;
        }
        SetReturnType(returnType) {
            this.ReturnType = returnType;
        }
        SetEncompassID(encompassID) {
            this.EncompassID = encompassID;
        }
        AddParameter(Name, value, Operator) {
            this.Parameters.push({
                Name,
                Operator,
                Value: EC_Fmt.Null2EmptyStr(value),
                Verb: EC_Verb.Get,
            });
        }
        AddRequestVariable(Name, value, Verb) {
            if (Verb === undefined) {
                Verb = EC_Verb.Get;
            }
            this.Variables.push({
                Name,
                Operator: EC_Operator.Equals,
                Value: EC_Fmt.Null2EmptyStr(value),
                Verb,
            });
            if (Verb === EC_Verb.Post) {
                this.Verb = EC_Verb.Post;
            }
        }
        AddJSON(json) {
            this.Body = json;
            this.Verb = EC_Verb.Post;
            this.ContentType = "application/json";
        }
        AddFile(Name, File) {
            this.Variables.push({
                Name,
                Operator: EC_Operator.Equals,
                Value: File,
                Verb: EC_Verb.Post,
            });
            this.Verb = EC_Verb.Post;
            this.ContentType = "multipart/form-data";
        }
        SetRequestHeader(Header, Value) {
            this.Headers.push({ Header, Value });
        }
        SubmitAPIRequest(TimeoutInSeconds) {
            const Me = this;
            return new Promise((resolve, reject) => {
                let url = "";
                let hasQuickKey = false;
                let externalOrPublic = false;
                if (this.APIHost) {
                    url = `https://${this.APIHost}/aspx1/`;
                    externalOrPublic = true;
                }
                url += "api?APICommand=" + encodeURIComponent(Me.Command);
                if (Me.EncompassID !== "") {
                    const CurrentEncompassID = EC_Fmt.GetCookie("EncompassID");
                    if ((EC_Fmt.isNull(CurrentEncompassID) || CurrentEncompassID !== Me.EncompassID) && !this.APIHost) {
                        if (TimeoutInSeconds > 180) {
                            url = "https://api.encompass8.com/aspx1/api?APICommand=" + encodeURIComponent(Me.Command);
                        }
                        else {
                            url = "https://api.e8.co/api?APICommand=" + encodeURIComponent(Me.Command);
                        }
                        externalOrPublic = true;
                    }
                    url += "&EncompassID=" + encodeURIComponent(Me.EncompassID);
                }
                else if (Me.Public && !EC_Fmt.isNull(EC_Fmt.GetCookie("EncompassID"))) {
                    url += "&EncompassID=" + encodeURIComponent(EC_Fmt.GetCookie("EncompassID"));
                }
                if (Me.Public) {
                    url += "&APIToken=" + encodeURIComponent(Me.APIToken);
                    externalOrPublic = true;
                }
                if (!TimeoutInSeconds) {
                    TimeoutInSeconds = externalOrPublic ? 180 : 900;
                }
                url += `&WebRequestID=${ECP.WebRequestID}`;
                if (window.Settings && window.Settings.DashboardID) {
                    url += `&RequestDashboardID=${window.Settings.DashboardID}`;
                }
                if (window.Settings && window.Settings.EnableBeta) {
                    url += "&IsBeta=True";
                }
                if (Me.Variables) {
                    for (let i = 0, len = Me.Variables.length; i < len; i++) {
                        if (Me.Variables[i].Verb === EC_Verb.Get) {
                            url += `&${encodeURIComponent(Me.Variables[i].Name)}=${encodeURIComponent(Me.Variables[i].Value)}`;
                        }
                        if (!hasQuickKey && Me.Variables[i].Name.toLocaleLowerCase() === "quickkey" && !EC_Fmt.isNull(Me.Variables[i].Value)) {
                            hasQuickKey = true;
                        }
                    }
                }
                let parameters = "";
                if (Me.Parameters) {
                    for (let i = 0, len = Me.Parameters.length; i < len; i++) {
                        if (parameters !== "") {
                            parameters += "|";
                        }
                        parameters += `F:${encodeURIComponent(Me.Parameters[i].Name)}~V:${encodeURIComponent(Me.Parameters[i].Value)}~O:${EC_Fmt.OperatorToURLOperator(Me.Parameters[i].Operator)}`;
                        if (Me.Parameters[i].Operator === EC_Operator.Range && Me.Parameters[i].Value.split("^").length !== 2) {
                            throw Error("Invalid use of Range operator, must contain 2 and only 2 values separated by a '^' character.");
                        }
                    }
                }
                if (parameters !== "") {
                    url += "&Parameters=" + parameters;
                }
                if (!EC_Fmt.isNull(Me.QueryString)) {
                    if (Me.QueryString.endsWith("&")) {
                        Me.QueryString = Me.QueryString.substring(0, Me.QueryString.length - 1);
                    }
                    url += "&" + Me.QueryString;
                }
                const quickKey = EC_Fmt.GetPageParameter("QuickKey");
                if (quickKey && !hasQuickKey) {
                    url += "&QuickKey=" + quickKey;
                }
                const enableLogging = EC_Fmt.GetPageParameter("EnableLogging");
                if ((enableLogging == "True" || enableLogging == "true") && url.toLowerCase().indexOf("enablelogging") == -1) {
                    url += "&EnableLogging=True";
                }
                Me.xhr = new XMLHttpRequest();
                Me.xhr.timeout = TimeoutInSeconds * 1000;
                if (Me.Verb === EC_Verb.Post) {
                    Me.xhr.open("POST", url);
                }
                else {
                    Me.xhr.open("GET", url);
                }
                if (this.Headers.length > 0) {
                    for (let i = 0; i < this.Headers.length; i++) {
                        const header = this.Headers[i];
                        Me.xhr.setRequestHeader(header.Header, header.Value);
                    }
                }
                if (Me.ReturnType === EC_ReturnType.Blob) {
                    Me.xhr.responseType = "blob";
                }
                const myRequest = Me;
                Me.xhr.onload = () => {
                    if (this.APIHost != "https://ew.encompass8.com" && Me.Command != "VerifySession" && Me.Command != "HeaderOverflowMenu") {
                        const serverTime = Me.xhr.getResponseHeader("X-Server-Time");
                        if (serverTime && window.PageLoadTime) {
                            window.PageLoadTime = (parseFloat(window.PageLoadTime) + parseFloat(serverTime)).toFixed(2);
                        }
                    }
                    if (Me.xhr.status >= 200 && Me.xhr.status < 300) {
                        switch (myRequest.ReturnType) {
                            case EC_ReturnType.Json:
                                try {
                                    resolve(JSON.parse(Me.xhr.responseText));
                                }
                                catch (error) {
                                    reject("Invalid JSON: " + Me.xhr.responseText);
                                }
                                break;
                            case EC_ReturnType.Blob:
                                try {
                                    resolve(Me.xhr.response);
                                }
                                catch (error) {
                                    reject("Invalid Blob.");
                                }
                                break;
                            default:
                                resolve(Me.xhr.responseText);
                                break;
                        }
                    }
                    else {
                        reject(Me.xhr.status);
                    }
                };
                Me.xhr.onerror = () => {
                    if (!window.navigator.onLine) {
                        reject("Internet Connection Lost");
                    }
                    else {
                        reject("EC_Request: Failed to request");
                    }
                };
                Me.xhr.ontimeout = () => {
                    if (window.PageLoadTime) {
                        window.PageLoadTime = (parseFloat(window.PageLoadTime) + TimeoutInSeconds).toFixed(2);
                    }
                    reject("EC_Request: Request timed out");
                };
                if (Me.Verb === EC_Verb.Post && Me.Body === undefined) {
                    for (let i = 0, len = Me.Variables.length; i < len; i++) {
                        if (Me.Variables[i].Verb === EC_Verb.Post) {
                            if (this.ContentType === "multipart/form-data") {
                                if (Me.Body === undefined) {
                                    Me.Body = new FormData();
                                }
                                Me.Body.append(Me.Variables[i].Name, Me.Variables[i].Value);
                            }
                            else {
                                if (Me.Body === undefined) {
                                    Me.Body = "";
                                }
                                if (Me.Body !== "") {
                                    Me.Body += "&";
                                }
                                Me.Body += `${encodeURIComponent(Me.Variables[i].Name)}=${encodeURIComponent(Me.Variables[i].Value)}`;
                            }
                        }
                    }
                }
                if (Me.Verb === EC_Verb.Post && Me.Body !== undefined) {
                    if (this.ContentType !== "multipart/form-data") {
                        Me.xhr.setRequestHeader("Content-Type", Me.ContentType);
                    }
                    Me.xhr.send(Me.Body);
                }
                else {
                    Me.xhr.send();
                }
            });
        }
        Abort() {
            if (this.xhr) {
                this.xhr.abort();
            }
        }
        Submit(TimeoutInSeconds) {
            const Me = this;
            return new Promise((resolve, reject) => {
                if (!Me.Public && !IsImpersonateUser) {
                    EWS.VerifySession(() => {
                        Me.SubmitAPIRequest(TimeoutInSeconds).then((data) => {
                            resolve(data);
                        }, (err) => {
                            reject(err);
                        });
                    });
                }
                else {
                    Me.SubmitAPIRequest(TimeoutInSeconds).then((data) => {
                        resolve(data);
                    }, (err) => {
                        reject(err);
                    });
                }
            });
        }
    }
    ECP.EC_Request = EC_Request;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    class EC_TableEdit {
        get Action() {
            return this._Action;
        }
        get TableName() {
            return this._TableName;
        }
        get KeyValue() {
            return this._KeyValue;
        }
        get FieldDict() {
            return this._FieldDict;
        }
        get FieldKeys() {
            return Object.keys(this._FieldDict);
        }
        constructor(tableName) {
            this._Action = "";
            this._TableName = tableName;
            this._KeyValue = "";
            this._FieldDict = {};
            this.EditMemo = "";
            this.Convert2ServerTime = true;
        }
        AddRecord() {
            this._Action = "TableEdit_Add_Record";
            this._FieldDict = {};
        }
        EditRecord(keyValue) {
            this._Action = "TableEdit_Edit_Record";
            this._KeyValue = keyValue;
            this._FieldDict = {};
        }
        DeleteRecord(keyValue) {
            this._Action = "TableEdit_Delete_Record";
            this._KeyValue = keyValue;
            this._FieldDict = {};
        }
        UpdateRecord(fieldName, newValue) {
            this._FieldDict[fieldName] = newValue;
        }
        SaveRecord() {
            if (this._Action === "") {
                throw Error("Invalid Action: Must call 'AddRecord()' or 'EditRecord()' before using SaveRecord() on the TableEdit object");
            }
            if (this.FieldKeys.length === 0 && this._Action !== "TableEdit_Delete_Record") {
                throw Error("Invalid Table Edit: Must call 'UpdateRecord()' on at least one field before calling SaveRecord()");
            }
            if (EC_Fmt.isNull(this._TableName)) {
                throw Error("Invalid Table Edit: Table Name must be set to a valid string.");
            }
            if (this._Action !== "TableEdit_Add_Record" && EC_Fmt.isNull(this._KeyValue)) {
                throw Error("Invalid Table Edit: Key Value must be set to a valid string.");
            }
            let jsonB = `{"EditMemo":"${EC_Fmt.JSONEncode(this.EditMemo)}",`
                + `"TableName":"${EC_Fmt.JSONEncode(this._TableName)}",`;
            if (this._Action !== "TableEdit_Add_Record") {
                jsonB += `"KeyValue":"${EC_Fmt.JSONEncode(this._KeyValue)}",`;
            }
            jsonB += `"FieldDict":{`;
            let first = true;
            for (const key in this._FieldDict) {
                if (first) {
                    first = false;
                }
                else {
                    jsonB += ",";
                }
                jsonB += `"${EC_Fmt.JSONEncode(key)}":"${EC_Fmt.JSONEncode(this._FieldDict[key])}"`;
            }
            jsonB += "},";
            jsonB += `"Convert2ServerTime":${this.Convert2ServerTime}}`;
            const myRequest = new ECP.EC_Request(this._Action);
            myRequest.SetReturnType(ECP.EC_ReturnType.Json);
            myRequest.Verb = ECP.EC_Verb.Post;
            myRequest.ContentType = "multipart/form-data";
            const formData = new FormData();
            formData.append("TableEditParameter", jsonB);
            myRequest.Body = formData;
            gtag("event", "tableEdit_saveSingleRecordChange", { table: this._TableName, keyValue: this._KeyValue });
            return myRequest.Submit();
        }
        static async SaveFromRecordSet(RecordSet, callback) {
            if (!RecordSet.TableName) {
                throw Error("Invalid RecordSet object sent to SaveFromRecordSet(), table objects must have table names");
            }
            else {
                gtag("event", "tableEdit_saveFromRecordSet", { table: RecordSet.TableName });
                RecordSet.MoveFirst();
                while (!RecordSet.EOF) {
                    const subTables = RecordSet.Records[RecordSet.Index].SubTables;
                    if (EC_Fmt.MultipleSelected(subTables)) {
                        for (let i = 0, len = subTables.length; i < len; i++) {
                            const SubTableRs = new ECP.EC_Recordset(subTables[i]);
                            while (!SubTableRs.EOF) {
                                if (SubTableRs.GetStatus() === ECP.RecordStatus.Delete) {
                                    await EC_TableEdit.SaveFromRecord(SubTableRs);
                                }
                                else {
                                    SubTableRs.MoveNext();
                                }
                            }
                        }
                    }
                    const isDelete = RecordSet.GetStatus() === ECP.RecordStatus.Delete;
                    await EC_TableEdit.SaveFromRecord(RecordSet);
                    if (!isDelete) {
                        if (EC_Fmt.MultipleSelected(subTables)) {
                            for (let i = 0, len = subTables.length; i < len; i++) {
                                const SubTableRs = new ECP.EC_Recordset(subTables[i]);
                                while (!SubTableRs.EOF) {
                                    if (SubTableRs.GetStatus() == ECP.RecordStatus.New && SubTableRs.ColumnExists(RecordSet.TableKey)) {
                                        SubTableRs.SetItem(RecordSet.TableKey, RecordSet.ItemDBValue(RecordSet.TableKey));
                                        SubTableRs.SetItem("enc-keyValue", RecordSet.ItemDBValue(RecordSet.TableKey));
                                    }
                                    if (SubTableRs.GetStatus() !== ECP.RecordStatus.Delete) {
                                        await EC_TableEdit.SaveFromRecord(SubTableRs);
                                    }
                                    SubTableRs.MoveNext();
                                }
                            }
                        }
                        RecordSet.MoveNext();
                    }
                }
                callback();
            }
        }
        static async SaveFromRecord(RecordSet) {
            if (RecordSet.GetStatus() !== ECP.RecordStatus.Existing) {
                const myTableEdit = new EC_TableEdit(RecordSet.TableName);
                myTableEdit.Convert2ServerTime = false;
                if (RecordSet.GetStatus() === ECP.RecordStatus.Delete) {
                    if (RecordSet.KeyValue() !== undefined) {
                        myTableEdit.DeleteRecord(RecordSet.KeyValue());
                    }
                    else {
                        throw Error("Cannot call EC_Recordset.DeleteRecord() if the table key is not in the recordset");
                    }
                }
                else {
                    if (RecordSet.GetStatus() === ECP.RecordStatus.New) {
                        myTableEdit.AddRecord();
                    }
                    else {
                        myTableEdit.EditRecord(RecordSet.KeyValue());
                    }
                    for (let i = 0, len = RecordSet.Fields.length; i < len; i++) {
                        const Field = RecordSet.Fields[i];
                        if (RecordSet.ItemDBValue(Field.Name) !== undefined
                            && (Field.CanEdit || (Field.Required && Field.Default === "" && RecordSet.GetStatus() === ECP.RecordStatus.New))
                            && Field.Name !== RecordSet.TableKey) {
                            myTableEdit.UpdateRecord(Field.Name, RecordSet.ItemDBValue(Field.Name));
                        }
                    }
                }
                try {
                    await EC_TableEdit.sleep(200);
                    let result = await myTableEdit.SaveRecord();
                    if (typeof result === "string") {
                        result = JSON.parse(result);
                    }
                    if (result.Status === "Success") {
                        if (RecordSet.GetStatus() === ECP.RecordStatus.Delete) {
                            RecordSet.Records.splice(RecordSet.Index, 1);
                            RecordSet.updateEOFAndBOF();
                        }
                        else {
                            if (RecordSet.GetStatus() == ECP.RecordStatus.New) {
                                RecordSet.Records[RecordSet.Index][RecordSet.TableKey] = result.Key;
                                RecordSet.Records[RecordSet.Index]["enc-keyValue"] = result.Key;
                            }
                            RecordSet.Records[RecordSet.Index].__Status = ECP.RecordStatus.Existing;
                        }
                    }
                    else {
                        ECP.Dialog.Alert(`Error Saving Record ID ${result.Key}: ${result.Message}`);
                    }
                }
                catch (error) {
                    ECP.Dialog.Alert(`Error Saving RecordSet: ${error}`);
                    console.error(error);
                }
            }
        }
        static sleep(milliseconds) {
            return new Promise((r) => setTimeout(r, milliseconds));
        }
    }
    ECP.EC_TableEdit = EC_TableEdit;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let Dialog;
    (function (Dialog) {
        const allLoadingMasks = {};
        let loadingID = 0;
        let dialogID = 0;
        let isDialogMoveEventAttached = false;
        let isGlobalKeyboardEventAttached = false;
        let currentDialog = null;
        let startX = 0;
        let priorUserSelect = "";
        let startY = 0;
        function ShowDialog(Title, Message, DialogOptions) {
            if (!DialogOptions) {
                DialogOptions = {};
            }
            if (!document.getElementById("dialogStyle")) {
                const DialogStyle = document.createElement("style");
                DialogStyle.id = "dialogStyle";
                DialogStyle.textContent = ".ecp-dialog{position:fixed;top:0;left:0;z-index:300;width:100%;height:100%;background:var(--neutral-t48);font-size:var(--body-font-size);line-height: var(--body-line-height);}"
                    + ".ecp-dialog-container{position:absolute;z-index:300;border-radius:8px;display:flex;flex-direction:column;background:linear-gradient(0deg, var(--bg-object) 0%, var(--bg-object) 100%), var(--bg);padding: 4px;box-shadow:2px 2px 10px 2px var(--neutral-t24);animation:ecp-keyframe-appearfromtop var(--ecp-duration-moderate); transition-property: opacity}"
                    + ".ecp-dialog-title{padding:8px 40px 12px 16px;min-height:40px;box-sizing:border-box;font-size:var(--body-font-size);font-weight: var(--semibold-weight);line-height: var(--body-line-height);color:var(--text);cursor:default;border-radius:8px 8px 0 0;}"
                    + ".ecp-dialog-title-text{line-height: var(--body-line-height)}"
                    + ".ecp-dialog-title-flex{display:flex;align-items:baseline;gap:8px}"
                    + ".ecp-dialog-title-icon{width:16px;height:16px;color:var(--text-secondary)}"
                    + ".ecp-dialog-subtitle{color:var(--text-secondary);font-size:var(--bodysm-font-size);line-height:var(--bodysm-line-height);font-weight:var(--regular-weight)}"
                    + ".ecp-dialog-subtitle.ecp-dialog-action,.ecp-dialog-title-icon.ecp-dialog-action{color:var(--text-secondary-onbg-action)}"
                    + ".ecp-dialog-dot-cutoff{display:flex;align-items:center;gap:8px}"
                    + ".ecp-dialog-dot{width:2px;height:2px;background:var(--text-secondary);border-radius:50%}"
                    + ".ecp-dialog-action .ecp-dialog-dot{background:var(--text-secondary-onbg-action)}"
                    + ".ecp-dialog-container .ecp-dialog-close{position:absolute;top:6px;right:16px;cursor:pointer;color:var(--text)}"
                    + ".ecp-dialog-content{flex: 1;font-size:13px;overflow: auto;background:var(--bg);padding:16px;box-sizing:border-box;border-radius: 4px 4px 0 0;}"
                    + ".ecp-dialog-footer{display:flex;justify-content:flex-end;align-items:center;box-sizing:border-box;padding:0 16px 16px;border-radius:0 0 8px 8px; background:var(--bg);}"
                    + ".ecp-dialog-confirm-button:not(ecp-btn){color:var(--text-onbg-action);background:var(--bg-action);border:solid 1px var(--bg-action)}"
                    + ".ecp-dialog-confirm-button:not(ecp-btn):hover{background:var(--bg-action-hover)}"
                    + ".ecp-dialog-cancel-button:not(ecp-btn), .ecp-dialog-confirm-button:not(ecp-btn){margin-left:8px;padding:0 12px;height:32px;line-height:27px;font-size:13px;border-radius:4px;cursor:pointer;box-sizing:border-box}"
                    + ".ecp-dialog-cancel-button:not(ecp-btn){color:var(--text);background:var(--bg);border:solid 1px var(--border)}"
                    + ".ecp-dialog-cancel-button:not(ecp-btn):hover{background:var(--layer-special)}"
                    + ".ecp-dialog-container-action{background:var(--bg-action);}"
                    + ".ecp-dialog-footer-message{background:var(--bg);padding:16px 32px;color:var(--text-secondary);font-size:12px;font-weight:400}"
                    + ".ecp-dialog-container .ecp-dialog-light-close span{color:var(--text-onbg-action)}"
                    + ".ecp-dialog-container .ecp-dialog-light-close .button:hover{background:var(--bg-action-hover)}"
                    + ".ecp-dialog::-webkit-scrollbar{width:0;height:0}"
                    + ".overflow-behavior{overflow-y:auto;overflow-x:hidden}"
                    + ".ecp-dialog-container-bottom:after{display:block;height:80px;width:100%;position:absolute;bottom:-80px;content:''}"
                    + ".full-screen-title{position:fixed;top:0;width:100%;border-radius:0;z-index:20;overflow: hidden;text-overflow: ellipsis; background:linear-gradient(0deg, var(--bg-object) 0%, var(--bg-object) 100%), var(--bg);}"
                    + ".full-screen-footer{position:fixed;left:0;bottom:0;z-index:12;flex-flow:wrap;padding-top:24px;width:100%;background:var(--bg);box-shadow:0 -4px 4px rgba(0, 0, 0, 0.1);border-radius:0}"
                    + ".ecp-dialog-container .full-close{position:fixed;z-index:21}"
                    + ".ecp-dialog-container .ecp-dialog-close span{font-weight:bold;font-size:14px}"
                    + ".ecp-dialog-footer-bottom:after{display:block;height:80px;width:100%;content:''}"
                    + ".ecp-full-screen-container{top:0;left:0;width:100%;height:100%;box-shadow:none;box-sizing:border-box;border-radius:0;background: var(--bg);padding: 0;}"
                    + ".ecp-full-screen-container .ecp-dialog-content{position:relative; z-index: 11;overflow:visible;margin-top:42px}"
                    + ".ecp-full-screen-container .ui-resizable-handle{position:static}"
                    + ".ecp-dialog-bar-title{padding-left:16px;padding-right:40px;min-height:46px;background:var(--bg-action);color:var(--text-onbg-action);display:flex;align-items:center}"
                    + ".ecp-full-screen{background:var(--bg)}"
                    + ".ecp-dialog-footer .hover-button.ecp-dialog-cancel-button {background-color:var(--layer-special);border-radius:4px}"
                    + ".ecp-dialog-footer .hover-button.ecp-dialog-confirm-button {opacity: 0.7}";
                document.head.appendChild(DialogStyle);
            }
            dialogID++;
            DialogOptions.confirmButtonTitle = EC_Fmt.NullChkStr(DialogOptions.confirmButtonTitle, "Confirm");
            let currentModalStyle = "";
            let currentContentStyle = "";
            const maxWidth = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
            const maxHeight = window.innerHeight > 0 ? window.innerHeight : window.screen.height;
            const isSmallScreen = window.innerWidth <= 600 ? true : false;
            if (!(isSmallScreen && DialogOptions.isFullScreen)) {
                currentModalStyle += `width:${DialogOptions.width && DialogOptions.width !== -1 ? DialogOptions.width + "px" : "fit-content"};`;
                currentModalStyle += `height:${DialogOptions.height ? DialogOptions.height + "px" : "auto"};`;
                currentModalStyle += `min-height:200px;max-width:${maxWidth - 10}px;`;
                if (isSmallScreen) {
                    currentModalStyle += `min-width: ${maxWidth > 400 ? 400 : maxWidth - 10}px;`;
                }
                else {
                    currentModalStyle += `min-width:${DialogOptions.width && DialogOptions.width < maxWidth && DialogOptions.width !== -1 ? DialogOptions.width + "px" : "450px"};`;
                }
                if (DialogOptions.height > maxHeight - 50 || DialogOptions.disableModal) {
                    if (isSmallScreen) {
                        currentContentStyle += `max-height:${maxHeight - 30 - 47 - 5}px;`;
                        currentModalStyle += `max-height:${maxHeight - 10}px;`;
                    }
                    else {
                        currentModalStyle += `max-height:${maxHeight - 50}px;`;
                        currentContentStyle += `max-height:${maxHeight - 30 - 47 - 5 - 20}px;`;
                    }
                }
            }
            let htmlB = `<div id="ecp-dialog-container-${dialogID}"style="${currentModalStyle}"class="ecp-dialog-container`;
            let fullTitle = "draggable-handle";
            let fullClose = "";
            if (isSmallScreen && DialogOptions.isFullScreen) {
                fullTitle = "full-screen-title";
                fullClose = "full-close";
            }
            if (DialogOptions.barPosition == "top") {
                fullTitle += ` ecp-dialog-bar-title`;
                htmlB += ` ecp-dialog-container-action`;
            }
            htmlB += `"><div class="ecp-dialog-title ${fullTitle}">`;
            let bg = "";
            if (DialogOptions.barPosition == "top") {
                bg = "ecp-dialog-action";
            }
            let iconHtml = "";
            if (DialogOptions.icon) {
                iconHtml = `<span class="ecp-dialog-title-icon ${DialogOptions.icon} ${bg}"></span>`;
            }
            let subtitleHtml = "";
            if (DialogOptions.subTitle) {
                const subtitleParts = DialogOptions.subTitle.split(";");
                if (subtitleParts.length > 1) {
                    subtitleHtml = `<div class="ecp-dialog-subtitle ${bg}"><div class=ecp-dialog-dot-cutoff><div>${subtitleParts[0]}</div><div class=ecp-dialog-dot></div><div>${subtitleParts[1]}</div></div></div>`;
                }
                else {
                    subtitleHtml = `<div class="ecp-dialog-subtitle ${bg}">${DialogOptions.subTitle}</div>`;
                }
            }
            if (iconHtml || subtitleHtml) {
                htmlB += `<div class=ecp-dialog-title-flex>${iconHtml}<div><div class=ecp-dialog-title-text>${Title}</div>${subtitleHtml}</div></div></div>`;
            }
            else {
                htmlB += `${Title}</div>`;
            }
            if (typeof Message === "string") {
                const template = document.createElement("div");
                template.innerHTML = Message;
                Message = template.innerHTML;
            }
            htmlB += `<div style="${currentContentStyle}"class=ecp-dialog-content>${(typeof Message == "string") ? Message : ""}</div>`;
            if (DialogOptions.barPosition == "center") {
                htmlB += `<div class=ecp-dialog-bar-title>${DialogOptions.barTitle}</div>`;
                htmlB += `<div class=ecp-dialog-footer-message>${(typeof DialogOptions.footerMessage == "string") ? DialogOptions.footerMessage : ""}</div>`;
                if (isSmallScreen && DialogOptions.isFullScreen) {
                    htmlB += `<div class="ecp-dialog-footer full-screen-footer">`;
                }
                else {
                    htmlB += `<div class=ecp-dialog-footer style=background:var(--bg)>`;
                }
            }
            else {
                if (isSmallScreen && DialogOptions.isFullScreen) {
                    htmlB += `<div class="ecp-dialog-footer full-screen-footer">`;
                }
                else {
                    htmlB += `<div class=ecp-dialog-footer>`;
                }
            }
            if (DialogOptions.footer) {
                htmlB += DialogOptions.footer;
            }
            else if (!DialogOptions.disableButtons) {
                if (!EC_Fmt.isNull(DialogOptions.cancelButtonTitle)) {
                    if (DialogOptions.cancelButtonTitle === "Close" || DialogOptions.cancelButtonTitle === "Cancel") {
                        htmlB += `<ecp-btn type=ghost class=ecp-dialog-cancel-button id=ecp-dialog-cancelButton-${dialogID}> ${DialogOptions.cancelButtonTitle} </ecp-btn>`;
                    }
                    else {
                        htmlB += `<ecp-btn class=ecp-dialog-cancel-button id=ecp-dialog-cancelButton-${dialogID}> ${DialogOptions.cancelButtonTitle} </ecp-btn>`;
                    }
                }
                if (!EC_Fmt.isNull(DialogOptions.confirmButtonType)) {
                    if (DialogOptions.confirmButtonType.toLowerCase() === "permanent" ||
                        DialogOptions.confirmButtonType.toLowerCase() === "permanent-destructive") {
                        htmlB += `<ecp-btn type="${DialogOptions.confirmButtonType}"class=ecp-dialog-confirm-button id=ecp-dialog-confirmButton-${dialogID} tabIndex=0> ${DialogOptions.confirmButtonTitle} </ecp-btn>`;
                    }
                }
                else {
                    htmlB += `<ecp-btn type=primary class=ecp-dialog-confirm-button id=ecp-dialog-confirmButton-${dialogID} tabIndex=0> ${DialogOptions.confirmButtonTitle} </ecp-btn>`;
                }
            }
            htmlB += "</div>";
            htmlB += `<div id=ecp-dialog-close-${dialogID} class="ecp-dialog-close ${fullClose}">`;
            if (DialogOptions.barPosition == "top") {
                htmlB += '<ecp-btn type=ghost inverted icon=ews-icon-close></ecp-btn>';
            }
            else {
                htmlB += '<ecp-btn type=ghost icon=ews-icon-close></ecp-btn>';
            }
            htmlB += "</div>"
                + "</div>";
            const modalContainer = document.createElement("div");
            modalContainer.id = `ecp-dialog-${dialogID}`;
            modalContainer.style.opacity = "0";
            modalContainer.innerHTML = htmlB;
            if (!DialogOptions.disableModal) {
                modalContainer.style.opacity = "0";
                modalContainer.setAttribute("class", "ecp-dialog overflow-behavior motion-slow");
                requestAnimationFrame(() => {
                    modalContainer.style.opacity = "1";
                });
            }
            else {
                modalContainer.style.position = "absolute";
                modalContainer.style.top = "0";
                modalContainer.style.left = "0";
            }
            if (Message && typeof Message != "string") {
                modalContainer.querySelector(".ecp-dialog-content").appendChild(Message);
            }
            if (DialogOptions.barPosition == "center" && DialogOptions.footerMessage && typeof DialogOptions.footerMessage != "string") {
                modalContainer.querySelector(".ecp-dialog-footer-message").appendChild(DialogOptions.footerMessage);
            }
            document.querySelector("body").appendChild(modalContainer);
            const dialogModal = modalContainer.querySelector(".ecp-dialog-container");
            const positionDialog = () => {
                const currentHeight = window.innerHeight > 0 ? window.innerHeight : window.screen.height;
                const currentWidth = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
                if (currentWidth <= 600 && (DialogOptions.isFullScreen || dialogModal.clientHeight > currentHeight - 50)) {
                    applyModalFullScreenPosition(modalContainer, dialogModal, DialogOptions.barPosition, currentHeight);
                }
                else if (modalContainer.style.display !== "none") {
                    applyModalStandardPosition(modalContainer, dialogModal, DialogOptions.height, currentHeight, currentWidth, DialogOptions.disableModal);
                }
            };
            modalContainer.ECPPositionDialog = positionDialog;
            modalContainer.dataset.ecpDialog = "true";
            setTimeout(() => {
                positionDialog();
                modalContainer.style.opacity = "1";
            }, 50);
            const draggableHandle = modalContainer.querySelector(`.draggable-handle`);
            if (draggableHandle) {
                const moveStart = (event) => {
                    event.preventDefault();
                    currentDialog = modalContainer;
                    startX = event.touches ? event.touches[0].clientX : event.clientX;
                    startY = event.touches ? event.touches[0].clientY : event.clientY;
                    priorUserSelect = document.body.style.userSelect || document.body.style.webkitUserSelect || "";
                    document.body.style.userSelect = "none";
                    document.body.style.webkitUserSelect = "none";
                };
                draggableHandle.addEventListener("mousedown", moveStart);
                draggableHandle.addEventListener("touchstart", moveStart);
                if (!isDialogMoveEventAttached) {
                    const MoveDone = () => {
                        if (currentDialog) {
                            currentDialog = null;
                            startX = 0;
                            startY = 0;
                            document.body.style.userSelect = priorUserSelect;
                            document.body.style.webkitUserSelect = priorUserSelect;
                        }
                    };
                    const MoveDialog = (event) => {
                        if (currentDialog) {
                            const content = currentDialog.querySelector(".ecp-dialog-container");
                            let top = (content.style.top ? parseInt(content.style.top.replace("px", ""), 10) : 0) + (event.touches ? event.touches[0].clientY : event.clientY) - startY;
                            let left = (content.style.left ? parseInt(content.style.left.replace("px", ""), 10) : 0) + (event.touches ? event.touches[0].clientX : event.clientX) - startX;
                            const topMaxLimit = window.innerHeight - content.clientHeight - 4;
                            const leftMaxLimit = window.innerWidth - content.clientWidth - 4;
                            if (top < 0) {
                                top = 0;
                            }
                            if (topMaxLimit > 0 && top > topMaxLimit) {
                                top = topMaxLimit;
                            }
                            if (left < 0) {
                                left = 0;
                            }
                            if (left > leftMaxLimit) {
                                left = leftMaxLimit;
                            }
                            content.style.top = top + "px";
                            content.style.left = left + "px";
                            content.dataset.userPositioned = "true";
                            startY = event.touches ? event.touches[0].clientY : event.clientY;
                            startX = event.touches ? event.touches[0].clientX : event.clientX;
                        }
                    };
                    document.addEventListener("mousemove", MoveDialog);
                    document.addEventListener("mouseup", MoveDone);
                    document.addEventListener("touchmove", MoveDialog);
                    document.addEventListener("touchend", MoveDone);
                    isDialogMoveEventAttached = true;
                }
            }
            const close = document.getElementById(`ecp-dialog-close-${dialogID}`);
            if (close) {
                close.addEventListener("click", () => {
                    if (!EC_Fmt.isNull(DialogOptions.cancelButtonAction)) {
                        DialogOptions.cancelButtonAction(modalContainer);
                    }
                    modalContainer.style.animation = "ecp-keyframe-disappeartotop var(--ecp-duration-moderate)";
                    const handleAnimationEnd = () => {
                        modalContainer.remove();
                        modalContainer.removeEventListener("animationend", handleAnimationEnd);
                    };
                    modalContainer.addEventListener("animationend", handleAnimationEnd);
                });
            }
            if (!DialogOptions.disableButtons || !DialogOptions.footer) {
                const confirmButton = document.getElementById(`ecp-dialog-confirmButton-${dialogID}`);
                if (!EC_Fmt.isNull(DialogOptions.cancelButtonTitle)) {
                    const cancelButton = document.getElementById(`ecp-dialog-cancelButton-${dialogID}`);
                    if (cancelButton) {
                        cancelButton.addEventListener("click", () => {
                            if (!EC_Fmt.isNull(DialogOptions.cancelButtonAction)) {
                                DialogOptions.cancelButtonAction(modalContainer);
                            }
                            modalContainer.style.animation = "ecp-keyframe-disappeartotop var(--ecp-duration-moderate)";
                            const handleAnimationEnd = () => {
                                modalContainer.remove();
                                modalContainer.removeEventListener("animationend", handleAnimationEnd);
                            };
                            modalContainer.addEventListener("animationend", handleAnimationEnd);
                        });
                        if (DialogOptions.keyboard) {
                            const PreviousFocus = document.activeElement;
                            cancelButton.setAttribute("tabindex", "0");
                            cancelButton.addEventListener("keydown", (event) => {
                                const targetEl = event.target;
                                if (targetEl.classList.contains("ecp-dialog-cancel-button")) {
                                    if (event.key === "Enter") {
                                        EC_Fmt.TriggerEvent(cancelButton, "click");
                                        if (PreviousFocus && PreviousFocus.focus) {
                                            PreviousFocus.focus();
                                        }
                                    }
                                    else if (event.key === "ArrowRight") {
                                        if (confirmButton) {
                                            cancelButton.classList.remove("hover-button");
                                            confirmButton.classList.add("hover-button");
                                            confirmButton.focus();
                                        }
                                    }
                                }
                            });
                        }
                    }
                }
                if (confirmButton) {
                    confirmButton.addEventListener("click", () => {
                        modalContainer.style.display = "none";
                        if (!EC_Fmt.isNull(DialogOptions.confirmButtonAction)) {
                            DialogOptions.confirmButtonAction(modalContainer);
                        }
                        else {
                            modalContainer.remove();
                        }
                    });
                    if (EC_Fmt.isNull(DialogOptions.confirmButtonAction) || DialogOptions.keyboard) {
                        const PreviousFocus = document.activeElement;
                        confirmButton.focus();
                        confirmButton.classList.add("hover-button");
                        confirmButton.addEventListener("keydown", (event) => {
                            const targetEl = event.target;
                            if (targetEl.classList.contains("ecp-dialog-confirm-button")) {
                                if (event.key === "Enter") {
                                    EC_Fmt.TriggerEvent(confirmButton, "click");
                                    if (PreviousFocus && PreviousFocus.focus) {
                                        PreviousFocus.focus();
                                    }
                                }
                                else if (DialogOptions.keyboard && event.key === "ArrowLeft") {
                                    const cancelButton = document.getElementById(`ecp-dialog-cancelButton-${dialogID}`);
                                    if (cancelButton) {
                                        confirmButton.classList.remove("hover-button");
                                        cancelButton.classList.add("hover-button");
                                        cancelButton.focus();
                                    }
                                }
                            }
                        });
                    }
                }
                if (!EC_Fmt.isNull(DialogOptions.keyboardFocusElementClass)) {
                    if (typeof DialogOptions.keyboardFocusElementClass == "string") {
                        const btn = document.querySelector(`.${DialogOptions.keyboardFocusElementClass}`);
                        if (btn) {
                            btn.focus();
                            btn.classList.add("hover-button");
                            if (DialogOptions.keyboardFocusElementClass == `ecp-dialog-close`) {
                                btn.addEventListener("keydown", (event) => {
                                    if (event.key === "Enter") {
                                        EC_Fmt.TriggerEvent(btn, "click");
                                    }
                                });
                            }
                        }
                    }
                }
            }
            if (DialogOptions.disableButtons) {
                const footer = modalContainer.querySelector(".ecp-dialog-footer");
                if (footer) {
                    footer.style.display = "none";
                }
            }
            if (!DialogOptions.disableResize) {
                Resizable(dialogModal);
            }
            dialogModal.addEventListener("animationend", (e) => {
                e.currentTarget.style.animation = "none";
            });
            if (!isGlobalKeyboardEventAttached) {
                document.addEventListener("keydown", handleGlobalDialogKeyboard);
                isGlobalKeyboardEventAttached = true;
            }
            gtag("event", "dialogShown", { Title: EC_Fmt.Left(Title, 100), Message: EC_Fmt.Left((typeof Message === "string" ? Message : Message.innerText), 5000) });
            return modalContainer;
        }
        Dialog.ShowDialog = ShowDialog;
        function CenterDialog(modalContainer) {
            if (!modalContainer) {
                modalContainer = currentDialog;
            }
            if (!modalContainer) {
                return;
            }
            const positionDialog = modalContainer.ECPPositionDialog;
            if (typeof positionDialog === "function") {
                positionDialog();
                return;
            }
            const maxHeight = window.innerHeight > 0 ? window.innerHeight : window.screen.height;
            const maxWidth = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
            const dialogModal = modalContainer.querySelector(".ecp-dialog-container");
            if (dialogModal.clientHeight < maxHeight - 50 || dialogModal.clientWidth < maxWidth - 50) {
                applyModalStandardPosition(modalContainer, dialogModal, undefined, maxHeight, maxWidth, false);
            }
        }
        Dialog.CenterDialog = CenterDialog;
        function applyModalFullScreenPosition(modalContainer, dialogModal, barPosition, maxHeight) {
            dialogModal.classList.remove("ecp-dialog-container-bottom");
            dialogModal.style.top = "";
            dialogModal.style.left = "";
            dialogModal.style.right = "";
            modalContainer.classList.add("ecp-full-screen");
            dialogModal.classList.add("ecp-full-screen-container");
            if (dialogModal.clientHeight > maxHeight - 50) {
                modalContainer.querySelector(".ecp-dialog-footer").classList.add("full-screen-footer");
                modalContainer.querySelector(".ecp-dialog-title").classList.add("full-screen-title");
                const closeSection = modalContainer.querySelector(".ecp-dialog-close");
                if (closeSection) {
                    closeSection.classList.add("full-close");
                }
            }
            if (barPosition == "center") {
                dialogModal.querySelector(".ecp-dialog-footer-message").classList.add("ecp-dialog-footer-bottom");
            }
            else {
                modalContainer.querySelector(".ecp-dialog-content").classList.add("ecp-dialog-footer-bottom");
            }
        }
        function clearModalFullScreenPosition(modalContainer, dialogModal) {
            if (!dialogModal.classList.contains("ecp-full-screen-container")) {
                return;
            }
            modalContainer.classList.remove("ecp-full-screen");
            dialogModal.classList.remove("ecp-full-screen-container");
            const fullScreenClasses = ["full-screen-title", "full-screen-footer", "full-close", "ecp-dialog-footer-bottom"];
            for (let i = 0; i < fullScreenClasses.length; i++) {
                const elements = modalContainer.querySelectorAll(`.${fullScreenClasses[i]}`);
                for (let j = 0; j < elements.length; j++) {
                    elements[j].classList.remove(fullScreenClasses[i]);
                }
            }
        }
        function applyModalStandardPosition(modalContainer, dialogModal, height, maxHeight, maxWidth, disableModal) {
            clearModalFullScreenPosition(modalContainer, dialogModal);
            dialogModal.classList.remove("ecp-dialog-container-bottom");
            if (!disableModal && (dialogModal.clientHeight > maxHeight - 120) && (!height || !(height > maxHeight - 50))) {
                dialogModal.style.top = "120px";
                dialogModal.classList.add("ecp-dialog-container-bottom");
            }
            else {
                dialogModal.style.top = maxHeight / 2 - dialogModal.clientHeight / 2 + "px";
            }
            const newCenter = maxWidth / 2 - dialogModal.clientWidth / 2 + "px";
            dialogModal.style.left = newCenter;
            dialogModal.style.right = newCenter;
        }
        function handleGlobalDialogKeyboard(event) {
            if (event.key !== 'Escape' && event.key !== 'Enter') {
                return;
            }
            const allDialogs = document.querySelectorAll('.ecp-dialog');
            if (allDialogs.length === 0)
                return;
            let topDialog = null;
            let highestZIndex = -1;
            for (let i = 0; i < allDialogs.length; i++) {
                const dialog = allDialogs[i];
                if (dialog.style.display !== 'none') {
                    const zIndex = parseInt(getComputedStyle(dialog).zIndex) || 0;
                    if (zIndex >= highestZIndex) {
                        highestZIndex = zIndex;
                        topDialog = dialog;
                    }
                }
            }
            if (!topDialog)
                return;
            if (event.key === 'Enter') {
                const activeElement = document.activeElement;
                const isInInputField = activeElement && (activeElement.tagName === 'INPUT' ||
                    activeElement.tagName === 'TEXTAREA' ||
                    activeElement.tagName === 'SELECT' ||
                    activeElement.contentEditable === 'true' ||
                    activeElement.contentEditable === 'plaintext-only' ||
                    activeElement.getAttribute('contenteditable') === 'true' ||
                    activeElement.closest('[contenteditable="true"]') !== null);
                if (!isInInputField) {
                    const confirmButton = topDialog.querySelector('.ecp-dialog-confirm-button');
                    const footer = topDialog.querySelector('.ecp-dialog-footer');
                    if (confirmButton &&
                        confirmButton.style.display !== 'none' &&
                        footer &&
                        footer.style.display !== 'none') {
                        EC_Fmt.TriggerEvent(confirmButton, "click");
                    }
                }
            }
            else if (event.key === 'Escape') {
                const hasOpenHideable = Array.from(document.getElementsByClassName('Hideable')).some((el) => EC_Fmt.isVisible(el));
                if (hasOpenHideable) {
                    return;
                }
                const cancelButton = topDialog.querySelector('.ecp-dialog-cancel-button');
                const closeButton = topDialog.querySelector('.ecp-dialog-close');
                if (cancelButton) {
                    EC_Fmt.TriggerEvent(cancelButton, "click");
                }
                else if (closeButton) {
                    EC_Fmt.TriggerEvent(closeButton, "click");
                }
                else {
                    topDialog.remove();
                }
            }
        }
        function CloseDialog(Context) {
            if (Context) {
                Context.remove();
                gtag("event", "CloseDialog", { itemId: Context.id });
            }
        }
        Dialog.CloseDialog = CloseDialog;
        let resizeContext;
        const isResizeEventAttached = false;
        let resizeDirection = "";
        let priorResizeUserSelect = "";
        let defaultHeight = 0;
        let defaultWidth = 0;
        let resizeX = 0;
        let resizeY = 0;
        function Resizable(Context) {
            if (getComputedStyle(Context).position == "static") {
                Context.style.position = "relative";
            }
            const div = document.createElement("div");
            div.innerHTML = `<div class="ui-resizable-handle ui-resizable-e"></div><div class="ui-resizable-handle ui-resizable-s"></div><div class="ui-resizable-handle ui-resizable-se ui-icon ui-icon-gripsmall-diagonal-se"></div>`;
            const childNodes = Array.from(div.childNodes);
            for (let i = 0; i < childNodes.length; i++) {
                Context.appendChild(childNodes[i]);
            }
            Context.addEventListener("mousedown", (event) => {
                const targetClassList = event.target.classList;
                if (targetClassList.contains("ui-resizable-e") || targetClassList.contains("ui-resizable-s") || targetClassList.contains("ui-resizable-se")) {
                    priorResizeUserSelect = document.body.style.userSelect || document.body.style.webkitUserSelect || "";
                    document.body.style.userSelect = "none";
                    document.body.style.webkitUserSelect = "none";
                    resizeContext = Context;
                    if (targetClassList.contains("ui-resizable-e")) {
                        resizeDirection = "e";
                    }
                    if (targetClassList.contains("ui-resizable-s")) {
                        resizeDirection = "s";
                    }
                    if (targetClassList.contains("ui-resizable-se")) {
                        resizeDirection = "se";
                    }
                    resizeX = event.pageX;
                    resizeY = event.pageY;
                    defaultHeight = resizeContext.offsetHeight;
                    defaultWidth = resizeContext.offsetWidth;
                }
            });
            if (!isResizeEventAttached) {
                const resizeMove = (mouseEvent) => {
                    if (mouseEvent.pageY > window.innerHeight || mouseEvent.pageX > window.innerWidth) {
                        return false;
                    }
                    if (resizeDirection == "s" || resizeDirection == "se") {
                        resizeContext.style.height = defaultHeight + (mouseEvent.pageY - resizeY) + "px";
                    }
                    if (resizeDirection == "e" || resizeDirection == "se") {
                        resizeContext.style.width = defaultWidth + (mouseEvent.pageX - resizeX) + "px";
                    }
                    if (resizeDirection) {
                        resizeContext.dataset.userPositioned = "true";
                    }
                    return true;
                };
                document.addEventListener("mousemove", resizeMove);
            }
            ;
            const resizeDone = () => {
                if (resizeContext) {
                    gtag("event", "itemResizedByUser", { itemId: Context.id });
                    resizeContext = null;
                    resizeDirection = "";
                    resizeX = 0;
                    resizeY = 0;
                    defaultHeight = 0;
                    defaultWidth = 0;
                    document.body.style.userSelect = priorResizeUserSelect;
                    document.body.style.webkitUserSelect = priorResizeUserSelect;
                }
            };
            document.addEventListener("mouseup", resizeDone);
        }
        Dialog.Resizable = Resizable;
        function Alert(Message, confirmButtonAction) {
            return ShowDialog("Message", `<div style=font-size:16px;margin:auto;min-height:117px;display:flex;flex-direction:column;align-items:center;justify-content:center;user-select:text>${Message}</div>`, {
                confirmButtonTitle: "OK",
                confirmButtonAction: confirmButtonAction,
                cancelButtonAction: confirmButtonAction
            });
        }
        Dialog.Alert = Alert;
        let _LoadingMask;
        function ShowLoading(LoadingText, CoverSelector, inDialog) {
            loadingID += 1;
            LoadingText = EC_Fmt.NullChk(LoadingText, "Loading...");
            let htmlB = `<div class=ecp-html-loading-mask style=display:none;position:absolute;width:100%;top:54px;bottom:0;left:0;z-index:100000;background:var(--bg);opacity:0.9;box-sizing:border-box>`
                + "<table class=NoPadding style=width:100%;height:100%>";
            htmlB += "<tbody><tr><td style=width:100%;height:100%;text-align:center;vertical-align:middle;font-size:24px;color:var(--text-secondary)>"
                + "<center>"
                + `<svg xmlns=http://www.w3.org/2000/svg viewBox="0 0 360 360"style=width:48px><defs>`
                + "<style>"
                + " .st0{fill:#00B2A9}"
                + " .st1{fill:var(--primary-110)}"
                + " .flip-right {transform-origin:50%;animation:flip-right 2.5s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both}"
                + " @keyframes flip-right {0% {transform:rotateZ(0)}100% {transform:rotateZ(360deg)}}"
                + "</style>"
                + "</defs>"
                + "<g>"
                + ` <rect x="95.5" y="85.7" class="st0" width="168.9" height="40.5"/>`
                + ` <polygon class="st1" points="264.4,200.3 264.4,159.8 136,159.8 95.5,159.8 95.5,200.3 95.5,233.8 95.5,274.3 136,274.3     264.4,274.3 264.4,233.8 136,233.8 136,200.3   "/>`
                + "</g>"
                + "<g class=flip-right>"
                + ` <path class="st1" d="M164.8,326.2C90.9,318.6,33,255.9,33,180S90.9,41.4,164.8,33.8V3.3C73.9,11,2.6,87.2,2.6,180    c0,92.9,71.4,169,162.2,176.7V326.2z"/>`
                + ` <path class="st0" d="M195.2,3.3v30.5C269.1,41.4,327,104.1,327,180s-57.9,138.6-131.8,146.2v30.5c90.9-7.7,162.2-83.9,162.2-176.7    C357.4,87.2,286,11,195.2,3.3z"/>`
                + "</g>"
                + "</svg>"
                + `<div>${LoadingText}</div>`
                + "</center>"
                + "</td></tr></tbody></table></div>";
            if (EC_Fmt.isNull(CoverSelector) && !EC_Fmt.isNull(_LoadingMask)) {
                HideLoading();
            }
            _LoadingMask = document.createElement("div");
            _LoadingMask.id = `ecp-loading-${loadingID}`;
            _LoadingMask.innerHTML = htmlB;
            let cover;
            if (!CoverSelector) {
                cover = document.getElementById("Content");
            }
            else if (CoverSelector instanceof HTMLElement) {
                cover = CoverSelector;
            }
            else {
                cover = document.querySelector(CoverSelector);
            }
            if (cover) {
                cover.style.animation = "none";
                const isContent = cover.id === "Content";
                if (isContent) {
                    cover.appendChild(_LoadingMask);
                }
                else {
                    cover.parentElement.appendChild(_LoadingMask);
                }
                if (getComputedStyle(cover.parentElement).position === "static") {
                    cover.parentElement.style.position = "relative";
                    cover.parentElement.setAttribute("position", "static");
                }
                const loading = _LoadingMask.firstChild;
                loading.style.position = "absolute";
                if (isContent) {
                    loading.style.top = "0px";
                    loading.style.left = "0px";
                    loading.style.right = "0px";
                    loading.style.bottom = "0px";
                    loading.style.display = "block";
                }
                else if (inDialog) {
                    loading.style.top = "0px";
                    loading.style.display = "block";
                }
                else {
                    setTimeout(() => {
                        const boundingRect = cover.getBoundingClientRect();
                        const parentBoundingRect = cover.parentElement.getBoundingClientRect();
                        loading.style.height = boundingRect.height + "px";
                        loading.style.width = boundingRect.width + "px";
                        loading.style.top = boundingRect.top - parentBoundingRect.top + "px";
                        loading.style.left = boundingRect.left - parentBoundingRect.left + "px";
                        loading.style.display = "block";
                    }, 100);
                }
                loading.style.zIndex = "999";
                allLoadingMasks[`ecp-loading-${loadingID}`] = {
                    loadingMask: _LoadingMask,
                    cover: cover
                };
                return _LoadingMask;
            }
            document.body.appendChild(_LoadingMask);
            return _LoadingMask;
        }
        Dialog.ShowLoading = ShowLoading;
        function HideLoading(cover) {
            let LoadingMask = _LoadingMask;
            if (cover && cover instanceof HTMLDivElement) {
                LoadingMask = cover;
            }
            if (LoadingMask && LoadingMask.parentElement) {
                if (LoadingMask.parentElement.getAttribute("position") === "static") {
                    LoadingMask.parentElement.style.position = "static";
                }
                delete allLoadingMasks[LoadingMask.id];
                LoadingMask.remove();
                LoadingMask = undefined;
            }
            else {
                let FoundLoadingMasks = document.querySelectorAll(".ecp-html-loading-mask");
                for (let i = 0; i < FoundLoadingMasks.length; i++) {
                    delete allLoadingMasks[FoundLoadingMasks[i].parentElement.id];
                    FoundLoadingMasks[i].parentElement.parentElement.removeChild(FoundLoadingMasks[i].parentElement);
                }
                FoundLoadingMasks = undefined;
            }
        }
        Dialog.HideLoading = HideLoading;
        function repositionOpenDialogs() {
            const openDialogs = document.querySelectorAll("[data-ecp-dialog]");
            for (let i = 0; i < openDialogs.length; i++) {
                const modalContainer = openDialogs[i];
                const dialogModal = modalContainer.querySelector(".ecp-dialog-container");
                if (modalContainer.style.display === "none" || dialogModal.dataset.userPositioned) {
                    continue;
                }
                modalContainer.ECPPositionDialog();
            }
        }
        const repositionLoadingMasks = () => {
            const loadingMaskKeyArr = Object.keys(allLoadingMasks);
            for (let i = 0; i < loadingMaskKeyArr.length; i++) {
                const loadingMaskId = loadingMaskKeyArr[i];
                const loadingMaskObj = allLoadingMasks[loadingMaskId];
                if (loadingMaskObj.loadingMask && loadingMaskObj.cover && loadingMaskObj.cover.parentElement) {
                    const boundingRect = loadingMaskObj.cover.getBoundingClientRect();
                    const parentBoundingRect = loadingMaskObj.cover.parentElement.getBoundingClientRect();
                    const loading = loadingMaskObj.loadingMask.firstElementChild;
                    loading.style.height = boundingRect.height + "px";
                    loading.style.width = boundingRect.width + "px";
                    loading.style.top = boundingRect.top - parentBoundingRect.top + "px";
                    loading.style.left = boundingRect.left - parentBoundingRect.left + "px";
                }
            }
        };
        const hasScreenOrientation = !!screen.orientation;
        let repositionTimeout = 0;
        window.addEventListener("resize", () => {
            clearTimeout(repositionTimeout);
            repositionTimeout = setTimeout(() => {
                repositionOpenDialogs();
                if (!hasScreenOrientation) {
                    repositionLoadingMasks();
                }
            }, 100);
        }, {
            passive: true
        });
        if (hasScreenOrientation) {
            screen.orientation.addEventListener("change", () => {
                setTimeout(repositionLoadingMasks, 100);
            }, {
                passive: true
            });
        }
    })(Dialog = ECP.Dialog || (ECP.Dialog = {}));
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let CommonDashboards;
    (function (CommonDashboards) {
        CommonDashboards[CommonDashboards["RetailerHome"] = 100000] = "RetailerHome";
        CommonDashboards[CommonDashboards["LogOn"] = 100008] = "LogOn";
        CommonDashboards[CommonDashboards["DeliveryOptimizer"] = 100009] = "DeliveryOptimizer";
        CommonDashboards[CommonDashboards["Knowledge"] = 100013] = "Knowledge";
        CommonDashboards[CommonDashboards["CustomerSearch"] = 100015] = "CustomerSearch";
        CommonDashboards[CommonDashboards["TableView"] = 100100] = "TableView";
        CommonDashboards[CommonDashboards["TableEdit"] = 100101] = "TableEdit";
        CommonDashboards[CommonDashboards["TableMerge"] = 100102] = "TableMerge";
        CommonDashboards[CommonDashboards["TableCopy"] = 100103] = "TableCopy";
        CommonDashboards[CommonDashboards["TableMap"] = 100104] = "TableMap";
        CommonDashboards[CommonDashboards["TableEditor"] = 162403] = "TableEditor";
        CommonDashboards[CommonDashboards["FusionView"] = 100120] = "FusionView";
        CommonDashboards[CommonDashboards["FusionEdit"] = 100121] = "FusionEdit";
        CommonDashboards[CommonDashboards["FusionCheck"] = 100122] = "FusionCheck";
        CommonDashboards[CommonDashboards["ReportView"] = 100130] = "ReportView";
        CommonDashboards[CommonDashboards["ReportEdit"] = 100132] = "ReportEdit";
        CommonDashboards[CommonDashboards["SavedReports"] = 100004] = "SavedReports";
        CommonDashboards[CommonDashboards["ScheduledReports"] = 172809] = "ScheduledReports";
        CommonDashboards[CommonDashboards["InvoiceView"] = 158170] = "InvoiceView";
        CommonDashboards[CommonDashboards["InvoiceMerge"] = 171676] = "InvoiceMerge";
        CommonDashboards[CommonDashboards["InvoiceReverse"] = 172006] = "InvoiceReverse";
        CommonDashboards[CommonDashboards["InvoiceEditPlus"] = 170799] = "InvoiceEditPlus";
        CommonDashboards[CommonDashboards["InvoiceEdit"] = 163987] = "InvoiceEdit";
        CommonDashboards[CommonDashboards["InvoicePrint"] = 166689] = "InvoicePrint";
        CommonDashboards[CommonDashboards["InvoiceManualEdit"] = 167409] = "InvoiceManualEdit";
        CommonDashboards[CommonDashboards["InvoiceEditFreeGoods"] = 172947] = "InvoiceEditFreeGoods";
        CommonDashboards[CommonDashboards["PromotionOverride"] = 172277] = "PromotionOverride";
        CommonDashboards[CommonDashboards["PotentialPromotionsReport"] = 172230] = "PotentialPromotionsReport";
        CommonDashboards[CommonDashboards["InvoiceEditAddProducts"] = 173445] = "InvoiceEditAddProducts";
        CommonDashboards[CommonDashboards["OthersAddProducts"] = 174075] = "OthersAddProducts";
        CommonDashboards[CommonDashboards["InvoicePriceCalc"] = 173992] = "InvoicePriceCalc";
        CommonDashboards[CommonDashboards["PromotionsCalendar"] = 174188] = "PromotionsCalendar";
        CommonDashboards[CommonDashboards["PricingReport"] = 174225] = "PricingReport";
        CommonDashboards[CommonDashboards["StatementPrintPDF"] = 175598] = "StatementPrintPDF";
        CommonDashboards[CommonDashboards["PurchaseView"] = 168160] = "PurchaseView";
        CommonDashboards[CommonDashboards["BuildBOM"] = 165909] = "BuildBOM";
        CommonDashboards[CommonDashboards["CheckRuns"] = 166098] = "CheckRuns";
        CommonDashboards[CommonDashboards["LoadSheetReceipts"] = 166177] = "LoadSheetReceipts";
        CommonDashboards[CommonDashboards["Deposits"] = 171600] = "Deposits";
        CommonDashboards[CommonDashboards["ExchangeTaskView"] = 168059] = "ExchangeTaskView";
        CommonDashboards[CommonDashboards["LoadSheetLoad"] = 171387] = "LoadSheetLoad";
        CommonDashboards[CommonDashboards["LoadSheetErrorCheck"] = 172553] = "LoadSheetErrorCheck";
        CommonDashboards[CommonDashboards["InvoiceMove"] = 171931] = "InvoiceMove";
        CommonDashboards[CommonDashboards["AddCustomers"] = 171882] = "AddCustomers";
        CommonDashboards[CommonDashboards["ControlPanel"] = 100148] = "ControlPanel";
        CommonDashboards[CommonDashboards["SystemSettings"] = 171671] = "SystemSettings";
        CommonDashboards[CommonDashboards["RetailerReportsPriceSheet"] = 173067] = "RetailerReportsPriceSheet";
        CommonDashboards[CommonDashboards["Reports"] = 172919] = "Reports";
        CommonDashboards[CommonDashboards["AccountsReceivableAging"] = 173986] = "AccountsReceivableAging";
        CommonDashboards[CommonDashboards["TakeASurvey"] = 100012] = "TakeASurvey";
        CommonDashboards[CommonDashboards["FinanceCharges"] = 175106] = "FinanceCharges";
        CommonDashboards[CommonDashboards["LoadSheetReceiptsImport"] = 176524] = "LoadSheetReceiptsImport";
        CommonDashboards[CommonDashboards["PaymentAdd"] = 176597] = "PaymentAdd";
        CommonDashboards[CommonDashboards["ARWriteOff"] = 176264] = "ARWriteOff";
        CommonDashboards[CommonDashboards["MapView"] = 175277] = "MapView";
        CommonDashboards[CommonDashboards["TemplateDesigner"] = 173328] = "TemplateDesigner";
        CommonDashboards[CommonDashboards["TemplateDesignerForMobile"] = 172808] = "TemplateDesignerForMobile";
        CommonDashboards[CommonDashboards["CalendarView"] = 179256] = "CalendarView";
        CommonDashboards[CommonDashboards["FleetTracker"] = 100007] = "FleetTracker";
        CommonDashboards[CommonDashboards["ServiceEventsMap"] = 171925] = "ServiceEventsMap";
        CommonDashboards[CommonDashboards["VehiclePlanner"] = 172451] = "VehiclePlanner";
        CommonDashboards[CommonDashboards["MappedRouting"] = 172453] = "MappedRouting";
        CommonDashboards[CommonDashboards["Geocoding"] = 172511] = "Geocoding";
        CommonDashboards[CommonDashboards["SequenceDelivery"] = 172529] = "SequenceDelivery";
        CommonDashboards[CommonDashboards["StopManager"] = 172857] = "StopManager";
        CommonDashboards[CommonDashboards["SequenceProducts"] = 173031] = "SequenceProducts";
        CommonDashboards[CommonDashboards["AddStop"] = 173064] = "AddStop";
        CommonDashboards[CommonDashboards["DynamicRouting"] = 173122] = "DynamicRouting";
        CommonDashboards[CommonDashboards["AutoCreateRoutes"] = 173128] = "AutoCreateRoutes";
        CommonDashboards[CommonDashboards["PlanOptimizer"] = 173238] = "PlanOptimizer";
        CommonDashboards[CommonDashboards["GoogleMapGeo"] = 999901532] = "GoogleMapGeo";
        CommonDashboards[CommonDashboards["CustomerGeocode"] = 173331] = "CustomerGeocode";
        CommonDashboards[CommonDashboards["RoutePlanner"] = 173335] = "RoutePlanner";
        CommonDashboards[CommonDashboards["RoutePlanerSelector"] = 173362] = "RoutePlanerSelector";
        CommonDashboards[CommonDashboards["MapPointsGeocode"] = 173685] = "MapPointsGeocode";
        CommonDashboards[CommonDashboards["ImportConflicts"] = 174029] = "ImportConflicts";
        CommonDashboards[CommonDashboards["ImportConflictsMoveInvoice"] = 174073] = "ImportConflictsMoveInvoice";
        CommonDashboards[CommonDashboards["PrintDirections"] = 174149] = "PrintDirections";
        CommonDashboards[CommonDashboards["TimeClockEventMap"] = 174255] = "TimeClockEventMap";
        CommonDashboards[CommonDashboards["AlternateLocations"] = 174264] = "AlternateLocations";
        CommonDashboards[CommonDashboards["OversoldProducts"] = 174413] = "OversoldProducts";
        CommonDashboards[CommonDashboards["LoadSheetImportExport"] = 174481] = "LoadSheetImportExport";
        CommonDashboards[CommonDashboards["ShuttleTruckPlanner"] = 174571] = "ShuttleTruckPlanner";
        CommonDashboards[CommonDashboards["AddLoadSheet"] = 174927] = "AddLoadSheet";
        CommonDashboards[CommonDashboards["CloseDatedProducts"] = 175058] = "CloseDatedProducts";
        CommonDashboards[CommonDashboards["OverAllocatedProducts"] = 175377] = "OverAllocatedProducts";
        CommonDashboards[CommonDashboards["VehiclePlannerIPad"] = 175948] = "VehiclePlannerIPad";
        CommonDashboards[CommonDashboards["RoutingReport"] = 175990] = "RoutingReport";
        CommonDashboards[CommonDashboards["ManifestPrint"] = 176178] = "ManifestPrint";
        CommonDashboards[CommonDashboards["DockTimeCalendar"] = 176552] = "DockTimeCalendar";
        CommonDashboards[CommonDashboards["RouteOptimizer"] = 176792] = "RouteOptimizer";
        CommonDashboards[CommonDashboards["SalesmanCallTimes"] = 176922] = "SalesmanCallTimes";
        CommonDashboards[CommonDashboards["PurchaseVsForecast"] = 177554] = "PurchaseVsForecast";
        CommonDashboards[CommonDashboards["InventoryProjections"] = 177637] = "InventoryProjections";
        CommonDashboards[CommonDashboards["ShipmentOptimizer"] = 177717] = "ShipmentOptimizer";
        CommonDashboards[CommonDashboards["ShipmentPlanner"] = 177937] = "ShipmentPlanner";
        CommonDashboards[CommonDashboards["ForecastReport"] = 177939] = "ForecastReport";
        CommonDashboards[CommonDashboards["ActualVsForecast"] = 178242] = "ActualVsForecast";
        CommonDashboards[CommonDashboards["CarrierSchedule"] = 178559] = "CarrierSchedule";
        CommonDashboards[CommonDashboards["POImport"] = 178888] = "POImport";
        CommonDashboards[CommonDashboards["OutofStockRules"] = 179435] = "OutofStockRules";
        CommonDashboards[CommonDashboards["POGenerator"] = 179438] = "POGenerator";
        CommonDashboards[CommonDashboards["TransferPlanner"] = 179508] = "TransferPlanner";
        CommonDashboards[CommonDashboards["Forecasting"] = 179546] = "Forecasting";
        CommonDashboards[CommonDashboards["ImportRoutine"] = 180050] = "ImportRoutine";
        CommonDashboards[CommonDashboards["TaskEdit"] = 181004] = "TaskEdit";
        CommonDashboards[CommonDashboards["PrintRetailerLabels"] = 160198] = "PrintRetailerLabels";
        CommonDashboards[CommonDashboards["InviteUsersToDSDLink"] = 189552] = "InviteUsersToDSDLink";
        CommonDashboards[CommonDashboards["MyProfile"] = 187515] = "MyProfile";
        CommonDashboards[CommonDashboards["SetPassword"] = 165739] = "SetPassword";
    })(CommonDashboards = ECP.CommonDashboards || (ECP.CommonDashboards = {}));
    let HTML;
    (function (HTML) {
        let Icons;
        (function (Icons) {
            Icons[Icons["None"] = 0] = "None";
            Icons[Icons["Add"] = 1] = "Add";
            Icons[Icons["Alert"] = 2] = "Alert";
            Icons[Icons["Audit"] = 3] = "Audit";
            Icons[Icons["BackgroundColor"] = 4] = "BackgroundColor";
            Icons[Icons["Bold"] = 5] = "Bold";
            Icons[Icons["Borders"] = 6] = "Borders";
            Icons[Icons["Calendar"] = 7] = "Calendar";
            Icons[Icons["CaretDown"] = 8] = "CaretDown";
            Icons[Icons["Center"] = 9] = "Center";
            Icons[Icons["Check"] = 10] = "Check";
            Icons[Icons["CircleClosed"] = 11] = "CircleClosed";
            Icons[Icons["CircleOpen"] = 12] = "CircleOpen";
            Icons[Icons["Code"] = 13] = "Code";
            Icons[Icons["Clear"] = 14] = "Clear";
            Icons[Icons["Close"] = 15] = "Close";
            Icons[Icons["Computer"] = 16] = "Computer";
            Icons[Icons["Copy"] = 17] = "Copy";
            Icons[Icons["Credit"] = 18] = "Credit";
            Icons[Icons["Cut"] = 19] = "Cut";
            Icons[Icons["Dashboard"] = 20] = "Dashboard";
            Icons[Icons["Data"] = 21] = "Data";
            Icons[Icons["Delete"] = 22] = "Delete";
            Icons[Icons["Document"] = 23] = "Document";
            Icons[Icons["Download"] = 24] = "Download";
            Icons[Icons["EChat"] = 25] = "EChat";
            Icons[Icons["Edit"] = 26] = "Edit";
            Icons[Icons["Ellipsis"] = 27] = "Ellipsis";
            Icons[Icons["Email"] = 28] = "Email";
            Icons[Icons["Excel"] = 29] = "Excel";
            Icons[Icons["ShowColor"] = 30] = "ShowColor";
            Icons[Icons["HideColor"] = 31] = "HideColor";
            Icons[Icons["FavoriteOff"] = 32] = "FavoriteOff";
            Icons[Icons["FavoriteOn"] = 33] = "FavoriteOn";
            Icons[Icons["First"] = 34] = "First";
            Icons[Icons["Folder"] = 35] = "Folder";
            Icons[Icons["Format"] = 36] = "Format";
            Icons[Icons["Font"] = 37] = "Font";
            Icons[Icons["FontColor"] = 38] = "FontColor";
            Icons[Icons["Ban"] = 39] = "Ban";
            Icons[Icons["FontSize"] = 40] = "FontSize";
            Icons[Icons["Freemium"] = 41] = "Freemium";
            Icons[Icons["Google"] = 42] = "Google";
            Icons[Icons["Graph"] = 43] = "Graph";
            Icons[Icons["Group"] = 44] = "Group";
            Icons[Icons["Image"] = 45] = "Image";
            Icons[Icons["Info"] = 46] = "Info";
            Icons[Icons["InsertColumn"] = 47] = "InsertColumn";
            Icons[Icons["InsertRow"] = 48] = "InsertRow";
            Icons[Icons["InsertSheet"] = 49] = "InsertSheet";
            Icons[Icons["Italic"] = 50] = "Italic";
            Icons[Icons["Last"] = 51] = "Last";
            Icons[Icons["Lists"] = 52] = "Lists";
            Icons[Icons["Left"] = 53] = "Left";
            Icons[Icons["Map"] = 54] = "Map";
            Icons[Icons["Money"] = 55] = "Money";
            Icons[Icons["News"] = 56] = "News";
            Icons[Icons["Run"] = 57] = "Run";
            Icons[Icons["Next"] = 58] = "Next";
            Icons[Icons["NextPage"] = 59] = "NextPage";
            Icons[Icons["NumberFormat"] = 60] = "NumberFormat";
            Icons[Icons["Page"] = 61] = "Page";
            Icons[Icons["Paste"] = 62] = "Paste";
            Icons[Icons["Phone"] = 63] = "Phone";
            Icons[Icons["Previous"] = 64] = "Previous";
            Icons[Icons["PreviousPage"] = 65] = "PreviousPage";
            Icons[Icons["Print"] = 66] = "Print";
            Icons[Icons["RecentChats"] = 67] = "RecentChats";
            Icons[Icons["Refresh"] = 68] = "Refresh";
            Icons[Icons["Rename"] = 69] = "Rename";
            Icons[Icons["Report"] = 70] = "Report";
            Icons[Icons["Retailer"] = 71] = "Retailer";
            Icons[Icons["Right"] = 72] = "Right";
            Icons[Icons["Save"] = 73] = "Save";
            Icons[Icons["Search"] = 74] = "Search";
            Icons[Icons["Send"] = 75] = "Send";
            Icons[Icons["Settings"] = 76] = "Settings";
            Icons[Icons["Share"] = 77] = "Share";
            Icons[Icons["Sort"] = 78] = "Sort";
            Icons[Icons["Spreadsheet"] = 79] = "Spreadsheet";
            Icons[Icons["StepIn"] = 80] = "StepIn";
            Icons[Icons["Table"] = 81] = "Table";
            Icons[Icons["Text"] = 82] = "Text";
            Icons[Icons["Underline"] = 83] = "Underline";
            Icons[Icons["Unlock"] = 84] = "Unlock";
            Icons[Icons["Upload"] = 85] = "Upload";
            Icons[Icons["User"] = 86] = "User";
            Icons[Icons["View"] = 87] = "View";
            Icons[Icons["Warning"] = 88] = "Warning";
            Icons[Icons["Xml"] = 89] = "Xml";
            Icons[Icons["Youtube"] = 90] = "Youtube";
            Icons[Icons["ExternalLink"] = 91] = "ExternalLink";
            Icons[Icons["Square"] = 92] = "Square";
            Icons[Icons["PlusSquareO"] = 93] = "PlusSquareO";
            Icons[Icons["MinusSquareO"] = 94] = "MinusSquareO";
            Icons[Icons["ThLarge"] = 95] = "ThLarge";
            Icons[Icons["FitSize"] = 96] = "FitSize";
            Icons[Icons["BorderDashed"] = 97] = "BorderDashed";
            Icons[Icons["Chatting"] = 98] = "Chatting";
            Icons[Icons["Password"] = 99] = "Password";
            Icons[Icons["Location"] = 100] = "Location";
            Icons[Icons["LogOff"] = 101] = "LogOff";
            Icons[Icons["ParentUp"] = 102] = "ParentUp";
            Icons[Icons["Header"] = 103] = "Header";
            Icons[Icons["Knowledge"] = 104] = "Knowledge";
            Icons[Icons["Link"] = 105] = "Link";
            Icons[Icons["Strike"] = 106] = "Strike";
            Icons[Icons["Rule"] = 107] = "Rule";
            Icons[Icons["Trash"] = 108] = "Trash";
            Icons[Icons["SelectAll"] = 109] = "SelectAll";
            Icons[Icons["SelectNone"] = 110] = "SelectNone";
            Icons[Icons["Truck"] = 111] = "Truck";
            Icons[Icons["Adjust"] = 112] = "Adjust";
            Icons[Icons["BarCode"] = 113] = "BarCode";
            Icons[Icons["Back"] = 114] = "Back";
            Icons[Icons["Cancel"] = 115] = "Cancel";
            Icons[Icons["ByCustomer"] = 116] = "ByCustomer";
            Icons[Icons["ByProduct"] = 117] = "ByProduct";
            Icons[Icons["ByPallet"] = 118] = "ByPallet";
            Icons[Icons["Book"] = 119] = "Book";
            Icons[Icons["Conformation"] = 120] = "Conformation";
            Icons[Icons["Dynamic"] = 121] = "Dynamic";
            Icons[Icons["EmailAt"] = 122] = "EmailAt";
            Icons[Icons["Export"] = 123] = "Export";
            Icons[Icons["Sweep"] = 124] = "Sweep";
            Icons[Icons["Go"] = 125] = "Go";
            Icons[Icons["Help"] = 126] = "Help";
            Icons[Icons["Hide"] = 127] = "Hide";
            Icons[Icons["BiDirection"] = 128] = "BiDirection";
            Icons[Icons["Import"] = 129] = "Import";
            Icons[Icons["Inbox"] = 130] = "Inbox";
            Icons[Icons["Information"] = 131] = "Information";
            Icons[Icons["Monitor"] = 132] = "Monitor";
            Icons[Icons["NewMessage"] = 133] = "NewMessage";
            Icons[Icons["Note"] = 134] = "Note";
            Icons[Icons["NotePad"] = 135] = "NotePad";
            Icons[Icons["Permission"] = 136] = "Permission";
            Icons[Icons["RecentlyUpdated"] = 137] = "RecentlyUpdated";
            Icons[Icons["Reload"] = 138] = "Reload";
            Icons[Icons["Reply"] = 139] = "Reply";
            Icons[Icons["Return"] = 140] = "Return";
            Icons[Icons["Show"] = 141] = "Show";
            Icons[Icons["Zip"] = 142] = "Zip";
            Icons[Icons["Error"] = 143] = "Error";
            Icons[Icons["ManuallyEdit"] = 144] = "ManuallyEdit";
            Icons[Icons["Assign"] = 145] = "Assign";
            Icons[Icons["ViewCustomer"] = 146] = "ViewCustomer";
            Icons[Icons["ClearCustomer"] = 147] = "ClearCustomer";
            Icons[Icons["Road"] = 148] = "Road";
            Icons[Icons["RotateRight"] = 149] = "RotateRight";
            Icons[Icons["RotateLeft"] = 150] = "RotateLeft";
            Icons[Icons["House"] = 151] = "House";
            Icons[Icons["Awards"] = 152] = "Awards";
            Icons[Icons["Flag"] = 153] = "Flag";
            Icons[Icons["Tag"] = 154] = "Tag";
            Icons[Icons["Facebook"] = 155] = "Facebook";
            Icons[Icons["Windows"] = 156] = "Windows";
            Icons[Icons["ChainBroken"] = 157] = "ChainBroken";
            Icons[Icons["LinkedIn"] = 158] = "LinkedIn";
            Icons[Icons["Label"] = 159] = "Label";
            Icons[Icons["Line"] = 160] = "Line";
            Icons[Icons["InfoLabel"] = 161] = "InfoLabel";
            Icons[Icons["Minus"] = 162] = "Minus";
            Icons[Icons["PrevNotesIcon"] = 163] = "PrevNotesIcon";
            Icons[Icons["NextNotesIcon"] = 164] = "NextNotesIcon";
            Icons[Icons["ReDo"] = 165] = "ReDo";
            Icons[Icons["TextAlignBothSide"] = 166] = "TextAlignBothSide";
            Icons[Icons["ListNum"] = 167] = "ListNum";
            Icons[Icons["TableGrid"] = 168] = "TableGrid";
            Icons[Icons["TableGridDelete"] = 169] = "TableGridDelete";
            Icons[Icons["TableGridAddTop"] = 170] = "TableGridAddTop";
            Icons[Icons["TableGridAddBottom"] = 171] = "TableGridAddBottom";
            Icons[Icons["TableGridAddLeft"] = 172] = "TableGridAddLeft";
            Icons[Icons["TableGridAddRight"] = 173] = "TableGridAddRight";
            Icons[Icons["TableGridDeleteRow"] = 174] = "TableGridDeleteRow";
            Icons[Icons["TableGridDeleteColumn"] = 175] = "TableGridDeleteColumn";
            Icons[Icons["Globe"] = 176] = "Globe";
            Icons[Icons["AddressBookO"] = 177] = "AddressBookO";
            Icons[Icons["OpenO"] = 178] = "OpenO";
            Icons[Icons["UserCircleO"] = 179] = "UserCircleO";
            Icons[Icons["CircleO"] = 180] = "CircleO";
            Icons[Icons["Pricing"] = 181] = "Pricing";
            Icons[Icons["Test"] = 182] = "Test";
            Icons[Icons["Purchasing"] = 183] = "Purchasing";
            Icons[Icons["Objectives"] = 184] = "Objectives";
            Icons[Icons["Products"] = 185] = "Products";
            Icons[Icons["Reports"] = 186] = "Reports";
            Icons[Icons["Routing"] = 187] = "Routing";
            Icons[Icons["Home"] = 188] = "Home";
            Icons[Icons["Webinar"] = 189] = "Webinar";
            Icons[Icons["Warehouse"] = 190] = "Warehouse";
            Icons[Icons["Users"] = 191] = "Users";
            Icons[Icons["Support"] = 192] = "Support";
            Icons[Icons["ImportExport"] = 193] = "ImportExport";
            Icons[Icons["Delivery"] = 194] = "Delivery";
            Icons[Icons["Customers"] = 195] = "Customers";
            Icons[Icons["Accounting"] = 196] = "Accounting";
            Icons[Icons["EDI"] = 197] = "EDI";
            Icons[Icons["Picking"] = 198] = "Picking";
            Icons[Icons["AjaxInput"] = 199] = "AjaxInput";
            Icons[Icons["Setting"] = 200] = "Setting";
            Icons[Icons["DropDown"] = 201] = "DropDown";
            Icons[Icons["DropDownAttention"] = 202] = "DropDownAttention";
            Icons[Icons["EncompassLogo"] = 203] = "EncompassLogo";
            Icons[Icons["RetailerServices"] = 204] = "RetailerServices";
            Icons[Icons["Platform"] = 205] = "Platform";
            Icons[Icons["CRM"] = 206] = "CRM";
            Icons[Icons["WCS"] = 207] = "WCS";
            Icons[Icons["WMS"] = 208] = "WMS";
            Icons[Icons["Logistics"] = 209] = "Logistics";
            Icons[Icons["PurchasingO"] = 210] = "PurchasingO";
            Icons[Icons["Focus"] = 211] = "Focus";
            Icons[Icons["Direction"] = 212] = "Direction";
            Icons[Icons["EMAccountsReceivable"] = 213] = "EMAccountsReceivable";
            Icons[Icons["EMAssets"] = 214] = "EMAssets";
            Icons[Icons["EMClockOut"] = 215] = "EMClockOut";
            Icons[Icons["EMCustomerInformation"] = 216] = "EMCustomerInformation";
            Icons[Icons["EMCustomerNotes"] = 217] = "EMCustomerNotes";
            Icons[Icons["EMDocuments"] = 218] = "EMDocuments";
            Icons[Icons["EMDOT"] = 219] = "EMDOT";
            Icons[Icons["EMDOTPreView"] = 220] = "EMDOTPreView";
            Icons[Icons["EMDSDLink"] = 221] = "EMDSDLink";
            Icons[Icons["EMHistoricalInvoices"] = 222] = "EMHistoricalInvoices";
            Icons[Icons["EMHOS"] = 223] = "EMHOS";
            Icons[Icons["EMInventory"] = 224] = "EMInventory";
            Icons[Icons["EMInvoices"] = 225] = "EMInvoices";
            Icons[Icons["EMIReport"] = 226] = "EMIReport";
            Icons[Icons["EMKnowledge"] = 227] = "EMKnowledge";
            Icons[Icons["EMLoadRequest"] = 228] = "EMLoadRequest";
            Icons[Icons["EMLoadsheetReturn"] = 229] = "EMLoadsheetReturn";
            Icons[Icons["EMPReport"] = 230] = "EMPReport";
            Icons[Icons["EMProductInquiry"] = 231] = "EMProductInquiry";
            Icons[Icons["EMPromotions"] = 232] = "EMPromotions";
            Icons[Icons["EMReplenish"] = 233] = "EMReplenish";
            Icons[Icons["EMReport"] = 234] = "EMReport";
            Icons[Icons["EMRetailPricing"] = 235] = "EMRetailPricing";
            Icons[Icons["EMRReport"] = 236] = "EMRReport";
            Icons[Icons["EMShoppingCart"] = 237] = "EMShoppingCart";
            Icons[Icons["EMSurveys"] = 238] = "EMSurveys";
            Icons[Icons["EMFileSync"] = 239] = "EMFileSync";
            Icons[Icons["EMTask"] = 240] = "EMTask";
            Icons[Icons["EMTurnByTurn"] = 241] = "EMTurnByTurn";
            Icons[Icons["EMUsers"] = 242] = "EMUsers";
            Icons[Icons["EMBreak"] = 243] = "EMBreak";
            Icons[Icons["EMControlPanel"] = 244] = "EMControlPanel";
            Icons[Icons["EMCustomers"] = 245] = "EMCustomers";
            Icons[Icons["EMDashboard"] = 246] = "EMDashboard";
            Icons[Icons["EMDrive"] = 247] = "EMDrive";
            Icons[Icons["EMEchat"] = 248] = "EMEchat";
            Icons[Icons["EMMeal"] = 249] = "EMMeal";
            Icons[Icons["EMMeeting"] = 250] = "EMMeeting";
            Icons[Icons["EMMyday"] = 251] = "EMMyday";
            Icons[Icons["EMPMK"] = 252] = "EMPMK";
            Icons[Icons["EMQuickTour"] = 253] = "EMQuickTour";
            Icons[Icons["EMRetailerLabels"] = 254] = "EMRetailerLabels";
            Icons[Icons["EMSalesExecution"] = 255] = "EMSalesExecution";
            Icons[Icons["EMWarehouse"] = 256] = "EMWarehouse";
            Icons[Icons["EMDefault"] = 257] = "EMDefault";
            Icons[Icons["EMCallManager"] = 258] = "EMCallManager";
            Icons[Icons["EMPlay"] = 259] = "EMPlay";
            Icons[Icons["EMPause"] = 260] = "EMPause";
            Icons[Icons["EMVolume"] = 261] = "EMVolume";
            Icons[Icons["EMVolumeNone"] = 262] = "EMVolumeNone";
            Icons[Icons["HalfCircle"] = 263] = "HalfCircle";
            Icons[Icons["Up"] = 264] = "Up";
            Icons[Icons["Calculation"] = 265] = "Calculation";
            Icons[Icons["EMPDS"] = 266] = "EMPDS";
            Icons[Icons["CarFont"] = 267] = "CarFont";
            Icons[Icons["PhoneCallO"] = 268] = "PhoneCallO";
            Icons[Icons["PhoneCall"] = 269] = "PhoneCall";
            Icons[Icons["SortAlphaAsc"] = 270] = "SortAlphaAsc";
            Icons[Icons["SortAlphaDesc"] = 271] = "SortAlphaDesc";
            Icons[Icons["SortDesc"] = 272] = "SortDesc";
            Icons[Icons["SortAsc"] = 273] = "SortAsc";
            Icons[Icons["SortAmountAsc"] = 274] = "SortAmountAsc";
            Icons[Icons["SortAmountDesc"] = 275] = "SortAmountDesc";
            Icons[Icons["Move"] = 276] = "Move";
            Icons[Icons["BoxDraw"] = 277] = "BoxDraw";
            Icons[Icons["PolygonDraw"] = 278] = "PolygonDraw";
            Icons[Icons["MapErase"] = 279] = "MapErase";
            Icons[Icons["BoxErase"] = 280] = "BoxErase";
            Icons[Icons["PolygonErase"] = 281] = "PolygonErase";
            Icons[Icons["EMPlayCircle"] = 287] = "EMPlayCircle";
            Icons[Icons["EMLocation"] = 288] = "EMLocation";
            Icons[Icons["EMSend"] = 289] = "EMSend";
            Icons[Icons["EMVoiceReply"] = 290] = "EMVoiceReply";
            Icons[Icons["EMVoiceReplyLeft"] = 291] = "EMVoiceReplyLeft";
            Icons[Icons["EMVideo"] = 292] = "EMVideo";
            Icons[Icons["EMRecordVideo"] = 293] = "EMRecordVideo";
            Icons[Icons["EMFolder"] = 294] = "EMFolder";
            Icons[Icons["EMPhotoGraph"] = 295] = "EMPhotoGraph";
            Icons[Icons["EMVoice"] = 296] = "EMVoice";
            Icons[Icons["EMImages"] = 297] = "EMImages";
            Icons[Icons["EMEmail"] = 298] = "EMEmail";
            Icons[Icons["EMNote"] = 299] = "EMNote";
            Icons[Icons["EMTel"] = 300] = "EMTel";
            Icons[Icons["EMCheckBold"] = 301] = "EMCheckBold";
            Icons[Icons["EMErrorBold"] = 302] = "EMErrorBold";
            Icons[Icons["EMKnowledgeVideo"] = 303] = "EMKnowledgeVideo";
            Icons[Icons["EMKnowledgeAudio"] = 304] = "EMKnowledgeAudio";
            Icons[Icons["EMKnowledgeImage"] = 305] = "EMKnowledgeImage";
            Icons[Icons["EMKnowledgeDOC"] = 306] = "EMKnowledgeDOC";
            Icons[Icons["EMKnowledgeHTML"] = 307] = "EMKnowledgeHTML";
            Icons[Icons["EMKnowledgePDF"] = 308] = "EMKnowledgePDF";
            Icons[Icons["EMKnowledgePPT"] = 309] = "EMKnowledgePPT";
            Icons[Icons["EMKnowledgeRTF"] = 310] = "EMKnowledgeRTF";
            Icons[Icons["EMKnowledgeTXT"] = 311] = "EMKnowledgeTXT";
            Icons[Icons["EMKnowledgeXLS"] = 312] = "EMKnowledgeXLS";
            Icons[Icons["EMKnowledgeOther"] = 313] = "EMKnowledgeOther";
            Icons[Icons["EMAddDocument"] = 315] = "EMAddDocument";
            Icons[Icons["MultiplePlatform"] = 316] = "MultiplePlatform";
            Icons[Icons["EMFilter"] = 317] = "EMFilter";
            Icons[Icons["SendDelay"] = 318] = "SendDelay";
            Icons[Icons["EMHorizontal"] = 319] = "EMHorizontal";
            Icons[Icons["EmVertical"] = 320] = "EmVertical";
            Icons[Icons["Hardware"] = 321] = "Hardware";
            Icons[Icons["EMDownLoad"] = 322] = "EMDownLoad";
            Icons[Icons["EMResetPassword"] = 323] = "EMResetPassword";
            Icons[Icons["EMRouteComplete"] = 324] = "EMRouteComplete";
            Icons[Icons["EMSync"] = 325] = "EMSync";
            Icons[Icons["Mobile"] = 326] = "Mobile";
            Icons[Icons["AreaChart"] = 327] = "AreaChart";
            Icons[Icons["ColumnGraph"] = 328] = "ColumnGraph";
            Icons[Icons["BarGraph"] = 329] = "BarGraph";
            Icons[Icons["DoughnutChart"] = 330] = "DoughnutChart";
            Icons[Icons["EMResetPasswordO"] = 331] = "EMResetPasswordO";
            Icons[Icons["EMDistributor"] = 332] = "EMDistributor";
            Icons[Icons["EMCaretDown"] = 333] = "EMCaretDown";
            Icons[Icons["UploadFiles"] = 334] = "UploadFiles";
            Icons[Icons["ClearFormat"] = 335] = "ClearFormat";
            Icons[Icons["History"] = 336] = "History";
            Icons[Icons["EchatSupport"] = 341] = "EchatSupport";
            Icons[Icons["DisablesVoice"] = 342] = "DisablesVoice";
            Icons[Icons["LineChart"] = 343] = "LineChart";
            Icons[Icons["GaugeChart"] = 344] = "GaugeChart";
            Icons[Icons["BusinessFinance"] = 345] = "BusinessFinance";
            Icons[Icons["FactoryStock"] = 346] = "FactoryStock";
            Icons[Icons["HandSmartphone"] = 347] = "HandSmartphone";
            Icons[Icons["StackedBar"] = 348] = "StackedBar";
            Icons[Icons["Fusion"] = 349] = "Fusion";
            Icons[Icons["ChatsHistory"] = 350] = "ChatsHistory";
            Icons[Icons["CodeBlocksLogo"] = 352] = "CodeBlocksLogo";
            Icons[Icons["CloudFunction"] = 355] = "CloudFunction";
            Icons[Icons["EMPayRoll"] = 357] = "EMPayRoll";
            Icons[Icons["EMMemo"] = 358] = "EMMemo";
            Icons[Icons["EMTime"] = 359] = "EMTime";
            Icons[Icons["EnvelopeImport"] = 360] = "EnvelopeImport";
            Icons[Icons["Envelope"] = 361] = "Envelope";
            Icons[Icons["EMGPAnalytics"] = 362] = "EMGPAnalytics";
            Icons[Icons["EMPin"] = 363] = "EMPin";
            Icons[Icons["Pin"] = 364] = "Pin";
            Icons[Icons["Deal"] = 365] = "Deal";
            Icons[Icons["TrophyEmpty"] = 366] = "TrophyEmpty";
            Icons[Icons["EMCreateTask"] = 367] = "EMCreateTask";
            Icons[Icons["EMEditTask"] = 368] = "EMEditTask";
            Icons[Icons["EMLabelP"] = 370] = "EMLabelP";
            Icons[Icons["EMReverseP"] = 373] = "EMReverseP";
            Icons[Icons["EMLabelK"] = 374] = "EMLabelK";
            Icons[Icons["EMReverseK"] = 375] = "EMReverseK";
            Icons[Icons["EMLabelDP"] = 376] = "EMLabelDP";
            Icons[Icons["EMReverseDP"] = 377] = "EMReverseDP";
            Icons[Icons["EMLabelDK"] = 378] = "EMLabelDK";
            Icons[Icons["EMReverseDK"] = 379] = "EMReverseDK";
            Icons[Icons["EMSignature"] = 382] = "EMSignature";
            Icons[Icons["Drafting"] = 383] = "Drafting";
            Icons[Icons["AccountingTeam"] = 384] = "AccountingTeam";
            Icons[Icons["CRMTeam"] = 385] = "CRMTeam";
            Icons[Icons["eCommerceTeam"] = 386] = "eCommerceTeam";
            Icons[Icons["InvoicingTeam"] = 387] = "InvoicingTeam";
            Icons[Icons["LogisticsTeam"] = 388] = "LogisticsTeam";
            Icons[Icons["PlatformTeam"] = 389] = "PlatformTeam";
            Icons[Icons["WCSTeam"] = 390] = "WCSTeam";
            Icons[Icons["WMSTeam"] = 391] = "WMSTeam";
            Icons[Icons["HashTag"] = 392] = "HashTag";
            Icons[Icons["AttachLight"] = 393] = "AttachLight";
            Icons[Icons["Waive"] = 394] = "Waive";
            Icons[Icons["FilterBold"] = 395] = "FilterBold";
            Icons[Icons["Plane"] = 396] = "Plane";
            Icons[Icons["NoArrange"] = 397] = "NoArrange";
            Icons[Icons["HideHeader"] = 398] = "HideHeader";
            Icons[Icons["PlusSquare"] = 400] = "PlusSquare";
            Icons[Icons["MinusSquare"] = 401] = "MinusSquare";
            Icons[Icons["EMLightOff"] = 402] = "EMLightOff";
            Icons[Icons["EMLightOn"] = 403] = "EMLightOn";
            Icons[Icons["EMRoundStar"] = 404] = "EMRoundStar";
            Icons[Icons["Eye"] = 405] = "Eye";
            Icons[Icons["ShoppingCar"] = 406] = "ShoppingCar";
            Icons[Icons["NoShoppingCar"] = 407] = "NoShoppingCar";
            Icons[Icons["OrchestraLogo"] = 408] = "OrchestraLogo";
            Icons[Icons["HandoffLogo"] = 409] = "HandoffLogo";
            Icons[Icons["EditItem"] = 410] = "EditItem";
            Icons[Icons["SettingItem"] = 411] = "SettingItem";
            Icons[Icons["HeaderItem"] = 412] = "HeaderItem";
            Icons[Icons["HideHeaderItem"] = 413] = "HideHeaderItem";
            Icons[Icons["ExpandItem"] = 414] = "ExpandItem";
            Icons[Icons["UnExpandItem"] = 415] = "UnExpandItem";
            Icons[Icons["EMKeyboard"] = 416] = "EMKeyboard";
            Icons[Icons["EMSilence"] = 417] = "EMSilence";
            Icons[Icons["EMSpeaker"] = 418] = "EMSpeaker";
            Icons[Icons["TextMessage"] = 419] = "TextMessage";
            Icons[Icons["AlarmClock"] = 420] = "AlarmClock";
            Icons[Icons["BeerLight"] = 421] = "BeerLight";
            Icons[Icons["AppleLight"] = 422] = "AppleLight";
            Icons[Icons["BeeLight"] = 423] = "BeeLight";
            Icons[Icons["GobletLight"] = 424] = "GobletLight";
            Icons[Icons["SakeLight"] = 425] = "SakeLight";
            Icons[Icons["SeltzerLight"] = 426] = "SeltzerLight";
            Icons[Icons["SpritesLight"] = 427] = "SpritesLight";
            Icons[Icons["GrapeLight"] = 428] = "GrapeLight";
            Icons[Icons["EditLight"] = 429] = "EditLight";
            Icons[Icons["AddLight"] = 430] = "AddLight";
            Icons[Icons["Beverage"] = 431] = "Beverage";
            Icons[Icons["CannabisLight"] = 432] = "CannabisLight";
            Icons[Icons["CoffeeLight"] = 433] = "CoffeeLight";
            Icons[Icons["ECigarette"] = 434] = "ECigarette";
            Icons[Icons["EnergyDrink"] = 435] = "EnergyDrink";
            Icons[Icons["FrozenGoods"] = 436] = "FrozenGoods";
            Icons[Icons["Kombucha"] = 437] = "Kombucha";
            Icons[Icons["Malt"] = 438] = "Malt";
            Icons[Icons["Mixer"] = 439] = "Mixer";
            Icons[Icons["Snacks"] = 440] = "Snacks";
            Icons[Icons["Soda"] = 441] = "Soda";
            Icons[Icons["SportsDrinks"] = 442] = "SportsDrinks";
            Icons[Icons["WaterLight"] = 443] = "WaterLight";
            Icons[Icons["TeaLight"] = 444] = "TeaLight";
            Icons[Icons["JuiceLight"] = 445] = "JuiceLight";
            Icons[Icons["SmileLight"] = 446] = "SmileLight";
            Icons[Icons["SadLight"] = 447] = "SadLight";
            Icons[Icons["MehLight"] = 448] = "MehLight";
            Icons[Icons["EMCoPilot"] = 449] = "EMCoPilot";
            Icons[Icons["TrafficLightBold"] = 450] = "TrafficLightBold";
            Icons[Icons["PayLinkLight"] = 451] = "PayLinkLight";
            Icons[Icons["ProductionLight"] = 452] = "ProductionLight";
            Icons[Icons["MenuLight"] = 453] = "MenuLight";
            Icons[Icons["NonAlcoholicLight"] = 454] = "NonAlcoholicLight";
            Icons[Icons["NonBeverageLight"] = 455] = "NonBeverageLight";
            Icons[Icons["EMCameraLight"] = 456] = "EMCameraLight";
            Icons[Icons["EMNumLight"] = 457] = "EMNumLight";
            Icons[Icons["EMTextSquareLight"] = 458] = "EMTextSquareLight";
            Icons[Icons["EMLabelE"] = 459] = "EMLabelE";
            Icons[Icons["EMCopyBold"] = 460] = "EMCopyBold";
            Icons[Icons["EMTaskBold"] = 461] = "EMTaskBold";
            Icons[Icons["EMSendBold"] = 462] = "EMSendBold";
            Icons[Icons["GiantLight"] = 463] = "GiantLight";
            Icons[Icons["Visa"] = 464] = "Visa";
            Icons[Icons["EMUserLight"] = 465] = "EMUserLight";
            Icons[Icons["EMDashboardLight"] = 466] = "EMDashboardLight";
            Icons[Icons["EMEmailLight"] = 467] = "EMEmailLight";
            Icons[Icons["EMScheduleLight"] = 468] = "EMScheduleLight";
            Icons[Icons["EMSettingLight"] = 469] = "EMSettingLight";
            Icons[Icons["EMSurveyLight"] = 470] = "EMSurveyLight";
            Icons[Icons["EMTaskLight"] = 471] = "EMTaskLight";
            Icons[Icons["EMUsersLight"] = 472] = "EMUsersLight";
            Icons[Icons["VolumeNone"] = 473] = "VolumeNone";
            Icons[Icons["Task"] = 474] = "Task";
            Icons[Icons["EMQRLight"] = 475] = "EMQRLight";
            Icons[Icons["Collection"] = 476] = "Collection";
            Icons[Icons["Signal"] = 477] = "Signal";
            Icons[Icons["DevOpsTeam"] = 478] = "DevOpsTeam";
            Icons[Icons["UnCollection"] = 479] = "UnCollection";
            Icons[Icons["EMPackage"] = 480] = "EMPackage";
            Icons[Icons["EMBox"] = 481] = "EMBox";
            Icons[Icons["LogoC"] = 483] = "LogoC";
            Icons[Icons["DataCollectionTeam"] = 484] = "DataCollectionTeam";
            Icons[Icons["Shop"] = 485] = "Shop";
            Icons[Icons["MasterCard"] = 486] = "MasterCard";
            Icons[Icons["DiscoverCard"] = 487] = "DiscoverCard";
            Icons[Icons["AMEXCard"] = 488] = "AMEXCard";
            Icons[Icons["DefaultCard"] = 489] = "DefaultCard";
            Icons[Icons["Drink"] = 490] = "Drink";
            Icons[Icons["RecoverWindow"] = 491] = "RecoverWindow";
            Icons[Icons["PlusLight"] = 492] = "PlusLight";
            Icons[Icons["Overflow"] = 493] = "Overflow";
            Icons[Icons["Bank"] = 494] = "Bank";
            Icons[Icons["HomeBold"] = 495] = "HomeBold";
            Icons[Icons["ShopBold"] = 496] = "ShopBold";
            Icons[Icons["OrderBold"] = 497] = "OrderBold";
            Icons[Icons["DollarBold"] = 498] = "DollarBold";
            Icons[Icons["CartBold"] = 499] = "CartBold";
            Icons[Icons["GearBold"] = 500] = "GearBold";
            Icons[Icons["SupportBold"] = 501] = "SupportBold";
            Icons[Icons["HTML"] = 502] = "HTML";
            Icons[Icons["CSS"] = 503] = "CSS";
            Icons[Icons["Markdown"] = 504] = "Markdown";
            Icons[Icons["JS"] = 505] = "JS";
            Icons[Icons["TestScript"] = 506] = "TestScript";
            Icons[Icons["Transfer"] = 507] = "Transfer";
            Icons[Icons["EMReplenishment"] = 508] = "EMReplenishment";
            Icons[Icons["EncompassHelp"] = 509] = "EncompassHelp";
            Icons[Icons["ACH"] = 510] = "ACH";
            Icons[Icons["Cheque"] = 511] = "Cheque";
            Icons[Icons["ChinaUnionPay"] = 512] = "ChinaUnionPay";
            Icons[Icons["DinersClub"] = 513] = "DinersClub";
            Icons[Icons["JCB"] = 514] = "JCB";
            Icons[Icons["MoneyOrder"] = 515] = "MoneyOrder";
            Icons[Icons["PayPal"] = 516] = "PayPal";
            Icons[Icons["EMDistillation"] = 517] = "EMDistillation";
            Icons[Icons["RoundB"] = 518] = "RoundB";
            Icons[Icons["RoundBK"] = 519] = "RoundBK";
            Icons[Icons["Round2"] = 520] = "Round2";
            Icons[Icons["Round2k"] = 521] = "Round2k";
            Icons[Icons["RoundS"] = 522] = "RoundS";
            Icons[Icons["RoundSK"] = 523] = "RoundSK";
            Icons[Icons["RoundX"] = 524] = "RoundX";
            Icons[Icons["RoundXK"] = 525] = "RoundXK";
            Icons[Icons["RoundK"] = 526] = "RoundK";
            Icons[Icons["RoundOB"] = 527] = "RoundOB";
            Icons[Icons["RoundOBK"] = 528] = "RoundOBK";
            Icons[Icons["RoundO2"] = 529] = "RoundO2";
            Icons[Icons["RoundO2K"] = 530] = "RoundO2K";
            Icons[Icons["RoundOS"] = 531] = "RoundOS";
            Icons[Icons["RoundOSK"] = 532] = "RoundOSK";
            Icons[Icons["RoundOX"] = 533] = "RoundOX";
            Icons[Icons["RoundOXK"] = 534] = "RoundOXK";
            Icons[Icons["RoundOK"] = 535] = "RoundOK";
            Icons[Icons["EyeHide"] = 536] = "EyeHide";
            Icons[Icons["EMRestore"] = 537] = "EMRestore";
            Icons[Icons["EMCircleDollarLight"] = 538] = "EMCircleDollarLight";
            Icons[Icons["EMSearchReport"] = 539] = "EMSearchReport";
            Icons[Icons["ArrowLeftThin"] = 540] = "ArrowLeftThin";
            Icons[Icons["Bottle"] = 541] = "Bottle";
            Icons[Icons["Goblet"] = 542] = "Goblet";
            Icons[Icons["Cocktails"] = 543] = "Cocktails";
            Icons[Icons["PaymentApplied"] = 544] = "PaymentApplied";
            Icons[Icons["PaymentCollected"] = 545] = "PaymentCollected";
            Icons[Icons["FileSent"] = 546] = "FileSent";
            Icons[Icons["FileReceived"] = 547] = "FileReceived";
            Icons[Icons["DotsPlusBold"] = 548] = "DotsPlusBold";
            Icons[Icons["BottleLight"] = 549] = "BottleLight";
            Icons[Icons["Connect"] = 550] = "Connect";
            Icons[Icons["PackRetail"] = 551] = "PackRetail";
            Icons[Icons["SingleWholeSale"] = 552] = "SingleWholeSale";
            Icons[Icons["PackWholeSale"] = 553] = "PackWholeSale";
            Icons[Icons["Stars"] = 554] = "Stars";
            Icons[Icons["DeliveryAdd"] = 555] = "DeliveryAdd";
            Icons[Icons["Split"] = 556] = "Split";
            Icons[Icons["Reproof"] = 557] = "Reproof";
            Icons[Icons["DBSync"] = 558] = "DBSync";
            Icons[Icons["Blocks"] = 559] = "Blocks";
            Icons[Icons["Layout"] = 562] = "Layout";
            Icons[Icons["DragVertical"] = 563] = "DragVertical";
            Icons[Icons["Filter"] = 564] = "Filter";
            Icons[Icons["Diamond"] = 565] = "Diamond";
            Icons[Icons["At"] = 566] = "At";
            Icons[Icons["ProductReturn"] = 567] = "ProductReturn";
            Icons[Icons["BrewHouse"] = 568] = "BrewHouse";
            Icons[Icons["ArrowUp"] = 569] = "ArrowUp";
            Icons[Icons["ArrowDown"] = 570] = "ArrowDown";
            Icons[Icons["ArrowUpRight"] = 571] = "ArrowUpRight";
            Icons[Icons["ArrowDownRight"] = 572] = "ArrowDownRight";
            Icons[Icons["ArrowLeft"] = 573] = "ArrowLeft";
            Icons[Icons["ArrowRight"] = 574] = "ArrowRight";
            Icons[Icons["Fermenter"] = 575] = "Fermenter";
            Icons[Icons["LostSales"] = 576] = "LostSales";
            Icons[Icons["GeographicSales"] = 577] = "GeographicSales";
            Icons[Icons["Abnormalities"] = 578] = "Abnormalities";
            Icons[Icons["Inventory"] = 579] = "Inventory";
            Icons[Icons["Security"] = 580] = "Security";
            Icons[Icons["BriteTank"] = 581] = "BriteTank";
            Icons[Icons["Trends"] = 582] = "Trends";
            Icons[Icons["Product"] = 583] = "Product";
            Icons[Icons["Weight"] = 584] = "Weight";
            Icons[Icons["YeastManagement"] = 586] = "YeastManagement";
            Icons[Icons["WiseSystems"] = 590] = "WiseSystems";
            Icons[Icons["WaterfallChart"] = 595] = "WaterfallChart";
            Icons[Icons["Brewery"] = 597] = "Brewery";
            Icons[Icons["AIHelp"] = 599] = "AIHelp";
            Icons[Icons["Spark"] = 600] = "Spark";
            Icons[Icons["CombinationChart"] = 601] = "CombinationChart";
            Icons[Icons["Company"] = 602] = "Company";
            Icons[Icons["NumberCard"] = 609] = "NumberCard";
            Icons[Icons["BubbleChart"] = 610] = "BubbleChart";
            Icons[Icons["BarChart"] = 611] = "BarChart";
            Icons[Icons["StackedAreaChart"] = 612] = "StackedAreaChart";
            Icons[Icons["StackedBarChart"] = 613] = "StackedBarChart";
            Icons[Icons["SankeyChart"] = 614] = "SankeyChart";
            Icons[Icons["Invoice"] = 617] = "Invoice";
            Icons[Icons["ISellBeer"] = 619] = "ISellBeer";
            Icons[Icons["Route"] = 620] = "Route";
            Icons[Icons["PaintBrush"] = 622] = "PaintBrush";
            Icons[Icons["Undo"] = 626] = "Undo";
            Icons[Icons["CircleDashed"] = 627] = "CircleDashed";
            Icons[Icons["CircleStar"] = 628] = "CircleStar";
            Icons[Icons["Lock"] = 629] = "Lock";
            Icons[Icons["CircleHalfDashed"] = 630] = "CircleHalfDashed";
            Icons[Icons["Shelves"] = 631] = "Shelves";
            Icons[Icons["Insight"] = 632] = "Insight";
            Icons[Icons["Swap"] = 633] = "Swap";
            Icons[Icons["Locationtiming"] = 634] = "Locationtiming";
            Icons[Icons["TagAdd"] = 635] = "TagAdd";
        })(Icons = HTML.Icons || (HTML.Icons = {}));
        let ButtonActionType;
        (function (ButtonActionType) {
            ButtonActionType[ButtonActionType["JSEvent"] = 1] = "JSEvent";
            ButtonActionType[ButtonActionType["Link"] = 2] = "Link";
            ButtonActionType[ButtonActionType["Submit"] = 3] = "Submit";
        })(ButtonActionType = HTML.ButtonActionType || (HTML.ButtonActionType = {}));
        let ControlType;
        (function (ControlType) {
            ControlType[ControlType["Calendar"] = 1] = "Calendar";
            ControlType[ControlType["Document"] = 4] = "Document";
            ControlType[ControlType["EWS"] = 6] = "EWS";
            ControlType[ControlType["FileExport"] = 7] = "FileExport";
            ControlType[ControlType["FileImport"] = 8] = "FileImport";
            ControlType[ControlType["Gridster"] = 9] = "Gridster";
            ControlType[ControlType["HtmlEdit"] = 10] = "HtmlEdit";
            ControlType[ControlType["JsonPath"] = 11] = "JsonPath";
            ControlType[ControlType["PrintPreview"] = 12] = "PrintPreview";
            ControlType[ControlType["QuickLink"] = 13] = "QuickLink";
            ControlType[ControlType["SavedReport"] = 16] = "SavedReport";
            ControlType[ControlType["SendMessage"] = 17] = "SendMessage";
            ControlType[ControlType["Slides"] = 18] = "Slides";
            ControlType[ControlType["Table"] = 19] = "Table";
        })(ControlType = HTML.ControlType || (HTML.ControlType = {}));
        let IRefFieldSortOrder;
        (function (IRefFieldSortOrder) {
            IRefFieldSortOrder[IRefFieldSortOrder["ASC"] = 1] = "ASC";
            IRefFieldSortOrder[IRefFieldSortOrder["DESC"] = 2] = "DESC";
        })(IRefFieldSortOrder = HTML.IRefFieldSortOrder || (HTML.IRefFieldSortOrder = {}));
        let TabActionType;
        (function (TabActionType) {
            TabActionType[TabActionType["JSEvent"] = 1] = "JSEvent";
            TabActionType[TabActionType["Link"] = 2] = "Link";
        })(TabActionType = HTML.TabActionType || (HTML.TabActionType = {}));
        function FillWithAutoComplete(Container, AutoCompleteOptions, APIToken, EncompassID, OnChangeCallback) {
            console.warn('ECP.HTML.FillWithAutoComplete() is deprecated, please Use the <ecp-auto-complete> component directly instead, found in the design system');
            return new Promise((resolve, reject) => {
                this.AutoComplete(AutoCompleteOptions, APIToken, EncompassID)
                    .then((AutoCompleteHTML) => {
                    Container.innerHTML = AutoCompleteHTML;
                    const textInput = Container.querySelector("input[type='text']");
                    textInput.autocomplete = "off";
                    resolve(new AjaxInput(textInput, APIToken, EncompassID, OnChangeCallback).hidden);
                }).catch((error) => { reject(error); });
            });
        }
        HTML.FillWithAutoComplete = FillWithAutoComplete;
        const validAutoCompleteProperties = ["InputName", "RefTable", "RefField", "DataType", "RefFieldDisplay", "RefFieldDisplayDataType",
            "Width", "CurValue", "CurDisplayValue", "RefFieldFilter", "RefFieldSortOrder", "Required", "LimitToRefList", "IsSearch",
            "Translate", "TabIndex", "RandomID", "ListLength", "AllowAddRelated", "LookupUrl", "ValuesArr", "DisableNotIn", "Placeholder"];
        function validateAutoCompleteObject(AutoCompleteOptions) {
            if (!AutoCompleteOptions.RefFieldSortOrder) {
                AutoCompleteOptions.RefFieldSortOrder = IRefFieldSortOrder.ASC;
            }
            if (!AutoCompleteOptions.RandomID && AutoCompleteOptions.InputName.indexOf(" ") !== -1) {
                throw new Error("Invalid AjaxInput Name, must not contain spaces.");
            }
            if (!EC_Fmt.isNull(AutoCompleteOptions.CurDisplayValue) && EC_Fmt.isNull(AutoCompleteOptions.CurValue)) {
                throw new Error("Invalid AjaxInput, cannot use CurDisplayValue if CurValue is empty.");
            }
            for (const propName in AutoCompleteOptions) {
                if (validAutoCompleteProperties.indexOf(propName) != -1) {
                    if (propName == "DataType" || propName == "RefFieldDisplayDataType") {
                        AutoCompleteOptions[propName] = ECP.DataType[AutoCompleteOptions[propName]];
                    }
                }
                else {
                    delete AutoCompleteOptions[propName];
                }
            }
            if (AutoCompleteOptions.AllowAddRelated && !AutoCompleteOptions.IsSearch) {
                EC_Fmt.LoadScript("Controls/Table.js");
            }
        }
        function AutoComplete_Bulk(AutoCompleteOptionArr, APIToken, EncompassID, HTMLAPICommandOverride) {
            return new Promise((resolve, reject) => {
                if (AutoCompleteOptionArr.length === 0) {
                    throw new Error("AutoCompleteOptionArr cannot be empty.");
                }
                const AutoCompleteRequest = new ECP.EC_Request("UI_AutoCompleteFieldHTML_Bulk");
                AutoCompleteRequest.SetReturnType(ECP.EC_ReturnType.Json);
                if (!EC_Fmt.isNull(APIToken)) {
                    AutoCompleteRequest.SetAPIToken(APIToken);
                    let Distributor;
                    EncompassID = EC_Fmt.NullChk(EncompassID, Distributor);
                    AutoCompleteRequest.SetEncompassID(EncompassID);
                }
                const autoCompleteOptionsObject = { "AutoCompleteOptionArr": AutoCompleteOptionArr };
                AutoCompleteRequest.AddJSON(JSON.stringify(autoCompleteOptionsObject));
                AutoCompleteRequest.Submit().then((jsonText) => {
                    for (let i = 0; i < AutoCompleteOptionArr.length; i++) {
                        const Placeholder = AutoCompleteOptionArr[i].Placeholder;
                        if (!EC_Fmt.isNull(Placeholder)) {
                            jsonText["AutoCompleteHTMLArr"][i] = jsonText["AutoCompleteHTMLArr"][i].replace("input type=text", `input type=text placeholder="${Placeholder}"`);
                        }
                    }
                    resolve(jsonText);
                }).catch((error) => {
                    reject(error);
                });
            });
        }
        let RequestAutoCompleteHTMLTimeoutId = null;
        const PendingAutoCompleteOptionsArr = [];
        function AutoComplete(AutoCompleteOptions, APIToken, EncompassID) {
            return new Promise((resolve, reject) => {
                if (EC_Fmt.isNull(AutoCompleteOptions.HTMLAPICommandOverride)) {
                    validateAutoCompleteObject(AutoCompleteOptions);
                    if (EC_Fmt.isNull(APIToken) || EC_Fmt.isNull(EncompassID)) {
                        PendingAutoCompleteOptionsArr.push({ options: AutoCompleteOptions, resolve, reject });
                        if (RequestAutoCompleteHTMLTimeoutId === null) {
                            RequestAutoCompleteHTMLTimeoutId = setTimeout(() => {
                                const tmpAutoCompleteOptionArr = [];
                                while (PendingAutoCompleteOptionsArr.length > 0) {
                                    const options = PendingAutoCompleteOptionsArr.pop();
                                    tmpAutoCompleteOptionArr.push(options);
                                }
                                RequestAutoCompleteHTMLTimeoutId = null;
                                AutoComplete_Bulk(tmpAutoCompleteOptionArr.map(x => x.options), APIToken, EncompassID).then((jsonResults) => {
                                    for (let i = 0; i < tmpAutoCompleteOptionArr.length; i++) {
                                        tmpAutoCompleteOptionArr[i].resolve(jsonResults["AutoCompleteHTMLArr"][i]);
                                    }
                                }).catch((error) => {
                                    for (let i = 0; i < tmpAutoCompleteOptionArr.length; i++) {
                                        tmpAutoCompleteOptionArr[i].reject(error);
                                    }
                                });
                            }, 50);
                        }
                    }
                    else {
                        AutoComplete_Bulk([AutoCompleteOptions], APIToken, EncompassID).then((jsonResults) => {
                            resolve(jsonResults["AutoCompleteHTMLArr"][0]);
                        }).catch((error) => {
                            reject(error);
                        });
                    }
                }
                else {
                    const AutoCompleteRequest = new ECP.EC_Request(AutoCompleteOptions.HTMLAPICommandOverride);
                    AutoCompleteRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    validateAutoCompleteObject(AutoCompleteOptions);
                    if (!EC_Fmt.isNull(APIToken)) {
                        AutoCompleteRequest.SetAPIToken(APIToken);
                        let Distributor;
                        EncompassID = EC_Fmt.NullChk(EncompassID, Distributor);
                        AutoCompleteRequest.SetEncompassID(EncompassID);
                    }
                    for (const propName in AutoCompleteOptions) {
                        if (propName !== "Placeholder") {
                            AutoCompleteRequest.AddRequestVariable(propName, AutoCompleteOptions[propName], ECP.EC_Verb.Post);
                        }
                    }
                    AutoCompleteRequest.Submit().then((text) => {
                        if (!EC_Fmt.isNull(AutoCompleteOptions.Placeholder)) {
                            text = text.replace("input type=text", `input type=text placeholder="${AutoCompleteOptions.Placeholder}"`);
                        }
                        resolve(text);
                    }).catch((error) => {
                        reject(error);
                    });
                }
            });
        }
        HTML.AutoComplete = AutoComplete;
        HTML.DefaultMIMETypes = {
            image: [".tiff", ".pjp", ".pjpeg", ".jfif", ".tif", ".gif", ".svg", ".bmp", ".png", ".jpeg", ".svgz", ".jpg", ".webp", ".ico", ".xbm", ".dib"],
            audio: [".opus", ".flac", ".webm", ".weba", ".wav", ".ogg", ".m4a", ".mp3", ".oga", ".mid", ".amr", ".aiff", ".wma", ".au", ".aac"],
            video: [".ogm", ".wmv", ".mpg", ".webm", ".ogv", ".mov", ".asx", ".mpeg", ".mp4", ".m4v", ".avi"],
            application: [".xls", ".xlsx", ".csv", ".docx", ".doc", ".patch", ".zip", ".crt", ".swl", ".xul", ".apk", ".js", ".rdf", ".ps", ".rss", ".p7s", ".woff", ".p7z", ".p7c", ".p7m", ".pdf", ".exe", ".bin", ".json", ".m3u8", ".epub", ".gz", ".tar", ".ai", ".com", ".cer", ".xhtml", ".tgz", ".xht", ".swf", ".xhtm", ".eps", ".crx", ".wasm"],
            text: [".xbl", ".xsl", ".text", ".xslt", ".txt", ".ehtml", ".sh", ".html", ".ics", ".mjs", ".js", ".shtml", ".xml", ".css", ".shtm", ".htm"]
        };
        function FileInput(InputID, FileUploadedCallback, InputAcceptTypes, ReplaceDocumentID, DocumentTypeID, AttachmentTable, AttachmentKeyValue, Description, width = 200, SubDir) {
            const dropArea = document.createElement("div");
            dropArea.classList.add("FileInput");
            dropArea.style.width = `${width}px`;
            dropArea.innerHTML = "<span class=FileInputContainer>"
                + "<span>"
                + `<input type=file id="${InputID}"name="${InputID}"multiple${InputAcceptTypes ? ` accept="${InputAcceptTypes}"` : ""}>`
                + "</span>"
                + "<input class=FileInputButton value=Browse type=button>"
                + "<input class=FileInputText type=text placeholder='or Drag and Drop'autocomplete=off>"
                + "</span><br>"
                + `<progress id=progress-bar style="display:none;width:${width}px;height:6px;border:var(--neutral-30) 1px solid;background:var(--bg);color:var(--primary-80);border-radius:0 0 4px 4px"max=100 value=0></progress>`;
            const progressBar = dropArea.querySelector("progress");
            let progressBarCSS = document.getElementById("FileUpload_progressBarCSS");
            if (!progressBarCSS) {
                progressBarCSS = document.createElement("style");
                progressBarCSS.textContent = "progress::-moz-progress-bar{background:var(--primary-80)} progress::-webkit-progress-bar{background:var(--bg)} progress::-webkit-progress-value{background:var(--primary-80)}";
                document.head.appendChild(progressBarCSS);
            }
            const highlight = (event) => {
                event.preventDefault();
                event.stopPropagation();
                event.currentTarget.style.borderColor = "var(--primary-80)";
                event.currentTarget.style.borderWidth = "2px";
            };
            dropArea.addEventListener("dragenter", highlight, false);
            dropArea.addEventListener("dragover", highlight, false);
            const removeHighlight = (event) => {
                event.preventDefault();
                event.stopPropagation();
                event.currentTarget.style.borderColor = "#ccc";
                event.currentTarget.style.borderWidth = "1px";
            };
            dropArea.addEventListener("dragleave", removeHighlight, false);
            dropArea.addEventListener("drop", removeHighlight, false);
            function uploadFiles(files) {
                progressBar.value = 0;
                progressBar.style.display = "block";
                const displayFileNames = [];
                for (let j = 0; j < files.length; j++) {
                    displayFileNames.push(files[j].name);
                }
                const FileInputText = dropArea.querySelector("input.FileInputText");
                FileInputText.value = displayFileNames.toString();
                const uploadProgress = [];
                for (let i = files.length; i > 0; i--) {
                    uploadProgress.push(0);
                }
                function updateProgress(fileNumber, percent) {
                    uploadProgress[fileNumber] = percent;
                    const total = uploadProgress.reduce((tot, curr) => tot + curr, 0) / uploadProgress.length;
                    progressBar.value = total;
                }
                ;
                let UploadURL = "api?APICommand=SalesComm_UploadDocument";
                if (EC_Fmt.isInteger(ReplaceDocumentID)) {
                    UploadURL += "&DocumentID=" + ReplaceDocumentID;
                }
                if (EC_Fmt.isInteger(DocumentTypeID)) {
                    UploadURL += "&DocumentTypeID=" + DocumentTypeID;
                }
                if (!EC_Fmt.isNull(Description)) {
                    UploadURL += "&Description=" + encodeURIComponent(Description);
                }
                if (!EC_Fmt.isNull(SubDir)) {
                    if (SubDir.substring(0, 2) !== "S3") {
                        SubDir = "S3" + SubDir;
                    }
                    UploadURL += "&SubDir=" + encodeURIComponent(SubDir);
                }
                if (!EC_Fmt.isNull(AttachmentTable) && !EC_Fmt.isNull(AttachmentKeyValue)) {
                    UploadURL += "&AttachmentTable=" + encodeURIComponent(AttachmentTable) + "&AttachmentKeyValue=" + encodeURIComponent(AttachmentKeyValue);
                }
                else if (!EC_Fmt.isNull(AttachmentTable) || !EC_Fmt.isNull(AttachmentKeyValue)) {
                    throw Error("Both AttachmentTable and AttachmentKeyValue must be provided at the same time");
                }
                function UploadFile(file, i) {
                    gtag("event", "uploadFile", { file: file });
                    return new Promise(((resolve, reject) => {
                        const xhr = new XMLHttpRequest();
                        xhr.open("POST", UploadURL, true);
                        xhr.upload.addEventListener("progress", (e) => {
                            updateProgress(i, (e.loaded * 100.0 / e.total) || 100);
                        });
                        xhr.onload = () => {
                            if (xhr.status >= 200 && xhr.status < 300) {
                                resolve(xhr.responseText);
                            }
                            else {
                                reject(xhr.statusText);
                            }
                        };
                        xhr.onerror = () => {
                            reject(xhr.statusText + ": " + xhr.responseText);
                        };
                        const formData = new FormData();
                        formData.append("file", file);
                        xhr.send(formData);
                    }));
                }
                (async function () {
                    const returnDocumentsArr = [];
                    for (let i = 0; i < files.length; i++) {
                        returnDocumentsArr.push(JSON.parse(await UploadFile(files[i], i)));
                    }
                    FileInputText.value = "Uploaded";
                    FileUploadedCallback(returnDocumentsArr);
                }());
            }
            const fileInput = dropArea.querySelector("input[type=file]");
            const UpdateFileInputDisplay = (files) => {
                const FileInputText = dropArea.querySelector("input.FileInputText");
                let filesString = "";
                if (files) {
                    for (let i = 0; i < files.length; i++) {
                        if (i !== 0) {
                            filesString += ", ";
                        }
                        filesString += files[i].name;
                    }
                }
                FileInputText.value = filesString;
                progressBar.value = 0;
                progressBar.style.display = "none";
            };
            dropArea.addEventListener("drop", (event) => {
                let AllValidFileTypes = false;
                const files = event.dataTransfer.files;
                if (InputAcceptTypes) {
                    const acceptedTypes = InputAcceptTypes.toLowerCase().split(",");
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        const fileType = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                        AllValidFileTypes = false;
                        for (let j = 0; j < acceptedTypes.length; j++) {
                            const acceptedType = acceptedTypes[j];
                            if (acceptedType.startsWith(".")) {
                                if (fileType === acceptedType) {
                                    AllValidFileTypes = true;
                                }
                            }
                            else if (acceptedType.split("/").length === 2) {
                                const [MIMEType, MIMESubtype] = acceptedType.split("/");
                                const DefaultMIMETypeKeys = Object.keys(HTML.DefaultMIMETypes);
                                for (let k = 0; k < DefaultMIMETypeKeys.length; k++) {
                                    const key = DefaultMIMETypeKeys[k];
                                    if (MIMEType === key) {
                                        if (MIMESubtype === "*") {
                                            if (HTML.DefaultMIMETypes[key].includes(fileType)) {
                                                AllValidFileTypes = true;
                                            }
                                        }
                                        else if ("." + MIMESubtype === fileType) {
                                            AllValidFileTypes = true;
                                        }
                                        break;
                                    }
                                }
                            }
                            if (AllValidFileTypes) {
                                break;
                            }
                        }
                        if (!AllValidFileTypes) {
                            break;
                        }
                    }
                }
                else {
                    AllValidFileTypes = true;
                }
                if (AllValidFileTypes) {
                    if (!EC_Fmt.isNull(FileUploadedCallback)) {
                        uploadFiles(files);
                    }
                    else {
                        fileInput.files = files;
                        UpdateFileInputDisplay(fileInput.files);
                    }
                    return true;
                }
                else {
                    ECP.Dialog.Alert("Invalid File Type, only accepts " + EC_Fmt.ReplaceAll(InputAcceptTypes, ",", ", "));
                    return false;
                }
            }, false);
            fileInput.addEventListener("click", (event) => {
                UpdateFileInputDisplay(null);
                event.currentTarget.value = null;
            });
            fileInput.addEventListener("change", (event) => {
                if (!EC_Fmt.isNull(FileUploadedCallback)) {
                    uploadFiles(event.currentTarget.files);
                }
                else {
                    UpdateFileInputDisplay(event.currentTarget.files);
                }
            });
            return dropArea;
        }
        HTML.FileInput = FileInput;
        function Button(ButtonID, Title, Icon, ActionType, Action) {
            console.warn('ECP.HTML.Button() is deprecated, please use <ecp-btn> from the component library instead');
            let htmlB = `<ecp-btn id=ActionButton${ButtonID}`;
            if (Action) {
                switch (ActionType) {
                    case ButtonActionType.JSEvent:
                        htmlB += ` onclick="${Action}"`;
                        break;
                    case ButtonActionType.Link:
                        htmlB += ` href="${Action}"`;
                        break;
                }
            }
            if (Icon != Icons.None) {
                htmlB += ` icon=ews-icon-${Icons[Icon].toLowerCase()}`;
            }
            htmlB += `>${Title}</ecp-btn>`;
            return htmlB;
        }
        HTML.Button = Button;
        function CheckboxSelect(FieldName, CurrentValues, Values, width, height, Sortable) {
            EC_Fmt.LoadScript("includes/SelectInput_INC.js");
            if (!Sortable && Sortable !== false) {
                Sortable = true;
            }
            if (!document.getElementById("checkboxSelectStyle")) {
                const DialogStyle = document.createElement("style");
                DialogStyle.id = "checkboxSelectStyle";
                DialogStyle.textContent = ".ecp-checkbox-select,.dashboard-item .content .ecp-checkbox-select{display:inline-flex;flex-direction:column}"
                    + ".ecp-checkbox-select .CheckboxSelect,.dashboard-item .content .ecp-checkbox-select .CheckboxSelect{flex:auto}"
                    + ".ecp-checkbox-select .CheckboxSelect ul,.dashboard-item .content .ecp-checkbox-select .CheckboxSelect ul{margin:0;padding:0}"
                    + ".ecp-checkbox-select .CheckboxSelect ul li,.dashboard-item .content .ecp-checkbox-select .CheckboxSelect ul li{list-style-type:none}"
                    + ".ecp-checkbox-select .CheckboxSelect ul li.SortableSelectStateHighlight,.dashboard-item .content .ecp-checkbox-select .CheckboxSelect ul li.SortableSelectStateHighlight{border:1px dashed var(--neutral-120)}";
                document.head.appendChild(DialogStyle);
            }
            const currentValues = (CurrentValues || "").split("^");
            const values = (Values || "").split("^");
            let selectedItems = [];
            const itemArr = [];
            for (let i = 0, len = values.length; i < len; i++) {
                const [value, text] = values[i].split("|");
                const currentValueIndex = currentValues.indexOf(value);
                if (currentValueIndex > -1) {
                    if (Sortable) {
                        selectedItems[currentValueIndex] = { value, text };
                    }
                    else {
                        selectedItems.push({ value, text });
                    }
                }
                else {
                    itemArr.push({ value, text });
                }
            }
            if (selectedItems.length > 0) {
                if (Sortable) {
                    selectedItems = selectedItems.filter((item) => {
                        return item !== null;
                    });
                }
                itemArr.splice(0, 0, ...selectedItems);
            }
            let htmlB = `<div id="Select${FieldName}Div"class="CheckboxSelect${Sortable ? " SortableSelect" : ""}"style=width:${width ? width : 220}px;height:${height ? height : 319}px>`
                + `<div style="padding:2px 5px">`
                + `<a href="javascript:SortableSelect_SelectToggle(true,'${FieldName}')">Select All</a>`
                + " | "
                + `<a href="javascript:SortableSelect_SelectToggle(false,'${FieldName}')">Clear</a>`
                + "</div>"
                + "<ul style=position:relative>";
            for (let i = 0, len = itemArr.length; i < len; i++) {
                const item = itemArr[i];
                const isSelect = currentValues.indexOf(item.value) > -1;
                htmlB += `<li onclick="SortableSelect_SelectItem(!document.getElementById('Select${FieldName}Checkbox${i}').checked,event,'${FieldName}',${i});">`
                    + `<div id="Select${FieldName}Item${i}"class="AutocompleteItem${Sortable ? " SortableSelectItem" : ""}${isSelect ? " Highlight" : ""}">`
                    + "<table class=NoPadding>"
                    + "<tr>"
                    + `<td style=padding:0>`
                    + `<input id="Select${FieldName}Checkbox${i}"style=margin-top:3px!important index=${i} name="${FieldName}"value="${item.value}"onclick="SortableSelect_SelectItem(this.checked,event,'${FieldName}',${i})"${isSelect ? " checked" : ""} type=checkbox>`
                    + "</td>"
                    + `<td class=Handle style=padding:0>${item.text}</td>`
                    + "</tr></table></div></li>";
            }
            htmlB += "</ul></div>";
            const checkboxSelect = document.createElement("div");
            checkboxSelect.classList.add("ecp-checkbox-select");
            checkboxSelect.innerHTML = htmlB;
            if (Sortable) {
                const checkboxSelectArr = checkboxSelect.querySelectorAll(".CheckboxSelect");
                for (let i = 0, len = checkboxSelectArr.length; i < len; i++) {
                    const checkboxElement = checkboxSelectArr[i];
                    checkboxElement.addEventListener("mouseover", () => {
                        document.body.style.userSelect = "none";
                    });
                    checkboxElement.addEventListener("mouseout", () => {
                        document.body.style.userSelect = "";
                    });
                }
                const sortableSelectArr = checkboxSelect.querySelectorAll(".SortableSelect");
                for (let i = 0, len = sortableSelectArr.length; i < len; i++) {
                    const sortableUl = sortableSelectArr[i].querySelector("ul");
                    if (sortableUl.hasChildNodes()) {
                        ECP.Tools.Sortable.Create(sortableUl, {
                            ItemSelector: "li",
                            PlaceholderClass: "SortableSelectStateHighlight",
                            Axis: "y"
                        });
                    }
                }
            }
            return checkboxSelect;
        }
        HTML.CheckboxSelect = CheckboxSelect;
        function MultipleSelectArr(FieldName, Size, Options, Values) {
            const Selectable = Options.split("^");
            let html = "<div class=\"SelectField MultiSelect\">"
                + `<select name=${FieldName} id=${FieldName} multiple size=${Size}>`;
            let SortSelectedValuesToTop = false;
            let startK = 1;
            const valueSelected = !!Values && Values.length > 0;
            if (valueSelected && Selectable.length > Size) {
                SortSelectedValuesToTop = true;
                startK = 0;
            }
            for (let k = startK; k <= 1; k++) {
                for (let i = 0; i < Selectable.length; i++) {
                    let [value, text] = Selectable[i].split("|");
                    if (!text) {
                        text = "";
                    }
                    let Selected = false;
                    if (valueSelected) {
                        Selected = Values.indexOf(value) >= 0;
                    }
                    const SortToTop = Selected || text === "";
                    if (!SortSelectedValuesToTop || (k === 0 && SortToTop) || (k === 1 && !SortToTop)) {
                        if (Selected) {
                            html += `<option value="${value}"selected>${text}</option>`;
                        }
                        else {
                            html += `<option value="${value}">${text}</option>`;
                        }
                    }
                }
            }
            html += "</select></div>";
            return html;
        }
        HTML.MultipleSelectArr = MultipleSelectArr;
        function TabBar(Tabs, CurrentTabID, CurrentTabClass = "", ContainerClass = "") {
            let html = `<div class="ContentTabs clear-fix ${ContainerClass}">`;
            CurrentTabID = EC_Fmt.ReplaceAll(CurrentTabID, " ", "");
            CurrentTabClass = CurrentTabClass ? ` ${CurrentTabClass}` : "";
            for (let i = 0; i < Tabs.length; i++) {
                const Tab = Tabs[i];
                if (!Tab.Action) {
                    Tab.Action = "javascript:void(0);";
                }
                html += (Tab.ActionType === TabActionType.JSEvent ? `<div onclick="${Tab.Action}"` : `<a href="${Tab.Action}"`)
                    + `class="PageTab motion-fast${CurrentTabID === Tab.TabID ? `${CurrentTabClass} Active` : ""}"id=Tab${Tab.TabID}>`
                    + `<div class="InnerTab motion-fast">${Tab.Name}</div>`
                    + (Tab.ActionType === TabActionType.JSEvent ? "</div>" : "</a>");
            }
            html += "</div>";
            return html;
        }
        HTML.TabBar = TabBar;
        function ToolTip(Container, TargetEl, Title, Placement, Width) {
            Container.classList.remove("hidden");
            Container.innerHTML = `<div class=tooltip-container>${TargetEl}<div position="${Placement}"class=tooltip-description>${Title}</div></div>`;
            Container.addEventListener("mouseover", () => {
                requestAnimationFrame(() => {
                    const containerRect = Container.getBoundingClientRect();
                    const tipEle = Container.querySelector(".tooltip-container");
                    const targetDiv = Container.querySelector(".tooltip-description");
                    let position = targetDiv.getAttribute("position");
                    const pNode = Container.parentNode;
                    if (!position) {
                        position = "bottom";
                    }
                    if (position === "left") {
                        if (containerRect.left < 222) {
                            position = "right";
                        }
                    }
                    else if (position === "top") {
                        if ((containerRect.top - 60) < targetDiv.offsetHeight) {
                            position = "bottom";
                        }
                    }
                    else if (position === "bottom") {
                        if (window.innerHeight - containerRect.bottom < 100) {
                            position = "top";
                        }
                    }
                    else if (position === "right") {
                        if (targetDiv.offsetWidth > (window.innerWidth - containerRect.left - tipEle.offsetWidth - 4)) {
                            position = "left";
                        }
                    }
                    const len = textSize("13px", Title);
                    if (position === "left") {
                        if (Width) {
                            targetDiv.style.left = `${containerRect.left - Width - 10}px`;
                        }
                        else if (len > 200) {
                            targetDiv.style.left = `${containerRect.left - 210}px`;
                        }
                        else {
                            targetDiv.style.left = `${containerRect.left - len - 40}px`;
                        }
                        if (targetDiv.offsetWidth > containerRect.left && (targetDiv.offsetWidth > (window.innerWidth - containerRect.width - containerRect.left))) {
                            position = "bottom";
                            targetDiv.style.width = "210px";
                            return;
                        }
                        else {
                            targetDiv.style.top = `${containerRect.top}px`;
                        }
                    }
                    if (position === "top") {
                        targetDiv.style.top = `${containerRect.top - tipEle.offsetHeight - 16}px`;
                        targetDiv.style.left = `${containerRect.left}px`;
                    }
                    if (position === "bottom") {
                        targetDiv.style.top = `${containerRect.top + tipEle.offsetHeight}px`;
                        targetDiv.style.left = `${containerRect.left}px`;
                    }
                    if (position === "right") {
                        targetDiv.style.top = `${containerRect.top}px`;
                        targetDiv.style.left = `${tipEle.getBoundingClientRect().left + tipEle.offsetWidth}px`;
                    }
                    if (Width) {
                        targetDiv.style.width = `${Width}px`;
                    }
                    else if (len > 200) {
                        if (position === "top" || position === "bottom") {
                            if (pNode.clientWidth) {
                                targetDiv.style.maxWidth = pNode.clientWidth + "px";
                            }
                        }
                        else {
                            targetDiv.style.maxWidth = "200px";
                        }
                    }
                    if (position === "top" || position === "bottom") {
                        if (containerRect.left > pNode.clientWidth / 2) {
                            targetDiv.classList.add("tooltip-description-center");
                        }
                    }
                });
            });
        }
        HTML.ToolTip = ToolTip;
        function textSize(fontSize, text) {
            const span = document.createElement("span");
            const reWidth = span.offsetWidth;
            span.style.visibility = "hidden";
            span.style.fontSize = fontSize;
            span.style.display = "inline-block";
            document.body.appendChild(span);
            if (typeof span.textContent !== "undefined") {
                span.textContent = text;
            }
            else {
                span.innerText = text;
            }
            const width = parseFloat(window.getComputedStyle(span).width) - reWidth;
            document.body.removeChild(span);
            return width;
        }
        function Snackbar(Title, Type = "Info", Description = "", Action = null, AutoDismiss = true) {
            Type = Type.trim().toLowerCase();
            const validTypes = ["success", "error", "warning", "info"];
            if (!validTypes.includes(Type)) {
                Type = "info";
                console.warn(`Invalid Snackbar type: ${Type}. Defaulting to "info".`);
            }
            const iconMap = {
                success: "ews-icon-emcheckbold",
                error: "ews-icon-emerrorbold",
                warning: "ews-icon-warning",
                info: "ews-icon-info"
            };
            const icon = iconMap[Type];
            const snackbarId = `snackbar-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
            const snackbarDiv = document.createElement("div");
            snackbarDiv.id = snackbarId;
            snackbarDiv.className = `ecp-snackbar animation-appear-from-bottom ecp-snackbar-${Type}`;
            const actionHTML = Action ? `<div class="ecp-snackbar-actionwrap">${Action.outerHTML}</div>` : "";
            snackbarDiv.innerHTML = `
            <i class="ecp-body ecp-snackbar-icon ${icon}"></i>
            <div class="ecp-snackbar-content">
                <h4>${Title}</h4>
                ${Description ? `<p>${Description}</p>` : ""}
                ${actionHTML}
            </div>
            <ecp-btn class="ecp-snackbar-icon-close" type="ghost" icon="ews-icon-close"></ecp-btn>
            `;
            document.body.appendChild(snackbarDiv);
            positionSnackbar(snackbarDiv);
            setupEventListeners(snackbarDiv, AutoDismiss);
            logSnackbarEvent(Title, Type, Description, Action, AutoDismiss);
            return {
                id: snackbarId,
                element: snackbarDiv,
                dismiss: () => dismissSnackbar(snackbarId)
            };
        }
        HTML.Snackbar = Snackbar;
        const SNACKBAR_BASE_TOP = 95;
        const SNACKBAR_BASE_BOTTOM = 20;
        function positionSnackbar(snackbarDiv) {
            requestAnimationFrame(() => {
                const allSnackbars = Array.from(document.querySelectorAll(".ecp-snackbar"));
                const currentIndex = allSnackbars.indexOf(snackbarDiv);
                const isMobile = EC_Fmt.isMobile;
                let offset = 0;
                for (let i = 0; i < currentIndex; i++) {
                    offset += allSnackbars[i].offsetHeight + 10;
                }
                if (isMobile) {
                    snackbarDiv.style.bottom = `${SNACKBAR_BASE_BOTTOM}px`;
                    snackbarDiv.style.left = "15px";
                    snackbarDiv.style.right = "15px";
                    snackbarDiv.style.margin = "0 auto";
                    snackbarDiv.style.transform = `translateY(${-offset}px)`;
                }
                else {
                    snackbarDiv.style.top = `${SNACKBAR_BASE_TOP}px`;
                    snackbarDiv.style.transform = `translateY(${offset}px)`;
                }
                snackbarDiv.classList.add("animate_active");
            });
        }
        function setupEventListeners(snackbarDiv, autoDismiss) {
            const closeButton = snackbarDiv.querySelector(".ecp-snackbar-icon-close");
            closeButton?.addEventListener("click", () => {
                dismissSnackbar(snackbarDiv.id);
            });
            if (autoDismiss) {
                const dismissTime = 4700;
                const removeTime = 5000;
                const dismissTimer = setTimeout(() => {
                    snackbarDiv.classList.add("animation-scale-out");
                }, dismissTime);
                const removeTimer = setTimeout(() => {
                    dismissSnackbar(snackbarDiv.id);
                }, removeTime);
                snackbarDiv.addEventListener("mouseenter", () => {
                    clearTimeout(dismissTimer);
                    clearTimeout(removeTimer);
                });
                snackbarDiv.addEventListener("mouseleave", () => {
                    if (autoDismiss) {
                        const remainingTime = dismissTime - (Date.now() - parseInt(snackbarDiv.dataset.createdAt || "0"));
                        if (remainingTime > 0) {
                            setTimeout(() => {
                                snackbarDiv.classList.add("animation-disappear-to-top");
                            }, remainingTime);
                            setTimeout(() => dismissSnackbar(snackbarDiv.id), remainingTime + 300);
                        }
                    }
                });
                snackbarDiv.dataset.createdAt = Date.now().toString();
            }
        }
        function dismissSnackbar(snackbarId) {
            const snackbar = document.getElementById(snackbarId);
            if (!snackbar)
                return;
            const allVisibleSnackbars = Array.from(document.querySelectorAll('.ecp-snackbar:not(.animation-disappear-to-top)'));
            snackbar.classList.add("animation-disappear-to-top");
            const onAnimationEnd = () => {
                snackbar.removeEventListener("animationend", onAnimationEnd);
                if (document.body.contains(snackbar)) {
                    document.body.removeChild(snackbar);
                }
                repositionRemainingSnackbars(allVisibleSnackbars, snackbar);
            };
            snackbar.addEventListener("animationend", onAnimationEnd);
            setTimeout(() => {
                if (document.body.contains(snackbar)) {
                    snackbar.removeEventListener("animationend", onAnimationEnd);
                    document.body.removeChild(snackbar);
                    repositionRemainingSnackbars(allVisibleSnackbars, snackbar);
                }
            }, 1000);
        }
        function repositionRemainingSnackbars(allSnackbars, removedSnackbar) {
            const remainingSnackbars = allSnackbars.filter(sb => sb !== removedSnackbar);
            const isMobile = EC_Fmt.isMobile;
            const direction = isMobile ? -1 : 1;
            let offset = 0;
            remainingSnackbars.forEach((snackbar) => {
                snackbar.style.transform = `translateY(${direction * offset}px)`;
                offset += snackbar.offsetHeight + 10;
            });
        }
        function logSnackbarEvent(Title, Type, Description, Action, AutoDismiss) {
            if (typeof gtag === "function") {
                gtag("event", "snackbarDisplayed", {
                    Title,
                    Type,
                    Description,
                    Action: Action?.outerHTML || null,
                    AutoDismiss
                });
            }
        }
        class AjaxInput {
            constructor(input, APIToken, EncompassID, OnChangeCallback) {
                this.LookupUrl = "api?APICommand=AjaxLookup";
                this.APIToken = "";
                this.EncompassID = "";
                this.OnChangeCallback = undefined;
                this.SearchOperator = "";
                this.SelectedIndex = -1;
                this.MobileDialog = undefined;
                this.MobileInput = undefined;
                this.SelectedStatus = false;
                this.isCloseResults = false;
                this.HasCustomLookupUrl = false;
                this.aborted = false;
                this.NOT_SearchOn = false;
                this.isInternalUpdating = false;
                this.isCtrl = false;
                this.GetResultFromServer_Callback = (me, SelectedValues, SearchStr, Offset) => {
                    me.AbortRunningAjaxCall();
                    me.aborted = false;
                    const Selected = SelectedValues.join("^");
                    const RequestQueryString = `AjaxCacheID=${me.AjaxCacheID}&SearchStr=${encodeURIComponent(SearchStr)}&Selected=${encodeURIComponent(Selected)}&FieldID=${encodeURIComponent(me.FieldID)}&Offset=${Offset}`;
                    const LookupUrlParameters = EC_Fmt.GetURLParameters(me.LookupUrl);
                    const myRequest = new ECP.EC_Request(LookupUrlParameters.APICommand);
                    const ParameterKeyArr = Object.keys(LookupUrlParameters);
                    me.CurrentRequest = myRequest;
                    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
                    for (let i = 0; i < ParameterKeyArr.length; i++) {
                        const Key = ParameterKeyArr[i];
                        if (Key.toLowerCase() === "apitoken") {
                            myRequest.SetAPIToken(LookupUrlParameters[Key]);
                        }
                        else if (Key.toLowerCase() === "encompassid") {
                            myRequest.SetEncompassID(LookupUrlParameters[Key]);
                        }
                        else if (Key.toLowerCase() !== "apicommand") {
                            myRequest.AddRequestVariable(Key, LookupUrlParameters[Key]);
                        }
                    }
                    if (`${me.LookupUrl}&${RequestQueryString}`.length < 2000) {
                        myRequest.QueryString = RequestQueryString;
                    }
                    else {
                        myRequest.AddRequestVariable("AjaxCacheID", me.AjaxCacheID);
                        myRequest.AddRequestVariable("SearchStrPost", SearchStr, ECP.EC_Verb.Post);
                        myRequest.AddRequestVariable("SelectedPost", Selected, ECP.EC_Verb.Post);
                        myRequest.AddRequestVariable("FieldIDPost", me.FieldID, ECP.EC_Verb.Post);
                        myRequest.AddRequestVariable("OffsetPost", Offset.toString(), ECP.EC_Verb.Post);
                    }
                    const StartTime = new Date();
                    let LoadingTimeout;
                    const AppendToList = (Offset > 0);
                    if (!AppendToList) {
                        LoadingTimeout = setTimeout(() => {
                            LoadingTimeout = null;
                            me.ShowResults("<div class=AutocompleteItem id=LoadingTimeout onclick='AllowHideAllDivs=false'>Searching...</div>", SearchStr, [], false);
                        }, 300);
                    }
                    myRequest.SubmitAPIRequest().then((Data) => {
                        if (LoadingTimeout) {
                            clearTimeout(LoadingTimeout);
                            me.ShowResults(Data, SearchStr, SelectedValues, AppendToList);
                        }
                        else {
                            const EndTime = new Date();
                            if ((EndTime.getTime() - StartTime.getTime()) < 800) {
                                setTimeout(() => {
                                    me.ShowResults(Data, SearchStr, SelectedValues, AppendToList);
                                }, 500);
                            }
                            else {
                                me.ShowResults(Data, SearchStr, SelectedValues, AppendToList);
                            }
                        }
                    }).catch(() => {
                        clearTimeout(LoadingTimeout);
                    });
                    gtag("event", "ajaxSearch", { fieldID: me.FieldID, search: SearchStr, Offset: Offset });
                };
                this.input = input;
                this.hidden = input.previousSibling;
                this.FieldID = input.closest("section").getAttribute("FieldID");
                if (input.closest("table")) {
                    this.Results = input.closest("table").nextSibling;
                }
                else {
                    this.hidden = input.closest("section").querySelector("input[type='hidden']");
                    this.Results = input.closest("section").querySelector("#" + EC_Fmt.CssEscape(this.FieldID) + "_Results");
                }
                if (!this.input || !this.hidden || !this.Results || !this.FieldID) {
                    throw new Error("Invalid AjaxInput setup, unable to create the javascript object");
                }
                this.Results.addEventListener("animationend", () => {
                    if (this.Results.classList.contains("animation-disappear-to-top") || this.Results.classList.contains("animation-disappear-to-bottom")) {
                        this.Results.style.display = "none";
                        this.Results.classList.remove("animation-disappear-to-top", "animation-appear-from-top", "animation-disappear-to-bottom");
                        const inputSection = this.input.closest("section");
                        if (this.IsSearch && inputSection?.classList.contains("inline")) {
                            inputSection.querySelector(".selected-item").classList.add("hidden");
                            inputSection.querySelector(".multiple-selected").classList.add("hidden");
                            const CheckedListItems = this.input.getAttribute("displayval").split("^");
                            if (CheckedListItems.length > 1 && (textSize("13px", this.input.getAttribute("displayval")) > this.input.clientWidth)) {
                                inputSection.querySelector(".multiple-selected-num").classList.remove("hidden");
                                inputSection.querySelector(".multiple-selected-num").lastElementChild.innerHTML = "+" + CheckedListItems.length;
                            }
                        }
                    }
                });
                this.OnChangeCallback = OnChangeCallback;
                if (this.OnChangeCallback instanceof Function) {
                    this.OnChangeCallback = (input, hidden) => {
                        clearTimeout(this.Timer);
                        this.Timer = setTimeout(() => {
                            OnChangeCallback(input, hidden);
                        }, 150);
                    };
                }
                let Distributor;
                this.APIToken = EC_Fmt.Null2EmptyStr(APIToken);
                this.EncompassID = EC_Fmt.Null2EmptyStr(EC_Fmt.NullChk(EncompassID, Distributor));
                this.HasCustomLookupUrl = input.hasAttribute("LookupUrl");
                if (this.HasCustomLookupUrl) {
                    this.LookupUrl = input.getAttribute("LookupUrl");
                }
                let Reg = /[?|&]APIToken=/ig;
                if (this.APIToken !== "" && !Reg.exec(this.LookupUrl)) {
                    this.LookupUrl += "&APIToken=" + this.APIToken;
                }
                Reg = /[?|&]EncompassID/ig;
                if (this.EncompassID !== "" && !Reg.exec(this.LookupUrl)) {
                    this.LookupUrl += "&EncompassID=" + this.EncompassID;
                }
                this.AjaxCacheID = input.getAttribute("AjaxCacheID");
                this.IsSearch = input.getAttribute("IsSearch") === "true";
                this.Required = input.getAttribute("req") === "true";
                this.LimitToList = input.getAttribute("LimitToList") === "true";
                this.DisableNotIn = input.getAttribute("DisableNotIn") === "true";
                this.CurrentRequest = undefined;
                this.CurSearchStr = "";
                this.OnPaste = this.OnPaste.bind(this);
                this.OnKeyDown = this.OnKeyDown.bind(this);
                this.OnKeyUp = this.OnKeyUp.bind(this);
                this.OnFocus = this.OnFocus.bind(this);
                this.OnClick = this.OnClick.bind(this);
                this.OnBlur = this.OnBlur.bind(this);
                this.OnChange = this.OnChange.bind(this);
                this.OnClick_Button = this.OnClick_Button.bind(this);
                this.RequestResults = this.RequestResults.bind(this);
                this.GetResultFromServer = this.GetResultFromServer.bind(this);
                this.ShowResults = this.ShowResults.bind(this);
                this.SelectResultsItem = this.SelectResultsItem.bind(this);
                this.ClickAjaxItem = this.ClickAjaxItem.bind(this);
                this.ClickAjaxItemCheck = this.ClickAjaxItemCheck.bind(this);
                this.ClickSelectedItemCheck = this.ClickSelectedItemCheck.bind(this);
                this.UpdateSelectedArray = this.UpdateSelectedArray.bind(this);
                this.PopulateFields = this.PopulateFields.bind(this);
                this.AbortRunningAjaxCall = this.AbortRunningAjaxCall.bind(this);
                this.Init_AJAXInput();
            }
            Init_AJAXInput() {
                const me = this;
                let section = document.getElementById("ews-results-section");
                if (!section) {
                    section = document.createElement("section");
                    section.id = "ews-results-section";
                    document.body.appendChild(section);
                }
                const oldResults = section.querySelector(`#${EC_Fmt.CssEscape(me.FieldID)}_Results`);
                const oldAutoCompleteUID = oldResults?.getAttribute("AutoCompleteUID");
                const autocomplete = document.querySelector(`ecp-auto-complete[autocompleteuid='${oldAutoCompleteUID}']`);
                if (oldResults && !autocomplete) {
                    section.removeChild(oldResults);
                }
                const inputSection = me.input.closest("section");
                let isInline = false;
                if (inputSection?.classList.contains("inline")) {
                    isInline = true;
                    me.Results.classList.add("inline", "motion-moderate");
                }
                const autoCompleteUID = me.Results?.getAttribute("AutoCompleteUID");
                const autocompleteEl = document.querySelector(`ecp-auto-complete[autocompleteuid='${autoCompleteUID}']`);
                if (me.Results && autocompleteEl || !isInline) {
                    section.appendChild(me.Results);
                }
                me.SelectedResults = me.Results.firstElementChild.firstElementChild;
                me.SearchedResults = me.Results.firstElementChild.lastElementChild;
                const htmlRemovedStr = EC_Fmt.Null2EmptyStr(me.input.value).replace(/<\/?[^>^@]+>/g, "");
                if (htmlRemovedStr !== "") {
                    me.input.value = htmlRemovedStr;
                }
                if (me.IsSearch) {
                    if (!me.DisableNotIn && me.hidden.value.startsWith("<>")) {
                        me.NOT_SearchOn = true;
                        if (inputSection?.classList.contains("inline")) {
                            inputSection.querySelector(".excludes").classList.toggle("hidden");
                            if (me.input.value.startsWith("<>")) {
                                me.input.value = me.input.value.substring(2);
                            }
                        }
                        me.Results.classList.toggle("excludes");
                        me.hidden.setAttribute("SelArray", me.hidden.value.substring(2));
                        const index = me.hidden.value.indexOf("^");
                        if (index > -1 && index !== 2 && me.input.value.startsWith("<>")) {
                            me.input.value = me.input.value.substring(2);
                            me.input.value = "Multiple ...";
                            me.input.classList.add("Info");
                            me.input.setAttribute("SelArray", me.input.getAttribute("SelArray").substring(2));
                            me.input.setAttribute("DisplayVal", me.input.getAttribute("DisplayVal").substring(2));
                        }
                    }
                    else {
                        me.hidden.setAttribute("SelArray", me.hidden.value);
                    }
                }
                me.input.addEventListener("mousedown", me.OnClick);
                EC_Fmt.AfterInput(me.input, 1, 250, () => {
                    me.RequestResults(me.input.value ? false : true);
                }, true);
                const iconSpans = me.input.closest("section").querySelectorAll("span[class*='ews-icon-']");
                if (EC_Fmt.isMobile) {
                    for (let i = 0, len = iconSpans.length; i < len; i++) {
                        iconSpans[i].addEventListener("click", () => {
                            EC_Fmt.TriggerEvent(me.input, "click");
                            me.input.focus();
                        });
                    }
                    me.input.addEventListener("click", () => {
                        AjaxInput.MobileInit(me);
                    });
                }
                else {
                    for (let i = 0, len = iconSpans.length; i < len; i++) {
                        iconSpans[i].addEventListener("click", me.OnClick_Button);
                    }
                    me.input.addEventListener("paste", me.OnPaste);
                    me.input.addEventListener("keydown", me.OnKeyDown);
                    me.input.addEventListener("keyup", me.OnKeyUp);
                    me.input.addEventListener("focus", me.OnFocus);
                    me.input.addEventListener("blur", me.OnBlur);
                    if (me.OnChangeCallback instanceof Function) {
                        me.input.addEventListener("change", me.OnChange);
                    }
                    me.AjaxInputInitActions();
                }
            }
            OnPaste() {
                const me = this;
                requestAnimationFrame(() => {
                    me.input.value = me.input.value.trim();
                    me.hidden.value = me.input.value;
                    me.CurSearchStr = AjaxInput.HtmlEncode(me.input.value);
                });
            }
            OnKeyDown(Event) {
                const me = this;
                const KeyCode = Event.code;
                let oldHiddenValue = me.hidden.value;
                if (this.isCloseResults) {
                    this.isCloseResults = false;
                }
                if (me.IsSearch && me.input.value === "Multiple ..." && (KeyCode === "ArrowLeft" || KeyCode === "ArrowRight")) {
                    Event.preventDefault();
                    me.input.selectionStart = 0;
                    me.input.selectionEnd = 0;
                }
                else if (KeyCode !== "ShiftLeft" && KeyCode !== "ShiftRight" && KeyCode !== "ControlLeft" && KeyCode !== "ControlRight") {
                    if (me.IsSearch && me.input.value === "Multiple ...") {
                        if (KeyCode !== "ArrowUp" && KeyCode !== "ArrowDown") {
                            me.input.value = "";
                            me.input.classList.remove("Info");
                        }
                        else {
                            Event.preventDefault();
                            me.input.selectionStart = 0;
                            me.input.selectionEnd = 0;
                        }
                    }
                    if (KeyCode === "ArrowUp" || KeyCode === "ArrowDown" || KeyCode === "Tab" || KeyCode === "Enter" || KeyCode === "NumpadEnter") {
                        if (!(me.Results.offsetWidth === 0 && me.Results.offsetHeight === 0)) {
                            const SearchedResultsCount = me.SearchedResults.children.length;
                            const SelectedResultsCount = me.SelectedResults.children.length;
                            if (KeyCode === "ArrowUp") {
                                if (me.SelectedIndex > 0) {
                                    me.SelectedIndex--;
                                    me.SelectedIndex = Math.min(me.SelectedIndex, (SearchedResultsCount + SelectedResultsCount - 1));
                                    if (me.SelectedIndex > -1) {
                                        me.SelectResultsItem(me.SelectedIndex, KeyCode);
                                    }
                                }
                            }
                            else if (KeyCode === "ArrowDown") {
                                let Len = SearchedResultsCount + SelectedResultsCount - 1;
                                if (me.Results.querySelector(".AutocompleteItem.Off")) {
                                    Len -= 1;
                                }
                                if (me.SelectedIndex <= SelectedResultsCount - 1) {
                                    me.SelectedIndex = SelectedResultsCount - 1;
                                }
                                me.SelectedIndex++;
                                me.SelectedIndex = Math.min(me.SelectedIndex, Len);
                                if (me.SelectedIndex <= Len) {
                                    me.SelectResultsItem(me.SelectedIndex, KeyCode);
                                }
                            }
                            else if ((KeyCode === "Tab" || KeyCode === "Enter" || KeyCode === "NumpadEnter") && me.SelectedIndex > -1) {
                                const selectedListItem = document.getElementById(`${me.FieldID}_Item_${me.SelectedIndex}`);
                                const selectedCheckbox = selectedListItem?.querySelector("input[type='checkbox']");
                                const inputSection = me.input.closest("section");
                                if ((KeyCode === "Enter" || KeyCode === "NumpadEnter") && inputSection?.classList.contains("inline") && selectedListItem && selectedCheckbox) {
                                    const keyboardSelectedIndex = me.SelectedIndex;
                                    me.ClickAjaxItemCheck(Event, me.SelectedIndex, selectedListItem);
                                    me.SelectedIndex = keyboardSelectedIndex;
                                }
                                else {
                                    me.PopulateFields(me.SelectedIndex, undefined, undefined, Event);
                                    me.hidden.value = me.hidden.value.replace(me.SearchOperator, "");
                                    me.input.value = me.input.value.replace(me.SearchOperator, "");
                                    if (me.OnChangeCallback instanceof Function) {
                                        me.OnChangeCallback(me.input, me.hidden);
                                    }
                                    me.isInternalUpdating = true;
                                }
                            }
                        }
                        if (KeyCode === "Enter" || KeyCode === "NumpadEnter") {
                            if (me.IsSearch && me.SelectedIndex === -1) {
                                const validSearchItems = me.SearchedResults.querySelectorAll("div.AutocompleteItem[encvalue]");
                                const searchText = EC_Fmt.Null2EmptyStr(me.SearchedResults.textContent).replace(/\s+/g, "");
                                const isShortSearchPlaceholder = /^[*-]+$/.test(searchText) && searchText.indexOf("-") > -1;
                                if (validSearchItems.length === 0 && isShortSearchPlaceholder) {
                                    if (me.CommitManualSearchValue() && me.OnChangeCallback instanceof Function) {
                                        me.OnChangeCallback(me.input, me.hidden);
                                        me.isInternalUpdating = true;
                                    }
                                }
                            }
                            else {
                                if (!me.LimitToList && !me.IsSearch) {
                                    me.isCloseResults = true;
                                    if (oldHiddenValue !== me.hidden.value) {
                                        me.Results.classList.add("animation-disappear-to-bottom");
                                    }
                                    else {
                                        me.Results.classList.add("animation-disappear-to-top");
                                    }
                                }
                                me.OnBlur(Event);
                            }
                        }
                    }
                }
                if (((KeyCode === "KeyC" || KeyCode === "KeyA") && (Event.ctrlKey || Event.metaKey))) {
                    me.isCtrl = true;
                }
                else {
                    me.isCtrl = false;
                }
            }
            OnKeyUp(Event) {
                const KeyCode = Event.code;
                if (KeyCode !== "Tab" && KeyCode !== "Enter" && KeyCode !== "NumpadEnter" && KeyCode !== "ShiftLeft" && KeyCode !== "ShiftRight" && KeyCode !== "ControlLeft" && KeyCode !== "ControlRight" && !this.isCtrl) {
                    switch (this.input.value.toUpperCase()) {
                        case "NOT NULL":
                        case "NOT IS NULL":
                        case "IS NOT NULL":
                        case "ANY VALUE":
                            this.hidden.value = "NOT IS NULL";
                            break;
                        case "IS NULL":
                        case "NULL":
                        case "NO VALUE":
                            this.hidden.value = "IS NULL";
                            break;
                        default:
                            this.hidden.value = AjaxInput.HtmlEncode(this.input.value);
                            break;
                    }
                    this.CurSearchStr = AjaxInput.HtmlEncode(this.input.value);
                }
            }
            OnFocus() {
                if (this.isCloseResults) {
                    this.isCloseResults = false;
                }
                if (this.input.value === "Multiple ...") {
                    this.input.selectionStart = 0;
                    this.input.selectionEnd = 0;
                }
                this.input.closest(".AutocompleteField").classList.add("AutocompleteActive");
                if (this.IsSearch && this.input.value) {
                    const inputSection = this.input.closest("section");
                    if (inputSection?.classList.contains("inline")) {
                        const selectedObj = this.Results.querySelector(`div.AutocompleteItem[encvalue='${EC_Fmt.CssEscape(this.hidden.value)}']`);
                        const valueList = this.input.getAttribute("displayval").split("^").length;
                        if (valueList > 1 || selectedObj) {
                            inputSection.querySelector(".selected-item").innerHTML = valueList.toString();
                            inputSection.querySelector(".selected-item").classList.remove("hidden");
                            if (valueList > 1) {
                                inputSection.querySelector(".multiple-selected").classList.remove("hidden");
                            }
                            this.input.value = "";
                        }
                        inputSection.querySelector(".multiple-selected-num").classList.add("hidden");
                    }
                }
            }
            OnClick(Event) {
                if (this.input.value === "Multiple ...") {
                    Event.preventDefault();
                    this.input.selectionStart = 0;
                    this.input.selectionEnd = 0;
                }
                if (!EC_Fmt.isMobile) {
                    AllowHideAllDivs = false;
                    this.input.focus();
                    const inputSection = this.input.closest("section");
                    if (inputSection?.classList.contains("inline")) {
                        if (this.Results.offsetWidth === 0 && this.Results.offsetHeight === 0) {
                            HideAllDivs();
                            this.RequestResults(true);
                        }
                        else {
                            if (this.Results.getAttribute("inputchanged") === "true") {
                                this.Results.classList.add("animation-disappear-to-bottom");
                            }
                            else {
                                this.Results.classList.add("animation-disappear-to-top");
                            }
                        }
                    }
                }
            }
            OnChange() {
                const me = this;
                let isChanged = true;
                if ((me.LimitToList && me.input.value !== "" && me.input.value !== me.input.getAttribute("displayval")) || (me.input.value === "" && me.Required && me.LimitToList)) {
                    isChanged = false;
                }
                if (isChanged && me.OnChangeCallback instanceof Function) {
                    me.OnChangeCallback(me.input, me.hidden);
                }
            }
            OnBlur(Event) {
                const me = this;
                me.AbortRunningAjaxCall();
                let InputVal = AjaxInput.HtmlEncode(me.input.value);
                me.input.closest(".AutocompleteField").classList.remove("AutocompleteActive");
                let isInline = false;
                const inputSection = me.input.closest("section");
                if (inputSection?.classList.contains("inline") || me.MobileDialog?.classList.contains("inline")) {
                    isInline = true;
                    InputVal = AjaxInput.HtmlEncode(me.hidden.value);
                }
                if (InputVal === "" && (!me.LimitToList || !me.Required)) {
                    if (EC_Fmt.Null2EmptyStr(me.input.getAttribute("selarray")).split("^").length > 1 && me.OnChangeCallback instanceof Function) {
                        me.OnChangeCallback(me.input, me.hidden);
                    }
                    me.input.setAttribute("SelArray", "");
                    me.input.setAttribute("DisplayVal", "");
                    return;
                }
                if (me.LimitToList) {
                    const maxReached = me.Results.querySelector("div[name='MaxReached']");
                    if (!maxReached || !Event || (maxReached && Event.relatedTarget !== maxReached)) {
                        let IsNotForced = true;
                        const beforeSelArray = me.hidden.getAttribute("selarray");
                        if (!me.Required) {
                            me.SearchOperator = EC_Fmt.get_searchOp(InputVal);
                            if (me.SearchOperator.toUpperCase() === "NOT IS NULL" || me.SearchOperator.toUpperCase() === "IS NULL") {
                                me.SearchOperator = "";
                            }
                        }
                        let i = 0;
                        let ListItem = document.getElementById(`${me.FieldID}_Item_${i}`);
                        const ListItemArr = [];
                        while (ListItem) {
                            ListItemArr.push(ListItem);
                            const encValue = ListItem.getAttribute("encValue");
                            if (me.hidden.value.toLowerCase() === encValue.toLowerCase()) {
                                me.input.value = ListItem.innerText;
                                me.SetHiddenValue(AjaxInput.HtmlEncode(encValue));
                                me.SelectedIndex = i;
                                IsNotForced = false;
                                break;
                            }
                            i++;
                            ListItem = document.getElementById(`${me.FieldID}_Item_${i}`);
                        }
                        if (IsNotForced) {
                            for (let i = 0; i < ListItemArr.length; i++) {
                                const ListItem = ListItemArr[i];
                                const encValue = ListItem.getAttribute("encValue");
                                if (me.input.value.toLowerCase() === ListItem.innerText.toLowerCase()) {
                                    me.input.value = ListItem.innerText;
                                    me.SetHiddenValue(AjaxInput.HtmlEncode(encValue));
                                    me.SelectedIndex = i;
                                    IsNotForced = false;
                                    break;
                                }
                            }
                        }
                        if (IsNotForced) {
                            me.SelectedIndex = -1;
                            if (me.Required) {
                                if (EC_Fmt.isNull(me.input.getAttribute("KeyValue"))) {
                                    me.SetHiddenValue(me.hidden.getAttribute("SelArray"));
                                }
                                else {
                                    me.SetHiddenValue(me.input.getAttribute("KeyValue"));
                                }
                                me.input.value = AjaxInput.HtmlDecode(me.input.getAttribute("DisplayVal"));
                                if (me.IsSearch) {
                                    me.input.setAttribute("SelArray", me.input.getAttribute("DisplayVal"));
                                }
                            }
                        }
                        me.PopulateFields(me.SelectedIndex, undefined, undefined, Event);
                        if (me.OnChangeCallback instanceof Function && !IsNotForced && me.hidden.value !== beforeSelArray) {
                            me.OnChangeCallback(me.input, me.hidden);
                        }
                    }
                }
                if (me.IsSearch) {
                    const CheckedListItems = me.Results.querySelectorAll("input:checked");
                    if (CheckedListItems && CheckedListItems.length > 0 && me.input.value === "") {
                        let Value = "";
                        let MultipleSelectedArray = "";
                        for (let j = 0, len = CheckedListItems.length; j < len; j++) {
                            if (Value !== "") {
                                Value += "^";
                            }
                            if (MultipleSelectedArray !== "") {
                                MultipleSelectedArray += "^";
                            }
                            Value += CheckedListItems[j].value;
                            MultipleSelectedArray += CheckedListItems[j].getAttribute("SelValue");
                        }
                        Value = AjaxInput.HtmlEncode(Value);
                        me.hidden.setAttribute("SelArray", Value);
                        me.SetHiddenValue(Value);
                        if (isInline) {
                            setTimeout(() => {
                                if (!me.input.value && (me.Results.classList.contains("animation-disappear-to-top") || me.Results.classList.contains("animation-disappear-to-bottom") || me.Results.style.display == "none" || me.MobileDialog?.style.display == "none")) {
                                    me.input.value = EC_Fmt.ReplaceAll(MultipleSelectedArray, "^", ", ");
                                    if (me.NOT_SearchOn && !me.hidden.value.startsWith("<>")) {
                                        me.hidden.value = "<>" + me.hidden.value;
                                    }
                                    if (me.OnChangeCallback instanceof Function) {
                                        me.OnChangeCallback(me.input, me.hidden);
                                    }
                                }
                            }, 250);
                        }
                        me.input.classList.add("Info");
                        me.input.setAttribute("SelArray", MultipleSelectedArray.replace(/\|/g, "{LINE}"));
                        me.input.setAttribute("DisplayVal", MultipleSelectedArray);
                    }
                }
                const htmlRemovedStr = me.input.value.replace(/<\/?[^>^@]+>/g, "");
                if (htmlRemovedStr !== "") {
                    me.input.value = htmlRemovedStr;
                }
                me.input.scrollLeft = 0;
            }
            OnClick_Button() {
                AllowHideAllDivs = false;
                this.input.focus();
                this.CurSearchStr = "";
                if (this.Results.offsetWidth === 0 && this.Results.offsetHeight === 0) {
                    HideAllDivs();
                    this.RequestResults(true);
                }
                else {
                    if (this.Results.getAttribute("inputchanged") === "true") {
                        this.Results.classList.add("animation-disappear-to-bottom");
                    }
                    else {
                        this.Results.classList.add("animation-disappear-to-top");
                    }
                }
            }
            RequestResults(DisplayAll) {
                const me = this;
                const InputValue = AjaxInput.HtmlEncode(me.CurSearchStr);
                me.SearchOperator = EC_Fmt.get_searchOp(InputValue);
                if (me.SearchOperator.toUpperCase() === "NOT IS NULL" || me.SearchOperator.toUpperCase() === "IS NULL") {
                    me.SearchOperator = "";
                }
                let SearchStr = "^";
                if (!DisplayAll) {
                    SearchStr = InputValue.replace(me.SearchOperator, "").replace(/^\s+|\s+$/g, "");
                    me.input.setAttribute("data-selectedValue", SearchStr);
                }
                if (me.LimitToList) {
                    me.SearchOperator = "";
                }
                if (SearchStr !== "" && me.SearchOperator !== "><") {
                    SearchStr = me.SearchOperator + SearchStr;
                }
                let htmlB = "";
                const selectedValue = me.input.getAttribute("SelArray");
                const SelectedValues = [];
                let MultipleSelectedArray = [];
                if (!EC_Fmt.isNull(selectedValue)) {
                    MultipleSelectedArray = selectedValue.split("^");
                    const hasNotIsNull = selectedValue.toUpperCase().indexOf("NOT IS NULL") !== -1;
                    let HiddenInputArr;
                    if (me.hidden.getAttribute("SelArray")) {
                        HiddenInputArr = me.hidden.getAttribute("SelArray").split("^");
                        if (HiddenInputArr.includes("IS NULL") && selectedValue.toUpperCase().indexOf("IS NULL") === -1 && HiddenInputArr.length > MultipleSelectedArray.length) {
                            MultipleSelectedArray.splice(HiddenInputArr.indexOf("IS NULL"), 0, "IS NULL");
                        }
                    }
                    for (let i = 0, len = MultipleSelectedArray.length; i < len; i++) {
                        const ValueArray = MultipleSelectedArray[i].split("|");
                        let selValue = ValueArray[1] || ValueArray[0];
                        let value = ValueArray[0];
                        if (!ValueArray[1] && HiddenInputArr) {
                            value = HiddenInputArr[i];
                        }
                        if (selValue) {
                            selValue = selValue.replace(/{LINE}/g, "|");
                            value = value.replace(/{LINE}/g, "|");
                            SelectedValues.push(value);
                            if (!hasNotIsNull) {
                                htmlB += `<div class="AutocompleteItem Highlight"id="${me.FieldID}_Item_${i}"encValue="${value}"index=${i}>`;
                                if (me.IsSearch) {
                                    htmlB += `<input type=checkbox SelValue="${EC_Fmt.HTMLEncode(selValue)}"value="${value}"checked>`
                                        + `<label>${selValue}</label>`;
                                }
                                else {
                                    htmlB += `${selValue}`;
                                }
                                htmlB += "</div>";
                            }
                            else {
                                me.input.setAttribute("data-selectedValue", selValue);
                            }
                        }
                    }
                }
                me.GetResultFromServer(SelectedValues, SearchStr, 0);
                const myList = me.SelectedResults;
                if (myList) {
                    myList.innerHTML = htmlB;
                    if (htmlB !== "") {
                        const SelectedListItems = myList.querySelectorAll("div.AutocompleteItem");
                        for (let i = 0, len = SelectedListItems.length; i < len; i++) {
                            const SelectedListItem = SelectedListItems[i];
                            const SelectedCheckbox = SelectedListItem.querySelector("input[type='checkbox']");
                            if (SelectedCheckbox) {
                                SelectedListItem.addEventListener("click", (Event) => {
                                    me.ClickSelectedItemCheck(Event, SelectedListItem, SelectedCheckbox);
                                });
                                SelectedCheckbox.addEventListener("click", () => {
                                    SelectedCheckbox.checked = !SelectedCheckbox.checked;
                                });
                            }
                            else {
                                SelectedListItem.addEventListener("click", (Event) => {
                                    me.ClickAjaxItem(Event, parseInt(SelectedListItem.getAttribute("index")), SelectedListItem);
                                });
                            }
                        }
                    }
                }
            }
            GetResultFromServer(SelectedValues, SearchStr, Offset) {
                const me = this;
                if (me.APIToken !== "") {
                    me.GetResultFromServer_Callback(me, SelectedValues, SearchStr, Offset);
                }
                else if (EWS) {
                    EWS.VerifySession(() => {
                        me.GetResultFromServer_Callback(me, SelectedValues, SearchStr, Offset);
                    });
                }
                else {
                    throw "APIToken and EncompassID must be used for all AjaxInputs created outside of an Encompass page";
                }
            }
            AbortRunningAjaxCall() {
                this.aborted = true;
                if (this.CurrentRequest) {
                    this.CurrentRequest.Abort();
                }
            }
            ShowResults(Data, SearchStr, SelectedValues, AppendToList) {
                const me = this;
                if (me.isCloseResults || me.aborted || !EC_Fmt.isVisible(me.input)) {
                    return;
                }
                me.SelectedIndex = -1;
                const RefResults = me.SearchedResults;
                if (SelectedValues.length > 0 && SearchStr === "^" && Data.match("No Records Found")) {
                    RefResults.innerHTML = "";
                }
                else if (Data && Data.errors && Data.errors[0] && Data.errors[0].status === "401") {
                    RefResults.innerHTML = Data.errors[0].title;
                    if (EWS) {
                        EWS.Login();
                    }
                    return;
                }
                else if (AppendToList) {
                    RefResults.removeChild(RefResults.querySelector("div[name='MaxReached']"));
                    RefResults.innerHTML = RefResults.innerHTML + Data;
                    requestAnimationFrame(() => {
                        const selectedItems = RefResults.querySelectorAll(".AutocompleteItem.Highlight");
                        for (let i = 0; i < selectedItems.length; i++) {
                            EC_Fmt.TriggerEvent(selectedItems[i], "click");
                        }
                    });
                }
                else {
                    if (Data.match("No Similar Records Found Like")) {
                        if (Data.includes("ews-action")) {
                            const re = Data.match(/<div[^>]*onclick[^>]*>.*?<\/div>/i);
                            if (re) {
                                Data = re[0];
                                const regex = /onclick="([^"]+)"/;
                                const result = Data.match(regex);
                                if (result && result[1]) {
                                    Data = Data.replace(`<div name=ErrorPrompt style=padding:5px>No similar records found like '${SearchStr}'<br>`, "");
                                    Data = Data.replace("</div>", "");
                                    RefResults.innerHTML = `<div name=ErrorPrompt><ecp-sectionmessage type="info">No results
                            <ecp-sectionmessage-action onclick=${result[1]}>Add related record</ecp-sectionmessage-action></ecp-sectionmessage></div>`;
                                }
                                else {
                                    RefResults.innerHTML = Data;
                                }
                            }
                            else {
                                RefResults.innerHTML = Data;
                            }
                        }
                        else {
                            RefResults.innerHTML = `<div name=ErrorPrompt><ecp-sectionmessage type="info">No results</ecp-sectionmessage></div>`;
                            ;
                        }
                    }
                    else {
                        RefResults.innerHTML = Data;
                    }
                }
                const hasErrorSection = !!RefResults.querySelector(".auto-error-section");
                if (!RefResults.querySelector("#LoadingTimeout")) {
                    me.AjaxInputActions?.classList.toggle("hidden", hasErrorSection);
                    me.Results.querySelector(".done-button")?.classList.toggle("hidden", hasErrorSection);
                }
                me.Results.style.height = "auto";
                me.Results.style.minWidth = `${me.input.parentElement.offsetWidth + 18}px`;
                me.Results.classList.remove("animation-disappear-to-top", "animation-disappear-to-bottom");
                me.Results.classList.add("animation-appear-from-top");
                me.Results.style.display = "flex";
                if (!EC_Fmt.isMobile) {
                    me.Results.style.maxHeight = "278px";
                    const bodyHeight = window.innerHeight;
                    let InputPosition;
                    if (me.input.closest("table")) {
                        InputPosition = me.input.closest("table").getBoundingClientRect();
                    }
                    else {
                        InputPosition = me.input.closest("section").getBoundingClientRect();
                    }
                    const InputTop = Math.ceil(InputPosition.top);
                    const InputHeight = me.input.offsetHeight;
                    const clientWidth = document.body.clientWidth;
                    const Width = me.Results.offsetWidth;
                    let ResultsHeight = Math.ceil(me.Results.offsetHeight);
                    let Top = InputTop + InputHeight;
                    let Left = InputPosition.left;
                    if (Top + ResultsHeight > bodyHeight) {
                        const bottomSpaceHeight = bodyHeight - Top;
                        if (bottomSpaceHeight < InputTop) {
                            Top = InputTop - ResultsHeight;
                            if (Top < 0) {
                                ResultsHeight += Top;
                                Top = 0;
                            }
                        }
                        else {
                            ResultsHeight = bodyHeight - Top;
                        }
                    }
                    me.Results.style.top = `${Top + 10}px`;
                    if (!hasErrorSection) {
                        me.Results.style.height = `${ResultsHeight}px`;
                    }
                    if (Left + Width > clientWidth) {
                        if (Left > clientWidth - InputPosition.right) {
                            Left = Math.max(0, InputPosition.right - Width);
                            if (Left === 0) {
                                me.Results.style.width = `${InputPosition.right}px`;
                            }
                        }
                        else {
                            me.Results.style.width = `${clientWidth - InputPosition.left}px`;
                        }
                    }
                    me.Results.style.left = `${Left}px`;
                }
                else if (me.MobileDialog?.classList.contains("inline")) {
                    me.MobileDialog.querySelector(".ews-dialog-mobile").classList.add("animation-appear-from-top");
                }
                let selectValue = me.input.getAttribute("data-selectedValue") || me.hidden.value;
                const ResultsList = me.SelectedResults;
                if (selectValue && selectValue !== "") {
                    switch (selectValue.toUpperCase()) {
                        case "NOT NULL":
                        case "NOT IS NULL":
                        case "IS NOT NULL":
                        case "ANY VALUE":
                            selectValue = "NOT IS NULL";
                            break;
                        case "IS NULL":
                        case "NULL":
                        case "NO VALUE":
                            selectValue = "IS NULL";
                            break;
                    }
                    const selectedObj = RefResults.querySelector(`div.AutocompleteItem[encvalue='${EC_Fmt.CssEscape(selectValue)}']`);
                    if (selectedObj && ResultsList.innerHTML === "") {
                        selectedObj.classList.add("Highlight");
                        me.SelectedIndex = Array.from(RefResults.querySelectorAll("div.AutocompleteItem")).indexOf(selectedObj);
                    }
                }
                else if (ResultsList.innerHTML !== "") {
                    const highlightedValue = document.querySelector("div.Highlight[encvalue]");
                    if (highlightedValue) {
                        selectValue = highlightedValue.getAttribute("encvalue");
                        if (selectValue === "NOT IS NULL") {
                            ResultsList.innerHTML = "";
                        }
                    }
                }
                if (RefResults.innerHTML === "" && ResultsList.innerHTML === "") {
                    me.Results.classList.add("ecp-keyframe-disappeartobottom");
                }
                else {
                    const MaxReached = me.Results.querySelector("div[name='MaxReached']");
                    if (MaxReached && MaxReached.hasAttribute("offset")) {
                        MaxReached.addEventListener("click", (event) => {
                            MaxReached.innerHTML = "<div class=AutocompleteItem onclick='AllowHideAllDivs=false'id=LoadingTimeout>Loading...</div>";
                            const Offset = EC_Fmt.Null2ZeroInt(event.currentTarget.getAttribute("offset"));
                            const InputValue = AjaxInput.HtmlEncode(me.CurSearchStr);
                            me.SearchOperator = EC_Fmt.get_searchOp(InputValue);
                            if (me.SearchOperator.toUpperCase() === "NOT IS NULL" || me.SearchOperator.toUpperCase() === "IS NULL") {
                                me.SearchOperator = "";
                            }
                            let SearchStr = "^";
                            if (!EC_Fmt.isNull(InputValue)) {
                                SearchStr = InputValue.replace(me.SearchOperator, "").replace(/^\s+|\s+$/g, "");
                                me.input.setAttribute("data-selectedValue", SearchStr);
                            }
                            if (me.LimitToList) {
                                me.SearchOperator = "";
                            }
                            if (SearchStr !== "" && me.SearchOperator !== "><") {
                                SearchStr = me.SearchOperator + SearchStr;
                            }
                            const SelectedValues = [];
                            const selectedItemArr = me.SelectedResults.querySelectorAll("div[encvalue]");
                            for (let i = 0; i < selectedItemArr.length; i++) {
                                SelectedValues.push(selectedItemArr[i].getAttribute("encvalue").replace(/{LINE}/g, "|"));
                            }
                            AllowHideAllDivs = false;
                            me.GetResultFromServer(SelectedValues, SearchStr, Offset + 1);
                        });
                    }
                    if (me.IsSearch) {
                        const ErrorPrompt = me.Results.querySelector("div[name='ErrorPrompt']");
                        if (!EC_Fmt.isMobile) {
                            const SelectAll = me.AjaxInputActions.querySelector("#AjaxSelectAll");
                            if (!MaxReached && !ErrorPrompt) {
                                SelectAll.style.display = "";
                            }
                            else {
                                SelectAll.style.display = "none";
                            }
                        }
                        else {
                            const SelectAllButtons = me.MobileDialog.querySelectorAll("ecp-btn[name='SelectAll']");
                            const inlineSelectAll = me.MobileDialog.querySelector("span[name='SelectAll']");
                            if (!MaxReached && !ErrorPrompt) {
                                for (let i = 0; i < SelectAllButtons.length; i++) {
                                    SelectAllButtons[i].style.display = "";
                                }
                                if (inlineSelectAll) {
                                    inlineSelectAll.style.display = "";
                                }
                            }
                            else {
                                for (let i = 0; i < SelectAllButtons.length; i++) {
                                    SelectAllButtons[i].style.display = "none";
                                }
                                if (inlineSelectAll) {
                                    inlineSelectAll.style.display = "none";
                                }
                            }
                        }
                    }
                }
                const AutocompleteItems = Array.from(RefResults.getElementsByClassName("AutocompleteItem")).filter(item => item.hasAttribute("encvalue"));
                for (let i = 0, len = AutocompleteItems.length; i < len; i++) {
                    const AutoCompleteItem = AutocompleteItems[i];
                    const idArray = AutoCompleteItem.id.split("_");
                    const index = i + SelectedValues.length;
                    const checkbox = AutoCompleteItem.querySelector("input[type='checkbox']");
                    if (idArray.length > 1) {
                        idArray[idArray.length - 1] = index.toString();
                        AutoCompleteItem.id = idArray.join("_");
                    }
                    if (!checkbox) {
                        if (AutoCompleteItem.id !== "LoadingTimeout" && AutoCompleteItem.getAttribute("name") !== "MaxReached") {
                            AutoCompleteItem.addEventListener("click", (event) => {
                                me.ClickAjaxItem(event, index, AutoCompleteItem);
                            });
                        }
                    }
                    else {
                        AutoCompleteItem.addEventListener("click", (event) => {
                            me.ClickAjaxItemCheck(event, index, AutoCompleteItem);
                            if (EC_Fmt.isMobile) {
                                me.MobileInput.focus();
                            }
                        });
                        AutoCompleteItem.addEventListener("mousemove", () => {
                            me.SelectResultsItem(index, undefined);
                        });
                    }
                }
            }
            AjaxInputInitActions() {
                const me = this;
                const list = me.Results.querySelector("div");
                if (list) {
                    list.classList.add("ajax-input-results");
                }
                me.AjaxInputActions = document.createElement("div");
                me.AjaxInputActions.classList.add("ajax-input-actions");
                let htmlB = "";
                if (me.IsSearch) {
                    htmlB += "<span id=AjaxSelectAll>Select all</span>"
                        + "<span id=AjaxClear>Clear</span>";
                    if (!me.DisableNotIn) {
                        htmlB += `<ecp-switch size="small" active-color="bg-error" ${me.NOT_SearchOn ? "checked" : ""} id=AjaxNOT class=${me.NOT_SearchOn ? "AjaxNotOn" : ""}>Exclude</ecp-switch>`;
                    }
                    me.AjaxInputActions.innerHTML = htmlB;
                    me.Results.insertBefore(me.AjaxInputActions, me.Results.firstChild);
                }
                const doneEl = document.createElement("div");
                doneEl.className = 'done-button';
                doneEl.innerHTML = "<span id=AjaxOK>Done</span>";
                me.Results.appendChild(doneEl);
                if (me.IsSearch) {
                    const AjaxClear = me.AjaxInputActions.querySelector("#AjaxClear");
                    AjaxClear.addEventListener("click", (event) => {
                        event.stopPropagation();
                        me.IsSelectIng = true;
                        const Checkboxes = me.Results.querySelectorAll("input[type='checkbox']:checked");
                        if (Checkboxes.length > 0) {
                            for (let i = 0, CheckboxesLength = Checkboxes.length; i < CheckboxesLength; i++) {
                                if (i === CheckboxesLength - 1) {
                                    me.IsSelectIng = false;
                                }
                                EC_Fmt.TriggerEvent(Checkboxes[i].parentElement, "click");
                            }
                        }
                        else {
                            me.hidden.value = "";
                            me.input.value = "";
                        }
                        me.IsSelectIng = false;
                    });
                    const SelectAll = me.AjaxInputActions.querySelector("#AjaxSelectAll");
                    SelectAll.addEventListener("click", (event) => {
                        event.stopPropagation();
                        me.IsSelectIng = true;
                        const Checkboxes = me.Results.querySelectorAll("input:not(:checked)");
                        for (let i = 0, CheckboxesLength = Checkboxes.length; i < CheckboxesLength; i++) {
                            if (i === CheckboxesLength - 1) {
                                me.IsSelectIng = false;
                            }
                            EC_Fmt.TriggerEvent(Checkboxes[i].parentElement, "click");
                        }
                        me.IsSelectIng = false;
                    });
                    if (!me.DisableNotIn) {
                        const AjaxNOT = me.AjaxInputActions.querySelector("#AjaxNOT");
                        AjaxNOT.addEventListener("click", (event) => {
                            event.stopPropagation();
                            AjaxNOT.classList.toggle("AjaxNotOn");
                            const inputSection = me.input.closest("section");
                            if (inputSection?.classList.contains("inline")) {
                                inputSection.querySelector(".excludes").classList.toggle("hidden");
                            }
                            me.Results.classList.toggle("excludes");
                            me.NOT_SearchOn = AjaxNOT.classList.contains("AjaxNotOn");
                            if (me.hidden.value !== "") {
                                if (me.NOT_SearchOn && !me.hidden.value.startsWith("<>")) {
                                    me.hidden.value = "<>" + me.hidden.value;
                                }
                                else if (me.hidden.value.startsWith("<>")) {
                                    me.hidden.value = me.hidden.value.substring(2);
                                }
                                if (me.OnChangeCallback instanceof Function) {
                                    me.OnChangeCallback(me.input, me.hidden);
                                }
                                me.input.focus();
                                me.isInternalUpdating = true;
                            }
                        });
                    }
                }
                const AjaxOk = me.Results.querySelector("#AjaxOK");
                AjaxOk.addEventListener("click", (event) => {
                    event.stopPropagation();
                    if (me.Results.getAttribute("inputchanged") === "true") {
                        me.Results.classList.add("animation-disappear-to-bottom");
                    }
                    else {
                        me.Results.classList.add("animation-disappear-to-top");
                    }
                    me.AbortRunningAjaxCall();
                });
                document.addEventListener("keydown", (event) => {
                    if (event.code === "Escape" || event.key === "Escape") {
                        me.Results.style.display = "none";
                        me.AbortRunningAjaxCall();
                    }
                });
                me.AjaxInputActions.addEventListener("click", (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    AjaxOk.click();
                });
            }
            SelectResultsItem(ItemIndex, KeyCode) {
                const me = this;
                const SelectedInputObject = document.getElementById(`${me.FieldID}_Item_${me.SelectedIndex}`);
                let i = 0;
                let ListItem = document.getElementById(`${me.FieldID}_Item_${i}`);
                while (ListItem) {
                    if (i === ItemIndex) {
                        ListItem.classList.add("On");
                    }
                    else {
                        ListItem.classList.remove("On");
                    }
                    i++;
                    ListItem = document.getElementById(`${me.FieldID}_Item_${i}`);
                }
                me.SelectedIndex = ItemIndex;
                if (me.SelectedIndex > (i - 1)) {
                    me.SelectedIndex = i - 1;
                    if (SelectedInputObject) {
                        SelectedInputObject.classList.add("On");
                    }
                }
                if ((KeyCode === "ArrowUp" || KeyCode === "ArrowDown") && SelectedInputObject) {
                    const ResultsContainer = me.Results.querySelector(".ajax-input-results");
                    const RefListScrollTop = ResultsContainer.scrollTop;
                    const RefListTop = ResultsContainer.getBoundingClientRect().top;
                    const OriginalSelectedTop = SelectedInputObject.getBoundingClientRect().top;
                    if (RefListScrollTop !== 0) {
                        ResultsContainer.scrollTop = 0;
                    }
                    const SelectedPositionTop = SelectedInputObject.getBoundingClientRect().top;
                    if ((SelectedPositionTop + (SelectedInputObject.offsetHeight * 2)) > (RefListScrollTop + RefListTop + ResultsContainer.clientHeight)) {
                        ResultsContainer.scrollTop = RefListScrollTop + SelectedInputObject.offsetHeight;
                    }
                    else if ((OriginalSelectedTop - SelectedInputObject.offsetHeight) < RefListTop) {
                        ResultsContainer.scrollTop = RefListScrollTop - SelectedInputObject.offsetHeight;
                    }
                    else {
                        ResultsContainer.scrollTop = RefListScrollTop;
                    }
                }
                me.SearchedResults.focus();
            }
            ClickAjaxItem(Event, ItemIndex, ListItem) {
                Event.stopPropagation();
                Event.preventDefault();
                const me = this;
                const beforeValue = me.input.value;
                me.PopulateFields(ItemIndex, undefined, ListItem, Event);
                me.hidden.value = me.hidden.value.replace(me.SearchOperator, "");
                const htmlRemovedStr = me.input.value.replace(me.SearchOperator, "").replace(/<\/?[^>^@]+>/g, "");
                if (htmlRemovedStr !== "") {
                    me.input.value = htmlRemovedStr;
                }
                if (EC_Fmt.isMobile) {
                    me.MobileInput.value = me.input.value;
                    requestAnimationFrame(() => {
                        AjaxInput.MobileSaveToInput(me);
                        if (beforeValue !== me.input.value) {
                            me.Results.classList.add("animation-disappear-to-bottom");
                        }
                        else {
                            me.Results.classList.add("animation-disappear-to-top");
                        }
                        me.AbortRunningAjaxCall();
                    });
                }
                else {
                    if (beforeValue !== me.input.value) {
                        me.Results.classList.add("animation-disappear-to-bottom");
                    }
                    else {
                        me.Results.classList.add("animation-disappear-to-top");
                    }
                    me.AbortRunningAjaxCall();
                    me.input.focus();
                    me.input.select();
                    me.input.scrollLeft = 0;
                }
                if (beforeValue !== me.input.value && me.OnChangeCallback instanceof Function) {
                    me.OnChangeCallback(me.input, me.hidden);
                }
                me.isInternalUpdating = true;
            }
            ClickAjaxItemCheck(Event, ItemIndex, ListItem) {
                Event.stopPropagation();
                Event.preventDefault();
                const me = this;
                const Checkbox = ListItem.querySelector("input[type='checkbox']");
                let Selected = (Checkbox && !Checkbox.checked);
                if (Event && Event.target === Checkbox) {
                    Selected = !Selected;
                    setTimeout(() => { Checkbox.checked = Selected; }, 10);
                }
                let ShiftKey = false;
                if (Event) {
                    try {
                        ShiftKey = Event.shiftKey;
                    }
                    catch (e) {
                        ShiftKey = false;
                    }
                }
                if (me.SearchOperator === "*") {
                    me.SearchOperator = "";
                }
                if (ShiftKey && Selected) {
                    const lastSelected = me.Results.querySelector("div.lastSelected");
                    let StartIndex = lastSelected ? Array.from(lastSelected.parentElement.children).indexOf(lastSelected) : 0;
                    let EndIndex = ItemIndex;
                    StartIndex = StartIndex < 0 ? 0 : StartIndex;
                    if (StartIndex > ItemIndex) {
                        EndIndex = StartIndex;
                        StartIndex = ItemIndex;
                    }
                    me.input.value = "";
                    for (let i = StartIndex; i <= EndIndex; i++) {
                        const RefInputCheckbox = me.Results.querySelector(`#${me.FieldID}_Item_${i} input[type='checkbox']`);
                        if (RefInputCheckbox) {
                            RefInputCheckbox.parentElement.classList.add("Highlight");
                            RefInputCheckbox.checked = true;
                        }
                    }
                    me.UpdateSelectedArray();
                }
                else {
                    me.input.value = "";
                    if (Selected) {
                        ListItem.classList.add("Highlight");
                    }
                    else {
                        ListItem.classList.remove("Highlight");
                    }
                    if (Checkbox) {
                        if (Selected) {
                            Checkbox.checked = true;
                        }
                        else {
                            Checkbox.checked = false;
                        }
                    }
                    me.PopulateFields(ItemIndex, true, undefined, Event);
                    if (!EC_Fmt.isMobile) {
                        me.input.focus();
                    }
                    const ListItemSiblings = ListItem.parentElement.children;
                    for (let i = 0, len = ListItemSiblings.length; i < len; i++) {
                        if (ListItemSiblings[i].classList.contains("lastSelected")) {
                            ListItemSiblings[i].classList.remove("lastSelected");
                        }
                    }
                    ListItem.classList.add("lastSelected");
                    me.UpdateSelectedArray();
                }
            }
            ClickSelectedItemCheck(Event, SelListItem, Checkbox) {
                Event.stopPropagation();
                if (!Checkbox.checked) {
                    SelListItem.classList.add("Highlight");
                }
                else {
                    SelListItem.classList.remove("Highlight");
                }
                Checkbox.checked = !Checkbox.checked;
                this.UpdateSelectedArray();
                if (!EC_Fmt.isMobile) {
                    this.input.focus();
                }
            }
            UpdateSelectedArray() {
                const me = this;
                let Value = "";
                let MultipleSelectedArray = "";
                const RefListChecked = me.Results.querySelectorAll("input:checked");
                let hasMultipleChecked = false;
                let inputSection = me.input.closest("section");
                let isInline = false;
                if (me.MobileDialog?.classList.contains("inline")) {
                    isInline = true;
                    inputSection = me.MobileDialog.querySelector(".ajaxinput-mobile-wrapper");
                }
                else if (inputSection?.classList.contains("inline")) {
                    isInline = true;
                }
                for (let i = 0, len = RefListChecked.length; i < len; i++) {
                    if (Value !== "") {
                        Value += "^";
                        hasMultipleChecked = true;
                    }
                    if (MultipleSelectedArray !== "") {
                        MultipleSelectedArray += "^";
                    }
                    Value += RefListChecked[i].value;
                    MultipleSelectedArray += RefListChecked[i].getAttribute("SelValue");
                }
                if (Value !== "" && MultipleSelectedArray !== "") {
                    me.hidden.setAttribute("SelArray", AjaxInput.HtmlEncode(Value));
                    if (me.IsSearch && me.NOT_SearchOn) {
                        me.hidden.value = "<>" + AjaxInput.HtmlEncode(Value);
                    }
                    else {
                        me.hidden.value = AjaxInput.HtmlEncode(Value);
                    }
                    if (!EC_Fmt.isMobile) {
                        me.input.focus();
                    }
                    me.input.setAttribute("KeyValue", Value);
                    me.input.setAttribute("SelArray", MultipleSelectedArray.replace(/\|/g, "{LINE}"));
                    me.input.setAttribute("DisplayVal", MultipleSelectedArray);
                    if (hasMultipleChecked) {
                        if (isInline) {
                            inputSection.querySelector(".selected-item").classList.remove("hidden");
                            inputSection.querySelector(".selected-item").innerHTML = RefListChecked.length.toString();
                            inputSection.querySelector(".multiple-selected").classList.remove("hidden");
                            me.input.value = "";
                        }
                        else {
                            me.input.value = "Multiple ...";
                        }
                        me.input.classList.add("Info");
                    }
                    else {
                        const htmlRemovedStr = AjaxInput.HtmlDecode(MultipleSelectedArray).replace(/<\/?[^>^@]+>/g, "");
                        if (isInline) {
                            inputSection.querySelector(".selected-item").classList.remove("hidden");
                            inputSection.querySelector(".selected-item").innerHTML = "1";
                            inputSection.querySelector(".multiple-selected").classList.add("hidden");
                            if (EC_Fmt.isMobile) {
                                if (!htmlRemovedStr) {
                                    me.input.value = AjaxInput.HtmlDecode(MultipleSelectedArray);
                                }
                                else {
                                    me.input.value = htmlRemovedStr.toString().replace(/\^/g, ", ");
                                }
                            }
                        }
                        else {
                            if (!htmlRemovedStr) {
                                me.input.value = AjaxInput.HtmlDecode(MultipleSelectedArray);
                            }
                            else {
                                me.input.value = htmlRemovedStr;
                            }
                        }
                        me.input.classList.remove("Info");
                        if (!EC_Fmt.isMobile) {
                            me.input.select();
                        }
                    }
                    me.SelectedIndex = -1;
                }
                else {
                    me.hidden.value = "";
                    me.input.value = "";
                    me.input.classList.remove("Info");
                    me.input.setAttribute("SelArray", "");
                    me.SelectedIndex = -1;
                    if (isInline) {
                        inputSection.querySelector(".selected-item").classList.add("hidden");
                        inputSection.querySelector(".multiple-selected").classList.add("hidden");
                    }
                }
                const htmlRemovedStr = me.input.value.replace(/<\/?[^>^@]+>/g, "");
                if (htmlRemovedStr) {
                    me.input.value = htmlRemovedStr;
                }
                if (EC_Fmt.isMobile) {
                    me.MobileInput.value = "";
                    if (isInline) {
                        me.MobileInput.placeholder = "Search";
                    }
                    else {
                        me.MobileInput.placeholder = me.input.value;
                    }
                }
                if (!me.IsSelectIng && me.OnChangeCallback instanceof Function) {
                    me.OnChangeCallback(me.input, me.hidden);
                    if (isInline && htmlRemovedStr) {
                        inputSection.classList.add("selected");
                    }
                }
                AllowHideAllDivs = true;
                me.isInternalUpdating = true;
            }
            CommitManualSearchValue() {
                const manualValue = EC_Fmt.Null2EmptyStr(this.input.value).trim();
                if (manualValue === "" || manualValue === "Multiple ...") {
                    return false;
                }
                let hasManualOption = false;
                const checkedInputs = this.Results?.querySelectorAll("input:checked");
                if (checkedInputs && checkedInputs.length > 0) {
                    for (let i = 0; i < checkedInputs.length; i++) {
                        const selValue = EC_Fmt.Null2EmptyStr(checkedInputs[i].getAttribute("SelValue"));
                        if (selValue === manualValue) {
                            hasManualOption = true;
                            break;
                        }
                    }
                }
                if (!hasManualOption && this.SelectedResults) {
                    const itemIndex = this.SelectedResults.querySelectorAll("div.AutocompleteItem").length;
                    const manualItem = document.createElement("div");
                    manualItem.className = "AutocompleteItem Highlight";
                    manualItem.id = `${this.FieldID}_Item_${itemIndex}`;
                    manualItem.setAttribute("encValue", manualValue);
                    manualItem.setAttribute("index", itemIndex.toString());
                    const manualCheckbox = document.createElement("input");
                    manualCheckbox.type = "checkbox";
                    manualCheckbox.checked = true;
                    manualCheckbox.value = manualValue;
                    manualCheckbox.setAttribute("SelValue", manualValue);
                    const manualLabel = document.createElement("label");
                    manualLabel.innerHTML = EC_Fmt.HTMLEncode(manualValue);
                    manualItem.appendChild(manualCheckbox);
                    manualItem.appendChild(manualLabel);
                    this.SelectedResults.appendChild(manualItem);
                    manualItem.addEventListener("click", (Event) => {
                        this.ClickSelectedItemCheck(Event, manualItem, manualCheckbox);
                    });
                    manualCheckbox.addEventListener("click", () => {
                        manualCheckbox.checked = !manualCheckbox.checked;
                    });
                }
                const checkedResults = this.Results?.querySelectorAll("input:checked");
                const displayValArray = [];
                const selArray = [];
                if (checkedResults && checkedResults.length > 0) {
                    for (let i = 0; i < checkedResults.length; i++) {
                        const selValue = EC_Fmt.Null2EmptyStr(checkedResults[i].getAttribute("SelValue"));
                        if (selValue !== "") {
                            displayValArray.push(selValue);
                            selArray.push(selValue.replace(/\|/g, "{LINE}"));
                        }
                    }
                }
                const nextDisplayVal = displayValArray.join("^");
                this.input.setAttribute("DisplayVal", nextDisplayVal);
                this.hidden.value = nextDisplayVal;
                const encodedDisplay = manualValue.replace(/\|/g, "{LINE}");
                if (!selArray.includes(encodedDisplay)) {
                    selArray.push(encodedDisplay);
                }
                this.input.setAttribute("SelArray", selArray.join("^"));
                this.hidden.setAttribute("SelArray", selArray.join("^"));
                const inputSection = this.input.closest("section");
                const valueCount = displayValArray.length;
                if (inputSection?.classList.contains("inline")) {
                    const selectedItem = inputSection.querySelector(".selected-item");
                    const multipleSelected = inputSection.querySelector(".multiple-selected");
                    if (selectedItem) {
                        selectedItem.innerHTML = valueCount.toString();
                        selectedItem.classList.remove("hidden");
                    }
                    if (multipleSelected) {
                        if (valueCount > 1) {
                            multipleSelected.classList.remove("hidden");
                        }
                        else {
                            multipleSelected.classList.add("hidden");
                        }
                    }
                    this.input.value = "";
                }
                else {
                    this.input.value = valueCount > 1 ? "Multiple ..." : manualValue;
                }
                this.input.classList.add("Info");
                this.SelectedIndex = -1;
                return true;
            }
            SetHiddenValue(value) {
                const normalizedValue = EC_Fmt.Null2EmptyStr(value);
                if (this.IsSearch && this.NOT_SearchOn && normalizedValue !== "" && !normalizedValue.startsWith("<>")) {
                    this.hidden.value = "<>" + normalizedValue;
                }
                else if ((!this.IsSearch || !this.NOT_SearchOn) && normalizedValue.startsWith("<>")) {
                    this.hidden.value = normalizedValue.substring(2);
                }
                else {
                    this.hidden.value = normalizedValue;
                }
            }
            PopulateFields(ItemIndex, NotForcedSingleResult, ListItem, Event) {
                const me = this;
                const inputSection = me.input.closest("section");
                let isInline = false;
                let oldHiddenValue = me.hidden.value;
                if (!(Event instanceof KeyboardEvent) && inputSection?.classList.contains("inline")) {
                    isInline = true;
                }
                if (!ListItem) {
                    ListItem = document.getElementById(`${me.FieldID}_Item_${ItemIndex}`);
                }
                if (!me.IsSearch) {
                    NotForcedSingleResult = false;
                }
                let Value;
                if (ItemIndex === -1 && me.hidden.value !== "") {
                    if (me.Required) {
                        if (EC_Fmt.isNull(me.input.getAttribute("KeyValue"))) {
                            me.SetHiddenValue(me.hidden.getAttribute("SelArray"));
                        }
                        else {
                            me.SetHiddenValue(me.input.getAttribute("KeyValue"));
                        }
                        if (me.IsSearch && me.hidden.value.indexOf("^") > -1) {
                            me.input.value = "Multiple ...";
                        }
                        else {
                            me.input.value = AjaxInput.HtmlDecode(me.input.getAttribute("DisplayVal"));
                        }
                    }
                    else {
                        Value = AjaxInput.HtmlEncode(me.input.getAttribute("KeyValue"));
                        Value = AjaxInput.HtmlDecode(Value.replace(EC_Fmt.get_searchOp(Value), ""));
                        me.SetHiddenValue(AjaxInput.HtmlEncode(Value));
                        if (me.IsSearch && me.hidden.value.indexOf("^") > -1) {
                            me.input.value = "Multiple ...";
                            me.input.classList.add("Info");
                        }
                        else {
                            const DisplayValue = AjaxInput.HtmlEncode(me.input.getAttribute("DisplayVal"));
                            me.input.value = AjaxInput.HtmlDecode(DisplayValue.replace(EC_Fmt.get_searchOp(DisplayValue), ""));
                            me.input.classList.remove("Info");
                        }
                    }
                }
                else if (ListItem && !NotForcedSingleResult) {
                    Value = AjaxInput.HtmlEncode(AjaxInput.HtmlDecode(ListItem.getAttribute("encValue")));
                    me.hidden.setAttribute("SelArray", Value);
                    me.SetHiddenValue(Value);
                    if (!AjaxInput.HtmlDecode(ListItem.innerText).trim()) {
                        me.input.value = AjaxInput.HtmlDecode(ListItem.innerHTML);
                    }
                    else {
                        me.input.value = AjaxInput.HtmlDecode(ListItem.innerText).trim();
                    }
                    me.input.setAttribute("SelArray", me.input.value.replace(/\|/g, "{LINE}"));
                    me.input.setAttribute("DisplayVal", me.input.value);
                    me.input.classList.remove("Info");
                    if (me.input.value === "NOT NULL") {
                        me.input.setAttribute("SelArray", "");
                    }
                    if (me.LimitToList) {
                        me.SelectedIndex = ItemIndex;
                    }
                    else {
                        me.SelectedResults.innerHTML = "";
                    }
                }
                else if (ListItem && NotForcedSingleResult) {
                    Value = "";
                    let MultipleSelectedArray = "";
                    const CheckedResults = me.Results.querySelectorAll("input:checked");
                    for (let i = 0, len = CheckedResults.length; i < len; i++) {
                        if (Value !== "") {
                            Value += "^";
                        }
                        if (MultipleSelectedArray !== "") {
                            MultipleSelectedArray += "^";
                        }
                        Value += CheckedResults[i].value;
                        MultipleSelectedArray += CheckedResults[i].getAttribute("SelValue");
                    }
                    Value = AjaxInput.HtmlEncode(Value);
                    me.hidden.setAttribute("SelArray", Value);
                    me.SetHiddenValue(Value);
                    if (CheckedResults.length > 1) {
                        if (isInline) {
                            me.input.value = MultipleSelectedArray.replace(/\|/g, ", ");
                        }
                        else {
                            me.input.value = "Multiple ...";
                        }
                        me.input.classList.add("Info");
                    }
                    else {
                        let TextElement = ListItem.querySelector("label");
                        if (!TextElement) {
                            TextElement = ListItem.querySelector("td:nth-child(2)");
                        }
                        if (!AjaxInput.HtmlDecode(TextElement.innerText).trim()) {
                            me.input.value = AjaxInput.HtmlDecode(TextElement.innerHTML);
                        }
                        else {
                            me.input.value = AjaxInput.HtmlDecode(TextElement.innerText).trim();
                        }
                        me.input.classList.remove("Info");
                    }
                    me.input.setAttribute("SelArray", MultipleSelectedArray.replace(/\|/g, "{LINE}"));
                    me.input.setAttribute("DisplayVal", MultipleSelectedArray);
                }
                if (!me.IsSearch && !NotForcedSingleResult && Event instanceof KeyboardEvent) {
                    if (oldHiddenValue !== me.hidden.value) {
                        me.Results.classList.add("animation-disappear-to-bottom");
                    }
                    else {
                        me.Results.classList.add("animation-disappear-to-top");
                    }
                    me.AbortRunningAjaxCall();
                }
                if (this.IsSearch && isInline && ItemIndex === -1) {
                    me.input.value = "";
                }
                else if (inputSection.classList.contains("inline")) {
                    inputSection.querySelector(".multiple-selected").classList.add("hidden");
                    inputSection.querySelector(".selected-item").classList.add("hidden");
                }
            }
            static HtmlEncode(value) {
                if (typeof value === "string") {
                    return value.replace(/[|]/g, "&#124;").replace(/[~]/g, "&#126;").replace(/[`]/g, "&#96;");
                }
                return value;
            }
            static HtmlDecode(value) {
                if (typeof value === "string") {
                    return value.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, "\"").replace(/&#124;/g, "|").replace(/&#126;/g, "~").replace(/&#96;/g, "`")
                        .trim();
                }
                return value;
            }
            static MobileInit(me) {
                if (!me.MobileDialog) {
                    me.MobileDialog = document.createElement("section");
                    me.MobileDialog.id = EC_Fmt.CssEscape(me.FieldID) + "_MobileResult";
                    const inputSection = me.input.closest("section");
                    let isInline = false;
                    if (inputSection?.classList.contains("inline")) {
                        me.MobileDialog.classList.add("inline");
                        isInline = true;
                    }
                    me.MobileDialog.classList.add("inline-style");
                    if (me.NOT_SearchOn) {
                        me.MobileDialog.classList.add("excludes");
                    }
                    let htmlB = `<div class="ews-dialog ews-dialog-mobile animation-appear-from-top motion-moderate" style="width:100%;height:100%;z-index:270;display:flex;flex-direction:column">`;
                    let toolbar = "";
                    if (me.IsSearch) {
                        toolbar += "<div class=toolbar><span name=SelectAll>Select all</span>"
                            + "<span name=Clear>Clear</span>"
                            + "<ecp-btn name=Go class=hidden>Go</ecp-btn><ecp-btn type=primary name=OK class=hidden>OK</ecp-btn>";
                        if (!me.DisableNotIn) {
                            toolbar += `<ecp-switch size="small" active-color="bg-error" ${me.NOT_SearchOn ? "checked" : ""} name=AjaxNOT class=${me.NOT_SearchOn ? "excludes" : ""}>Exclude</ecp-switch>`;
                        }
                        toolbar += "</div>";
                    }
                    let inlineLabel = inputSection.querySelector(".label-inline")?.innerHTML;
                    if (inlineLabel && !inlineLabel.endsWith(':')) {
                        inlineLabel += ":";
                    }
                    htmlB += "<div class=ews-dialog-content style=display:flex;flex-direction:column;flex:1;overflow:auto;padding-top:10px>"
                        + `<div class='ajaxinput-mobile-wrapper AutocompleteField' style="${me.IsSearch ? "" : "margin-bottom:10px"}">`
                        + "<div class=ajax-input-delete-wrapper>";
                    if (me.LimitToList) {
                        htmlB += "<span class=ews-icon-caretdown></span>";
                    }
                    else {
                        htmlB += "<span class=ews-icon-ajaxinput></span>";
                    }
                    let defaultVal = 0;
                    if (isInline && me.IsSearch && me.input.value) {
                        if (me.input.value.split(",").length > 1) {
                            defaultVal = me.input.value.split(",").length;
                        }
                        else {
                            defaultVal = 1;
                        }
                    }
                    me.input.setAttribute("enterkeyhint", "Done");
                    htmlB += "</div>"
                        + `<label class="${inlineLabel ? 'label-inline' : 'label-inline hidden'}">${inlineLabel}</label><label class="excludes ${me.NOT_SearchOn ? "" : "hidden"}">Excludes</label>`
                        + `<label class="${defaultVal > 0 ? 'multiple-selected' : 'multiple-selected hidden'}"></label><label class="${defaultVal > 0 ? 'selected-item' : 'selected-item hidden'}">${defaultVal}</label>`
                        + me.input.outerHTML
                        + "</div>"
                        + toolbar
                        + "<div class=ajaxinput-list-mobile style=height:auto;width:100%;display:flex;flex-direction:column;flex:1;overflow:auto;top:0;left:0;box-sizing:border-box>"
                        + "<div></div>"
                        + "<div></div>"
                        + "</div>"
                        + "</div></div>";
                    me.MobileDialog.innerHTML = htmlB;
                    document.body.appendChild(me.MobileDialog);
                    me.MobileDialog.addEventListener("click", (event) => {
                        event.stopPropagation();
                        const maskDiv = event.target;
                        if (maskDiv.classList.contains("ews-dialog-mobile")) {
                            me.CurSearchStr = "";
                            AjaxInput.MobileSaveToInput(me);
                        }
                        return false;
                    });
                    me.Results = me.MobileDialog.querySelector("div.ajaxinput-list-mobile");
                    me.MobileDialog.addEventListener("animationend", () => {
                        if (me.MobileDialog.classList.contains("animation-disappear-to-top") || me.MobileDialog.classList.contains("animation-disappear-to-bottom")) {
                            me.MobileDialog.classList.remove("animation-disappear-to-top", "animation-appear-from-top", "animation-disappear-to-bottom");
                            const inputSection = me.input.closest("section");
                            if (inputSection?.classList.contains("inline")) {
                                inputSection.querySelector(".selected-item").classList.add("hidden");
                                inputSection.querySelector(".multiple-selected").classList.add("hidden");
                                me.input.value = EC_Fmt.ReplaceAll(me.input.getAttribute("displayval"), "^", ", ");
                                const CheckedListItems = me.input.getAttribute("displayval").split(",");
                                if (textSize("13px", me.input.value) > me.input.clientWidth && CheckedListItems.length > 1) {
                                    inputSection.querySelector(".multiple-selected-num").classList.remove("hidden");
                                    inputSection.querySelector(".multiple-selected-num").lastElementChild.innerHTML = "+" + CheckedListItems.length;
                                }
                            }
                        }
                    });
                    me.SelectedResults = me.Results.firstElementChild;
                    me.SearchedResults = me.Results.lastElementChild;
                    me.MobileInput = me.MobileDialog.querySelector("div.ajaxinput-mobile-wrapper input");
                    me.MobileInput.addEventListener("click", (event) => {
                        if (me.IsSearch && me.MobileInput.value === "Multiple ...") {
                            event.preventDefault();
                            requestAnimationFrame(() => {
                                me.MobileInput.focus();
                            });
                        }
                        return false;
                    });
                    me.MobileInput.addEventListener("keydown", (event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                            me.CurSearchStr = "";
                            AjaxInput.MobileSaveToInput(me);
                        }
                    });
                    if (EC_Fmt.isIOS) {
                        const listEl = me.MobileDialog.querySelector(".ews-dialog-content");
                        listEl.style.height = "95vh";
                        me.MobileInput.addEventListener("focus", () => {
                            setTimeout(() => {
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                            }, 500);
                        });
                    }
                    if (me.OnChangeCallback instanceof Function) {
                        me.MobileInput.addEventListener("change", me.OnChange);
                    }
                    me.MobileInput.placeholder = "Search";
                    me.MobileInput.value = "";
                    EC_Fmt.AfterInput(me.MobileInput, 1, 400, () => {
                        me.CurSearchStr = AjaxInput.HtmlEncode(me.MobileInput.value);
                        me.RequestResults(me.MobileInput.value ? false : true);
                    }, true);
                    const DeleteText = me.MobileDialog.querySelector("div.ajax-input-delete-wrapper");
                    DeleteText.addEventListener("click", () => {
                        const Checkboxes = me.Results.querySelectorAll("input[type='checkbox']:checked");
                        if (Checkboxes && Checkboxes.length === 1) {
                            Checkboxes[0].parentElement.classList.remove("Highlight", "On");
                            EC_Fmt.TriggerEvent(Checkboxes[0].parentElement, "click");
                        }
                        else {
                            const item = me.Results.querySelectorAll("div.Highlight");
                            if (item && item.length === 1) {
                                item[0].classList.remove("Highlight", "On");
                                me.hidden.value = "";
                                me.input.value = "";
                                me.OnChangeCallback(me.input, me.hidden);
                            }
                        }
                        me.MobileInput.placeholder = "";
                        me.MobileInput.value = "";
                        me.CurSearchStr = "";
                        requestAnimationFrame(() => {
                            me.MobileInput.focus();
                        });
                    });
                    const OkButtons = me.MobileDialog.querySelectorAll("ecp-btn[name='OK']");
                    const OkButtonClick = (event) => {
                        event.stopPropagation();
                        me.CurSearchStr = "";
                        AjaxInput.MobileSaveToInput(me);
                        return false;
                    };
                    for (let i = 0; i < OkButtons.length; i++) {
                        OkButtons[i].addEventListener("click", OkButtonClick);
                    }
                    const GoButtons = me.MobileDialog.querySelectorAll("ecp-btn[name='Go']");
                    if (GoButtons && GoButtons.length > 0) {
                        const GoButtonClick = (event) => {
                            event.stopPropagation();
                            AjaxInput.MobileSaveToInput(me);
                            ECP.Dialog.ShowLoading();
                            const myAjaxForm = me.input.closest("form");
                            if (myAjaxForm) {
                                if (EC_Fmt.TriggerEvent(myAjaxForm, "submit")) {
                                    myAjaxForm.submit();
                                }
                            }
                            else {
                                ECP.Dialog.HideLoading();
                            }
                            return false;
                        };
                        for (let i = 0; i < GoButtons.length; i++) {
                            GoButtons[i].addEventListener("click", GoButtonClick);
                        }
                    }
                    let ClearButtons = me.MobileDialog.querySelector("span[name='Clear']");
                    if (ClearButtons) {
                        const ClearButtonClick = (event) => {
                            event.stopPropagation();
                            me.MobileInput.value = "";
                            me.IsSelectIng = true;
                            requestAnimationFrame(() => {
                                me.MobileInput.focus();
                            });
                            const Checkboxes = me.Results.querySelectorAll("input[type='checkbox']:checked");
                            for (let i = 0; i < Checkboxes.length; i++) {
                                if (i === Checkboxes.length - 1) {
                                    me.IsSelectIng = false;
                                }
                                if (Checkboxes[i].checked) {
                                    Checkboxes[i].parentElement.classList.remove("Highlight", "On");
                                    EC_Fmt.TriggerEvent(Checkboxes[i].parentElement, "click");
                                }
                            }
                            me.IsSelectIng = false;
                        };
                        ClearButtons.addEventListener("click", ClearButtonClick);
                    }
                    let SelectAllButtons = me.MobileDialog.querySelector("span[name='SelectAll']");
                    if (SelectAllButtons) {
                        const SelectAllButtonClick = (event) => {
                            event.stopPropagation();
                            me.IsSelectIng = true;
                            const Checkboxes = me.Results.querySelectorAll("input:not(:checked)");
                            const CheckboxesLength = Checkboxes.length;
                            for (let i = 0; i < CheckboxesLength; i++) {
                                if (i === CheckboxesLength - 1) {
                                    me.IsSelectIng = false;
                                }
                                if (!Checkboxes[i].checked) {
                                    EC_Fmt.TriggerEvent(Checkboxes[i].parentElement, "click");
                                }
                            }
                            me.IsSelectIng = false;
                        };
                        SelectAllButtons.addEventListener("click", SelectAllButtonClick);
                    }
                    if (!me.DisableNotIn) {
                        const NotInButton = me.MobileDialog.querySelector("ecp-switch");
                        if (NotInButton) {
                            NotInButton.addEventListener("click", (event) => {
                                event.stopPropagation();
                                me.NOT_SearchOn = !me.NOT_SearchOn;
                                if (me.hidden.value !== "") {
                                    if (me.NOT_SearchOn && !me.hidden.value.startsWith("<>")) {
                                        me.hidden.value = "<>" + me.hidden.value;
                                    }
                                    else if (me.hidden.value.startsWith("<>")) {
                                        me.hidden.value = me.hidden.value.substring(2);
                                    }
                                }
                                const inputSection = me.input.closest("section");
                                if (inputSection?.classList.contains("inline")) {
                                    const labelNode = me.MobileDialog.querySelector("label.excludes");
                                    labelNode.classList.toggle("hidden");
                                    if (!me.MobileDialog.querySelector("label.label-inline").innerHTML.endsWith(":") && NotInButton.checked) {
                                        me.MobileDialog.querySelector("label.label-inline").innerHTML += ":";
                                    }
                                    else if (!me.hidden.value && !NotInButton.checked) {
                                        me.MobileDialog.querySelector("label.label-inline").innerHTML.replace(":", "");
                                    }
                                    inputSection.querySelector(".excludes").classList.toggle("hidden");
                                    if (!inputSection.querySelector(".label-inline").innerHTML.endsWith(":")) {
                                        inputSection.querySelector(".label-inline").innerHTML += ":";
                                    }
                                }
                                me.MobileDialog.classList.toggle("excludes");
                            });
                        }
                    }
                }
                else {
                    me.CurSearchStr = "";
                    me.MobileDialog.style.display = "";
                }
                let maxZIndex = 300;
                const mobileDialogs = document.querySelectorAll(".ews-dialog.ews-dialog-mobile");
                for (let i = 0; i < mobileDialogs.length; i++) {
                    const zIndex = parseInt(getComputedStyle(mobileDialogs[i]).zIndex, 10);
                    if (zIndex > maxZIndex) {
                        maxZIndex = zIndex;
                    }
                }
                me.MobileDialog.querySelector(".ews-dialog.ews-dialog-mobile").style.zIndex = (maxZIndex + 10).toString();
                setTimeout(() => {
                    me.MobileInput.focus();
                    me.MobileInput.setSelectionRange(0, me.MobileInput.value.length);
                    me.MobileInput.scrollLeft = 0;
                }, 100);
                me.SelectedResults.innerHTML = "";
                me.SearchedResults.innerHTML = "";
                if (me.IsSearch || me.input.hasAttribute("AutoLoadResults")) {
                    me.RequestResults(true);
                }
            }
            static MobileSaveToInput(me) {
                me.MobileDialog.style.display = "none";
                me.MobileDialog.classList.add("animation-disappear-to-top");
                const FirstSelectedCheckbox = me.Results.querySelector("input[type='checkbox']:checked");
                const searchOp = FirstSelectedCheckbox ? EC_Fmt.get_searchOp(FirstSelectedCheckbox.value) : "";
                if (me.IsSearch && (!FirstSelectedCheckbox || me.MobileInput.value !== "" || (searchOp !== "" && searchOp !== "IS NULL" && searchOp !== "NOT IS NULL"))) {
                    switch (EC_Fmt.Null2EmptyStr(me.MobileInput.value).toUpperCase()) {
                        case "NOT NULL":
                        case "NOT IS NULL":
                        case "IS NOT NULL":
                        case "ANY VALUE":
                            me.MobileInput.value = "NOT IS NULL";
                            break;
                        case "IS NULL":
                        case "NULL":
                        case "NO VALUE":
                            me.MobileInput.value = "IS NULL";
                            break;
                    }
                    const Value = EC_Fmt.Null2EmptyStr(me.MobileInput.value);
                    me.input.value = Value;
                    me.hidden.value = Value;
                    me.input.setAttribute("SelArray", "");
                    me.hidden.setAttribute("SelArray", "");
                }
                if (!me.IsSearch && (!me.LimitToList || !me.Required) && EC_Fmt.isNull(me.MobileInput.value)) {
                    me.input.value = "";
                    me.hidden.value = "";
                    me.input.setAttribute("SelArray", "");
                    me.hidden.setAttribute("SelArray", "");
                }
                me.OnBlur(undefined);
                me.SelectedResults.innerHTML = "";
                me.SearchedResults.innerHTML = "";
            }
        }
        HTML.AjaxInput = AjaxInput;
        const Controls = [];
        function AddControl(Control) {
            switch (Control) {
                case ControlType.Gridster:
                    {
                        if (!Controls.includes("Controls/Gridster.js")) {
                            Controls.push("Controls/Gridster.js");
                        }
                        break;
                    }
                case ControlType.Document:
                    {
                        AddControl(ControlType.HtmlEdit);
                        if (!Controls.includes("Controls/Document.css")) {
                            Controls.push("Controls/Document.css");
                        }
                        if (!Controls.includes("Controls/Document.js")) {
                            Controls.push("Controls/Document.js");
                        }
                        if (!Controls.includes("Controls/Tinymce/tinymce.js")) {
                            Controls.push("Controls/Tinymce/tinymce.js");
                        }
                        if (!Controls.includes("Controls/TinymceEdit.js")) {
                            Controls.push("Controls/TinymceEdit.js");
                        }
                        break;
                    }
                case ControlType.FileExport:
                    {
                        AddControl(ControlType.JsonPath);
                        if (!Controls.includes("Controls/FileExport.js")) {
                            Controls.push("Controls/FileExport.js");
                        }
                        break;
                    }
                case ControlType.FileImport:
                    {
                        if (!Controls.includes("Services/FileImport.js")) {
                            Controls.push("Services/FileImport.js");
                        }
                        break;
                    }
                case ControlType.HtmlEdit:
                    {
                        if (!Controls.includes("Controls/Tinymce/tinymce.js")) {
                            Controls.push("Controls/Tinymce/tinymce.js");
                        }
                        if (!Controls.includes("Controls/TinymceEdit.js")) {
                            Controls.push("Controls/TinymceEdit.js");
                        }
                        break;
                    }
                case ControlType.JsonPath:
                    {
                        if (!Controls.includes("Controls/JsonPath.js")) {
                            Controls.push("Controls/JsonPath.js");
                        }
                        break;
                    }
                case ControlType.PrintPreview:
                    {
                        if (!Controls.includes("Controls/PrintPreview.css")) {
                            Controls.push("Controls/PrintPreview.css");
                        }
                        if (!Controls.includes("Controls/PrintPreview.js")) {
                            Controls.push("Controls/PrintPreview.js");
                        }
                        break;
                    }
                case ControlType.QuickLink:
                    {
                        AddControl(ControlType.SendMessage);
                        if (!Controls.includes("Controls/QuickLinkAjax.css")) {
                            Controls.push("Controls/QuickLinkAjax.css");
                        }
                        if (!Controls.includes("Controls/QuickLinkAjax.js")) {
                            Controls.push("Controls/QuickLinkAjax.js");
                        }
                        break;
                    }
                case ControlType.SendMessage:
                    {
                        AddControl(ControlType.HtmlEdit);
                        if (!Controls.includes("Controls/SendMessage.css")) {
                            Controls.push("Controls/SendMessage.css");
                        }
                        if (!Controls.includes("Controls/SendMessage.js")) {
                            Controls.push("Controls/SendMessage.js");
                        }
                        break;
                    }
                case ControlType.Table:
                    {
                        if (!Controls.includes("Controls/Table.css")) {
                            Controls.push("Controls/Table.css");
                        }
                        if (!Controls.includes("Controls/Table.js")) {
                            Controls.push("Controls/Table.js");
                        }
                        break;
                    }
                case ControlType.Calendar:
                    {
                        if (!Controls.includes("includes/Styles/DashboardCalendar.css")) {
                            Controls.push("includes/Styles/DashboardCalendar.css");
                        }
                        if (!Controls.includes("Controls/DashboardCalendar_INC.js")) {
                            Controls.push("Controls/DashboardCalendar_INC.js");
                        }
                        break;
                    }
            }
        }
        HTML.AddControl = AddControl;
        async function LoadControls(sync) {
            if (!sync) {
                for (let i = 0, len = Controls.length; i < len; i++) {
                    EC_Fmt.LoadScript(Controls[i]);
                }
            }
            else {
                for (let i = 0, len = Controls.length; i < len; i++) {
                    await EC_Fmt.LoadScript(Controls[i]);
                }
            }
        }
        HTML.LoadControls = LoadControls;
        function RenderHtmlTemplate(template, data) {
            return ECPTemplateCompiler.render(template, data);
        }
        HTML.RenderHtmlTemplate = RenderHtmlTemplate;
        async function LoadWebComponent(name) {
            const response = await fetch(`UI/WebComponents/${name}${ReleasedCode ? ".min" : ""}.html?v=${ECPVersion}`, {
                credentials: "same-origin"
            });
            const webComponent = await response.text();
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = webComponent;
            document.body.appendChild(tempDiv);
            const scripts = tempDiv.querySelectorAll("script");
            for (let i = 0, len = scripts.length; i < len; i++) {
                const actionFn = new Function(scripts[i].textContent);
                actionFn();
            }
        }
        HTML.LoadWebComponent = LoadWebComponent;
        function ReplaceEncDateInput(EncDateInputElement) {
        }
        HTML.ReplaceEncDateInput = ReplaceEncDateInput;
        function DateInput(FieldName, FieldID, Required, CurVal, FieldTitle, TabIndex = "", Width = 100, HideOtherMenus = true, Placeholder = "", StartDate = "", EndDate = "", ExcludeDates = []) {
            return `<ecp-input type=date SubTabValue="Custom" PickerType=single name="${FieldName}"id="${FieldID}"Required="${Required}"value="${CurVal}"FieldTitle="${FieldTitle}"TabIndex="${TabIndex}"Width="${Width}"Placeholder="${EC_Fmt.Null2EmptyStr(Placeholder)}"StartDate="${EC_Fmt.Null2EmptyStr(StartDate)}"EndDate="${EC_Fmt.Null2EmptyStr(EndDate)}"ExcludeDates="${(Array.isArray(ExcludeDates) ? ExcludeDates : []).join(",")}"></ecp-input>`;
        }
        HTML.DateInput = DateInput;
        function DateRangeInput(FieldName, FieldID, Required, CurVal, FieldTitle, TabIndex = "", Width = 100, HideOtherMenus = true, Placeholder = "", StartDate = "", EndDate = "", ExcludeDates = []) {
            return `<ecp-input type=date SubTabValue=Custom PickerType=range name="${FieldName}"id="${FieldID}"Required="${Required}"value="${CurVal}"FieldTitle="${FieldTitle}"TabIndex="${TabIndex}"Width="${Width}"Placeholder="${EC_Fmt.Null2EmptyStr(Placeholder)}"StartDate="${EC_Fmt.Null2EmptyStr(StartDate)}"EndDate="${EC_Fmt.Null2EmptyStr(EndDate)}"ExcludeDates="${(Array.isArray(ExcludeDates) ? ExcludeDates : []).join(",")}"></ecp-input>`;
        }
        HTML.DateRangeInput = DateRangeInput;
        function DateTimeInput(FieldName, FieldID, Required, CurVal, FieldTitle, TabIndex = "", Width = 100, HideOtherMenus = true, Placeholder = "", StartDate = "", EndDate = "", ExcludeDates = []) {
            return `<ecp-input IncludeTime=true type=datetime SubTabValue=Custom PickerType=single  name="${FieldName}"id="${FieldID}"Required="${Required}"value="${CurVal}"FieldTitle="${FieldTitle}"TabIndex="${TabIndex}"Width="${Width}"Placeholder="${EC_Fmt.Null2EmptyStr(Placeholder)}"StartDate="${EC_Fmt.Null2EmptyStr(StartDate)}"EndDate="${EC_Fmt.Null2EmptyStr(EndDate)}"ExcludeDates="${(Array.isArray(ExcludeDates) ? ExcludeDates : []).join(",")}"></ecp-input>`;
        }
        HTML.DateTimeInput = DateTimeInput;
        function DateTimeRangeInput(name, id, Required, value, FieldTitle, TabIndex = "", Width = 100, HideOtherMenus = true, Placeholder = "", StartDate = "", EndDate = "", ExcludeDates = []) {
            return `<ecp-input type=datetime SubTabValue=Custom PickerType=range IncludeTime=true name="${name}"id="${id}"Required="${Required}"value="${value}"FieldTitle="${FieldTitle}"TabIndex="${TabIndex}"Width="${Width}"Placeholder="${EC_Fmt.Null2EmptyStr(Placeholder)}"StartDate="${EC_Fmt.Null2EmptyStr(StartDate)}"EndDate="${EC_Fmt.Null2EmptyStr(EndDate)}"ExcludeDates="${(Array.isArray(ExcludeDates) ? ExcludeDates : []).join(",")}"></ecp-input>`;
        }
        HTML.DateTimeRangeInput = DateTimeRangeInput;
        function DatePickerInput(FieldName, FieldID, Required, CurVal, Type, FieldTitle, PickerType = "", SubTabValue = "", SelectorType = "", SelectorTypeArr = [], Width = 100, TabIndex = "", HideOtherMenus = true, Placeholder = "", StartDate = "", EndDate = "", ExcludeDates = []) {
            return `<ecp-input type=${Type} PickerType=${PickerType} SubTabValue=${SubTabValue} SelectorType=${SelectorType} SelectorTypeArr=${SelectorTypeArr} name="${FieldName}"id="${FieldID}"Required="${Required}"value="${CurVal}"FieldTitle="${FieldTitle}"TabIndex="${TabIndex}"Width="${Width}"Placeholder="${EC_Fmt.Null2EmptyStr(Placeholder)}"StartDate="${EC_Fmt.Null2EmptyStr(StartDate)}"EndDate="${EC_Fmt.Null2EmptyStr(EndDate)}"ExcludeDates="${(Array.isArray(ExcludeDates) ? ExcludeDates : []).join(",")}"></ecp-input>`;
        }
        HTML.DatePickerInput = DatePickerInput;
        class Calendar {
            constructor(CurDate, IncludeTime, RangeTitle, DisplayOK, PositionFunction, SelectDateFunction, ChangeYearAndMonthFunction, ChangeTimeFunction, ClickRangeFunction, RefStartDate, FieldID, displayInput, StartDate, EndDate, ExcludeDates) {
                this.CurDate = new Date(CurDate);
                this.SelectedDate = new Date(CurDate);
                this.IncludeTime = IncludeTime;
                this.RangeTitle = RangeTitle;
                this.DisplayOK = DisplayOK;
                this.PositionFunction = PositionFunction;
                this.SelectDateFunction = SelectDateFunction;
                this.ChangeYearAndMonthFunction = ChangeYearAndMonthFunction;
                this.ChangeTimeFunction = ChangeTimeFunction;
                this.ClickRangeFunction = ClickRangeFunction;
                this.RefStartDate = RefStartDate;
                this.StartDate = StartDate;
                this.EndDate = EndDate;
                this.ExcludeDates = ExcludeDates;
                this.DisplayCalendar = this.DisplayCalendar.bind(this);
                this.DisplayMonthSelection = this.DisplayMonthSelection.bind(this);
                this.NextMonth = this.NextMonth.bind(this);
                this.PrevMonth = this.PrevMonth.bind(this);
                this.NextYear = this.NextYear.bind(this);
                this.PrevYear = this.PrevYear.bind(this);
                this.SetYear = this.SetYear.bind(this);
                this.SetMonth = this.SetMonth.bind(this);
                this.ClickDateEvent = this.ClickDateEvent.bind(this);
                this.ClickDate = this.ClickDate.bind(this);
                this.HighlightRange = this.HighlightRange.bind(this);
                if (!document.getElementById("Enc_DateCalendarStyle")) {
                    const DateCalendarStyle = document.createElement("style");
                    DateCalendarStyle.id = "Enc_DateCalendarStyle";
                    DateCalendarStyle.textContent = ".DateInputCalendar{position:fixed;z-index:100000;box-shadow:2px 2px 6px var(--neutral-50);background-color:var(--bg);border-radius:8px;font-size:11px;text-align:center;user-select:none;margin:1px}"
                        + ".DateInputCalendar thead td{color:var(--neutral-60)}"
                        + ".DateInputCalendar .Previous, .DateInputCalendar .Title, .DateInputCalendar .Next{height:24px;cursor:pointer;border-radius:8px;color:var(--text);transition:background-color .2s}"
                        + ".DateInputCalendar .Previous:hover, .DateInputCalendar .Title:hover, .DateInputCalendar .Next:hover{background-color:#ddd}"
                        + ".DateInputCalendar .Previous, .DateInputCalendar .Next{width:24px;line-height:19px}"
                        + ".DateInputCalendar .Title{font-size:11px;font-weight:bold}"
                        + ".DateInputCalendar tbody td:not(.empty){cursor:pointer;background-color:var(--bg);transition:border .2s,background-color .2s}"
                        + ".DateInputCalendar tbody:not(.MonthView) td div {padding:5px 8px;border:1px transparent solid;transition:border .2s,background-color .2s;border-radius:5px}"
                        + "@media only screen and (max-device-width: 736px) and (orientation: portrait){.DateInputCalendar tbody:not(.MonthView) td div {padding:5px 6px}}"
                        + ".DateInputCalendar tbody:not(.MonthView) td div:hover{border-color:var(--enc-sector-color, #b80000);background:var(--bg)}"
                        + ".DateInputCalendar tbody.MonthView div{padding:5px;border:1px transparent solid;transition:border .2s;border-radius:5px}"
                        + ".DateInputCalendar tbody.MonthView div:hover{border-color:var(--enc-sector-color, #b80000)}"
                        + ".DateInputCalendar tbody.MonthView tr td:last-of-type{border-left:1px solid var(--neutral-80)}"
                        + ".DateInputCalendar .DateOkAction{cursor:pointer;padding:2px 5px!important;border-radius:8px;transition:background-color .2s;color:var(--text);font-weight:700}"
                        + ".DateInputCalendar .DateOkAction:hover{background-color:#ddd}"
                        + ".DateInputCalendar .currentDate{border-bottom:1px var(--neutral-80) dashed!important}"
                        + ".DateInputCalendar .refStartDate{border:1px var(--neutral-50) dashed!important}"
                        + ".DateInputCalendar .selectedDate{border:1px var(--enc-sector-color, #b80000) solid!important}"
                        + ".DateInputCalendar tbody td:not(.empty).rangeHighlight{background-color:var(--neutral-20)}"
                        + ".DateInputCalendar .TimeRangeBtn{text-align:center;height:18px;font-size:13px;color:var(--text)}"
                        + ".DateInputCalendar .TimeRangeBtnHover{cursor:pointer;color:var(--neutral-60)}"
                        + ".DateInputCalendar .TimeRangeBtnHover:hover{color:var(--text)}"
                        + ".DateInputCalendar .DayDiffDisplay{position:fixed;height:16px;padding:3px;background-color:var(--bg);box-shadow:2px 2px 6px #bbb!important;border-radius:5px;display:none}";
                    document.head.appendChild(DateCalendarStyle);
                }
                this.CalendarElement = document.createElement("table");
                this.CalendarElement.id = `${EC_Fmt.Null2EmptyStr(FieldID)}_Calendar`;
                this.CalendarElement.classList.add("DateInputCalendar", "Hideable", "NoPadding");
                this.CalendarElement.addEventListener("click", () => {
                    AllowHideAllDivs = false;
                }, true);
                document.body.appendChild(this.CalendarElement);
                if (displayInput) {
                    this.AddCalendarMutationObserver(displayInput);
                }
            }
            AddCalendarMutationObserver(displayInput) {
                const myCalendarMutationObserver = new MutationObserver((mutations) => {
                    for (let i = 0, len = mutations.length; i < len; i++) {
                        const mutation = mutations[i];
                        if (mutation.type === "attributes") {
                            const target = mutation.target;
                            if (target.style.display === "none" && displayInput.getAttribute("haschangevalue") === "true") {
                                EC_Fmt.TriggerEvent(displayInput, "blur");
                                EC_Fmt.TriggerEvent(displayInput, "change");
                            }
                            else {
                                displayInput.setAttribute("haschangevalue", "false");
                            }
                        }
                    }
                });
                myCalendarMutationObserver.observe(this.CalendarElement, { attributes: true });
            }
            DisplayCalendar() {
                this.CalendarElement.innerHTML = "";
                const year = this.CurDate.getFullYear();
                const month = this.CurDate.getMonth();
                const today = new Date();
                const tHeader = document.createElement("thead");
                let htmlB = "";
                if (this.RangeTitle) {
                    htmlB += `<tr><td colspan=100% class="TimeRangeBtn${this.ClickRangeFunction ? " TimeRangeBtnHover" : ""}">${this.RangeTitle}</td></tr>`;
                }
                htmlB += `<tr><td class=Previous><span class=ews-icon-previous></span></td><td colspan=5 class=Title>${EC_Fmt.MonthNames[month]} ${year}</td><td class=Next><span class=ews-icon-next></span></td></tr>`
                    + "<tr><td>Sun</td><td>Mon</td><td>Tue</td><td>Wed</td><td>Thu</td><td>Fri</td><td>Sat</td></tr>";
                tHeader.innerHTML = htmlB;
                this.CalendarElement.appendChild(tHeader);
                this.tBody = document.createElement("tbody");
                const firstDay = (new Date(year, month)).getDay();
                const daysInMonth = 32 - new Date(year, month, 32).getDate();
                const IsTodaysMonth = year === today.getFullYear() && month === today.getMonth();
                const IsSelectedMonth = year === this.SelectedDate.getFullYear() && month === this.SelectedDate.getMonth();
                const IsRefStartDateMonth = this.RefStartDate && year === this.RefStartDate.getFullYear() && month === this.RefStartDate.getMonth();
                let date = 1;
                let currentDate;
                for (let i = 0; i < 6; i++) {
                    const row = document.createElement("tr");
                    for (let j = 0; j < 7; j++) {
                        if (i === 0 && j < firstDay) {
                            const cell = document.createElement("td");
                            cell.classList.add("empty");
                            row.appendChild(cell);
                        }
                        else if (date > daysInMonth) {
                            break;
                        }
                        else {
                            const contentDiv = document.createElement("div");
                            contentDiv.textContent = date.toString();
                            if (IsTodaysMonth && date === today.getDate()) {
                                contentDiv.classList.add("currentDate");
                            }
                            if (IsSelectedMonth && date === this.SelectedDate.getDate()) {
                                contentDiv.classList.add("selectedDate");
                            }
                            else if (IsRefStartDateMonth && date === this.RefStartDate.getDate()) {
                                contentDiv.classList.add("refStartDate");
                            }
                            currentDate = new Date(year, month, date);
                            const cell = document.createElement("td");
                            if (this.StartDate || this.EndDate) {
                                if ((this.StartDate && currentDate < this.StartDate) || (this.EndDate && currentDate > this.EndDate)) {
                                    cell.classList.add("disabled");
                                }
                            }
                            if (this.ExcludeDates && this.ExcludeDates.length > 0) {
                                for (let k = 0; k < this.ExcludeDates.length; k++) {
                                    const ExcludeDate = this.ExcludeDates[k];
                                    if (ExcludeDate.getTime() === currentDate.getTime()) {
                                        cell.classList.add("disabled");
                                    }
                                }
                            }
                            cell.appendChild(contentDiv);
                            row.appendChild(cell);
                            date++;
                        }
                    }
                    this.tBody.appendChild(row);
                }
                if (this.RefStartDate) {
                    this.DayDiffDisplay = document.createElement("div");
                    this.DayDiffDisplay.classList.add("DayDiffDisplay");
                    this.tBody.appendChild(this.DayDiffDisplay);
                    let lastTarget = undefined;
                    this.tBody.addEventListener("mouseover", (event) => {
                        let target = event.target;
                        if (target.tagName === "TD" && target.firstChild) {
                            target = target.firstChild;
                        }
                        if (target.tagName === "DIV") {
                            if (target !== lastTarget) {
                                lastTarget = target;
                                const DiffInDays = EC_Fmt.Round((new Date(year, month, EC_Fmt.CDec(target.textContent)).getTime() - new Date(this.RefStartDate.getFullYear(), this.RefStartDate.getMonth(), this.RefStartDate.getDate()).getTime()) / (1000 * 3600 * 24), 0);
                                const targetPosition = target.getBoundingClientRect();
                                this.DayDiffDisplay.style.top = `${targetPosition.top - 24}px`;
                                this.DayDiffDisplay.style.left = `${targetPosition.left}px`;
                                this.DayDiffDisplay.style.display = "block";
                                if (DiffInDays === 1 || DiffInDays === -1) {
                                    this.DayDiffDisplay.textContent = `${DiffInDays} day`;
                                }
                                else {
                                    this.DayDiffDisplay.textContent = `${DiffInDays} days`;
                                }
                                this.HighlightRange(EC_Fmt.CDec(target.textContent), undefined);
                            }
                        }
                        else {
                            this.DayDiffDisplay.style.display = "";
                        }
                    });
                    this.tBody.addEventListener("mouseleave", () => {
                        this.DayDiffDisplay.style.display = "";
                        this.HighlightRange(this.SelectedDate.getDate(), undefined);
                    });
                    this.HighlightRange(this.SelectedDate.getDate(), undefined);
                }
                this.CalendarElement.appendChild(this.tBody);
                htmlB = "";
                if (this.IncludeTime) {
                    let hour = this.CurDate.getHours();
                    const minute = this.CurDate.getMinutes();
                    htmlB += "<tr><td colspan=100%>"
                        + "<table class=NoPadding style=width:100%;max-width:180px;margin:auto><tr>"
                        + "<td class=empty>Time:</td>";
                    if (EC_Fmt.userTimeFormat === 2) {
                        htmlB += `<td class=empty><input type=number name=hour min=1 max=23 style=width:32px value=${hour}></td><td class=empty style=padding:0>:</td>`
                            + `<td class=empty><input type=number name=minute min=0 max=59 style=width:32px value=${EC_Fmt.Right("0" + minute, 2)}></td>`;
                    }
                    else {
                        let AM = true;
                        if (hour >= 12) {
                            AM = false;
                            if (hour > 12) {
                                hour -= 12;
                            }
                        }
                        else if (hour <= 0) {
                            hour = 12;
                        }
                        htmlB += `<td class=empty><input type=number name=hour min=1 max=12 style=width:32px value=${hour}></td><td class=empty style=padding:0>:</td>`
                            + `<td class=empty><input type=number name=minute min=0 max=59 style=width:32px value=${EC_Fmt.Right("0" + minute, 2)}></td>`
                            + `<td class=empty><select name=PMorAM style=width:56px;height:27px;padding:3px><option value=AM${AM ? " selected" : ""}>AM</option><option value=PM${AM ? "" : " selected"}>PM</option></select></td>`;
                    }
                    htmlB += "</tr></table>"
                        + "</td></tr>";
                }
                htmlB += "<tr><td colspan=100% style=height:20px>";
                if (this.DisplayOK) {
                    htmlB += "<div class=DateOkAction>OK</div>";
                }
                else {
                    htmlB += "<table class=NoPadding style=width:100%><tr>"
                        + "<td style=border-radius:5px><div class=DateOkAction id=DateThisWeekAction>This Week</div></td>"
                        + "<td style=border-radius:5px><div class=DateOkAction id=DateThisMonthAction>This Month</div></td>"
                        + "</tr></table>";
                }
                htmlB += "</td></tr>";
                const tFoot = document.createElement("tfoot");
                tFoot.innerHTML = htmlB;
                this.CalendarElement.appendChild(tFoot);
                this.PositionFunction(this.CalendarElement);
                if (this.RangeTitle && this.ClickRangeFunction) {
                    tHeader.querySelector(".TimeRangeBtn").addEventListener("click", this.ClickRangeFunction);
                }
                tHeader.querySelector(".Previous").addEventListener("click", this.PrevMonth);
                tHeader.querySelector(".Title").addEventListener("click", this.DisplayMonthSelection);
                tHeader.querySelector(".Next").addEventListener("click", this.NextMonth);
                if (this.DisplayOK) {
                    tFoot.querySelector(".DateOkAction").addEventListener("click", () => {
                        const calendars = document.querySelectorAll("table.DateInputCalendar");
                        for (let i = 0; i < calendars.length; i++) {
                            calendars[i].style.display = "none";
                        }
                    });
                }
                if (this.IncludeTime) {
                    const PMorAM = tFoot.querySelector("select[name='PMorAM']");
                    tFoot.querySelector("input[name='hour']").addEventListener("change", (event) => {
                        let hour = EC_Fmt.CDec(event.currentTarget.value);
                        if (hour < 0) {
                            hour = 0;
                        }
                        else if (!PMorAM && hour >= 24) {
                            hour = 23;
                        }
                        else if (PMorAM && hour > 12) {
                            hour = 12;
                        }
                        event.currentTarget.value = hour.toString();
                        if (PMorAM) {
                            if (PMorAM.value === "AM" && hour === 12) {
                                hour = 0;
                            }
                            else if (PMorAM.value === "PM" && hour !== 12) {
                                hour += 12;
                            }
                        }
                        this.CurDate.setHours(hour);
                        this.ChangeTimeFunction(this.CurDate);
                    });
                    tFoot.querySelector("input[name='minute']").addEventListener("change", (event) => {
                        let minute = EC_Fmt.CDec(event.currentTarget.value);
                        if (minute < 0) {
                            minute = 0;
                        }
                        else if (minute >= 60) {
                            minute = 59;
                        }
                        event.currentTarget.value = EC_Fmt.Right("0" + minute, 2);
                        this.CurDate.setMinutes(minute);
                        this.ChangeTimeFunction(this.CurDate);
                    });
                    if (PMorAM) {
                        PMorAM.addEventListener("change", () => {
                            if (PMorAM.value === "PM") {
                                this.CurDate.setHours(this.CurDate.getHours() + 12);
                            }
                            else {
                                this.CurDate.setHours(this.CurDate.getHours() - 12);
                            }
                            this.ChangeTimeFunction(this.CurDate);
                        });
                    }
                }
                this.tBody.addEventListener("click", this.ClickDateEvent);
                gtag("event", "displayDateInputCalendar");
            }
            HighlightRange(hoveringDate, newRefStartDate) {
                const year = this.CurDate.getFullYear();
                const month = this.CurDate.getMonth();
                const cells = this.tBody.querySelectorAll("td:not(.empty)");
                if (newRefStartDate) {
                    this.RefStartDate = new Date(newRefStartDate);
                    const IsRefStartDateMonth = this.RefStartDate && year === this.RefStartDate.getFullYear() && month === this.RefStartDate.getMonth();
                    if (IsRefStartDateMonth) {
                        for (let i = 0, len = cells.length; i < len; i++) {
                            const cell = cells[i];
                            cell.firstChild.classList.remove("refStartDate");
                            if (EC_Fmt.CDec(cell.firstChild.textContent) === this.RefStartDate.getDate()) {
                                cell.firstChild.classList.add("refStartDate");
                            }
                        }
                    }
                }
                const IsRefStartDateMonth = this.RefStartDate && year === this.RefStartDate.getFullYear() && month === this.RefStartDate.getMonth();
                const RefStartDateInPreviousYearMonth = this.RefStartDate && (year > this.RefStartDate.getFullYear() || (year === this.RefStartDate.getFullYear() && month > this.RefStartDate.getMonth()));
                for (let i = 0, len = cells.length; i < len; i++) {
                    const cell = cells[i];
                    const date = EC_Fmt.CDec(cell.firstChild.textContent);
                    if ((RefStartDateInPreviousYearMonth && date <= hoveringDate) || (IsRefStartDateMonth && date <= hoveringDate && date >= this.RefStartDate.getDate())) {
                        cell.classList.add("rangeHighlight");
                    }
                    else {
                        cell.classList.remove("rangeHighlight");
                    }
                }
            }
            ClickDateEvent(event) {
                let target = event.target;
                if ((target.tagName === "TD" && target.firstElementChild) || target.tagName === "DIV") {
                    if (target.tagName === "TD") {
                        target = target.firstElementChild;
                    }
                    const day = EC_Fmt.CDec(target.textContent);
                    this.ClickDate(target, day);
                }
            }
            ClickDate(dateDiv, day) {
                if (dateDiv.tagName === "DIV") {
                    const lastSelectedDay = dateDiv.closest(".DateInputCalendar").querySelector(".selectedDate");
                    if (lastSelectedDay) {
                        lastSelectedDay.classList.remove("selectedDate");
                    }
                    dateDiv.classList.add("selectedDate");
                    this.CurDate.setDate(day);
                    this.SelectedDate = new Date(this.CurDate);
                    this.HighlightRange(this.SelectedDate.getDate(), undefined);
                    this.SelectDateFunction(this.CurDate);
                }
            }
            PrevMonth() {
                this.CurDate.setMonth(this.CurDate.getMonth() - 1, 1);
                this.ChangeYearAndMonthFunction(this.CurDate);
                this.DisplayCalendar();
            }
            NextMonth() {
                this.CurDate.setMonth(this.CurDate.getMonth() + 1, 1);
                this.ChangeYearAndMonthFunction(this.CurDate);
                this.DisplayCalendar();
            }
            DisplayMonthSelection() {
                this.CalendarElement.innerHTML = "";
                const month = this.CurDate.getMonth();
                const year = this.CurDate.getFullYear();
                this.CalendarElement.innerHTML = "<thead><tr><td colspan=100%>"
                    + `<table class=NoPadding style=width:100%><thead><tr><td class=Previous><span class=ews-icon-previous></span></td><td colspan=5 class=Title>${EC_Fmt.MonthNames[month]} ${year}</td><td class=Next><span class=ews-icon-next></span></td></tr></thead></table>`
                    + "</td></tr></thead>"
                    + "<tbody class=MonthView>"
                    + `<tr><td month=0><div>${EC_Fmt.MonthNames[0]}</div></td><td month=1><div>${EC_Fmt.MonthNames[1]}</div></td><td year><div>${year - 2}</div></td></tr>`
                    + `<tr><td month=2><div>${EC_Fmt.MonthNames[2]}</div></td><td month=3><div>${EC_Fmt.MonthNames[3]}</div></td><td year><div>${year - 1}</div></td></tr>`
                    + `<tr><td month=4><div>${EC_Fmt.MonthNames[4]}</div></td><td month=5><div>${EC_Fmt.MonthNames[5]}</div></td><td year style=background-color:var(--neutral-60);color:var(--text-onbg-action)><div>${year}</div></td></tr>`
                    + `<tr><td month=6><div>${EC_Fmt.MonthNames[6]}</div></td><td month=7><div>${EC_Fmt.MonthNames[7]}</div></td><td year><div>${year + 1}</div></td></tr>`
                    + `<tr><td month=8><div>${EC_Fmt.MonthNames[8]}</div></td><td month=9><div>${EC_Fmt.MonthNames[9]}</div></td><td year><div>${year + 2}</div></td></tr>`
                    + `<tr><td month=10><div>${EC_Fmt.MonthNames[10]}</div></td><td month=11><div>${EC_Fmt.MonthNames[11]}</div></td><td year><div>${year + 3}</div></td></tr>`
                    + "</tbody>";
                this.PositionFunction(this.CalendarElement);
                this.CalendarElement.querySelector(".Previous").addEventListener("click", this.PrevYear);
                this.CalendarElement.querySelector(".Title").addEventListener("click", this.DisplayCalendar);
                this.CalendarElement.querySelector(".Next").addEventListener("click", this.NextYear);
                const yearOptions = this.CalendarElement.querySelectorAll("td[year] div");
                for (let i = 0; i < yearOptions.length; i++) {
                    yearOptions[i].addEventListener("click", this.SetYear);
                }
                const monthOptions = this.CalendarElement.querySelectorAll("td[month]");
                for (let i = 0; i < monthOptions.length; i++) {
                    monthOptions[i].addEventListener("click", this.SetMonth);
                }
            }
            PrevYear() {
                this.CurDate.setFullYear(this.CurDate.getFullYear() - 1);
                this.ChangeYearAndMonthFunction(this.CurDate);
                this.DisplayMonthSelection();
            }
            NextYear() {
                this.CurDate.setFullYear(this.CurDate.getFullYear() + 1);
                this.ChangeYearAndMonthFunction(this.CurDate);
                this.DisplayMonthSelection();
            }
            SetYear(event) {
                this.CurDate.setFullYear(EC_Fmt.CDec(event.currentTarget.textContent));
                this.ChangeYearAndMonthFunction(this.CurDate);
                this.DisplayMonthSelection();
            }
            SetMonth(event) {
                this.CurDate.setMonth(EC_Fmt.CDec(event.currentTarget.getAttribute("month")), 1);
                this.ChangeYearAndMonthFunction(this.CurDate);
                this.DisplayCalendar();
            }
        }
        HTML.Calendar = Calendar;
    })(HTML = ECP.HTML || (ECP.HTML = {}));
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let Tools;
    (function (Tools) {
        function Ajax(Url, Options) {
            Options = Object.assign({}, {
                credentials: "same-origin"
            }, Options);
            return new Promise((resolve, reject) => {
                EWS.VerifySession(() => {
                    fetch(Url, Options).then((response) => {
                        resolve(response);
                    }).catch((err) => {
                        reject(err);
                    });
                }, false, () => {
                    reject("Network Error: Please try again.");
                });
            });
        }
        Tools.Ajax = Ajax;
        function AsyncAnimationFrame() {
            return new Promise(resolve => {
                requestAnimationFrame(() => { requestAnimationFrame(resolve); });
            });
        }
        Tools.AsyncAnimationFrame = AsyncAnimationFrame;
        function PersistForm(Form, Key) {
            if (!EC_Fmt.isNull(Form)) {
                const generateKey = (Element) => {
                    return Element.id.split("_")[0] + Element.name + Element.tagName + Element.type;
                };
                const formKey = "SavedForm#" + Key;
                const navigationEntry = performance.getEntriesByType("navigation")[0];
                if (navigationEntry?.type === "back_forward") {
                    const data = JSON.parse(localStorage.getItem(formKey));
                    if (!EC_Fmt.isNull(data)) {
                        for (let i = 0, len = Form.elements.length; i < len; i++) {
                            const element = (Form.elements[i]);
                            const elementKey = generateKey(element);
                            if (!EC_Fmt.isNull(data[elementKey])) {
                                element.value = data[elementKey];
                            }
                        }
                    }
                }
                window.addEventListener("pagehide", () => {
                    const data = {};
                    for (let i = 0, len = Form.elements.length; i < len; i++) {
                        const element = (Form.elements[i]);
                        if (element.type !== "password" && element.type !== "file") {
                            data[generateKey(element)] = element.value;
                        }
                    }
                    try {
                        localStorage.setItem(formKey, JSON.stringify(data));
                    }
                    catch (err) {
                    }
                });
                setTimeout(() => {
                    for (let i = 0, len = localStorage.length; i < len; i++) {
                        const key = localStorage.key(i);
                        if (key && key.startsWith("SavedForm#") && key !== formKey) {
                            localStorage.removeItem(key);
                        }
                    }
                }, 300);
            }
        }
        Tools.PersistForm = PersistForm;
        let SortableType;
        (function (SortableType) {
            SortableType[SortableType["Original"] = 1] = "Original";
            SortableType[SortableType["Clone"] = 2] = "Clone";
        })(SortableType = Tools.SortableType || (Tools.SortableType = {}));
        let SortDirectionType;
        (function (SortDirectionType) {
            SortDirectionType[SortDirectionType["Vertical"] = 1] = "Vertical";
            SortDirectionType[SortDirectionType["Horizontal"] = 2] = "Horizontal";
        })(SortDirectionType = Tools.SortDirectionType || (Tools.SortDirectionType = {}));
        class Sortable {
            constructor(ContainerEl, Options) {
                this.Options = {
                    ItemSelector: undefined,
                    Axis: "",
                    SortableType: SortableType.Original,
                    PlaceholderClass: "ecp-sortable-placeholder",
                    ConnectWithClass: `ecp-sortable-${(new Date()).getTime()}`,
                    ConnectToSortable: "",
                    ScrollWhenNearEdge: false,
                    DisableSortAnimation: false,
                    SortDirection: SortDirectionType.Vertical
                };
                this.IsMoving = false;
                if (!ContainerEl || !ContainerEl.nodeType || ContainerEl.nodeType !== 1) {
                    throw new Error("Invalid Sortable setup, please pass in a valid DOM element");
                }
                this.ContainerEl = ContainerEl;
                this.Options = Object.assign({}, this.Options, Options);
                this.ContainerEl.dataset.ecpSortable = this.Options.ConnectWithClass;
                this.ContainerEl.dataset.itemSelector = this.Options.ItemSelector;
                if (this.Options.DisableCurrentSort && this.Options.DisableCurrentSort.toString().toLowerCase() === "true") {
                    this.ContainerEl.setAttribute("disable-current-sort", "true");
                }
                this.Init_Sortable();
                if (this.Options.DisableSortAnimation.toString().toLowerCase() !== "true") {
                    if (!document.getElementById("DragAndDropAnimationCSS_" + EC_Fmt.CssEscape(this.Options.ItemSelector))) {
                        const AnimationCSS = document.createElement("style");
                        AnimationCSS.id = "DragAndDropAnimationCSS_" + EC_Fmt.CssEscape(this.Options.ItemSelector);
                        AnimationCSS.textContent = this.Options.ItemSelector + " {transition:top 500ms, left 500ms;top:0;left:0} .notransition {transition:none !important}";
                        document.head.appendChild(AnimationCSS);
                    }
                }
            }
            Init_Sortable() {
                const me = this;
                let eventType;
                if (EC_Fmt.isMobile || (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1)) {
                    eventType = ["touchstart", "touchmove", "touchend"];
                }
                else {
                    eventType = ["mousedown", "mousemove", "mouseup"];
                }
                if (me.ContainerEl.tagName.toLowerCase() === "tbody") {
                    me.ContainerEl.closest("table").style.position = "relative";
                }
                me.ContainerEl.addEventListener(eventType[0], (event) => {
                    let target = event.target;
                    if ((event.type === "mousedown" && event.button !== 0) || (me.Options.DragHandle && !target.closest(me.Options.DragHandle))) {
                        return;
                    }
                    me.Target = target.closest(me.Options.ItemSelector);
                    if (!me.Target || !me.ContainerEl.contains(me.Target)) {
                        return;
                    }
                    const mouseDownX = event.type === "mousedown" ? event.x : event.touches[0].clientX;
                    const mouseDownY = event.type === "mousedown" ? event.y : event.touches[0].clientY;
                    const originalRect = me.Target.getBoundingClientRect();
                    const offsetX = originalRect.left;
                    const offsetY = originalRect.top;
                    me.CreateSortElement();
                    const mouseMoveHandle = (event) => {
                        me.mouseMoveX = event.type === "mousemove" ? event.x : event.touches[0].clientX;
                        me.mouseMoveY = event.type === "mousemove" ? event.y : event.touches[0].clientY;
                        if (!me.IsMoving && Math.abs(me.mouseMoveX - mouseDownX) < 1 && Math.abs(me.mouseMoveY - mouseDownY) < 1) {
                            return false;
                        }
                        event.preventDefault();
                        let newTargetStyle = "";
                        if (!me.IsMoving) {
                            if (me.Options.SortableType !== SortableType.Clone) {
                                me.Target.parentElement.insertBefore(me.Placeholder, me.Target);
                                me.Target.style.display = "none";
                            }
                            if (me.Options.AppendTo && document.querySelector(me.Options.AppendTo)) {
                                document.querySelector(me.Options.AppendTo).appendChild(me.CloneTarget);
                            }
                            else {
                                me.Target.parentElement.appendChild(me.CloneTarget);
                            }
                            newTargetStyle += `width:${me.TargetStyle.width};height:${me.TargetStyle.height};`
                                + "position:fixed;opacity:0.9;z-index:1000;";
                        }
                        const nextMoveX = me.mouseMoveX - mouseDownX + offsetX;
                        const nextMoveY = me.mouseMoveY - mouseDownY + offsetY;
                        switch (me.Options.Axis.toLowerCase()) {
                            case "x":
                                newTargetStyle += `left:${nextMoveX}px;top:${offsetY}px;`;
                                break;
                            case "y":
                                newTargetStyle += `top:${nextMoveY}px;left:${offsetX}px;`;
                                break;
                            default:
                                newTargetStyle += `left:${nextMoveX}px;top:${nextMoveY}px;`;
                        }
                        me.CloneTarget.style.cssText += newTargetStyle;
                        me.InsertNode();
                        if (me.Options.ScrollWhenNearEdge.toString().toLowerCase() === "true") {
                            me.ScrollWhenNearEdge();
                            gtag("event", "DragAndDrop_ScrollNearEdge");
                        }
                        if (me.Options.OnDragStart && !me.IsMoving) {
                            me.AddCallback(event, me.Options.OnDragStart);
                            gtag("event", "DragAndDrop_DragStart");
                        }
                        if (me.Options.OnDrag) {
                            me.AddCallback(event, me.Options.OnDrag);
                        }
                        me.IsMoving = true;
                        return true;
                    };
                    const mouseUpHandle = (event) => {
                        if (me.IsMoving) {
                            if (me.Placeholder && me.Placeholder.parentElement) {
                                switch (me.Options.SortableType) {
                                    case SortableType.Clone:
                                        me.Placeholder.parentElement.insertBefore(me.CloneTarget, me.Placeholder);
                                        me.CloneTarget.style.cssText = me.Target.style.cssText;
                                        me.CloneTarget.style.display = me.TargetStyle.display;
                                        break;
                                    default:
                                        if (me.Target) {
                                            me.Placeholder.parentElement.insertBefore(me.Target, me.Placeholder);
                                        }
                                        me.Target.style.display = me.TargetStyle.display;
                                        me.CloneTarget.remove();
                                }
                                me.Placeholder.remove();
                            }
                            if (me.Options.OnDrop) {
                                gtag("event", "DragAndDrop_DroppedSuccessful");
                                me.AddCallback(event, me.Options.OnDrop, true);
                            }
                            me.IsMoving = false;
                        }
                        document.removeEventListener(eventType[1], mouseMoveHandle);
                        document.removeEventListener(eventType[2], mouseUpHandle);
                    };
                    document.addEventListener(eventType[1], mouseMoveHandle, { passive: false });
                    document.addEventListener(eventType[2], mouseUpHandle);
                    event.stopPropagation();
                });
            }
            CreateSortElement() {
                const me = this;
                const targetStyle = window.getComputedStyle(me.Target);
                const defaultStyle = {
                    width: targetStyle.width,
                    height: targetStyle.height,
                    margin: targetStyle.margin,
                    "background-color": "var(--neutral-10)"
                };
                const newPlaceholderStyle = Object.assign({}, defaultStyle, me.Options.PlaceholderStyle);
                let newStyle = "";
                const optionKeys = Object.keys(newPlaceholderStyle);
                for (let i = 0, len = optionKeys.length; i < len; i++) {
                    const key = optionKeys[i];
                    newStyle += `${key}: ${newPlaceholderStyle[key]};`;
                }
                const placeholder = document.createElement(me.Target.tagName);
                if (me.Target.tagName === "TR") {
                    const placeholderTd = document.createElement("td");
                    placeholderTd.setAttribute("colspan", me.Target.childElementCount);
                    placeholder.appendChild(placeholderTd);
                }
                placeholder.classList.add(me.Options.PlaceholderClass);
                placeholder.setAttribute("style", newStyle);
                me.Placeholder = placeholder;
                me.TargetParent = me.Target.parentElement;
                me.TargetSibling = me.Target.nextElementSibling;
                me.CloneTarget = me.Target.cloneNode(true);
                defaultStyle.display = targetStyle.display;
                me.TargetStyle = defaultStyle;
            }
            InsertNode() {
                const me = this;
                me.CloneTarget.style.display = "none";
                let SortTarget = document.elementFromPoint(me.mouseMoveX, me.mouseMoveY);
                if (SortTarget) {
                    do {
                        if (SortTarget.dataset && SortTarget.dataset.ecpSortable && SortTarget.dataset.itemSelector && (me.Options.ConnectWithClass === SortTarget.dataset.ecpSortable || (me.Options.ConnectToSortable && SortTarget.matches(me.Options.ConnectToSortable))) && SortTarget.getAttribute("disable-current-sort") !== "true") {
                            let items = Array.from(SortTarget.querySelectorAll(SortTarget.dataset.itemSelector));
                            items = items.filter(item => (item !== me.Target && item !== me.CloneTarget && EC_Fmt.isVisible(item)));
                            if (me.Options.DisableSortAnimation.toString().toLowerCase() !== "true") {
                                for (let i = 0; i < items.length; i++) {
                                    const item = items[i];
                                    item.classList.remove("notransition");
                                    item.style.top = "";
                                    item.style.left = "";
                                    item["originalRect"] = item.getBoundingClientRect();
                                }
                            }
                            const lastItem = items[items.length - 1];
                            let insertBeforeItem;
                            switch (me.Options.SortDirection) {
                                case SortDirectionType.Vertical:
                                    if (items.length === 0 || me.mouseMoveY >= lastItem.getBoundingClientRect().top + lastItem.offsetHeight - 5) {
                                        SortTarget.appendChild(me.Placeholder);
                                    }
                                    else {
                                        for (let i = 0; i < items.length; i++) {
                                            const item = items[i];
                                            const itemRect = item.getBoundingClientRect();
                                            if (me.mouseMoveY < itemRect.top + 5) {
                                                insertBeforeItem = item;
                                                break;
                                            }
                                            if (me.mouseMoveY < itemRect.top + item.offsetHeight - 5) {
                                                break;
                                            }
                                        }
                                    }
                                    break;
                                case SortDirectionType.Horizontal:
                                    if (items.length === 0 || me.mouseMoveX >= lastItem.getBoundingClientRect().left + lastItem.offsetWidth - 5) {
                                        SortTarget.appendChild(me.Placeholder);
                                    }
                                    else {
                                        for (let i = 0; i < items.length; i++) {
                                            const item = items[i];
                                            const itemRect = item.getBoundingClientRect();
                                            if (me.mouseMoveX < itemRect.left + 5) {
                                                insertBeforeItem = item;
                                                break;
                                            }
                                            if (me.mouseMoveX < itemRect.left + item.offsetWidth - 5) {
                                                break;
                                            }
                                        }
                                    }
                                    break;
                            }
                            if (insertBeforeItem) {
                                SortTarget.insertBefore(me.Placeholder, insertBeforeItem);
                            }
                            if (me.Options.DisableSortAnimation.toString().toLowerCase() !== "true") {
                                for (let i = 0; i < items.length; i++) {
                                    const item = items[i];
                                    if (item["originalRect"]) {
                                        const newRect = item.getBoundingClientRect();
                                        const tempTop = item["originalRect"].top - newRect.top;
                                        const tempLeft = item["originalRect"].left - newRect.left;
                                        if (tempTop !== 0 || tempLeft !== 0) {
                                            item.classList.add("notransition");
                                            item["originalPosition"] = item.style.position;
                                            item.style.position = "relative";
                                            item.style.top = tempTop + "px";
                                            item.style.left = tempLeft + "px";
                                            item["originalZIndex"] = item.style.zIndex;
                                            item.style.zIndex = getComputedStyle(item).getPropertyValue("z-index") + 10;
                                        }
                                        else {
                                            item["originalRect"] = undefined;
                                        }
                                    }
                                }
                                requestAnimationFrame(() => {
                                    for (let i = 0; i < items.length; i++) {
                                        const item = items[i];
                                        if (item["originalRect"]) {
                                            item.classList.remove("notransition");
                                            item.style.top = "";
                                            item.style.left = "";
                                        }
                                    }
                                    setTimeout(() => {
                                        for (let i = 0; i < items.length; i++) {
                                            const item = items[i];
                                            if (item["originalRect"]) {
                                                item.style.position = item["originalPosition"];
                                                item.style.zIndex = item["originalZIndex"];
                                                item["originalRect"] = undefined;
                                                item["originalPosition"] = undefined;
                                                item["originalZIndex"] = undefined;
                                            }
                                        }
                                        items = undefined;
                                    }, 500);
                                });
                            }
                            me.SortTarget = SortTarget;
                            break;
                        }
                        SortTarget = SortTarget.parentElement;
                    } while (SortTarget);
                }
                me.CloneTarget.style.display = me.TargetStyle.display;
            }
            ScrollWhenNearEdge() {
                const me = this;
                me.CloneTarget.style.display = "none";
                const moveTarget = document.elementFromPoint(me.mouseMoveX, me.mouseMoveY);
                me.CloneTarget.style.display = me.TargetStyle.display;
                const scrollContainer = me.GetScrollableParent(moveTarget);
                if (scrollContainer) {
                    const edgeSize = 100;
                    const maxStep = 15;
                    const scrollContainerClientRect = scrollContainer.getBoundingClientRect();
                    const edgeLeft = scrollContainerClientRect.left + edgeSize;
                    const edgeRight = scrollContainerClientRect.right - edgeSize;
                    const edgeTop = scrollContainerClientRect.top + edgeSize;
                    const edgeBottom = scrollContainerClientRect.bottom - edgeSize;
                    const isInLeftEdge = (me.mouseMoveX > scrollContainerClientRect.left && me.mouseMoveX < edgeLeft);
                    const isInRightEdge = (me.mouseMoveX < scrollContainerClientRect.right && me.mouseMoveX > edgeRight);
                    const isInTopEdge = (me.mouseMoveY > scrollContainerClientRect.top && me.mouseMoveY < edgeTop);
                    const isInBottomEdge = (me.mouseMoveY < scrollContainerClientRect.bottom && me.mouseMoveY > edgeBottom);
                    if (!(isInLeftEdge || isInRightEdge || isInTopEdge || isInBottomEdge)) {
                        clearTimeout(me.ScrollTimer);
                        return;
                    }
                    const maxScrollX = scrollContainer.scrollWidth - scrollContainer.clientWidth;
                    const maxScrollY = scrollContainer.scrollHeight - scrollContainer.clientHeight;
                    let currentScrollX = scrollContainer.scrollLeft;
                    let currentScrollY = scrollContainer.scrollTop;
                    (function checkContainerIsScrolling() {
                        clearTimeout(me.ScrollTimer);
                        if (adjustContainerScroll()) {
                            me.ScrollTimer = setTimeout(checkContainerIsScrolling, 30);
                        }
                    })();
                    function adjustContainerScroll() {
                        if (!me.IsMoving) {
                            return false;
                        }
                        let nextScrollX = currentScrollX;
                        let nextScrollY = currentScrollY;
                        if (isInLeftEdge && currentScrollX > 0) {
                            nextScrollX = Math.max(0, Math.min(maxScrollX, currentScrollX - (maxStep * ((edgeLeft - me.mouseMoveX) / edgeSize))));
                        }
                        else if (isInRightEdge && currentScrollX < maxScrollX) {
                            nextScrollX = Math.max(0, Math.min(maxScrollX, currentScrollX + (maxStep * ((me.mouseMoveX - edgeRight) / edgeSize))));
                        }
                        if (isInTopEdge && currentScrollY > 0) {
                            nextScrollY = Math.max(0, Math.min(maxScrollY, currentScrollY - (maxStep * ((edgeTop - me.mouseMoveY) / edgeSize))));
                        }
                        else if (isInBottomEdge && currentScrollY < maxScrollY) {
                            nextScrollY = Math.max(0, Math.min(maxScrollY, currentScrollY + (maxStep * ((me.mouseMoveY - edgeBottom) / edgeSize))));
                        }
                        if (nextScrollX !== currentScrollX) {
                            currentScrollX = nextScrollX;
                            scrollContainer.scrollLeft = nextScrollX;
                            return true;
                        }
                        if (nextScrollY !== currentScrollY) {
                            currentScrollY = nextScrollY;
                            scrollContainer.scrollTop = nextScrollY;
                            return true;
                        }
                        return false;
                    }
                }
            }
            GetScrollableParent(node) {
                const me = this;
                if (!node) {
                    return null;
                }
                const computedStyle = getComputedStyle(node);
                const overflowSettingX = computedStyle.overflowX;
                const overflowSettingY = computedStyle.overflowY;
                if (node.scrollWidth > node.clientWidth && (overflowSettingX === "scroll" || overflowSettingX === "auto")) {
                    return node;
                }
                if (node.scrollHeight > node.clientHeight && (overflowSettingY === "scroll" || overflowSettingY === "auto")) {
                    return node;
                }
                return me.GetScrollableParent(node.parentElement);
            }
            AddCallback(Event, Callback, isOnDrop) {
                const me = this;
                const UI = {
                    dragEvent: Event,
                    dragElement: isOnDrop && me.Options.SortableType === SortableType.Original ? me.Target : me.CloneTarget,
                    placeholder: me.Placeholder,
                    sortTarget: me.SortTarget
                };
                if (isOnDrop) {
                    UI["cancel"] = () => { return me.CancelDrag(me); };
                    gtag("event", "DragAndDrop_DroppedCancelled");
                }
                Callback(UI);
            }
            CancelDrag(me) {
                switch (me.Options.SortableType) {
                    case SortableType.Clone:
                        me.CloneTarget.remove();
                        break;
                    default:
                        if (me.TargetSibling) {
                            me.TargetSibling.parentElement.insertBefore(me.Target, me.TargetSibling);
                        }
                        else {
                            me.TargetParent.appendChild(me.Target);
                        }
                }
            }
            static Create(ContainerEl, Options) {
                return new Sortable(ContainerEl, Options);
            }
        }
        Tools.Sortable = Sortable;
        function CaptchaV3(Action, VerifyCallback) {
            EC_Fmt.LoadScript("https://www.recaptcha.net/recaptcha/api.js?render=6Lei1aAaAAAAABh42gx0qAjy2ZGKIWZRDs4WgV5J").then(() => {
                grecaptcha.ready(() => {
                    grecaptcha.execute('6Lei1aAaAAAAABh42gx0qAjy2ZGKIWZRDs4WgV5J', { action: Action }).then(function (token) {
                        VerifyCallback(token);
                    });
                });
            });
        }
        Tools.CaptchaV3 = CaptchaV3;
        const RecaptchaV2SiteKey = "6LegzTQtAAAAAKu9Dn7uu9BDWEKYWjkQM-9cg1gV";
        function CaptchaV2(ContainerEl, VerifyCallback) {
            EC_Fmt.LoadScript("https://www.recaptcha.net/recaptcha/api.js?render=explicit").then(() => {
                grecaptcha.ready(() => {
                    grecaptcha.render(ContainerEl, { sitekey: RecaptchaV2SiteKey, callback: VerifyCallback });
                });
            });
        }
        Tools.CaptchaV2 = CaptchaV2;
        class EventBusCenter {
            constructor() {
                this.eventDic = {};
            }
            On(eventId, callback) {
                if (!this.eventDic[eventId]) {
                    this.eventDic[eventId] = new Array();
                }
                this.eventDic[eventId].push(callback);
            }
            Emit(eventId, data) {
                this.eventDic[eventId]?.map(f => f(data));
            }
        }
        Tools.EventBus = new EventBusCenter();
        function ReceiveServerSentEvents(ChannelID, IntervalTime, Callback, CloseCallback) {
            const source = new EventSource(`api?APICommand=Get_ServerSendMassage&ChannelID=${ChannelID}&IntervalTime=${IntervalTime}`);
            source.addEventListener("message", (msResult) => {
                if (msResult.data === "_SSE_Closed_") {
                    source.close();
                    if (CloseCallback) {
                        CloseCallback();
                    }
                    return;
                }
                Callback(msResult.data);
            });
            source.addEventListener("error", (e) => {
                source.close();
                if (CloseCallback) {
                    CloseCallback(e);
                }
            });
        }
        Tools.ReceiveServerSentEvents = ReceiveServerSentEvents;
    })(Tools = ECP.Tools || (ECP.Tools = {}));
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    class SubscriberSet {
        constructor(subject, initialSubscriber) {
            this.sub1 = void 0;
            this.sub2 = void 0;
            this.spillover = void 0;
            this.subject = subject;
            this.sub1 = initialSubscriber;
        }
        has(subscriber) {
            return this.spillover === void 0 ? this.sub1 === subscriber || this.sub2 === subscriber : this.spillover.indexOf(subscriber) !== -1;
        }
        subscribe(subscriber) {
            const spillover = this.spillover;
            if (spillover === void 0) {
                if (this.has(subscriber)) {
                    return;
                }
                if (this.sub1 === void 0) {
                    this.sub1 = subscriber;
                    return;
                }
                if (this.sub2 === void 0) {
                    this.sub2 = subscriber;
                    return;
                }
                this.spillover = [this.sub1, this.sub2, subscriber];
                this.sub1 = void 0;
                this.sub2 = void 0;
            }
            else {
                const index = spillover.indexOf(subscriber);
                if (index === -1) {
                    spillover.push(subscriber);
                }
            }
        }
        unsubscribe(subscriber) {
            const spillover = this.spillover;
            if (spillover === void 0) {
                if (this.sub1 === subscriber) {
                    this.sub1 = void 0;
                }
                else if (this.sub2 === subscriber) {
                    this.sub2 = void 0;
                }
            }
            else {
                const index = spillover.indexOf(subscriber);
                if (index !== -1) {
                    spillover.splice(index, 1);
                }
            }
        }
        notify(args) {
            const spillover = this.spillover;
            const subject = this.subject;
            if (spillover === void 0) {
                const sub1 = this.sub1;
                const sub2 = this.sub2;
                if (sub1 !== void 0) {
                    sub1.handleChange(subject, args);
                }
                if (sub2 !== void 0) {
                    sub2.handleChange(subject, args);
                }
            }
            else {
                for (let i = 0, ii = spillover.length; i < ii; ++i) {
                    spillover[i].handleChange(subject, args);
                }
            }
        }
    }
    ECP.SubscriberSet = SubscriberSet;
    class PropertyChangeNotifier {
        constructor(subject) {
            this.subscribers = {};
            this.subjectSubscribers = null;
            this.subject = subject;
        }
        notify(propertyName) {
            this.subscribers[propertyName]?.notify(propertyName);
            this.subjectSubscribers?.notify(propertyName);
        }
        subscribe(subscriber, propertyToWatch) {
            let subscribers;
            if (propertyToWatch) {
                subscribers =
                    this.subscribers[propertyToWatch] ??
                        (this.subscribers[propertyToWatch] = new SubscriberSet(this.subject));
            }
            else {
                subscribers =
                    this.subjectSubscribers ??
                        (this.subjectSubscribers = new SubscriberSet(this.subject));
            }
            subscribers.subscribe(subscriber);
        }
        unsubscribe(subscriber, propertyToUnwatch) {
            if (propertyToUnwatch) {
                this.subscribers[propertyToUnwatch]?.unsubscribe(subscriber);
            }
            else {
                this.subjectSubscribers?.unsubscribe(subscriber);
            }
        }
    }
    ECP.PropertyChangeNotifier = PropertyChangeNotifier;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    ECP.Updates = (() => {
        const tasks = [];
        const pendingErrors = [];
        let updateAsync = true;
        function throwFirstError() {
            if (pendingErrors.length) {
                throw pendingErrors.shift();
            }
        }
        function tryRunTask(task) {
            try {
                task.call();
            }
            catch (error) {
                if (updateAsync) {
                    pendingErrors.push(error);
                    setTimeout(throwFirstError, 0);
                }
                else {
                    tasks.length = 0;
                    throw error;
                }
            }
        }
        function process() {
            const capacity = 1024;
            let index = 0;
            while (index < tasks.length) {
                tryRunTask(tasks[index]);
                index++;
                if (index > capacity) {
                    for (let scan = 0, newLength = tasks.length - index; scan < newLength; scan++) {
                        tasks[scan] = tasks[scan + index];
                    }
                    tasks.length -= index;
                    index = 0;
                }
            }
            tasks.length = 0;
        }
        function enqueue(callable) {
            tasks.push(callable);
            if (tasks.length < 2) {
                updateAsync ? requestAnimationFrame(process) : process();
            }
        }
        return Object.freeze({
            enqueue,
            next: () => new Promise(enqueue),
            process,
            setMode: (isAsync) => (updateAsync = isAsync),
        });
    })();
    ECP.Observable = (() => {
        const queueUpdate = ECP.Updates.enqueue;
        const volatileRegex = /(:|&&|\|\||if)/;
        const notifierLookup = new WeakMap();
        const accessorLookup = new WeakMap();
        let watcher = void 0;
        let createArrayObserver = (array) => {
            throw Error("Needs Array Observation");
        };
        function getNotifier(source) {
            let found = source.$controller ?? notifierLookup.get(source);
            if (found === void 0) {
                Array.isArray(source) ? (found = createArrayObserver(source)) : notifierLookup.set(source, (found = new ECP.PropertyChangeNotifier(source)));
            }
            return found;
        }
        function getAccessors(target) {
            let accessors = accessorLookup.get(target);
            if (accessors === void 0) {
                let currentTarget = Reflect.getPrototypeOf(target);
                while (accessors === void 0 && currentTarget !== null) {
                    accessors = accessorLookup.get(currentTarget);
                    currentTarget = Reflect.getPrototypeOf(currentTarget);
                }
                accessors = accessors === void 0 ? [] : accessors.slice(0);
                accessorLookup.set(target, accessors);
            }
            return accessors;
        }
        class DefaultObservableAccessor {
            constructor(name) {
                this.name = name;
                this.field = `_${name}`;
                this.callback = `${name}Changed`;
            }
            getValue(source) {
                if (watcher !== void 0) {
                    watcher.watch(source, this.name);
                }
                return source[this.field];
            }
            setValue(source, newValue) {
                const field = this.field;
                const oldValue = source[field];
                if (oldValue !== newValue) {
                    source[field] = newValue;
                    const callback = source[this.callback];
                    if (typeof callback === "function") {
                        callback.call(source, oldValue, newValue);
                    }
                    getNotifier(source).notify(this.name);
                }
            }
        }
        class BindingObserverImplementation extends ECP.SubscriberSet {
            constructor(binding, initialSubscriber, isVolatileBinding = false) {
                super(binding, initialSubscriber);
                this.binding = binding;
                this.isVolatileBinding = isVolatileBinding;
                this.needsRefresh = true;
                this.needsQueue = true;
                this.isAsync = true;
                this.first = this;
                this.last = null;
            }
            setMode(isAsync) {
                this.isAsync = this.needsQueue = isAsync;
            }
            observe(source) {
                if (this.needsRefresh && this.last !== null) {
                    this.dispose();
                }
                const previousWatcher = watcher;
                watcher = this.needsRefresh ? this : void 0;
                this.needsRefresh = this.isVolatileBinding;
                const result = this.binding(source);
                watcher = previousWatcher;
                return result;
            }
            dispose() {
                if (this.last !== null) {
                    let current = this.first;
                    while (current !== void 0) {
                        current.notifier.unsubscribe(this, current.propertyName);
                        current = current.next;
                    }
                    this.last = null;
                    this.needsRefresh = this.needsQueue = this.isAsync;
                }
            }
            watch(propertySource, propertyName) {
                const prev = this.last;
                const notifier = getNotifier(propertySource);
                const current = prev === null ? this.first : {};
                current.propertySource = propertySource;
                current.propertyName = propertyName;
                current.notifier = notifier;
                notifier.subscribe(this, propertyName);
                if (prev !== null) {
                    if (!this.needsRefresh) {
                        let prevValue;
                        watcher = void 0;
                        prevValue = prev.propertySource[prev.propertyName];
                        watcher = this;
                        if (propertySource === prevValue) {
                            this.needsRefresh = true;
                        }
                    }
                    prev.next = current;
                }
                this.last = current;
            }
            handleChange() {
                if (this.needsQueue) {
                    this.needsQueue = false;
                    queueUpdate(this);
                }
                else if (!this.isAsync) {
                    this.call();
                }
            }
            call() {
                if (this.last !== null) {
                    this.needsQueue = this.isAsync;
                    this.notify(this);
                }
            }
            *records() {
                let next = this.first;
                while (next !== void 0) {
                    yield next;
                    next = next.next;
                }
            }
        }
        return Object.freeze({
            setArrayObserverFactory(factory) {
                createArrayObserver = factory;
            },
            getNotifier,
            track(source, propertyName) {
                watcher && watcher.watch(source, propertyName);
            },
            trackVolatile() {
                watcher && (watcher.needsRefresh = true);
            },
            notify(source, args) {
                getNotifier(source).notify(args);
            },
            defineProperty(target, nameOrAccessor) {
                if (typeof nameOrAccessor === "string") {
                    nameOrAccessor = new DefaultObservableAccessor(nameOrAccessor);
                }
                getAccessors(target).push(nameOrAccessor);
                Reflect.defineProperty(target, nameOrAccessor.name, {
                    enumerable: true,
                    get() {
                        return nameOrAccessor.getValue(this);
                    },
                    set(newValue) {
                        nameOrAccessor.setValue(this, newValue);
                    },
                });
            },
            getAccessors,
            binding(binding, initialSubscriber, isVolatileBinding = this.isVolatileBinding(binding)) {
                return new BindingObserverImplementation(binding, initialSubscriber, isVolatileBinding);
            },
            isVolatileBinding(binding) {
                return volatileRegex.test(binding.toString());
            },
        });
    })();
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    const booleanMode = "boolean";
    const reflectMode = "reflect";
    ECP.booleanConverter = {
        toView(value) {
            return value ? "true" : "false";
        },
        fromView(value) {
            return value === null ||
                value === void 0 ||
                value === "false" ||
                value === false ||
                value === 0
                ? false
                : true;
        },
    };
    function toNumber(value) {
        if (value === null || value === undefined) {
            return null;
        }
        const number = value * 1;
        return isNaN(number) ? null : number;
    }
    ECP.nullableNumberConverter = {
        toView(value) {
            const output = toNumber(value);
            return output ? output.toString() : output;
        },
        fromView: toNumber,
    };
    class AttributeDefinition {
        constructor(Owner, name, attribute = name.toLowerCase(), mode = reflectMode, converter) {
            this.guards = new Set();
            this.Owner = Owner;
            this.name = name;
            this.attribute = attribute;
            this.mode = mode;
            this.converter = converter;
            this.fieldName = `_${name}`;
            this.callbackName = `${name}Changed`;
            this.hasCallback = this.callbackName in Owner.prototype;
            if (mode === booleanMode && converter === void 0) {
                this.converter = ECP.booleanConverter;
            }
        }
        setValue(source, newValue) {
            const oldValue = source[this.fieldName];
            const converter = this.converter;
            if (converter !== void 0) {
                newValue = converter.fromView(newValue);
            }
            if (oldValue !== newValue) {
                source[this.fieldName] = newValue;
                this.tryReflectToAttribute(source);
                if (this.hasCallback) {
                    source[this.callbackName](oldValue, newValue);
                }
                source.$controller.notify(this.name);
            }
        }
        getValue(source) {
            return source[this.fieldName];
        }
        onAttributeChangedCallback(element, value) {
            if (this.guards.has(element)) {
                return;
            }
            this.guards.add(element);
            this.setValue(element, value);
            this.guards.delete(element);
        }
        tryReflectToAttribute(element) {
            const mode = this.mode;
            const guards = this.guards;
            if (guards.has(element) || mode === "fromView") {
                return;
            }
            ECP.Updates.enqueue(() => {
                guards.add(element);
                const latestValue = element[this.fieldName];
                switch (mode) {
                    case reflectMode:
                        const converter = this.converter;
                        const value = converter !== void 0 ? converter.toView(latestValue) : latestValue;
                        if (value === null || value === undefined) {
                            element.removeAttribute(this.attribute);
                        }
                        else {
                            element.setAttribute(this.attribute, value);
                        }
                        break;
                    case booleanMode:
                        latestValue ? element.setAttribute(this.attribute, "") : element.removeAttribute(this.attribute);
                        break;
                }
                guards.delete(element);
            });
        }
        static collect(Owner, ...attributeLists) {
            const attributes = [];
            attributeLists.push(Owner.attributes);
            for (let i = 0, ii = attributeLists.length; i < ii; ++i) {
                const list = attributeLists[i];
                if (list === void 0) {
                    continue;
                }
                for (let j = 0, jj = list.length; j < jj; ++j) {
                    const config = list[j];
                    if (typeof config === "string") {
                        attributes.push(new AttributeDefinition(Owner, config));
                    }
                    else {
                        attributes.push(new AttributeDefinition(Owner, config.property, config.attribute, config.mode, config.converter));
                    }
                }
            }
            return attributes;
        }
    }
    ECP.AttributeDefinition = AttributeDefinition;
    function attr(configOrTarget, prop) {
        let config;
        function decorator($target, $prop) {
            if (arguments.length > 1) {
                config.property = $prop;
            }
            const attributes = $target.constructor.attributes ||
                ($target.constructor.attributes = []);
            attributes.push(config);
        }
        if (arguments.length > 1) {
            config = {};
            decorator(configOrTarget, prop);
            return;
        }
        config = configOrTarget === void 0 ? {} : configOrTarget;
        return decorator;
    }
    ECP.attr = attr;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    const shadowRoots = new WeakMap();
    const defaultEventOptions = {
        bubbles: true,
        composed: true,
        cancelable: true,
    };
    function getShadowRoot(element) {
        return element.shadowRoot ?? shadowRoots.get(element) ?? null;
    }
    function getStyleSheetDocument(target) {
        return target.ownerDocument ?? target;
    }
    const isConnectedPropertyName = "isConnected";
    const styleSheetCache = new WeakMap();
    let fontStyleStr = '';
    let fontStyleRequestPromiseChain;
    async function sendFontStyleRequest() {
        const response = await fetch(`Controls/Command${ReleasedCode ? ".min" : ""}.css?v=${ECPVersion}`, {
            credentials: "same-origin"
        });
        fontStyleStr = await response.text();
    }
    function setFontStyle(callback) {
        if (!fontStyleRequestPromiseChain) {
            fontStyleRequestPromiseChain = sendFontStyleRequest().then(() => {
                callback();
            });
        }
        else {
            fontStyleRequestPromiseChain.then(() => {
                callback();
            });
        }
    }
    class Controller extends ECP.PropertyChangeNotifier {
        get template() {
            if (this._template === null) {
                const definition = this.definition;
                if (definition.template) {
                    this._template = definition.template ?? null;
                }
            }
            return this._template;
        }
        get styles() {
            if (this._styles === null) {
                const definition = this.definition;
                if (definition.styles) {
                    this._styles = definition.styles ?? null;
                }
            }
            return this._styles;
        }
        get enableIcon() {
            if (this._enableIcon === null) {
                const definition = this.definition;
                if (definition.enableIcon !== null && definition.enableIcon !== void 0) {
                    this._enableIcon = definition.enableIcon ?? null;
                }
            }
            return this._enableIcon;
        }
        setIsConnected(value) {
            this._isConnected = value;
            ECP.Observable.notify(this, isConnectedPropertyName);
        }
        constructor(element, definition) {
            super(element);
            this.boundObservables = null;
            this.hasExistingShadowRoot = false;
            this.needsInitialization = true;
            this._template = null;
            this._styles = null;
            this._isConnected = false;
            this._enableIcon = null;
            this.element = element;
            this.definition = definition;
            const shadowOptions = definition.shadowOptions;
            if (shadowOptions !== void 0) {
                let shadowRoot = element.shadowRoot;
                if (shadowRoot) {
                    this.hasExistingShadowRoot = true;
                }
                else {
                    shadowRoot = element.attachShadow(shadowOptions);
                    if (shadowOptions.mode === "closed") {
                        shadowRoots.set(element, shadowRoot);
                    }
                }
            }
            const accessors = ECP.Observable.getAccessors(element);
            if (accessors.length > 0) {
                const boundObservables = (this.boundObservables = Object.create(null));
                for (let i = 0, ii = accessors.length; i < ii; ++i) {
                    const propertyName = accessors[i].name;
                    const value = element[propertyName];
                    if (value !== void 0) {
                        delete element[propertyName];
                        boundObservables[propertyName] = value;
                    }
                }
            }
            this.renderTemplate(this.template);
        }
        onConnectedCallback() {
            if (this._isConnected) {
                return;
            }
            if (this.needsInitialization) {
                this.finishInitialization();
            }
            this.setIsConnected(true);
        }
        onDisconnectedCallback() {
            if (!this._isConnected) {
                return;
            }
            this.setIsConnected(false);
        }
        onAttributeChangedCallback(name, oldValue, newValue) {
            const attrDef = this.definition.attributeLookup[name];
            if (attrDef !== void 0) {
                attrDef.onAttributeChangedCallback(this.element, newValue);
            }
        }
        emit(type, detail, options) {
            if (this._isConnected) {
                return this.element.dispatchEvent(new CustomEvent(type, { detail, ...defaultEventOptions, ...options }));
            }
            return false;
        }
        finishInitialization() {
            const element = this.element;
            const boundObservables = this.boundObservables;
            if (boundObservables !== null) {
                const propertyNames = Object.keys(boundObservables);
                for (let i = 0, ii = propertyNames.length; i < ii; ++i) {
                    const propertyName = propertyNames[i];
                    element[propertyName] = boundObservables[propertyName];
                }
                this.boundObservables = null;
            }
            if (this.enableIcon) {
                const element = this.element;
                const host = getShadowRoot(element) ?? element;
                if (host.adoptedStyleSheets !== void 0) {
                    const me = this;
                    setFontStyle(() => {
                        me.addStyles(fontStyleStr);
                    });
                }
                else {
                    host.appendChild(EC_Fmt.HtmlStrToElement(`<link href="Controls/Command${ReleasedCode ? ".min" : ""}.css?v=${ECPVersion}"rel="stylesheet"type="text/css">`));
                }
            }
            this.addStyles(this.styles);
            this.needsInitialization = false;
            this.created();
        }
        renderTemplate(template) {
            const element = this.element;
            const host = getShadowRoot(element) ?? element;
            if (!this.needsInitialization || this.hasExistingShadowRoot) {
                this.hasExistingShadowRoot = false;
                for (let child = host.firstChild; child !== void 0; child = host.firstChild) {
                    host.removeChild(child);
                }
            }
            if (template !== void 0 && template !== null && template !== "") {
                host.innerHTML = template;
            }
        }
        created() {
            const element = this.element;
            if (this.element.created !== void 0) {
                const host = getShadowRoot(element) ?? element;
                this.element.created(host);
            }
        }
        addStyles(styles) {
            if (!EC_Fmt.isNull(styles)) {
                const target = getShadowRoot(this.element) || this.element.getRootNode();
                if (target.adoptedStyleSheets !== void 0) {
                    const styleSheetDocument = getStyleSheetDocument(target);
                    let documentStyleSheetCache = styleSheetCache.get(styleSheetDocument);
                    if (documentStyleSheetCache === void 0) {
                        documentStyleSheetCache = new Map();
                        styleSheetCache.set(styleSheetDocument, documentStyleSheetCache);
                    }
                    let sheet = documentStyleSheetCache.get(styles);
                    if (sheet === void 0) {
                        sheet = new CSSStyleSheet();
                        sheet.replaceSync(styles);
                        documentStyleSheetCache.set(styles, sheet);
                    }
                    target.adoptedStyleSheets = [...target.adoptedStyleSheets, sheet];
                }
                else {
                    const style = document.createElement("style");
                    style.textContent = styles;
                    target.appendChild(style);
                }
            }
        }
        static forCustomElement(element) {
            const controller = element.$controller;
            if (controller !== void 0) {
                return controller;
            }
            const definition = ECP.ComponentDefinition.getForInstance(element);
            return (element.$controller = new Controller(element, definition));
        }
    }
    ECP.Controller = Controller;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    function createTypeRegistry() {
        const typeToDefinition = new Map();
        return Object.freeze({
            register(definition) {
                if (typeToDefinition.has(definition.type)) {
                    return false;
                }
                typeToDefinition.set(definition.type, definition);
                return true;
            },
            getByType(key) {
                return typeToDefinition.get(key);
            },
            getForInstance(object) {
                return typeToDefinition.get(object.constructor);
            },
        });
    }
    const defaultShadowOptions = { mode: "open" };
    const defaultElementOptions = {};
    const componentRegistry = createTypeRegistry();
    class ComponentDefinition {
        constructor(type, nameOrConfig = type.definition) {
            if (typeof nameOrConfig === "string") {
                nameOrConfig = { name: nameOrConfig };
            }
            this.type = type;
            this.name = nameOrConfig.name;
            const attributes = ECP.AttributeDefinition.collect(type, nameOrConfig.attributes);
            const observedAttributes = new Array(attributes.length);
            const propertyLookup = {};
            const attributeLookup = {};
            for (let i = 0, ii = attributes.length; i < ii; ++i) {
                const current = attributes[i];
                observedAttributes[i] = current.attribute;
                propertyLookup[current.name] = current;
                attributeLookup[current.attribute] = current;
            }
            this.attributes = attributes;
            this.observedAttributes = observedAttributes;
            this.propertyLookup = propertyLookup;
            this.attributeLookup = attributeLookup;
            this.enableIcon = nameOrConfig.enableIcon;
            this.template = nameOrConfig.template;
            this.styles = nameOrConfig.styles;
            this.shadowOptions =
                nameOrConfig.shadowOptions === void 0
                    ? defaultShadowOptions
                    : nameOrConfig.shadowOptions === null
                        ? void 0
                        : { ...defaultShadowOptions, ...nameOrConfig.shadowOptions };
            this.elementOptions =
                nameOrConfig.elementOptions === void 0
                    ? defaultElementOptions
                    : { ...defaultElementOptions, ...nameOrConfig.elementOptions };
        }
        define() {
            const type = this.type;
            if (componentRegistry.register(this)) {
                const attributes = this.attributes;
                for (let i = 0, ii = attributes.length; i < ii; ++i) {
                    ECP.Observable.defineProperty(type.prototype, attributes[i]);
                }
                Reflect.defineProperty(type, "observedAttributes", {
                    value: this.observedAttributes,
                    enumerable: true,
                });
            }
            if (!customElements.get(this.name)) {
                const name = this.name;
                const elementOptions = this.elementOptions;
                if (document.readyState === 'loading') {
                    document.addEventListener("DOMContentLoaded", () => {
                        customElements.define(name, type, elementOptions);
                    });
                }
                else {
                    customElements.define(name, type, elementOptions);
                }
            }
            return this;
        }
    }
    ComponentDefinition.getForInstance = componentRegistry.getForInstance;
    ECP.ComponentDefinition = ComponentDefinition;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    function createComponent(BaseType) {
        return class extends BaseType {
            constructor() {
                super();
                this.$controller = ECP.Controller.forCustomElement(this);
            }
            $emit(type, detail, options) {
                return this.$controller.emit(type, detail, options);
            }
            connectedCallback() {
                this.$controller.onConnectedCallback();
            }
            disconnectedCallback() {
                this.$controller.onDisconnectedCallback();
            }
            attributeChangedCallback(name, oldValue, newValue) {
                this.$controller.onAttributeChangedCallback(name, oldValue, newValue);
            }
        };
    }
    ECP.Component = Object.assign(createComponent(HTMLElement), {
        define(type, nameOrDef) {
            return new ECP.ComponentDefinition(type, nameOrDef).define().type;
        },
    });
    function customElement(nameOrDef) {
        return function (type) {
            new ECP.ComponentDefinition(type, nameOrDef).define();
        };
    }
    ECP.customElement = customElement;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    const ElementInternalsKey = "ElementInternals";
    ECP.supportsElementInternals = ElementInternalsKey in window &&
        "setFormValue" in window[ElementInternalsKey].prototype;
    const proxySlotName = "form-associated-proxy";
    const InternalsMap = new WeakMap();
    class FormAssociatedElement extends ECP.Component {
        static get formAssociated() {
            return ECP.supportsElementInternals;
        }
        get form() {
            return this.elementInternals ? this.elementInternals.form : this.proxy.form;
        }
        constructor() {
            super();
            this.dirtyValue = false;
            this.disabled = false;
            this.proxyEventsToBlock = ["change", "click"];
            this.proxyInitialized = false;
            if (!this.elementInternals) {
                this.formResetCallback = this.formResetCallback.bind(this);
            }
        }
        get elementInternals() {
            if (!ECP.supportsElementInternals) {
                return null;
            }
            let internals = InternalsMap.get(this);
            if (!internals) {
                internals = this.attachInternals();
                InternalsMap.set(this, internals);
            }
            return internals;
        }
        formResetCallback() {
            this.dirtyValue = false;
        }
        setFormValue(value, state) {
            if (this.elementInternals) {
                this.elementInternals.setFormValue(value, state || value);
            }
        }
        valueChanged(oldValue, newValue) {
            if (this.proxy instanceof HTMLElement) {
                this.proxy.value = this.value;
            }
            this.setFormValue(newValue);
        }
        nameChanged(previous, next) {
            if (this.proxy instanceof HTMLElement) {
                this.proxy.name = this.name;
            }
        }
        disabledChanged(previous, next) {
            if (this.proxy instanceof HTMLElement) {
                this.proxy.disabled = this.disabled;
            }
        }
        created(host) {
            this.addEventListener("keypress", this._keypressHandler);
            if (!this.elementInternals) {
                this.attachProxy();
            }
        }
        _keypressHandler(e) {
            switch (e.key) {
                case "Enter":
                    if (this.form instanceof HTMLFormElement) {
                        const defaultButton = this.form.querySelector("[type=submit]");
                        requestAnimationFrame(() => {
                            defaultButton?.click();
                        });
                    }
                    break;
            }
        }
        disconnectedCallback() {
            this.proxyEventsToBlock.forEach(name => this.proxy.removeEventListener(name, this.stopPropagation));
        }
        attachProxy() {
            if (!this.proxyInitialized) {
                this.proxyInitialized = true;
                this.proxy.style.display = "none";
                this.proxyEventsToBlock.forEach(name => this.proxy.addEventListener(name, this.stopPropagation));
                this.proxy.disabled = this.disabled;
                if (typeof this.name === "string") {
                    this.proxy.name = this.name;
                }
                if (typeof this.value === "string") {
                    this.proxy.value = this.value;
                }
                this.proxy.setAttribute("slot", proxySlotName);
                this.proxySlot = document.createElement("slot");
                this.proxySlot.setAttribute("name", proxySlotName);
            }
            this.shadowRoot?.appendChild(this.proxySlot);
            this.appendChild(this.proxy);
        }
        stopPropagation(e) {
            e.stopPropagation();
        }
    }
    ECP.FormAssociatedElement = FormAssociatedElement;
})(ECP || (ECP = {}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ECP;
(function (ECP) {
    let ECPSubTabs = class ECPSubTabs extends ECP.Component {
        created() {
            this.setAttribute("role", "tablist");
            this.addEventListener("ecp-subtab-select", (e) => {
                const selectedItem = e.target;
                const items = this.querySelectorAll("ecp-subtab-item");
                items.forEach((item) => {
                    if (item !== selectedItem && item.hasAttribute("selected")) {
                        item.removeAttribute("selected");
                    }
                });
                this.dispatchEvent(new Event("change"));
            });
        }
    };
    ECPSubTabs = __decorate([
        ECP.customElement({
            name: "ecp-subtabs",
            template: `<slot></slot>`,
            styles: `
            :host {
                display: flex;
                align-items: stretch;
                width: 100%;
                padding: 0 10px;
                background-color: transparent;
                overflow-x: auto;
            }

            :host([vertical]) {
                flex-direction: column;
                align-items: flex-start;
                padding: 0;
            }
            
            ::slotted(ecp-subtab-item:not(:last-child)) {
                margin-right: 10px;
            }

            :host([vertical]) ::slotted(ecp-subtab-item) {
                max-width: none;
                width: 100%;
            }

            :host([vertical]) ::slotted(ecp-subtab-item:not(:last-child)) {
                margin-bottom: 12px;
                margin-right: 0;
            }
        `
        })
    ], ECPSubTabs);
    ECP.ECPSubTabs = ECPSubTabs;
    let ECPSubTabItem = class ECPSubTabItem extends ECP.Component {
        created() {
            this.setAttribute("role", "tab");
            this.updateIcon();
            if (!this.disabled && !this.hasAttribute("tabindex")) {
                this.setAttribute("tabindex", "0");
            }
            this.shadowRoot.querySelector("slot").addEventListener("slotchange", () => {
                this.checkIconOnly();
            });
            this.addEventListener("click", () => {
                if (this.hasAttribute("disabled"))
                    return;
                if (this.href) {
                    try {
                        const isAnchor = this.href.startsWith("#");
                        const url = new URL(this.href, window.location.href);
                        if (isAnchor || url.protocol === "http:" || url.protocol === "https:") {
                            const a = document.createElement("a");
                            a.href = this.href;
                            if (this.target) {
                                a.target = this.target;
                                a.rel = "noopener noreferrer";
                            }
                            a.click();
                        }
                    }
                    catch (e) {
                        ECP.HTML.Snackbar("Invalid URL", "error");
                    }
                }
                if (!this.hasAttribute("selected")) {
                    this.setAttribute("selected", "");
                    this.dispatchEvent(new Event("ecp-subtab-select", { bubbles: true, composed: true }));
                }
            });
        }
        iconChanged(oldValue, newValue) {
            this.updateIcon();
        }
        selectedChanged(oldValue, newValue) {
            const isSelected = newValue !== null && newValue !== "false" && newValue !== false;
            this.setAttribute("aria-selected", isSelected ? "true" : "false");
        }
        checkIconOnly() {
            const slot = this.shadowRoot.querySelector('slot:not([name])');
            if (!slot)
                return;
            const nodes = slot.assignedNodes({ flatten: true });
            let hasContent = false;
            for (let node of nodes) {
                if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '') {
                    hasContent = true;
                    break;
                }
                if (node.nodeType === Node.ELEMENT_NODE) {
                    hasContent = true;
                    break;
                }
            }
            if (this.icon && !hasContent) {
                this.classList.add("icon-only");
            }
            else {
                this.classList.remove("icon-only");
            }
        }
        updateIcon() {
            const iconSpan = this.shadowRoot.querySelector(".icon");
            if (this.icon) {
                iconSpan.className = `icon ${this.icon}`;
                iconSpan.style.display = "";
            }
            else {
                iconSpan.className = `icon`;
                iconSpan.style.display = "none";
            }
            this.checkIconOnly();
        }
    };
    __decorate([
        ECP.attr
    ], ECPSubTabItem.prototype, "href", void 0);
    __decorate([
        ECP.attr
    ], ECPSubTabItem.prototype, "target", void 0);
    __decorate([
        ECP.attr
    ], ECPSubTabItem.prototype, "icon", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSubTabItem.prototype, "selected", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSubTabItem.prototype, "disabled", void 0);
    ECPSubTabItem = __decorate([
        ECP.customElement({
            name: "ecp-subtab-item",
            template: `<div class="ecp-body ecp-subtab-item">
            <span class="icon"></span>
            <div class="slot-wrap"><slot></slot></div>
            <div class="des-wrap"><slot name="des"></slot></div>
        </div>`,
            styles: `
            :host {
                display: flex;
            }

            :host([vertical]) ecp-subtab-item {
                max-width: none;
                width: 100%;
            }

            .ecp-subtab-item {
                display: flex;
                cursor: pointer;
                white-space: nowrap;
                color: var(--text);
                border: solid 1px transparent;
                border-radius: 6px;
                transition: var(--ecp-duration-fastest) var(--ecp-ease-standard);
                min-height: 32px;
                padding: 3px 10px;
                flex-direction: column;
                justify-content: center;
                box-sizing: border-box;
                width: 100%;
            }

            :host {
                outline: none;
            }

            :host(:focus-visible) .ecp-subtab-item {
                box-shadow: 0 0 0 1px var(--border-active) inset;
            }

            :host([icon]) .ecp-subtab-item {
                flex-direction: row;
                align-items: center;
                gap: 0 8px;
            }

            :host([icon].icon-only) .ecp-subtab-item {
                padding: 0;
                width: 32px;
            }
            
            .icon {
                line-height: 0;
                display: none;
            }

            .icon[class*="ews-icon-overflow"] {
                font-size: 24px;
            }

            .ecp-subtab-item:hover {
                background-color: var(--bg-hover);
            }

            :host([selected]:not([selected='false'])) .ecp-subtab-item {
                color: var(--text);
                text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;
                background-color: var(--bg-selected);
                border: 1px solid var(--border-selected);
            }

            :host([selected]:not([selected='false'])) .icon,
            :host([selected]:not([selected='false'])) ::slotted([class*="ews-icon-"]),
            :host([selected]:not([selected='false'])) ::slotted([class*="ews-illustration-"]) {
                text-shadow: none;
            }

            :host([des]) .ecp-subtab-item {
                display: grid;
                grid-template-columns: auto 1fr;
                grid-template-rows: auto auto;
                padding: 12px 16px;
                height: 100%;
            }

            :host([disabled]) {
                opacity: 0.3;
                cursor: not-allowed;
            }
            
            :host([disabled]) .ecp-subtab-item {
                pointer-events: none;
                cursor: not-allowed;
            }

            .slot-wrap {
                display: flex;
                align-items: center;
            }

            .des-wrap {
                grid-column: 1 / -1;
            }
        `,
            enableIcon: true
        })
    ], ECPSubTabItem);
    ECP.ECPSubTabItem = ECPSubTabItem;
    let ECPSubTabItemDes = class ECPSubTabItemDes extends ECP.Component {
        created() {
            this.setAttribute("slot", "des");
            if (this.parentElement) {
                this.parentElement.setAttribute("des", "true");
            }
        }
    };
    ECPSubTabItemDes = __decorate([
        ECP.customElement({
            name: "ecp-subtab-item-des",
            template: `<div class="ecp-subtabs-item-des"><slot></slot></div>`,
            styles: `
            :host {
                display: contents;
            }

            .ecp-subtabs-item-des {
                display: block;
                grid-column: span 2;
                overflow: hidden;
                overflow-wrap: break-word;
                width: 100%;
                white-space: normal;
                max-width: 300px;
                color: var(--text-secondary, #666);
                text-shadow: none;
            }
        `
        })
    ], ECPSubTabItemDes);
    ECP.ECPSubTabItemDes = ECPSubTabItemDes;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    if (!window.customElements.get("ecp-sectionmessage")) {
        class SectionMessageWebComponent extends HTMLElement {
            constructor() {
                super();
                this.SectionMessageHtml = "";
            }
            get type() {
                return this.getAttribute("type");
            }
            set type(value) {
                this.setAttribute("type", value);
            }
            get id() {
                return this.getAttribute("id");
            }
            set id(value) {
                this.setAttribute("id", value);
            }
            get class() {
                return this.getAttribute("class");
            }
            set class(value) {
                this.setAttribute("class", value);
            }
            get width() {
                return this.getAttribute("width");
            }
            set width(value) {
                this.setAttribute("width", value);
            }
            get trn() {
                return this.hasAttribute("trn");
            }
            set trn(value) {
                this.setAttribute("trn", value.toString());
            }
            connectedCallback() {
                if (!this.querySelector(".ecp-section-message")) {
                    this.SectionMessageHtml = this.innerHTML;
                    this.innerHTML = "";
                    this.initSectionMessage();
                }
            }
            initSectionMessage() {
                const me = this;
                const data = {
                    type: me.type,
                    typeClass: "",
                    icon: ""
                };
                switch (me.type ? me.type.toLowerCase() : me.type) {
                    case "warning":
                        data.type = "warning";
                        data.typeClass = "message-warning";
                        data.icon = '<i class="ews-icon-warning icon-warning"></i>';
                        break;
                    case "error":
                        data.type = "error";
                        data.typeClass = "message-error";
                        data.icon = '<i class="ews-icon-emerrorbold icon-error"></i>';
                        break;
                    default:
                        data.type = "information";
                        data.typeClass = "message-info";
                        data.icon = '<i class="ews-icon-info icon-info"></i>';
                        break;
                }
                if (me.class) {
                    data.typeClass += ` ${me.class}`;
                }
                let mySectionMessageTemplate = EC_Fmt.HtmlStrToElement(`<div ${me.trn ? "trn" : ''} class="ecp-section-message ${data.typeClass}"type="${data.type}">${data.icon}</div>`);
                if (me.width) {
                    mySectionMessageTemplate.style.width = me.width;
                }
                if (me.id) {
                    mySectionMessageTemplate.id = me.id;
                }
                if (me.SectionMessageHtml) {
                    const sectionMessage = document.createElement("div");
                    sectionMessage.classList.add("section-message");
                    sectionMessage.innerHTML = me.SectionMessageHtml;
                    mySectionMessageTemplate.appendChild(sectionMessage);
                }
                me.appendChild(mySectionMessageTemplate);
            }
        }
        document.addEventListener("DOMContentLoaded", () => {
            window.customElements.define("ecp-sectionmessage", SectionMessageWebComponent);
        });
    }
    if (!window.customElements.get("ecp-sectionmessage-action")) {
        class SectionMessageActionWebComponent extends HTMLElement {
            constructor() {
                super();
                this.SectionMessageActionHtml = "";
            }
            get id() {
                return this.getAttribute("id");
            }
            set id(value) {
                this.setAttribute("id", value);
            }
            get class() {
                return this.getAttribute("class");
            }
            set class(value) {
                this.setAttribute("class", value);
            }
            get href() {
                return this.getAttribute("href");
            }
            set href(value) {
                this.setAttribute("href", value);
            }
            get target() {
                return this.getAttribute("target");
            }
            set target(value) {
                this.setAttribute("target", value);
            }
            get trn() {
                return this.hasAttribute("trn");
            }
            set trn(value) {
                this.setAttribute("trn", value.toString());
            }
            connectedCallback() {
                this.SectionMessageActionHtml = this.innerHTML;
                this.innerHTML = "";
                this.initSectionMessageAction();
            }
            initSectionMessageAction() {
                const me = this;
                let mySectionMessageActionTemplate = EC_Fmt.HtmlStrToElement(`<div ${me.trn ? "trn" : ''} class="ecp-section-message-action ${me.class ? me.class : ''}"></div>`);
                if (me.href) {
                    let aTag = document.createElement("a");
                    aTag.setAttribute("href", me.href);
                    if (me.target) {
                        aTag.setAttribute("target", me.target);
                    }
                    if (me.SectionMessageActionHtml) {
                        aTag.innerHTML = me.SectionMessageActionHtml;
                    }
                    mySectionMessageActionTemplate.appendChild(aTag);
                }
                else if (me.SectionMessageActionHtml) {
                    let aTag = document.createElement("a");
                    aTag.setAttribute("href", "#");
                    aTag.innerHTML = me.SectionMessageActionHtml;
                    mySectionMessageActionTemplate.appendChild(aTag);
                }
                if (me.id) {
                    mySectionMessageActionTemplate.id = me.id;
                }
                me.appendChild(mySectionMessageActionTemplate);
            }
        }
        document.addEventListener("DOMContentLoaded", () => {
            window.customElements.define("ecp-sectionmessage-action", SectionMessageActionWebComponent);
        });
    }
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    if (!window.customElements.get("ecp-empty")) {
        class EmptyWebComponent extends HTMLElement {
            constructor() {
                super();
            }
            get illustration() {
                return this.getAttribute("illustration");
            }
            set illustration(value) {
                this.setAttribute("illustration", value);
            }
            get id() {
                return this.getAttribute("id");
            }
            set id(value) {
                this.setAttribute("id", value);
            }
            connectedCallback() {
                if (!this.querySelector(".empty-state")) {
                    this.initEmpty();
                }
            }
            initEmpty() {
                const me = this;
                const data = {
                    illustration: me.illustration,
                    icon: ""
                };
                switch (me.illustration ? me.illustration.toLowerCase() : me.illustration) {
                    case "success":
                        data.illustration = "success";
                        data.icon = "ews-illustration-flag";
                        break;
                    case "search":
                        data.illustration = "search";
                        data.icon = "ews-illustration-search";
                        break;
                    case "empty":
                        data.illustration = "empty";
                        data.icon = "ews-illustration-empty";
                        break;
                    case "404":
                        data.illustration = "search";
                        data.icon = "ews-illustration-search";
                        break;
                    case "permission":
                        data.illustration = "permission";
                        data.icon = "ews-illustration-permission";
                        break;
                    case "warning":
                        data.illustration = "warning";
                        data.icon = "ews-illustration-warning";
                        break;
                }
                const children = Array.from(this.children);
                const emptyContainer = document.createElement("div");
                emptyContainer.setAttribute("illustration", data.illustration);
                emptyContainer.classList.add("empty-state");
                emptyContainer.innerHTML = `<ecp-illustration illustration="${data.icon}"size=xl></ecp-illustration>`;
                me.appendChild(emptyContainer);
                for (let i = 0; i < children.length; i++) {
                    emptyContainer.appendChild(children[i]);
                }
            }
        }
        document.addEventListener("DOMContentLoaded", () => {
            window.customElements.define("ecp-empty", EmptyWebComponent);
        });
    }
    if (!window.customElements.get("ecp-empty-title")) {
        class EmptyTitleWebComponent extends HTMLElement {
            constructor() {
                super();
                this.EmptyTitleHtml = "";
            }
            connectedCallback() {
                if (!this.querySelector(".empty-title")) {
                    this.EmptyTitleHtml = this.innerHTML;
                    this.innerHTML = "";
                    this.initEmptyTitle();
                }
            }
            initEmptyTitle() {
                const me = this;
                const title = document.createElement("h3");
                title.classList.add("empty-title");
                title.innerHTML = me.EmptyTitleHtml;
                me.appendChild(title);
            }
        }
        document.addEventListener("DOMContentLoaded", () => {
            window.customElements.define("ecp-empty-title", EmptyTitleWebComponent);
        });
    }
    if (!window.customElements.get("ecp-empty-body")) {
        class EmptyBodyWebComponent extends HTMLElement {
            constructor() {
                super();
                this.EmptyBodyHtml = "";
            }
            connectedCallback() {
                if (!this.querySelector(".empty-description")) {
                    this.EmptyBodyHtml = this.innerHTML;
                    this.innerHTML = "";
                    this.initEmptyBody();
                }
            }
            initEmptyBody() {
                const me = this;
                const description = document.createElement("div");
                description.classList.add("empty-description");
                description.innerHTML = me.EmptyBodyHtml;
                me.appendChild(description);
            }
        }
        document.addEventListener("DOMContentLoaded", () => {
            window.customElements.define("ecp-empty-body", EmptyBodyWebComponent);
        });
    }
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    var ECPCheckbox_1;
    let ECPCheckboxGroup = class ECPCheckboxGroup extends ECP.Component {
        constructor() {
            super(...arguments);
            this.indeterminate = false;
            this.disabled = false;
        }
        created() {
            const selectAll = this.shadowRoot.querySelector(".select-all");
            let syncingSelectAllState = false;
            selectAll.addEventListener("change", () => {
                if (syncingSelectAllState) {
                    return;
                }
                const selectAllChecked = selectAll.checked;
                const checkboxes = this.shadowRoot.querySelector("slot").assignedElements();
                for (let i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = selectAllChecked;
                }
            });
            const checkSelectAllState = () => {
                let checkedCount = 0;
                let unCheckedCount = 0;
                const checkboxes = this.shadowRoot.querySelector("slot").assignedElements();
                for (let i = 0; i < checkboxes.length; i++) {
                    if (checkboxes[i].checked) {
                        checkedCount++;
                    }
                    else {
                        unCheckedCount++;
                    }
                }
                const allChecked = checkedCount > 0 && unCheckedCount === 0;
                const noneChecked = checkedCount === 0;
                syncingSelectAllState = true;
                selectAll.checked = allChecked;
                selectAll.indeterminate = !allChecked && !noneChecked;
                syncingSelectAllState = false;
            };
            this.shadowRoot.querySelector("slot").addEventListener("slotchange", () => {
                checkSelectAllState();
                const checkboxes = this.shadowRoot.querySelector("slot").assignedElements();
                for (let i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].removeEventListener("change", checkSelectAllState);
                    checkboxes[i].addEventListener("change", checkSelectAllState);
                }
            });
        }
        alignmentChanged() {
            if (this.alignment === "vertical") {
                this.shadowRoot.querySelector(".ecp-checkbox-group").classList.add("alignment");
            }
            else {
                this.shadowRoot.querySelector(".ecp-checkbox-group").classList.remove("alignment");
            }
        }
        indeterminateChanged() {
            const checkAllEl = this.shadowRoot.querySelector(".check-all");
            if (this.indeterminate) {
                checkAllEl.style.display = "block";
                this.shadowRoot.querySelector(".ecp-checkbox-group").classList.add("indeterminate");
            }
            else {
                checkAllEl.style.display = "none";
                this.shadowRoot.querySelector(".ecp-checkbox-group").classList.remove("indeterminate");
            }
        }
        checkedChanged() {
            const selectAll = this.shadowRoot.querySelector(".select-all");
            const selectAllChecked = !selectAll.checked;
            const checkboxes = this.shadowRoot.querySelector("slot").assignedElements();
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = selectAllChecked;
            }
        }
        disabledChanged() {
            const selectAll = this.shadowRoot.querySelector(".select-all");
            selectAll.disabled = this.disabled;
            const checkboxes = this.shadowRoot.querySelector("slot").assignedElements();
            for (let i = 0; i < checkboxes.length; i++) {
                checkboxes[i].disabled = this.disabled;
            }
        }
    };
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPCheckboxGroup.prototype, "indeterminate", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPCheckboxGroup.prototype, "alignment", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPCheckboxGroup.prototype, "disabled", void 0);
    ECPCheckboxGroup = __decorate([
        ECP.customElement({
            name: "ecp-checkbox-group",
            template: `<div class="ecp-checkbox check-all"><ecp-checkbox label="Select All"class=select-all></ecp-checkbox></div>
<div class=ecp-checkbox-group><slot></slot></div>`,
            styles: `
.check-all{
display:none
}
.ecp-checkbox-group{
font-size:0
}
.ecp-checkbox-group.alignment{
display:flex;
flex-direction:column
}
.ecp-checkbox-group.alignment ::slotted(*){
margin-top:10px
}`
        })
    ], ECPCheckboxGroup);
    ECP.ECPCheckboxGroup = ECPCheckboxGroup;
    let ECPCheckbox = ECPCheckbox_1 = class ECPCheckbox extends ECP.Component {
        constructor() {
            super(...arguments);
            this.indeterminate = false;
            this.checked = false;
            this.disabled = false;
            this.not = false;
        }
        created() {
            const checkbox = this.shadowRoot.querySelector("input");
            const handleEnterToggle = (event) => {
                if (event.defaultPrevented) {
                    return;
                }
                if (event.key === "Enter") {
                    event.preventDefault();
                    event.stopPropagation();
                    this.setChecked(checkbox, event);
                }
            };
            if (!this.disabled && !this.hasAttribute("tabindex")) {
                this.setAttribute("tabindex", "0");
            }
            this.shadowRoot.querySelector(".ecp-checkbox__inner").addEventListener("click", (event) => {
                this.setChecked(checkbox, event);
            });
            this.shadowRoot.querySelector(".ecp-checkbox__label").addEventListener("click", (event) => {
                this.setChecked(checkbox, event);
            });
            this.addEventListener("keydown", handleEnterToggle);
        }
        setChecked(checkbox, event) {
            this.checked = !this.checked;
            checkbox.setAttribute("checked", this.checked.toString());
            if (event.shiftKey && ECPCheckbox_1.lastChecked) {
                let start = ECPCheckbox_1.lastChecked.index ? parseInt(ECPCheckbox_1.lastChecked.index.toString()) : 0;
                let end = this.index ? parseInt(this.index.toString()) : 0;
                let checkVal = true;
                if (!ECPCheckbox_1.lastChecked.checked) {
                    checkVal = false;
                }
                if (this.checked === checkVal) {
                    if (start > end) {
                        [start, end] = [end, start];
                    }
                    const checkElements = Array.from(document.querySelectorAll(`ecp-checkbox[name='${this.name}']`))
                        .filter((element) => !element.closest("ecp-code-snippet"));
                    const checkElementsDictionary = Object.assign({}, ...checkElements.map((element) => ({ [Number(element.index)]: element })));
                    for (let i = start; i < end; i++) {
                        if (checkElementsDictionary[i]) {
                            checkElementsDictionary[i].checked = checkVal;
                        }
                    }
                }
            }
            ECPCheckbox_1.lastChecked = this;
        }
        labelChanged() {
            this.shadowRoot.querySelector(".ecp-checkbox__label").innerHTML = this.label || "";
        }
        nameChanged() {
            this.shadowRoot.querySelector("input").name = this.name || "";
        }
        valueChanged() {
            this.shadowRoot.querySelector("input").value = this.value;
        }
        checkedChanged() {
            this.shadowRoot.querySelector("input").checked = this.checked;
            const checkboxInput = this.shadowRoot.querySelector(".ecp-checkbox__input");
            if (this.checked) {
                checkboxInput.classList.add("is-checked");
            }
            else {
                checkboxInput.classList.remove("is-checked");
            }
            this.$emit("change");
        }
        disabledChanged() {
            this.shadowRoot.querySelector("input").disabled = this.disabled;
            if (this.hasAttribute("tabindex")) {
                this.setAttribute("tabindex", this.disabled ? "-1" : "0");
            }
            const checkboxInput = this.shadowRoot.querySelector(".ecp-checkbox__input");
            if (this.disabled) {
                checkboxInput.classList.add("is-disabled");
            }
            else {
                checkboxInput.classList.remove("is-disabled");
            }
        }
        indeterminateChanged() {
            const checkboxInput = this.shadowRoot.querySelector(".ecp-checkbox__input");
            if (this.indeterminate) {
                checkboxInput.classList.add("is-indeterminate");
            }
            else {
                checkboxInput.classList.remove("is-indeterminate");
            }
        }
        notChanged() {
            const checkboxNode = this.shadowRoot.querySelector(".ecp-checkbox__inner");
            if (this.not) {
                checkboxNode.classList.add("isNot");
            }
            else {
                checkboxNode.classList.remove("isNot");
            }
        }
    };
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPCheckbox.prototype, "indeterminate", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPCheckbox.prototype, "value", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPCheckbox.prototype, "label", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPCheckbox.prototype, "name", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPCheckbox.prototype, "checked", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPCheckbox.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPCheckbox.prototype, "index", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPCheckbox.prototype, "not", void 0);
    ECPCheckbox = ECPCheckbox_1 = __decorate([
        ECP.customElement({
            name: "ecp-checkbox",
            template: `<div class="ecp-checkbox ecp-checkbox__input">
    <span class=ecp-checkbox__inner></span>
    <input type=checkbox class=ecp-checkbox__original tabindex="0">
    <span class="ecp-checkbox__label"></span></div>`,
            styles: `
:host{
font-size:var(--body-font-size);
outline:none
}
:host:focus,
:host:focus-visible{
outline:none
}
:host(:focus-visible) .ecp-checkbox__inner{
outline: 1px solid var(--border-active);
outline-offset: 1px
}
.ecp-checkbox{
color:var(--text);
cursor:pointer;
display:inline-block;
user-select:none;
margin-right:20px;
position:relative
}
.ecp-checkbox__input{
line-height:1
}
.ecp-checkbox__input.is-disabled .ecp-checkbox__inner{
background-color:var(--layer-3);
border-color:var(--border);
cursor:not-allowed
}
.ecp-checkbox__input.is-disabled .ecp-checkbox__inner:after{
cursor:not-allowed;
border-color:var(--border);
color:var(--border)
}
.ecp-checkbox__input.is-disabled .ecp-checkbox__inner+.ecp-checkbox__label{
cursor:not-allowed
}
.ecp-checkbox__input.is-disabled.is-checked .ecp-checkbox__inner,
.ecp-checkbox__input.is-disabled.is-checked .ecp-checkbox__inner.isNot{
background-color:var(--layer-1);
border-color:var(--border) !important
}
.ecp-checkbox__input.is-disabled.is-indeterminate .ecp-checkbox__inner{
background-color:var(--text-accent);
border-color:var(--text-accent)
}
.ecp-checkbox__input.is-disabled.is-indeterminate .ecp-checkbox__inner:before{
background-color:var(--layer-1);
border-color:var(--layer-1)
}
.ecp-checkbox__input.is-checked .ecp-checkbox__inner{
background-color:var(--text-accent);
border-color:var(--text-accent)!important
}
.ecp-checkbox__input.is-checked .ecp-checkbox__inner:not(.isNot):after{
transform:rotate(45deg) scaleY(1)
}
.ecp-checkbox__input.is-checked .ecp-checkbox__inner.isNot{
background-color:var(--bg-error);
border-color:var(--bg-error)!important
}
.ecp-checkbox__input.is-checked .ecp-checkbox__inner.isNot:before{
transform:translate(-50%, -50%) rotate(45deg) scaleY(1)
}
.ecp-checkbox__input.is-checked .ecp-checkbox__inner.isNot:after{
transform:translate(-50%, -50%) rotate(-45deg) scaleY(1)
}
.ecp-checkbox__input.is-focus .ecp-checkbox__inner{
border-color:var(--text-accent)
}
.ecp-checkbox__input.is-indeterminate .ecp-checkbox__inner{
background-color:var(--text-accent);
border-color:var(--text-accent)
}
.ecp-checkbox__input.is-indeterminate .ecp-checkbox__inner:before{
content:'';
position:absolute;
display:block;
background-color:var(--bg);
height:4px;
transform:scale(0.5);
left:0;
right:0;
top:4px
}
.ecp-checkbox__input.is-indeterminate .ecp-checkbox__inner:after{
display:none
}
.ecp-checkbox__inner{
display:inline-flex;
align-items:center;
justify-content:center;
position:relative;
border:1px solid var(--border);
border-radius:2px;
box-sizing:border-box;
width:13px;
height:13px;
background-color:var(--bg);
z-index:1;
transition:border-color var(--ecp-duration-fastest) var(--ecp-ease-standard),background-color var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
.ecp-checkbox:hover .ecp-checkbox__inner{
border-color:var(--border-active)
}
.ecp-checkbox:hover .is-disabled .ecp-checkbox__inner{
border-color:var(--border)
}
.ecp-checkbox__inner:not(.isNot):after{
box-sizing:content-box!important;
content:'';
border:2px solid var(--bg);
border-left:0;
border-top:0;
height:7px;
left:3px;
position:absolute;
top:0;
transform:rotate(45deg) scaleY(0);
width:3px;
transition:transform var(--ecp-duration-fastest) var(--ecp-ease-standard);
transform-origin:center
}
.ecp-checkbox__inner.isNot:before,
.ecp-checkbox__inner.isNot:after {
content:'';
position:absolute;
top:50%;
left:50%;
width:11px;
height:2px;
border-radius:2px;
background:var(--bg);
transform:scaleY(0);
transition:transform var(--ecp-duration-fastest) var(--ecp-ease-standard);
transform-origin:center
}
.ecp-checkbox__original{
opacity:0;
outline:none;
position:absolute;
margin:0;
width:0;
height:0;
z-index:-1
}
.ecp-checkbox__original:focus,
.ecp-checkbox__original:focus-visible{
outline:none;
box-shadow:none
}
.ecp-checkbox__label{
padding-left:20px;
line-height:19px;
display:block;
word-wrap:break-word;
margin-top:-18px
}
ecp-checkbox:last-of-type{
margin-right:0
}
.ecp-checkbox.is-disabled{
color:var(--text-secondary);
cursor:not-allowed;
pointer-events: none
}`
        })
    ], ECPCheckbox);
    ECP.ECPCheckbox = ECPCheckbox;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    var ECPMenu_1;
    function findNearestTransformedAncestor(node) {
        let current = node;
        while (current) {
            if (current instanceof ShadowRoot) {
                current = current.host;
                continue;
            }
            if (current instanceof Element) {
                const style = window.getComputedStyle(current);
                if (style.transform && style.transform !== "none") {
                    return current;
                }
                current = current.parentNode;
                continue;
            }
            break;
        }
        return null;
    }
    function findNearestScrollableAncestor(node) {
        let current = node;
        while (current) {
            if (current instanceof ShadowRoot) {
                current = current.host;
                continue;
            }
            if (current instanceof Element) {
                const style = window.getComputedStyle(current);
                if (style.overflowY === "auto" || style.overflowY === "scroll") {
                    return current;
                }
                current = current.parentNode;
                continue;
            }
            break;
        }
        return null;
    }
    let ECPMenu = ECPMenu_1 = class ECPMenu extends ECP.Component {
        constructor() {
            super(...arguments);
            this._portalOriginalParent = null;
            this._portalOriginalNextSibling = null;
            this._portalScrollHandler = null;
            this._portalScrollTarget = null;
        }
        created() {
            const isSmallScreen = window.innerWidth <= 600 ? true : false;
            if (isSmallScreen) {
                this.classList.add("motion-moderate");
            }
            ECPMenu_1.MenuArr.push(this);
            this.addEventListener("click", (event) => {
                event.stopPropagation();
            });
        }
        ShowMenu(triggerElement) {
            const isSmallScreen = window.innerWidth <= 600;
            if (this.classList.contains("expanded")) {
                if (!isSmallScreen) {
                    this.classList.remove("slide-show");
                    this.style.animation = "ecp-keyframe-disappeartobottom var(--ecp-duration-fast)";
                    setTimeout(() => {
                        this.classList.remove("expanded");
                    }, 50);
                }
                else {
                    this.style.display = "none";
                    const height = this.offsetHeight;
                    this.style.transform = `translateY(${height}px)`;
                    const mobileMask = document.getElementById("MobileMenuMask");
                    if (mobileMask) {
                        mobileMask.remove();
                    }
                }
            }
            else {
                const rect = triggerElement.getBoundingClientRect();
                if (!isSmallScreen) {
                    const transformedAncestor = findNearestTransformedAncestor(this.parentNode);
                    if (transformedAncestor && !this._portalOriginalParent) {
                        this._portalOriginalParent = this.parentNode;
                        this._portalOriginalNextSibling = this.nextSibling;
                        transformedAncestor.appendChild(this);
                        const scrollTarget = findNearestScrollableAncestor(triggerElement.parentNode);
                        if (scrollTarget) {
                            this._portalScrollTarget = scrollTarget;
                            this._portalScrollHandler = () => this.CloseMenu();
                            scrollTarget.addEventListener("scroll", this._portalScrollHandler, { once: true });
                        }
                    }
                    const containerRect = transformedAncestor ? transformedAncestor.getBoundingClientRect() : null;
                    const availableWidth = containerRect ? containerRect.width : window.innerWidth;
                    const availableHeight = containerRect ? containerRect.height : window.innerHeight;
                    this.classList.add("expanded");
                    if (transformedAncestor) {
                        this.style.position = "absolute";
                    }
                    requestAnimationFrame(() => {
                        this.classList.add("slide-show");
                        this.style.animation = "ecp-keyframe-appearfromtop var(--ecp-duration-fast)";
                        const menuWidth = this.offsetWidth;
                        const menuHeight = this.offsetHeight;
                        let top = rect.top + triggerElement.offsetHeight;
                        let left = rect.left;
                        if (containerRect) {
                            top -= containerRect.top - transformedAncestor.scrollTop;
                            left -= containerRect.left - transformedAncestor.scrollLeft;
                        }
                        const rightMargin = availableWidth - triggerElement.offsetWidth - (containerRect ? left : rect.left);
                        const leftMargin = triggerElement.offsetWidth + (containerRect ? left : rect.left);
                        if ((menuHeight + top) > availableHeight && top > menuHeight) {
                            top -= menuHeight + 37;
                            this.classList.add("slide-bottom");
                        }
                        if ((menuHeight + top) > availableHeight) {
                            this.style.overflow = "auto";
                            this.style.bottom = "16px";
                        }
                        if ((this.offsetWidth + left) > availableWidth && left > (this.offsetWidth - triggerElement.offsetWidth)) {
                            left = (left - this.offsetWidth) + triggerElement.offsetWidth;
                        }
                        this.style.top = `${top}px`;
                        if ((menuWidth > rightMargin) && (menuWidth > leftMargin)) {
                            this.style.maxWidth = "100%";
                            this.style.left = "0";
                            this.style.right = "0";
                        }
                        else {
                            this.style.left = `${left}px`;
                            this.style.right = "unset";
                        }
                    });
                }
                else {
                    requestAnimationFrame(() => {
                        this.style.display = "block";
                        setTimeout(() => {
                            this.style.transform = "translateY(0px)";
                        }, 50);
                        const mobileMenuMaskDom = document.getElementById("MobileMenuMask");
                        if (!mobileMenuMaskDom) {
                            const maskHTML = document.createElement("div");
                            maskHTML.style.opacity = "0";
                            maskHTML.setAttribute("id", "MobileMenuMask");
                            maskHTML.classList.add("motion-slow");
                            requestAnimationFrame(() => {
                                maskHTML.style.opacity = "1";
                            });
                            this.parentNode.insertBefore(maskHTML, this);
                        }
                        requestAnimationFrame(() => {
                            this.style.left = "0";
                            this.style.right = "0";
                            this.style.bottom = "0";
                            this.style.width = "100%";
                            this.style.maxHeight = "256px";
                            this.style.borderRadius = "0";
                            this.style.boxShadow = "none";
                            this.style.overflowY = "auto";
                        });
                    });
                }
            }
        }
        CloseMenu() {
            if (this.classList.contains("slide-show")) {
                this.classList.remove("slide-show");
                this.classList.remove("expanded");
            }
            if (window.innerWidth <= 600 && this.style.display === "block" && this.style.transform === "translateY(0px)") {
                requestAnimationFrame(() => {
                    this.style.transform = `translateY(${this.offsetHeight}px)`;
                });
                setTimeout(() => {
                    this.classList.remove("expanded");
                }, 500);
                const MobileMenuMask = document.getElementById("MobileMenuMask");
                if (MobileMenuMask) {
                    MobileMenuMask.remove();
                }
            }
            this._restoreFromPortal();
        }
        _restoreFromPortal() {
            if (this._portalScrollTarget && this._portalScrollHandler) {
                this._portalScrollTarget.removeEventListener("scroll", this._portalScrollHandler);
            }
            this._portalScrollTarget = null;
            this._portalScrollHandler = null;
            if (this._portalOriginalParent) {
                if (this._portalOriginalNextSibling && this._portalOriginalNextSibling.parentNode === this._portalOriginalParent) {
                    this._portalOriginalParent.insertBefore(this, this._portalOriginalNextSibling);
                }
                else {
                    this._portalOriginalParent.appendChild(this);
                }
                this.style.position = "";
                this._portalOriginalParent = null;
                this._portalOriginalNextSibling = null;
            }
        }
    };
    ECPMenu.MenuArr = [];
    ECPMenu = ECPMenu_1 = __decorate([
        ECP.customElement({
            name: "ecp-menu",
            template: `<slot></slot>`,
            styles: `
:host{
display:none;
position:fixed;
z-index:666;
width:max-content;
background:var(--bg);
border:solid 1px var(--border);
border-radius:8px;
box-shadow:0 2px 6px rgba(0,0,0,0.2);
}
:host(.expanded){
display:block;
}
:host(.slide-show) {
transform: none;
}
::slotted(ecp-list){
padding:16px 8px
}`
        })
    ], ECPMenu);
    ECP.ECPMenu = ECPMenu;
    let ECPList = class ECPList extends ECP.Component {
        created() {
            const typeValue = this.getAttribute("type");
            if (typeValue === "null" || typeValue === "" || (typeValue !== "clickable" && typeValue !== "default")) {
                this.setAttribute("type", "default");
            }
        }
    };
    ECPList = __decorate([
        ECP.customElement({
            name: "ecp-list",
            template: `<slot></slot>`,
            styles: `
:host{
display:block;
padding:16px 0;
font-size:13px;
border-radius:4px
}
:host([type="clickable"]) ::slotted(ecp-list-item){
transition: background var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
:host([type="clickable"]) ::slotted(ecp-list-item:hover){
background:var(--bg-hover);
cursor:pointer
}`
        })
    ], ECPList);
    ECP.ECPList = ECPList;
    let ECPListSubHeader = class ECPListSubHeader extends ECP.Component {
    };
    ECPListSubHeader = __decorate([
        ECP.customElement({
            name: "ecp-list-subheader",
            template: `<slot></slot>`,
            styles: `
:host{
display:block;
padding:5px 16px 10px;
color:var(--text);
font-weight:bold
}`
        })
    ], ECPListSubHeader);
    ECP.ECPListSubHeader = ECPListSubHeader;
    let ECPListItem = class ECPListItem extends ECP.Component {
        sizeChanged(oldValue, newValue) {
            if (this.parentElement.getAttribute("type") == "clickable") {
                if (newValue && newValue.toLowerCase() === "large") {
                    this.classList.add("list-large");
                }
                else {
                    this.classList.remove("list-large");
                }
            }
        }
        hrefChanged(oldValue, newValue) {
            if (EC_Fmt.isNull(oldValue) && !EC_Fmt.isNull(newValue)) {
                this.addEventListener("click", (event) => this.onClick(event));
            }
            else if (!EC_Fmt.isNull(oldValue) && EC_Fmt.isNull(newValue)) {
                this.removeEventListener("click", this.onClick);
            }
        }
        onClick(event) {
            if (!EC_Fmt.isNull(this.href)) {
                EC_Fmt.OpenWithCtrlClickSupport(event, this.href);
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPListItem.prototype, "size", void 0);
    __decorate([
        ECP.attr
    ], ECPListItem.prototype, "href", void 0);
    ECPListItem = __decorate([
        ECP.customElement({
            name: "ecp-list-item",
            template: `<slot></slot>`,
            styles: `
:host{
display:flex;
justify-content:space-between;
padding:6px 16px;
border-radius:4px;
color:var(--text);
line-height:20px;
align-items: center;
}
:host([href]){
color:var(--text-link);
cursor:pointer
}
:host([href]:hover){
color:var(--text-link-hover)
}
:host(:not(:last-child)){
margin-bottom:4px
}
::slotted(a){
display:block;
color:var(--text)!important
}
:host(.list-large),
:host(.list-large) ::slotted(span[class*="ews-icon-"]){
line-height:44px!important
}
::slotted(span[class*="ews-icon-"]){
flex-shrink:0;
margin-right:8px;
width:24px;
line-height:20px!important;
font-size:15px!important
}
::slotted(.toggle-multiple-labels){
margin-left:48px
}

:host([ecp-colorstrip]) {
    position: relative;
}
:host([ecp-colorstrip]):before {
    content: "";
    display: block;
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 4px;
    width: 6px;
    background: transparent;
    border-radius: 4px;
}
:host([ecp-colorstrip="black"]):before {
    background: var(--strip-black);
}
:host([ecp-colorstrip="red"]):before,
:host([ecp-colorstrip="error"]):before,
:host([ecp-colorstrip="danger"]):before {
    background: var(--strip-red);
}
:host([ecp-colorstrip="orange"]):before {
    background: var(--strip-orange);
}
:host([ecp-colorstrip="yellow"]):before,
:host([ecp-colorstrip="warnings"]):before {
    background: var(--strip-yellow);
}
:host([ecp-colorstrip="green"]):before {
    background: var(--strip-green);
}
:host([ecp-colorstrip="teal"]):before,
:host([ecp-colorstrip="success"]):before,
:host([ecp-colorstrip="complete"]):before {
    background: var(--strip-teal);
}
:host([ecp-colorstrip="blue"]):before {
    background: var(--strip-blue);
}
:host([ecp-colorstrip="navy"]):before {
    background: var(--strip-navy);
}
:host([ecp-colorstrip="purple"]):before,
:host([ecp-colorstrip="pending"]):before {
    background: var(--strip-purple);
}
:host([ecp-colorstrip="magenta"]):before {
    background: var(--strip-magenta);
}
:host([ecp-colorstrip="black-subtle"]):before {
    background: var(--strip-black-subtle);
}
:host([ecp-colorstrip="red-subtle"]):before {
    background: var(--strip-red-subtle);
}
:host([ecp-colorstrip="orange-subtle"]):before {
    background: var(--strip-orange-subtle);
}
:host([ecp-colorstrip="yellow-subtle"]):before {
    background: var(--strip-yellow-subtle);
}
:host([ecp-colorstrip="green-subtle"]):before {
    background: var(--strip-green-subtle);
}
:host([ecp-colorstrip="teal-subtle"]):before {
    background: var(--strip-teal-subtle);
}
:host([ecp-colorstrip="blue-subtle"]):before {
    background: var(--strip-blue-subtle);
}
:host([ecp-colorstrip="navy-subtle"]):before {
    background: var(--strip-navy-subtle);
}
:host([ecp-colorstrip="purple-subtle"]):before {
    background: var(--strip-purple-subtle);
}
:host([ecp-colorstrip="magenta-subtle"]):before {
    background: var(--strip-magenta-subtle);
}`
        })
    ], ECPListItem);
    ECP.ECPListItem = ECPListItem;
    let ECPListItemContent = class ECPListItemContent extends ECP.Component {
    };
    ECPListItemContent = __decorate([
        ECP.customElement({
            name: "ecp-list-item-content",
            template: `<slot></slot>`,
            styles: `
 :host {
flex:1;
display:flex;
flex-direction:column;
font-size:inherit;
white-space:normal
 }`
        })
    ], ECPListItemContent);
    ECP.ECPListItemContent = ECPListItemContent;
    let ECPListItemTitle = class ECPListItemTitle extends ECP.Component {
    };
    ECPListItemTitle = __decorate([
        ECP.customElement({
            name: "ecp-list-item-title",
            template: `<slot></slot>`,
            styles: `
:host{
flex:1;
color:inherit;
font-size:inherit
}`
        })
    ], ECPListItemTitle);
    ECP.ECPListItemTitle = ECPListItemTitle;
    let ECPListItemSubTitle = class ECPListItemSubTitle extends ECP.Component {
    };
    ECPListItemSubTitle = __decorate([
        ECP.customElement({
            name: "ecp-list-item-subtitle",
            template: `<slot></slot>`,
            styles: `
:host{
color:var(--text-secondary);
font-size:inherit
}`
        })
    ], ECPListItemSubTitle);
    ECP.ECPListItemSubTitle = ECPListItemSubTitle;
    let ECPDivider = class ECPDivider extends ECP.Component {
    };
    ECPDivider = __decorate([
        ECP.customElement({
            name: "ecp-divider",
            styles: `
:host{
display:block;
margin:12px 16px;
height:1px;
background:var(--divider);
border:none
}`
        })
    ], ECPDivider);
    ECP.ECPDivider = ECPDivider;
    window.addEventListener("click", () => {
        for (let i = 0; i < ECPMenu.MenuArr.length; i++) {
            const ecpMenu = ECPMenu.MenuArr[i];
            if (ecpMenu) {
                ecpMenu.CloseMenu();
            }
        }
    });
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    var ECPAutoComplete_1;
    let ECPAutoComplete = ECPAutoComplete_1 = class ECPAutoComplete extends ECP.FormAssociatedElement {
        static GetMultiDisplayText(displayVal) {
            if (!displayVal) {
                return "";
            }
            const values = displayVal.split("^");
            const labels = [];
            for (let i = 0; i < values.length; i++) {
                const value = values[i];
                if (!value) {
                    continue;
                }
                const parts = value.split("|");
                labels.push(parts.length > 1 ? parts[1] : value);
            }
            return labels.join(", ");
        }
        constructor() {
            super();
            this.randomID = false;
            this.listLength = 40;
            this.allowAddRelated = false;
            this.disableNotIn = false;
            this.disabled = false;
            this.required = false;
            this.isSearch = false;
            this.limitToRefList = false;
            this.error = false;
            this.translate = false;
            this.labelAlign = "top";
            this.selected = false;
            this.isFocus = false;
            this.oldValue = "";
            this.autoCompleteUID = "";
            this.proxy = document.createElement("input");
        }
        EnsureAutoCompleteUID() {
            if (!this.autoCompleteUID) {
                const safeInputName = EC_Fmt.Null2EmptyStr(this.inputName).replace(/\s+/g, "_");
                ECPAutoComplete_1.AutoCompleteIndex++;
                this.autoCompleteUID = `${safeInputName}_${ECPAutoComplete_1.AutoCompleteIndex}`;
            }
            return this.autoCompleteUID;
        }
        created(host) {
            super.created(host);
            if (!this.inputName) {
                ECP.HTML.Snackbar('InputName is a required field.', "Error");
                return;
            }
            if (!this.name) {
                this.name = this.inputName;
            }
            const section = this.shadowRoot.querySelector("section");
            section.setAttribute("fieldid", this.inputName);
            const inputHidden = section.querySelector("input[type='hidden']");
            inputHidden.setAttribute("id", this.inputName + "Hidden");
            inputHidden.setAttribute("name", this.inputName);
            const resultDiv = section.querySelector("div");
            resultDiv.setAttribute("id", this.inputName + "_Results");
            const autoCompleteUID = this.EnsureAutoCompleteUID();
            resultDiv.setAttribute("AutoCompleteUID", autoCompleteUID);
            this.setAttribute("AutoCompleteUID", autoCompleteUID);
            if (this.width) {
                resultDiv.style.minWidth = this.width;
            }
            let dataType = ECP.DataType._Integer;
            if (this.dataType && this.dataType != "ECP.DataType._Integer") {
                let str = this.dataType.replace("ECP.DataType.", "");
                if (str) {
                    dataType = ECP.DataType[str];
                }
            }
            let displayType = ECP.DataType._Text;
            if (this.refFieldDisplayDataType) {
                let displayStr = this.refFieldDisplayDataType.replace("ECP.DataType.", "");
                if (displayStr) {
                    displayType = ECP.DataType[displayStr];
                }
            }
            if (this.refFieldSortOrder) {
                this.refFieldSortOrder = this.refFieldSortOrder.toUpperCase();
            }
            this.AutoCompleteOptions = {
                InputName: this.inputName,
                RefTable: this.refTable,
                RefField: this.refField,
                DataType: dataType,
                RefFieldDisplay: this.refFieldDisplay,
                RefFieldDisplayDataType: displayType,
                Width: 0,
                ListLength: this.listLength,
                IsSearch: this.isSearch,
                LimitToRefList: this.limitToRefList,
                CurValue: this.curValue,
                CurDisplayValue: this.curDisplayValue,
                RefFieldFilter: this.refFieldFilter,
                RefFieldSortOrder: this.refFieldSortOrder == "DESC" ? 2 : 1,
                Required: this.required,
                Translate: this.translate,
                TabIndex: this.tabIndex,
                RandomID: this.randomID,
                AllowAddRelated: this.allowAddRelated,
                LookupUrl: this.lookupUrl,
                ValuesArr: this.valuesArr,
                DisableNotIn: this.disableNotIn,
                HTMLAPICommandOverride: this.HTMLAPICommandOverride
            };
            if (this.curValue) {
                inputHidden.setAttribute("value", this.curValue);
                inputHidden.setAttribute("selarray", this.curValue);
            }
            if (this.limitToRefList == true) {
                const spanIcon = section.querySelector("span");
                spanIcon.classList.add("ews-icon-caretdown", "single-selection");
                spanIcon.classList.remove("ews-icon-ajaxinput", "ajax-input-icon");
            }
            if (this.disabled) {
                this.classList.add("disabled");
                section.classList.add("disabled");
            }
            ECP.HTML.AutoComplete(this.AutoCompleteOptions, this.APIToken, this.encompassID)
                .then((AutoCompleteHTML) => {
                const autoCompleteTemp = EC_Fmt.HtmlStrToElement(AutoCompleteHTML);
                const textInput = autoCompleteTemp.querySelector("input[type='text']");
                textInput.autocomplete = "off";
                if (this.placeholder) {
                    textInput.placeholder = this.placeholder;
                }
                if (this.curDisplayValue) {
                    textInput.value = this.curDisplayValue.replace("^", ",");
                }
                this.setAttribute("FieldID", autoCompleteTemp.getAttribute("FieldID"));
                this.setAttribute("AjaxCacheID", textInput.getAttribute("AjaxCacheID"));
                section.replaceChild(textInput, section.querySelector("input[type='text']"));
                if (textInput.value === "Multiple ...") {
                    const displayVal = textInput.getAttribute("displayval");
                    textInput.value = ECPAutoComplete_1.GetMultiDisplayText(displayVal);
                }
                this.AjaxInputInstance = new ECP.HTML.AjaxInput(textInput, this.APIToken, this.encompassID, InputChange);
                this.$emit("complete");
                if (!this.required) {
                    const hiddenTextInput = autoCompleteTemp.querySelector("input[type='hidden']");
                    textInput.addEventListener("change", () => {
                        this.AjaxInputInstance.isInternalUpdating = true;
                        if (EC_Fmt.isNull(textInput.value)) {
                            this.curDisplayValue = textInput.value;
                            this.value = hiddenTextInput.value;
                        }
                    });
                }
                textInput.addEventListener("click", (event) => {
                    this.isFocus = true;
                    section.classList.remove("hover", "selected");
                    this.selectedChanged(false, false);
                    this.oldValue = this.value;
                });
                section.addEventListener("mousedown", (event) => {
                    const target = event.target;
                    if (!target || this.disabled) {
                        return;
                    }
                    if (target.closest("input[type='text']") || target.closest(".btn-icon") || target.closest(".ews-icon-close") || target.closest(".AutocompleteMenu")) {
                        return;
                    }
                    EC_Fmt.TriggerEvent(textInput, "mousedown");
                });
                textInput.addEventListener("blur", () => {
                    if (this.oldValue !== inputHidden.value) {
                        resultDiv.setAttribute("inputchanged", "true");
                    }
                    else {
                        resultDiv.setAttribute("inputchanged", "false");
                    }
                    this.isFocus = false;
                    if (this.value) {
                        this.selectedChanged(false, true);
                    }
                });
            }).catch((error) => { throw new Error(error); });
            const me = this;
            function InputChange(input, hiddenInput) {
                if (input.getAttribute("keyvalue") == hiddenInput.value) {
                    me.curDisplayValue = input.getAttribute("displayval");
                }
                else {
                    me.curDisplayValue = input.value;
                }
                if (me.curValue !== hiddenInput.value || hiddenInput.value === "") {
                    me.curValue = hiddenInput.value;
                    me.$emit('change', {
                        input,
                        hiddenInput
                    });
                }
            }
            const el = this.shadowRoot.querySelector("section input[type='text']");
            const clearBtn = host.querySelector(".ews-icon-close");
            clearBtn.addEventListener("click", (event) => {
                event.stopPropagation();
                if (!this.isFocus) {
                    this.$emit("clear");
                    this.value = "";
                    this.curDisplayValue = "";
                    el.value = "";
                    const escapedName = EC_Fmt.CssEscape(this.name);
                    const clearSelector = `#${escapedName}_Results #AjaxClear`;
                    if (document.querySelector(clearSelector)) {
                        EC_Fmt.TriggerEvent(document.querySelector(clearSelector), "click");
                    }
                    this.shadowRoot.querySelector(".multiple-selected-num")?.classList.add("hidden");
                    this.shadowRoot.querySelector(".selected-item")?.classList.add("hidden");
                    this.shadowRoot.querySelector(".multiple-selected")?.classList.add("hidden");
                }
                event.preventDefault();
            }, false);
            const btn = host.querySelector(".btn-icon");
            this.addEventListener("mouseenter", (event) => {
                if (!this.isFocus) {
                    btn.classList.remove("hidden");
                    clearBtn.classList.add("hidden");
                    section.classList.add("hover");
                }
            });
            this.addEventListener("mouseout", (event) => {
                if (!this.isFocus) {
                    if (this.value && this.labelAlign === "inline") {
                        btn.classList.add("hidden");
                        clearBtn.classList.remove("hidden");
                    }
                    else {
                        btn.classList.remove("hidden");
                        clearBtn.classList.add("hidden");
                    }
                    section.classList.remove("hover");
                }
            }, false);
            btn.addEventListener("mouseenter", (event) => {
                event.stopPropagation();
                if (!this.isFocus && this.labelAlign === "inline") {
                    if (this.value) {
                        btn.classList.add("hidden");
                        clearBtn.classList.remove("hidden");
                        section.classList.remove("hover");
                    }
                    else {
                        btn.classList.remove("hidden");
                        clearBtn.classList.add("hidden");
                    }
                }
            });
            const numContainer = this.shadowRoot.querySelector(".multiple-selected-num .selected-item");
            numContainer?.addEventListener("mouseenter", (event) => {
                event.stopPropagation();
                if (!this.isFocus && this.value) {
                    btn.classList.add("hidden");
                    clearBtn.classList.remove("hidden");
                    section.classList.remove("hover");
                    const inputNode = this.shadowRoot.querySelector("input[type='text']");
                    const displayVal = inputNode?.getAttribute("displayval");
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    const s = getComputedStyle(inputNode);
                    context.font = `${s.fontStyle} ${s.fontVariant} ${s.fontWeight} ${s.fontSize} / ${s.lineHeight} ${s.fontFamily}`;
                    if (context.measureText(displayVal).width > inputNode.clientWidth) {
                        let tooltip = this.shadowRoot.querySelector(".tooltip-description");
                        if (!tooltip) {
                            tooltip = document.createElement("div");
                            tooltip.classList.add("tooltip-description");
                            this.shadowRoot.appendChild(tooltip);
                        }
                        tooltip.innerHTML = EC_Fmt.ReplaceAll(displayVal, "^", "<br>");
                        tooltip.classList.remove("hidden");
                        const target = event.currentTarget;
                        const targetRect = target.getBoundingClientRect();
                        if (window.innerHeight - targetRect.bottom < tooltip.clientHeight) {
                            tooltip.style.top = `${10 + targetRect.top - tooltip.clientHeight}px`;
                        }
                        else {
                            tooltip.style.top = `${10 + targetRect.top + targetRect.height}px`;
                        }
                        tooltip.style.transformOrigin = "right top";
                        tooltip.style.left = `${targetRect.left - inputNode.clientWidth / 2}px`;
                        tooltip.style.transform = "scaleY(1)";
                    }
                }
            }, false);
            numContainer.addEventListener("mouseout", (event) => {
                event.stopPropagation();
                if (!this.isFocus && this.value) {
                    let tooltip = this.shadowRoot.querySelector(".tooltip-description");
                    if (tooltip) {
                        tooltip.style.transform = "scaleY(0)";
                    }
                }
            }, false);
        }
        valueChanged(oldValue, newValue) {
            super.valueChanged(oldValue, newValue);
            if (oldValue !== newValue) {
                this.curValue = newValue;
            }
            let inputEl = this.shadowRoot.querySelector("section input[type='text']");
            if (newValue) {
                this.selectedChanged(false, true);
                let isShown = true;
                if ((EC_Fmt.isMobile && document.getElementById(this.inputName + "_MobileResult")?.style.display === "none") || this.AjaxInputInstance?.Results.style.display === "none") {
                    isShown = false;
                }
                if (!isShown && !this.AjaxInputInstance.isInternalUpdating) {
                    let AjaxNOT;
                    if (EC_Fmt.isMobile) {
                        AjaxNOT = this.AjaxInputInstance.MobileDialog?.querySelector("ecp-switch");
                    }
                    else {
                        AjaxNOT = this.AjaxInputInstance.AjaxInputActions.querySelector("#AjaxNOT");
                    }
                    let searchVal = newValue;
                    if (newValue.toString().startsWith("<>") && this.isSearch) {
                        searchVal = newValue.toString().substring(2);
                        if (AjaxNOT) {
                            this.shadowRoot.querySelector(".excludes").classList.remove("hidden");
                            AjaxNOT.checked = true;
                            AjaxNOT.classList.add("AjaxNotOn");
                            this.AjaxInputInstance.Results.classList.add("excludes");
                            this.AjaxInputInstance.NOT_SearchOn = true;
                        }
                    }
                    else if (AjaxNOT) {
                        this.shadowRoot.querySelector(".excludes").classList.add("hidden");
                        AjaxNOT.checked = false;
                        AjaxNOT.classList.remove("AjaxNotOn");
                        this.AjaxInputInstance.Results.classList.remove("excludes");
                        this.AjaxInputInstance.NOT_SearchOn = false;
                    }
                    let dataType = ECP.DataType._Integer;
                    if (this.dataType && this.dataType != "ECP.DataType._Integer") {
                        let str = this.dataType.replace("ECP.DataType.", "");
                        if (str) {
                            dataType = ECP.DataType[str];
                        }
                    }
                    let displayType = ECP.DataType._Text;
                    if (this.refFieldDisplayDataType) {
                        let displayStr = this.refFieldDisplayDataType.replace("ECP.DataType.", "");
                        if (displayStr) {
                            displayType = ECP.DataType[displayStr];
                        }
                    }
                    this.AutoCompleteOptions.RefFieldDisplayDataType = displayType;
                    this.AutoCompleteOptions.DataType = dataType;
                    this.AutoCompleteOptions.CurValue = newValue;
                    ECP.HTML.AutoComplete(this.AutoCompleteOptions, this.APIToken, this.encompassID)
                        .then((AutoCompleteHTML) => {
                        const autoCompleteTemp = EC_Fmt.HtmlStrToElement(AutoCompleteHTML);
                        const textInput = autoCompleteTemp.querySelector("input[type='text']");
                        const displayVal = textInput.getAttribute("displayval");
                        if (textInput.value === "Multiple ...") {
                            inputEl.value = ECPAutoComplete_1.GetMultiDisplayText(displayVal);
                        }
                        else {
                            inputEl.value = displayVal;
                        }
                        this.curDisplayValue = inputEl.value;
                        const el = this.shadowRoot.querySelector("section input[type='hidden']");
                        el.setAttribute("SelArray", searchVal);
                        inputEl.setAttribute("SelArray", textInput.getAttribute("selarray"));
                        inputEl.setAttribute("DisplayVal", textInput.getAttribute("displayval"));
                        inputEl.setAttribute("keyvalue", searchVal);
                        this.shadowRoot.querySelector(".multiple-selected-num")?.classList.add("hidden");
                    }).catch((error) => { throw new Error(error); });
                }
            }
            else {
                this.selectedChanged(false, false);
                inputEl.value = "";
                inputEl.setAttribute("SelArray", "");
                this.curDisplayValue = "";
                const escapedName = EC_Fmt.CssEscape(this.name);
                const mobileResultSelector = `#${escapedName}_MobileResult`;
                if (EC_Fmt.isMobile && document.querySelector(mobileResultSelector)) {
                    document.querySelector(`${mobileResultSelector} div.ajaxinput-mobile-wrapper input`)?.setAttribute('placeholder', "");
                    document.querySelector(`${mobileResultSelector} .selected-item`)?.classList.add("hidden");
                    document.querySelector(`${mobileResultSelector} .multiple-selected`)?.classList.add("hidden");
                    document.querySelector(`${mobileResultSelector} .multiple-selected-num`)?.classList.add("hidden");
                }
                else {
                    this.shadowRoot.querySelector(".multiple-selected-num")?.classList.add("hidden");
                    this.shadowRoot.querySelector(".selected-item")?.classList.add("hidden");
                    this.shadowRoot.querySelector(".multiple-selected")?.classList.add("hidden");
                }
            }
            if (this.label && this.labelAlign === "inline") {
                const labelInline = this.shadowRoot.querySelector(".label-inline");
                if (labelInline) {
                    labelInline.innerHTML = newValue || this.placeholder ? this.label + ":" : this.label;
                }
            }
            if (this.AjaxInputInstance) {
                this.AjaxInputInstance.isInternalUpdating = false;
            }
        }
        curValueChanged(oldValue, newValue) {
            const el = this.shadowRoot.querySelector("section input[type='hidden']");
            el.value = newValue;
            this.value = newValue;
        }
        curDisplayValueChanged() {
            if (this.shadowRoot.querySelector(".selected-item").classList.contains("hidden")) {
                const el = this.shadowRoot.querySelector("section input[type='text']");
                el.value = EC_Fmt.ReplaceAll(this.curDisplayValue.toString(), "^", ", ");
            }
        }
        widthChanged() {
            const el = this.shadowRoot.querySelector("section");
            if (EC_Fmt.isNumber(this.width)) {
                el.style.width = this.width + "px";
            }
            else {
                el.style.width = this.width;
            }
        }
        disabledChanged() {
            const section = this.shadowRoot.querySelector("section");
            if (this.disabled) {
                this.classList.add("disabled");
                section.classList.add("disabled");
            }
            else {
                this.classList.remove("disabled");
                section.classList.remove("disabled");
            }
        }
        nameChanged(oldValue, newValue) {
            this.inputName = newValue;
        }
        sizeChanged(oldValue, newValue) {
            const section = this.shadowRoot.querySelector("section");
            const label = this.shadowRoot.querySelector(".label");
            if (newValue && newValue.toLowerCase() === "large") {
                section.classList.add("AutoCompleteInput-large");
                if (label && this.labelAlign == "left") {
                    label.classList.add("AutoCompleteInput-large");
                }
            }
            else {
                section.classList.remove("AutoCompleteInput-large");
                if (label) {
                    label.classList.remove("AutoCompleteInput-large");
                }
            }
        }
        errorChanged(oldValue, newValue) {
            const section = this.shadowRoot.querySelector("section");
            if (newValue) {
                section.classList.add("Autocomplete-error");
            }
            else {
                section.classList.remove("Autocomplete-error");
            }
        }
        helperTextChanged(oldValue, newValue) {
            const helperText = this.shadowRoot.querySelector(".helper-text");
            if (newValue) {
                if (helperText) {
                    helperText.innerHTML = newValue;
                }
                else {
                    const span = document.createElement("span");
                    span.classList.add("helper-text");
                    span.innerHTML = newValue;
                    this.shadowRoot.appendChild(span);
                }
                this.setPadding();
            }
            else if (helperText) {
                this.shadowRoot.removeChild(helperText);
            }
        }
        select() {
            const input = this.shadowRoot.querySelector("input[type='text']");
            if (input) {
                input.select();
            }
        }
        focus() {
            const input = this.shadowRoot.querySelector("input[type='text']");
            if (input) {
                input.focus();
            }
        }
        labelChanged(oldValue, newValue) {
            const label = this.shadowRoot.querySelector(".label");
            if (this.labelAlign == "inline") {
                const labelInline = this.shadowRoot.querySelector(".label-inline");
                labelInline.innerHTML = newValue && (this.value || this.placeholder) ? newValue + ":" : newValue;
            }
            else if (newValue) {
                if (label) {
                    label.innerHTML = newValue;
                }
                else {
                    const firstChild = this.shadowRoot.firstChild;
                    const label = document.createElement("label");
                    label.classList.add("label");
                    label.innerHTML = newValue;
                    this.shadowRoot.insertBefore(label, firstChild);
                }
            }
            else if (label) {
                this.shadowRoot.removeChild(label);
            }
        }
        labelAlignChanged(oldValue, newValue) {
            if (newValue) {
                const label = this.shadowRoot.querySelector(".label");
                const labelInline = this.shadowRoot.querySelector(".label-inline");
                const section = this.shadowRoot.querySelector("section");
                if (newValue === "top") {
                    if (label) {
                        label.classList.remove("hidden", "label-column");
                        section.classList.remove("flex-label");
                        this.classList.remove("flex");
                    }
                    labelInline.classList.add("hidden");
                    this.selectedChanged(false, false);
                }
                else if (newValue === "left") {
                    if (label) {
                        label.classList.add("label-column");
                        label.classList.remove("hidden");
                        section.classList.add("flex-label");
                        this.classList.add("flex");
                    }
                    labelInline.classList.add("hidden");
                    this.selectedChanged(false, false);
                }
                else if (newValue === "inline") {
                    section.classList.remove("flex-label");
                    this.classList.remove("flex");
                    labelInline.innerHTML = this.label && (this.value || this.placeholder) ? this.label + ":" : this.label;
                    labelInline.classList.remove("hidden");
                    if (label) {
                        label.classList.add("hidden");
                    }
                    if (this.value) {
                        this.selectedChanged(false, true);
                    }
                }
                this.setPadding();
            }
        }
        selectedChanged(oldValue, newValue) {
            const clearBtn = this.shadowRoot.querySelector(".ews-icon-close");
            const section = this.shadowRoot.querySelector("section");
            const btn = this.shadowRoot.querySelector(".btn-icon");
            if (this.labelAlign == "inline" && newValue) {
                if (this.value) {
                    clearBtn.classList.remove("hidden");
                    btn.classList.add("hidden");
                }
                section.classList.add("selected");
            }
            else {
                clearBtn.classList.add("hidden");
                btn.classList.remove("hidden");
                section.classList.remove("selected");
            }
        }
        setPadding() {
            const helperText = this.shadowRoot.querySelector(".helper-text");
            if (helperText) {
                if (this.label && this.labelAlign == "left") {
                    const label = this.shadowRoot.querySelector(".label");
                    helperText.style.paddingLeft = (label.clientWidth + 12) + "px";
                }
                else {
                    helperText.style.paddingLeft = "0px";
                }
            }
        }
    };
    ECPAutoComplete.AutoCompleteIndex = 0;
    __decorate([
        ECP.attr
    ], ECPAutoComplete.prototype, "name", void 0);
    __decorate([
        ECP.attr
    ], ECPAutoComplete.prototype, "value", void 0);
    __decorate([
        ECP.attr
    ], ECPAutoComplete.prototype, "size", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "APIToken", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "encompassID", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "inputName", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "refTable", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "refField", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "dataType", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "refFieldDisplay", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "refFieldDisplayDataType", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPAutoComplete.prototype, "curValue", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPAutoComplete.prototype, "curDisplayValue", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "refFieldFilter", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "refFieldSortOrder", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "randomID", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "listLength", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "allowAddRelated", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "lookupUrl", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "disableNotIn", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "valuesArr", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "placeholder", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPAutoComplete.prototype, "width", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], ECPAutoComplete.prototype, "HTMLAPICommandOverride", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "required", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "isSearch", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "limitToRefList", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "error", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "translate", void 0);
    __decorate([
        ECP.attr
    ], ECPAutoComplete.prototype, "helperText", void 0);
    __decorate([
        ECP.attr
    ], ECPAutoComplete.prototype, "label", void 0);
    __decorate([
        ECP.attr
    ], ECPAutoComplete.prototype, "labelAlign", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPAutoComplete.prototype, "selected", void 0);
    ECPAutoComplete = ECPAutoComplete_1 = __decorate([
        ECP.customElement({
            name: "ecp-auto-complete",
            template: `<section class="AutocompleteField inline"><input type=hidden SelArray value><label class=label-inline></label><label class="excludes hidden">Excludes</label>
        <label class="multiple-selected hidden"></label><label class="selected-item hidden">1</label>
<input type=text class="AutoCompleteInput Autocomplete"autocomplete=off></input>
<label class="multiple-selected-num hidden"><label></label><label class="selected-item"></label></label>
<span class="ews-icon-ajaxinput ajax-input-icon btn-icon"></span><icon class="ews-icon-close ajax-input-icon hidden"></icon>
<div class="AutocompleteList AutocompleteMenu Hideable"style=display:none;flex-direction:column>
<div style=overflow:auto;flex:1>
<div></div><div></div></div></div></section>`,
            styles: `
.AutocompleteField{
display:flex;
border:1px var(--border) solid;
border-radius:4px;
height:32px;
line-height:32px;
box-sizing:border-box;
padding-left:var(--ecp-auto-complete-padding-left, 12px);
align-items:center;
background:var(--bg);
transition:border-color var(--ecp-duration-fastest) var(--ecp-ease-standard),background-color var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
.AutoCompleteInput{
height:100%;
padding:0;
width:100%;
background:var(--bg);
border-radius:4px 0 0 4px;
border:none;
font-family:inherit;
outline:none;
font-size:13px;
overflow:hidden;
text-overflow:ellipsis;
font-weight:var(--regular-weight);
color:var(--text)
}
.selected .AutoCompleteInput{
font-weight:var(--semibold-weight)
}
:host section span{
width:28px;
height:100%;
line-height:inherit;
text-align:center;
font-size:13px;
border:none;
border-radius:0 4px 4px 0;
background:var(--bg);
margin:0;
padding-right:5px;
cursor:pointer
}
.AutocompleteActive{
border-color:var(--border-active)
}
.AutocompleteActive input[type='text']{
outline:none
}
.disabled{
pointer-events:none;
cursor:not-allowed;
background:var(--bg-object)!important;
border-color:var(--bg-object)!important;
color:var(--text-secondary)
}
.AutoCompleteInput-large,.AutoCompleteInput-large.label-column{
height:44px!important;
line-height:44px!important
}
.AutoCompleteInput-large span{
width:40px
}
.Autocomplete-error{
border-color:var(--text-error)
}
.helper-text{
font-size:10px!important;
color:var(--text-secondary);
flex:0 0 100%;
box-sizing:border-box;
display:block
}
.flex-label{
flex:1
}
.label{
display:inline-block
}
.label-column{
height:32px;
line-height:32px;
margin-right:12px
}
.label:not(.label-column){
margin-bottom:4px
}
.inline .label-inline{
height:100%;
margin-right:8px;
white-space:nowrap;
cursor:pointer
}
.hidden{
display:none!important
}
.ews-icon-close::before{
font-size:10px;
display:inline-block;
width:18px
}
.inline .btn-icon::before{
display:inline-block;
width:18px
}
.inline .ews-icon-close{
height:18px;
line-height:18px;
margin-right:8px;
padding-right:0;
border-radius:50%;
text-align:center
}
.inline.hover{
background:var(--bg-hover)!important
}
.inline.selected{
background:var(--bg-selected);
border:1px solid var(--border-selected)
}
.inline.selected.hover{
background:var(--bg-selected-hover)!important
}
.inline .AutoCompleteInput,
.inline .ajax-input-icon,
.inline .btn-icon{
background:transparent;
cursor:pointer
}
.inline.selected .ews-icon-close:hover{
background:var(--bg-object)
}
.excludes{
color:var(--text-error);
font-size:var(--body-font-size);
font-weight:var(--semibold-weight);
margin-right:4px
}
.inline .selected-item{
display:flex;
height:16px;
padding:0 5px;
justify-content:center;
align-items:center;
border-radius:2px;
margin-right:8px;
background:var(--neutral-t24);
color:var(--text);
font-size:var(--bodysm-font-size);
font-weight:var(--bold-weight);
cursor:pointer;
line-height:var(--bodysm-line-height)
}
.inline .multiple-selected,
.inline .multiple-selected-num{
display:flex;
align-items:center;
cursor:pointer;
height:100%
}
.inline .multiple-selected:before,
.inline .multiple-selected-num:before,
.inline .multiple-selected:after,
.inline .multiple-selected-num label:first-child{
display:block;
content:"";
width:3px;
height:16px;
margin-right:2px;
border-radius:2px 0px 0px 2px;
background:var(--neutral-t24)
}
.AutoCompleteInput:focus{
font-weight:var(--regular-weight)
}
.tooltip-description{
position:fixed;
background:var(--neutral-120);
color:var(--text-onbg-action);
padding:8px 12px;
border-radius:5px;
z-index:667;
box-shadow:0 -5px 10px -2px rgba(0,0,0,0.4);
width:180px;
word-wrap:break-word;
transition:transform var(--ecp-duration-fastest) var(--ecp-ease-standard);
font-size:var(--body-font-size);
font-weight:var(--semibold-weight);
line-height:var(--body-line-height);
max-height:278px;
overflow-y:auto;
transform:scaleY(0)
}`,
            enableIcon: true,
            shadowOptions: {
                mode: "open",
                delegatesFocus: true
            }
        })
    ], ECPAutoComplete);
    ECP.ECPAutoComplete = ECPAutoComplete;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPButton = class ECPButton extends ECP.Component {
        constructor() {
            super(...arguments);
            this.type = "default";
            this.dropdown = false;
            this.disabled = false;
            this.inverted = false;
        }
        getTypeClass() {
            let typeClass = "";
            switch (this.type) {
                case "ghost":
                    break;
                case "secondary":
                    typeClass = "button-default";
                    break;
                case "primary":
                case "permanent":
                case "permanent-destructive":
                    if (!this.disabled) {
                        typeClass = `button-${this.type.toLowerCase()}`;
                    }
                    else {
                        typeClass = `button-primary`;
                    }
                    break;
                default:
                    typeClass = "button-default";
                    break;
            }
            return typeClass;
        }
        typeChanged(oldValue, newValue) {
            this.type = newValue ? newValue.toLowerCase() : "default";
            const button = this.shadowRoot.querySelector("button");
            button.classList.remove("button-default", "button-primary", "button-permanent", "button-permanent-destructive");
            const typeClass = this.getTypeClass();
            if (typeClass) {
                button.classList.add(typeClass);
            }
        }
        disabledChanged(oldValue, newValue) {
            const button = this.shadowRoot.querySelector("button");
            button.classList.remove("button-default", "button-primary", "button-permanent", "button-permanent-destructive");
            if (newValue) {
                button.classList.add("disabled");
            }
            else {
                button.classList.remove("disabled");
            }
            const typeClass = this.getTypeClass();
            if (typeClass) {
                button.classList.add(typeClass);
            }
        }
        iconChanged(oldValue, newValue) {
            const button = this.shadowRoot.querySelector("button");
            const hasText = !EC_Fmt.isNull(this.textContent);
            if (oldValue) {
                const icon = this.shadowRoot.querySelector(`span.${oldValue}`);
                if (icon) {
                    icon.remove();
                }
            }
            button.classList.remove("icon-right", "button-icon");
            if (newValue) {
                button.classList.add(hasText ? "icon-left" : "button-icon");
                const newIcon = document.createElement("span");
                newIcon.className = newValue;
                button.insertBefore(newIcon, button.firstChild);
                if (!hasText && this.style.fontSize) {
                    button.style.fontSize = this.style.fontSize;
                }
                this.invertedChanged(!this.inverted, this.inverted);
            }
        }
        dropdownChanged(oldValue, newValue) {
            const button = this.shadowRoot.querySelector("button");
            if (newValue) {
                button.classList.add("icon-right");
                const newIcon = document.createElement("span");
                newIcon.classList.add("ews-icon-caretdown");
                button.insertBefore(newIcon, button.firstChild);
            }
            else {
                button.classList.remove("icon-right");
                const icon = this.shadowRoot.querySelector(`span.ews-icon-caretdown`);
                if (icon) {
                    icon.remove();
                }
            }
        }
        hrefChanged(oldValue, newValue) {
            let linkElement = this.shadowRoot.querySelector("a");
            if (newValue) {
                if (linkElement) {
                    linkElement.href = newValue;
                    if (this.target) {
                        linkElement.target = this.target;
                    }
                    else {
                        linkElement.removeAttribute("target");
                    }
                }
                else {
                    linkElement = document.createElement("a");
                    if (this.target) {
                        linkElement.target = this.target;
                    }
                    linkElement.href = newValue;
                    linkElement.appendChild(this.shadowRoot.querySelector("button"));
                    this.shadowRoot.appendChild(linkElement);
                }
            }
            else {
                if (linkElement) {
                    this.shadowRoot.insertBefore(linkElement.querySelector("button"), this.shadowRoot.firstChild);
                    this.shadowRoot.removeChild(linkElement);
                }
            }
        }
        targetChanged(oldValue, newValue) {
            let linkElement = this.shadowRoot.querySelector("a");
            if (linkElement) {
                if (newValue) {
                    linkElement.target = newValue;
                }
                else {
                    linkElement.removeAttribute("target");
                }
            }
        }
        invertedChanged(oldValue, newValue) {
            const button = this.shadowRoot.querySelector("button.button-icon");
            if (button) {
                if (newValue) {
                    button.classList.add("button-inverted");
                }
                else {
                    button.classList.remove("button-inverted");
                }
            }
        }
        sizeChanged(oldValue, newValue) {
            if (newValue && newValue.toLowerCase() === "large") {
                this.classList.add("button-large");
            }
            else {
                this.classList.remove("button-large");
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPButton.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], ECPButton.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], ECPButton.prototype, "href", void 0);
    __decorate([
        ECP.attr
    ], ECPButton.prototype, "target", void 0);
    __decorate([
        ECP.attr
    ], ECPButton.prototype, "size", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPButton.prototype, "dropdown", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPButton.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPButton.prototype, "inverted", void 0);
    ECPButton = __decorate([
        ECP.customElement({
            name: "ecp-btn",
            template: `<button type=button class=button><slot></slot></button>`,
            styles: `
:host{
display:inline-block;
height:32px;
cursor:pointer
}
button{
font-size:var(--body-font-size);
line-height:var(--body-line-height);
margin-right:0!important;
height:unset;
border:none;
width:100%
}
.button{
color:var(--text);
display:inline-flex;
flex-wrap:nowrap;
align-items:center;
justify-content:center;
background-color:transparent;
font-weight:var(--regular-weight);
white-space:nowrap;
user-select:none;
height:100%;
border:1px solid transparent;
border-radius:4px;
text-decoration:none;
cursor:inherit;
padding:7px 12px;
transition:background-color var(--ecp-duration-fastest) var(--ecp-ease-standard),border-color var(--ecp-duration-fastest) var(--ecp-ease-standard),color var(--ecp-duration-fastest) var(--ecp-ease-standard),transform var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
.button:active:not(.disabled){
transform:scale(0.97)
}
.button.disabled{
opacity:0.3;
cursor:not-allowed
}
.button.icon-left span[class*="ews-icon-"]{
margin-right:5px
}
.button.icon-right{
flex-direction:row-reverse
}
.button.icon-right span[class*="ews-icon-"]{
margin-left:10px
}
.button.icon-right span[class*="ews-icon-"]::before{
font-size:12px;
vertical-align:-2px
}
.button-icon{
max-width:32px;
max-height:32px
}
.button-icon .ews-icon-overflow{
font-size:24px
}
.button-icon.button-inverted{
color:var(--text-onbg-action)
}
.button-icon.button-inverted:hover{
background:transparent
}
.button-default{
color:var(--text);
background:var(--bg);
border-color:var(--border)
}
.button:hover,
.button-default:hover{
background-color:var(--bg-hover)
}
.button:active,
.button-default:active{
background-color:var(--bg-active)
}
.button.button-default.disabled{
background:var(--neutral-t16);
border-color:var(--neutral-t16)
}
.button-primary{
background-color:var(--bg-action);
color:var(--text-onbg-action);
border-color:var(--bg-action)
}
.button-primary:hover{
background-color:var(--bg-action-hover);
border-color:var(--bg-action-hover)
}
.button-primary:active{
background:var(--bg-action-active);
border-color:var(--bg-action-active)
}
.button-primary.disabled{
background:var(--neutral-60);
border-color:var(--neutral-60)
}
.button-permanent{
color:var(--text-onbg-success);
background-color:var(--bg-success);
border-color:var(--bg-success)
}
.button-permanent:hover{
background-color:var(--bg-success-hover);
border-color:var(--bg-success-hover)
}
.button-permanent:active{
background:var(--bg-success-active);
border-color:var(--bg-success-active)
}
.button-permanent-destructive{
color:var(--text-onbg-error);
background-color:var(--bg-error);
border-color:var(--bg-error)
}
.button-permanent-destructive:hover{
background-color:var(--bg-error-hover);
border-color:var(--bg-error-hover)
}
.button-permanent-destructive:active{
background-color:var(--bg-error-active);
border-color:var(--bg-error-active)
}
:host([disabled]:active){
pointer-events:none
}
:host([disabled="false"]){
pointer-events:auto
}
a:link, a:visited, a:active{
color:var(--text-link)
}
a{
text-decoration:none
}
:host(.button-large){
height:44px
}
:host(.button-large) button{
padding:7px 16px
}
:host(.button-large) .icon-left span[class*="ews-icon-"]{
margin-right:10px
}
:host(.button-large) .button-icon:not(.icon-left){
max-width:44px;
max-height:44px
}
:host(.button-large) .button-icon:not(.icon-left) span[class*="ews-icon-"]{
display:flex;
align-items:center;
font-size:18px
}
:host(.button-large) .button-icon:not(.icon-left) span.ews-icon-overflow{
font-size:30px
}
:host([shimmer]) .button-icon span[class*="ews-icon-"]{
animation:ecp-btn-icon-shimmer 1.4s ease-in-out 800ms 1
}
/* Keyframes must live in this shadow root: page-level @keyframes are not visible to shadow elements */
@keyframes ecp-btn-icon-shimmer{
from{
color:transparent;
background-image:linear-gradient(100deg,var(--text) 35%,var(--teal) 50%,var(--text) 65%);
background-size:500% 100%;
background-position:100% 0;
-webkit-background-clip:text;
background-clip:text
}
to{
color:transparent;
background-image:linear-gradient(100deg,var(--text) 35%,var(--teal) 50%,var(--text) 65%);
background-size:500% 100%;
background-position:0 0;
-webkit-background-clip:text;
background-clip:text
}
}
@media (prefers-reduced-motion:reduce){
:host([shimmer]) .button-icon span[class*="ews-icon-"]{
animation:none
}
}`,
            enableIcon: true
        })
    ], ECPButton);
    ECP.ECPButton = ECPButton;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let DayType;
    (function (DayType) {
        DayType[DayType["_StartDate"] = 0] = "_StartDate";
        DayType[DayType["_EndDate"] = 1] = "_EndDate";
        DayType[DayType["_CurrDate"] = 2] = "_CurrDate";
    })(DayType || (DayType = {}));
    let DatePickerType;
    (function (DatePickerType) {
        DatePickerType["_Exactly"] = "Exactly";
        DatePickerType["_Before"] = "Before";
        DatePickerType["_After"] = "After";
        DatePickerType["_Between"] = "Between";
    })(DatePickerType || (DatePickerType = {}));
    let Period;
    (function (Period) {
        Period[Period["None"] = 0] = "None";
        Period[Period["Last 30 Days"] = 1] = "Last 30 Days";
        Period[Period["Last 60 Days"] = 2] = "Last 60 Days";
        Period[Period["Last 90 Days"] = 3] = "Last 90 Days";
        Period[Period["Last 2 Weeks"] = 4] = "Last 2 Weeks";
        Period[Period["Last 4 Weeks"] = 5] = "Last 4 Weeks";
        Period[Period["Last 8 Weeks"] = 6] = "Last 8 Weeks";
        Period[Period["Last 13 Weeks"] = 7] = "Last 13 Weeks";
        Period[Period["Last 26 Weeks"] = 8] = "Last 26 Weeks";
        Period[Period["Last 52 Weeks"] = 9] = "Last 52 Weeks";
        Period[Period["Last Complete 3 Months"] = 10] = "Last Complete 3 Months";
        Period[Period["Last Complete 6 Months"] = 11] = "Last Complete 6 Months";
        Period[Period["Last Complete 9 Months"] = 12] = "Last Complete 9 Months";
        Period[Period["Last Complete 12 Months"] = 13] = "Last Complete 12 Months";
        Period[Period["Last Complete 24 Months"] = 14] = "Last Complete 24 Months";
        Period[Period["Last Complete 4 Quarters"] = 45] = "Last Complete 4 Quarters";
        Period[Period["Last Month"] = 15] = "Last Month";
        Period[Period["Last Quarter"] = 16] = "Last Quarter";
        Period[Period["Last Trimester"] = 17] = "Last Trimester";
        Period[Period["Last Week"] = 18] = "Last Week";
        Period[Period["Last Year"] = 19] = "Last Year";
        Period[Period["This Year"] = 20] = "This Year";
        Period[Period["Next Year"] = 21] = "Next Year";
        Period[Period["Last Year Last Month"] = 22] = "Last Year Last Month";
        Period[Period["Last Year Next Month"] = 23] = "Last Year Next Month";
        Period[Period["Last Year This Month"] = 24] = "Last Year This Month";
        Period[Period["Month To Date"] = 25] = "Month To Date";
        Period[Period["Month To Selling Days"] = 26] = "Month To Selling Days";
        Period[Period["Next Week"] = 27] = "Next Week";
        Period[Period["Quarter To Date"] = 28] = "Quarter To Date";
        Period[Period["Rolling 12 Months"] = 29] = "Rolling 12 Months";
        Period[Period["Rolling 7 Days"] = 30] = "Rolling 7 Days";
        Period[Period["This Month"] = 31] = "This Month";
        Period[Period["This Quarter"] = 32] = "This Quarter";
        Period[Period["This Trimester"] = 33] = "This Trimester";
        Period[Period["This Week"] = 34] = "This Week";
        Period[Period["This Week To Date"] = 35] = "This Week To Date";
        Period[Period["This Year Complete Months"] = 36] = "This Year Complete Months";
        Period[Period["This Year Complete Weeks"] = 37] = "This Year Complete Weeks";
        Period[Period["Today"] = 38] = "Today";
        Period[Period["Tomorrow"] = 39] = "Tomorrow";
        Period[Period["Trimester To Date"] = 40] = "Trimester To Date";
        Period[Period["Year To Date"] = 41] = "Year To Date";
        Period[Period["Year To Selling Days"] = 42] = "Year To Selling Days";
        Period[Period["Yesterday"] = 43] = "Yesterday";
        Period[Period["Close Date"] = 44] = "Close Date";
        Period[Period["Rolling 14 Days"] = 46] = "Rolling 14 Days";
        Period[Period["Year To Day Of Year"] = 47] = "Year To Day Of Year";
        Period[Period["Next Month"] = 48] = "Next Month";
    })(Period || (Period = {}));
    let InputWebComponent = class InputWebComponent extends ECP.FormAssociatedElement {
        typeChanged(oldValue, newValue) {
            const input = this.shadowRoot.querySelector("input[type]");
            if (EC_Fmt.isNull(newValue)) {
                this.type = "text";
            }
            else if (input && (newValue.toLowerCase() === "number" || newValue.toLowerCase() === "password")) {
                input.setAttribute("type", newValue.toLowerCase());
            }
            else if (input) {
                input.setAttribute("type", "text");
            }
        }
        valueChanged(oldValue, newValue) {
            super.valueChanged(oldValue, newValue);
            const isDate = EC_Fmt.ChkDate(newValue) ? EC_Fmt.ChkDate(newValue) : EC_Fmt.isNull(newValue);
            const Operator = EC_Fmt.get_searchOp(newValue);
            switch (this.type.toLowerCase()) {
                case "datetime":
                case "date":
                    let formatValue = "";
                    if (this.myDateSelector) {
                        if (this.PickerType !== "full" || isDate || Operator) {
                            this.myDateSelector.CurDate = undefined;
                            if (EC_Fmt.isNull(newValue)) {
                                this.myDateSelector.PickerStartDate = undefined;
                            }
                            if (EC_Fmt.ChkDate(newValue) && Operator === "" && this.myDateSelector.SelectorType !== DatePickerType._Exactly) {
                                this.myDateSelector.SelectorType = DatePickerType._Exactly;
                                if (this.myDateSelector.Calendar) {
                                    this.myDateSelector.Calendar.SelectorType = DatePickerType._Exactly;
                                }
                            }
                            [formatValue] = this.myDateSelector.SetDisplayValue(newValue);
                        }
                        else {
                            [formatValue] = this.myDateSelector.SetPeriodValue(newValue);
                        }
                        if (this.value !== formatValue) {
                            this.value = formatValue;
                        }
                        if (this.value) {
                            this.selectedChanged(true);
                        }
                        else {
                            this.selectedChanged(false);
                        }
                        if (this.label && this.labelAlign === "inline") {
                            const labelInline = this.shadowRoot.querySelector(".label-inline");
                            labelInline.innerHTML = this.value || this.placeholder ? this.label + ":" : this.label;
                        }
                        if (this.StartDate || this.EndDate) {
                            const inputValue = new Date(newValue);
                            if (this.error) {
                                this.removeAttribute("error");
                            }
                            if (this.StartDate) {
                                const startDate = new Date(this.StartDate);
                                if (inputValue < startDate) {
                                    this.error = true;
                                    this.value = "";
                                    ECP.HTML.Snackbar(`Date must be greater than or equal to ${this.StartDate}`, "error");
                                    return;
                                }
                            }
                            if (this.EndDate) {
                                const endDate = new Date(this.EndDate);
                                if (inputValue > endDate) {
                                    this.error = true;
                                    this.value = "";
                                    ECP.HTML.Snackbar(`Date must be less than or equal to ${this.EndDate}`, "error");
                                    return;
                                }
                            }
                        }
                    }
                    break;
                case "address":
                    break;
                case "textarea":
                    const textarea = this.shadowRoot.querySelector("textarea");
                    if (textarea) {
                        textarea.value = newValue;
                    }
                    break;
                case "time":
                    const timeInput = this.shadowRoot.querySelector("input[type]");
                    if (timeInput) {
                        if (timeInput.getAttribute("isInternalUpdating") == "false") {
                            const formattedTime = this.convertTimeForCurrentUser(newValue);
                            timeInput.value = formattedTime;
                        }
                        else {
                            timeInput.setAttribute("isInternalUpdating", "false");
                        }
                    }
                    break;
                default:
                    const input = this.shadowRoot.querySelector("input[type]");
                    if (input) {
                        input.value = newValue;
                    }
                    else {
                        const select = this.shadowRoot.querySelector("select");
                        if (select) {
                            select.value = newValue;
                        }
                    }
                    this.value = newValue;
                    if (this.clearable) {
                        this.clearableChanged(null, this.clearable);
                    }
                    break;
            }
            if (this.getAttribute("value") !== this.value) {
                this.setAttribute("value", this.value);
            }
        }
        change() {
            let input;
            if (this.type.toLowerCase() === "date" || this.type.toLowerCase() === "datetime") {
                input = this.shadowRoot.querySelector("input[type=text]");
            }
            else {
                input = this.shadowRoot.querySelector("input[type]");
            }
            if (input) {
                EC_Fmt.TriggerEvent(input, "change");
            }
        }
        PickerTypeChanged(oldValue, newValue) {
            if (EC_Fmt.isNull(newValue)) {
                this.PickerType = "full";
            }
        }
        ForceExactRangeChanged(oldValue, newValue) {
            this.ForceExactRange = newValue === true;
            const forceFullRangeEnabled = this.ForceExactRange && this.PickerType === "range";
            if (forceFullRangeEnabled) {
                this.SelectorType = DatePickerType._Between;
                this.SubTabValue = "Custom";
            }
            if (this.myDateSelector) {
                this.myDateSelector.ForceExactRange = forceFullRangeEnabled;
                if (forceFullRangeEnabled) {
                    this.myDateSelector.SelectorType = DatePickerType._Between;
                    this.myDateSelector.SubTabValue = "Custom";
                    const datePickerValue = this.value || this.myDateSelector.HiddenInput.value;
                    const [hiddenValue] = this.myDateSelector.SetDisplayValue(datePickerValue);
                    if (this.value !== hiddenValue) {
                        this.value = hiddenValue;
                    }
                }
            }
        }
        disabledChanged(oldValue, newValue) {
            if (newValue) {
                this.classList.add("disabled");
                if (this.shadowRoot.querySelector(".ecp-input")) {
                    this.shadowRoot.querySelector(".ecp-input").classList.add("disabled-input");
                }
                if (this.shadowRoot.querySelector("input")) {
                    this.shadowRoot.querySelector("input").disabled = true;
                }
                if (this.myDateSelector && this.myDateSelector.RootHTMLElement.querySelector(`input[type="text"]`)) {
                    this.myDateSelector.RootHTMLElement.querySelector(`input[type="text"]`).setAttribute("disabled", "true");
                    this.myDateSelector.CalendarIcon.parentElement.classList.add("DisableIconClick");
                }
            }
            else {
                this.classList.remove("disabled");
                if (this.shadowRoot.querySelector(".ecp-input")) {
                    this.shadowRoot.querySelector(".ecp-input").classList.remove("disabled-input");
                }
                if (this.shadowRoot.querySelector("input")) {
                    this.shadowRoot.querySelector("input").disabled = false;
                }
                if (this.myDateSelector && this.myDateSelector.RootHTMLElement.querySelector(`input[type="text"]`)) {
                    this.myDateSelector.RootHTMLElement.querySelector(`input[type="text"]`).removeAttribute("disabled");
                    this.myDateSelector.CalendarIcon.parentElement.classList.remove("DisableIconClick");
                }
            }
        }
        errorChanged(oldValue, newValue) {
            if (this.shadowRoot.querySelector(`.ecp-input`)) {
                if (newValue) {
                    this.shadowRoot.querySelector(`.ecp-input`).classList.add("error");
                }
                else {
                    this.shadowRoot.querySelector(`.ecp-input`).classList.remove("error");
                }
            }
            else if (this.shadowRoot.querySelector(`.input-border`)) {
                if (newValue) {
                    this.shadowRoot.querySelector(`.input-border`).classList.add("error");
                }
                else {
                    this.shadowRoot.querySelector(`.input-border`).classList.remove("error");
                }
            }
        }
        lengthChanged(oldValue, newValue) {
            this.maxLength = newValue;
        }
        placeholderChanged(oldValue, newValue) {
            const inputEle = this.shadowRoot.querySelector("input:not([type=hidden])");
            const textAreaEle = this.shadowRoot.querySelector("textarea");
            if (inputEle) {
                inputEle.setAttribute("placeholder", newValue);
            }
            else if (textAreaEle) {
                textAreaEle.setAttribute("placeholder", newValue);
            }
        }
        paddingChanged(oldValue, newValue) {
            if (this.myDateSelector && this.myDateSelector.RootHTMLElement.querySelector(`input[type="text"]`)) {
                this.myDateSelector.RootHTMLElement.querySelector(`input[type="text"]`).style.padding = newValue ? newValue : null;
            }
            if (this.shadowRoot.querySelector(`input[type=text]`)) {
                this.shadowRoot.querySelector(`input[type=text]`).style.padding = newValue ? newValue : null;
            }
        }
        ValuesArrChanged(oldValue, newValue) {
            const select = this.shadowRoot.querySelector("select");
            if (select) {
                select.innerHTML = "";
                if (newValue) {
                    const valueItemArr = newValue.split(";");
                    for (let i = 0; i < valueItemArr.length; i++) {
                        const item = valueItemArr[i];
                        if (item) {
                            const optionArr = item.split(",");
                            const option = document.createElement("option");
                            option.value = optionArr[0];
                            option.innerText = optionArr[1];
                            select.appendChild(option);
                        }
                    }
                }
                EC_Fmt.TriggerEvent(select, "change");
            }
        }
        valueAddress1Changed(oldValue, newValue) {
            const input = this.shadowRoot.querySelector("#address1");
            if (input) {
                input.value = newValue;
            }
        }
        valueAddress2Changed(oldValue, newValue) {
            const input = this.shadowRoot.querySelector("#address2");
            if (input) {
                input.value = newValue;
            }
        }
        valueCityChanged(oldValue, newValue) {
            const input = this.shadowRoot.querySelector("#city");
            if (input) {
                input.value = newValue;
            }
        }
        valueStateChanged(oldValue, newValue) {
            const select = this.shadowRoot.querySelector("#state");
            if (select) {
                select.value = newValue;
            }
        }
        valuePostalChanged(oldValue, newValue) {
            const input = this.shadowRoot.querySelector("#postal");
            if (input) {
                input.value = newValue;
            }
        }
        sizeChanged(oldValue, newValue) {
            if (this.type != "textarea") {
                if (newValue && newValue.toLowerCase() === "large") {
                    this.classList.add("input-large");
                }
                else {
                    this.classList.remove("input-large");
                }
            }
        }
        helperTextChanged(oldValue, newValue) {
            const helperText = this.shadowRoot.querySelector(".helper-text");
            if (helperText) {
                if (newValue) {
                    helperText.innerHTML = newValue;
                }
                else {
                    helperText.innerHTML = "";
                }
            }
        }
        widthChanged(oldValue, newValue) {
            if (this.type.toLowerCase() !== "address") {
                const width = parseFloat(newValue) || 0;
                if (width > 0) {
                    this.myInput.style.width = `${width}px`;
                }
                else {
                    this.myInput.style.width = "100%";
                }
            }
        }
        textAlignChanged(oldValue, newValue) {
            if (this.type.toLowerCase() === "text" || this.type.toLowerCase() === "number" || this.type.toLowerCase() === "currency") {
                if (newValue !== "") {
                    this.myInput.setAttribute("textAlign", newValue);
                }
                else {
                    this.myInput.removeAttribute("textAlign");
                }
            }
        }
        constructor() {
            super();
            this.required = false;
            this.disabled = false;
            this.error = false;
            this.combined = false;
            this.clearable = false;
            this.ForceExactRange = false;
            this.isCreated = false;
            this.myInput = EC_Fmt.HtmlStrToElement(`<div class="ecp-input basic-input"><input type=text><input type="hidden" class="hidden"><div class="clear right-icon hidden"></div><div class="tool-tip right-icon hidden"></div><div class="shortcut hidden"><slot name="shortcut"></slot></div>`);
            this.myDropdownInput = EC_Fmt.HtmlStrToElement(`<div class="ecp-select full-width"><span class="select-icon ews-icon-caretdown"></span><select class="ecp-select full-width"></select></div>`);
            this.myAddressInput = EC_Fmt.HtmlStrToElement(`<div class="ecp-input ecp-input-combined"></div>`);
            this.myTimeInput = EC_Fmt.HtmlStrToElement(`<div class=ecp-input><input type=text autocomplete=off value="${EC_Fmt.userTimeFormat == 2 ? '--:--' : '--:-- --'}" maxlength=8></div>`);
            this.AMEXCardTypeRegex = `^3(4|7)`;
            this.DiscoverCardTypeRegex = `^(6|6011|644|65)`;
            this.proxy = document.createElement("input");
            this.type = "text";
            this.selectionStart = 0;
        }
        select() {
            const input = this.myInput.querySelector("input:not([type='hidden'])");
            if (input) {
                input.select();
            }
        }
        focus() {
            const input = this.myInput.querySelector("input:not([type='hidden'])");
            if (input) {
                input.focus();
            }
            else {
                const select = this.myInput.querySelector("select");
                if (select) {
                    select.focus();
                }
            }
        }
        created(host) {
            super.created(host);
            if (this.combined) {
                this.type = "address";
            }
            if ((this.type === "date" || this.type === "datetime") && !this.PickerType) {
                this.PickerType = "full";
            }
            if (this.PickerType === "range") {
                this.SelectorType = DatePickerType._Between;
                if (this.ForceExactRange) {
                    this.SubTabValue = "Custom";
                }
            }
            switch (this.type.toLowerCase()) {
                case "datetime":
                    this.IncludeTime = true;
                    this.initDatePickerInput();
                    break;
                case "date":
                    this.IncludeTime = false;
                    this.initDatePickerInput();
                    break;
                case "address":
                    this.initCombinedInput();
                    break;
                default:
                    this.initInput();
                    break;
            }
            if (this.padding) {
                this.paddingChanged(null, this.padding);
            }
            this.isCreated = true;
        }
        initInput() {
            const me = this;
            const type = me.type.toLowerCase();
            let myInput;
            let Currency = "";
            switch (type) {
                case "text":
                    if (me.ValuesArr) {
                        myInput = me.writeDropdownInput();
                    }
                    else {
                        if (EC_Fmt.isNull(me.dataType)) {
                            me.dataType = "Text";
                        }
                        myInput = me.writeTextInput();
                    }
                    break;
                case "email":
                    me.dataType = "Email";
                    me.icon = "ews-icon-email";
                    myInput = me.writeEmailInput();
                    myInput.classList.add("has-right-icon");
                    break;
                case "phone":
                    me.dataType = "Phone";
                    me.icon = "ews-icon-phone";
                    myInput = me.writePhoneInput();
                    break;
                case "card":
                    me.dataType = "Card";
                    me.icon = "ews-icon-credit";
                    myInput = me.writeCardInput();
                    myInput.classList.add("has-right-icon");
                    myInput.firstElementChild.setAttribute("maxlength", "23");
                    break;
                case "currency":
                    me.dataType = "Currency";
                    Currency = "$";
                    me.icon = "icon-currency";
                    myInput = me.writeCurrencyInput();
                    break;
                case "time":
                    me.dataType = "Time";
                    myInput = me.writeTimeInput();
                    me.blockInputDragDrop(myInput.querySelector("input"));
                    break;
                case "textarea":
                    me.dataType = "Textarea";
                    myInput = me.writeTextareaInput();
                    break;
                case "number":
                    me.dataType = "Number";
                    myInput = me.writeNumberInput();
                    break;
                case "password":
                    me.dataType = "Password";
                    myInput = me.writeTextInput();
                    myInput.querySelector("input[type=text]").setAttribute("autocomplete", "new-password");
                    myInput.querySelector("input[type=text]").setAttribute("type", "password");
                    break;
                default:
                    myInput = me.writeTextInput();
                    break;
            }
            if (me.id) {
                myInput.firstElementChild.id = me.id;
            }
            if (me.width) {
                myInput.style.width = me.width;
            }
            if (me.name) {
                myInput.firstElementChild.setAttribute("name", me.name);
            }
            if (me.icon) {
                const newIcon = document.createElement("i");
                newIcon.classList.add(me.icon);
                if (me.ValuesArr) {
                    newIcon.classList.add("select-left-icon");
                }
                else {
                    newIcon.classList.add("input-icon");
                    newIcon.innerHTML = Currency;
                }
                myInput.appendChild(newIcon);
                myInput.classList.add("has-left-icon");
            }
            if (me.required) {
                myInput.setAttribute("required", "true");
                if (me.dataType != "Time") {
                    myInput.classList.add("has-right-icon");
                }
            }
            if (me.error) {
                myInput.classList.add("error");
            }
            const input = myInput.querySelector("input");
            const select = myInput.querySelector("select");
            if (me.placeholder && input) {
                input.setAttribute("placeholder", me.placeholder);
            }
            if (me.value && input) {
                if (type == "time") {
                    input.value = EC_Fmt.InputFmt(me.value, ECP.DataType._Time, NaN, false, false);
                }
                else if (!me.getAttribute("ValuesArr")) {
                    input.value = me.value;
                }
                if (me.clearable && type !== "textarea" && type !== "date" && type !== "datetime" && type !== "card" && type !== "time" && !me.ValuesArr) {
                    myInput.querySelector(".clear").classList.remove("hidden");
                }
            }
            if (me.clearable && type !== "textarea" && type !== "date" && type !== "datetime" && !me.ValuesArr) {
                myInput.classList.add("has-right-icon");
            }
            if (me.label) {
                const labelEl = me.createLabel();
                labelEl.appendChild(myInput);
                me.shadowRoot.appendChild(labelEl);
                if (input) {
                    input.setAttribute("encDisplayName", me.label.replace(/^\s*\*/g, "").trim());
                }
                if (select) {
                    select.setAttribute("encDisplayName", me.label.replace(/^\s*\*/g, "").trim());
                }
            }
            else {
                me.shadowRoot.appendChild(myInput);
            }
            if (me.disabled) {
                this.disabledChanged(!me.disabled, me.disabled);
            }
            if (input && type !== "address" && type !== "time") {
                if (me.maxLength > 0) {
                    input.setAttribute("maxlength", me.maxLength.toString());
                }
                input.addEventListener("input", () => {
                    this.value = input.value;
                });
            }
            if (me.helperText) {
                const span = document.createElement("span");
                span.classList.add("helper-text");
                span.innerHTML = me.helperText;
                myInput.appendChild(span);
            }
            if (input && (type.toLowerCase() === "text" || type.toLowerCase() === "number" || type.toLowerCase() === "currency") && me.textAlign) {
                myInput.setAttribute("textAlign", me.textAlign);
            }
            if (me.querySelector("ecp-shortcut-group") || me.querySelector("ecp-shortcut")) {
                myInput.querySelector(".shortcut")?.classList.remove("hidden");
            }
        }
        createLabel() {
            const me = this;
            let labelEl = document.createElement("div");
            if (me.labelAlign && me.labelAlign === "top") {
                labelEl.classList.add("column-label");
                labelEl.innerHTML = `<label class="input-label-top">${me.label}</label>`;
            }
            else {
                labelEl.classList.add("ecp-input-label");
                labelEl.innerHTML = `<label class="input-label">${me.label}</label>`;
            }
            return labelEl;
        }
        initCombinedInput() {
            const me = this;
            let myInput;
            myInput = me.writeAddressInput();
            if (me.hasAttribute("label")) {
                let labelEl = document.createElement("div");
                if (me.hasAttribute("label-align") && me.labelAlign === "top") {
                    labelEl.classList.add("column-label");
                    labelEl.innerHTML = `<label class="input-label-top">${me.label}</label>`;
                }
                else {
                    labelEl.classList.add("left-label-input");
                    labelEl.innerHTML = `<label class="input-label">${me.label}</label>`;
                }
                labelEl.appendChild(myInput);
                me.shadowRoot.appendChild(labelEl);
            }
            else {
                me.shadowRoot.appendChild(myInput);
            }
        }
        ;
        initDatePickerInput() {
            const me = this;
            const DatePickerElement = me;
            if (DatePickerElement && DatePickerElement.parentElement) {
                const newDateSelector = new DateSelector(this.name, this.id, this.SubTabValue, this.required, this.value, this.IncludeTime, this.PickerType, this.FieldTitle, this.TabIndex, EC_Fmt.CDec(this.width), this.placeholder, this.StartDate, this.EndDate, this.SelectorType, this.ExcludeDates, this.ForceExactRange, (newValue) => {
                    const isDate = EC_Fmt.ChkDate(newValue) ? EC_Fmt.ChkDate(newValue) : EC_Fmt.isNull(newValue);
                    const Operator = EC_Fmt.get_searchOp(newValue);
                    if (this.myDateSelector && (this.type.toLowerCase() === "datetime" || this.type.toLowerCase() === "date")) {
                        if (this.PickerType !== "full" || isDate || Operator) {
                            this.myDateSelector.CurDate = undefined;
                            this.myDateSelector.SetDisplayValue(newValue);
                        }
                        else {
                            this.myDateSelector.SetPeriodValue(newValue);
                        }
                    }
                    this.value = newValue;
                });
                newDateSelector.NotifyChangeCallback = () => {
                    this.$emit("change");
                };
                this.myInput = newDateSelector.RootHTMLElement;
                DatePickerElement.shadowRoot.appendChild(newDateSelector.RootHTMLElement);
                this.myDateSelector = newDateSelector;
                if (this.error && this.myInput.querySelector(".input-border")) {
                    this.myInput.querySelector(".input-border").classList.add("error");
                }
                if (this.helperText) {
                    const span = document.createElement("span");
                    span.classList.add("helper-text");
                    span.innerHTML = this.helperText;
                    this.myInput.appendChild(span);
                }
                if (this.label && this.labelAlign !== "top") {
                    this.labelAlignChanged("", this.labelAlign);
                }
                if (this.label && this.labelAlign === "inline") {
                    const section = this.myInput.querySelector(".input-border");
                    const clearBtn = this.shadowRoot.querySelector(".ews-icon-close");
                    clearBtn.addEventListener("click", (event) => {
                        if (this.label && this.labelAlign == "inline") {
                            event.stopPropagation();
                            this.$emit("clear");
                            this.value = "";
                        }
                    }, false);
                    const btn = this.shadowRoot.querySelector(".ews-icon-calendar");
                    this.addEventListener("mouseenter", (event) => {
                        if (this.label && this.labelAlign == "inline") {
                            event.stopPropagation();
                            btn.classList.remove("hidden");
                            clearBtn.classList.add("hidden");
                            section.classList.add("hover");
                        }
                    }, false);
                    this.addEventListener("mouseout", (event) => {
                        if (this.label && this.labelAlign == "inline") {
                            event.stopPropagation();
                            if (this.value) {
                                btn.classList.add("hidden");
                                clearBtn.classList.remove("hidden");
                            }
                            else {
                                btn.classList.remove("hidden");
                                clearBtn.classList.add("hidden");
                            }
                            section.classList.remove("hover");
                        }
                    }, false);
                    btn.addEventListener("mouseenter", (event) => {
                        if (this.label && this.labelAlign == "inline") {
                            event.stopPropagation();
                            event.stopPropagation();
                            if (this.value) {
                                btn.classList.add("hidden");
                                clearBtn.classList.remove("hidden");
                                section.classList.remove("hover");
                            }
                            else {
                                btn.classList.remove("hidden");
                                clearBtn.classList.add("hidden");
                            }
                        }
                    }, false);
                }
            }
        }
        writeDropdownInput() {
            const me = this;
            const valuesArray = me.ValuesArr.split(";");
            for (let i = 0; i < valuesArray.length; i++) {
                const item = valuesArray[i];
                if (item) {
                    const optionArr = item.split(",");
                    const option = document.createElement("option");
                    option.value = optionArr[0];
                    option.innerText = optionArr[1] ? optionArr[1] : optionArr[0];
                    if (me.hasAttribute("value") && (me.getAttribute("value") == option.value)) {
                        option.selected = true;
                    }
                    me.myDropdownInput.querySelector("select").appendChild(option);
                    if (me.getAttribute("value") == null) {
                        me.value = option.value;
                    }
                }
            }
            me.myDropdownInput.querySelector("select").addEventListener("change", () => {
                const selectElement = this.myDropdownInput.querySelector("select");
                if (selectElement) {
                    me.value = selectElement.value;
                }
                this.$emit("change");
            });
            return me.myDropdownInput;
        }
        writeTextInput() {
            const me = this;
            const hiddenInput = me.myInput.querySelector("input[type='hidden']");
            me.myInput.firstElementChild.addEventListener("change", () => {
                this.setErrByRequired(me);
                EC_Fmt.InputFmt(me.myInput.firstElementChild, EC_Fmt.DataTypeParse(me.dataType), me.maxLength, me.required, false);
                hiddenInput.value = me.myInput.firstElementChild.value;
                hiddenInput.setAttribute("value", hiddenInput.value);
                me.value = hiddenInput.value;
                me.$emit("change");
            });
            return me.myInput;
        }
        writeEmailInput() {
            const me = this;
            me.myInput.firstElementChild.addEventListener("change", () => {
                this.setErrByRequired(me);
                EC_Fmt.InputFmt(me.myInput.firstElementChild, EC_Fmt.DataTypeParse(me.dataType), me.maxLength, me.required, false);
                const inputValue = me.myInput.querySelector("input").value;
                me.value = inputValue;
                if ((!me.required && EC_Fmt.isNull(inputValue)) || EC_Fmt.isEmail(inputValue)) {
                    me.myInput.classList.remove("error");
                }
                else {
                    me.myInput.classList.add("error");
                }
                this.$emit("change");
            });
            return me.myInput;
        }
        writePhoneInput() {
            const me = this;
            const input = me.myInput.firstElementChild;
            input.addEventListener("change", () => {
                this.setErrByRequired(me);
                me.value = me.myInput.querySelector("input").value;
                EC_Fmt.InputFmt(input, EC_Fmt.DataTypeParse(me.dataType), me.maxLength, me.required, false);
                this.$emit("change");
            });
            if (!EC_Fmt.isMobile) {
                input.addEventListener("keydown", (e) => me.OnNumericKeyDown(e, ''));
                input.addEventListener("keyup", (e) => me.OnNumericKeyUp(e, /\D/g));
                input.addEventListener("paste", (e) => me.OnNumericPaste(e, /\D/g));
            }
            else {
                input.addEventListener("input", (e) => me.OnNumericKeyUp(e, /\D/g));
            }
            return me.myInput;
        }
        writeNumberInput() {
            const me = this;
            me.myInput.firstElementChild.setAttribute("type", "number");
            me.myInput.firstElementChild.addEventListener("change", () => {
                this.setErrByRequired(me);
                me.value = me.myInput.querySelector("input").value;
                EC_Fmt.InputFmt(me.myInput.firstElementChild, EC_Fmt.DataTypeParse(me.dataType), me.maxLength, me.required, false);
                this.$emit("change");
            });
            return me.myInput;
        }
        writeCardInput() {
            const me = this;
            const input = me.myInput.firstElementChild;
            input.addEventListener("change", () => {
                const inputValue = me.myInput.querySelector("input").value;
                me.value = inputValue;
                EC_Fmt.InputFmt(input, EC_Fmt.DataTypeParse(me.dataType), me.maxLength, me.required, false);
                this.setErrByRequired(me);
                const cardType = me.GetCardType(inputValue);
                if (me.myInput.querySelector(".card-type-icon")) {
                    me.myInput.removeChild(me.myInput.querySelector(".card-type-icon"));
                }
                if (!me.error) {
                    const iconElement = document.createElement("i");
                    iconElement.classList.add("right-icon", "card-type-icon");
                    switch (cardType) {
                        case "Visa":
                            iconElement.classList.add("ews-icon-visa");
                            break;
                        case "Mastercard":
                            iconElement.classList.add("ews-icon-mastercard");
                            break;
                        case "Discover":
                            iconElement.classList.add("ews-icon-discovercard");
                            break;
                        case "AMEX":
                            iconElement.classList.add("ews-icon-amexcard");
                            break;
                        default:
                            iconElement.classList.add("ews-icon-defaultcard");
                            break;
                    }
                    me.myInput.appendChild(iconElement);
                }
                this.$emit("change");
            });
            if (!EC_Fmt.isMobile) {
                input.addEventListener("keydown", me.OnKeyDown);
                input.addEventListener("keyup", me.OnKeyUp);
                input.addEventListener("paste", me.OnPaste);
            }
            else {
                input.addEventListener("input", me.OnInput);
            }
            return me.myInput;
        }
        writeCurrencyInput() {
            const me = this;
            const input = me.myInput.firstElementChild;
            input.addEventListener("change", () => {
                const formattedValue = EC_Fmt.InputFmt(input.value, EC_Fmt.DataTypeParse(me.dataType), me.maxLength, me.required, false, "");
                me.value = EC_Fmt.CDec(formattedValue).toString();
                this.setErrByRequired(me);
                input.value = formattedValue;
                this.$emit("change");
            });
            if (!EC_Fmt.isMobile) {
                input.addEventListener("keydown", (e) => me.OnNumericKeyDown(e, '.,\-'));
                input.addEventListener("keyup", (e) => me.OnNumericKeyUp(e, /[^0-9.,\-]/g));
                input.addEventListener("paste", (e) => me.OnNumericPaste(e, /[^0-9.,\-]/g));
            }
            else {
                input.addEventListener("input", (e) => me.OnNumericKeyUp(e, /[^0-9.,\-]/g));
            }
            return me.myInput;
        }
        writeAddressInput() {
            const me = this;
            me.myAddressInput.innerHTML += "<div class=column>"
                + " <input type=text id=address1 class=top-input maxlength=32>"
                + " <input type=text id=address2 class=middle-input maxlength=32>"
                + " <input type=text id=city class=middle-input maxlength=36>"
                + "</div>"
                + "<div class=row>"
                + " <div class=ecp-select style=width:40%><span class=\"select-icon ews-icon-caretdown\"></span><select class=\"lower-left-input full-width\"id=state></select></div>"
                + " <input type=text id=postal class=lower-right-input maxlength=12>"
                + "</div>";
            const select = me.myAddressInput.querySelector("select");
            if (me.ValuesArr) {
                const valueItemArr = me.ValuesArr.split(";");
                for (let i = 0; i < valueItemArr.length; i++) {
                    const item = valueItemArr[i];
                    if (item) {
                        const optionArr = item.split(",");
                        const option = document.createElement("option");
                        option.value = optionArr[0];
                        option.innerText = optionArr[1] ? optionArr[1] : optionArr[0];
                        select.appendChild(option);
                    }
                }
            }
            const addressInputSelectArr = me.myAddressInput.querySelectorAll("input, select");
            for (let i = 0; i < addressInputSelectArr.length; i++) {
                const item = addressInputSelectArr[i];
                if (me.hasAttribute("placeholder-" + item.id)) {
                    item.setAttribute("placeholder", me.getAttribute("placeholder-" + item.id));
                }
                if (me.hasAttribute("value-" + item.id)) {
                    item.value = me.getAttribute("value-" + item.id);
                }
                item.addEventListener("change", () => {
                    EC_Fmt.InputFmt(item, ECP.DataType._Text, NaN, false, false);
                    me.setAttribute("value-" + item.id, item.value);
                    this.$emit("change");
                });
                item.addEventListener("focus", () => {
                    switch (item.id) {
                        case "address1":
                        case "address2":
                            item.style.borderColor = "var(--border-active)";
                            item.nextElementSibling.classList.add("border-top");
                            break;
                        case "city":
                            item.style.borderColor = "var(--border-active)";
                            select.classList.add("border-top");
                            select.parentElement.nextElementSibling.classList.add("border-top");
                            break;
                        case "postal":
                            item.style.borderColor = "var(--border-active)";
                            break;
                        case "state":
                            item.style.borderColor = "var(--border-active)";
                            item.parentElement.nextElementSibling.classList.add("border-left");
                            break;
                    }
                });
                item.addEventListener("blur", () => {
                    switch (item.id) {
                        case "address1":
                        case "address2":
                            item.style.borderColor = "var(--border)";
                            item.nextElementSibling.classList.remove("border-top");
                            break;
                        case "city":
                            item.style.borderColor = "var(--border)";
                            select.classList.remove("border-top");
                            select.parentElement.nextElementSibling.classList.remove("border-top");
                            break;
                        case "postal":
                            item.style.borderColor = "var(--border)";
                            break;
                        case "state":
                            item.style.borderColor = "var(--border)";
                            item.parentElement.nextElementSibling.classList.remove("border-left");
                            break;
                    }
                });
                item.addEventListener("keydown", (event) => {
                    event.stopPropagation();
                    me.$emit(`keydown-${item.id}`, {
                        event
                    });
                });
                if (item.id === "state") {
                    EC_Fmt.TriggerEvent(item, "change");
                }
            }
            if (this.helperText) {
                const span = document.createElement("span");
                span.classList.add("helper-text");
                span.innerHTML = this.helperText;
                me.myAddressInput.appendChild(span);
            }
            return me.myAddressInput;
        }
        writeTimeInput() {
            const me = this;
            const timeInput = me.myTimeInput.firstElementChild;
            const is24Hour = EC_Fmt.userTimeFormat === 2;
            if (is24Hour) {
                timeInput.setAttribute("maxlength", "5");
            }
            timeInput.setAttribute("isInternalUpdating", "false");
            timeInput.setAttribute("focusValue", me.normalizeTimeValue(timeInput.value));
            timeInput.addEventListener("focus", () => {
                timeInput.setAttribute("focusValue", me.normalizeTimeValue(timeInput.value));
            });
            timeInput.addEventListener("blur", () => {
                me.finalizeTimeInputValue(timeInput);
            });
            timeInput.addEventListener("mouseup", me.timeInputMouseUp);
            timeInput.addEventListener("keydown", (e) => { me.timeKeyDown(e, me); });
            return me.myTimeInput;
        }
        timeInputMouseUp(e) {
            const inputEl = this;
            const index = inputEl.value.indexOf("-");
            const tag = inputEl.value.indexOf(":");
            const is24Hour = EC_Fmt.userTimeFormat === 2;
            inputEl.clicked = true;
            if (is24Hour) {
                if (inputEl.selectionEnd <= 2) {
                    inputEl.setSelectionRange(0, 2);
                }
                else {
                    inputEl.setSelectionRange(3, 5);
                }
            }
            else {
                if (index == 0 && inputEl.selectionEnd > 7) {
                    inputEl.setSelectionRange(0, 2);
                }
                else if (tag == 1) {
                    if (inputEl.selectionEnd < 2) {
                        inputEl.setSelectionRange(0, 1);
                    }
                    else if (inputEl.selectionEnd < 5) {
                        inputEl.setSelectionRange(2, 4);
                    }
                    else {
                        inputEl.setSelectionRange(5, 7);
                    }
                }
                else if (inputEl.selectionEnd < 3) {
                    inputEl.setSelectionRange(0, 2);
                }
                else if (inputEl.selectionEnd < 6) {
                    inputEl.setSelectionRange(3, 5);
                }
                else {
                    inputEl.setSelectionRange(6, 8);
                }
            }
            e.preventDefault();
            e.stopPropagation();
        }
        timeKeyDown(e, timeInput) {
            const inputEl = e.target;
            const val = inputEl.value;
            const index = val.indexOf(":");
            const keyNumber = parseInt(e.key, 10);
            const is24Hour = EC_Fmt.userTimeFormat === 2;
            if (isNaN(parseInt(e.key, 10))) {
                const tag = val.split(" ");
                if ((e.ctrlKey || e.metaKey) && (e.key === "a" || e.key === "A")) {
                    inputEl.select();
                }
                else if (((e.shiftKey && (e.key === "A" || e.key === "P")) || (e.key === "a" || e.key === "p")) && inputEl.selectionEnd > 6) {
                    inputEl.value = `${tag[0]} ${e.key.toUpperCase()}M`;
                }
                else if (e.key === "Backspace" || e.key === "Delete") {
                    if (inputEl.selectionStart == 0 && (is24Hour ? inputEl.selectionEnd == 5 : inputEl.selectionEnd == 8)) {
                        inputEl.value = is24Hour ? "--:--" : "--:-- --";
                        inputEl.setSelectionRange(0, 2);
                    }
                    else if (inputEl.selectionEnd < 3) {
                        inputEl.value = `--${val.substring(index)}`;
                        inputEl.setSelectionRange(0, 2);
                    }
                    else if (inputEl.selectionEnd < 6) {
                        if (val.charAt(index + 1) == "-") {
                            inputEl.value = `--${val.substring(index)}`;
                            inputEl.setSelectionRange(0, 2);
                        }
                        else {
                            inputEl.value = is24Hour ? `${val.substring(0, index)}:--` : `${val.substring(0, index)}:-- ${val.slice(-2)}`;
                            inputEl.setSelectionRange(index + 1, index + 3);
                        }
                    }
                    else if (val.charAt(tag[0].length + 1) == "-") {
                        inputEl.value = is24Hour ? `${val.substring(0, index)}:--` : `${val.substring(0, index)}:-- ${val.slice(-2)}`;
                        inputEl.setSelectionRange(index + 1, index + 3);
                    }
                    else if (!is24Hour) {
                        inputEl.value = `${tag[0]} --`;
                        inputEl.setSelectionRange(tag[0].length + 1, tag[0].length + 3);
                    }
                    inputEl.clicked = true;
                }
            }
            else if (inputEl.selectionEnd < 3) {
                if (inputEl.clicked) {
                    inputEl.value = `0${e.key}${val.substring(index)}`;
                    if (keyNumber < 2) {
                        inputEl.setSelectionRange(0, 2);
                        inputEl.clicked = false;
                    }
                    else {
                        if (is24Hour && keyNumber == 2) {
                            inputEl.setSelectionRange(0, 2);
                            inputEl.clicked = false;
                        }
                        else {
                            inputEl.setSelectionRange(3, 5);
                            inputEl.clicked = true;
                        }
                    }
                }
                else {
                    const hour = val.charAt(1);
                    if (is24Hour && hour == 2) {
                        inputEl.value = `${val.charAt(0)}${e.key}${val.substring(index)}`;
                    }
                    if (hour == 0 || hour > 1) {
                        if (is24Hour && hour == 2) {
                            if (keyNumber < 3) {
                                inputEl.value = `2${e.key}${val.substring(index)}`;
                            }
                            else {
                                inputEl.value = `23${val.substring(index)}`;
                            }
                        }
                        else {
                            inputEl.value = `0${e.key}${val.substring(index)}`;
                        }
                    }
                    else if (hour == 1) {
                        if (keyNumber > 2) {
                            inputEl.value = `12${val.substring(index)}`;
                        }
                        else {
                            inputEl.value = `${hour}${e.key}${val.substring(index)}`;
                        }
                    }
                    inputEl.setSelectionRange(3, 5);
                    inputEl.clicked = true;
                }
            }
            else if (inputEl.selectionEnd > 2 && inputEl.selectionEnd < 6) {
                const miu = val.split(":");
                if (inputEl.clicked) {
                    inputEl.value = is24Hour ? `${miu[0]}:0${e.key}` : `${miu[0]}:0${e.key} ${val.slice(-2)}`;
                    inputEl.setSelectionRange(3, 5);
                    inputEl.clicked = false;
                }
                else {
                    let min = miu[1].charAt(1);
                    if (min > 5) {
                        inputEl.value = is24Hour ? `${miu[0]}:59` : `${miu[0]}:59 ${val.slice(-2)}`;
                    }
                    else {
                        inputEl.value = is24Hour ? `${miu[0]}:${min}${e.key}` : `${miu[0]}:${min}${e.key} ${val.slice(-2)}`;
                    }
                    if (!is24Hour) {
                        inputEl.setSelectionRange(6, 8);
                    }
                }
            }
            inputEl.setAttribute("isInternalUpdating", "true");
            inputEl.setAttribute("value", inputEl.value);
            timeInput.value = inputEl.value;
            e.preventDefault();
            e.stopPropagation();
        }
        convertTimeForCurrentUser(value) {
            if (EC_Fmt.isNull(value)) {
                return "";
            }
            const parsed = this.parseTimeParts(value);
            if (!parsed.valid) {
                return value;
            }
            if (EC_Fmt.userTimeFormat === 2) {
                return `${EC_Fmt.Right("0" + parsed.hour24, 2)}:${EC_Fmt.Right("0" + parsed.minute, 2)}`;
            }
            const displayHour = parsed.hour24 === 0 ? 12 : (parsed.hour24 > 12 ? parsed.hour24 - 12 : parsed.hour24);
            const period = parsed.hour24 >= 12 ? "PM" : "AM";
            return `${EC_Fmt.Right("0" + displayHour, 2)}:${EC_Fmt.Right("0" + parsed.minute, 2)} ${period}`;
        }
        normalizeTimeValue(value) {
            const trimmed = EC_Fmt.Null2EmptyStr(value).trim();
            if (trimmed === "") {
                return "";
            }
            if (trimmed === "--:--" || trimmed === "--:-- --") {
                return trimmed;
            }
            const parsed = this.parseTimeParts(trimmed);
            if (!parsed.valid) {
                return trimmed;
            }
            return this.convertTimeForCurrentUser(trimmed);
        }
        finalizeTimeInputValue(timeInput) {
            const focusValue = timeInput.getAttribute("focusValue") || this.normalizeTimeValue(this.value);
            const normalizedValue = this.normalizeTimeValue(timeInput.value);
            timeInput.value = normalizedValue;
            timeInput.setAttribute("value", normalizedValue);
            timeInput.setAttribute("focusValue", normalizedValue);
            timeInput.setAttribute("isInternalUpdating", "true");
            this.value = normalizedValue;
            this.setErrByRequired(this);
            if (focusValue !== normalizedValue) {
                this.$emit("change");
            }
        }
        parseTimeParts(value) {
            let trimmed = value.trim();
            if (trimmed === "") {
                return { valid: false, hour24: 0, minute: 0 };
            }
            const periodMatch = trimmed.match(/\b(AM|PM)\b/i);
            const hasPeriod = periodMatch != null;
            const isPM = hasPeriod && periodMatch[1].toUpperCase() === "PM";
            trimmed = trimmed.replace(/am|pm/ig, "").trim();
            let hour = NaN;
            let minute = NaN;
            if (trimmed.includes(":")) {
                const colonParts = trimmed.split(":");
                const hourPart = colonParts[0];
                const minutePart = (colonParts[1] || "").split(/\s+/)[0] || "0";
                hour = parseInt(hourPart, 10);
                minute = parseInt(minutePart, 10);
            }
            else if (/^\d{3,4}$/.test(trimmed)) {
                if (trimmed.length === 3) {
                    hour = parseInt(trimmed.substring(0, 1), 10);
                    minute = parseInt(trimmed.substring(1), 10);
                }
                else {
                    hour = parseInt(trimmed.substring(0, trimmed.length - 2), 10);
                    minute = parseInt(trimmed.substring(trimmed.length - 2), 10);
                }
            }
            else if (/^\d{1,2}$/.test(trimmed)) {
                hour = parseInt(trimmed, 10);
                minute = 0;
            }
            else {
                return { valid: false, hour24: 0, minute: 0 };
            }
            if (isNaN(hour) || isNaN(minute)) {
                return { valid: false, hour24: 0, minute: 0 };
            }
            if (minute < 0 || minute > 59) {
                return { valid: false, hour24: 0, minute: 0 };
            }
            let hour24 = hour;
            if (hasPeriod) {
                if (hour === 12) {
                    hour24 = isPM ? 12 : 0;
                }
                else if (isPM) {
                    hour24 = hour + 12;
                }
            }
            if (!hasPeriod && (hour < 0 || hour > 23)) {
                return { valid: false, hour24: 0, minute: 0 };
            }
            hour24 = Math.max(0, Math.min(23, hour24));
            return { valid: true, hour24, minute };
        }
        writeTextareaInput() {
            const me = this;
            const textareaContainer = document.createElement("div");
            textareaContainer.classList.add("ecp-input", "basic-input", "ecp-textarea");
            textareaContainer.innerHTML = "<input type=hidden class=hidden><textarea class=textarea_inner></textarea><div class=\"tool-tip right-icon hidden\"></div>";
            const textarea = textareaContainer.querySelector("textarea");
            const input = textareaContainer.querySelector("input");
            if (me.rows) {
                textarea.setAttribute("rows", me.rows);
            }
            if (me.hasAttribute("placeholder")) {
                textarea.setAttribute("placeholder", me.placeholder);
            }
            if (me.hasAttribute("value")) {
                textarea.value = me.value;
            }
            if (me.maxLength > 0) {
                textarea.setAttribute("maxlength", me.maxLength.toString());
            }
            textarea.addEventListener("change", () => {
                input.value = textarea.value;
                const toolTip = textareaContainer.querySelector(".tool-tip");
                if (me.required && !textarea.value) {
                    me.error = true;
                    ECP.HTML.ToolTip(toolTip, `<i class=ews-icon-info style=color:var(--text-error)></i>`, "Required", "right", 150);
                }
                else {
                    me.error = false;
                    if (toolTip) {
                        toolTip.innerHTML = "";
                        toolTip.classList.add("hidden");
                    }
                }
                EC_Fmt.InputFmt(input, EC_Fmt.DataTypeParse(me.dataType), me.maxLength, me.required, false);
                me.value = input.value;
                this.$emit("change");
            });
            return textareaContainer;
        }
        blockInputDragDrop(input) {
            if (!input) {
                return;
            }
            input.addEventListener("drop", this.preventInputDrop);
            input.addEventListener("dragover", this.preventInputDrop);
        }
        preventInputDrop(event) {
            event.preventDefault();
            event.stopPropagation();
        }
        OnKeyUp(Event) {
            const me = this;
            const position = me.selectionStart;
            if (!isNaN(parseInt(Event.key, 10))) {
                const sp = (me.value.slice(0, position).match(/\s/g) || []).length;
                me.value = me.value.replace(/\s/g, '').replace(/(\w{4})(?=\w)/g, '$1 ');
                if (me.value.length > 23) {
                    me.value = me.value.substring(0, 23);
                }
                const curSp = (me.value.slice(0, position).match(/\s/g) || []).length;
                me.selectionStart = position + curSp - sp;
            }
        }
        OnKeyDown(Event) {
            const me = this;
            const position = me.selectionStart;
            if (Event.key === "Backspace") {
                if (me.value.slice(-1) === ' ') {
                    me.value = me.value.slice(0, -1);
                }
                else if (me.value.charAt(position - 1) === ' ') {
                    me.value = me.value.substring(0, position - 2) + me.value.substring(position);
                    me.selectionStart = position - 1;
                }
            }
            else if (isNaN(parseInt(Event.key))) {
                if (((EC_Fmt.isMac || EC_Fmt.isIOS) ? !Event.metaKey : !Event.ctrlKey) && (Event.key !== "Backspace" && Event.key !== "Tab" && Event.key !== "ArrowLeft" && Event.key !== "ArrowUp" && Event.key !== "ArrowRight" && Event.key !== "ArrowDown")) {
                    Event.preventDefault();
                    Event.stopPropagation();
                }
            }
        }
        OnPaste(e) {
            const me = this;
            const pastedText = e.clipboardData.getData('Text');
            let str = pastedText.replace(/\D/g, '');
            if (str.length > 19) {
                str = str.substring(0, 19);
            }
            me.value = str.replace(/(\w{4})(?=\w)/g, '$1 ');
            EC_Fmt.TriggerEvent(me, "change");
            e.preventDefault();
            e.stopPropagation();
        }
        OnNumericKeyDown(Event, allowedChars = '') {
            const key = Event.key;
            const isNumeric = !isNaN(parseInt(key, 10));
            const isAllowed = allowedChars.includes(key);
            const isControlKey = (key === "Backspace" || key === "Delete" || key === "Tab" || key === "ArrowLeft" || key === "ArrowUp" || key === "ArrowRight" || key === "ArrowDown");
            const isCopy = (Event.ctrlKey || Event.metaKey) && (key === 'c' || key === 'C' || key === 'x' || key === 'X' || key === 'a' || key === 'A');
            if (!isNumeric && !isAllowed && !isControlKey && !isCopy) {
                Event.preventDefault();
                Event.stopPropagation();
            }
        }
        OnNumericKeyUp(Event, filterPattern) {
            const target = Event.target;
            target.value = target.value.replace(filterPattern, '');
        }
        OnNumericPaste(e, filterPattern) {
            const pastedText = e.clipboardData.getData('Text');
            const str = pastedText.replace(filterPattern, '');
            this.value = str;
            EC_Fmt.TriggerEvent(this, "change");
            e.preventDefault();
            e.stopPropagation();
        }
        OnInput(e) {
            const me = this;
            const text = e.target.value;
            let position = e.target.selectionStart;
            let newPositionText = e.target.value.slice(0, position).replace(/\D/g, '');
            if (newPositionText.length > 19) {
                newPositionText = newPositionText.substring(0, 19);
            }
            newPositionText = newPositionText.replace(/(\w{4})(?=\w)/g, '$1 ');
            position = newPositionText.length;
            let str = text.replace(/\D/g, '');
            if (str.length > 19) {
                str = str.substring(0, 19);
            }
            str = str.replace(/(\w{4})(?=\w)/g, '$1 ');
            me.value = str;
            e.target.selectionStart = position;
            e.target.selectionEnd = position;
        }
        setErrByRequired(me) {
            const toolTip = me.myInput.querySelector(".tool-tip");
            if (me.required && !me.myInput.querySelector("input:not(.hidden)").value) {
                me.error = true;
                ECP.HTML.ToolTip(toolTip, `<i class=ews-icon-info style=color:var(--text-error)></i>`, "Required", "right", 150);
            }
            else {
                me.error = false;
                if (toolTip) {
                    me.myInput.querySelector(".tool-tip").innerHTML = "";
                    toolTip.classList.add("hidden");
                }
            }
        }
        GetCardType(number) {
            const numberAsString = number.toString();
            if (numberAsString.startsWith("4")) {
                return "Visa";
            }
            if (numberAsString.startsWith("5")) {
                return "Mastercard";
            }
            if (numberAsString.match(this.AMEXCardTypeRegex) != null) {
                return "AMEX";
            }
            if (numberAsString.match(this.DiscoverCardTypeRegex) != null) {
                return "Discover";
            }
            return "";
        }
        getStandardInputRoot() {
            return this.shadowRoot.querySelector(".ecp-input, .ecp-select");
        }
        getStandardLabelClassName(labelAlign) {
            if (labelAlign === "top") {
                return "column-label";
            }
            const inputType = (this.type || "").toLowerCase();
            if (inputType === "address") {
                return "left-label-input";
            }
            return "ecp-input-label";
        }
        appendStandardLabel(container, labelText, labelAlign) {
            const effectiveLabelAlign = labelAlign || "left";
            const labelClassName = this.getStandardLabelClassName(effectiveLabelAlign);
            const labelElement = document.createElement("label");
            container.classList.remove("column-label", "ecp-input-label", "left-label-input");
            container.classList.add(labelClassName);
            labelElement.className = effectiveLabelAlign === "top" ? "input-label-top" : "input-label";
            labelElement.textContent = labelText;
            container.textContent = "";
            container.appendChild(labelElement);
        }
        hasUsableLabel(labelValue) {
            return labelValue !== undefined && labelValue !== null && labelValue.toString().trim() !== "";
        }
        updateStandardLabel(newValue) {
            const currentLabel = this.shadowRoot.querySelector(".input-label, .input-label-top");
            const hasLabel = this.hasUsableLabel(newValue);
            if (hasLabel) {
                if (currentLabel) {
                    currentLabel.textContent = newValue;
                }
                else {
                    const inputRoot = this.getStandardInputRoot();
                    if (inputRoot) {
                        const newContainer = document.createElement("div");
                        this.appendStandardLabel(newContainer, newValue, this.labelAlign);
                        if (inputRoot.parentNode === this.shadowRoot) {
                            this.shadowRoot.removeChild(inputRoot);
                        }
                        newContainer.appendChild(inputRoot);
                        this.shadowRoot.appendChild(newContainer);
                    }
                }
            }
            else if (currentLabel) {
                currentLabel.textContent = "";
            }
            const encDisplayName = (newValue || "").replace(/^\s*\*/g, "").trim();
            const displayNodes = this.shadowRoot.querySelectorAll("input:not(.hidden), select, textarea");
            for (let i = 0; i < displayNodes.length; i++) {
                const node = displayNodes[i];
                if (encDisplayName) {
                    node.setAttribute("encDisplayName", encDisplayName);
                }
                else {
                    node.removeAttribute("encDisplayName");
                }
            }
        }
        labelChanged(oldValue, newValue) {
            if (this.type.toLowerCase() === "date" || this.type.toLowerCase() === "datetime") {
                const label = this.shadowRoot.querySelector(".label");
                const hasLabel = this.hasUsableLabel(newValue);
                if (this.labelAlign == "inline") {
                    const labelInline = this.shadowRoot.querySelector(".label-inline");
                    labelInline.innerHTML = newValue && (this.value || this.placeholder) ? newValue + ":" : newValue;
                }
                else if (hasLabel) {
                    if (label) {
                        label.innerHTML = newValue;
                    }
                    else {
                        const firstChild = this.shadowRoot.firstChild;
                        const label = document.createElement("label");
                        label.classList.add("label");
                        label.innerHTML = newValue;
                        this.shadowRoot.insertBefore(label, firstChild);
                    }
                }
                else if (label) {
                    this.shadowRoot.removeChild(label);
                }
            }
            else if (this.isCreated) {
                this.updateStandardLabel(newValue);
            }
        }
        updateStandardLabelAlign(newValue) {
            const labelContainer = this.shadowRoot.querySelector(".column-label, .ecp-input-label, .left-label-input");
            const inputRoot = this.getStandardInputRoot();
            if (labelContainer && inputRoot) {
                if (labelContainer.contains(inputRoot)) {
                    labelContainer.removeChild(inputRoot);
                }
                this.appendStandardLabel(labelContainer, this.label, newValue);
                labelContainer.appendChild(inputRoot);
            }
        }
        labelAlignChanged(oldValue, newValue) {
            if (this.type.toLowerCase() === "date" || this.type.toLowerCase() === "datetime") {
                if (this.label && newValue) {
                    const label = this.shadowRoot.querySelector(".label");
                    const labelInline = this.shadowRoot.querySelector(".label-inline");
                    const section = this.shadowRoot.querySelector(".input-border");
                    const container = this.shadowRoot.querySelector(".DatePickerField");
                    if (newValue === "left") {
                        if (label) {
                            label.classList.add("label-column");
                            label.classList.remove("hidden");
                            this.classList.add("flex");
                        }
                        labelInline?.classList.add("hidden");
                        section?.classList.remove("inline");
                        container?.classList.add("flex-label");
                        this.selectedChanged(false);
                    }
                    else if (newValue === "inline") {
                        this.classList.remove("flex");
                        if (labelInline) {
                            labelInline.innerHTML = this.label && (this.value || this.placeholder) ? this.label + ":" : this.label;
                            labelInline.classList.remove("hidden");
                        }
                        if (label) {
                            label.classList.add("hidden");
                        }
                        section?.classList.add("inline");
                        if (this.value) {
                            this.selectedChanged(true);
                        }
                    }
                    else {
                        if (label) {
                            label.classList.remove("hidden", "label-column");
                            this.classList.remove("flex");
                        }
                        labelInline?.classList.add("hidden");
                        section?.classList.remove("inline");
                        container?.classList.remove("flex-label");
                        this.selectedChanged(false);
                    }
                }
            }
            else if (this.label && this.isCreated) {
                this.updateStandardLabelAlign(newValue);
            }
        }
        selectedChanged(newValue) {
            const clearBtn = this.shadowRoot.querySelector(".ews-icon-close");
            const container = this.shadowRoot.querySelector(".input-border");
            const btn = this.shadowRoot.querySelector(".ews-icon-calendar");
            if (container) {
                if (this.labelAlign == "inline" && newValue) {
                    if (this.value) {
                        clearBtn.classList.remove("hidden");
                        btn.classList.add("hidden");
                    }
                    container.classList.add("selected");
                }
                else {
                    clearBtn.classList.add("hidden");
                    btn.classList.remove("hidden");
                    container.classList.remove("selected");
                }
            }
        }
        clearableChanged(oldValue, newValue) {
            if (this.myInput && this.type !== "textarea" && this.type !== "date" && this.type !== "datetime" && this.type !== "time" && !this.ValuesArr) {
                const rightDiv = this.myInput.querySelector(".clear");
                const isIcon = this.myInput.classList.contains("has-right-icon");
                if (this.value && newValue) {
                    this.myInput.classList.add("has-right-icon");
                    rightDiv.classList.remove("hidden");
                    this.setErrByRequired(this);
                    if (!rightDiv.querySelector(".ews-icon-close")) {
                        const close = document.createElement("i");
                        close.classList.add("ews-icon-close");
                        rightDiv.appendChild(close);
                        close.addEventListener("click", () => {
                            this.value = "";
                            this.myInput.querySelector("input").value = "";
                            this.setErrByRequired(this);
                            this.$emit("change");
                        });
                        if (this.type == "card") {
                            this.myInput.addEventListener("mouseenter", () => {
                                const cardIcon = this.myInput.querySelector(".card-type-icon");
                                rightDiv.classList.remove("hidden");
                                cardIcon?.classList.add("hidden");
                            });
                            this.myInput.addEventListener("mouseleave", () => {
                                if (this.value) {
                                    const cardIcon = this.myInput.querySelector(".card-type-icon");
                                    rightDiv.classList.add("hidden");
                                    cardIcon?.classList.remove("hidden");
                                }
                            });
                        }
                    }
                }
                else if (rightDiv.querySelector(".ews-icon-close")) {
                    rightDiv.removeChild(rightDiv.querySelector(".ews-icon-close"));
                    if (!isIcon) {
                        this.myInput.classList.remove("has-right-icon");
                    }
                }
            }
        }
        EndDateChanged(oldValue, newValue) {
            if (newValue && this.myDateSelector) {
                this.myDateSelector.EndDate = new Date(newValue);
            }
        }
    };
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "name", void 0);
    __decorate([
        ECP.attr({ attribute: 'data-type' })
    ], InputWebComponent.prototype, "dataType", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "id", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "placeholder", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "icon", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "ValuesArr", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], InputWebComponent.prototype, "required", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], InputWebComponent.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], InputWebComponent.prototype, "error", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "value", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView', converter: ECP.nullableNumberConverter })
    ], InputWebComponent.prototype, "length", void 0);
    __decorate([
        ECP.attr({ attribute: 'maxlength', mode: 'fromView', converter: ECP.nullableNumberConverter })
    ], InputWebComponent.prototype, "maxLength", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "label", void 0);
    __decorate([
        ECP.attr({ attribute: 'label-align' })
    ], InputWebComponent.prototype, "labelAlign", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "width", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "rows", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], InputWebComponent.prototype, "combined", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "padding", void 0);
    __decorate([
        ECP.attr({ attribute: 'value-address1' })
    ], InputWebComponent.prototype, "valueAddress1", void 0);
    __decorate([
        ECP.attr({ attribute: 'value-address2' })
    ], InputWebComponent.prototype, "valueAddress2", void 0);
    __decorate([
        ECP.attr({ attribute: 'value-city' })
    ], InputWebComponent.prototype, "valueCity", void 0);
    __decorate([
        ECP.attr({ attribute: 'value-state' })
    ], InputWebComponent.prototype, "valueState", void 0);
    __decorate([
        ECP.attr({ attribute: 'value-postal' })
    ], InputWebComponent.prototype, "valuePostal", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "size", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "helperText", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "textAlign", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], InputWebComponent.prototype, "clearable", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "FieldTitle", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "TabIndex", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "StartDate", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "EndDate", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "ExcludeDates", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "SelectorType", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], InputWebComponent.prototype, "SubTabValue", void 0);
    __decorate([
        ECP.attr
    ], InputWebComponent.prototype, "PickerType", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], InputWebComponent.prototype, "ForceExactRange", void 0);
    InputWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-input",
            enableIcon: true,
            shadowOptions: {
                mode: "open",
                delegatesFocus: true
            },
            styles: `
:host *{
box-sizing:border-box
}
.margin-bottom-5{
margin-bottom:5px
}
input, select, textarea{
border:1px solid var(--border);
border-radius:4px;
font-size:13px;
font-family:Open Sans, Segoe UI, SF Pro Text, Helvetica, Helvetica Neue, Arial, Tahoma, sans-serif;
margin:0;
padding:0 5px
}
.DisableIconClick{
pointer-events:none
}
.DatePickerField{
height:32px
}
.DatePickerField .input-border{
padding-left:12px;
background:var(--bg);
border:1px var(--border) solid;
border-radius:4px;
transition:border-color var(--ecp-duration-fastest) var(--ecp-ease-standard),background-color var(--ecp-duration-fastest) var(--ecp-ease-standard);
height:32px
}
.DatePickerField input[type=text]{
width:100%;
height:32px;
line-height:32px;
background:transparent;
border:none;
border-radius:4px 0 0 4px;
box-sizing:border-box;
margin:0;
padding:0;
color:var(--text);
}
.DatePickerField .icon-box{
width:32px;
display:flex;
align-items:center;
justify-content:center
}
.DatePickerField span.ews-icon-calendar{
width: 100%;
height:30px;
line-height:30px;
cursor:pointer;
padding:0 6px;
color:var(--text);
border-radius:0 4px 4px 0;
background-color:var(--bg);
transition:background-color var(--ecp-duration-fastest) var(--ecp-ease-standard);
box-sizing:border-box;
font-size:14px;
text-align:center;
}
.DatePickerField span.ews-icon-calendar:hover{
background-color:var(--bg-hover)
}
.flex{
display:flex;
align-items:center
}
:focus{
outline:0
}
.ecp-input{
display:inline-flex;
position:relative;
font-size:13px;
width:100%;
flex-direction:column
}
.ecp-input input {
width:100%;
height:32px;
line-height:32px;
font-size:inherit;
color:var(--text);
background:var(--bg);
border:solid 1px var(--border)
}
.ecp-input input::placeholder{
color:var(--text-placeholder)
}
.ecp-input input:focus{
border-color:var(--border-active) !important
}
.ecp-input input::-webkit-outer-spin-button, .ecp-input input::-webkit-inner-spin-button{
-webkit-appearance: none;
margin:0
}
.ecp-input.basic-input input {
padding:0 12px;
box-sizing:border-box
}
.ecp-input.error-tip{
position:absolute;
top:30px;
left:5px
}
.ecp-input.has-left-icon .input-icon{
display:flex;
justify-content:center;
align-items:center;
position:absolute;
top:0;
left:0;
width:32px;
height:32px;
color:var(--text-placeholder);
font-style:normal
}
.ecp-input.has-left-icon .input-icon.icon-currency{
font-size:14px
}
.ecp-input.has-left-icon input{
padding-left:32px
}
.ecp-input.has-right-icon input{
padding-right:32px !important
}
.ecp-input.has-right-icon .right-icon{
display:flex;
justify-content:center;
align-items:center;
position:absolute;
top:0;
right:0;
width:32px;
height:32px;
color:var(--text-secondary);
font-style:normal
}

.ecp-input.has-right-icon .right-icon .tooltip-container{
width:auto;
height:auto;
position:relative;
display:inline-block
}
.ecp-input.error input, .DatePickerField .error{
border-color:var(--text-error)
}
.ecp-input.disabled-input input{
border-color:var(--bg-object);
background:var(--bg-object);
color:var(--text-secondary);
pointer-events:none
}
.ecp-input[textAlign=left] input{
text-align:left
}
.ecp-input[textAlign=right] input{
text-align:right
}
.ecp-select{
position:relative
}
.select-icon{
position:absolute;
right:0;
top:0;
width:32px;
height:32px;
line-height:32px !important;
text-align:center;
font-size:inherit;
z-index:8;
background:var(--bg);
border-radius:4px
}
.ecp-select select{
appearance:none;
position:relative;
z-index:10;
padding:0 32px 0 12px;
width:100%;
height:32px;
color:var(--text);
font-size:inherit;
background:linear-gradient(to right,var(--bg) calc(100% - 30px),transparent 32px);
cursor:pointer
}
.ecp-select select:active, .ecp-select select:focus{
border-color:var(--border-active) !important
}
.ecp-select.error select{
border-color:var(--text-error)
}
.ecp-select.has-left-icon .select-left-icon{
display:flex;
justify-content:center;
align-items:center;
position:absolute;
top:0;
left:0;
width:32px;
height:32px;
color:var(--text-secondary);
font-style:normal
}
.ecp-select.has-left-icon select{
padding-left:32px
}
.ecp-select.disabled-input select{
border-color:var(--bg-object);
background:var(--bg-object);
color:var(--text-secondary);
pointer-events:none
}
.ecp-input.ecp-input-combined input{
border-radius:0
}
.ecp-input.ecp-input-combined .up-left-input{
border-top-left-radius:4px
}
.ecp-input.ecp-input-combined .up-right-input{
border-top-right-radius:4px
}
.ecp-input.ecp-input-combined .lower-left-input{
border-radius:0 0 0 4px;
border-right:solid 0
}
.ecp-input.ecp-input-combined .lower-right-input{
border-bottom-right-radius:4px;
width:60%
}
.ecp-input.ecp-input-combined .top-input{
border-top-left-radius:4px;
border-top-right-radius:4px;
border-bottom:solid 0
}
.ecp-input.ecp-input-combined .bottom-input{
border-radius:0 0 4px 4px
}
.ecp-input.ecp-input-combined .middle-input{
border-radius:0;
border-bottom:solid 0
}
.ecp-input-combined input:focus{
border-color:var(--border-active) !important
}
.border-top {
border-top-color:var(--border-active) !important
}
.border-left {
border-left-color:var(--border-active) !important
}
.ecp-input.ecp-input-combined .column{
display:flex;
flex-wrap:nowrap;
flex-direction:column
}
.ecp-input.ecp-input-combined .row {
display:flex;
flex-wrap:nowrap;
flex-direction:row
}
.ecp-input-label{
height:100%;
display:flex
}
.ecp-input-label .ecp-input{
flex:1
}
.input-label{
line-height:32px;
margin-right:12px
}
.left-label-input{
display:flex;
align-items:center
}
.ecp-input .input-time-icon{
position:absolute;
right:8px;
top:10px;
color:#ccc
}
.ecp-input-time-picker-panel{
color:var(--text-secondary);
border:1px solid #e4e7ed;
box-shadow:0 2px 12px 0 var(--neutral-30);
background:var(--bg);
border-radius:4px;
line-height:30px;
display:flex;
justify-content:space-around;
position:fixed;
width:193px;
z-index:99
}
.ecp-input-time-picker-panel .time-select-item{
padding:8px 10px;
font-size:14px;
line-height:20px;
height:185px;
overflow-y:scroll;
cursor:pointer
}
.ecp-input-time-picker-panel .time-select-item .time-item{
margin:5px;
text-align:center;
padding:5px 8px
}
.ecp-input-time-picker-panel .time-select-item .time-item:hover{
background:var(--bg-hover)
}
.ecp-input-time-picker-panel .time-select-item .active{
background:var(--bg-action);
color:var(--text-onbg-action)
}
.ecp-input-time-picker-panel .time-select-item::-webkit-scrollbar{
width:0;
height:0
}
.ShakeToReject{
animation: kf_shake 0.5s 1 linear
}
@keyframes kf_shake{
0% {
    transform: translate(30px);
}
20% {
    transform: translate(-30px);
}
40% {
    transform: translate(15px);
}
60% {
    transform: translate(-15px);
}
80% {
    transform: translate(8px);
}
100% {
    transform: translate(0);
}
}
.tooltip-description{
display:none;
position:fixed;
pointer-events:none;
padding:8px 15px;
border-radius:5px;
z-index:100;
box-shadow:0 -5px 10px -2px rgb(0 0 0 / 40%);
width: max-content
}
.tooltip-description[position=right]{
left:30px;
top:-6px;
animation:ani-left .45s ease-out
}
.tip-container i.ews-icon-info-label, .tooltip-description{
background:var(--bg-action);
color:var(--text-onbg-action)
}
.tooltip-container:hover .tooltip-description{
display: block
}
.hidden{
display:none !important
}
.ecp-input.ecp-textarea{
height:100%;
resize:inherit;
color:var(--text)
}
.ecp-input .textarea_inner{
height:100%;
display:block;
line-height:20px;
width:100%;
background-color:var(--bg);
padding:0 12px;
resize:inherit
}
.ecp-input.error .textarea_inner{
border-color:var(--text-error)
}
.AutocompleteActive .input-border{
border-color:var(--border-active)!important;
}
.AutocompleteActive input[type=text]{
outline:none
}
:host(.input-large) input[type="text"],
:host(.input-large) input[type="number"],
:host(.input-large) .input-icon,
:host(.input-large) .right-icon,
:host(.input-large) .select-icon,
:host(.input-large) .ecp-select select,
:host(.input-large) .label-column,
:host(.input-large) .inline .label-inline{
height:44px!important;
line-height:44px!important
}
:host(.input-large) .ecp-input input {
padding: 0 16px;
}
:host(.input-large) .ecp-input.has-left-icon .input-icon,
:host(.input-large) .ecp-input.has-right-icon .right-icon {
width:44px;
}
:host(.input-large) .ecp-input.has-left-icon input {
padding-left: 42px;
}
:host(.input-large) .ecp-input.has-right-icon input {
padding-right: 42px!important;
}
:host(.input-large) .ecp-select select {
padding: 0 36px 0 16px;
}
:host(.input-large) .DatePickerField,
:host(.input-large) .inline.selected,
:host(.input-large) .DatePickerField .input-border{
height:44px!important
}
:host(.input-large) .input-label{
line-height:44px!important
}
:host(.input-large) .DatePickerField input[type="text"],:host(.input-large) .DatePickerField span.ews-icon-calendar{
height:42px!important;
line-height:42px!important
}
:host(.input-large) .DatePickerField .icon-box{
width:46px
}
:host(.input-large) .DatePickerField span.ews-icon-calendar{
padding:0 16px
}
:host(.input-large) .DatePickerField .input-border {
padding-left: 16px;
}
:host(.input-large) .inline .label-inline {
margin-right: 12px;
}
.helper-text{
font-size:10px;
color:var(--text-secondary)
}
.column-label{
height:100%;
display:flex;
flex-direction:column;
gap:4px
}
.column-label .ecp-textarea{
flex:1
}
.label{
display:inline-block
}
.label-column{
height:32px;
line-height:32px;
margin-right:12px
}
.label:not(.label-column){
margin-bottom:4px
}
.flex-label{
flex: 1 1 0%
}
.inline .label-inline{
margin-right:8px;
cursor:pointer;
height:32px;
line-height:32px
}
.ews-icon-close{
font-size: 10px!important
}
.inline .DatePickerInput{
font-weight:var(--semibold-weight)
}
.inline.hover{
background:var(--bg-hover)!important
}
.inline.selected{
background:var(--bg-selected);
border:1px solid var(--border-selected)
}
.inline.selected.hover{
background:var(--bg-selected-hover)!important
}
.inline .DatePickerInput,
.inline .ews-icon-calendar{
background:transparent!important;
cursor:pointer
}
.inline.selected .ews-icon-close{
width:16px;
height:16px;
line-height:16px;
border-radius:50%;
text-align:center
}
.inline.selected .ews-icon-close:hover {
background:var(--bg-object)
}
.clear .ews-icon-close{
height:18px;
width:18px;
line-height:18px;
padding-right:0px;
border-radius:50%;
text-align:center;
cursor:pointer;
transition:background-color var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
.clear .ews-icon-close:hover {
background:var(--bg-object)
}
.shortcut{
display:flex;
align-items:center;
position:absolute;
top:0px;
right:12px;
height:32px
}
:host(.input-large) .shortcut{
height:44px
}`
        })
    ], InputWebComponent);
    ECP.InputWebComponent = InputWebComponent;
    class Calendar {
        constructor(CurDate, IncludeTime, PickerType, SubTabValue, PositionFunction, SelectDateFunction, ChangeYearAndMonthFunction, ChangeTimeFunction, SetPeriodValueFunction, PeriodValue, id, displayInput, StartDate, EndDate, AllowStartDate, AllowEndDate, SelectorType, ExcludeDates, ForceExactRange) {
            this.EndTime = "";
            this.CurDate = new Date(CurDate);
            this.SelectedDate = new Date(CurDate);
            this.IncludeTime = IncludeTime;
            this.SubTabValue = SubTabValue;
            this.PositionFunction = PositionFunction;
            this.SelectDateFunction = SelectDateFunction;
            this.ChangeYearAndMonthFunction = ChangeYearAndMonthFunction;
            this.ChangeTimeFunction = ChangeTimeFunction;
            this.SetPeriodValueFunction = SetPeriodValueFunction;
            this.PeriodValue = PeriodValue;
            this.StartDate = StartDate;
            this.EndDate = EndDate;
            this.AllowStartDate = AllowStartDate;
            this.AllowEndDate = AllowEndDate;
            this.SelectorType = SelectorType;
            this.ExcludeDates = ExcludeDates;
            this.DataType = IncludeTime ? ECP.DataType._DateTime : ECP.DataType._Date;
            this.PickerType = PickerType;
            this.ForceExactRange = ForceExactRange === true;
            this.DisplayInputElement = displayInput;
            this.DisplayCalendar = this.DisplayCalendar.bind(this);
            this.DisplayMonthSelection = this.DisplayMonthSelection.bind(this);
            this.NextMonth = this.NextMonth.bind(this);
            this.PrevMonth = this.PrevMonth.bind(this);
            this.NextYear = this.NextYear.bind(this);
            this.PrevYear = this.PrevYear.bind(this);
            this.SetYear = this.SetYear.bind(this);
            this.SetMonth = this.SetMonth.bind(this);
            this.ClickDateEvent = this.ClickDateEvent.bind(this);
            this.ClickDate = this.ClickDate.bind(this);
            this.CalendarElement = document.createElement("ecp-calendar");
            this.CalendarElement.id = `${EC_Fmt.Null2EmptyStr(id)}_Calendar`;
            this.CalendarElement.classList.add("DatePickerCalendar", "Hideable", "NoPadding");
            this.CalendarElement.addEventListener("click", () => {
                AllowHideAllDivs = false;
                if (this.DisplayInputElement && document.activeElement !== this.DisplayInputElement && !this.CalendarElement.contains(document.activeElement)) {
                    this.DisplayInputElement.focus();
                }
            }, true);
            document.body.appendChild(this.CalendarElement);
            if (displayInput) {
                this.AddCalendarMutationObserver(displayInput);
            }
            this.CalendarElement.addEventListener("animationend", () => {
                if (this.CalendarElement.classList.contains("animation-disappear-to-top") || this.CalendarElement.classList.contains("animation-disappear-to-bottom")) {
                    this.CalendarElement.style.display = "none";
                    this.CalendarElement.classList.remove("animation-disappear-to-top", "animation-appear-from-top", "animation-disappear-to-bottom");
                }
            }, true);
            document.addEventListener("keydown", (event) => {
                if ((event.key === "Escape" || event.code === "Escape") && EC_Fmt.isVisible(this.CalendarElement)) {
                    if (this.CalendarElement.getAttribute("inputchanged") === "true") {
                        this.CalendarElement.classList.add("animation-disappear-to-bottom");
                    }
                    else {
                        this.CalendarElement.classList.add("animation-disappear-to-top");
                    }
                }
            });
        }
        AddCalendarMutationObserver(displayInput) {
            const myCalendarMutationObserver = new MutationObserver((mutations) => {
                for (let i = 0, len = mutations.length; i < len; i++) {
                    const mutation = mutations[i];
                    if (mutation.type === "attributes") {
                        const target = mutation.target;
                        if (target.style.display === "none" && displayInput.getAttribute("haschangevalue") === "true") {
                            EC_Fmt.TriggerEvent(displayInput, "change");
                        }
                        else {
                            displayInput.setAttribute("haschangevalue", "false");
                            displayInput.setAttribute("inputchanged", "false");
                            this.CalendarElement.setAttribute("inputchanged", "false");
                        }
                    }
                }
            });
            myCalendarMutationObserver.observe(this.CalendarElement, { attributes: true, attributeFilter: ["style"] });
        }
        DisplayCalendar() {
            if (!EC_Fmt.ChkDate(this.CurDate)) {
                this.CurDate = new Date();
            }
            this.CalendarElement.innerHTML = "";
            if (this.PickerType.toLowerCase() === "range" && this.ForceExactRange) {
                this.SubTabValue = "Custom";
                this.SelectorType = DatePickerType._Between;
            }
            else if (this.SubTabValue != "Period") {
                this.SubTabValue = "Custom";
            }
            if (this.SubTabValue === "Custom") {
                switch (this.PickerType.toLowerCase()) {
                    case "single":
                        this.SelectorType = DatePickerType._Exactly;
                        break;
                    case "range":
                        this.DisplayCalendarHeader();
                        break;
                    default:
                        this.DisPlaySubTab();
                        this.DisplayCalendarHeader();
                        break;
                }
                this.DisplayDateSelection();
                if (this.IncludeTime) {
                    this.DisplayTimeInput();
                }
            }
            else {
                this.DisPlaySubTab();
                const periodDate = document.createElement("div");
                periodDate.classList.add("PeriodBox");
                periodDate.innerHTML += `<div class="Period-Title Common"><span>Common</span></div>`
                    + `<div class="Period-item Common"value="${Period.Today}"><span>Today</span></div>`
                    + `<div class="Period-item Common"value="${Period.Yesterday}"><span>Yesterday</span></div>`
                    + `<div class="Period-item Common"value="${Period["Last 30 Days"]}"><span>Last 30 Days</span></div>`
                    + `<div class="Period-item Common"value="${Period["This Week"]}"><span>This Week</span></div>`
                    + `<div class="Period-item Common"value="${Period["Last Week"]}"><span>Last Week</span></div>`
                    + `<div class="Period-item Common"value="${Period["This Month"]}"><span>This Month</span></div>`
                    + `<div class="Period-item Common"value="${Period["Last Month"]}"><span>Last Month</span></div>`
                    + `<div class="Period-item Common"value="${Period["Year To Date"]}"><span>Year To Date</span></div>`
                    + `<div class="Period-Empty Common"><span></span></div>`
                    + `<div class=Period-Title><span>Day</span></div>`
                    + `<div class=Period-item value="${Period.Today}"><span>Today</span></div>`
                    + `<div class=Period-item value="${Period["Tomorrow"]}"><span>Tomorrow</span></div>`
                    + `<div class=Period-item value="${Period.Yesterday}"><span>Yesterday</span></div>`
                    + `<div class=Period-item value="${Period["Close Date"]}"><span>Close Date</span></div>`
                    + `<div class=Period-item value="${Period["Last 60 Days"]}"><span>Last 60 Days</span></div>`
                    + `<div class=Period-item value="${Period["Last 90 Days"]}"><span>Last 90 Days</span></div>`
                    + `<div class=Period-item value="${Period["Rolling 7 Days"]}"><span>Rolling 7 Days</span></div>`
                    + `<div class=Period-item value="${Period["Rolling 14 Days"]}"><span>Rolling 14 Days</span></div>`
                    + `<div class=Period-Empty><span></span></div>`
                    + `<div class=Period-Title><span>Week</span></div>`
                    + `<div class=Period-item value="${Period["Next Week"]}"><span>Next Week</span></div>`
                    + `<div class=Period-item value="${Period["This Week"]}"><span>This Week</span></div>`
                    + `<div class=Period-item value="${Period["Last Week"]}"><span>Last Week</span></div>`
                    + `<div class=Period-item value="${Period["This Week To Date"]}"><span>This Week To Date</span></div>`
                    + `<div class=Period-item value="${Period["Last 2 Weeks"]}"><span>Last 2 Weeks</span></div>`
                    + `<div class=Period-item value="${Period["Last 4 Weeks"]}"><span>Last 4 Weeks</span></div>`
                    + `<div class=Period-item value="${Period["Last 8 Weeks"]}"><span>Last 8 Weeks</span></div>`
                    + `<div class=Period-item value="${Period["Last 13 Weeks"]}"><span>Last 13 Weeks</span></div>`
                    + `<div class=Period-item value="${Period["Last 26 Weeks"]}"><span>Last 26 Weeks</span></div>`
                    + `<div class=Period-item value="${Period["Last 52 Weeks"]}"><span>Last 52 Weeks</span></div>`
                    + `<div class=Period-Empty><span></span></div>`
                    + `<div class=Period-Title><span>Month</span></div>`
                    + `<div class=Period-item value="${Period["This Month"]}"><span>This Month</span></div>`
                    + `<div class=Period-item value="${Period["Next Month"]}"><span>Next Month</span></div>`
                    + `<div class=Period-item value="${Period["Last Month"]}"><span>Last Month</span></div>`
                    + `<div class=Period-item value="${Period["Month To Date"]}"><span>Month To Date</span></div>`
                    + `<div class=Period-item value="${Period["Month To Selling Days"]}"><span>Month To Selling Days</span></div>`
                    + `<div class=Period-item value="${Period["Last Complete 3 Months"]}"><span>Last Complete 3 Months</span></div>`
                    + `<div class=Period-item value="${Period["Last Complete 6 Months"]}"><span>Last Complete 6 Months</span></div>`
                    + `<div class=Period-item value="${Period["Last Complete 9 Months"]}"><span>Last Complete 9 Months</span></div>`
                    + `<div class=Period-item value="${Period["Last Complete 12 Months"]}"><span>Last Complete 12 Months</span></div>`
                    + `<div class=Period-item value="${Period["Last Complete 24 Months"]}"><span>Last Complete 24 Months</span></div>`
                    + `<div class=Period-item value="${Period["Rolling 12 Months"]}"><span>Rolling 12 Months</span></div>`
                    + `<div class=Period-item value="${Period["Last Year This Month"]}"><span>Last Year This Month</span></div>`
                    + `<div class=Period-item value="${Period["Last Year Next Month"]}"><span>Last Year Next Month</span></div>`
                    + `<div class=Period-item value="${Period["Last Year Last Month"]}"><span>Last Year Last Month</span></div>`
                    + `<div class=Period-item value="${Period["Rolling 12 Months"]}"><span>Rolling 12 Months</span></div>`
                    + `<div class=Period-Empty><span></span></div>`
                    + `<div class=Period-Title><span>Year</span></div>`
                    + `<div class=Period-item value="${Period["This Year"]}"><span>This Year</span></div>`
                    + `<div class=Period-item value="${Period["Next Year"]}"><span>Next Year</span></div>`
                    + `<div class=Period-item value="${Period["Last Year"]}"><span>Last Year</span></div>`
                    + `<div class=Period-item value="${Period["Year To Date"]}"><span>Year To Date</span></div>`
                    + `<div class=Period-item value="${Period["Year To Selling Days"]}"><span>Year To Selling Days</span></div>`
                    + `<div class=Period-item value="${Period["Year To Day Of Year"]}"><span>Year To Day Of Year</span></div>`
                    + `<div class=Period-item value="${Period["This Year Complete Months"]}"><span>This Year Complete Months</span></div>`
                    + `<div class=Period-item value="${Period["This Year Complete Weeks"]}"><span>This Year Complete Weeks</span></div>`
                    + `<div class=Period-Empty><span></span></div>`
                    + `<div class=Period-Title><span>Quarter</span></div>`
                    + `<div class=Period-item value="${Period["This Quarter"]}"><span>This Quarter</span></div>`
                    + `<div class=Period-item value="${Period["Last Quarter"]}"><span>Last Quarter</span></div>`
                    + `<div class=Period-item value="${Period["Quarter To Date"]}"><span>Quarter To Date</span></div>`
                    + `<div class=Period-item value="${Period["Last Complete 4 Quarters"]}"><span>Last Complete 4 Quarters</span></div>`
                    + `<div class=Period-Empty><span></span></div>`
                    + `<div class=Period-Title><span>Trimester</span></div>`
                    + `<div class=Period-item value="${Period["This Trimester"]}"><span>This Trimester</span></div>`
                    + `<div class=Period-item value="${Period["Last Trimester"]}"><span>Last Trimester</span></div>`
                    + `<div class=Period-item value="${Period["Trimester To Date"]}"><span>Trimester To Date</span></div>`
                    + `<div class="Period-EmptyState hide"><ecp-sectionmessage type="information">No options</ecp-sectionmessage></div>`;
                if (this.PeriodValue) {
                    this.SetPeriodValueFunction(this.PeriodValue);
                    periodDate.innerHTML = `<div class=Period-item value="${this.PeriodValue}"selected><span>${Period[this.PeriodValue]}</span></div>` + periodDate.innerHTML;
                }
                for (let i = 0; i < periodDate.querySelectorAll(".Period-item").length; i++) {
                    const item = periodDate.querySelectorAll(".Period-item")[i];
                    item.addEventListener("click", () => {
                        if (periodDate.querySelector(".Period-item[selected]")) {
                            periodDate.querySelector(".Period-item[selected]").removeAttribute("selected");
                        }
                        this.SetPeriodValueFunction(item.getAttribute("value"));
                        item.setAttribute("selected", "");
                    });
                }
                this.CalendarElement.appendChild(periodDate);
            }
            const buttons = document.createElement("div");
            buttons.innerHTML = "<span id=confirmButton>Done</span>";
            buttons.classList.add("ecp-dialog-footer-btn");
            this.CalendarElement.appendChild(buttons);
            this.CalendarElement.querySelector("#confirmButton").addEventListener("click", () => {
                if (this.SubTabValue === "Custom") {
                    this.SelectDateFunction(this.CurDate, this.SelectorType);
                }
                if (this.DisplayInputElement.getAttribute("inputchanged") === "true") {
                    this.CalendarElement.classList.add("animation-disappear-to-bottom");
                }
                else {
                    this.CalendarElement.classList.add("animation-disappear-to-top");
                }
            });
            this.PositionFunction(this.CalendarElement);
        }
        FormatTime(value, IsAM) {
            if (EC_Fmt.isNull(value)) {
                value = "";
                return value;
            }
            let myHour;
            let myMinute;
            value = value.replace(/a-z/ig, "").replace(/a-z/ig, "").trim();
            if (value.indexOf(":") < 0) {
                const len = value.length;
                if (len < 3) {
                    myHour = value;
                    myMinute = "00";
                }
                else if (len === 3) {
                    myHour = value.substr(0, 1);
                    myMinute = value.substr(1, 3);
                }
                else {
                    myHour = value.substr(0, 2);
                    myMinute = value.substr(2, 2);
                }
            }
            else {
                const HoursMinutes = value.split(":");
                myHour = HoursMinutes[0];
                myMinute = HoursMinutes[1].split(" ")[0];
            }
            let hour;
            if (EC_Fmt.isInteger(myHour)) {
                hour = EC_Fmt.CDec(myHour);
                if (hour < 0 || hour > 24) {
                    hour = 0;
                }
            }
            else {
                hour = 0;
            }
            if (IsAM && hour === 12) {
                hour = 0;
            }
            if (!IsAM) {
                if (hour === 0 && EC_Fmt.userTimeFormat !== 2) {
                    hour = 12;
                }
                else if (hour < 12 && hour > 0) {
                    hour += 12;
                }
                else if (hour === 24) {
                    if (EC_Fmt.userTimeFormat !== 2) {
                        hour = 12;
                    }
                    else {
                        hour = 0;
                    }
                }
                if (hour > 12 && hour < 24) {
                    hour -= 12;
                }
            }
            else {
                if (hour > 12 && hour < 24) {
                    hour -= 12;
                }
                else if ((hour === 0 || hour === 24) && EC_Fmt.userTimeFormat !== 2) {
                    hour = 12;
                }
                else if (hour === 24 && EC_Fmt.userTimeFormat === 2) {
                    hour = 0;
                }
            }
            let minute;
            if (EC_Fmt.isInteger(myMinute)) {
                minute = EC_Fmt.CDec(myMinute);
                if (minute < 0) {
                    minute = 0;
                }
                else if (minute > 59) {
                    minute = 59;
                }
            }
            else {
                minute = 0;
            }
            value = `${EC_Fmt.Right("0" + hour, 2)}:${EC_Fmt.Right("0" + minute, 2)}`;
            return value;
        }
        ClickDateEvent(event) {
            let target = event.target;
            if (target.classList.contains("day")) {
                let day = EC_Fmt.CDec(target.textContent);
                this.ClickDate(target, day);
            }
        }
        SetTimeValue(Date, TimeEL, IsAMEL) {
            if (this.IncludeTime) {
                const timeIsAM = IsAMEL.value === "AM" ? true : false;
                TimeEL.value = this.FormatTime(TimeEL.value, timeIsAM);
                let hour = EC_Fmt.CDec(TimeEL.value.split(":")[0]);
                if (hour === 12 && timeIsAM) {
                    hour = 0;
                }
                Date.setHours(hour);
                Date.setMinutes(EC_Fmt.CDec(TimeEL.value.split(":")[1]));
            }
            return Date;
        }
        ClickDate(dateDiv, day) {
            if (dateDiv.tagName === "DIV") {
                this.CurDate.setDate(day);
                this.SelectedDate = new Date(this.CurDate);
                switch (this.SelectorType) {
                    case "Exactly":
                        this.Clear();
                        dateDiv.classList.add("selectedDate");
                        this.SelectDateFunction(this.CurDate, DayType._CurrDate);
                        if (this.DataType === ECP.DataType._Date) {
                            if (this.DisplayInputElement.getAttribute("inputchanged") === "true") {
                                this.CalendarElement.classList.add("animation-disappear-to-bottom");
                            }
                            else {
                                this.CalendarElement.classList.add("animation-disappear-to-top");
                            }
                        }
                        break;
                    case "After":
                        this.Clear();
                        dateDiv.classList.add("selectedDate");
                        dateDiv.parentElement.classList.add("After");
                        for (let i = 0; i < this.CalendarElement.querySelectorAll(".day").length; i++) {
                            const item = this.CalendarElement.querySelectorAll(".day")[i];
                            if (EC_Fmt.CDec(item.textContent) > EC_Fmt.CDec(dateDiv.textContent)) {
                                item.parentElement.classList.add("pitch-on");
                            }
                        }
                        this.SelectDateFunction(this.CurDate, DayType._CurrDate);
                        if (this.DataType === ECP.DataType._Date) {
                            if (this.DisplayInputElement.getAttribute("inputchanged") === "true") {
                                this.CalendarElement.classList.add("animation-disappear-to-bottom");
                            }
                            else {
                                this.CalendarElement.classList.add("animation-disappear-to-top");
                            }
                        }
                        break;
                    case "Before":
                        this.Clear();
                        dateDiv.classList.add("selectedDate");
                        dateDiv.parentElement.classList.add("Before");
                        for (let i = 0; i < this.CalendarElement.querySelectorAll(".day").length; i++) {
                            const item = this.CalendarElement.querySelectorAll(".day")[i];
                            if (EC_Fmt.CDec(item.textContent) < EC_Fmt.CDec(dateDiv.textContent)) {
                                item.parentElement.classList.add("pitch-on");
                            }
                        }
                        this.SelectDateFunction(this.CurDate, DayType._CurrDate);
                        if (this.DataType === ECP.DataType._Date) {
                            if (this.DisplayInputElement.getAttribute("inputchanged") === "true") {
                                this.CalendarElement.classList.add("animation-disappear-to-bottom");
                            }
                            else {
                                this.CalendarElement.classList.add("animation-disappear-to-top");
                            }
                        }
                        break;
                    case "Between":
                        const time1 = this.CalendarElement.querySelector("#time1");
                        const time2 = this.CalendarElement.querySelector("#time2");
                        const StartPMorAM = this.CalendarElement.querySelector("select[name='StartPMorAM']");
                        const EndPMorAM = this.CalendarElement.querySelector("select[name='EndPMorAM']");
                        if (this.StartDate) {
                            if (this.EndDate) {
                                this.Clear();
                                this.StartDate = new Date(this.CurDate.setDate(day));
                                this.StartDate = this.SetTimeValue(this.StartDate, time1, StartPMorAM);
                                this.SelectDateFunction(this.StartDate, DayType._StartDate);
                                this.SelectDateFunction(null, DayType._EndDate);
                                dateDiv.classList.add("startDate");
                                dateDiv.parentElement.classList.add("After");
                            }
                            else {
                                const endSelectedDay = this.CalendarElement.querySelector(".endDate");
                                if (endSelectedDay) {
                                    endSelectedDay.classList.remove("endDate");
                                    endSelectedDay.parentElement.classList.remove("Before");
                                }
                                this.CalendarElement.querySelectorAll(".pitch-on").forEach((item) => {
                                    item.classList.remove("pitch-on");
                                });
                                if (new Date(this.CurDate) < this.StartDate) {
                                    this.EndDate = this.StartDate;
                                    this.EndDate = this.SetTimeValue(this.EndDate, time2, EndPMorAM);
                                    this.SelectDateFunction(this.EndDate, DayType._EndDate);
                                    this.StartDate = new Date(this.CurDate);
                                    this.StartDate = this.SetTimeValue(this.StartDate, time1, StartPMorAM);
                                    this.SelectDateFunction(this.StartDate, DayType._StartDate);
                                    const newStartDate = this.CalendarElement.querySelector(".startDate");
                                    newStartDate.classList.remove("startDate");
                                    newStartDate.parentElement.classList.remove("After");
                                    newStartDate.classList.add("endDate");
                                    newStartDate.parentElement.classList.add("Before");
                                    dateDiv.classList.add("startDate");
                                    dateDiv.parentElement.classList.add("After");
                                }
                                else {
                                    dateDiv.classList.add("endDate");
                                    dateDiv.parentElement.classList.add("Before");
                                    this.EndDate = new Date(this.CurDate);
                                    this.EndDate = this.SetTimeValue(this.EndDate, time2, EndPMorAM);
                                    this.SelectDateFunction(this.EndDate, DayType._EndDate);
                                }
                                let currDay;
                                currDay = this.CurDate;
                                for (let i = 0; i < this.CalendarElement.querySelectorAll(".day").length; i++) {
                                    const item = this.CalendarElement.querySelectorAll(".day")[i];
                                    currDay.setDate(Number(EC_Fmt.CDec(item.textContent)));
                                    if ((currDay > this.StartDate) && (currDay < this.EndDate)) {
                                        item.parentElement.classList.add("pitch-on");
                                    }
                                }
                            }
                        }
                        else {
                            this.Clear();
                            this.StartDate = new Date(this.CurDate);
                            this.StartDate = this.SetTimeValue(this.StartDate, time1, StartPMorAM);
                            this.SelectDateFunction(this.StartDate, DayType._StartDate);
                            dateDiv.classList.add("startDate");
                            dateDiv.parentElement.classList.add("After");
                        }
                        break;
                    default:
                        this.Clear();
                        dateDiv.classList.add("selectedDate");
                        this.SelectDateFunction(this.CurDate, DayType._CurrDate);
                        if (this.DataType === ECP.DataType._Date) {
                            if (this.DisplayInputElement.getAttribute("inputchanged") === "true") {
                                this.CalendarElement.classList.add("animation-disappear-to-bottom");
                            }
                            else {
                                this.CalendarElement.classList.add("animation-disappear-to-top");
                            }
                        }
                        break;
                }
            }
        }
        DisPlaySubTab() {
            if (this.ForceExactRange && this.PickerType.toLowerCase() === "range") {
                return;
            }
            if (!this.CalendarElement.querySelector("ecp-tabs")) {
                const tabDate = document.createElement("div");
                tabDate.classList.add("HearDiv");
                tabDate.innerHTML = `<ecp-tabs class="ecp-body"><ecp-tab-item id="TabPeriod" ${this.SubTabValue === "Period" ? "selected" : ""}>Period</ecp-tab-item><ecp-tab-item id="TabCustom" ${this.SubTabValue === "Custom" ? "selected" : ""}>Custom</ecp-tab-item></ecp-tabs>`;
                this.CalendarElement.appendChild(tabDate);
                tabDate.querySelector("#TabPeriod").addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.SubTabValue = "Period";
                    this.SetPeriodValueFunction("", "");
                    this.DisplayCalendar();
                });
                tabDate.querySelector("#TabCustom").addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.SubTabValue = "Custom";
                    this.DisplayCalendar();
                });
            }
        }
        DisplayCalendarHeader() {
            if (this.ForceExactRange && this.PickerType.toLowerCase() === "range") {
                this.SelectorType = DatePickerType._Between;
                return;
            }
            const selectorDateType = document.createElement("div");
            selectorDateType.classList.add("HearDiv");
            selectorDateType.innerHTML = "<ecp-subtabs class=flex></ecp-subtabs>";
            selectorDateType.firstElementChild.innerHTML += "<ecp-subtab-item selected>Exactly</ecp-subtab-item>"
                + "<ecp-subtab-item>Before</ecp-subtab-item>"
                + "<ecp-subtab-item>After</ecp-subtab-item>"
                + "<ecp-subtab-item>Between</ecp-subtab-item>";
            selectorDateType.addEventListener("click", () => {
                this.SelectorType = selectorDateType.querySelector("ecp-subtab-item[selected]").textContent;
                if (this.SubTabValue === "Custom") {
                    this.SelectDateFunction(this.CurDate, this.SelectorType);
                }
                this.PositionFunction(this.CalendarElement);
                if (this.IncludeTime) {
                    const time2 = this.CalendarElement.querySelector("#time2").closest(".time");
                    if (this.SelectorType === "Between") {
                        time2.classList.remove("hide");
                    }
                    else if (!time2.classList.contains("hide")) {
                        time2.classList.add("hide");
                    }
                }
                this.DisplayCalendar();
            });
            if (this.SelectorType) {
                selectorDateType.querySelector("ecp-subtab-item[selected]").removeAttribute("selected");
                selectorDateType.querySelectorAll("ecp-subtab-item").forEach((item) => {
                    if (item.textContent === this.SelectorType) {
                        item.setAttribute("selected", "");
                    }
                });
            }
            this.CalendarElement.appendChild(selectorDateType);
        }
        DisplayTimeInput() {
            let htmlB = "";
            let hour;
            let minute;
            let endHour;
            let endMinute;
            let endIsAM = true;
            if (this.SelectorType === DatePickerType._Between && EC_Fmt.ChkDate(this.StartDate) && EC_Fmt.ChkDate(this.EndDate)) {
                hour = this.StartDate.getHours();
                minute = this.StartDate.getMinutes();
                endHour = this.EndDate.getHours();
                endMinute = this.EndDate.getMinutes();
                if (endHour >= 12) {
                    endIsAM = false;
                    if (endHour > 12) {
                        endHour -= 12;
                    }
                }
                else if (endHour <= 0) {
                    endHour = 12;
                }
            }
            else {
                hour = this.CurDate.getHours();
                minute = this.CurDate.getMinutes();
            }
            let AM = true;
            if (hour >= 12) {
                AM = false;
                if (hour > 12) {
                    hour -= 12;
                }
            }
            else if (hour <= 0) {
                hour = 12;
            }
            htmlB += `<div class="flex time"><div class=empty><input id=time1 style=background:var(--bg);height:32px;width:61px;text-align:center value=${this.FormatTime(hour + ":" + minute, true)}></div>`
                + `<div class=empty><select name=StartPMorAM style=background:var(--bg);width:56px;height:32px;padding:3px><option value=AM${AM ? " selected" : ""}>AM</option><option value=PM${AM ? "" : " selected"}>PM</option></select></div></div>`
                + `<div class="flex time hide"><div class=empty><input id=time2 style=background:var(--bg);height:32px;width:61px;text-align:center value=${this.FormatTime(endHour + ":" + endMinute, true)}></div>`
                + `<div class=empty><select name=EndPMorAM style=background:var(--bg);width:56px;height:32px;padding:3px><option value=AM${endIsAM ? " selected" : ""}>AM</option><option value=PM${endIsAM ? "" : " selected"}>PM</option></select></div></div>`
                + "</div></div>";
            const timeInput = document.createElement("div");
            timeInput.classList.add("flex");
            timeInput.classList.add("timeInputs");
            timeInput.innerHTML = htmlB;
            const time1 = timeInput.querySelector("#time1");
            const time2 = timeInput.querySelector("#time2");
            const StartPMorAM = timeInput.querySelector("select[name='StartPMorAM']");
            const EndPMorAM = timeInput.querySelector("select[name='EndPMorAM']");
            if (this.SelectorType === DatePickerType._Between) {
                time2.closest(".time").classList.remove("hide");
            }
            time1.addEventListener("change", () => {
                const isAM = StartPMorAM.value === "AM" ? true : false;
                time1.value = this.FormatTime(time1.value, isAM);
                let hour = EC_Fmt.CDec(time1.value.split(":")[0]);
                if (hour === 12 && isAM) {
                    hour = 0;
                }
                else if (!isAM && hour > 0 && hour < 12) {
                    hour += 12;
                }
                if (this.SelectorType === "Between" && this.StartDate) {
                    this.StartDate.setHours(hour);
                    this.StartDate.setMinutes(EC_Fmt.CDec(time1.value.split(":")[1]));
                    this.ChangeTimeFunction(this.StartDate, DayType._StartDate);
                }
                else if (this.CurDate) {
                    this.CurDate.setHours(hour);
                    this.CurDate.setMinutes(EC_Fmt.CDec(time1.value.split(":")[1]));
                    this.ChangeTimeFunction(this.CurDate);
                }
            });
            time2.addEventListener("change", () => {
                const isAM = EndPMorAM.value === "AM" ? true : false;
                time2.value = this.FormatTime(time2.value, isAM);
                let hour = EC_Fmt.CDec(time2.value.split(":")[0]);
                if (hour === 12 && isAM) {
                    hour = 0;
                }
                else if (!isAM && hour > 0 && hour < 12) {
                    hour += 12;
                }
                if (this.EndDate) {
                    this.EndDate.setHours(hour);
                    this.EndDate.setMinutes(EC_Fmt.CDec(time2.value.split(":")[1]));
                    this.ChangeTimeFunction(this.EndDate, DayType._EndDate);
                }
                if (time2.value) {
                    this.EndTime = time2.value + " " + EndPMorAM.value;
                }
            });
            StartPMorAM.addEventListener("change", () => {
                const isAM = StartPMorAM.value === "AM" ? true : false;
                const value = this.FormatTime(time1.value, isAM);
                let hour = EC_Fmt.CDec(value.split(":")[0]);
                if (hour === 12 && isAM) {
                    hour = 0;
                }
                else if (!isAM && hour > 0 && hour < 12) {
                    hour += 12;
                }
                if (this.SelectorType === "Between") {
                    if (this.StartDate) {
                        this.StartDate.setHours(hour);
                        this.StartDate.setMinutes(EC_Fmt.CDec(value.split(":")[1]));
                        this.ChangeTimeFunction(this.StartDate, DayType._StartDate);
                    }
                }
                else {
                    this.CurDate.setHours(hour);
                    this.CurDate.setMinutes(EC_Fmt.CDec(value.split(":")[1]));
                    this.ChangeTimeFunction(this.CurDate);
                }
            });
            EndPMorAM.addEventListener("change", () => {
                const isAM = EndPMorAM.value === "AM" ? true : false;
                const value = this.FormatTime(time2.value, isAM);
                let hour = EC_Fmt.CDec(value.split(":")[0]);
                if (hour === 12 && isAM) {
                    hour = 0;
                }
                else if (!isAM && hour > 0 && hour < 12) {
                    hour += 12;
                }
                if (this.EndDate) {
                    this.EndDate.setHours(hour);
                    this.EndDate.setMinutes(EC_Fmt.CDec(value.split(":")[1]));
                    this.ChangeTimeFunction(this.EndDate, DayType._EndDate);
                }
                if (time2.value) {
                    this.EndTime = time2.value + " " + EndPMorAM.value;
                }
            });
            this.CalendarElement.appendChild(timeInput);
            if (time2.value) {
                this.EndTime = time2.value + " " + EndPMorAM.value;
            }
        }
        DisplayMonthSelection() {
            const year = this.CurDate.getFullYear();
            this.CalendarElement.querySelector(".myCalendar").innerHTML = "<div>"
                + `<div class="flex year"><div class=Previous><span class=ews-icon-previouspage></span></div><div class=Title>${year}</div><div class=Next><span class=ews-icon-nextpage></span></div></div>`
                + "<div class='flex weeks'><span>S</span><span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span></div>"
                + "</div>"
                + "<div class=MonthView>"
                + `<div>`
                + ` <div month=0><div>${EC_Fmt.MonthNames[0].substring(0, 3)}</div></div>`
                + ` <div month=1><div>${EC_Fmt.MonthNames[1].substring(0, 3)}</div></div>`
                + ` <div month=2><div>${EC_Fmt.MonthNames[2].substring(0, 3)}</div></div>`
                + `</div>`
                + `<div>`
                + ` <div month=3><div>${EC_Fmt.MonthNames[3].substring(0, 3)}</div></div>`
                + ` <div month=4><div>${EC_Fmt.MonthNames[4].substring(0, 3)}</div></div>`
                + ` <div month=5><div>${EC_Fmt.MonthNames[5].substring(0, 3)}</div></div>`
                + `</div>`
                + `<div>`
                + ` <div month=6><div>${EC_Fmt.MonthNames[6].substring(0, 3)}</div></div>`
                + ` <div month=7><div>${EC_Fmt.MonthNames[7].substring(0, 3)}</div></div>`
                + ` <div month=8><div>${EC_Fmt.MonthNames[8].substring(0, 3)}</div></div>`
                + `</div>`
                + `<div>`
                + ` <div month=9><div>${EC_Fmt.MonthNames[9].substring(0, 3)}</div></div>`
                + ` <div month=10><div>${EC_Fmt.MonthNames[10].substring(0, 3)}</div></div>`
                + ` <div month=11><div>${EC_Fmt.MonthNames[11].substring(0, 3)}</div></div>`
                + `</div>`
                + `</div>`;
            this.PositionFunction(this.CalendarElement);
            this.CalendarElement.querySelector(".Previous").addEventListener("click", (e) => { e.stopPropagation(); this.PrevYear(); });
            this.CalendarElement.querySelector(".Title").addEventListener("click", (e) => { e.stopPropagation(); this.DisplayCalendar(); });
            this.CalendarElement.querySelector(".Next").addEventListener("click", (e) => { e.stopPropagation(); this.NextYear(); });
            const monthOptions = this.CalendarElement.querySelectorAll("div[month]");
            for (let i = 0; i < monthOptions.length; i++) {
                monthOptions[i].addEventListener("click", (e) => { e.stopPropagation(); this.SetMonth(e); });
            }
        }
        DisplayDateSelection() {
            const year = this.CurDate.getFullYear();
            const month = this.CurDate.getMonth();
            const today = new Date();
            const yearToDate = document.createElement("div");
            yearToDate.style.backgroundColor = "var(--bg-hover)";
            yearToDate.style.width = "100%";
            yearToDate.classList.add("myCalendar");
            yearToDate.innerHTML = `<div class="flex year"><div class=Previous><span class=ews-icon-previouspage></span></div><div class=Title>${EC_Fmt.MonthNames[month]} ${year}</div><div class="Next"><span class=ews-icon-nextpage></span></div></div>`
                + "<div class='flex weeks'><span>S</span><span>M</span><span>T</span><span>W</span><span>T</span><span>F</span><span>S</span></div>";
            this.calendar = document.createElement("div");
            this.calendar.classList.add("flex");
            this.calendar.classList.add("calendar");
            this.calendar.style.flexDirection = "column";
            this.calendar.style.backgroundColor = "var(--bg)";
            let firstDay = (new Date(year, month)).getDay();
            let lastDay = (new Date(year, month + 1, 0)).getDate();
            const daysInMonth = 32 - new Date(year, month, 32).getDate();
            const IsTodaysMonth = year === today.getFullYear() && month === today.getMonth();
            const IsSelectedMonth = year === this.SelectedDate.getFullYear() && month === this.SelectedDate.getMonth();
            const IsRefStartDateMonth = this.RefStartDate && year === this.RefStartDate.getFullYear() && month === this.RefStartDate.getMonth();
            let date = 1;
            let currentDate;
            for (let i = 0; i < 6; i++) {
                if (i === 5 && date > lastDay) {
                    break;
                }
                const row = document.createElement("div");
                row.classList.add("flex");
                for (let j = 0; j < 7; j++) {
                    if (i === 0 && j < firstDay || date > lastDay) {
                        const cell = document.createElement("div");
                        cell.classList.add("empty");
                        cell.classList.add("days");
                        row.appendChild(cell);
                    }
                    else if (date > daysInMonth) {
                        break;
                    }
                    else {
                        const contentDiv = document.createElement("div");
                        contentDiv.textContent = date.toString();
                        contentDiv.classList.add("day");
                        contentDiv.classList.add("motion-fast");
                        if (IsTodaysMonth && date === today.getDate()) {
                            contentDiv.classList.add("currentDate");
                        }
                        currentDate = new Date(year, month, date);
                        const cell = document.createElement("div");
                        cell.classList.add("days");
                        switch (this.SelectorType) {
                            case DatePickerType._Before:
                                if (IsSelectedMonth && date === this.SelectedDate.getDate()) {
                                    contentDiv.classList.add("selectedDate");
                                    cell.classList.add("Before");
                                }
                                if (this.SelectedDate && currentDate < this.SelectedDate) {
                                    cell.classList.add("pitch-on");
                                }
                                break;
                            case DatePickerType._After:
                                if (IsSelectedMonth && date === this.SelectedDate.getDate()) {
                                    contentDiv.classList.add("selectedDate");
                                    cell.classList.add("After");
                                }
                                if (this.SelectedDate && currentDate > this.SelectedDate) {
                                    cell.classList.add("pitch-on");
                                }
                                break;
                            case DatePickerType._Between:
                                if (this.StartDate && this.EndDate) {
                                    if (this.StartDate.getMonth() === month && date === this.StartDate.getDate()) {
                                        contentDiv.classList.add("startDate");
                                        cell.classList.add("After");
                                    }
                                    if (this.EndDate.getMonth() === month && date === this.EndDate.getDate()) {
                                        contentDiv.classList.add("endDate");
                                        cell.classList.add("Before");
                                    }
                                    if ((currentDate > this.StartDate) && (currentDate < this.EndDate) && !contentDiv.classList.contains("endDate")) {
                                        cell.classList.add("pitch-on");
                                    }
                                }
                                break;
                            default:
                                if (IsSelectedMonth && date === this.SelectedDate.getDate()) {
                                    contentDiv.classList.add("selectedDate");
                                }
                                else if (IsRefStartDateMonth && date === this.RefStartDate.getDate()) {
                                    contentDiv.classList.add("refStartDate");
                                }
                                break;
                        }
                        if (this.AllowStartDate || this.AllowEndDate) {
                            if ((this.AllowStartDate && currentDate < this.AllowStartDate) || (this.AllowEndDate && currentDate > this.AllowEndDate)) {
                                cell.classList.add("disabled");
                            }
                        }
                        if (this.ExcludeDates && this.ExcludeDates.length > 0) {
                            for (let k = 0; k < this.ExcludeDates.length; k++) {
                                const ExcludeDate = this.ExcludeDates[k];
                                if (ExcludeDate.getTime() === currentDate.getTime()) {
                                    cell.classList.add("disabled");
                                }
                            }
                        }
                        cell.appendChild(contentDiv);
                        row.appendChild(cell);
                        date++;
                    }
                }
                this.calendar.appendChild(row);
            }
            yearToDate.appendChild(this.calendar);
            this.calendar.addEventListener("click", this.ClickDateEvent);
            this.CalendarElement.appendChild(yearToDate);
            yearToDate.querySelector(".Previous").addEventListener("click", (e) => { e.stopPropagation(); this.PrevMonth(); });
            yearToDate.querySelector(".Title").addEventListener("click", (e) => { e.stopPropagation(); this.DisplayMonthSelection(); });
            yearToDate.querySelector(".Next").addEventListener("click", (e) => { e.stopPropagation(); this.NextMonth(); });
        }
        Clear() {
            const lastSelectedDay = this.CalendarElement.querySelector(".selectedDate");
            const startSelectedDay = this.CalendarElement.querySelector(".startDate");
            const endSelectedDay = this.CalendarElement.querySelector(".endDate");
            this.StartDate = null;
            this.EndDate = null;
            if (lastSelectedDay) {
                lastSelectedDay.classList.remove("selectedDate");
                lastSelectedDay.parentElement.classList.remove("After");
                lastSelectedDay.parentElement.classList.remove("Before");
            }
            if (startSelectedDay) {
                startSelectedDay.classList.remove("startDate");
                startSelectedDay.parentElement.classList.remove("After");
            }
            if (endSelectedDay) {
                endSelectedDay.classList.remove("endDate");
                endSelectedDay.parentElement.classList.remove("Before");
            }
            this.CalendarElement.querySelectorAll(".pitch-on").forEach((item) => {
                item.classList.remove("pitch-on");
            });
        }
        PrevMonth() {
            this.CurDate.setMonth(this.CurDate.getMonth() - 1, 1);
            this.ChangeYearAndMonthFunction(this.CurDate);
            this.DisplayCalendar();
        }
        NextMonth() {
            this.CurDate.setMonth(this.CurDate.getMonth() + 1, 1);
            this.ChangeYearAndMonthFunction(this.CurDate);
            this.DisplayCalendar();
        }
        PrevYear() {
            this.CurDate.setFullYear(this.CurDate.getFullYear() - 1);
            this.ChangeYearAndMonthFunction(this.CurDate);
            this.DisplayMonthSelection();
        }
        NextYear() {
            this.CurDate.setFullYear(this.CurDate.getFullYear() + 1);
            this.ChangeYearAndMonthFunction(this.CurDate);
            this.DisplayMonthSelection();
        }
        SetYear(event) {
            this.CurDate.setFullYear(EC_Fmt.CDec(event.currentTarget.textContent));
            this.ChangeYearAndMonthFunction(this.CurDate);
            this.DisplayMonthSelection();
        }
        SetMonth(event) {
            let month = EC_Fmt.CDec(event.currentTarget.getAttribute("month"));
            this.CurDate.setMonth(month, 1);
            this.ChangeYearAndMonthFunction(this.CurDate);
            this.DisplayCalendar();
        }
    }
    class DateSelector {
        constructor(name, id, SubTabValue, Required, Value, IncludeTime, PickerType, FieldTitle, TabIndex, Width, Placeholder, StartDate, EndDate, SelectorType, ExcludeDates, ForceExactRange, ChangeCallback) {
            this.Required = Required;
            this.IncludeTime = IncludeTime;
            this.PickerType = PickerType;
            this.DataType = IncludeTime ? ECP.DataType._DateTime : ECP.DataType._Date;
            this.SelectorType = SelectorType;
            this.SubTabValue = SubTabValue;
            this.ForceExactRange = ForceExactRange === true;
            if (this.IsForceFullRangeEnabled()) {
                this.SelectorType = DatePickerType._Between;
                this.SubTabValue = "Custom";
            }
            Value = EC_Fmt.Null2EmptyStr(Value);
            let Operator = EC_Fmt.get_searchOp(Value);
            if (EC_Fmt.ChkDate(Value) || Operator) {
                this.CurDate = EC_Fmt.ToDate(Value.replace(/^\s+|\s+$/g, "").replace(Operator, ""));
            }
            else if (this.SubTabValue !== "Custom") {
                this.SubTabValue = "Period";
            }
            this.RootHTMLElement = document.createElement("div");
            if (!EC_Fmt.isInteger(Width) || Width === 0) {
                Width = -1;
            }
            if (id == "") {
                id = name;
            }
            id = EC_Fmt.ReplaceAll(EC_Fmt.ReplaceAll(id, " ", ""), "\"", "");
            this.id = id;
            if (StartDate) {
                StartDate = StartDate.replace(/^\s+|\s+$/g, "");
                this.StartDate = EC_Fmt.ToDate(EC_Fmt.InputFmt(StartDate, this.DataType, 18, this.Required, true));
            }
            if (EndDate) {
                EndDate = EndDate.replace(/^\s+|\s+$/g, "");
                this.EndDate = EC_Fmt.ToDate(EC_Fmt.InputFmt(EndDate, this.DataType, 18, this.Required, true));
            }
            if (ExcludeDates) {
                const ExcludeDateArr = ExcludeDates.split(",");
                for (let i = 0; i < ExcludeDateArr.length; i++) {
                    const ExcludeDate = ExcludeDateArr[i];
                    if (EC_Fmt.ChkDate(ExcludeDate)) {
                        if (!this.ExcludeDates) {
                            this.ExcludeDates = [];
                        }
                        this.ExcludeDates.push(EC_Fmt.ToDate(ExcludeDate));
                    }
                }
            }
            this.PositionCalendar = this.PositionCalendar.bind(this);
            this.SelectDate = this.SelectDate.bind(this);
            this.ChangeTime = this.ChangeTime.bind(this);
            this.SetPeriodValue = this.SetPeriodValue.bind(this);
            this.ChangeYearAndMonth = this.ChangeYearAndMonth.bind(this);
            this.SetDisplayValue = this.SetDisplayValue.bind(this);
            this.ClickDateThisWeek = this.ClickDateThisWeek.bind(this);
            this.ClickDateThisMonth = this.ClickDateThisMonth.bind(this);
            this.RootHTMLElement.addEventListener("click", () => {
                AllowHideAllDivs = false;
            }, true);
            let [HiddenValue, DisplayValue] = ["", ""];
            if (this.SubTabValue === "Period") {
                [HiddenValue, DisplayValue] = this.SetPeriodValue(Value);
            }
            else {
                [HiddenValue, DisplayValue] = this.SetDisplayValue(Value);
            }
            HiddenValue = EC_Fmt.ReplaceAll(HiddenValue, "\"", "");
            DisplayValue = EC_Fmt.ReplaceAll(DisplayValue, "\"", "");
            name = EC_Fmt.ReplaceAll(name, "\"", "'");
            TabIndex = EC_Fmt.ReplaceAll(TabIndex, "\"", "");
            FieldTitle = EC_Fmt.ReplaceAll(FieldTitle, "\"", "'");
            Placeholder = EC_Fmt.ReplaceAll(Placeholder, "\"", "'");
            this.RootHTMLElement.classList.add("DatePickerField", "NoPadding");
            this.RootHTMLElement.style.width = Width < 0 ? "100%" : `${Width}px`;
            this.RootHTMLElement.innerHTML = `<div class="flex input-border" style=flex-wrap:nowrap><label class=label-inline></label><div style=flex:1 valign=top>`
                + `<input ${name ? "name=" : ""}"${name}" value="${HiddenValue}"type=hidden>`
                + `<input type=text class=DatePickerInput style=width:100% encreq=${Required.toString()} tabindex="${TabIndex}"value="${DisplayValue}"title="${FieldTitle}"alias="${FieldTitle}"placeholder="${Placeholder}"autocomplete=off>`
                + "</div>"
                + "<div class=icon-box>"
                + `<span class=ews-icon-calendar></span>`
                + `<icon class="ews-icon-close hidden"></icon>`
                + "</div></div>";
            this.DisplayInput = this.RootHTMLElement.querySelector(`input[type="text"]`);
            this.HiddenInput = this.RootHTMLElement.querySelector(`input[type="hidden"]`);
            this.DisplayInput.addEventListener("focus", (e) => {
                this.RootHTMLElement.classList.add("AutocompleteActive");
            });
            this.DisplayInput.addEventListener("change", () => {
                if (this.CurDate) {
                    this.CurDate = undefined;
                }
                const isDate = EC_Fmt.ChkDate(this.DisplayInput.value) ? EC_Fmt.ChkDate(this.DisplayInput.value) : EC_Fmt.isNull(this.HiddenInput.value);
                const Operator = EC_Fmt.get_searchOp(this.DisplayInput.value) || (EC_Fmt.Left(this.DisplayInput.value, 6).toLowerCase() === "before" ? "before" : (EC_Fmt.Left(this.DisplayInput.value, 5).toLowerCase() === "after" ? "after" : ""));
                if (this.SubTabValue !== "Period" || isDate || Operator) {
                    if (!this.DisplayInput.value) {
                        this.PickerStartDate = null;
                    }
                    if (!this.IsForceFullRangeEnabled() && Operator === "" && this.SelectorType !== DatePickerType._Exactly && EC_Fmt.ChkDate(this.DisplayInput.value)) {
                        this.SelectorType = DatePickerType._Exactly;
                        if (this.Calendar) {
                            this.Calendar.SelectorType = DatePickerType._Exactly;
                        }
                    }
                    this.SetDisplayValue(this.DisplayInput.value);
                }
                else {
                    this.SetPeriodValue(Period[this.DisplayInput.value]);
                }
                if (typeof this.NotifyChangeCallback === "function") {
                    this.NotifyChangeCallback();
                }
            });
            this.DisplayInput.addEventListener("blur", (e) => {
                this.RootHTMLElement.classList.remove("AutocompleteActive");
            });
            const closeCalendarOnFocusOut = (e) => {
                const relatedTarget = e.relatedTarget;
                if (!this.Calendar || !EC_Fmt.isVisible(this.Calendar.CalendarElement)) {
                    return;
                }
                if (!relatedTarget || this.RootHTMLElement.contains(relatedTarget) || this.Calendar.CalendarElement.contains(relatedTarget)) {
                    return;
                }
                if (this.DisplayInput.getAttribute("inputchanged") === "true") {
                    this.Calendar.CalendarElement.classList.add("animation-disappear-to-bottom");
                }
                else {
                    this.Calendar.CalendarElement.classList.add("animation-disappear-to-top");
                }
            };
            this.RootHTMLElement.addEventListener("focusout", closeCalendarOnFocusOut);
            this.DisplayInput.addEventListener("keyup", (e) => {
                if (this.SubTabValue === "Period" && this.Calendar) {
                    const PeriodBox = this.Calendar.CalendarElement.querySelector(".PeriodBox");
                    const EmptyState = PeriodBox.querySelector(".Period-EmptyState");
                    if (this.DisplayInput.value && this.DisplayInput.value !== DisplayValue) {
                        const PeriodList = PeriodBox.querySelectorAll(".Period-item");
                        const HideList = PeriodBox.querySelectorAll(".hide");
                        const CommonList = PeriodBox.querySelectorAll(".Common");
                        if (CommonList) {
                            for (let i = 0; i < CommonList.length; i++) {
                                CommonList[i].classList.add("hide");
                            }
                        }
                        if (HideList) {
                            for (let i = 0; i < HideList.length; i++) {
                                if (!HideList[i].classList.contains("Common")) {
                                    HideList[i].classList.remove("hide");
                                }
                            }
                        }
                        if (PeriodList) {
                            for (let i = 0; i < PeriodList.length; i++) {
                                if (PeriodList[i].firstChild.textContent.toLowerCase().indexOf(this.DisplayInput.value.toLowerCase()) < 0) {
                                    PeriodList[i].classList.add("hide");
                                }
                            }
                        }
                        const CategoryTitles = PeriodBox.querySelectorAll(".Period-Title:not(.Common)");
                        let visibleCategoryCount = 0;
                        for (let i = 0; i < CategoryTitles.length; i++) {
                            const title = CategoryTitles[i];
                            let hasVisibleItem = false;
                            const spacers = [];
                            let sibling = title.nextElementSibling;
                            while (sibling && !sibling.classList.contains("Period-Title")) {
                                if (sibling.classList.contains("Period-item") && !sibling.classList.contains("hide")) {
                                    hasVisibleItem = true;
                                }
                                if (sibling.classList.contains("Period-Empty")) {
                                    spacers.push(sibling);
                                }
                                sibling = sibling.nextElementSibling;
                            }
                            title.classList.toggle("hide", !hasVisibleItem);
                            for (let j = 0; j < spacers.length; j++) {
                                spacers[j].classList.toggle("hide", !hasVisibleItem);
                            }
                            if (hasVisibleItem) {
                                visibleCategoryCount++;
                            }
                        }
                        if (EmptyState) {
                            EmptyState.classList.toggle("hide", visibleCategoryCount > 0);
                        }
                    }
                    else if (!this.DisplayInput.value) {
                        const AllPeriodElements = PeriodBox.querySelectorAll(".Period-item, .Period-Title, .Period-Empty");
                        for (let i = 0; i < AllPeriodElements.length; i++) {
                            AllPeriodElements[i].classList.remove("hide");
                        }
                        if (EmptyState) {
                            EmptyState.classList.add("hide");
                        }
                    }
                    const calendarRect = this.Calendar.CalendarElement.getBoundingClientRect();
                    const displayPosition = this.RootHTMLElement.getBoundingClientRect();
                    if (calendarRect.top < displayPosition.top) {
                        this.Calendar.CalendarElement.style.top = `${displayPosition.top - this.Calendar.CalendarElement.offsetHeight - 8}px`;
                    }
                    AllowHideAllDivs = false;
                }
            });
            this.CalendarIcon = this.RootHTMLElement.querySelector(".ews-icon-calendar");
            const inputBorder = this.RootHTMLElement.querySelector(".input-border");
            inputBorder.addEventListener("click", () => {
                if (this.Calendar && EC_Fmt.isVisible(this.Calendar.CalendarElement)) {
                    if (this.DisplayInput.getAttribute("inputchanged") === "true") {
                        this.Calendar.CalendarElement.classList.add("animation-disappear-to-bottom");
                    }
                    else {
                        this.Calendar.CalendarElement.classList.add("animation-disappear-to-top");
                    }
                }
                else {
                    if (!this.CurDate) {
                        this.CurDate = new Date();
                    }
                    AllowHideAllDivs = false;
                    if (this.SelectorType === DatePickerType._Between && this.StartDate) {
                        this.CurDate = this.PickerStartDate;
                    }
                    if (!this.Calendar) {
                        this.Calendar = new Calendar(this.CurDate, this.IncludeTime, this.PickerType, this.SubTabValue, this.PositionCalendar, this.SelectDate, this.ChangeYearAndMonth, this.ChangeTime, this.SetPeriodValue, this.PeriodValue, this.id, this.DisplayInput, this.PickerStartDate, this.PickerEndDate, this.StartDate, this.EndDate, this.SelectorType, this.ExcludeDates, this.ForceExactRange);
                        this.Calendar.CalendarElement.addEventListener("focusout", closeCalendarOnFocusOut);
                    }
                    else {
                        this.Calendar.CurDate = new Date(this.CurDate);
                        this.Calendar.SelectedDate = new Date(this.CurDate);
                        this.Calendar.SelectorType = this.SelectorType;
                        this.Calendar.SubTabValue = this.SubTabValue;
                        this.Calendar.ForceExactRange = this.ForceExactRange;
                        if (this.IsForceFullRangeEnabled()) {
                            this.Calendar.SelectorType = DatePickerType._Between;
                            this.Calendar.SubTabValue = "Custom";
                        }
                        this.Calendar.StartDate = this.PickerStartDate && new Date(this.PickerStartDate);
                        this.Calendar.EndDate = this.PickerEndDate && new Date(this.PickerEndDate);
                        this.Calendar.AllowStartDate = this.StartDate && new Date(this.StartDate);
                        this.Calendar.AllowEndDate = this.EndDate && new Date(this.EndDate);
                    }
                    this.Calendar.DisplayCalendar();
                }
            });
            this.ChangeCallback = ChangeCallback;
            if (HiddenValue !== Value && this.ChangeCallback) {
                this.ChangeCallback(HiddenValue);
            }
        }
        IsForceFullRangeEnabled() {
            return this.ForceExactRange && this.PickerType === "range";
        }
        SetPeriodValue(PeriodHiddenValue) {
            if (this.DisplayInput) {
                this.SubTabValue = "Period";
                if (PeriodHiddenValue) {
                    this.DisplayInput.value = PeriodHiddenValue ? Period[PeriodHiddenValue] : PeriodHiddenValue;
                    this.DisplayInput.setAttribute("value", this.DisplayInput.value);
                    this.HiddenInput.value = PeriodHiddenValue;
                }
                else {
                    this.DisplayInput.value = "";
                    this.DisplayInput.setAttribute("value", "");
                    this.HiddenInput.value = "";
                }
                this.DisplayInput.setAttribute("haschangevalue", "true");
                if (EC_Fmt.CDec(this.oldHiddenValue) !== EC_Fmt.CDec(PeriodHiddenValue)) {
                    this.DisplayInput.setAttribute("inputchanged", "true");
                    if (this.Calendar && EC_Fmt.isVisible(this.Calendar.CalendarElement)) {
                        this.Calendar.CalendarElement.setAttribute("inputchanged", "true");
                    }
                }
            }
            AllowHideAllDivs = false;
            this.PeriodValue = PeriodHiddenValue;
            if (typeof this.ChangeCallback === "function" && EC_Fmt.CDec(this.oldHiddenValue) !== EC_Fmt.CDec(PeriodHiddenValue)) {
                this.oldHiddenValue = PeriodHiddenValue;
                this.ChangeCallback(PeriodHiddenValue);
            }
            return [PeriodHiddenValue, Period[PeriodHiddenValue]];
        }
        SetDisplayValue(value) {
            let DisplayValue = "";
            let HiddenValue = "";
            if (this.Calendar && this.Calendar.SelectorType) {
                this.SelectorType = this.Calendar.SelectorType;
            }
            let Operator = EC_Fmt.get_searchOp(value);
            if (this.IsForceFullRangeEnabled() || (Operator && Operator === "><" && value.indexOf("^") > -1) || (value && value.indexOf(" to ") > -1)) {
                this.SelectorType = DatePickerType._Between;
            }
            else if (Operator && (Operator === ">" || Operator === ">=")) {
                this.SelectorType = DatePickerType._After;
            }
            else if (Operator && (Operator === "<" || Operator === "<=")) {
                this.SelectorType = DatePickerType._Before;
            }
            else {
                Operator = "";
            }
            if (value) {
                value = value.replace(/^\s+|\s+$/g, "");
                if (this.SelectorType === DatePickerType._Between) {
                    value = value.replace("><", "");
                    let startTime;
                    let endTime;
                    if (value.indexOf("^") >= 0) {
                        startTime = value.split("^")[0];
                        endTime = value.split("^")[1];
                    }
                    else {
                        startTime = value.split(" to ")[0];
                        endTime = value.split(" to ")[1];
                    }
                    this.PickerStartDate = EC_Fmt.ToDate(EC_Fmt.InputFmt(startTime, this.DataType, 18, this.Required, true));
                    this.PickerEndDate = EC_Fmt.ToDate(EC_Fmt.InputFmt(endTime, this.DataType, 18, this.Required, true));
                }
                else {
                    this.CurDate = EC_Fmt.ToDate(EC_Fmt.InputFmt(value, this.DataType, 18, this.Required, true));
                    if (this.Calendar) {
                        this.Calendar.CurDate = this.CurDate;
                    }
                }
                switch (value.toUpperCase()) {
                    case "IS NULL":
                    case "NULL":
                        value = "IS NULL";
                        break;
                    case "NOT IS NULL":
                    case "NOT NULL":
                    case "IS NOT NULL":
                        value = "NOT IS NULL";
                }
            }
            this.SubTabValue = "Custom";
            if (value && value.toUpperCase() === "IS NULL" || value === "NOT IS NULL") {
                DisplayValue = EC_Fmt.ScreenFmt(value, this.DataType);
                HiddenValue = EC_Fmt.ScreenFmt(value, this.DataType);
            }
            else {
                switch (this.SelectorType) {
                    case DatePickerType._Exactly:
                        DisplayValue = EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                        HiddenValue = EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                        break;
                    case DatePickerType._After:
                        if (this.CurDate) {
                            DisplayValue = (Operator ? Operator : "After ") + EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                            HiddenValue = (Operator ? Operator : ">") + EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                        }
                        break;
                    case DatePickerType._Before:
                        if (this.CurDate) {
                            DisplayValue = (Operator ? Operator : "Before ") + EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                            HiddenValue = (Operator ? Operator : "<") + EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                        }
                        break;
                    case DatePickerType._Between:
                        if (this.PickerStartDate && this.DataType) {
                            if (!this.PickerEndDate) {
                                this.PickerEndDate = new Date(this.PickerStartDate);
                            }
                            if (!value && this.Calendar && this.Calendar.EndTime) {
                                const endTimeArr = this.Calendar.EndTime.split(" ");
                                if (endTimeArr.length == 2) {
                                    let hour = EC_Fmt.CDec(endTimeArr[0].split(":")[0]);
                                    const isAM = endTimeArr[1] === "AM";
                                    if (hour === 12 && isAM) {
                                        hour = 0;
                                    }
                                    else if (!isAM && hour > 0 && hour < 12) {
                                        hour += 12;
                                    }
                                    this.PickerEndDate.setHours(hour);
                                    this.PickerEndDate.setMinutes(EC_Fmt.CDec(endTimeArr[0].split(":")[1]));
                                }
                                else {
                                    this.PickerEndDate = null;
                                }
                            }
                            if (this.PickerEndDate) {
                                DisplayValue = EC_Fmt.ScreenFmt(this.PickerStartDate, this.DataType) + " to " + EC_Fmt.ScreenFmt(this.PickerEndDate, this.DataType);
                                HiddenValue = (Operator ? Operator : "><") + EC_Fmt.ScreenFmt(this.PickerStartDate, this.DataType) + "^" + EC_Fmt.ScreenFmt(this.PickerEndDate, this.DataType);
                            }
                            else {
                                DisplayValue = "";
                                HiddenValue = "";
                            }
                        }
                        break;
                    default:
                        DisplayValue = EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                        HiddenValue = EC_Fmt.ScreenFmt(this.CurDate, this.DataType);
                        break;
                }
            }
            if (this.DisplayInput) {
                this.DisplayInput.value = DisplayValue;
                this.DisplayInput.setAttribute("value", DisplayValue);
                this.HiddenInput.value = HiddenValue;
                this.RootHTMLElement.classList.add("AutocompleteActive");
                setTimeout(() => {
                    this.RootHTMLElement.classList.remove("AutocompleteActive");
                }, 260);
                if (this.oldHiddenValue !== HiddenValue) {
                    this.DisplayInput.setAttribute("inputchanged", "true");
                    if (this.Calendar && EC_Fmt.isVisible(this.Calendar.CalendarElement)) {
                        this.Calendar.CalendarElement.setAttribute("inputchanged", "true");
                    }
                }
                this.DisplayInput.setAttribute("haschangevalue", "true");
            }
            AllowHideAllDivs = false;
            if (typeof this.ChangeCallback === "function" && this.oldHiddenValue !== HiddenValue) {
                this.oldHiddenValue = HiddenValue;
                this.ChangeCallback(HiddenValue);
            }
            return [HiddenValue, DisplayValue];
        }
        PositionCalendar(calendar) {
            const activeElement = document.activeElement;
            if (activeElement && activeElement !== this.DisplayInput && !this.RootHTMLElement.contains(activeElement) && !this.Calendar.CalendarElement.contains(activeElement)) {
                this.DisplayInput.focus();
            }
            if (calendar === this.Calendar.CalendarElement) {
                const displayPosition = this.RootHTMLElement.getBoundingClientRect();
                calendar.style.top = `${displayPosition.height + displayPosition.top + 8}px`;
                calendar.style.left = `${displayPosition.left}px`;
            }
            else {
                const displayPosition = this.Calendar.CalendarElement.getBoundingClientRect();
                calendar.style.top = `${displayPosition.top}px`;
                calendar.style.left = `${displayPosition.width + displayPosition.left}px`;
            }
            calendar.style.display = "block";
            requestAnimationFrame(() => {
                calendar.classList.add("animation-appear-from-top");
                const calendarRect = calendar.getBoundingClientRect();
                if (calendarRect.left + calendar.offsetWidth > window.innerWidth) {
                    calendar.style.left = `${window.innerWidth - calendar.offsetWidth}px`;
                    if (calendar !== this.Calendar.CalendarElement) {
                        const calendar1Rect = this.Calendar.CalendarElement.getBoundingClientRect();
                        this.Calendar.CalendarElement.style.left = `${window.innerWidth - calendarRect.width - calendar1Rect.width}px`;
                    }
                }
                if (calendarRect.top + calendar.offsetHeight > window.innerHeight) {
                    if (calendar === this.Calendar.CalendarElement) {
                        const displayPosition = this.RootHTMLElement.getBoundingClientRect();
                        if (displayPosition.top - 8 >= calendar.offsetHeight) {
                            calendar.style.top = `${displayPosition.top - calendar.offsetHeight - 8}px`;
                        }
                        else {
                            calendar.style.top = `${Math.max(0, window.innerHeight - calendar.offsetHeight)}px`;
                        }
                    }
                    else {
                        calendar.style.top = `${Math.max(0, window.innerHeight - calendar.offsetHeight)}px`;
                    }
                }
            });
        }
        SelectDate(newDate, DateType) {
            this.CurDate = new Date(newDate);
            switch (DateType) {
                case DayType._StartDate:
                    this.PickerStartDate = new Date(newDate);
                    break;
                case DayType._EndDate:
                    this.PickerEndDate = newDate ? new Date(newDate) : null;
                    break;
                case DayType._CurrDate:
                    this.CurDate = new Date(newDate);
                    break;
                default:
                    this.CurDate = new Date(newDate);
                    break;
            }
            this.SetDisplayValue();
        }
        ChangeYearAndMonth(newDate) {
            if (this.CurDate) {
                this.CurDate.setFullYear(newDate.getFullYear());
                this.CurDate.setMonth(newDate.getMonth());
            }
        }
        ChangeTime(newDate, DateType) {
            if (!this.PickerStartDate) {
                this.PickerStartDate = new Date();
            }
            if (!this.PickerEndDate) {
                this.PickerEndDate = new Date();
            }
            switch (DateType) {
                case DayType._StartDate:
                    this.PickerStartDate.setHours(newDate.getHours());
                    this.PickerStartDate.setMinutes(newDate.getMinutes());
                    break;
                case DayType._EndDate:
                    this.PickerEndDate.setHours(newDate.getHours());
                    this.PickerEndDate.setMinutes(newDate.getMinutes());
                    break;
                case DayType._CurrDate:
                    this.CurDate.setHours(newDate.getHours());
                    this.CurDate.setMinutes(newDate.getMinutes());
                    break;
                default:
                    this.CurDate.setHours(newDate.getHours());
                    this.CurDate.setMinutes(newDate.getMinutes());
                    break;
            }
            this.SetDisplayValue();
        }
        SetDate(Calendar, date) {
            if (Calendar.CurDate.getFullYear() != date.getFullYear() || Calendar.CurDate.getMonth() != date.getMonth()) {
                Calendar.CurDate.setFullYear(date.getFullYear());
                Calendar.CurDate.setMonth(date.getMonth());
                Calendar.DisplayCalendar();
            }
            const cells = Calendar.calendar.getElementsByTagName("div");
            const day = date.getDate().toString();
            for (let i = 0, len = cells.length; i < len; i++) {
                if (cells[i].textContent === day) {
                    Calendar.ClickDate(cells[i], date.getDate());
                    break;
                }
            }
        }
        ClickDateThisWeek() {
            const today = new Date();
            const SundayOfThisWeek = new Date(today.setDate(today.getDate() - today.getDay()));
            SundayOfThisWeek.setHours(0, 0, 0, 0);
            const SaturdayOfThisWeek = new Date(SundayOfThisWeek);
            SaturdayOfThisWeek.setDate(SundayOfThisWeek.getDate() + 6);
            SaturdayOfThisWeek.setHours(23, 59, 59, 0);
            this.ChangeTime(SundayOfThisWeek);
            this.SetDate(this.Calendar, SundayOfThisWeek);
        }
        ClickDateThisMonth() {
            const today = new Date();
            const FirstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            FirstDayOfMonth.setHours(0, 0, 0, 0);
            const LastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            LastDayOfMonth.setHours(23, 59, 59, 0);
            this.ChangeTime(FirstDayOfMonth);
            this.SetDate(this.Calendar, FirstDayOfMonth);
        }
    }
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPFilterChip = class ECPFilterChip extends ECP.Component {
        created(host) {
            host.querySelector(".close-icon").addEventListener("click", () => {
                this.$emit("remove");
                this.remove();
            });
        }
        labelChanged(oldValue, newValue) {
            this.shadowRoot.querySelector(".filter-field").innerHTML = `${newValue}:`;
        }
        valueChanged(oldValue, newValue) {
            this.shadowRoot.querySelector(".filter-value").innerHTML = newValue;
        }
        isNotChanged(oldValue, newValue) {
            const filterNot = this.shadowRoot.querySelector(".filter-not");
            if (newValue) {
                filterNot.style.display = "block";
            }
            else {
                filterNot.style.display = "none";
            }
        }
        notClosableChanged(oldValue, newValue) {
            const closeIcon = this.shadowRoot.querySelector(".ews-icon-close");
            if (newValue) {
                closeIcon.style.display = "none";
            }
            else {
                closeIcon.style.display = "";
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPFilterChip.prototype, "label", void 0);
    __decorate([
        ECP.attr
    ], ECPFilterChip.prototype, "value", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPFilterChip.prototype, "isNot", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPFilterChip.prototype, "notClosable", void 0);
    ECPFilterChip = __decorate([
        ECP.customElement({
            name: "ecp-filter-chip",
            enableIcon: true,
            styles: `
.filter-chip{
display:flex;
height:32px;
background:var(--bg-selected);
padding:5px 12px;
border-radius:4px;
border:1px solid var(--border-selected);
box-sizing:border-box;
color:var(--text);
line-height:1
}
.filter-chip label{
height:20px;
line-height:20px
}
.filter-field{
white-space:nowrap
}
.filter-not{
margin-left:4px;
color:var(--text-error);
font-weight:700;
display:none
}
.filter-value{
margin-left:4px;
max-width:240px;
overflow:hidden;
text-overflow:ellipsis;
white-space:nowrap;
font-weight:700
}
.close-icon{
cursor:pointer;
padding:4px 0 4px 4px;
margin-left:6px;
font-size:12px !important;
color:var(--text-secondary)
}
:host{
display:inline-block
}
`,
            template: `<div class=filter-chip>
<label class=filter-field></label>
<label class=filter-not>NOT</label>
<label class=filter-value></label>
<i class="close-icon ews-icon-close"></i>
</div>`
        })
    ], ECPFilterChip);
    ECP.ECPFilterChip = ECPFilterChip;
    if (!window.customElements.get("ecp-filterbar")) {
        let FilterBarHTMLTemplate = "";
        class FilterBarWebComponent extends HTMLElement {
            constructor() {
                super();
                if (FilterBarHTMLTemplate === "") {
                    FilterBarHTMLTemplate = `<div>`
                        + `<div class="ecp-filter filterBar">`
                        + ` <div class=filter-top>`
                        + `  <div class=section-width>`
                        + `   <div class=top-main>`
                        + `    <ecp-btn type=ghost id=moreFiltersButton style="order:10;margin:4px 0">More filters...</ecp-btn>`
                        + `    <ecp-btn type=ghost id=filterResetButton style="order:11;margin:4px 0 4px 10px;display:none">Reset filters</ecp-btn>`
                        + `   </div>`
                        + `  </div>`
                        + ` </div>`
                        + `</div>`
                        + `<div class="ecp-filter moreFilter">`
                        + ` <div class=filter-top>`
                        + `  <div class=top-main></div>`
                        + `  <ecp-input type=text icon=ews-icon-search placeholder="Search filters"></ecp-input>`
                        + ` </div>`
                        + ` <div class="filter-bottom">`
                        + `  <div class="filter-bottom-content section-width">`
                        + `   <div class=scroll-section></div>`
                        + `  </div>`
                        + ` </div>`
                        + ` <ecp-empty illustration=search class=hidden>`
                        + `  <ecp-empty-title>No filter found</ecp-empty-title>`
                        + `  <ecp-empty-body>Try adjusting your search or filter options to find what you're looking for</ecp-empty-body>`
                        + ` </ecp-empty>`
                        + `</div>`
                        + `<div class=renderTemplate>`
                        + ` <div class=data-item>`
                        + `  <div class=data-title></div>`
                        + `  <div class=data-content></div>`
                        + ` </div>`
                        + ` <div class=filter-section>`
                        + `  <div class="filter-type filter-toggle">`
                        + `   <span class=type-text></span>`
                        + `   <span class="toggle-icon ews-icon-emcaretdown transform"></span>`
                        + `  </div>`
                        + `  <div class=data-form></div>`
                        + ` </div>`
                        + `</div>`
                        + `</div>`;
                }
                const filterBarTemplate = EC_Fmt.HtmlStrToElement(FilterBarHTMLTemplate);
                this.filterTemplate = filterBarTemplate.querySelector(".renderTemplate");
                this.filterBar = filterBarTemplate.querySelector(".ecp-filter.filterBar");
                this.moreFilter = filterBarTemplate.querySelector(".ecp-filter.moreFilter");
            }
            get filterData() {
                return this.getAttribute("filterdata");
            }
            get defaultParameter() {
                return this.getAttribute("defaultparameter");
            }
            get applyFilterCallBack() {
                return this.getAttribute("applyfiltercallback");
            }
            get removeSelectedFilterCallBack() {
                return this.getAttribute("removeselectedfiltercallback");
            }
            get resetFilterCallBack() {
                return this.getAttribute("resetfiltercallback");
            }
            connectedCallback() {
                if (this.filterData) {
                    this.initFilterBar(this.filterData, this.applyFilterCallBack, this.removeSelectedFilterCallBack);
                }
                else if (!this.isDefaultFilterBar) {
                    this.initCustomFilterBar(this.firstElementChild, this.applyFilterCallBack, this.removeSelectedFilterCallBack, this.resetFilterCallBack);
                }
            }
            disconnectedCallback() {
                if (this.moreFilterDialog) {
                    this.moreFilterDialog.remove();
                }
            }
            initCallBack(_ApplyFilterCallBack, _RemoveSelectedFilterCallBack, _ResetFilterCallBack) {
                if (_ApplyFilterCallBack) {
                    if (!(_ApplyFilterCallBack instanceof Function)) {
                        const actionFn = new Function(_ApplyFilterCallBack);
                        _ApplyFilterCallBack = actionFn();
                    }
                    if (_ApplyFilterCallBack instanceof Function) {
                        this.onApply = _ApplyFilterCallBack;
                    }
                }
                if (_RemoveSelectedFilterCallBack) {
                    if (!(_RemoveSelectedFilterCallBack instanceof Function)) {
                        const actionFn = new Function(_RemoveSelectedFilterCallBack);
                        _RemoveSelectedFilterCallBack = actionFn();
                    }
                    if (_RemoveSelectedFilterCallBack instanceof Function) {
                        this.onRemoveSelectedFilter = _RemoveSelectedFilterCallBack;
                    }
                }
                if (_ResetFilterCallBack) {
                    if (!(_ResetFilterCallBack instanceof Function)) {
                        const actionFn = new Function(_ResetFilterCallBack);
                        _ResetFilterCallBack = actionFn();
                    }
                    if (_ResetFilterCallBack instanceof Function) {
                        this.onReset = _ResetFilterCallBack;
                    }
                }
            }
            async initFilterBar(_FilterData, _ApplyFilterCallBack, _RemoveSelectedFilterCallBack) {
                if (!(_FilterData instanceof Array)) {
                    const actionFn = new Function(_FilterData);
                    _FilterData = actionFn();
                }
                if (!(_FilterData instanceof Array)) {
                    throw new Error("Invalid Filter Bar setup");
                }
                for (let i = 0; i < _FilterData.length; i++) {
                    const item = _FilterData[i];
                    if (!EC_Fmt.isNull(item.DataType)) {
                        item.DataType = ECP.DataType[item.DataType];
                    }
                    if (!EC_Fmt.isNull(item.RefFieldDisplayDataType)) {
                        item.RefFieldDisplayDataType = ECP.DataType[item.RefFieldDisplayDataType];
                    }
                }
                this.isDefaultFilterBar = true;
                this._FilterData = _FilterData;
                this.appendChild(this.filterBar);
                this.initCallBack(_ApplyFilterCallBack, _RemoveSelectedFilterCallBack);
                if (this.lazyLoad) {
                    this.writeFilterBar_LazyLoad();
                }
                else {
                    await this.writeMoreFilter();
                    this.writeMoreFilterDialog();
                    this.initialFormData = this.getInitialFormData();
                    this.writeFilterBar();
                }
                this.addEventToFilterBar();
            }
            initCustomFilterBar(_CustomContent, _ApplyFilterCallBack, _RemoveSelectedFilterCallBack, _ResetFilterCallBack) {
                if (_CustomContent instanceof HTMLElement) {
                    this.moreFilter.querySelector(".scroll-section").appendChild(_CustomContent);
                }
                this.isDefaultFilterBar = false;
                this.hasCenteredCustomMoreFilterDialog = false;
                this.appendChild(this.filterBar);
                this.initCallBack(_ApplyFilterCallBack, _RemoveSelectedFilterCallBack, _ResetFilterCallBack);
                this.writeMoreFilterDialog();
                this.writeFilterBar();
                this.addEventToFilterBar();
            }
            async processData(data, useParameters) {
                const FilterData = [];
                const myRequest = new ECP.EC_Request("FilterBar_GetFilterItemHTML");
                myRequest.AddRequestVariable("FilterData", JSON.stringify(data), ECP.EC_Verb.Post);
                if (useParameters) {
                    myRequest.AddRequestVariable("Parameters", decodeURIComponent(EC_Fmt.Null2EmptyStr(this.parameters)));
                }
                let FilterHTMLData;
                try {
                    FilterHTMLData = await myRequest.Submit();
                }
                catch (error) {
                    ECP.Dialog.Alert(error.message);
                    throw error;
                }
                let categoryArr = new Set();
                for (let i = 0; i < data.length; i++) {
                    const item = data[i];
                    item.ItemHTML = EC_Fmt.Null2EmptyStr(FilterHTMLData[i]);
                    categoryArr.add(EC_Fmt.Null2EmptyStr(item.Category));
                }
                categoryArr = Array.from(categoryArr);
                for (let i = 0; i < categoryArr.length; i++) {
                    const myFilterData = {
                        Category: categoryArr[i],
                        FilterItemData: []
                    };
                    const filterItemData = data.filter((f) => EC_Fmt.Null2EmptyStr(f.Category) === categoryArr[i]);
                    filterItemData.map(f => myFilterData.FilterItemData.push(f));
                    FilterData.push(myFilterData);
                }
                return FilterData;
            }
            writeFilterBar() {
                const me = this;
                me.filterBar.querySelectorAll(".selected-filter").forEach(item => item.remove());
                me.moreFilter.querySelectorAll(".top-main .selected-filter").forEach(item => item.remove());
                if (me.initialFormData && me.initialFormData.formData && me.initialFormData.formData.length > 0) {
                    me.initialFormData.formData.forEach((data) => {
                        me.setSelectedFilter(data.fieldName, data.fieldValue, data.fieldAlias, data.fieldDisplayValue);
                        me.setSelectedFilter(data.fieldName, data.fieldValue, data.fieldAlias, data.fieldDisplayValue, me.moreFilter.querySelector(".top-main"));
                    });
                }
                else {
                    me.filterBar.querySelector(".top-main").appendChild(EC_Fmt.HtmlStrToElement("<div class=\"selected-filter noFilter\">No filters applied</div>"));
                }
                const filterResetButton = me.filterBar.querySelector("#filterResetButton");
                if (filterResetButton) {
                    filterResetButton.style.display = "none";
                }
            }
            writeFilterBar_LazyLoad() {
                const me = this;
                let selectedFilterLength = 0;
                for (let i = 0; i < me._FilterData.length; i++) {
                    const item = me._FilterData[i];
                    if (!EC_Fmt.isNull(item.CurValue)) {
                        const fieldName = item.FieldName ?? item.TableFieldID.split(".")[1];
                        me.setSelectedFilter(fieldName, item.CurValue, item.Title, item.CurDisplayValue);
                        selectedFilterLength++;
                    }
                }
                if (selectedFilterLength === 0) {
                    me.filterBar.querySelector(".top-main").appendChild(EC_Fmt.HtmlStrToElement("<div class=\"selected-filter noFilter\">No filters applied</div>"));
                }
                const filterResetButton = me.filterBar.querySelector("#filterResetButton");
                if (filterResetButton) {
                    filterResetButton.style.display = "none";
                }
            }
            writeMoreFilterDialog() {
                const me = this;
                me.moreFilterDialog = ECP.Dialog.ShowDialog("Modify filters", me.moreFilter, {
                    barPosition: "top",
                    footer: "<ecp-btn id=filterCancelButton>Cancel</ecp-btn><ecp-btn id=filterApplyButton type=primary>Apply filters</ecp-btn>"
                });
                me.moreFilterDialog.querySelector("#filterCancelButton").addEventListener("click", () => {
                    me.moreFilterDialog.style.display = "none";
                });
                me.moreFilterDialog.querySelector("#filterApplyButton").addEventListener("click", () => {
                    requestAnimationFrame(() => {
                        if (!me.validateForm()) {
                            return;
                        }
                        const selectedFilters = me.moreFilter.querySelectorAll(".top-main ecp-filter-chip");
                        me.parameters = FilterBarWebComponent.getSelectedParameters(selectedFilters);
                        me.writeFilterBar();
                        if (me.onApply && me.onApply instanceof Function) {
                            me.onApply(me.parameters);
                        }
                        me.moreFilterDialog.style.display = "none";
                    });
                });
                const ecpEmpty = me.moreFilter.querySelector("ecp-empty");
                const allFilterItems = me.moreFilter.querySelectorAll("[filter-title]");
                if (allFilterItems.length > 0) {
                    EC_Fmt.AfterInput(me.moreFilterDialog.querySelector(".filter-top ecp-input"), 2, 250, (searchInput, search) => {
                        if (!EC_Fmt.isNull(search) && search.length > 1) {
                            let searchFilterLength = 0;
                            for (let i = 0; i < allFilterItems.length; i++) {
                                const item = allFilterItems[i];
                                if (item.getAttribute("filter-title").toLowerCase().indexOf(search.toLowerCase()) > -1) {
                                    item.classList.remove("hidden");
                                    if (item.closest(".filter-section")) {
                                        item.closest(".filter-section").classList.remove("hidden");
                                    }
                                    searchFilterLength++;
                                }
                                else {
                                    item.classList.add("hidden");
                                    const filterForm = item.closest(".data-form");
                                    if (filterForm && filterForm.offsetHeight === 0) {
                                        filterForm.closest(".filter-section").classList.add("hidden");
                                    }
                                }
                            }
                            if (searchFilterLength === 0) {
                                ecpEmpty.classList.remove("hidden");
                            }
                            else {
                                ecpEmpty.classList.add("hidden");
                            }
                        }
                        else {
                            ecpEmpty.classList.add("hidden");
                            allFilterItems.forEach(item => item.classList.remove("hidden"));
                            me.moreFilter.querySelectorAll(".filter-section.hidden").forEach(item => item.classList.remove("hidden"));
                        }
                    }, true);
                }
                else {
                    me.moreFilterDialog.querySelector(".filter-top ecp-input").remove();
                }
                this.moreFilterDialog.querySelector(".ecp-dialog-close").remove();
                this.moreFilterDialog.style.display = "none";
            }
            async writeMoreFilter(useParameters) {
                const me = this;
                const scrollSection = me.moreFilter.querySelector(".scroll-section");
                const loading = ECP.Dialog.ShowLoading("", me.moreFilter);
                const copyFilterData = me._FilterData.map(data => Object.assign({}, data));
                const FilterData = await me.processData(copyFilterData, useParameters);
                let filterForm;
                if (scrollSection.firstElementChild && scrollSection.firstElementChild.classList.contains("filter-form")) {
                    filterForm = scrollSection.firstElementChild;
                    filterForm.innerHTML = "";
                }
                else {
                    filterForm = EC_Fmt.HtmlStrToElement("<form class=filter-form></form>");
                    filterForm.addEventListener("submit", (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                    });
                    scrollSection.appendChild(filterForm);
                }
                filterForm.appendChild(EC_Fmt.HtmlStrToElement("<input type=submit class=hidden>"));
                for (let i = 0; i < FilterData.length; i++) {
                    const myFilterData = FilterData[i];
                    const filterCategoryTemp = me.filterTemplate.querySelector(".filter-section").cloneNode(true);
                    filterCategoryTemp.querySelector(".type-text").innerHTML = myFilterData.Category;
                    const filterItemData = myFilterData.FilterItemData;
                    for (let k = 0; k < filterItemData.length; k++) {
                        const filterItem = filterItemData[k];
                        const filterItemTemp = me.filterTemplate.querySelector(".data-item").cloneNode(true);
                        const itemContent = filterItemTemp.querySelector(".data-content");
                        let required = false;
                        if (filterItem.Required && filterItem.Required.toString() !== "0" && filterItem.Required.toString().toLowerCase() !== "false") {
                            required = true;
                        }
                        filterItemTemp.querySelector(".data-title").innerHTML = `${required ? "* " : ""}${EC_Fmt.Null2EmptyStr(filterItem.Title)}`;
                        filterItemTemp.setAttribute("filter-title", EC_Fmt.Null2EmptyStr(filterItem.Title));
                        itemContent.setAttribute("title", EC_Fmt.Null2EmptyStr(filterItem.Title));
                        itemContent.innerHTML = EC_Fmt.Null2EmptyStr(filterItem.ItemHTML);
                        if (required) {
                            itemContent.setAttribute("Required", "true");
                        }
                        if (filterItem.HTMLTemplateID || (filterItem.HTMLElement && filterItem.HTMLElement instanceof HTMLElement)) {
                            if (filterItem.HTMLTemplateID) {
                                itemContent.id = `HTMLTemplate_${filterItem.HTMLTemplateID}`;
                            }
                            if (filterItem.HTMLElement && filterItem.HTMLElement instanceof HTMLElement) {
                                itemContent.appendChild(filterItem.HTMLElement);
                            }
                            if (!filterItem.AddDefaultEvent) {
                                itemContent.setAttribute("NotAddDefaultEvent", "true");
                            }
                        }
                        filterCategoryTemp.querySelector(".data-form").appendChild(filterItemTemp);
                    }
                    filterForm.appendChild(filterCategoryTemp);
                }
                const AjaxInputs = filterForm.querySelectorAll(".data-content:not([NotAddDefaultEvent]) input[KeyValue][DisplayVal][LimitToList]");
                for (let i = 0; i < AjaxInputs.length; i++) {
                    new ECP.HTML.AjaxInput(AjaxInputs[i], "", "", (input, hidden) => {
                        const fieldValue = hidden.value;
                        let displayValue = input.value;
                        if (fieldValue.split("^").length > 1 && input.getAttribute("selarray")) {
                            displayValue = input.getAttribute("selarray");
                            displayValue = displayValue.split("^").map(value => EC_Fmt.NullChk(value.split("|")[1], value.split("|")[0])).join(", ");
                        }
                        if (displayValue !== fieldValue) {
                            const searchOp = EC_Fmt.get_searchOp(fieldValue);
                            if (displayValue !== fieldValue && searchOp !== "" && searchOp !== "NOT IS NULL" && searchOp !== "IS NULL" && EC_Fmt.Left(displayValue, searchOp.length) !== searchOp) {
                                displayValue = searchOp + displayValue;
                            }
                        }
                        me.setSelectedFilter(hidden.name, fieldValue, input.closest(".data-content").getAttribute("title"), displayValue, me.moreFilter.querySelector(".top-main"));
                    });
                }
                const otherInputs = filterForm.querySelectorAll(".data-content:not([NotAddDefaultEvent]) input[type='text'][name], .data-content:not([NotAddDefaultEvent]) input.DatePickerInput, .data-content:not([NotAddDefaultEvent]) select[name], .data-content:not([NotAddDefaultEvent]) ecp-input[name]");
                for (let i = 0; i < otherInputs.length; i++) {
                    const input = otherInputs[i];
                    if (input.tagName.toLowerCase() === "ecp-input") {
                        input.width = "";
                    }
                    input.addEventListener("change", () => {
                        let fieldName = "";
                        let fieldValue = "";
                        let fieldDisplayValue = "";
                        if (input.classList.contains("DatePickerInput")) {
                            fieldName = input.previousElementSibling.name;
                            fieldValue = input.previousElementSibling.value;
                            fieldDisplayValue = input.value;
                        }
                        else if (input.tagName === "SELECT") {
                            const selectedOptions = input.selectedOptions;
                            fieldName = input.name;
                            for (let j = 0; j < selectedOptions.length; j++) {
                                if (fieldValue !== "") {
                                    fieldValue += "^";
                                }
                                fieldValue += selectedOptions[j].value;
                                if (fieldDisplayValue !== "") {
                                    fieldDisplayValue += ", ";
                                }
                                fieldDisplayValue += selectedOptions[j].text;
                            }
                        }
                        else {
                            fieldName = input.name;
                            fieldValue = input.value;
                            fieldDisplayValue = input.value;
                        }
                        me.setSelectedFilter(fieldName, fieldValue, input.closest(".data-content").getAttribute("title"), fieldDisplayValue, me.moreFilter.querySelector(".top-main"));
                    });
                }
                const filterToggleBtnArr = filterForm.querySelectorAll(".filter-toggle");
                for (let i = 0; i < filterToggleBtnArr.length; i++) {
                    filterToggleBtnArr[i].addEventListener("click", (e) => {
                        const filterWrap = e.currentTarget.nextElementSibling;
                        const icon = e.currentTarget.querySelector(".toggle-icon");
                        if (filterWrap.classList.contains("hidden")) {
                            filterWrap.classList.remove("hidden");
                            icon.classList.add("transform");
                        }
                        else {
                            filterWrap.classList.add("hidden");
                            icon.classList.remove("transform");
                        }
                    });
                }
                ECP.Dialog.HideLoading(loading);
            }
            async writeMoreFilter_LazyLoad() {
                const dialogTemp = ECP.Dialog.ShowDialog("Modify filters", ECP.Dialog.ShowLoading(), {
                    width: 500,
                    height: 300,
                    barPosition: "top",
                    footer: "<ecp-btn id=filterCancelButton>Cancel</ecp-btn><ecp-btn id=filterApplyButton type=primary>Apply filters</ecp-btn>"
                });
                dialogTemp.querySelector(".ecp-dialog-close").remove();
                await this.writeMoreFilter();
                this.writeMoreFilterDialog();
                this.initialFormData = this.getInitialFormData();
                this.writeFilterBar();
                dialogTemp.remove();
                this.moreFilterDialog.style.display = "block";
            }
            setSelectedFilter(fieldName, fieldValue, fieldAlias, fieldDisplayValue, target = this.filterBar.querySelector(".top-main")) {
                if (!EC_Fmt.isNull(fieldName)) {
                    let selectedFilter = target.querySelector(`ecp-filter-chip[field='${fieldName}']`);
                    if (!EC_Fmt.isNull(fieldValue)) {
                        if (!selectedFilter) {
                            selectedFilter = document.createElement("ecp-filter-chip");
                            selectedFilter.classList.add("selected-filter");
                            selectedFilter.setAttribute("field", fieldName);
                            selectedFilter.addEventListener("remove", (event) => {
                                this.removeSelectedFilterEvent(event);
                            });
                        }
                        let valueTemp = fieldValue;
                        let displayValueTemp = EC_Fmt.NullChk(fieldDisplayValue, fieldValue);
                        const searchOp = EC_Fmt.get_searchOp(valueTemp);
                        if (searchOp !== "NOT IS NULL" && searchOp !== "IS NULL" && EC_Fmt.Left(valueTemp, searchOp.length) === searchOp) {
                            valueTemp = EC_Fmt.Right(valueTemp, valueTemp.length - searchOp.length);
                        }
                        const operator = EC_Fmt.OperatorStrToEnum(searchOp);
                        const parameter = `F:${fieldName}~V:${valueTemp}~O:${EC_Fmt.OperatorToURLOperator(operator)}`;
                        const valueTempArr = valueTemp.split("^");
                        if (valueTempArr.length > 1) {
                            displayValueTemp = `${valueTempArr.length} selected`;
                        }
                        if (operator === ECP.EC_Operator.NotEquals || operator === ECP.EC_Operator.NotLike) {
                            selectedFilter.isNot = true;
                            if (EC_Fmt.Left(displayValueTemp, 2) === "<>") {
                                displayValueTemp = EC_Fmt.Right(displayValueTemp, displayValueTemp.length - 2);
                            }
                        }
                        else {
                            selectedFilter.isNot = false;
                        }
                        selectedFilter.label = EC_Fmt.NullChk(fieldAlias, fieldName);
                        selectedFilter.value = displayValueTemp;
                        selectedFilter.title = EC_Fmt.NullChk(fieldDisplayValue, fieldValue);
                        selectedFilter.setAttribute("parameter", parameter);
                        const noFilter = target.querySelector(".noFilter");
                        if (noFilter) {
                            noFilter.remove();
                        }
                        if (!selectedFilter.parentElement) {
                            target.appendChild(selectedFilter);
                        }
                    }
                    else if (selectedFilter) {
                        selectedFilter.remove();
                    }
                    if (target === this.filterBar) {
                        requestAnimationFrame(() => {
                            const filterResetButton = target.querySelector("#filterResetButton");
                            if (this.initialFormData && this.initialFormData.parameters === FilterBarWebComponent.getSelectedParameters(target.querySelectorAll("ecp-filter-chip"))) {
                                filterResetButton.style.display = "none";
                            }
                            else {
                                filterResetButton.style.display = "";
                            }
                        });
                    }
                }
            }
            removeSelectedFilterEvent(event) {
                let parameters = "";
                let selectedFilters;
                const me = this;
                const currentFilterName = event.currentTarget.getAttribute("field");
                const fromMoreFilterDialog = !EC_Fmt.isNull(event.currentTarget.closest(".ecp-filter.moreFilter"));
                if (fromMoreFilterDialog) {
                    selectedFilters = Array.from(me.moreFilter.querySelectorAll(".top-main ecp-filter-chip")).filter(item => item !== event.currentTarget);
                }
                else {
                    selectedFilters = Array.from(me.filterBar.querySelectorAll("ecp-filter-chip")).filter(item => item !== event.currentTarget);
                }
                if (selectedFilters.length > 0) {
                    parameters = FilterBarWebComponent.getSelectedParameters(selectedFilters);
                }
                else if (!fromMoreFilterDialog) {
                    me.filterBar.querySelector(".top-main").appendChild(EC_Fmt.HtmlStrToElement("<div class=\"selected-filter noFilter\">No filters applied</div>"));
                }
                me.parameters = parameters;
                if (me.isDefaultFilterBar && (fromMoreFilterDialog || !me.notResetFilterBarOnRemove)) {
                    me.writeMoreFilter(true);
                }
                if (!fromMoreFilterDialog && me.onRemoveSelectedFilter && me.onRemoveSelectedFilter instanceof Function) {
                    me.onRemoveSelectedFilter(me.parameters, currentFilterName);
                }
            }
            getInitialFormData() {
                const filterInputs = this.moreFilter.querySelectorAll("input[name]:not([slot]),textarea[name],select[name],ecp-input[name]");
                const formData = [];
                let parameters = "";
                for (let i = 0; i < filterInputs.length; i++) {
                    const input = filterInputs[i];
                    if ((input.type !== `checkbox` && !EC_Fmt.isNull(input.value)) || (input.type === `checkbox` && input.checked)) {
                        let fieldValue = input.value;
                        let fieldDisplayValue = "";
                        let searchOp = EC_Fmt.get_searchOp(fieldValue);
                        if (input.closest(".AutocompleteField")) {
                            const autoCompleteInput = input.closest(".AutocompleteField").querySelector(".AutoCompleteInput");
                            fieldDisplayValue = autoCompleteInput.value;
                            if (input.value.split("^").length > 1 && autoCompleteInput.getAttribute("selarray")) {
                                fieldDisplayValue = autoCompleteInput.getAttribute("selarray");
                                fieldDisplayValue = fieldDisplayValue.split("^").map(value => EC_Fmt.NullChk(value.split("|")[1], value.split("|")[0])).join(", ");
                            }
                            if (fieldDisplayValue !== fieldValue && searchOp !== "" && searchOp !== "NOT IS NULL" && searchOp !== "IS NULL" && EC_Fmt.Left(fieldDisplayValue, searchOp.length) !== searchOp) {
                                fieldDisplayValue = searchOp + fieldDisplayValue;
                            }
                        }
                        else if (input.closest(".DatePickerField")) {
                            fieldDisplayValue = input.closest(".DatePickerField").querySelector(".DatePickerInput").value;
                        }
                        else if (input.tagName === "SELECT") {
                            const selectedOptions = input.selectedOptions;
                            fieldValue = "";
                            for (let j = 0; j < selectedOptions.length; j++) {
                                if (fieldValue !== "") {
                                    fieldValue += "^";
                                }
                                fieldValue += selectedOptions[j].value;
                                if (fieldDisplayValue !== "") {
                                    fieldDisplayValue += ", ";
                                }
                                fieldDisplayValue += selectedOptions[j].text;
                            }
                        }
                        else {
                            fieldDisplayValue = input.value;
                        }
                        formData.push({
                            fieldName: input.name,
                            fieldValue,
                            fieldAlias: input.closest(".data-content").getAttribute("title"),
                            fieldDisplayValue
                        });
                        if (searchOp === "*" && input.getAttribute("selarray") && input.getAttribute("selarray") === fieldValue) {
                            searchOp = "";
                        }
                        else if (searchOp !== "NOT IS NULL" && searchOp !== "IS NULL" && EC_Fmt.Left(fieldValue, searchOp.length) === searchOp) {
                            fieldValue = EC_Fmt.Right(fieldValue, fieldValue.length - searchOp.length);
                        }
                        if (parameters !== "") {
                            parameters += "|";
                        }
                        parameters += `F:${input.name}~V:${fieldValue}~O:${EC_Fmt.OperatorToURLOperator(EC_Fmt.OperatorStrToEnum(searchOp))}`;
                    }
                }
                return { parameters, formData };
            }
            validateForm() {
                let missingFieldList = "";
                let alertMessage = "";
                let startDate = null;
                let endDate = null;
                const requiredInputArr = this.moreFilter.querySelectorAll(".data-content[required='true'] [encreq='true'],.data-content[required='true'] [req='true']");
                for (let i = 0; i < requiredInputArr.length; i++) {
                    const element = requiredInputArr[i];
                    if (EC_Fmt.isNull(element.value)) {
                        if (element.classList.contains("AutoCompleteInput") || element.classList.contains("DatePickerInput")) {
                            const parentField = element.closest(".AutocompleteField") || element.closest(".DatePickerField");
                            if (parentField) {
                                parentField.classList.add("AutocompleteError");
                            }
                        }
                        else {
                            element.classList.add("FieldError");
                        }
                        missingFieldList += `${element.closest(".data-content").getAttribute("title")}<br>`;
                    }
                    else if (element.classList.contains("AutoCompleteInput") || element.classList.contains("DatePickerInput")) {
                        const parentField = element.closest(".AutocompleteField") || element.closest(".DatePickerField");
                        if (parentField) {
                            parentField.classList.remove("AutocompleteError");
                        }
                    }
                    else {
                        element.classList.remove("FieldError");
                    }
                    if (element.getAttribute("name") && !EC_Fmt.isNull(element.value)) {
                        if (element.getAttribute("name").toLowerCase() === "startdate") {
                            startDate = new Date(element.value);
                        }
                        else if (element.getAttribute("name").toLowerCase() === "enddate") {
                            endDate = new Date(element.value);
                        }
                    }
                }
                if (startDate && endDate && (startDate > endDate)) {
                    missingFieldList += "The Start Date is After the End Date<br>";
                }
                if (missingFieldList !== "") {
                    alertMessage += `The Following Fields are Required: <br><br>${missingFieldList}`;
                }
                if (alertMessage !== "") {
                    ECP.Dialog.Alert(alertMessage);
                    return false;
                }
                return true;
            }
            addEventToFilterBar() {
                const me = this;
                me.filterBar.querySelector("#moreFiltersButton").addEventListener("click", () => {
                    if (me.lazyLoad) {
                        me.writeMoreFilter_LazyLoad();
                        me.lazyLoad = false;
                    }
                    else {
                        me.moreFilterDialog.style.display = "block";
                        if (!me.isDefaultFilterBar && !me.hasCenteredCustomMoreFilterDialog) {
                            ECP.Dialog.CenterDialog(me.moreFilterDialog);
                            me.hasCenteredCustomMoreFilterDialog = true;
                        }
                    }
                });
                me.filterBar.querySelector("#filterResetButton").addEventListener("click", () => {
                    me.parameters = "";
                    if (me.initialFormData) {
                        me.parameters = me.initialFormData.parameters;
                    }
                    me.writeFilterBar();
                    if (me.isDefaultFilterBar) {
                        me.writeMoreFilter();
                    }
                    if (me.onReset && me.onReset instanceof Function) {
                        me.onReset(me.parameters);
                    }
                });
            }
            static getSelectedParameters(selectedFilters) {
                let parameters = "";
                for (let i = 0; i < selectedFilters.length; i++) {
                    const parameter = EC_Fmt.Null2EmptyStr(selectedFilters[i].getAttribute("parameter"));
                    if (parameter !== "") {
                        if (parameters !== "") {
                            parameters += "|";
                        }
                        parameters += parameter;
                    }
                }
                return parameters;
            }
        }
        document.addEventListener("DOMContentLoaded", () => {
            window.customElements.define("ecp-filterbar", FilterBarWebComponent);
        });
    }
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPProgressTracker = class ECPProgressTracker extends ECP.Component {
        constructor() {
            super(...arguments);
            this.direction = "vertical";
            this.active = 0;
            this.alignment = "left";
            this.selectable = true;
        }
        directionChanged(oldValue, newValue) {
            if (newValue === "horizontal") {
                this.shadowRoot.querySelector(".ecp-steps").classList.add("ecp-steps--horizontal");
                this.shadowRoot.querySelector(".ecp-steps").classList.remove("ecp-steps--vertical");
            }
            else {
                this.shadowRoot.querySelector(".ecp-steps").classList.remove("ecp-steps--horizontal");
                this.shadowRoot.querySelector(".ecp-steps").classList.add("ecp-steps--vertical");
            }
            for (let i = 0; i < this.children.length; i++) {
                const item = this.children[i];
                item.setAttribute("direction", newValue);
            }
        }
        activeChanged(oldValue, newValue) {
            const item = this.children;
            if (newValue >= item.length) {
                newValue = item.length - 1;
            }
            if (oldValue >= item.length) {
                oldValue = item.length - 1;
            }
            if (oldValue !== undefined) {
                const lastStep = item[oldValue];
                const activeStep = item[newValue];
                if (newValue >= 0) {
                    item[oldValue].setAttribute("selected", "false");
                    item[newValue].setAttribute("selected", "true");
                }
                this.$emit("change", { lastStep, activeStep });
            }
        }
        stepChanged(oldValue, newValue) {
            if (newValue > 1) {
                const steps = this.children;
                const lastLine = steps[steps.length - 1].shadowRoot.querySelector(".ecp-step__line");
                lastLine.style.display = "none";
            }
        }
        selectableChanged(oldValue, newValue) {
            for (let i = 0; i < this.children.length; i++) {
                const item = this.children[i];
                item.selectable = newValue;
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPProgressTracker.prototype, "direction", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPProgressTracker.prototype, "active", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], ECPProgressTracker.prototype, "step", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressTracker.prototype, "alignment", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressTracker.prototype, "selectable", void 0);
    ECPProgressTracker = __decorate([
        ECP.customElement({
            name: "ecp-progress-tracker",
            template: `<div class=ecp-steps><slot></slot></div>`,
            styles: `
.ecp-steps{
display:flex
}
.ecp-steps--horizontal{
white-space:nowrap
}
.ecp-steps--vertical{
flex-flow:column
}
:host([alignment="right"]) ::slotted(ecp-progress-step){
--ecp-step-flex-direction:row-reverse;
--ecp-step-text-direction:right
}
:host([alignment="right"][direction="horizontal"]) ::slotted(ecp-progress-step:last-of-type){
--ecp-step-line-last:block
}
:host([alignment="right"][direction="horizontal"]) ::slotted(ecp-progress-step:first-of-type){
--ecp-step-line-first:none
}
:host([alignment="right"][direction="horizontal"]) ::slotted(ecp-progress-step){
--left-value:-26px;
--right-value:40px;
--icon-left-value:auto;
--icon-right-value:25px
}
:host([selectable='false'][alignment="left"][direction="horizontal"]) ::slotted(ecp-progress-step){
--left-value:16px;
--right-value:0;
--icon-left-value:0;
--icon-right-value:auto
}
:host([selectable='false'][alignment="right"][direction="horizontal"]) ::slotted(ecp-progress-step) {
--left-value:-18px;
--right-value:32px;
--icon-left-value:auto;
--icon-right-value:17px
}`,
            enableIcon: true
        })
    ], ECPProgressTracker);
    ECP.ECPProgressTracker = ECPProgressTracker;
    let ECPProgressStep = class ECPProgressStep extends ECP.Component {
        constructor() {
            super(...arguments);
            this.type = "undone";
            this.direction = "vertical";
            this.selected = false;
            this.selectable = true;
        }
        created() {
            if (EC_Fmt.isNull(this.direction) && this.parentElement.getAttribute("direction") === "horizontal") {
                this.style.flexBasis = `${(1 / this.parentNode.children.length) * 100}%`;
            }
            this.addEventListener("click", () => {
                if (!stepSelectable(this.selectable)) {
                    return;
                }
                let isExit = -1;
                const node = this.parentNode.children;
                for (let i = 0; i < node.length; i++) {
                    node[i].setAttribute("selected", "false");
                    if (this === node[i]) {
                        isExit = i;
                    }
                }
                this.$emit("change");
                if (isExit > -1) {
                    const active = this.parentElement.getAttribute("active");
                    if (parseInt(active, 10) === isExit) {
                        this.setAttribute("selected", "true");
                    }
                    else {
                        this.parentElement.setAttribute("active", isExit.toString());
                    }
                }
            });
        }
        stepTitleChanged(oldValue, newValue) {
            this.shadowRoot.querySelector(".ecp-step__title").innerHTML = newValue;
        }
        typeChanged(oldValue, newValue) {
            const icon = this.shadowRoot.querySelector(".ecp-step__icon");
            if (newValue.toLowerCase() === "success") {
                icon.className = "ecp-step__icon ecp-step-item__node--success ews-icon-emcheckbold";
            }
            else if (newValue.toLowerCase() === "error") {
                icon.className = "ecp-step__icon ecp-step-item__node--error ews-icon-emerrorbold";
            }
            else {
                icon.className = "ecp-step__icon ecp-step-item__node--undone";
            }
        }
        selectedChanged(oldValue, newValue) {
            const icon = this.shadowRoot.querySelector(".ecp-step__icon");
            if (newValue !== false && stepSelectable(this.selectable)) {
                if (icon.className.indexOf("ews-icon") === -1) {
                    icon.className = "ecp-step__icon ecp-step-item__node--select";
                }
                this.shadowRoot.querySelector(".ecp-step__main").classList.add("ecp-step-item-select");
            }
            else {
                if (icon.className.indexOf("ews-icon") === -1) {
                    icon.className = "ecp-step__icon ecp-step-item__node--undone";
                }
                this.shadowRoot.querySelector(".ecp-step__main").classList.remove("ecp-step-item-select");
            }
        }
        directionChanged(oldValue, newValue) {
            const container = this.shadowRoot.querySelector(".ecp-step");
            if (newValue === "horizontal") {
                container.classList.add("is-horizontal");
                container.classList.remove("is-vertical");
            }
            else {
                container.classList.remove("is-horizontal");
                container.classList.add("is-vertical");
            }
        }
        selectableChanged(oldValue, newValue) {
            if (!stepSelectable(newValue)) {
                this.selected = false;
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPProgressStep.prototype, "stepTitle", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressStep.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressStep.prototype, "direction", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPProgressStep.prototype, "selected", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressStep.prototype, "selectable", void 0);
    ECPProgressStep = __decorate([
        ECP.customElement({
            name: "ecp-progress-step",
            template: `<div class="ecp-step is-vertical">
        <div class="ecp-step__head">
            <div class="ecp-step__line"></div>
            <div class="ecp-step__icon ecp-step-item__node--undone"></div>
        </div>
        <div class="ecp-step__main">
            <div class="ecp-step__title"></div>
            <div class="ecp-step__description"><slot></slot></div>
        </div>
    </div>`,
            styles: `
:host(:last-child) .ecp-step__line{
display:var(--ecp-step-line-last, none)
}
:host(:first-child) .ecp-step__line{
display:var(--ecp-step-line-first, block)
}
.ecp-step{
position:relative;
flex-shrink:1
}
.ecp-step__head{
position:relative
}
.ecp-step__icon{
position:absolute;
top:2px;
z-index:1;
display:inline-flex!important;
justify-content:center;
align-items:center;
width:16px;
height:16px;
font-size:16px!important;
box-sizing:border-box;
border-radius:50%;
transition:background-color var(--ecp-duration-fastest) var(--ecp-ease-standard);
cursor:pointer
}
.ecp-step.is-vertical .ecp-step__icon{
top:12px
}
:host([selectable='false']) .ecp-step.is-vertical .ecp-step__icon{
top:7px
}
.ecp-step.is-horizontal .ecp-step__icon{
left:var(--icon-left-value, 10px);
right:var(--icon-right-value, auto)
}
.ecp-step__line{
position:absolute;
background:var(--neutral-t16)
}
.ecp-step__main{
white-space:normal;
text-align:left;
color:var(--text);
border-radius:4px;
border:1px solid transparent;
box-sizing:content-box;
width:fit-content;
text-align:var(--ecp-step-text-direction, left)
}
:host([selectable]:not([selectable='false'])) .ecp-step__main{
padding:8px 12px;
cursor:pointer
}
:host([selectable]:not([selectable='false'])) .ecp-step__main:hover{
background:var(--bg-hover);
transition:background-color var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
.ecp-step__title{
font-size:13px;
color:var(--text);
line-height:24px
}
.ecp-step__description{
font-size:13px;
color:var(--text-secondary)
}
.ecp-step.is-horizontal .ecp-step__line{
height:4px;
top:7px;
left:var(--left-value, 26px);
right:var(--right-value, -10px)
}
.ecp-step.is-vertical{
display:flex;
gap:16px;
flex-direction:var(--ecp-step-flex-direction, row)
}
.ecp-step.is-horizontal  .ecp-step__head{
height:16px
}
.ecp-step.is-horizontal .ecp-step__main{
margin-top:8px;
margin-right:12px
}
:host([selectable='false']) .ecp-step.is-horizontal .ecp-step__main{
margin-right:16px
}
.ecp-step.is-vertical .ecp-step__main{
margin:0 0 16px 16px
}
.ecp-step.is-vertical .ecp-step__line{
width:4px;
top:28px;
bottom:-12px;
left:6px
}
:host([selectable='false']) .ecp-step.is-vertical .ecp-step__line{
top:23px;
bottom:-7px
}
.ecp-step__main.ecp-step-item-select{
background:var(--bg-selected);
border:1px solid var(--border-selected)
}
.ecp-step__main.ecp-step-item-select .ecp-step__title{
font-weight:700
}
.ecp-step-item__node--success{
background-color:var(--bg);
color:var(--text-success)
}
.ecp-step-item__node--select{
background-color:var(--primary-20)
}
.ecp-step-item__node--error{
background-color: var(--bg);
color:var(--text-error)
}
.ecp-step-item__node--undone{
background-color:var(--neutral-t16)
}
.remove-step .ecp-step__line{
display:none
}`,
            enableIcon: true
        })
    ], ECPProgressStep);
    ECP.ECPProgressStep = ECPProgressStep;
    function stepSelectable(value) {
        return value !== false && String(value) !== "false";
    }
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ToolTipWebComponent = class ToolTipWebComponent extends ECP.Component {
        created() {
            if (!EC_Fmt.isNull(this.for)) {
                if (EC_Fmt.isNull(this.placement)) {
                    this.placement = "bottom";
                }
                this.placement = this.placement.toLowerCase();
                if (!EC_Fmt.isNumber(this.delayms)) {
                    this.delayms = "300";
                }
                const tips = this.shadowRoot.querySelector(".tooltip-description");
                let elementToAddTipTo = document.getElementById(this.for);
                if (!elementToAddTipTo) {
                    const rootNode = this.getRootNode();
                    if (rootNode instanceof ShadowRoot) {
                        elementToAddTipTo = rootNode.getElementById(this.for);
                    }
                }
                if (elementToAddTipTo) {
                    let cursorIsOverElement = false;
                    tips.addEventListener("animationend", () => {
                        if (tips.classList.contains("animation-disappear-to-top") || tips.classList.contains("animation-disappear-to-bottom")) {
                            tips.style.opacity = "0";
                            tips.classList.remove("animation-disappear-to-top", "animation-disappear-to-bottom");
                        }
                    });
                    elementToAddTipTo.addEventListener("mouseover", (event) => {
                        cursorIsOverElement = true;
                        const target = event.currentTarget;
                        setTimeout(() => {
                            if (cursorIsOverElement) {
                                this.showTooltip(target);
                            }
                        }, EC_Fmt.CDec(this.delayms));
                    });
                    elementToAddTipTo.addEventListener("mouseleave", () => {
                        cursorIsOverElement = false;
                        requestAnimationFrame(() => {
                            tips.classList.remove("animation-appear-from-top", "animation-appear-from-bottom");
                            tips.classList.add(this.placement === "top" ? "animation-disappear-to-bottom" : "animation-disappear-to-top");
                        });
                    });
                }
            }
        }
        showTooltip(target) {
            const targetRect = target.getBoundingClientRect();
            const tips = this.shadowRoot.querySelector(".tooltip-description");
            tips.classList.remove("animation-disappear-to-top", "animation-disappear-to-bottom", "animation-appear-from-top", "animation-appear-from-bottom");
            tips.style.opacity = "1";
            tips.classList.add(this.placement === "top" ? "animation-appear-from-bottom" : "animation-appear-from-top");
            if (this.placement === "top" || this.placement === "bottom") {
                if (this.placement === "top") {
                    if (targetRect.top < tips.clientHeight) {
                        tips.style.top = `${10 + targetRect.top + targetRect.height}px`;
                    }
                    else {
                        tips.style.top = `${targetRect.top - tips.clientHeight - 10}px`;
                    }
                }
                else if (this.placement === "bottom") {
                    if (window.innerHeight - targetRect.bottom < tips.clientHeight) {
                        tips.style.top = `${10 + targetRect.top + tips.clientHeight}px`;
                    }
                    else {
                        tips.style.top = `${10 + targetRect.top + targetRect.height}px`;
                    }
                }
                if (targetRect.left > tips.clientWidth + 10) {
                    if (targetRect.width / 2 < tips.clientWidth) {
                        tips.style.left = `${targetRect.left + targetRect.width / 2 - tips.clientWidth / 2}px`;
                    }
                    else {
                        tips.style.left = `${targetRect.left}px`;
                    }
                }
            }
            else {
                if (targetRect.height < tips.clientHeight) {
                    tips.style.top = `${targetRect.top + targetRect.height / 2 - tips.clientHeight / 2}px`;
                }
                else {
                    tips.style.top = `${targetRect.top}px`;
                }
                if (this.placement === "left") {
                    if (targetRect.left - 10 < tips.clientWidth) {
                        tips.style.left = `${targetRect.right + 10}px`;
                    }
                    else {
                        tips.style.left = `${targetRect.left - 10 - tips.clientWidth}px`;
                    }
                }
                else if (window.innerWidth - targetRect.right - tips.clientWidth > 10) {
                    tips.style.left = `${targetRect.right + 10}px`;
                }
                else {
                    tips.style.left = `${targetRect.left - 10 - tips.clientWidth}px`;
                }
            }
        }
        show(target) {
            this.showTooltip(target);
        }
    };
    __decorate([
        ECP.attr
    ], ToolTipWebComponent.prototype, "for", void 0);
    __decorate([
        ECP.attr
    ], ToolTipWebComponent.prototype, "placement", void 0);
    __decorate([
        ECP.attr
    ], ToolTipWebComponent.prototype, "delayms", void 0);
    ToolTipWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-tooltip",
            template: `<div class=tooltip-description><slot></slot></div>`,
            styles: `
.tooltip-description {
position:fixed;
background:var(--neutral-120);
color:var(--text-onbg-action);
pointer-events:none;
padding:8px 15px;
border-radius:5px;
z-index:667;
box-shadow:0 -5px 10px -2px rgba(0,0,0,0.4);
width:inherit;
word-wrap:break-word;
opacity:0;
font-size:14px
}
.animation-appear-from-top{animation:ecp-keyframe-appearfromtop var(--ecp-duration-fastest)}
.animation-appear-from-bottom{animation:ecp-keyframe-appearfrombottom var(--ecp-duration-fastest)}
.animation-disappear-to-top{animation:ecp-keyframe-disappeartotop var(--ecp-duration-fastest)}
.animation-disappear-to-bottom{animation:ecp-keyframe-disappeartobottom var(--ecp-duration-fastest)}
@keyframes ecp-keyframe-appearfromtop{0%{opacity:0;translate:0 -0.5rem}100%{opacity:1;translate:0}}
@keyframes ecp-keyframe-appearfrombottom{0%{opacity:0;translate:0 0.5rem}100%{opacity:1;translate:0}}
@keyframes ecp-keyframe-disappeartotop{0%{opacity:1;translate:0}100%{opacity:0;translate:0 -0.5rem}}
@keyframes ecp-keyframe-disappeartobottom{0%{opacity:1;translate:0}100%{opacity:0;translate:0 0.5rem}}`
        })
    ], ToolTipWebComponent);
    ECP.ToolTipWebComponent = ToolTipWebComponent;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let TabWebComponent = class TabWebComponent extends ECP.Component {
        created() {
            this.remeasure = () => this.moveIndicator();
            if (typeof ResizeObserver === "undefined") {
                window.addEventListener("resize", this.remeasure);
            }
            else {
                this.indicatorObserver = new ResizeObserver(this.remeasure);
                this.indicatorObserver.observe(this);
            }
            requestAnimationFrame(() => {
                const item = this.getElementsByTagName("ecp-tab-item");
                if (item) {
                    let flag = true;
                    for (let i = 0; i < item.length; i++) {
                        const node = item[i];
                        if (node.selected) {
                            flag = false;
                            break;
                        }
                    }
                    if (flag && item.length > 1) {
                        item[0].setAttribute("selected", "true");
                    }
                    if (item.length < 2) {
                        throw new Error("Tab rows always contain two or more items.");
                    }
                }
                const me = this;
                if (me.nextElementSibling && me.nextElementSibling.tagName === "ECP-TABS") {
                    throw new Error("Tabs should only appear in one row, and not be nested.");
                }
                me.observeItems();
                me.moveIndicator();
            });
            this.classList.add("ecp-body");
            const slot = this.shadowRoot.querySelector("slot");
            if (slot) {
                slot.addEventListener("slotchange", () => {
                    this.observeItems();
                    this.moveIndicator();
                });
            }
        }
        connectedCallback() {
            super.connectedCallback();
            if (this.indicatorObserver) {
                this.indicatorObserver.observe(this);
                this.observeItems();
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            if (this.indicatorObserver) {
                this.indicatorObserver.disconnect();
            }
            else if (this.remeasure) {
                window.removeEventListener("resize", this.remeasure);
            }
        }
        observeItems() {
            if (!this.indicatorObserver) {
                return;
            }
            const items = this.getElementsByTagName("ecp-tab-item");
            for (let i = 0; i < items.length; i++) {
                this.indicatorObserver.observe(items[i]);
            }
        }
        moveIndicator(activeItem) {
            const indicator = this.shadowRoot.querySelector(".tab-indicator");
            const active = activeItem || this.querySelector("ecp-tab-item[selected]");
            if (!indicator || !active || active.offsetWidth === 0) {
                return;
            }
            const activeRect = active.getBoundingClientRect();
            const rowRect = this.getBoundingClientRect();
            indicator.style.width = `${activeRect.width}px`;
            indicator.style.transform = `translateX(${activeRect.left - rowRect.left + this.scrollLeft}px)`;
            indicator.classList.add("visible");
            this.style.setProperty("--ecp-tab-active-border", "transparent");
        }
    };
    TabWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-tabs",
            template: `<slot></slot><div class=tab-indicator></div>`,
            styles: `
:host{
display:flex;
position:relative;
border-bottom:1px solid var(--divider);
max-width:100%;
overflow-x:auto;
overflow-y:hidden
}
:host ::slotted(ecp-tab-item){
margin-left:24px;
margin-bottom:-1px
}
.tab-indicator{
position:absolute;
left:0;
bottom:-1px;
width:0;
height:3px;
background:var(--text);
opacity:0;
pointer-events:none;
transition:transform var(--ecp-duration-moderate) var(--ecp-ease-standard),width var(--ecp-duration-moderate) var(--ecp-ease-standard)
}
.tab-indicator.visible{
opacity:1
}`
        })
    ], TabWebComponent);
    ECP.TabWebComponent = TabWebComponent;
    let TabItemWebComponent = class TabItemWebComponent extends ECP.Component {
        constructor() {
            super(...arguments);
            this.disabled = false;
            this.selected = false;
        }
        created() {
            this.updateIcon();
            this.addEventListener("click", () => {
                const tabs = this.closest("ecp-tabs");
                const lastTabItem = tabs.querySelector("[selected]");
                if (lastTabItem) {
                    lastTabItem.removeAttribute("selected");
                }
                this.selected = !this.selected;
                const activeTabItem = this;
                ;
                const detail = { lastTabItem, activeTabItem };
                tabs.dispatchEvent(new CustomEvent("change", { detail }));
            });
        }
        selectedChanged(oldValue, newValue) {
            const label = this.shadowRoot.querySelector(".innerTab");
            if (newValue) {
                label.classList.add("active");
            }
            else {
                label.classList.remove("active");
            }
            const tabs = this.closest("ecp-tabs");
            if (newValue && tabs && typeof tabs.moveIndicator === "function") {
                tabs.moveIndicator(this);
            }
        }
        disabledChanged(oldValue, newValue) {
            if (newValue) {
                this.classList.add("disabled");
            }
            else {
                this.classList.remove("disabled");
            }
        }
        hrefChanged(oldValue, newValue) {
            if (newValue) {
                const label = this.shadowRoot.querySelector(".innerTab");
                let str = "";
                if (this.target) {
                    str = ` target="${this.target}"`;
                }
                label.innerHTML = `<a href="${newValue}" ${str}>${label.innerHTML}</a>`;
            }
        }
        targetChanged(oldValue, newValue) {
            if (newValue) {
                const a = this.shadowRoot.querySelector(".innerTab a");
                if (a) {
                    a.target = newValue;
                }
            }
        }
        iconChanged(oldValue, newValue) {
            this.updateIcon();
        }
        updateIcon() {
            const iconSpan = this.shadowRoot.querySelector(".icon");
            if (this.icon) {
                iconSpan.className = `icon ${this.icon}`;
                iconSpan.style.display = "";
            }
            else {
                iconSpan.className = "icon";
                iconSpan.style.display = "none";
            }
        }
    };
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], TabItemWebComponent.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], TabItemWebComponent.prototype, "selected", void 0);
    __decorate([
        ECP.attr
    ], TabItemWebComponent.prototype, "href", void 0);
    __decorate([
        ECP.attr
    ], TabItemWebComponent.prototype, "target", void 0);
    __decorate([
        ECP.attr
    ], TabItemWebComponent.prototype, "icon", void 0);
    TabItemWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-tab-item",
            template: `<div class="innerTab"><span class="icon"></span><slot></slot></div>`,
            styles: `
:host{
width:max-content;
height:100%
}
.innerTab{
color:var(--text-secondary);
font-weight:var(--regular-weight);
display:flex;
align-items:center;
gap:4px;
padding:12px 0;
height:100%;
box-sizing:border-box;
cursor:pointer;
border-bottom:3px solid transparent;
transition:border-color var(--ecp-duration-fastest) var(--ecp-ease-standard),color var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
.innerTab a{
display:flex;
align-items:center;
gap:4px;
height:100%;
color:var(--text-secondary);
text-decoration:none;
padding:12px 0;
margin:-12px 0
}
.innerTab:hover{
border-color:var(--text)
}
.active{
color:var(--text);
text-shadow: 0.2px 0 0 var(--text), -0.2px 0 0 var(--text);
border-color:var(--ecp-tab-active-border, var(--text))
}
.active *[class*="ews-icon-"],
.active *[class*="ews-illustration-"]{
text-shadow: none;
}
.icon{
display:none;
}
.icon[class*="ews-icon-"],
.icon[class*="ews-illustration-"]{
line-height:0;
}`,
            enableIcon: true
        })
    ], TabItemWebComponent);
    ECP.TabItemWebComponent = TabItemWebComponent;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let UploadWebComponent = class UploadWebComponent extends ECP.FormAssociatedElement {
        constructor() {
            super();
            this.helperText = "500 MB max file size";
            this.disabled = false;
            this.multiple = true;
            this.uploaded = false;
            this.error = false;
            this.text = "Upload Files";
            this.labelAlign = "left";
            this.proxy = document.createElement("input");
            this.proxy.type = "file";
        }
        created(host) {
            super.created(host);
            const wrapper = document.createElement("div");
            wrapper.classList.add("ecp-upload-wrapper");
            wrapper.classList.add(`align-${this.labelAlign || 'left'}`);
            if (this.label) {
                const labelEl = document.createElement("label");
                labelEl.classList.add("upload-label");
                labelEl.innerText = this.label;
                wrapper.appendChild(labelEl);
            }
            const uploadInput = document.createElement("div");
            if (this.type == "button") {
                uploadInput.classList.add("upload-button", "upload-btn");
                let uploadContent = `<span><input type="file" class="fileInput" ${this.multiple ? "multiple" : ''}></span>`;
                if (this.bg) {
                    uploadContent += `<div class=btn style="background:${this.bg}">${this.text}</div>`;
                }
                else {
                    uploadContent += `<ecp-btn>${this.text}</ecp-btn>`;
                }
                uploadInput.innerHTML = uploadContent;
            }
            else {
                uploadInput.classList.add("fileInput-container");
                uploadInput.innerHTML = `<div class="upload-container ${this.error ? "error" : ""}"><div class=upload-button><span><input type="file" class="fileInput" ${this.multiple ? "multiple" : ''}></span>`
                    + `<ecp-btn type=ghost>Upload Files</ecp-btn></div><div class=file-container>or Drop Files</div>`
                    + `<div class="close hidden ews-icon-close"></div></div>`
                    + `<progress id=progress-bar class="progress hidden" max=100 value=0></progress>`
                    + `<div class="helper-container ${this.error ? "error" : ""}"><span class=ews-icon-emerrorbold></span><span class=helper-text>${this.helperText}</span></div>`;
            }
            wrapper.appendChild(uploadInput);
            this.shadowRoot.appendChild(wrapper);
            const fileInput = this.shadowRoot.querySelector(".fileInput");
            if (!EC_Fmt.isNull(this.name)) {
                fileInput.id = `${this.name}Upload`;
                fileInput.name = `${this.name}Upload`;
            }
            else if (!EC_Fmt.isNull(this.id)) {
                fileInput.id = `${this.id}Upload`;
                fileInput.name = `${this.id}Upload`;
            }
            this.files = fileInput.files;
            if (this.type != "button") {
                this.oldText = this.helperText;
                const dropArea = this;
                const uploadContainer = this.shadowRoot.querySelector(".upload-container");
                const highlight = (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    uploadContainer.classList.add("drag");
                    dropArea.removeAttribute("error");
                };
                dropArea.addEventListener("dragenter", highlight, false);
                dropArea.addEventListener("dragover", highlight, false);
                const removeHighlight = (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    uploadContainer.classList.remove("drag");
                };
                dropArea.addEventListener("dragleave", removeHighlight, false);
                dropArea.addEventListener("drop", removeHighlight, false);
                this.dropFile();
                const closeBtn = this.shadowRoot.querySelector(".close");
                closeBtn.addEventListener("click", () => {
                    if (!closeBtn.classList.contains("hidden")) {
                        fileInput.value = "";
                        this.shadowRoot.querySelector(".file-container").innerHTML = "";
                        closeBtn.classList.add("hidden");
                        this.shadowRoot.querySelector("#progress-bar").classList.add("hidden");
                    }
                });
            }
            fileInput.addEventListener("change", (event) => {
                if (this.type != "button") {
                    this.error = false;
                    if (this.oldText !== this.helperText) {
                        this.helperText = this.oldText;
                    }
                }
                if (this.uploaded) {
                    this.uploadFiles(event.currentTarget.files);
                }
                else if (this.type != "button") {
                    this.updateFileInputDisplay(event.currentTarget.files);
                }
                const files = event.currentTarget.files;
                this.$emit("change", { files });
                this.files = files;
            });
        }
        filesChanged(oldValue, newValue) {
            if (newValue && newValue instanceof FileList) {
                if (newValue.length > 1) {
                    const form = new FormData();
                    for (let i = 0; i < newValue.length; i++) {
                        form.append("file", newValue[i]);
                    }
                    this.setFormValue(form);
                }
                else {
                    this.setFormValue(newValue[0]);
                }
            }
        }
        acceptChanged(oldValue, newValue) {
            const fileInput = this.shadowRoot.querySelector(".fileInput");
            if (newValue && fileInput) {
                fileInput.accept = this.accept;
            }
        }
        disabledChanged(oldValue, newValue) {
            if (newValue) {
                this.classList.add("disabled");
            }
            else {
                this.classList.remove("disabled");
            }
        }
        errorChanged(oldValue, newValue) {
            const uploadContainer = this.shadowRoot.querySelector(".upload-container");
            if (uploadContainer) {
                const helperText = this.shadowRoot.querySelector(".helper-container");
                if (newValue) {
                    uploadContainer.classList.add("error");
                    helperText.classList.add("error");
                    const fileContainer = this.shadowRoot.querySelector(".file-container");
                    fileContainer.classList.remove("finish");
                    fileContainer.innerHTML = "or Drop Files";
                    this.shadowRoot.querySelector(".close").classList.add("hidden");
                }
                else {
                    uploadContainer.classList.remove("error");
                    helperText.classList.remove("error");
                }
            }
        }
        helperTextChanged(oldValue, newValue) {
            const helperText = this.shadowRoot.querySelector(".helper-text");
            if (helperText) {
                if (newValue) {
                    helperText.innerText = newValue;
                }
                else {
                    helperText.innerText = "";
                }
            }
        }
        multipleChanged(oldValue, newValue) {
            const fileInput = this.shadowRoot.querySelector(".fileInput");
            if (fileInput) {
                if (newValue) {
                    fileInput.multiple = true;
                }
                else {
                    fileInput.removeAttribute("multiple");
                }
            }
        }
        sizeChanged(oldValue, newValue) {
            if (newValue && newValue.toLowerCase() === "large") {
                this.classList.add("size-large");
            }
            else {
                this.classList.remove("size-large");
            }
        }
        dropFile() {
            this.addEventListener("drop", (event) => {
                let AllValidFileTypes = false;
                const files = event.dataTransfer.files;
                if (this.accept) {
                    const acceptedTypes = this.accept.toLowerCase().split(",");
                    for (let i = 0; i < files.length; i++) {
                        const file = files[i];
                        const fileType = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
                        AllValidFileTypes = false;
                        for (let j = 0; j < acceptedTypes.length; j++) {
                            const acceptedType = acceptedTypes[j];
                            if (acceptedType.startsWith(".")) {
                                if (fileType === acceptedType) {
                                    AllValidFileTypes = true;
                                    break;
                                }
                            }
                            else if (acceptedType.split("/").length === 2) {
                                const [MIMEType, MIMESubtype] = acceptedType.split("/");
                                const DefaultMIMETypeKeys = Object.keys(ECP.HTML.DefaultMIMETypes);
                                for (let k = 0; k < DefaultMIMETypeKeys.length; k++) {
                                    const key = DefaultMIMETypeKeys[k];
                                    if (MIMEType === key) {
                                        if (MIMESubtype === "*") {
                                            if (ECP.HTML.DefaultMIMETypes[key].includes(fileType)) {
                                                AllValidFileTypes = true;
                                            }
                                        }
                                        else if (`.${MIMESubtype}` === fileType) {
                                            AllValidFileTypes = true;
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                        if (!AllValidFileTypes) {
                            break;
                        }
                    }
                }
                else {
                    AllValidFileTypes = true;
                }
                if (AllValidFileTypes) {
                    this.$emit("change", { files });
                    if (this.uploaded) {
                        this.uploadFiles(files);
                    }
                    else {
                        const fileInput = this.shadowRoot.querySelector(".fileInput");
                        fileInput.files = files;
                        this.updateFileInputDisplay(files);
                    }
                    return true;
                }
                this.helperText = `Invalid File Type, only accepts ${EC_Fmt.ReplaceAll(this.accept, ",", ", ")}`;
                this.error = true;
                return false;
            }, false);
        }
        updateFileInputDisplay(files) {
            this.files = files;
            const fileInputText = this.shadowRoot.querySelector(".file-container");
            let filesString = "";
            if (files) {
                for (let i = 0; i < files.length; i++) {
                    if (i !== 0) {
                        filesString += ", ";
                    }
                    filesString += files[i].name;
                }
            }
            fileInputText.innerHTML = filesString;
            fileInputText.classList.add("finish");
            this.shadowRoot.querySelector(".close").classList.remove("hidden");
            this.shadowRoot.querySelector("#progress-bar").classList.add("hidden");
        }
        uploadFiles(files) {
            const progressBar = this.shadowRoot.querySelector("#progress-bar");
            if (this.type != "button") {
                this.updateFileInputDisplay(files);
                progressBar.value = 0;
                progressBar.classList.remove("hidden");
            }
            const uploadProgress = [];
            for (let i = files.length; i > 0; i--) {
                uploadProgress.push(0);
            }
            function updateProgress(fileNumber, percent) {
                uploadProgress[fileNumber] = percent;
                const total = uploadProgress.reduce((tot, curr) => tot + curr, 0) / uploadProgress.length;
                progressBar.value = total;
            }
            let UploadURL = "api?APICommand=SalesComm_UploadDocument";
            if (EC_Fmt.isInteger(this.replaceDocumentID)) {
                UploadURL += `&DocumentID=${this.replaceDocumentID}`;
            }
            if (EC_Fmt.isInteger(this.documentTypeID)) {
                UploadURL += `&DocumentTypeID=${this.documentTypeID}`;
            }
            if (!EC_Fmt.isNull(this.description)) {
                UploadURL += `&Description=${encodeURIComponent(this.description)}`;
            }
            if (!EC_Fmt.isNull(this.subDir)) {
                if (this.subDir.substring(0, 2) !== "S3") {
                    this.subDir = `S3${this.subDir}`;
                }
                UploadURL += `&SubDir=${encodeURIComponent(this.subDir)}`;
            }
            if (!EC_Fmt.isNull(this.attachmentTable) && !EC_Fmt.isNull(this.attachmentKeyValue)) {
                UploadURL += `&AttachmentTable=${encodeURIComponent(this.attachmentTable)}&AttachmentKeyValue=${encodeURIComponent(this.attachmentKeyValue)}`;
            }
            else if (this.type != "button" && !EC_Fmt.isNull(this.attachmentTable) || !EC_Fmt.isNull(this.attachmentKeyValue)) {
                this.helperText = ("Both AttachmentTable and AttachmentKeyValue must be provided at the same time");
                this.error = true;
                progressBar.classList.add("hidden");
                return;
            }
            const me = this;
            function UploadFile(file, i) {
                gtag("event", "uploadFile", { file });
                return new Promise(((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open("POST", UploadURL, true);
                    if (me.type != "button") {
                        xhr.upload.addEventListener("progress", (e) => {
                            updateProgress(i, (e.loaded * 100.0 / e.total) || 100);
                        });
                    }
                    xhr.onload = () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            resolve(xhr.responseText);
                        }
                        else {
                            reject(xhr.statusText);
                        }
                    };
                    xhr.onerror = () => {
                        reject(`${xhr.statusText}: ${xhr.responseText}`);
                    };
                    const formData = new FormData();
                    formData.append("file", file);
                    xhr.send(formData);
                }));
            }
            (async function () {
                const results = [];
                for (let i = 0; i < files.length; i++) {
                    results.push(JSON.parse(await UploadFile(files[i], i)));
                }
                me.$emit("uploadCallback", { results });
            }());
            this.files = files;
        }
        labelChanged(oldValue, newValue) {
            const wrapper = this.shadowRoot.querySelector(".ecp-upload-wrapper");
            if (!wrapper)
                return;
            let labelEl = this.shadowRoot.querySelector(".upload-label");
            if (newValue && !labelEl) {
                labelEl = document.createElement("label");
                labelEl.classList.add("upload-label");
                wrapper.insertBefore(labelEl, wrapper.firstChild);
            }
            if (labelEl) {
                if (newValue) {
                    labelEl.innerText = newValue;
                    labelEl.style.display = '';
                }
                else {
                    labelEl.remove();
                }
            }
        }
        labelAlignChanged(oldValue, newValue) {
            const wrapper = this.shadowRoot.querySelector(".ecp-upload-wrapper");
            if (!wrapper)
                return;
            if (oldValue) {
                wrapper.classList.remove(`align-${oldValue}`);
            }
            else {
                wrapper.classList.remove("align-left");
            }
            if (newValue) {
                wrapper.classList.add(`align-${newValue}`);
            }
            else {
                wrapper.classList.add("align-left");
            }
            const labelEl = this.shadowRoot.querySelector(".upload-label");
            if (labelEl && this.label) {
                if (!labelEl.parentNode) {
                    wrapper.insertBefore(labelEl, wrapper.firstChild);
                }
            }
        }
    };
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "name", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "value", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "files", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "helperText", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "replaceDocumentID", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "documentTypeID", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "attachmentTable", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "attachmentKeyValue", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "description", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "subDir", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], UploadWebComponent.prototype, "accept", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], UploadWebComponent.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], UploadWebComponent.prototype, "multiple", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], UploadWebComponent.prototype, "uploaded", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], UploadWebComponent.prototype, "error", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "text", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "bg", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "size", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "label", void 0);
    __decorate([
        ECP.attr
    ], UploadWebComponent.prototype, "labelAlign", void 0);
    UploadWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-upload",
            template: "",
            styles: `
:host([type="button"]){
height:32px
}
:host([type=button].size-large){
height:44px
}
.hidden{
display:none!important
}
:host(.size-large) .upload-container{
height:44px;
line-height:44px
}
.fileInput-container{
width:inherit
}
.upload-container{
display:flex;
height:32px;
line-height:32px;
font-size:13px;
border:1px solid var(--border);
border-radius:4px;
background:var(--bg);
display:flex;
box-sizing:border-box
}
.upload-container .upload-button{
width:98px;
border-right:1px solid var(--border)
}
.upload-button{
border-radius:4px;
text-align:center;
cursor:pointer;
color:var(--text);
position:relative;
height:inherit;
line-height:inherit
}
.upload-btn{
color:var(--bg)
}
.upload-btn .btn{
border-radius:4px;
height:inherit;
display:flex;
align-items:center;
justify-content:center
}
.upload-btn span,
.upload-btn ecp-btn{
width:100%;
height:inherit
}
.upload-btn input{
width:100%;
left:0px
}
.upload-container .upload-button span{
width:98px
}
.upload-button span{
height:inherit;
position:absolute;
display:block;
top:0px;
left:0;
overflow:hidden;
z-index:1;
opacity:0
}
.upload-container .upload-button input{
left:-140px
}
.upload-button input{
cursor:pointer;
height:inherit;
position:absolute
}
.file-container{
padding:0 8px;
flex:1;
overflow:hidden;
text-overflow:ellipsis;
white-space:nowrap;
color:var(--text-placeholder)
}
.close{
width:20px;
cursor:pointer
}
.ews-icon-close{
line-height:inherit!important;
color:var(--text)
}
[class*="ews-icon-"]{
font-size:12px!important
}
.helper-text{
font-size:10px;
color:var(--text-secondary)
}
.drag{
border-color:var(--border-active)
}
.error{
border-color:var(--text-error)
}
.finish{
color:var(--text-success)
}
.error .helper-text{
color:var(--text-error)
}
.ews-icon-emerrorbold{
display:none!important
}
.error .ews-icon-emerrorbold{
color:var(--text-error);
margin-right:5px;
display:inline-block!important
}
.progress{
height:6px;
border:1px solid var(--border);
background:var(--bg);
margin:0px;
vertical-align: top;
width:100%;
border-radius:0 0 4px 4px
}
progress::-moz-progress-bar{background:var(--bg-success)}
progress::-webkit-progress-bar{background:var(--bg)}
progress::-webkit-progress-value{background:var(--bg-success)}

.upload-label{
font-size:var(--body-font-size);
color:var(--text);
}
.ecp-upload-wrapper.align-left {
display: flex;
gap: 16px;
}
.align-left .upload-label {
line-height: 32px;
}
:host(.size-large) .align-left .upload-label {
line-height: 44px;
}
.ecp-upload-wrapper.align-top {
display: flex;
flex-direction: column;
gap: 4px;
}
.ecp-upload-wrapper{
height:inherit
}
`,
            enableIcon: true,
            shadowOptions: {
                mode: "open",
                delegatesFocus: true
            }
        })
    ], UploadWebComponent);
    ECP.UploadWebComponent = UploadWebComponent;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let RadioGroupWebComponent = class RadioGroupWebComponent extends ECP.FormAssociatedElement {
        constructor() {
            super();
            this.disabled = false;
            this.proxy = document.createElement("input");
            this.proxy.type = "radio";
        }
        created() {
            if (EC_Fmt.isNull(this.name)) {
                ECP.HTML.Snackbar("The radio button group does not provide a \"name\" attribute.", "Warning");
            }
        }
        nameChanged(oldValue, newValue) {
            const radios = this.children;
            for (let i = 0; i < radios.length; i++) {
                radios[i].setAttribute("name", newValue);
            }
        }
        valueChanged(oldValue, newValue) {
            super.valueChanged(oldValue, newValue);
            const radios = this.children;
            if (!EC_Fmt.isNull(newValue)) {
                for (let i = 0; i < radios.length; i++) {
                    if (radios[i].getAttribute("value") === newValue) {
                        radios[i].setAttribute("checked", "true");
                        break;
                    }
                }
            }
            else {
                for (let i = 0; i < radios.length; i++) {
                    radios[i].setAttribute("checked", "false");
                }
            }
            this.$emit("value-change", { oldValue, newValue });
        }
        disabledChanged(oldValue, newValue) {
            const radios = this.children;
            for (let i = 0; i < radios.length; i++) {
                radios[i].setAttribute("disabled", newValue);
            }
        }
        alignmentChanged(oldValue, newValue) {
            const radios = this.shadowRoot.querySelector(".ecp-radio-group");
            if (newValue === "vertical") {
                radios.classList.add("vertical");
                radios.classList.remove("horizontal");
            }
            else {
                radios.classList.remove("vertical");
                radios.classList.add("horizontal");
            }
        }
    };
    __decorate([
        ECP.attr
    ], RadioGroupWebComponent.prototype, "value", void 0);
    __decorate([
        ECP.attr
    ], RadioGroupWebComponent.prototype, "name", void 0);
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], RadioGroupWebComponent.prototype, "alignment", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], RadioGroupWebComponent.prototype, "disabled", void 0);
    RadioGroupWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-radio-group",
            template: `<div class="ecp-radio-group horizontal"><slot></slot></div>`,
            styles: `.ecp-radio-group.vertical{
display:flex;
flex-direction:column
}
.ecp-radio-group.vertical ::slotted(*){
margin-top:10px
}
:host .horizontal ::slotted(ecp-radio){
margin-right:10px
}`
        })
    ], RadioGroupWebComponent);
    ECP.RadioGroupWebComponent = RadioGroupWebComponent;
    let RadioWebComponent = class RadioWebComponent extends ECP.Component {
        constructor() {
            super(...arguments);
            this.checked = false;
            this.disabled = false;
        }
        created() {
            const radio = this.shadowRoot.querySelector("input");
            const radioInner = this.shadowRoot.querySelector(".ecp-radio_inner");
            const label = this.shadowRoot.querySelector(".ecp-radio_label");
            radioInner.addEventListener("click", () => {
                if (!this.checked) {
                    radio.setAttribute("checked", "true");
                    this.checked = true;
                }
            });
            label.addEventListener("click", () => {
                if (!this.checked) {
                    radio.setAttribute("checked", "true");
                    this.checked = true;
                }
            });
        }
        labelChanged() {
            this.shadowRoot.querySelector(".ecp-radio_label").innerHTML = this.label || "";
        }
        nameChanged(oldValue, newValue) {
            if (this.shadowRoot.querySelector("input")) {
                this.shadowRoot.querySelector("input").name = this.name || "";
            }
        }
        valueChanged(oldValue, newValue) {
            if (this.shadowRoot.querySelector("input")) {
                this.shadowRoot.querySelector("input").value = newValue;
            }
        }
        checkedChanged() {
            if (this.shadowRoot.querySelector("input")) {
                this.shadowRoot.querySelector("input").checked = this.checked;
            }
            const radioInput = this.shadowRoot.querySelector(".ecp-radio");
            if (this.checked) {
                if (this.name) {
                    const sameName = document.querySelectorAll(`ecp-radio[name='${this.name}']`);
                    if (sameName.length > 1) {
                        sameName.forEach((el) => {
                            if (el !== this) {
                                el.setAttribute("checked", "false");
                            }
                        });
                        const node = this.parentNode;
                        if (node.localName === "ecp-radio-group") {
                            node.setAttribute("value", this.value);
                        }
                    }
                }
                radioInput.classList.add("is-checked");
            }
            else {
                radioInput.classList.remove("is-checked");
            }
            this.$emit("change");
        }
        disabledChanged() {
            this.shadowRoot.querySelector("input").disabled = this.disabled;
            const radioInput = this.shadowRoot.querySelector(".ecp-radio");
            if (this.disabled) {
                radioInput.classList.add("is-disabled");
            }
            else {
                radioInput.classList.remove("is-disabled");
            }
        }
    };
    __decorate([
        ECP.attr({ mode: 'reflect' })
    ], RadioWebComponent.prototype, "value", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], RadioWebComponent.prototype, "label", void 0);
    __decorate([
        ECP.attr({ mode: 'fromView' })
    ], RadioWebComponent.prototype, "name", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], RadioWebComponent.prototype, "checked", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], RadioWebComponent.prototype, "disabled", void 0);
    RadioWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-radio",
            template: `<div class="ecp-radio">
    <span class=ecp-radio_inner>
    <input type=radio class=ecp-radio_original>
    </span>
    <span class="ecp-radio_label"></span>
</div>`,
            styles: `.ecp-radio{
 cursor:pointer;
 user-select:none;
 display:inline-flex;
 align-items:flex-end
}
.ecp-radio.is-disabled .ecp-radio_inner{
background:var(--layer-3);
border-color:var(--border);
pointer-events:none
}
.ecp-radio.is-disabled .ecp-radio_inner:after{
background-color:var(--border)
}
.ecp-radio.is-disabled .ecp-radio_label{
cursor:not-allowed;
pointer-events:none;
color:var(--text-secondary)
}
.ecp-radio.is-disabled.is-checked .ecp-radio_inner{
border-color:var(--border)
}
.ecp-radio.is-checked .ecp-radio_inner:after{
opacity:1;
}
.ecp-radio.is-focus .ecp-radio_inner{
border-color:var(--text-accent)
}
.ecp-radio_inner{
box-sizing:border-box;
display:inline-block;
position:relative;
border:1px solid var(--border);
width:13px;
height:13px;
background-color:var(--bg);
z-index:1;
border-radius:50%;
transition:border-color var(--ecp-duration-fastest) var(--ecp-ease-standard),background-color var(--ecp-duration-fastest) var(--ecp-ease-standard)
}
.ecp-radio.is-checked .ecp-radio_inner{
border-color:var(--text-accent)
}
.ecp-radio.is-checked:hover .ecp-radio_inner,
.ecp-radio.is-checked:hover .ecp-radio_inner:after{
border-color:var(--text-accent)
}
.ecp-radio:hover .ecp-radio_inner{
border-color:var(--border-active)
}
.ecp-radio:hover.is-disabled .ecp-radio_inner{
border-color:var(--border)
}
.ecp-radio_inner:after{
content:"";
width:7px;
height:7px;
position:absolute;
inset:0;
margin:auto;
opacity:0;
background-color:var(--text-accent);
border-radius:50%;
transition:opacity var(--ecp-duration-fastest) var(--ecp-ease-standard);
transform-origin:center;
}
.ecp-radio_original{
opacity:0;
outline:none;
position:absolute;
margin:0;
width:0;
height:0;
z-index:-1
}
.ecp-radio_label{
padding-left:8px;
color: var(--text);
word-wrap:break-word;
line-height:1
}
ecp-radio:last-of-type{
margin-right:0
}
.ecp-radio:hover.is-disabled .ecp-radio_label{
color:var(--text-secondary);
cursor:not-allowed
}`
        })
    ], RadioWebComponent);
    ECP.RadioWebComponent = RadioWebComponent;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPPageHeader = class ECPPageHeader extends ECP.Component {
        constructor() {
            super(...arguments);
            this.type = "object";
            this.return = false;
        }
        created(host) {
            const typeValue = this.type;
            const pageTitle = host.querySelector(".ecp-page-title");
            const leftAction = host.querySelector(".left-action");
            if (typeValue !== "action" && typeValue !== "object") {
                this.setAttribute("type", "object");
            }
            if (typeValue === "object") {
                if (this.return) {
                    leftAction.setAttribute("icon", "ews-icon-arrowleft");
                }
            }
            else if (typeValue === "action") {
                if (this.return) {
                    leftAction.setAttribute("icon", "ews-icon-close");
                    leftAction.setAttribute("inverted", "");
                }
                const buttonArr = host.querySelectorAll("ecp-btn[type=ghost]");
                for (let i = 0; i < buttonArr.length; i++) {
                    buttonArr[i].setAttribute("inverted", "");
                }
                this.innerHTML += "<ecp-page-footer>";
            }
            pageTitle.innerHTML = this.pageTitle;
            host.querySelector(".return-btn").addEventListener("click", () => {
                this.$emit("return");
            });
        }
        pageTitleChanged(oldValue, newValue) {
            if (newValue) {
                const titleEle = this.shadowRoot.querySelector(".ecp-page-title");
                titleEle.innerText = newValue;
            }
        }
    };
    __decorate([
        ECP.attr({ attribute: 'page-title' })
    ], ECPPageHeader.prototype, "pageTitle", void 0);
    __decorate([
        ECP.attr
    ], ECPPageHeader.prototype, "type", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPPageHeader.prototype, "return", void 0);
    ECPPageHeader = __decorate([
        ECP.customElement({
            name: "ecp-page-header",
            template: `<ecp-btn class="left-action return-btn" type="ghost" size="large"></ecp-btn>
        <span class="ecp-page-title"></span><slot></slot>`,
            styles: `
:host{
display:flex;
align-items:center;
padding:0 8px;
height:64px;
font-size:18px
}
:host([type="object"]){
background:rgba(31, 44, 64, 0.08)
}
:host([type="action"]){
background:var(--bg-action);
color:var(--text-onbg-action)
}
:host .ecp-page-title{
flex:1;
padding:0 8px;
word-wrap:break-word
}`
        })
    ], ECPPageHeader);
    ECP.ECPPageHeader = ECPPageHeader;
    let ECPHeaderAction = class ECPHeaderAction extends ECP.Component {
        constructor() {
            super(...arguments);
            this.inverted = false;
        }
        created(host) {
            const actionItemArr = this.children;
            let actionHtml = "";
            for (let i = 0; i < actionItemArr.length; i++) {
                actionHtml += `<ecp-list-item>${actionItemArr[i].outerHTML}</ecp-list-item>`;
            }
            const list = host.querySelector("ecp-list");
            list.innerHTML = actionHtml;
            const overflowButton = host.querySelector(".show-action-button");
            const actionMenu = host.querySelector(".action-menu");
            overflowButton.addEventListener("click", () => {
                actionMenu.ShowMenu(overflowButton);
            });
            if (this.hasAttribute("inverted")) {
                overflowButton.setAttribute("inverted", "");
            }
        }
    };
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPHeaderAction.prototype, "inverted", void 0);
    ECPHeaderAction = __decorate([
        ECP.customElement({
            name: "ecp-overflow-action",
            template: `
        <ecp-btn class="show-action-button" type="ghost" icon="ews-icon-overflow" size="large"></ecp-btn>
        <ecp-menu class="action-menu"><ecp-list type="clickable"></ecp-list></ecp-menu>`,
            enableIcon: true
        })
    ], ECPHeaderAction);
    ECP.ECPHeaderAction = ECPHeaderAction;
    let ECPPageFooter = class ECPPageFooter extends ECP.Component {
        created(host) {
            const overflowAction = this.parentNode.querySelector("ecp-overflow-action");
            if (overflowAction) {
                this.shadowRoot.insertBefore(overflowAction, this.shadowRoot.querySelector(".cancel-btn"));
                const listItemArr = overflowAction.shadowRoot.querySelector(".action-menu").querySelectorAll("ecp-list-item");
                for (let i = 0; i < listItemArr.length; i++) {
                    listItemArr[i].querySelector("ecp-btn").removeAttribute("inverted");
                }
            }
            host.querySelector(".cancel-btn").addEventListener("click", () => {
                this.$emit("cancel");
            });
            host.querySelector(".confirm-btn").addEventListener("click", () => {
                this.$emit("confirm");
            });
        }
    };
    ECPPageFooter = __decorate([
        ECP.customElement({
            name: "ecp-page-footer",
            template: `<ecp-btn class="cancel-btn" type="secondary" size=large>Cancel</ecp-btn>
        <ecp-btn class="confirm-btn" type="primary" size=large>Confirm</ecp-btn>`,
            styles: `
:host{
position:fixed;
bottom:0;
left:32px;
right:32px;
display:flex;
align-items:center;
justify-content:center;
padding-bottom:32px
}
:host > * {
flex:1;
text-align:center
}
:host ecp-btn:not(:last-child){
margin-right:16px
}`,
            enableIcon: true
        })
    ], ECPPageFooter);
    ECP.ECPPageFooter = ECPPageFooter;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    var SelectWebComponent_1;
    let SelectOptionWebComponent = class SelectOptionWebComponent extends ECP.Component {
        constructor() {
            super(...arguments);
            this.selected = false;
        }
        created() {
            if (!this.value) {
                this.setAttribute("value", this.innerText);
            }
            const selectEl = this.parentElement;
            const iconEl = this.shadowRoot.querySelector(".option-icon");
            if (this.icon || selectEl.hasAttribute("icon")) {
                iconEl.classList.remove("hidden");
            }
            else {
                iconEl.classList.add("hidden");
            }
        }
        valueChanged(oldValue, newValue) {
            this.value = newValue;
        }
        iconChanged(oldValue, newValue) {
            const icon = this.shadowRoot.querySelector(".option-icon");
            if (icon) {
                if (newValue) {
                    icon.classList.add(newValue);
                }
                if (oldValue) {
                    icon.classList.remove(oldValue);
                }
            }
        }
        selectedChanged(oldValue, newValue) {
            const icon = this.shadowRoot.querySelector(".option");
            if (newValue) {
                icon.classList.add("selected");
            }
            else {
                icon.classList.remove("selected");
            }
        }
    };
    __decorate([
        ECP.attr
    ], SelectOptionWebComponent.prototype, "value", void 0);
    __decorate([
        ECP.attr
    ], SelectOptionWebComponent.prototype, "icon", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], SelectOptionWebComponent.prototype, "selected", void 0);
    SelectOptionWebComponent = __decorate([
        ECP.customElement({
            name: "ecp-select-option",
            template: `<div class="option"><span class="option-icon"></span><slot></slot></div>`,
            styles: `:host{
  box-sizing:border-box
  }
  .option{
  height:32px;
  cursor:pointer;
  display:flex;
  align-items:center;
  color:var(--text);
  padding:0 12px;
  box-sizing:border-box;
  border-radius:4px;
  border:1px solid transparent
  }
  .option:hover{
  background:var(--bg-hover)
  }
  .option .option-icon{
  display:inline-flex;
  justify-content:center;
  align-items:center;
  margin-right:8px;
  width:12px;
  height:32px;
  color:var(--text-secondary)
  }
  .option.selected{
  background:var(--bg-selected);
  border:1px solid var(--border-selected)
  }
  ::slotted([class*="ews-icon-"]){
  line-height:32px!important
  }
  .hidden{
  display:none!important
  }`,
            enableIcon: true
        })
    ], SelectOptionWebComponent);
    ECP.SelectOptionWebComponent = SelectOptionWebComponent;
    let SelectWebComponent = SelectWebComponent_1 = class SelectWebComponent extends ECP.FormAssociatedElement {
        constructor() {
            super();
            this.type = "Default";
            this.disabled = false;
            this.error = false;
            this.selected = false;
            this.isChanged = false;
            this.proxy = document.createElement("input");
        }
        created(host) {
            super.created(host);
            this.writeDropdownInput();
            SelectWebComponent_1.SelectArr.push(this);
            this.addEventListener("click", (event) => {
                const list = this.shadowRoot.querySelector(".option-list");
                const option = event.target;
                if (option && option.tagName.toLowerCase() === "ecp-select") {
                    this.showList(list);
                    this.shadowRoot.querySelector(".select-container").classList.add("active");
                    this.shadowRoot.querySelector(".select-icon").classList.add("icon-up");
                }
                else {
                    this.hiddenList(list);
                }
            }, false);
            window.addEventListener("resize", (event) => {
                this.hiddenList(this.shadowRoot.querySelector(".option-list"));
            });
            const input = this.shadowRoot.querySelector(".select-input");
            input.addEventListener("keydown", (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.OnKeyDown(event, this);
            });
            const clearBtn = host.querySelector(".ews-icon-close");
            clearBtn.addEventListener("click", (event) => {
                if (this.labelAlign == "inline") {
                    this.$emit("clear");
                    this.value = "";
                    event.stopPropagation();
                }
            });
            const btn = host.querySelector(".ews-icon-caretdown");
            const container = this.shadowRoot.querySelector(".select-container");
            this.addEventListener("mouseenter", (event) => {
                if (this.label && this.labelAlign == "inline") {
                    if (this.value) {
                        btn.classList.remove("hidden");
                        clearBtn.classList.add("hidden");
                    }
                    container.classList.add("hover");
                }
            });
            this.addEventListener("mouseout", (event) => {
                if (this.label && this.labelAlign == "inline") {
                    if (this.value) {
                        btn.classList.add("hidden");
                        clearBtn.classList.remove("hidden");
                    }
                    else {
                        btn.classList.remove("hidden");
                        clearBtn.classList.add("hidden");
                    }
                    container.classList.remove("hover");
                }
            }, false);
            btn.addEventListener("mouseenter", (event) => {
                event.stopPropagation();
                if (this.label && this.labelAlign == "inline") {
                    if (this.value) {
                        btn.classList.add("hidden");
                        clearBtn.classList.remove("hidden");
                        container.classList.remove("hover");
                    }
                    else {
                        btn.classList.remove("hidden");
                        clearBtn.classList.add("hidden");
                    }
                }
            });
            this.applyGhostState();
            this.applyGhostDefaultValue();
            ECP.Updates.enqueue(() => this.syncSelectedOption());
        }
        isGhost() {
            return !!(this.type && this.type.toLowerCase() === "ghost");
        }
        syncSelectedOption() {
            const value = this.value;
            const allOptions = this.querySelectorAll("ecp-select-option");
            allOptions.forEach((option) => {
                option.selected = !!value && option.value === value;
            });
            if (!value) {
                return;
            }
            const input = this.shadowRoot.querySelector(".select-input");
            const option = this.querySelector(`ecp-select-option[value='${value}']`);
            if (input && option) {
                input.value = option.innerText;
                this.icon = option.getAttribute("icon");
            }
        }
        applyGhostState() {
            this.shadowRoot.querySelector(".select-container").classList.toggle("ghost", this.isGhost());
        }
        applyGhostDefaultValue() {
            if (!this.isGhost() || this.value) {
                return;
            }
            ECP.Updates.enqueue(() => {
                if (!this.isGhost() || this.value) {
                    return;
                }
                const firstOption = this.querySelector("ecp-select-option");
                if (firstOption) {
                    this.value = firstOption.value;
                }
            });
        }
        OnKeyDown(event, el) {
            const items = el.querySelectorAll("ecp-select-option");
            if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter") {
                let tag = 0;
                if (event.key === "ArrowDown") {
                    if (el.value) {
                        for (let i = 0; i < items.length; i++) {
                            const item = items[i];
                            if (item.value == el.value) {
                                tag = i + 1;
                                break;
                            }
                        }
                    }
                    if (tag >= items.length) {
                        tag = 0;
                    }
                }
                else if (event.key === "ArrowUp") {
                    if (el.value) {
                        for (let i = 0; i < items.length; i++) {
                            const item = items[i];
                            if (item.value == el.value) {
                                tag = i - 1;
                                break;
                            }
                        }
                    }
                    if (tag < 0) {
                        tag = items.length - 1;
                    }
                }
                else if (event.key === "Enter") {
                    el.hiddenList(el.shadowRoot.querySelector(".option-list"));
                    return;
                }
                const option = items[tag];
                el.value = option.value;
                option.setAttribute("selected", "true");
            }
        }
        hiddenList(list) {
            if (list.style.display == "flex") {
                if (this.isChanged) {
                    list.classList.add("animation-disappear-to-bottom");
                }
                else {
                    list.classList.add("animation-disappear-to-top");
                }
                list.addEventListener("animationend", () => {
                    list.style.display = "none";
                    list.style.top = "";
                    list.style.left = "";
                    list.style.maxWidth = "";
                    this.shadowRoot.querySelector(".select-container").classList.remove("active");
                    this.shadowRoot.querySelector(".select-icon").classList.remove("icon-up");
                    list.classList.remove("animation-disappear-to-top", "animation-appear-from-top", "animation-disappear-to-bottom");
                    this.isChanged = false;
                }, { once: true });
            }
        }
        showList(list) {
            if (list.style.display !== "flex") {
                requestAnimationFrame(() => {
                    const bodyWidth = document.documentElement.clientWidth;
                    if (this.offsetWidth) {
                        list.style.minWidth = Math.min(this.offsetWidth, bodyWidth) + "px";
                    }
                    list.style.display = "flex";
                    list.classList.add("animation-appear-from-top");
                    const rect = this.getBoundingClientRect();
                    const bodyHeight = window.innerHeight;
                    const InputTop = Math.ceil(rect.top);
                    const InputHeight = this.offsetHeight;
                    let ResultsHeight = Math.ceil(list.offsetHeight);
                    let Top = InputTop + InputHeight;
                    const headerHeight = document.getElementById("Header")?.offsetHeight || 0;
                    if (Top + ResultsHeight > bodyHeight) {
                        const bottomSpaceHeight = bodyHeight - Top;
                        if (bottomSpaceHeight < InputTop) {
                            Top = InputTop - ResultsHeight - InputHeight + 10;
                            if (Top < 0 || Top < headerHeight) {
                                ResultsHeight += Top - headerHeight;
                                Top = headerHeight;
                            }
                        }
                        else {
                            ResultsHeight = bodyHeight - Top;
                        }
                    }
                    list.style.maxWidth = bodyWidth + "px";
                    let Left = Math.ceil(rect.left);
                    const listWidth = Math.ceil(list.getBoundingClientRect().width);
                    if (Left + listWidth > bodyWidth) {
                        Left = Math.max(0, bodyWidth - listWidth);
                    }
                    if (Left < 0) {
                        Left = 0;
                    }
                    list.style.top = `${Top}px`;
                    list.style.left = `${Left}px`;
                    list.style.height = `${ResultsHeight}px`;
                });
            }
            else {
                this.hiddenList(list);
            }
        }
        writeDropdownInput() {
            const selectList = this.shadowRoot.querySelector(".option-list");
            const me = this;
            selectList.addEventListener("click", (event) => {
                const option = event.target;
                if (option && option.tagName.toLowerCase() === "ecp-select-option") {
                    me.value = option.value;
                    this.hiddenList(this.shadowRoot.querySelector(".option-list"));
                }
            }, false);
        }
        nameChanged(oldValue, newValue) {
            const input = this.shadowRoot.querySelector(".select-input");
            if (input) {
                input.name = newValue;
            }
        }
        placeholderChanged(oldValue, newValue) {
            const input = this.shadowRoot.querySelector(".select-input");
            if (input) {
                input.placeholder = newValue || "";
            }
            if (this.label && this.labelAlign === "inline") {
                const labelInline = this.shadowRoot.querySelector(".label-inline");
                labelInline.innerHTML = newValue || this.value ? this.label + ":" : this.label;
            }
        }
        valueChanged(oldValue, newValue) {
            super.valueChanged(oldValue, newValue);
            const input = this.shadowRoot.querySelector(".select-input");
            const allOptions = this.querySelectorAll("ecp-select-option");
            allOptions.forEach((option) => {
                option.selected = !!newValue && option.value === newValue;
            });
            if (newValue) {
                this.setAttribute("value", newValue);
                if (input) {
                    const option = this.querySelector(`ecp-select-option[value='${newValue}']`);
                    if (option) {
                        input.value = option.innerText;
                        this.icon = option.getAttribute("icon");
                    }
                }
                if (newValue !== oldValue) {
                    this.isChanged = true;
                }
                else {
                    this.isChanged = false;
                }
                this.selectedChanged(false, true);
            }
            else {
                input.value = "";
                this.selectedChanged(false, false);
                this.isChanged = false;
            }
            this.$emit("change");
            if (this.label && this.labelAlign === "inline") {
                const labelInline = this.shadowRoot.querySelector(".label-inline");
                labelInline.innerHTML = newValue || this.placeholder ? this.label + ":" : this.label;
            }
        }
        disabledChanged(oldValue, newValue) {
            const selectContainer = this.shadowRoot.querySelector(".select-container");
            if (newValue) {
                selectContainer.classList.add("disabled");
                this.classList.add("Disabled");
            }
            else {
                selectContainer.classList.remove("disabled");
                this.classList.remove("Disabled");
            }
        }
        sizeChanged(oldValue, newValue) {
            if (newValue && newValue.toLowerCase() === "large") {
                this.shadowRoot.querySelector(".ecp-select").classList.add("select-large");
            }
            else {
                this.shadowRoot.querySelector(".ecp-select").classList.remove("select-large");
            }
        }
        helperTextChanged(oldValue, newValue) {
            const helperText = this.shadowRoot.querySelector(".helper-text");
            if (helperText) {
                const value = this.isGhost() ? "" : newValue;
                helperText.innerHTML = value || "";
            }
        }
        typeChanged(oldValue, newValue) {
            this.applyGhostState();
            this.labelChanged(this.label, this.label);
            this.helperTextChanged(this.helperText, this.helperText);
            this.errorChanged(this.error, this.error);
            this.applyGhostDefaultValue();
        }
        iconChanged(oldValue, newValue) {
            const selectContainer = this.shadowRoot.querySelector(".ecp-select");
            const icon = this.shadowRoot.querySelector(".select-left-icon");
            if (icon) {
                if (newValue) {
                    icon.classList.add(newValue);
                }
                if (oldValue) {
                    icon.classList.remove(oldValue);
                }
            }
            else if (newValue) {
                const newIcon = document.createElement("i");
                newIcon.classList.add("select-left-icon", newValue);
                selectContainer.appendChild(newIcon);
            }
            if (newValue) {
                selectContainer.classList.add("has-left-icon");
            }
            else if (!this.querySelector("ecp-select-option[icon]")) {
                selectContainer.classList.remove("has-left-icon");
            }
        }
        labelChanged(oldValue, newValue) {
            const outer = this.shadowRoot.querySelector(".ecp-select");
            const label = this.shadowRoot.querySelector(".label");
            const labelInline = this.shadowRoot.querySelector(".label-inline");
            const container = this.shadowRoot.querySelector(".select-container");
            if (this.isGhost()) {
                outer.classList.remove("flex");
                label.innerHTML = "";
                label.classList.remove("label-column");
                labelInline.innerHTML = "";
                labelInline.classList.add("hidden");
                container.classList.remove("inline");
                this.selected = false;
                return;
            }
            if (!newValue) {
                label.innerHTML = "";
                labelInline.innerHTML = "";
                this.selected = false;
                container.classList.remove("inline");
                if (this.labelAlign) {
                    this.labelAlign = null;
                }
                return;
            }
            if (this.labelAlign == "inline") {
                labelInline.innerHTML = (this.value || this.placeholder) ? newValue + ":" : newValue;
                container.classList.add("inline");
                if (this.value) {
                    this.selected = true;
                }
            }
            else if (label) {
                label.innerHTML = newValue;
                container.classList.remove("inline");
            }
        }
        labelAlignChanged(oldValue, newValue) {
            if (this.isGhost()) {
                return;
            }
            if (this.label && newValue) {
                const selectContainer = this.shadowRoot.querySelector(".ecp-select");
                const label = this.shadowRoot.querySelector(".label");
                const labelInline = this.shadowRoot.querySelector(".label-inline");
                const container = this.shadowRoot.querySelector(".select-container");
                if (newValue === "top") {
                    selectContainer.classList.remove("flex");
                    labelInline.classList.add("hidden");
                    label.classList.remove("hidden", "label-column");
                    container.classList.remove("inline");
                    this.selectedChanged(false, false);
                }
                else if (newValue === "left") {
                    selectContainer.classList.add("flex");
                    label.classList.add("label-column");
                    label.innerHTML = this.label;
                    labelInline.classList.add("hidden");
                    label.classList.remove("hidden");
                    container.classList.remove("inline");
                    this.selectedChanged(false, false);
                }
                else {
                    labelInline.innerHTML = this.value || this.placeholder ? this.label + ":" : this.label;
                    labelInline.classList.remove("hidden");
                    label.classList.add("hidden");
                    container.classList.add("inline");
                    if (this.value) {
                        this.selectedChanged(false, true);
                    }
                }
            }
        }
        errorChanged(oldValue, newValue) {
            const inputEl = this.shadowRoot.querySelector(".select-container");
            const value = this.isGhost() ? false : newValue;
            if (value) {
                inputEl.classList.add("error");
            }
            else {
                inputEl.classList.remove("error");
            }
        }
        selectedChanged(oldValue, newValue) {
            const clearBtn = this.shadowRoot.querySelector(".ews-icon-close");
            const container = this.shadowRoot.querySelector(".select-container");
            const btn = this.shadowRoot.querySelector(".ews-icon-caretdown");
            if (this.labelAlign == "inline" && newValue) {
                if (this.value) {
                    clearBtn.classList.remove("hidden");
                    btn.classList.add("hidden");
                }
                container.classList.add("selected");
            }
            else {
                clearBtn.classList.add("hidden");
                btn.classList.remove("hidden");
                container.classList.remove("selected");
            }
        }
    };
    SelectWebComponent.SelectArr = [];
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "name", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "value", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "placeholder", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "helperText", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "label", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "labelAlign", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "size", void 0);
    __decorate([
        ECP.attr
    ], SelectWebComponent.prototype, "type", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], SelectWebComponent.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], SelectWebComponent.prototype, "error", void 0);
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], SelectWebComponent.prototype, "selected", void 0);
    SelectWebComponent = SelectWebComponent_1 = __decorate([
        ECP.customElement({
            name: "ecp-select",
            template: `<div class="ecp-select">
            <div class="label"></div>
            <div class="full-width"><div class="select-container">
            <span class="label-inline hidden"></span>
            <i class="select-left-icon"></i>
            <input class="select-input" readonly></input>
            <span class="select-icon ews-icon-caretdown"></span>
            <span class="select-icon ews-icon-close hidden"></span></div>
            <div class="helper-text"></div>
            <div class="option-list"><slot></slot></div>
            </div></div>`,
            styles: `
  :host{
  box-sizing:border-box!important;
  width:100%;
  font-size:var(--body-font-size);
  line-height:var(--body-line-height)
  }
  .select-large .select-container,
  .select-large .label.label-column{
  height:44px !important;
  line-height:44px !important
  }
  .select-container{
  background:var(--bg);
  height:32px;
  border-radius:4px;
  border:1px solid var(--border);
  display:flex;
  align-items:center;
  padding-left:12px;
  box-sizing:border-box
  }
  .select-icon{
  width:26px;
  min-width:18px;
  text-align:center;
  height:20px;
  border-radius:50%;
  margin-right:8px;
  line-height:20px !important;
  cursor:pointer
  }
  .ecp-select .select-input{
  border:none;
  border-radius:4px;
  font-weight:var(--regular-weight);
  font-family:Open Sans, Segoe UI, SF Pro Text, Helvetica, Helvetica Neue, Arial, Tahoma, sans-serif;
  margin:0;
  padding:0 5px;
  appearance:none;
  position:relative;
  z-index:10;
  padding:0 8px 0 0;
  width:100%;
  height:100%;
  color:var(--text);
  font-size:inherit;
  background:transparent;
  cursor:pointer;
  box-sizing:border-box
  }
  .ecp-select .select-input::placeholder{
  color:var(--text-placeholder)
  }
  .ecp-select .select-input:active,
  .ecp-select .select-input:focus,
  .select-container.active{
  border-color:var(--border-active) !important;
  outline:0
  }
  .ecp-select.has-left-icon .select-left-icon{
  flex-shrink:0;
  margin-top:2px;
  color:var(--text-secondary);
  margin-right:8px;
  width:12px;
  display:inline-flex;
  align-items:center;
  justify-content:center
  }
  .ecp-select .disabled{
  border-color:var(--bg-object);
  background:var(--bg-object);
  color:var(--text-secondary);
  pointer-events:none
  }
  .option-list{
  display:none;
  background:var(--bg);
  border:solid 1px var(--border);
  border-radius:8px;
  box-shadow:0 2px 6px rgba(0,0,0,0.2);
  transition-property:transform;
  padding:12px 8px;
  flex-direction:column;
  position:fixed;
  z-index:300;
  margin-top:10px;
  box-sizing:border-box;
  max-height:270px;
  overflow:auto
  }
  .helper-text{
  font-size:10px;
  color:var(--text-secondary)
  }
  .flex{
  display:flex
  }
  .flex .label{
  margin-right:12px;
  height:32px;
  line-height:32px;
  margin-bottom:0
  }
  .label{
  margin-bottom:4px
  }
  .label:empty{
  margin-bottom:0
  }
  .error{
  border-color:var(--text-error)!important
  }
  .select-container.ghost{
  border-color:transparent;
  background:transparent;
  padding:0 12px
  }
  .select-container.ghost:hover,
  .select-container.ghost.active{
  border-color:transparent!important;
  background:var(--bg-hover)
  }
  .select-container.ghost .select-input{
  padding-right:8px;
  color:var(--text-link);
  font-weight:var(--semibold-weight)
  }
  .select-container.ghost .select-icon{
  width:auto;
  min-width:0;
  margin-right:0;
  color:var(--text-link)
  }
  .select-container.ghost .select-left-icon{
  color:var(--text-link)
  }
  .full-width{
  width:100%
  }
  .inline .label-inline{
  margin-right:8px
  }
  .hidden{
  display:none!important
  }
  .icon-up{
  transform:rotate(180deg)
  }
  .ews-icon-close{
  font-size:10px!important
  }
  .inline.selected  .select-input{
  font-weight:var(--semibold-weight)
  }
  .inline.hover{
  background:var(--bg-hover)!important
  }
  .inline.selected{
  background:var(--bg-selected);
  border:1px solid var(--border-selected)
  }
  .inline.selected.hover{
  background:var(--bg-selected-hover)!important
  }
  .inline.selected .ews-icon-close:hover{
  background:var(--bg-object)
  }
  .inline{
  transition:border-color var(--ecp-duration-fastest) var(--ecp-ease-standard),background-color var(--ecp-duration-fastest) var(--ecp-ease-standard)
  }
  .animation-appear-from-top {
    transform-origin: center top;
    animation: ecp-keyframe-appearfromtop var(--ecp-duration-fast);
  }
  .animation-disappear-to-top {
    transform-origin: center top;
    animation: ecp-keyframe-disappeartotop var(--ecp-duration-fast);
  }
  .animation-disappear-to-bottom {
    transform-origin: center top;
    animation: ecp-keyframe-disappeartobottom var(--ecp-duration-fast);
  }
  @keyframes ecp-keyframe-appearfromtop {

    0% {
        opacity: 0;
        translate: 0 -0.5rem
    }

    100% {
        opacity: 1;
        translate: 0
    }
  }
  @keyframes ecp-keyframe-disappeartotop {
    0% {
        opacity: 1;
        translate: 0
    }

    100% {
        opacity: 0;
        translate: 0 -0.5rem
    }
  }
  @keyframes ecp-keyframe-disappeartobottom {

    0% {
        opacity: 1;
        translate: 0
    }

    100% {
        opacity: 0;
        translate: 0 0.5rem
    }
  }`,
            enableIcon: true,
            shadowOptions: {
                mode: "open",
                delegatesFocus: true
            }
        })
    ], SelectWebComponent);
    ECP.SelectWebComponent = SelectWebComponent;
    window.addEventListener("click", (e) => {
        for (let i = 0; i < SelectWebComponent.SelectArr.length; i++) {
            const ecpSelect = SelectWebComponent.SelectArr[i];
            if (ecpSelect) {
                const list = ecpSelect.shadowRoot.querySelector(".option-list");
                if (list.style.display == "flex") {
                    ecpSelect.hiddenList(list);
                }
            }
        }
    });
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    var ECPInlineAdd_1;
    let ECPInlineAdd = ECPInlineAdd_1 = class ECPInlineAdd extends ECP.Component {
        constructor() {
            super(...arguments);
            this.isSerchClear = false;
            this.OriginalDom = null;
        }
        debounceSearch(kw) {
            this.timer = setTimeout(() => {
                this.getSuggestList(kw);
            }, 500);
        }
        getSuggestList(kw) {
            this.shadowRoot.querySelector(".search-list").innerHTML = "";
            const list = this.querySelectorAll("ecp-list-item");
            let hasResult = false;
            for (let i = 0; i < list.length; i++) {
                const item = list[i];
                item.classList.add("hidden");
                if (item.innerText && item.innerText.toLowerCase().includes(kw.toLowerCase())) {
                    item.classList.remove("hidden");
                    hasResult = true;
                }
            }
            if (!hasResult) {
                this.shadowRoot.querySelector(".search-list").innerHTML = `No Similar Records Found Like ${kw}`;
                for (let i = 0; i < list.length; i++) {
                    const item = list[i];
                    item.classList.remove("hidden");
                }
            }
        }
        created() {
            this.classList.add("slide", "motion-moderate");
            ECPInlineAdd_1.AddArr.push(this);
            if (EC_Fmt.isMobile) {
                this.OriginalDom = this.parentElement;
            }
            const searchInput = this.shadowRoot.querySelector(".search-input");
            const closeBtn = this.shadowRoot.querySelector(".ews-icon-close");
            searchInput.addEventListener("keyup", (event) => {
                this.OnKeyDown(event, searchInput, closeBtn);
            });
            this.addEventListener("click", (event) => {
                if (this.isSerchClear) {
                    const item = event.target;
                    const itemNode = item.parentNode;
                    if (item.tagName.toLocaleLowerCase() === "ecp-list-item" || itemNode.tagName.toLocaleLowerCase() === "ecp-list-item") {
                        const searchInput = this.shadowRoot.querySelector(".search-input");
                        if (searchInput) {
                            this.classList.remove("slide-show");
                            this.style.display = "none";
                            closeBtn.click();
                            if (EC_Fmt.isMobile && this.parentElement) {
                                const section = this.parentElement.parentElement;
                                if (section && section.classList.contains("inline-add")) {
                                    this.OriginalDom.appendChild(this);
                                    document.body.removeChild(section);
                                }
                            }
                        }
                    }
                }
                event.stopPropagation();
            });
            closeBtn.addEventListener("click", (event) => {
                event.stopPropagation();
                searchInput.value = "";
                this.shadowRoot.querySelector(".search-list").innerHTML = "";
                searchInput.focus();
                closeBtn.classList.add("hidden");
                const items = this.querySelectorAll("ecp-list-item.hidden");
                for (let i = 0; i < items.length; i++) {
                    items[i].classList.remove("hidden");
                }
            });
        }
        OnKeyDown(event, searchInput, closeBtn) {
            if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter") {
                const items = this.querySelectorAll("ecp-list-item:not(.hidden)");
                const option = this.querySelector("ecp-list-item.select");
                if (option) {
                    option.classList.remove("select");
                }
                let tag = 0;
                if (event.key === "ArrowDown") {
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        if (item == option) {
                            tag = i + 1;
                            break;
                        }
                    }
                    if (tag >= items.length) {
                        tag = 0;
                    }
                }
                else if (event.key === "ArrowUp") {
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        if (item == option) {
                            tag = i - 1;
                            break;
                        }
                    }
                    if (tag < 0) {
                        tag = items.length - 1;
                    }
                }
                else if (event.key === "Enter") {
                    const selectItem = items[tag];
                    selectItem.removeAttribute("class");
                    selectItem.click();
                    return;
                }
                items[tag].classList.add("select");
            }
            else {
                clearTimeout(this.timer);
                const keywords = searchInput.value.trim();
                if (keywords.length > 0) {
                    closeBtn.classList.remove("hidden");
                }
                else {
                    closeBtn.classList.add("hidden");
                }
                this.debounceSearch(keywords);
            }
        }
        ShowInlineAdd(triggerElement) {
            const searchInput = this.shadowRoot.querySelector(".search-input");
            searchInput.placeholder = triggerElement.innerText;
            if (this.style.display === "block") {
                this.style.display = "none";
                requestAnimationFrame(() => {
                    const height = this.offsetHeight;
                    this.style.transform = `translateY(${height}px)`;
                });
            }
            else {
                const rect = triggerElement.getBoundingClientRect();
                this.style.display = "block";
                if (EC_Fmt.isMobile) {
                    const section = document.createElement("section");
                    section.classList.add("inline", "inline-add");
                    const conDiv = document.createElement("div");
                    conDiv.classList.add("ews-dialog-mobile", "ews-dialog", "slide", "slide-show");
                    conDiv.style.zIndex = "320";
                    conDiv.style.display = "flex";
                    conDiv.style.flexDirection = "column";
                    conDiv.addEventListener("click", () => {
                        this.OriginalDom.appendChild(this);
                        document.body.removeChild(section);
                    });
                    const items = this.querySelectorAll("ecp-list-item");
                    if (items.length > 0) {
                        items.forEach((item) => {
                            item.style.justifyContent = "flex-start";
                        });
                    }
                    conDiv.appendChild(this);
                    section.appendChild(conDiv);
                    document.body.appendChild(section);
                }
                requestAnimationFrame(() => {
                    searchInput.focus();
                    this.classList.add("slide-show");
                    if (EC_Fmt.isMobile) {
                        this.style.maxHeight = "80%";
                        this.style.width = "100%";
                        this.style.borderRadius = "8px 8px 0 0";
                    }
                    else {
                        this.style.maxHeight = "300px";
                        const menuHeight = this.offsetHeight;
                        let top = rect.top + triggerElement.offsetHeight;
                        const menuWidth = this.offsetWidth;
                        let left = rect.left;
                        const rightMargin = window.innerWidth - triggerElement.offsetWidth - left;
                        const leftMargin = triggerElement.offsetWidth + rect.left;
                        if ((menuHeight + top) > window.innerHeight && top > menuHeight) {
                            top -= menuHeight + 37;
                            this.classList.add("slide-bottom");
                        }
                        if ((menuHeight + top) > window.innerHeight) {
                            this.style.bottom = "16px";
                        }
                        if ((this.offsetWidth + left) > window.innerWidth && left > (this.offsetWidth - triggerElement.offsetWidth)) {
                            left = (left - this.offsetWidth) + triggerElement.offsetWidth;
                        }
                        this.style.top = `${top}px`;
                        if ((menuWidth > rightMargin) && (menuWidth > leftMargin)) {
                            this.style.left = "0";
                            this.style.right = "0";
                        }
                        else {
                            this.style.left = `${left}px`;
                            this.style.right = "unset";
                        }
                    }
                });
            }
        }
    };
    ECPInlineAdd.AddArr = [];
    __decorate([
        ECP.attr({ mode: 'boolean' })
    ], ECPInlineAdd.prototype, "isSerchClear", void 0);
    ECPInlineAdd = ECPInlineAdd_1 = __decorate([
        ECP.customElement({
            name: "ecp-inline-add",
            template: `<div>
        <div class="search-container"><span class="ews-icon-search"></span><input class="search-input"/><span class="ews-icon-close hidden"></span>
        </div><div class="search-list"></div><slot></slot><div>`,
            styles: `
:host{
display:none;
position:fixed;
z-index:666;
width:max-content;
background:var(--bg);
border:solid 1px var(--border);
border-radius:8px;
box-shadow:0 2px 6px rgba(0,0,0,0.2);
transition-property:transform;
padding-bottom:16px;
font-size:13px;
box-sizing:border-box;
overflow:auto
}
::slotted(ecp-list){
padding:0px
}
.search-container{
display: flex;
align-items: center;
padding:16px 16px 0 16px
}
.ews-icon-search,
.ews-icon-close{
color:var(--text-placeholder)
}
.ews-icon-close{
cursor:pointer
}
.search-input{
height:32px;
line-height:32px;
box-sizing:border-box;
margin:0 0 0 12px;
padding:0;
border:none;
outline:none;
background:transparent;
color:var(--text);
font-size:var(--body-font-size);
flex:1
}
.search-input::placeholder{
color:var(--text-placeholder)
}
.search-list{
cursor:pointer;
color:var(--text-placeholder);
padding:0 16px
}
.hidden{
display:none!important
}`,
            enableIcon: true
        })
    ], ECPInlineAdd);
    ECP.ECPInlineAdd = ECPInlineAdd;
    window.addEventListener("click", () => {
        for (let i = 0; i < ECPInlineAdd.AddArr.length; i++) {
            const ecpMenu = ECPInlineAdd.AddArr[i];
            if (ecpMenu) {
                if (ecpMenu.classList.contains("slide-show")) {
                    ecpMenu.classList.remove("slide-show");
                    ecpMenu.style.display = "none";
                }
            }
        }
    });
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPIllustration = class ECPIllustration extends ECP.Component {
        created() {
            const sizeValue = this.getAttribute("size").toLowerCase();
            const classValue = this.getAttribute("illustration");
            this.shadowRoot.querySelector("span").setAttribute("class", `${classValue}`);
            this.shadowRoot.querySelector("span").setAttribute("size", sizeValue);
        }
        sizeChanged(oldValue, newValue) {
            const iconEle = this.shadowRoot.querySelector("span");
            if (newValue) {
                iconEle.setAttribute("size", newValue);
            }
        }
        illustrationChanged(oldValue, newValue) {
            const iconEle = this.shadowRoot.querySelector("span");
            if (newValue) {
                iconEle.setAttribute("class", newValue);
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPIllustration.prototype, "size", void 0);
    __decorate([
        ECP.attr
    ], ECPIllustration.prototype, "illustration", void 0);
    __decorate([
        ECP.attr
    ], ECPIllustration.prototype, "image", void 0);
    ECPIllustration = __decorate([
        ECP.customElement({
            name: "ecp-illustration",
            template: `<span></span>`,
            styles: `
:host{
display:inline-flex;
align-items:center
}
span{
color:inherit
}
span[size=s]{
font-size:24px;
line-height: 24px;
}
span[size=m]{
font-size:32px;
line-height: 32px;
}
span[size=l]{
font-size:64px;
line-height: 64px;
}
span[size=xl]{
font-size:128px;
line-height: 128px;
}
:host([image]) span[size=s]{
width:24px;
height:24px;
}
:host([image]) span[size=m]{
width:32px;
height:32px;
}
:host([image]) span[size=l]{
width:64px;
height:64px;
}
:host([image]) span[size=xl]{
width:128px;
height:128px;
}
`,
            enableIcon: true
        })
    ], ECPIllustration);
    ECP.ECPIllustration = ECPIllustration;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPProgressBar = class ECPProgressBar extends ECP.Component {
        created(host) {
            const me = this;
            const progress = me.shadowRoot.querySelector(".ecp-progress");
            if (me.label) {
                if (me.labelAlign) {
                    progress.setAttribute("label-align", `${me.labelAlign}`);
                }
            }
            me.createLastProgressItem();
            const itemArrTemp = me.querySelectorAll("ecp-progressbar-item");
            itemArrTemp[0].classList.add("left-radius");
            itemArrTemp[itemArrTemp.length - 1].classList.add("right-radius");
        }
        labelChanged(oldValue, newValue) {
            const me = this;
            if (oldValue !== undefined) {
                const label = this.shadowRoot.querySelector(".progress-label");
                label.innerHTML = newValue;
            }
            else {
                const progressContainer = me.shadowRoot.querySelector(".progressbar-container");
                const span = document.createElement("span");
                span.classList.add("progress-label");
                span.innerHTML = me.label;
                progressContainer.parentNode.insertBefore(span, progressContainer);
            }
        }
        labelAlignChanged(oldValue, newValue) {
            const me = this;
            const progress = me.shadowRoot.querySelector(".ecp-progress");
            if (me.label && oldValue !== undefined) {
                progress.setAttribute("label-align", `${newValue}`);
            }
            else if (me.label && oldValue === undefined) {
                progress.setAttribute("label-align", `${newValue}`);
            }
        }
        helperTextChanged(oldValue, newValue) {
            const me = this;
            if (oldValue !== undefined) {
                const helperText = this.shadowRoot.querySelector(".helper-text");
                if (helperText) {
                    if (newValue) {
                        helperText.innerHTML = `${newValue}`;
                    }
                    else {
                        helperText.innerHTML = "";
                    }
                }
            }
            else {
                const progressContainer = me.shadowRoot.querySelector(".progressbar-container");
                const span = document.createElement("span");
                span.classList.add("helper-text");
                span.innerHTML = `${newValue}`;
                progressContainer.appendChild(span);
            }
        }
        stepsChanged(oldValue, newValue) {
            const me = this;
            if (newValue) {
                const progressItemArr = me.querySelectorAll("ecp-progressbar-item:not(.spare-item)");
                let progressValTemp = 0;
                for (let i = 0; i < progressItemArr.length; i++) {
                    const progressVal = parseInt(progressItemArr[i].getAttribute("progress"), 10);
                    const widthVal = Math.floor(progressVal * 100 / newValue);
                    progressItemArr[i].style.width = `${widthVal}%`;
                    progressValTemp += parseInt(progressItemArr[i].getAttribute("progress"), 10);
                }
                const spareItem = me.querySelector(".spare-item");
                if (parseInt(newValue, 10) < progressValTemp) {
                    ECP.HTML.Snackbar("Steps is smaller than items' progress. Please check it.", "Error");
                }
                else if (parseInt(newValue, 10) === progressValTemp) {
                    if (spareItem) {
                        spareItem.remove();
                    }
                    progressItemArr[progressItemArr.length - 1].classList.add("right-radius");
                }
                else {
                    if (spareItem) {
                        spareItem.remove();
                    }
                    if (parseInt(oldValue, 10) === progressValTemp) {
                        progressItemArr[progressItemArr.length - 1].classList.remove("right-radius");
                    }
                    me.createLastProgressItem();
                }
            }
        }
        bgColorChanged(oldValue, newValue) {
            const me = this;
            const spareItem = me.querySelector(".spare-item");
            if (newValue !== "") {
                if (spareItem) {
                    spareItem.remove();
                    this.createLastProgressItem();
                    me.querySelector(".spare-item").setAttribute("bg-color", `${newValue}`);
                }
            }
            else {
                if (spareItem) {
                    spareItem.remove();
                    this.createLastProgressItem();
                    me.querySelector(".spare-item").classList.add("right-radius");
                }
            }
        }
        createLastProgressItem() {
            const me = this;
            const itemArr = me.querySelectorAll("ecp-progressbar-item");
            let progressCount = 0;
            for (let i = 0; i < itemArr.length; i++) {
                progressCount += parseInt(itemArr[i].getAttribute("progress"), 10);
            }
            if ((me.steps && me.steps > progressCount) || (!me.steps && progressCount < 100)) {
                const progressItem = document.createElement("ecp-progressbar-item");
                progressItem.classList.add("spare-item");
                progressItem.classList.add("right-radius");
                if (me.bgColor) {
                    progressItem.setAttribute("bg-color", `${me.bgColor}`);
                }
                if (me.steps && me.steps > progressCount) {
                    const leftItem = me.steps - progressCount;
                    progressItem.setAttribute("progress", leftItem.toString());
                }
                me.appendChild(progressItem);
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPProgressBar.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressBar.prototype, "steps", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressBar.prototype, "label", void 0);
    __decorate([
        ECP.attr({ attribute: 'label-align' })
    ], ECPProgressBar.prototype, "labelAlign", void 0);
    __decorate([
        ECP.attr({ attribute: 'helper-text' })
    ], ECPProgressBar.prototype, "helperText", void 0);
    __decorate([
        ECP.attr({ attribute: 'bg-color' })
    ], ECPProgressBar.prototype, "bgColor", void 0);
    ECPProgressBar = __decorate([
        ECP.customElement({
            name: "ecp-progressbar",
            template: `<div class="ecp-progress"><div class="progressbar-container"><div class="progressbar-group"><slot></slot></div></div></div>`,
            styles: `
:host{
display:block
}
:host([type="segmented"]){
margin-right:-4px
}
.ecp-progress[label-align="top"] .progress-label{
display:block;
margin-bottom:4px
}
.ecp-progress[label-align="left"]{
display:flex;
align-items:baseline
}
.ecp-progress[label-align="left"] .progress-label{
margin-right:16px
}
.ecp-progress[label-align="right"]{
display:flex;
flex-direction:row-reverse;
align-items:baseline
}
.ecp-progress[label-align="right"] .progress-label{
margin-left:16px
}
.ecp-progress .helper-text{
display:block;
margin-top:4px;
font-size:10px;
color:var(--text-secondary)
}
.ecp-progress .progressbar-container{
flex:1
}
.progressbar-group{
display:flex
}`
        })
    ], ECPProgressBar);
    ECP.ECPProgressBar = ECPProgressBar;
    let ECPProgressItem = class ECPProgressItem extends ECP.Component {
        constructor() {
            super(...arguments);
            this.indeterminate = false;
        }
        created() {
            const me = this;
            const progressEle = me.parentElement;
            if (me.progress) {
                if (progressEle.hasAttribute("steps")) {
                    for (let i = 0; i < me.progress; i++) {
                        const div = document.createElement("div");
                        div.classList.add("progressbar-item");
                        me.shadowRoot.appendChild(div);
                    }
                    const stepsVal = parseInt(progressEle.getAttribute("steps"), 10);
                    const progressVal = parseInt(me.progress.toString(), 10);
                    const widthVal = Math.floor(progressVal * 100 / stepsVal);
                    me.style.width = `${widthVal}%`;
                }
                else {
                    const div = document.createElement("div");
                    div.classList.add("progressbar-item");
                    me.shadowRoot.appendChild(div);
                    me.style.width = `${me.progress}%`;
                }
            }
            else {
                const div = document.createElement("div");
                div.classList.add("progressbar-item");
                me.shadowRoot.appendChild(div);
                const progressedItemArr = progressEle.querySelectorAll("ecp-progressbar-item[progress]");
                let progressVal = 0;
                for (let i = 0; i < progressedItemArr.length; i++) {
                    progressVal += parseInt(progressedItemArr[i].getAttribute("progress"), 10);
                }
                const widthVal = Math.floor(100 - progressVal);
                me.style.width = `${widthVal}%`;
            }
            if (me.bgColor) {
                const progressItemArr = me.shadowRoot.querySelectorAll(".progressbar-item");
                for (let i = 0; i < progressItemArr.length; i++) {
                    progressItemArr[i].style.background = `var(--${me.bgColor})`;
                    progressItemArr[i].style.border = "none";
                }
            }
            if (progressEle.getAttribute("type") !== null) {
                me.setAttribute("type", progressEle.getAttribute("type"));
            }
        }
        bgColorChanged(oldValue, newValue) {
            const progressbarItemArr = this.shadowRoot.querySelectorAll(".progressbar-item");
            const progressEle = this.parentElement;
            if (progressbarItemArr.length > 0) {
                if (newValue !== "") {
                    for (let i = 0; i < progressbarItemArr.length; i++) {
                        progressbarItemArr[i].style.background = `var(--${newValue})`;
                    }
                }
                if (newValue === "" || !this.bgColor) {
                    if (progressEle.hasAttribute("bg-color")) {
                        for (let i = 0; i < progressbarItemArr.length; i++) {
                            progressbarItemArr[i].style.background = `var(--${progressEle.getAttribute("bg-color")})`;
                            progressbarItemArr[i].style.border = "none";
                        }
                    }
                    else {
                        for (let i = 0; i < progressbarItemArr.length; i++) {
                            progressbarItemArr[i].style.background = "transparent";
                            progressbarItemArr[i].style.border = "solid 1px var(--divider)";
                        }
                    }
                }
            }
        }
        progressChanged(oldValue, newValue) {
            this.setAttribute("progress", `${newValue}`);
            if (oldValue !== undefined && !this.classList.contains("spare-item")) {
                const progressEle = this.parentElement;
                const spareItem = progressEle.querySelector(".spare-item");
                let spareProgressNew = 0;
                let progressTemp = 0;
                if (spareItem) {
                    spareItem.remove();
                }
                const progressedItemArr = progressEle.querySelectorAll("ecp-progressbar-item");
                for (let i = 0; i < progressedItemArr.length; i++) {
                    progressTemp += parseInt(progressedItemArr[i].getAttribute("progress"), 10);
                }
                if (progressEle.getAttribute("steps") !== null) {
                    spareProgressNew = parseInt(progressEle.getAttribute("steps"), 10) - progressTemp;
                    this.style.width = `${parseInt(newValue, 10) * 100 / parseInt(progressEle.getAttribute("steps"), 10)}%`;
                    this.shadowRoot.innerHTML = "";
                    for (let i = 0; i < newValue; i++) {
                        const div = document.createElement("div");
                        div.classList.add("progressbar-item");
                        if (this.bgColor) {
                            div.style.background = `var(--${this.bgColor})`;
                            div.style.border = "none";
                        }
                        this.shadowRoot.appendChild(div);
                    }
                    if (spareProgressNew > 0) {
                        progressedItemArr[progressedItemArr.length - 1].classList.remove("right-radius");
                        const progressbarHTML = document.createElement("ecp-progressbar-item");
                        progressbarHTML.classList.add("spare-item");
                        progressbarHTML.classList.add("right-radius");
                        progressbarHTML.setAttribute("progress", `${Math.abs(spareProgressNew)}`);
                        if (newValue.toString() === "0") {
                            progressbarHTML.classList.add("left-radius");
                        }
                        if (progressEle.hasAttribute("bg-color")) {
                            progressbarHTML.setAttribute("bg-color", `${progressEle.getAttribute("bg-color")}`);
                        }
                        progressEle.appendChild(progressbarHTML);
                    }
                    else if (spareProgressNew === 0) {
                        progressedItemArr[progressedItemArr.length - 1].classList.add("right-radius");
                    }
                    else {
                        ECP.HTML.Snackbar("Progress is over total value, please check it.", "Error");
                    }
                }
                else {
                    this.style.width = `${newValue}%`;
                    const progressItemArr = progressEle.querySelectorAll("ecp-progressbar-item:not(.spare-item)");
                    let progressTemp = 0;
                    for (let i = 0; i < progressItemArr.length; i++) {
                        progressTemp += parseInt(progressItemArr[i].getAttribute("progress"), 10);
                    }
                    if (progressTemp < 100) {
                        const spareProgressNew = 100 - progressTemp;
                        const rightEle = progressEle.querySelector(".right-radius");
                        if (rightEle) {
                            progressEle.querySelector(".right-radius").classList.remove("right-radius");
                        }
                        const progressItem = document.createElement("ecp-progressbar-item");
                        progressItem.classList.add("spare-item");
                        progressItem.classList.add("right-radius");
                        progressItem.setAttribute("progress", `${spareProgressNew}`);
                        if (newValue.toString() === "0") {
                            progressItem.classList.add("left-radius");
                        }
                        if (progressEle.getAttribute("bg-color")) {
                            progressItem.style.background = `var(--${progressEle.getAttribute("bg-color")})`;
                            progressItem.style.border = "none";
                        }
                        progressEle.appendChild(progressItem);
                    }
                    else if ((progressTemp === 100)) {
                        progressItemArr[progressItemArr.length - 1].classList.add("right-radius");
                    }
                    else {
                        ECP.HTML.Snackbar("Progress is over 100, please check it.", "Error");
                    }
                }
            }
        }
    };
    __decorate([
        ECP.attr({ attribute: 'bg-color' })
    ], ECPProgressItem.prototype, "bgColor", void 0);
    __decorate([
        ECP.attr
    ], ECPProgressItem.prototype, "progress", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPProgressItem.prototype, "indeterminate", void 0);
    ECPProgressItem = __decorate([
        ECP.customElement({
            name: "ecp-progressbar-item",
            template: '',
            styles: `
:host{
display:inline-flex;
transition:width var(--ecp-duration-moderate) var(--ecp-ease-standard)
}
:host([indeterminate]){
width:100%!important;
overflow:hidden
}
:host([indeterminate]) .progressbar-item{
animation:ecp-progressbar-indeterminate 1.5s var(--ecp-ease-standard) infinite
}
@media (prefers-reduced-motion:reduce){
:host([indeterminate]) .progressbar-item{
animation:none
}
}
/* Keyframes must live in this shadow root: page-level @keyframes are not visible to shadow elements */
@keyframes ecp-progressbar-indeterminate{
0%{transform:translateX(-100%);}
100%{transform:translateX(100%);}
}
:host .progressbar-item{
flex:1;
height:8px;
background:transparent;
border:solid 1px var(--bg-object);
box-sizing:border-box
}
:host([type="segmented"]) .progressbar-item {
margin-right:2px
}
:host(.left-radius) .progressbar-item{
border-top-left-radius:8px;
border-bottom-left-radius:8px
}
:host(.right-radius) .progressbar-item{
border-top-right-radius:8px;
border-bottom-right-radius:8px
}
:host(.left-radius[type="segmented"]) .progressbar-item,
:host(.right-radius[type="segmented"]) .progressbar-item{
border-radius:0
}
:host(.left-radius[type="segmented"]) .progressbar-item:first-child{
border-top-left-radius:8px;
border-bottom-left-radius:8px
}
:host(.right-radius[type="segmented"]) .progressbar-item:last-child{
border-top-right-radius:8px;
border-bottom-right-radius:8px
}`
        })
    ], ECPProgressItem);
    ECP.ECPProgressItem = ECPProgressItem;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPSlider = class ECPSlider extends ECP.Component {
        constructor() {
            super(...arguments);
            this.value = 0;
            this.min = 0;
            this.max = 100;
            this.disabled = false;
            this.showTooltip = true;
            this.labelAlign = "top";
            this.flag = false;
            this.handle = null;
            this.boxWidth = 0;
        }
        created() {
            this.flag = false;
            this.handle = this.shadowRoot.querySelector(".ecp-slider-runway");
            this.boxWidth = this.handle.offsetWidth;
            setTimeout(() => {
                this.setLeft();
            }, 0);
            let isDragging = false;
            this.handle.addEventListener("pointerdown", (event) => {
                if (!this.disabled) {
                    this.handle.setPointerCapture(event.pointerId);
                    this.onMouseDown();
                    isDragging = true;
                    this.getValue(event);
                }
            });
            document.addEventListener("pointermove", (event) => {
                if (!this.disabled) {
                    const events = event.getCoalescedEvents ? event.getCoalescedEvents() : [event];
                    for (const e of events) {
                        this.onMouseMove(e);
                    }
                    if (isDragging && this.showTooltip) {
                        const tooltip = this.shadowRoot.querySelector("ecp-tooltip");
                        const dotWrap = this.shadowRoot.querySelector(".ecp-slider-button-wrapper");
                        if (tooltip && dotWrap) {
                            tooltip.show(dotWrap);
                        }
                    }
                }
            });
            const handlePointerUp = () => {
                if (!this.disabled) {
                    this.onMouseUp();
                    isDragging = false;
                }
            };
            document.addEventListener("pointerup", handlePointerUp);
            document.addEventListener("pointercancel", handlePointerUp);
            this.handle.addEventListener("click", (event) => {
                if (!this.disabled) {
                    this.getValue(event);
                }
            });
        }
        getValue(event) {
            this.boxWidth = this.handle.offsetWidth;
            if (!this.boxWidth)
                return;
            const boxLeft = this.handle.getBoundingClientRect().left;
            const offsetX = event.clientX - boxLeft;
            const left = Math.max(0, Math.min(offsetX, this.boxWidth));
            if (left !== this.value) {
                this.value = Math.floor((left / this.boxWidth) * this.max);
            }
        }
        onMouseDown() {
            this.flag = true;
        }
        onMouseMove(event) {
            if (this.flag) {
                this.handle.classList.add("dragging");
                this.getValue(event);
            }
        }
        onMouseUp() {
            this.flag = false;
            if (this.handle) {
                this.handle.classList.remove("dragging");
                if (this.value < 2) {
                    this.handle.style.left = "7.5px";
                    if (this.iconRight) {
                        this.handle.style.marginRight = "7.5px";
                    }
                }
                else {
                    this.handle.style.left = "0";
                    if (!this.iconRight) {
                        this.handle.style.marginRight = "0";
                    }
                }
            }
        }
        setLeft() {
            this.handle = this.shadowRoot.querySelector(".ecp-slider-runway");
            this.boxWidth = this.handle.offsetWidth;
            const bar = this.shadowRoot.querySelector(".ecp-slider-bar");
            if (!this.max) {
                this.max = 100;
            }
            bar.style.width = `${Math.ceil((this.value / this.max) * 100)}%`;
            const dot = this.shadowRoot.querySelector(".ecp-slider-button-wrapper");
            if (this.boxWidth) {
                dot.style.left = `${Math.ceil(((this.value / this.max) - (8 / this.boxWidth)) * 100)}%`;
            }
            else {
                dot.style.left = `${Math.ceil((this.value / this.max) * 100)}%`;
            }
        }
        minChanged(oldValue, newValue) {
            if (newValue) {
                if (newValue < 0) {
                    this.min = 0;
                }
                else if (newValue > this.max) {
                    this.min = this.max - 1;
                }
                this.setLeft();
            }
        }
        maxChanged(oldValue, newValue) {
            if (newValue) {
                if (newValue < this.min) {
                    this.max = this.min + 1;
                }
                this.setLeft();
            }
        }
        valueChanged(oldValue, newValue) {
            if (!EC_Fmt.isNull(newValue)) {
                if (newValue < this.min) {
                    this.value = this.min;
                }
                else if (newValue > this.max) {
                    this.value = this.max;
                }
                this.setLeft();
                const tooltip = this.shadowRoot.querySelector("ecp-tooltip");
                if (tooltip) {
                    tooltip.innerHTML = this.value.toString();
                }
            }
            this.$emit("change", newValue);
        }
        iconChanged(oldValue, newValue) {
            const slider = this.shadowRoot.querySelector(".ecp-slider");
            if (oldValue) {
                const icon = this.shadowRoot.querySelector(`span.${oldValue}`);
                if (icon) {
                    if (newValue) {
                        icon.className = `icon ${newValue}`;
                    }
                    else {
                        icon.remove();
                    }
                }
            }
            else if (newValue) {
                slider.insertBefore(EC_Fmt.HtmlStrToElement(`<span class='icon ${newValue}'></span>`), slider.firstChild);
            }
            this.setLeft();
        }
        iconRightChanged(oldValue, newValue) {
            const slider = this.shadowRoot.querySelector(".ecp-slider");
            if (oldValue) {
                const icon = this.shadowRoot.querySelector(`span.${oldValue}`);
                if (icon) {
                    if (newValue) {
                        icon.className = `icon-righ ${newValue}`;
                        if (this.value < 2) {
                            this.handle.style.marginRight = "7.5px";
                        }
                    }
                    else {
                        icon.remove();
                        this.handle.style.marginRight = "0";
                    }
                }
            }
            else if (newValue) {
                slider.appendChild(EC_Fmt.HtmlStrToElement(`<span class='icon-right ${newValue}'></span>`));
                if (this.value < 2 || this.value > (this.max - 2)) {
                    this.handle.style.marginRight = "7.5px";
                }
            }
            this.setLeft();
        }
        disabledChanged(oldValue, newValue) {
            const container = this.shadowRoot.querySelector(".ecp-slider-container");
            if (newValue) {
                container.classList.add("disabled");
            }
            else {
                container.classList.remove("disabled");
            }
        }
        showTooltipChanged(oldValue, newValue) {
            const tooltip = this.shadowRoot.querySelector("ecp-tooltip");
            if (!tooltip) {
                return;
            }
            if (newValue) {
                tooltip.classList.remove("hidden");
            }
            else {
                tooltip.classList.add("hidden");
            }
        }
        labelChanged(oldValue, newValue) {
            const container = this.shadowRoot.querySelector(".ecp-slider-container");
            if (oldValue) {
                const label = this.shadowRoot.querySelector(".label");
                if (label) {
                    if (newValue) {
                        label.innerHTML = newValue;
                    }
                    else {
                        label.remove();
                    }
                }
            }
            else if (newValue) {
                container.insertBefore(EC_Fmt.HtmlStrToElement(`<span class='label ${this.labelAlign === "left" ? "label-align" : "bottom-5"}'>${newValue}</span>`), container.firstChild);
            }
            this.setLeft();
        }
        labelAlignChanged(oldValue, newValue) {
            const label = this.shadowRoot.querySelector(".label");
            if (label) {
                const container = this.shadowRoot.querySelector(".ecp-slider-container");
                if (newValue === "top") {
                    label.classList.remove("label-align");
                    label.classList.add("bottom-5");
                    container.classList.remove("flex");
                }
                else {
                    label.classList.remove("bottom-5");
                    label.classList.add("label-align");
                    container.classList.add("flex");
                }
                this.setLeft();
            }
        }
        helperTextChanged(oldValue, newValue) {
            const helperText = this.shadowRoot.querySelector(".helper-text");
            if (helperText) {
                if (newValue) {
                    helperText.innerHTML = newValue;
                }
                else {
                    helperText.remove();
                }
            }
            else if (newValue) {
                const bar = this.shadowRoot.querySelector(".text-bar");
                bar.appendChild(EC_Fmt.HtmlStrToElement(`<span class='helper-text'>${newValue}</span>`));
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPSlider.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], ECPSlider.prototype, "label", void 0);
    __decorate([
        ECP.attr({ attribute: "value" })
    ], ECPSlider.prototype, "value", void 0);
    __decorate([
        ECP.attr({ attribute: "min" })
    ], ECPSlider.prototype, "min", void 0);
    __decorate([
        ECP.attr({ attribute: "max" })
    ], ECPSlider.prototype, "max", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSlider.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ attribute: 'icon-right' })
    ], ECPSlider.prototype, "iconRight", void 0);
    __decorate([
        ECP.attr({ attribute: 'show-tooltip', mode: "boolean" })
    ], ECPSlider.prototype, "showTooltip", void 0);
    __decorate([
        ECP.attr({ attribute: 'label-align' })
    ], ECPSlider.prototype, "labelAlign", void 0);
    __decorate([
        ECP.attr({ attribute: 'helper-text' })
    ], ECPSlider.prototype, "helperText", void 0);
    ECPSlider = __decorate([
        ECP.customElement({
            name: "ecp-slider",
            template: `<div class="ecp-slider-container full-width">
        <div class="full-width text-bar">
            <div class="ecp-slider full-width">
                <div class="ecp-slider-runway full-width">
                <div class="ecp-slider-line full-width">
                    <div class="ecp-slider-bar"></div>
                    <div id="slider-button-wrapper" tabindex="0" class="ecp-slider-button-wrapper">
                        <div class="ecp-slider-button" tabindex="0"></div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div><ecp-tooltip for="slider-button-wrapper" placement="top" delayms="0">0</ecp-tooltip>`,
            styles: `
:host{
width:100%
}
.ecp-slider{
height:24px;
box-sizing:border-box;
display:flex;
align-items:center
}
.ecp-slider-line {
height:4px;
background-color:var(--bg-object);
border-radius:999px
}
.ecp-slider-runway{
height:16px;
display:flex;
align-items:center;
position:relative;
cursor:pointer;
touch-action:none
}
.ecp-slider-runway.show-input{
margin-right:160px;
width:auto
}
.ecp-slider-bar{
height:4px;
background-color:var(--bg-success);
border-radius:999px;
position:absolute
}
.ecp-slider-button-wrapper{
width:24px;
height:24px;
border-radius:50%;
transform:translateX(-4px);
box-sizing:border-box;
position:absolute;
z-index:100;
top:-4px;
user-select:none;
display:flex;
justify-content:center;
align-items:center;
border:3px solid transparent;
background-color:transparent
}
.ecp-slider-button-wrapper:hover {
cursor:grab;
border-color:var(--bg-success);
background-color:var(--layer-1)
}
.ecp-slider-button-wrapper.dragging{
cursor:grabbing;
border-color:var(--bg-success);
background-color:var(--layer-1)
}
.ecp-slider-button{
width:16px;
height:16px;
background-color:var(--bg-success);
border-radius:50%;
transition:.2s;
user-select:none
}
.ecp-slider-button-wrapper.dragging .ecp-slider-button,
.ecp-slider-button-wrapper:hover .ecp-slider-button{
width:12px;
height:12px
}
.icon{
margin-right:16px;
font-size:16px !important;
margin-bottom:-2px;
}
.icon-right{
margin-left:16px;
font-size:16px !important;
margin-bottom:-2px
}
.hidden{
display:none
}
.label{
display:block;
color:var(--text);
font-size:var(--body-font-size);
word-wrap:break-word
}
.bottom-5{
margin-bottom:5px
}
.label-align{
margin-right:16px;
height:24px;
line-height:24px
}
.flex{
display:flex;
}
.full-width{
width:100%
}
.helper-text{
color:var(--text-secondary);
word-wrap:break-word;
font-size: var(--bodysm-font-size);
line-height: var(--bodysm-line-height);
}
.disabled{
opacity:.3;
cursor:not-allowed
}
.disabled .ecp-slider-button-wrapper{
cursor:not-allowed
}`,
            enableIcon: true
        })
    ], ECPSlider);
    ECP.ECPSlider = ECPSlider;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    var ECPScrollbar_1;
    let ECPScrollbar = ECPScrollbar_1 = class ECPScrollbar extends ECP.Component {
        created() {
            ECPScrollbar_1.ScrollbarArr.push(this);
            this.addEventListener("click", (event) => {
                event.stopPropagation();
            });
        }
    };
    ECPScrollbar.ScrollbarArr = [];
    ECPScrollbar = ECPScrollbar_1 = __decorate([
        ECP.customElement({
            name: "ecp-scrollbar",
            template: `<div class="ecp-scrollbar"><slot></slot><div class=ecp-scrollbar-track><div class=ecp-scrollbar-thumb></div></div></div>`,
            styles: `
:host{
display:block;
width:100%;
height:100%
}
.ecp-scrollbar{
position:relative;
height:100%
}
.ecp-scrollbar:not(.ecp-scrollbar-mobile){
padding-right:10px;
overflow:hidden
}
.ecp-scrollbar-mobile{
overflow:auto
}
.ecp-scrollbar:not(.ecp-scrollbar-mobile) .ecp-scrollbar-track{
position:absolute;
top:0;
right:0;
bottom:0;
width:10px;
background:var(--layer-2)
}
.ecp-scrollbar:not(.ecp-scrollbar-mobile) .ecp-scrollbar-thumb{
background: var(--neutral-40);
width:8px;
border-radius:10px
}`
        })
    ], ECPScrollbar);
    ECP.ECPScrollbar = ECPScrollbar;
    window.addEventListener("load", () => {
        for (let i = 0; i < ECPScrollbar.ScrollbarArr.length; i++) {
            const ecpScrollbar = ECPScrollbar.ScrollbarArr[i];
            if (ecpScrollbar) {
                const scrollbarContainer = ecpScrollbar.shadowRoot.querySelector(".ecp-scrollbar");
                const scrollingContent = ecpScrollbar.firstElementChild;
                const scrollThumb = ecpScrollbar.shadowRoot.querySelector(".ecp-scrollbar-thumb");
                if (EC_Fmt.isMobile) {
                    scrollbarContainer.classList.add("ecp-scrollbar-mobile");
                }
                else {
                    let isDragging = false;
                    let scrollEndTimeoutId;
                    let initialPosition_Mouse = 0;
                    let initialPosition_Thumb = 0;
                    let initialPosition_Content = 0;
                    let containerHeight = ecpScrollbar.getBoundingClientRect().height;
                    let contentHeight = scrollingContent.getBoundingClientRect().height;
                    scrollThumb.style.height = `${(1 - (contentHeight - containerHeight) / contentHeight) * containerHeight}px`;
                    let scrollSpacing = containerHeight - scrollThumb.getBoundingClientRect().height;
                    let contentSpacing = contentHeight - containerHeight;
                    window.addEventListener("resize", () => {
                        requestAnimationFrame(() => {
                            containerHeight = ecpScrollbar.getBoundingClientRect().height;
                            contentHeight = scrollingContent.getBoundingClientRect().height;
                            scrollSpacing = containerHeight - scrollThumb.getBoundingClientRect().height;
                            contentSpacing = contentHeight - containerHeight;
                        });
                        scrollThumb.style.height = `${(1 - (contentHeight - containerHeight) / contentHeight) * containerHeight}px`;
                    });
                    document.addEventListener("mousedown", (event) => {
                        if (event.target === ecpScrollbar) {
                            initialPosition(event);
                        }
                    });
                    document.addEventListener("mousemove", (event) => {
                        scrollingEvent(event);
                    });
                    document.addEventListener("mouseup", () => {
                        isDragging = false;
                    });
                    document.addEventListener("mouseleave", () => {
                        isDragging = false;
                    });
                    function initialPosition(e) {
                        isDragging = true;
                        initialPosition_Mouse = e.clientY;
                        initialPosition_Thumb = scrollThumb.getBoundingClientRect().top - ecpScrollbar.getBoundingClientRect().top;
                        initialPosition_Content = ecpScrollbar.getBoundingClientRect().top - scrollingContent.getBoundingClientRect().top;
                    }
                    function scrollingEvent(e) {
                        e.preventDefault();
                        if (!isDragging)
                            return;
                        const mouseMovement = e.clientY - initialPosition_Mouse;
                        const contentMovement = contentHeight / containerHeight * mouseMovement;
                        const currentPosition_Thumb = mouseMovement + initialPosition_Thumb;
                        const currentPosition_Content = contentMovement + initialPosition_Content;
                        scrollThumb.style.transform = `translateY(${currentPosition_Thumb}px)`;
                        scrollingContent.style.transform = `translateY(-${currentPosition_Content}px)`;
                        if (mouseMovement < 0 && currentPosition_Thumb <= 0) {
                            scrollThumb.style.transform = "translateY(0px)";
                            scrollingContent.style.transform = "translateY(0px)";
                        }
                        if (mouseMovement > 0 && (currentPosition_Thumb >= scrollSpacing || currentPosition_Content >= contentSpacing)) {
                            scrollThumb.style.transform = `translateY(${scrollSpacing}px)`;
                            scrollingContent.style.transform = `translateY(-${Math.min(currentPosition_Content, contentSpacing)}px)`;
                        }
                    }
                    scrollbarContainer.addEventListener('wheel', function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        if (!isDragging) {
                            const movement = event.deltaY;
                            const contentMovement = contentHeight / containerHeight * movement;
                            const transform_Thumb = window.getComputedStyle(scrollThumb).getPropertyValue('transform');
                            const matrixValues_Thumb = transform_Thumb.replace(/matrix\(|\)|\s/g, '').split(',');
                            const transform_Content = window.getComputedStyle(scrollingContent).getPropertyValue('transform');
                            const matrixValues_Content = transform_Content.replace(/matrix\(|\)|\s/g, '').split(',');
                            if (transform_Thumb !== "none") {
                                initialPosition_Thumb = parseFloat(matrixValues_Thumb[5]);
                                initialPosition_Content = parseFloat(matrixValues_Content[5]);
                            }
                            const currentPosition_Thumb = movement + initialPosition_Thumb;
                            const currentPosition_Content = Math.abs(contentMovement - initialPosition_Content);
                            scrollThumb.style.transform = `translateY(${currentPosition_Thumb}px)`;
                            scrollingContent.style.transform = `translateY(-${currentPosition_Content}px)`;
                            if (movement < 0 && currentPosition_Thumb <= 0) {
                                scrollThumb.style.transform = "translateY(0px)";
                                scrollingContent.style.transform = "translateY(0px)";
                            }
                            if (movement > 0 && (currentPosition_Thumb >= scrollSpacing || currentPosition_Content >= contentSpacing)) {
                                scrollThumb.style.transform = `translateY(${scrollSpacing}px)`;
                                scrollingContent.style.transform = `translateY(-${Math.min(currentPosition_Content, contentSpacing)}px)`;
                            }
                            clearTimeout(scrollEndTimeoutId);
                        }
                        scrollEndTimeoutId = setTimeout(() => {
                            isDragging = false;
                        }, 250);
                    }, { passive: false });
                }
            }
        }
    });
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPSwitchComponent = class ECPSwitchComponent extends ECP.Component {
        constructor() {
            super(...arguments);
            this.disabled = false;
            this.checked = false;
        }
        created(host) {
            const me = this;
            const switchContainer = me.shadowRoot.querySelector(".ecp-switch");
            const switchLayer = me.shadowRoot.querySelector(".ecp-switch-layer");
            if (me.activeLabel && !me.activeIcon) {
                const activeLabel = document.createElement("span");
                activeLabel.classList.add("active-label");
                activeLabel.innerText = me.activeLabel;
                switchContainer.appendChild(activeLabel);
            }
            if (me.inActiveLabel && !me.inActiveIcon) {
                const inActiveLabel = document.createElement("span");
                inActiveLabel.classList.add("inactive-label");
                inActiveLabel.innerText = me.inActiveLabel;
                switchContainer.insertBefore(inActiveLabel, switchLayer);
            }
            if (me.activeIcon) {
                const activeIcon = document.createElement("span");
                activeIcon.classList.add("active-label", `${me.activeIcon}`);
                switchContainer.appendChild(activeIcon);
            }
            if (me.inActiveIcon) {
                const inActiveIcon = document.createElement("span");
                inActiveIcon.classList.add("inactive-label", `${me.inActiveIcon}`);
                switchContainer.insertBefore(inActiveIcon, switchLayer);
            }
            if (me.innerText === "" || me.inActiveLabel || me.inActiveIcon) {
                me.shadowRoot.querySelector(".inner-text").remove();
            }
            if (me.activeColor) {
                me.setTrackColor();
            }
            if (!me.disabled) {
                me.addEventListener("click", () => {
                    me.checked = !me.checked;
                    if (me.activeColor) {
                        requestAnimationFrame(() => {
                            me.setTrackColor();
                        });
                    }
                });
            }
            else {
                switchContainer.classList.add("disabled");
            }
        }
        setTrackColor() {
            const me = this;
            const trackEle = me.shadowRoot.querySelector(".switch-track");
            const thumbEle = me.shadowRoot.querySelector(".switch-thumb");
            if (me.hasAttribute("checked")) {
                trackEle.style.backgroundColor = `var(--${me.activeColor}`;
                thumbEle.style.borderColor = `var(--${me.activeColor}`;
            }
            else {
                trackEle.style.backgroundColor = "var(--layer-special)";
                thumbEle.style.borderColor = "var(--layer-special)";
            }
        }
        activeColorChanged() {
            this.setTrackColor();
        }
        sizeChanged(oldValue, newValue) {
            if (newValue === "small") {
                this.setAttribute("size", "small");
            }
            else {
                this.removeAttribute("size");
            }
        }
        activeIconChanged(oldValue, newValue) {
            const activeLabel = this.shadowRoot.querySelector(".active-label");
            if (newValue && activeLabel) {
                activeLabel.setAttribute("class", `active-label ${newValue}`);
            }
        }
        inActiveIconChanged(oldValue, newValue) {
            const inActiveLabel = this.shadowRoot.querySelector(".inactive-label");
            if (newValue && inActiveLabel) {
                inActiveLabel.setAttribute("class", `inactive-label ${newValue}`);
            }
        }
        activeLabelChanged(oldValue, newValue) {
            const label = this.shadowRoot.querySelector(".active-label");
            if (newValue && label) {
                label.innerText = `${newValue}`;
            }
        }
        inActiveLabelChanged(oldValue, newValue) {
            const label = this.shadowRoot.querySelector(".inactive-label");
            if (newValue && label) {
                label.innerText = `${newValue}`;
            }
        }
        disabledChanged(oldValue, newValue) {
            const switchContainer = this.shadowRoot.querySelector(".ecp-switch");
            if (newValue) {
                switchContainer.classList.add("disabled");
            }
            else {
                switchContainer.classList.remove("disabled");
            }
        }
        checkedChanged(oldValue, newValue) {
            this.checked = newValue;
            if (this.activeColor) {
                requestAnimationFrame(() => {
                    this.setTrackColor();
                });
            }
        }
    };
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSwitchComponent.prototype, "disabled", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSwitchComponent.prototype, "checked", void 0);
    __decorate([
        ECP.attr
    ], ECPSwitchComponent.prototype, "name", void 0);
    __decorate([
        ECP.attr
    ], ECPSwitchComponent.prototype, "size", void 0);
    __decorate([
        ECP.attr({ attribute: 'active-label' })
    ], ECPSwitchComponent.prototype, "activeLabel", void 0);
    __decorate([
        ECP.attr({ attribute: 'inactive-label' })
    ], ECPSwitchComponent.prototype, "inActiveLabel", void 0);
    __decorate([
        ECP.attr({ attribute: 'active-value' })
    ], ECPSwitchComponent.prototype, "activeValue", void 0);
    __decorate([
        ECP.attr({ attribute: 'inactive-value' })
    ], ECPSwitchComponent.prototype, "inActiveValue", void 0);
    __decorate([
        ECP.attr({ attribute: 'active-icon' })
    ], ECPSwitchComponent.prototype, "activeIcon", void 0);
    __decorate([
        ECP.attr({ attribute: 'inactive-icon' })
    ], ECPSwitchComponent.prototype, "inActiveIcon", void 0);
    __decorate([
        ECP.attr({ attribute: 'active-color' })
    ], ECPSwitchComponent.prototype, "activeColor", void 0);
    ECPSwitchComponent = __decorate([
        ECP.customElement({
            name: "ecp-switch",
            template: `<div class="ecp-switch">
                     <span class="inner-text"><slot></slot></span>
                     <span class="ecp-switch-layer"><span class="switch-track"><span class="switch-thumb"></span></span></span>
                   </div>`,
            styles: `
:host{
display:inline-block;
vertical-align:middle
}
:host([disabled]){
pointer-events:none;
cursor:not-allowed
}
.inner-text{
margin-right:8px
}
.disabled .switch-track{
opacity:0.3;
cursor:not-allowed
}
.ecp-switch-layer{
position:relative;
display:block;
width:48px;
background-color:var(--layer-special);
border-radius:24px;
transform:scale(1, 1);
transition:all var(--ecp-duration-moderate) var(--ecp-ease-standard)
}
.switch-track{
position:relative;
display:block;
width:100%;
height:24px;
border-radius:24px;
cursor:pointer;
user-select:none;
transition:all var(--ecp-duration-moderate) var(--ecp-ease-standard)
}
.switch-thumb{
display:block;
content:"";
width:16px;
height:16px;
border:solid 4px var(--layer-special);
border-radius:24px;
background-color:var(--bg);
transition:all var(--ecp-duration-moderate) var(--ecp-ease-standard)
}
.ecp-switch-checkbox{
opacity:0;
position:absolute;
pointer-events:none
}
:host([checked]) .switch-track{
background-color:var(--bg-success)
}
:host([checked]) .switch-thumb {
border-color:var(--bg-success);
transform:translateX(24px);
}
:host([size="small"]) .ecp-switch-layer {
width:32px
}
:host([size="small"]) .switch-track {
height:16px
}
:host([size="small"]) .switch-thumb {
width:12px;
height:12px;
border-width:2px
}
:host([size="small"][checked]) .switch-thumb{
transform:translateX(16px)
}
.ecp-switch{
display: flex;
align-items: center
}
.active-label{
margin-left: 8px;
font-size: var(--body-font-size)
}
.inactive-label{
margin-right:8px;
font-size:var(--body-font-size)
}`,
            enableIcon: true
        })
    ], ECPSwitchComponent);
    ECP.ECPSwitchComponent = ECPSwitchComponent;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPChips = class ECPChips extends ECP.Component {
        constructor() {
            super(...arguments);
            this.color = "gray";
            this.type = "indicator";
        }
        created() {
            if (!EC_Fmt.isNull(this.textContent) && this.textContent.length <= 2) {
                this.shadowRoot.querySelector(".chips").classList.add("bold");
            }
            requestAnimationFrame(() => {
                if (this.type === "attribute" && EC_Fmt.isNull(this.icon)) {
                    throw new Error("ecp-chip error: attribute type chips must have an icon.");
                }
            });
        }
        colorChanged(oldValue, newValue) {
            this.color = newValue ? newValue.toLowerCase() : "gray";
            const div = this.shadowRoot.querySelector(".chips");
            div?.setAttribute("color", this.color);
        }
        typeChanged(oldValue, newValue) {
            this.type = newValue ? newValue.toLowerCase() : "indicator";
            const div = this.shadowRoot.querySelector(".chips");
            div?.setAttribute("type", this.type);
        }
        iconChanged(oldValue, newValue) {
            const div = this.shadowRoot.querySelector(".chips");
            if (oldValue) {
                const icon = this.shadowRoot.querySelector(`div.${oldValue}`);
                if (icon) {
                    icon.remove();
                }
            }
            if (newValue) {
                const spanElement = document.createElement("DIV");
                spanElement.classList.add(newValue);
                div.insertBefore(spanElement, div.firstChild);
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPChips.prototype, "color", void 0);
    __decorate([
        ECP.attr
    ], ECPChips.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], ECPChips.prototype, "type", void 0);
    ECPChips = __decorate([
        ECP.customElement({
            name: "ecp-chip",
            template: `<div class=chips><div class="content ecp-bodysm"><slot></slot></div></div>`,
            styles: `
:host{
height:20px;
display:inline-flex
}
:host([type="attribute"]) {
height: 24px;
}
.chips{
display:inline-flex;
height:20px;
line-height:18px;
box-sizing:border-box;
padding:0 8px;
align-items:baseline;
gap:4px;
flex-shrink:0;
border-radius:9999px;
color:var(--text);
font-size:var(--bodysm-font-size);
font-weight:var(--semibold-weight);
border: solid 1px transparent;
}
.bold{
font-weight:var(--bold-weight)
}
.chips[color="white"]{
border:1px solid var(--border);
background:var(--chip-bg-white);
color:var(--chip-text-onbg-white);
}
.chips[color="gray"]{
background:var(--chip-bg-gray);
color:var(--chip-text-onbg-gray);
}
.chips[color="black"]{
color:var(--chip-text);
background:var(--chip-bg-black);
}
.chips[color="brown"]{
color:var(--chip-text);
background: var(--chip-bg-brown);
}
.chips[color="red"]{
color:var(--chip-text);
background:var(--chip-bg-red);
}
.chips[color="yellow"]{
color:var(--chip-text);
background:var(--chip-bg-yellow);
}
.chips[color="green"]{
color:var(--chip-text);
background:var(--chip-bg-green);
}
.chips[color="teal"]{
color:var(--chip-text);
background:var(--chip-bg-teal);
}
.chips[color="blue"]{
color:var(--chip-text);
background:var(--chip-bg-blue);
}
.chips[color="purple"]{
color:var(--chip-text);
background:var(--chip-bg-purple);
}
.chips *[class*="ews-icon-"]{
color:var(--chip-icon);
}
.chips[color="white"] *[class*="ews-icon-"]{
color:var(--chip-icon-onbg-white);
}
.chips[color="gray"] *[class*="ews-icon-"]{
color:var(--chip-icon-onbg-gray);
}
/* EC-32626: Attribute type chips - icon swatch + separate text surface, distinct from Indicator's solid fill */
.chips[type="attribute"]{
height:20px;
padding:1px 0;
gap:0;
align-items:center;
border-radius:4px;
overflow:hidden;
box-sizing: content-box;
}
.chips[type="attribute"] .content{
background:var(--bg);
color:var(--text);
padding:0 8px;
height: 22px;
line-height: 22px;
box-sizing:border-box;
border-radius:3px;
}
.chips[type="attribute"] [class*="ews-icon-"]{
width:16px;
height:16px;
margin:0 4px;
flex:0 0 auto;
display:flex;
align-items:center;
justify-content:center;
font-size: var(--body-font-size);
line-height: 0;
color:var(--text-onbg-action);
}
.chips[type="attribute"][color="error"]{
background:var(--bg-error);
}
.chips[type="attribute"][color="warning"]{
background:var(--bg-warning);
}
.chips[type="attribute"][color="success"]{
background:var(--bg-success);
}
.chips[type="attribute"][color="gray"]{
background:var(--bg-accent-gray-bolder);
}
.chips[type="attribute"][color="red"]{
background:var(--bg-accent-red-bolder);
}
.chips[type="attribute"][color="orange"]{
background:var(--bg-accent-orange-bolder);
}
.chips[type="attribute"][color="yellow"]{
background:var(--bg-accent-yellow-bolder);
}
.chips[type="attribute"][color="green"]{
background:var(--bg-accent-green-bolder);
}
.chips[type="attribute"][color="teal"]{
background:var(--bg-accent-teal-bolder);
}
.chips[type="attribute"][color="blue"]{
background:var(--bg-accent-blue-bolder);
}
.chips[type="attribute"][color="navy"]{
background:var(--bg-accent-navy-bolder);
}
.chips[type="attribute"][color="purple"]{
background:var(--bg-accent-purple-bolder);
}
.chips[type="attribute"][color="magenta"]{
background:var(--bg-accent-magenta-bolder);
}
`,
            enableIcon: true
        })
    ], ECPChips);
    ECP.ECPChips = ECPChips;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPBadge = class ECPBadge extends ECP.Component {
        constructor() {
            super(...arguments);
            this.important = false;
        }
        created() {
            const div = this.shadowRoot.querySelector(".container");
            if (EC_Fmt.isNull(this.value)) {
                div.classList.add("dot");
            }
            if (this.important) {
                div.classList.add("success");
            }
        }
        importantChanged(oldValue, newValue) {
            const div = this.shadowRoot.querySelector(".container");
            div.classList.toggle("success", !!newValue);
        }
        valueChanged(oldValue, newValue) {
            const div = this.shadowRoot.querySelector(".container");
            if (EC_Fmt.isNull(newValue)) {
                div.classList.add("dot");
                div.classList.remove("badge");
                div.innerHTML = newValue;
            }
            else {
                div.classList.add("badge");
                div.classList.remove("dot");
                if (newValue > 99) {
                    div.innerHTML = "99+";
                }
                else {
                    div.innerHTML = newValue;
                }
            }
        }
    };
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPBadge.prototype, "important", void 0);
    __decorate([
        ECP.attr
    ], ECPBadge.prototype, "value", void 0);
    ECPBadge = __decorate([
        ECP.customElement({
            name: "ecp-badge",
            template: `<div class="container"></div>`,
            styles: `
:host{
display:inline-flex
}
.container{
display:flex;
align-items:center;
color:var(--text);
background:var(--layer-special);
font-size:var(--bodysm-font-size);
font-weight:var(--semibold-weight);
line-height:var(--bodysm-line-height);
box-sizing:border-box
}
.badge{
height:20px;
padding:0 8px;
border-radius:9999px
}
.dot{
width:8px;
height:8px;
border-radius:50%
}
.success{
color:var(--text-onbg-action);
background:var(--bg-success)
}`
        })
    ], ECPBadge);
    ECP.ECPBadge = ECPBadge;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPTableOfContents = class ECPTableOfContents extends ECP.Component {
        constructor() {
            super(...arguments);
            this.isClick = false;
        }
        created() {
            this.shadowRoot.querySelector(".head").innerHTML = this.header;
        }
        scrollToLinkChanged(oldValue, newValue) {
            if (newValue && newValue !== oldValue) {
                const child = this.querySelector(`ecp-content-link[href="${newValue}"]`);
                if (child) {
                    child.selected = true;
                    if (!this.isClick && child.shadowRoot) {
                        const anchorToScrollTo = child.shadowRoot.querySelector("a");
                        if (anchorToScrollTo) {
                            EC_Fmt.TriggerEvent(child.shadowRoot.querySelector("a"), "click");
                        }
                    }
                }
            }
            if (oldValue) {
                const child = this.querySelector(`ecp-content-link[href='${oldValue}']`);
                if (child) {
                    child.selected = false;
                }
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPTableOfContents.prototype, "header", void 0);
    __decorate([
        ECP.attr
    ], ECPTableOfContents.prototype, "scrollToLink", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPTableOfContents.prototype, "isClick", void 0);
    ECPTableOfContents = __decorate([
        ECP.customElement({
            name: "ecp-table-of-contents",
            template: `<div class="content"><div class="head"></div><div class="list"><slot></slot></div></div>`,
            styles: `
.content{
padding:20px;
background:var(--layer-2)
}
.content .head{
color:var(--text);
font-size:var(--body-font-size);
font-weight:var(--semibold-weight);
line-height:var(--body-line-height)
}
.list{
margin-top:20px;
display:flex;
flex-direction:column;
justify-content:center;
gap:4px;
border-left:2px solid var(--primary-10)
}`
        })
    ], ECPTableOfContents);
    ECP.ECPTableOfContents = ECPTableOfContents;
    let ECPContentLink = class ECPContentLink extends ECP.Component {
        constructor() {
            super(...arguments);
            this.selected = false;
        }
        created() {
            this.shadowRoot.querySelector("a").setAttribute("href", this.href);
            this.shadowRoot.addEventListener("click", () => {
                const parent = this.parentNode;
                parent.isClick = true;
                parent.scrollToLink = this.href;
            });
        }
        selectedChanged(oldValue, newValue) {
            const item = this.shadowRoot.querySelector(".item");
            if (newValue) {
                item.classList.add("selected");
            }
            else {
                item.classList.remove("selected");
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPContentLink.prototype, "href", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPContentLink.prototype, "selected", void 0);
    ECPContentLink = __decorate([
        ECP.customElement({
            name: "ecp-content-link",
            template: `<a><div class="item"><slot></slot></div></a>`,
            styles: `
.item{
min-height:32px;
padding:6px 18px;
display:flex;
align-items:flex-start;
box-sizing:border-box;
cursor:pointer;
border-left:2px solid transparent;
margin-left:-2px
}
.item:hover{
border-color:var(--border-selected)
}
a{
text-decoration:none;
color:var(--text);
font-size:var(--body-font-size);
font-weight:var(--regular-weight);
line-height:var(--body-line-height)
}
.selected{
border-color:var(--border-selected)
}
.selected {
font-weight:var(--semibold-weight)
}`
        })
    ], ECPContentLink);
    ECP.ECPContentLink = ECPContentLink;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPCodeSnippet = class ECPCodeSnippet extends ECP.Component {
        constructor() {
            super(...arguments);
            this.type = "inline";
        }
        created() {
            switch (this.type.toLowerCase()) {
                case "single-line":
                    this.initSingleLine();
                    break;
                case "multi-line":
                    this.initMultiLine();
                    break;
                default:
                    this.initInline();
                    break;
            }
        }
        async initInline() {
            const container = this.shadowRoot.querySelector(".code-container");
            if (this.language && this.language.toLowerCase() === "css") {
                const codeElement = document.createElement("code");
                codeElement.classList.add("inline", "ecp-body", "code", "content", "con", "padding-16", "center");
                codeElement.innerHTML = this.highlightCSSCode(this.textContent);
                container.appendChild(codeElement);
            }
            else if (this.language && this.language.toLowerCase() === "javascript") {
                const codeElement = document.createElement("code");
                codeElement.classList.add("inline", "ecp-body", "code", "content", "con", "padding-16", "center");
                codeElement.innerHTML = await this.highlightJSCode(this.textContent);
                container.appendChild(codeElement);
            }
            else {
                container.classList.add("inline", "ecp-body", "code");
                container.innerHTML = this.innerHTML.trim();
            }
        }
        async initSingleLine() {
            const codeContainer = this.shadowRoot.querySelector(".code-container");
            if (this.label) {
                const label = document.createElement("div");
                label.classList.add("ecp-body");
                label.innerHTML = this.label;
                codeContainer.appendChild(label);
            }
            const content = document.createElement("div");
            content.classList.add("content", "con", "padding-16", "center");
            if (this.label) {
                content.classList.add("margin-top-12");
            }
            const codeElement = document.createElement("code");
            codeElement.classList.add("code", "single", "ecp-body");
            content.appendChild(codeElement);
            const copyBtn = document.createElement("ecp-btn");
            copyBtn.type = "secondary";
            copyBtn.icon = "ews-icon-copy";
            content.appendChild(copyBtn);
            codeContainer.appendChild(content);
            if (this.language && this.language.toLowerCase() === "css") {
                codeElement.innerHTML = this.highlightCSSCode(this.textContent);
            }
            else if (this.language && this.language.toLowerCase() === "javascript") {
                codeElement.innerHTML = await this.highlightJSCode(this.textContent);
            }
            else {
                const htmlCode = this.innerHTML.trim();
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlCode, "text/html");
                const nodes = doc.body.childNodes;
                let highlightedCode = "";
                for (let i = 0; i < nodes.length; i++) {
                    highlightedCode += highlightNode(nodes[i]);
                }
                codeElement.innerHTML = highlightedCode;
            }
            function highlightNode(node) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    let result = `&lt;<span class="tag">${node.tagName.toLowerCase()}</span>`;
                    for (let i = 0; i < node.attributes.length; i++) {
                        const attr = node.attributes[i];
                        result += ` <span class="attribute">${attr.name}</span>`;
                        if (attr.value) {
                            result += `=<span class="value">${JSON.stringify(attr.value)}</span>`;
                        }
                    }
                    result += "<span>&gt;</span>";
                    for (let i = 0; i < node.childNodes.length; i++) {
                        result += highlightNode(node.childNodes[i]);
                    }
                    result += `&lt;<span class="tag">/${node.tagName.toLowerCase()}</span>&gt;`;
                    return result;
                }
                if (node.nodeType === Node.TEXT_NODE) {
                    return node.textContent;
                }
                return "";
            }
            this.copyCode(copyBtn, codeElement);
        }
        async initMultiLine() {
            const codeContainer = this.shadowRoot.querySelector(".code-container");
            if (this.label) {
                const label = document.createElement("div");
                label.classList.add("ecp-body");
                label.innerHTML = this.label;
                codeContainer.appendChild(label);
            }
            const content = document.createElement("div");
            content.classList.add("content");
            if (this.label) {
                content.classList.add("margin-top-12");
            }
            const con = document.createElement("div");
            con.classList.add("con");
            const codeElement = document.createElement("code");
            codeElement.classList.add("code", "multi", "ecp-body");
            con.appendChild(codeElement);
            const copyBtn = document.createElement("ecp-btn");
            copyBtn.type = "secondary";
            copyBtn.icon = "ews-icon-copy";
            copyBtn.classList.add("copy-btn");
            con.appendChild(copyBtn);
            content.appendChild(con);
            codeContainer.appendChild(content);
            if (this.language && this.language.toLowerCase() === "css") {
                codeElement.innerHTML = this.highlightCSSCode(this.textContent);
            }
            else if (this.language && this.language.toLowerCase() === "javascript") {
                codeElement.innerHTML = await this.highlightJSCode(this.textContent);
            }
            else {
                const htmlCode = this.innerHTML.trim();
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlCode, "text/html");
                const nodes = doc.body.childNodes;
                let highlightedCode = "";
                for (let i = 0; i < nodes.length; i++) {
                    highlightedCode += highlightNode(nodes[i]);
                }
                codeElement.innerHTML = highlightedCode;
            }
            this.copyCode(copyBtn, codeElement);
            requestAnimationFrame(() => {
                if (codeElement.scrollHeight > codeElement.clientHeight) {
                    const multi = document.createElement("div");
                    multi.classList.add("show-more");
                    multi.innerHTML = '<ecp-btn type="ghost" dropdown>Show more</ecp-btn>';
                    content.appendChild(multi);
                    this.showMore(multi, codeElement);
                }
                else {
                    content.classList.add("padding-16");
                }
            });
            function highlightNode(node, level = 0) {
                let indent = "";
                for (let i = 0; i < level; i++) {
                    indent += '<span class="code-indent"></span>';
                }
                if (node.nodeType === Node.ELEMENT_NODE) {
                    let result = `${level === 0 ? "" : "<br>"}${indent}&lt;<span class="tag">${node.tagName.toLowerCase()}</span>`;
                    for (let i = 0; i < node.attributes.length; i++) {
                        const attr = node.attributes[i];
                        result += ` <span class="attribute">${attr.name}</span>`;
                        if (attr.value) {
                            result += `=<span class="value">${JSON.stringify(attr.value)}</span>`;
                        }
                    }
                    result += "<span>&gt;</span>";
                    if (node.childNodes.length > 0) {
                        for (let i = 0; i < node.childNodes.length; i++) {
                            result += highlightNode(node.childNodes[i], level + 1);
                        }
                        if (node.childNodes.length !== 1 || (node.childNodes.length == 1 && !node.textContent.trim())) {
                            result += `<br>${indent}`;
                        }
                    }
                    result += `&lt;<span class="tag">/${node.tagName.toLowerCase()}</span>&gt;`;
                    return result;
                }
                if (node.nodeType === Node.TEXT_NODE) {
                    if (node.textContent.trim()) {
                        return `${node.textContent}`;
                    }
                    return `<br>`;
                }
                return "";
            }
        }
        copyCode(copyBtn, codeElement) {
            copyBtn.addEventListener("click", () => {
                const copyThroughTextArea = () => {
                    const input = document.createElement("textarea");
                    codeElement.appendChild(input);
                    input.value = this.innerHTML;
                    input.select();
                    if (document.execCommand("copy", false)) {
                        input.remove();
                        ECP.HTML.Snackbar("Code copied to clipboard", "Success");
                    }
                };
                const myNavigator = window.navigator;
                if (myNavigator.clipboard) {
                    myNavigator.clipboard.writeText(this.innerHTML).then(() => {
                        ECP.HTML.Snackbar("Code copied to clipboard", "Success");
                    }, copyThroughTextArea);
                    return;
                }
                copyThroughTextArea();
            });
        }
        showMore(btn, codeElement) {
            btn.addEventListener("click", () => {
                if (codeElement.style.maxHeight === "max-content") {
                    codeElement.style.maxHeight = "160px";
                    btn.innerHTML = '<ecp-btn type="ghost" dropdown>Show more</ecp-btn>';
                }
                else {
                    codeElement.style.maxHeight = "max-content";
                    btn.innerHTML = '<ecp-btn type="ghost" dropdown>Show less</ecp-btn>';
                    btn.querySelector("ecp-btn").shadowRoot.querySelector(".ews-icon-caretdown").className = "ews-icon-up";
                }
            });
        }
        highlightCSSCode(code) {
            code = code
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
            const regexPatterns = [
                { pattern: /(\/\*[\s\S]*?\*\/)/g, result: '<div class="token comment">$1</div>' },
                { pattern: /([.#]?[a-zA-Z0-9_-]+)(:[a-zA-Z-]+(\([^)]*\))?)?(\s*,\s*[.#]?[a-zA-Z0-9_-]+(:[a-zA-Z-]+(\([^)]*\))?)?)*(\s*{)/g, result: '<div class="code-line"><span class="token selector">$1$2$4$5</span><span>$7</span></div>' },
                { pattern: /(:\s*)([^\s;]+)(\s*;)/g, result: '<div class="code-line">$1<span class="token value">$2</span><span>$3</span></div>' },
                { pattern: /(!important)/g, result: '<span class="token important">!important</span>' },
                { pattern: /(var)/g, result: '<span class="token var">var</span>' },
                { pattern: /([0-9]+(\.[0-9]+)?)([a-z%]+)?(?=\s|;|,|$)/g, result: '<span class="token number">$1$3</span>' },
                { pattern: /(url\()([^)]*)(\))/g, result: '<span class="token function">$1</span><span class="token string">$2</span><span class="token function">$3</span>' }
            ];
            let highlightedCode = code;
            if (this.type.toLowerCase() === "inline") {
                highlightedCode = this.highlightInlineProperties(highlightedCode);
            }
            else {
                highlightedCode = this.highlightProperties(highlightedCode);
            }
            regexPatterns.forEach(({ pattern, result }) => {
                highlightedCode = highlightedCode.replace(pattern, result);
            });
            highlightedCode = highlightedCode.replace(/(calc\()([^)]*)(\))/g, (match, func, expr, close) => {
                expr = expr.replace(/([0-9]+(\.[0-9]+)?)([a-z%]+)/g, '<span class="token number">$1$2</span><span class="token unit">$3</span>');
                return `<span class="token function">calc</span>(${expr}<span>${close}</span>`;
            });
            highlightedCode = highlightedCode.replace(/;/g, ";</div>")
                .replace(/}/g, '<div class="code-line">}</div>')
                .replace(/(@[a-z-]+)(\s+[^]+)?({)/g, '<div class="code-media"><span class="token atrule">$1</span>$2<span>$3</span>')
                .replace(/}}/g, '<div class="code-line">}</div><div class="code-line">}</div></div>');
            if (this.type.toLowerCase() === "multi-line") {
                return this.format(highlightedCode);
            }
            return highlightedCode;
        }
        highlightProperties(code) {
            return code.replace(/\{([\s\S]*?)\}/g, (match, blockContent) => {
                const highlightedBlock = blockContent.replace(/([a-zA-Z-]+)(\s*:)/g, '<div class="code-line"><span class="token property">$1</span><span>$2</span>');
                return `{${highlightedBlock}}`;
            });
        }
        highlightInlineProperties(code) {
            return code.replace(/(\s*)([a-zA-Z-]+)(\s*:)/g, '$1<span class="token property">$2</span><span>$3</span>');
        }
        format(css) {
            css = css.replace(/\s+/g, " ").trim();
            const parts = this.splitByBraces(css);
            let formatted = "";
            let indentLevel = 0;
            const indentSize = 2;
            for (let i = 0; i < parts.length; i++) {
                const part = parts[i];
                if (part === "{") {
                    formatted += `${" ".repeat(indentLevel * indentSize)}{\n`;
                    indentLevel++;
                }
                else if (part === "}") {
                    indentLevel--;
                    formatted += `${" ".repeat(indentLevel * indentSize)}}\n`;
                }
                else if (i > 0 && parts[i - 1] === "{") {
                    formatted += this.formatProperties(part, indentLevel, indentSize);
                }
                else {
                    formatted += this.formatSelectors(part, indentLevel, indentSize);
                }
            }
            return formatted.trim();
        }
        splitByBraces(css) {
            const result = [];
            let current = "";
            let inString = false;
            let stringChar = "";
            let inComment = false;
            let escapeNext = false;
            for (let i = 0; i < css.length; i++) {
                const char = css[i];
                const nextChar = css[i + 1];
                if (escapeNext) {
                    current += char;
                    escapeNext = false;
                    continue;
                }
                if (inComment) {
                    current += char;
                    if (char === "*" && nextChar === "/") {
                        current += "/";
                        i++;
                        inComment = false;
                    }
                    continue;
                }
                if (inString) {
                    current += char;
                    if (char === "\\") {
                        escapeNext = true;
                    }
                    else if (char === stringChar) {
                        inString = false;
                    }
                    continue;
                }
                if (char === "/" && nextChar === "*") {
                    current += "/*";
                    i++;
                    inComment = true;
                    continue;
                }
                if (char === '"' || char === "'") {
                    current += char;
                    stringChar = char;
                    inString = true;
                    continue;
                }
                if (char === "{" || char === "}") {
                    if (current.trim()) {
                        result.push(current.trim());
                    }
                    result.push(char);
                    current = "";
                }
                else {
                    current += char;
                }
            }
            if (current.trim()) {
                result.push(current.trim());
            }
            return result;
        }
        formatSelectors(selectors, indentLevel, indentSize) {
            const selectorList = selectors.split(/,\s*(?![^{]*})/);
            let formatted = "";
            for (let i = 0; i < selectorList.length; i++) {
                const selector = selectorList[i].trim();
                if (selector) {
                    formatted += " ".repeat(indentLevel * indentSize) + selector;
                    if (i < selectorList.length - 1) {
                        formatted += ",\n";
                    }
                    else {
                        formatted += "\n";
                    }
                }
            }
            return formatted;
        }
        formatProperties(properties, indentLevel, indentSize) {
            const propList = properties.split(/;(?![^{]*})/);
            let formatted = "";
            for (let i = 0; i < propList.length; i++) {
                const prop = propList[i].trim();
                if (prop) {
                    const parts = prop.split(/:\s*(?![^{]*})/);
                    if (parts.length === 2) {
                        const [property, value] = parts;
                        formatted += `${" ".repeat(indentLevel * indentSize)
                            + property.trim()}: ${value.trim()};\n`;
                    }
                    else {
                        formatted += `${" ".repeat(indentLevel * indentSize) + prop}\n`;
                    }
                }
            }
            return formatted;
        }
        async highlightJSCode(code) {
            await EC_Fmt.LoadScript("../../Controls/highlight/highlight.min.js");
            return hljs.highlight(code, { language: 'javascript' }).value;
        }
    };
    __decorate([
        ECP.attr
    ], ECPCodeSnippet.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], ECPCodeSnippet.prototype, "label", void 0);
    __decorate([
        ECP.attr
    ], ECPCodeSnippet.prototype, "language", void 0);
    ECPCodeSnippet = __decorate([
        ECP.customElement({
            name: "ecp-code-snippet",
            template: `<pre><div class="code-container"></div></pre>`,
            styles: `
        ::-webkit-scrollbar{
            width:8px;
            height:8px;
            background-color:var(--layer-2)
        }
        ::-webkit-scrollbar-thumb{
            background:var(--neutral-40);
            width:8px;
            height:8px;
            border-radius:10px
        }
        .inline{
            display:inline-flex;
            padding:0px 8px;
            justify-content:center;
            align-items:center;
            border-radius:4px;
            background:var(--bg-object)
        }
        .inline:hover{
            background:var(--neutral-t8) !important
        }
        .inline:pressed{
            background:var(--neutral-t16)
        }
        .ecp-body{
            color:var(--text);
            font-size:var(--body-font-size);
            font-weight:var(--regular-weight);
            line-height:var(--body-line-height)
        }
        .con{
            display:flex;
            gap:8px;
            position:relative;
            justify-content:space-between
        }
        .content{
            padding:16px 16px 0 16px;
            border-radius:4px;
            background:var(--bg)
        }
        .padding-16{
            padding:16px
        }
        .code {
            font-family:"Inconsolata", Monaco, Consolas, "Andale Mono", monospace
        }
        .single{
            display:flex;
            align-items:center;
            flex-wrap:wrap
        }
        .single .attribute{
            margin-left:6px
        }
        .multi{
            max-height:160px;
            overflow:auto;
            padding-right:28px;
            margin-right:12px;
            flex:1
        }
        .show-more{
            display:flex;
            height:64px;
            justify-content:center;
            align-items:center;
            gap:6px;
            cursor:pointer
        }
        .copy-btn{
            position:absolute;
            right:0;
        }
        .tag{
            color:var(--text-accent-category-1)
        }
        .attribute {
            color:var(--text-accent-category-2);
        }
        .value{
            color:var(--text-accent-category-3)
        }
        .code-indent{
            padding-left:10px
        }
        .margin-top-12{
            margin-top:12px
        }
        .token.comment { color: #6a9955; }
        .token.selector { color: var(--text-accent-category-1)}
        .token.property { color: var(--blue-70); }
        .token.function { color: var(--yellow-60); }
        .token.atrule { color: #c586c0; }
        .token.rule { color: #c586c0; }
        .token.important { color: var(--blue-90);}
        .token.number, .token.unit { color: var(--green-60); }
        .token.hexcode { color: #b5cea8; }
        .token.keyword { color: #569cd6; }
        .token.operator { color: #d4d4d4; }
        .token.url { color: #ce9178; }
        .token.var { color: var(--text-accent-category-3);}
        .token.value {color: var(--text);}
        .center {
            align-items: center;
        }
        pre {
            display:inline-block;
            margin:0
        }
        .code-line .token.property {
            display: inline-block;
            text-indent: 2em;
        }
        .code-media .code-line:not(:last-child) {
            margin-left: 2em
        }
    `,
        })
    ], ECPCodeSnippet);
    ECP.ECPCodeSnippet = ECPCodeSnippet;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPSection = class ECPSection extends ECP.Component {
        constructor() {
            super(...arguments);
            this.type = "object";
        }
        iconChanged(oldValue, newValue) {
            const iconEl = this.shadowRoot.querySelector(".icon");
            if (newValue && newValue !== oldValue) {
                iconEl.className = `icon ${newValue}`;
            }
            else {
                iconEl.className = `icon hidden`;
            }
        }
        headingChanged(oldValue, newValue) {
            if (newValue !== oldValue) {
                const titleEl = this.shadowRoot.querySelector(".title");
                const subTitleEl = this.shadowRoot.querySelector(".subtitle");
                titleEl.innerHTML = newValue;
                if (newValue == null || newValue == undefined || newValue == "") {
                    subTitleEl.classList.add("primary");
                }
                else if (subTitleEl.classList.contains("primary")) {
                    subTitleEl.classList.remove("primary");
                }
            }
        }
        subtitleChanged(oldValue, newValue) {
            const subtitleEl = this.shadowRoot.querySelector(".subtitle");
            if (newValue && newValue !== oldValue) {
                const val = newValue.split(";");
                if (val.length > 1) {
                    subtitleEl.innerHTML = "";
                    const wrapper = document.createElement("div");
                    wrapper.className = "dot-cutoff";
                    const left = document.createElement("div");
                    left.innerHTML = val[0];
                    const center = document.createElement("div");
                    center.className = "dot";
                    center.setAttribute("aria-hidden", "true");
                    const right = document.createElement("div");
                    right.innerHTML = val[1];
                    wrapper.appendChild(left);
                    wrapper.appendChild(center);
                    wrapper.appendChild(right);
                    subtitleEl.appendChild(wrapper);
                }
                else {
                    subtitleEl.innerHTML = newValue;
                }
                if (!this.heading) {
                    subtitleEl.classList.add("primary");
                }
            }
            else {
                subtitleEl.innerHTML = "";
            }
        }
        typeChanged(oldValue, newValue) {
            const sectionEl = this.shadowRoot.querySelector(".section");
            if (!sectionEl)
                return;
            const isActionType = newValue?.toLowerCase() === "action";
            sectionEl.classList.toggle("action", isActionType);
            const btns = this.querySelectorAll("ecp-section-right-option ecp-btn[type=ghost], " +
                "ecp-section-option ecp-btn[type=ghost]");
            if (btns.length > 0) {
                btns.forEach(btn => {
                    btn.toggleAttribute("inverted", isActionType);
                });
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPSection.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], ECPSection.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], ECPSection.prototype, "heading", void 0);
    __decorate([
        ECP.attr
    ], ECPSection.prototype, "subtitle", void 0);
    ECPSection = __decorate([
        ECP.customElement({
            name: "ecp-section",
            template: `<div class=section>
            <div class=header>
                <div class="flex ecp-body">
                    <span class="icon hidden" aria-hidden="true"></span>
                    <div>
                        <div class=title></div>
                        <div class=subtitle></div>
                    </div>
                    <slot name=normal></slot>
                </div>
                <slot name="right"></slot>
            </div>
            <div class=content>
                <slot name="content"></slot>
            </div>
            <div class=footer>
                <slot name="footer"></slot>
            </div>
        </div>`,
            styles: `
:host{
display:flex;
flex-direction:column
}
a {
border: none;
text-decoration: none;
}
.section:not(.action) .title a:link,
.section:not(.action) .title a:visited,
.section:not(.action) .title a:active,
.section:not(.action) .subtitle a:link,
.section:not(.action) .subtitle a:visited,
.section:not(.action) .subtitle a:active {
color: var(--text-link);
}
.section:not(.action) .title a:hover,
.section:not(.action) .subtitle a:hover {
color: var(--text-link-hover);
}
.section.action .title a:link,
.section.action .title a:visited,
.section.action .title a:active,
.section.action .subtitle a:link,
.section.action .subtitle a:visited,
.section.action .subtitle a:active {
color: var(--text-link-onbg-action);
}
.section.action .title a:hover,
.section.action .subtitle a:hover {
color: var(--text-link-onbg-action-hover);
}
.section{
display:flex;
height:auto;
/* EC-33525: the cap keeps a section readable on a wide page, but a data-table section on an
   ultra-wide monitor wants the width - a page opts out with --ecp-section-max-width. Default
   unchanged. */
max-width:var(--ecp-section-max-width, 1557px);
flex-direction:column;
align-items:center;
border-radius:8px;
padding:8px 4px 4px 4px;
background:var(--bg-object)
}
.action{
background:var(--bg-action) !important
}
.action .title{
color:var(--text-onbg-action)
}
.action .subtitle,
.action .icon {
color:var(--text-secondary-onbg-action)
}
.action .dot{
background:var(--text-secondary-onbg-action)
}
.header{
display:flex;
padding:0px 20px 8px 20px;
justify-content:space-between;
align-items:center;
align-self:stretch;
min-height:36px;
box-sizing:border-box;
}
.flex{
display:flex;
align-items:baseline;
gap:8px;
}
.icon{
width:16px;
height:16px;
color:var(--text-secondary)
}
.title{
color:var(--text);
font-size:var(--body-font-size);
font-weight:var(--semibold-weight);
line-height:var(--body-line-height)
}
.subtitle{
color:var(--text-secondary);
font-size:var(--bodysm-font-size);
line-height:var(--bodysm-line-height);
font-weight:var(--regular-weight);
}
.dot-cutoff{
display:flex;
align-items:center;
gap:8px
}
.subtitle.primary{
line-height:var(--body-line-height);
font-weight:var(--semibold-weight);
}
.dot{
width:2px;
height:2px;
background:var(--text-secondary);
border-radius:50%
}
.content, .footer{
width:100%
}
.content {
flex: 1;
overflow: auto;
}
.hidden{
display:none
}`,
            enableIcon: true
        })
    ], ECPSection);
    ECP.ECPSection = ECPSection;
    let ECPSectionSubHeader = class ECPSectionSubHeader extends ECP.Component {
        iconChanged(oldValue, newValue) {
            const iconEl = this.shadowRoot.querySelector(".icon");
            if (newValue && newValue !== oldValue) {
                iconEl.className = `icon ${newValue}`;
            }
            else {
                iconEl.className = `icon hidden`;
            }
        }
        headingChanged(oldValue, newValue) {
            if (newValue !== oldValue) {
                const titleEl = this.shadowRoot.querySelector(".title");
                const subTitleEl = this.shadowRoot.querySelector(".subtitle");
                titleEl.innerHTML = newValue;
                if (newValue == null || newValue == undefined || newValue == "") {
                    subTitleEl.classList.add("primary");
                }
                else if (subTitleEl.classList.contains("primary")) {
                    subTitleEl.classList.remove("primary");
                }
            }
        }
        subtitleChanged(oldValue, newValue) {
            const subtitleEl = this.shadowRoot.querySelector(".subtitle");
            if (newValue && newValue !== oldValue) {
                const val = newValue.split(";");
                if (val.length > 1) {
                    subtitleEl.innerHTML = "";
                    const wrapper = document.createElement("div");
                    wrapper.className = "dot-cutoff";
                    const left = document.createElement("div");
                    left.innerHTML = val[0];
                    const center = document.createElement("div");
                    center.className = "dot";
                    center.setAttribute("aria-hidden", "true");
                    const right = document.createElement("div");
                    right.innerHTML = val[1];
                    wrapper.appendChild(left);
                    wrapper.appendChild(center);
                    wrapper.appendChild(right);
                    subtitleEl.appendChild(wrapper);
                }
                else {
                    subtitleEl.innerHTML = newValue;
                }
                if (!this.heading) {
                    subtitleEl.classList.add("primary");
                }
            }
            else {
                subtitleEl.innerHTML = "";
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPSectionSubHeader.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], ECPSectionSubHeader.prototype, "heading", void 0);
    __decorate([
        ECP.attr
    ], ECPSectionSubHeader.prototype, "subtitle", void 0);
    ECPSectionSubHeader = __decorate([
        ECP.customElement({
            name: "ecp-section-subheader",
            template: `<div class=header>
                <div class="flex ecp-body">
                    <span class="icon hidden"></span>
                    <div>
                        <div class=title></div>
                        <div class=subtitle></div>
                    </div>
                    <slot name=normal></slot>
                </div>
                <slot name="right"></slot>
            </div>`,
            styles: `
:host{
display:block;
width:100%
}
a {
border: none;
text-decoration: none;
}
.header .title a:link,
.header .title a:visited,
.header .title a:active,
.header .subtitle a:link,
.header .subtitle a:visited,
.header .subtitle a:active {
color: var(--text-link);
}
.header .title a:hover,
.header .subtitle a:hover {
color: var(--text-link-hover);
}
.header{
display:flex;
padding:8px 20px;
justify-content:space-between;
align-items:center;
align-self:stretch;
min-height:40px;
box-sizing:border-box;
}
.flex{
display:flex;
align-items:baseline;
gap:8px;
}
.icon{
width:16px;
height:16px;
color:var(--text-secondary)
}
.title{
color:var(--text);
font-size:var(--body-font-size);
font-weight:var(--semibold-weight);
line-height:var(--body-line-height)
}
.subtitle{
color:var(--text-secondary);
font-size:var(--bodysm-font-size);
line-height:var(--bodysm-line-height);
font-weight:var(--regular-weight);
}
.dot-cutoff{
display:flex;
align-items:center;
gap:8px
}
.subtitle.primary{
line-height:var(--body-line-height);
font-weight:var(--semibold-weight);
}
.dot{
width:2px;
height:2px;
background:var(--text-secondary);
border-radius:50%
}
.hidden{
display:none
}`,
            enableIcon: true
        })
    ], ECPSectionSubHeader);
    ECP.ECPSectionSubHeader = ECPSectionSubHeader;
    let ECPSectionRightOption = class ECPSectionRightOption extends ECP.Component {
    };
    ECPSectionRightOption = __decorate([
        ECP.customElement({
            name: "ecp-section-option",
            template: `<div class=option><slot></slot></div>`,
            styles: `
.option{
display:flex;
align-items:center;
gap:8px
}
:host ::slotted(ecp-btn){
margin-right:0!important
}`
        })
    ], ECPSectionRightOption);
    ECP.ECPSectionRightOption = ECPSectionRightOption;
    let ECPSectionContent = class ECPSectionContent extends ECP.Component {
        constructor() {
            super(...arguments);
            this.padding = false;
            this.active = false;
            this.selected = false;
            this.hover = false;
            this.warning = false;
            this.error = false;
        }
        paddingChanged(oldValue, newValue) {
            const sectionContent = this.shadowRoot.querySelector(".content");
            if (newValue && newValue !== oldValue) {
                sectionContent.classList.add("padding");
            }
            else {
                sectionContent.classList.remove("padding");
            }
        }
        hoverChanged(oldValue, newValue) {
            const sectionContent = this.shadowRoot.querySelector(".content");
            if (newValue && newValue !== oldValue) {
                sectionContent.classList.toggle("hover", true);
            }
            else {
                sectionContent.classList.toggle("hover", false);
            }
        }
        activeChanged(oldValue, newValue) {
            const sectionContent = this.shadowRoot.querySelector(".content");
            if (newValue && newValue !== oldValue) {
                sectionContent.classList.toggle("active", true);
            }
            else {
                sectionContent.classList.toggle("active", false);
            }
        }
        selectedChanged(oldValue, newValue) {
            const sectionContent = this.shadowRoot.querySelector(".content");
            if (newValue && newValue !== oldValue) {
                sectionContent.classList.toggle("selected", true);
            }
            else {
                sectionContent.classList.toggle("selected", false);
            }
        }
        warningChanged(oldValue, newValue) {
            const sectionContent = this.shadowRoot.querySelector(".content");
            if (newValue && newValue !== oldValue) {
                sectionContent.classList.toggle("warning", true);
            }
            else {
                sectionContent.classList.toggle("warning", false);
            }
        }
        errorChanged(oldValue, newValue) {
            const sectionContent = this.shadowRoot.querySelector(".content");
            if (newValue && newValue !== oldValue) {
                sectionContent.classList.toggle("error", true);
            }
            else {
                sectionContent.classList.toggle("error", false);
            }
        }
    };
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSectionContent.prototype, "padding", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSectionContent.prototype, "active", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSectionContent.prototype, "selected", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSectionContent.prototype, "hover", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSectionContent.prototype, "warning", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPSectionContent.prototype, "error", void 0);
    ECPSectionContent = __decorate([
        ECP.customElement({
            name: "ecp-section-content",
            template: `<div class=content><slot></slot></div>`,
            styles: `
:host{
display:block
}
.content{
border-radius:4px;
background:var(--layer-2);
width:100%;
height:100%;
box-sizing:border-box;
display:flex;
flex-direction:column;
border:1px solid transparent;
transition:background var(--ecp-duration-fastest) var(--ecp-ease-standard),border-color var(--ecp-duration-fastest) var(--ecp-ease-standard);
}
.content.hover:hover {
    background:linear-gradient(var(--bg-hover), var(--bg-hover)), var(--bg);
}
.content.active,
.content.selected {
    background:linear-gradient(var(--bg-selected), var(--bg-selected)), var(--bg);
    border-color:var(--border-selected);
}
.content.warning {
    background:linear-gradient(var(--bg-warning-secondary), var(--bg-warning-secondary)), var(--bg);
    border-color:var(--border-warning);
}
.content.error {
    background:linear-gradient(var(--bg-error-secondary), var(--bg-error-secondary)), var(--bg);
    border-color:var(--border-error);
}
.padding{
padding:20px
}`
        })
    ], ECPSectionContent);
    ECP.ECPSectionContent = ECPSectionContent;
    let ECPSectionFooter = class ECPSectionFooter extends ECP.Component {
    };
    ECPSectionFooter = __decorate([
        ECP.customElement({
            name: "ecp-section-footer",
            template: `<div class=footer><slot></slot></div>`,
            styles: `
:host{
display:block
}
.footer{
padding:8px 20px;
width:100%;
box-sizing:border-box
}`
        })
    ], ECPSectionFooter);
    ECP.ECPSectionFooter = ECPSectionFooter;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    const brandColorMap = {
        "Blue": "blue",
        "Navy Blue": "blue-bold",
        "Slate Blue": "navy-bold",
        "Steel Blue": "navy",
        "Sky Blue": "blue",
        "Forest Green": "green",
        "Olive Green": "green-bold",
        "Sea Green": "green-bold",
        "Lime Green": "green",
        "Yellow Green": "green",
        "Gold": "yellow",
        "Golden Rod": "yellow-bold",
        "Medium Yellow": "yellow",
        "Dark Yellow": "green",
        "Khaki": "green",
        "Saddle Brown": "orange-bold",
        "Brown": "orange",
        "Chocolate Brown": "orange",
        "Orange": "orange",
        "Dark Orange": "orange-bold",
        "Orange Red": "orange-bold",
        "Red": "red",
        "Tomato Red": "red",
        "Firebrick Red": "red-bold",
        "Crimson": "red-bold",
        "Salmon": "orange",
        "Pink": "magenta",
        "Dark Pink": "magenta-bold",
        "Rosy Brown": "red",
        "Maroon": "magenta-bold",
        "Violet Red": "magenta-bold",
        "Magenta": "magenta",
        "Violet": "magenta",
        "Orchid Purple": "purple",
        "Purple": "purple",
        "Medium Purple": "purple-bold",
        "Black": "gray-bold",
        "Light Grey": "gray",
        "Dark Grey": "gray"
    };
    function getBrandTokens(identifierColor) {
        if (identifierColor.endsWith("-bold")) {
            const base = identifierColor.replace("-bold", "");
            return {
                bg: `var(--bg-accent-${base}-bold)`,
                icon: `var(--icon-accent-${base}-bolder)`
            };
        }
        return {
            bg: `var(--bg-accent-${identifierColor})`,
            icon: `var(--icon-accent-${identifierColor}-bold)`
        };
    }
    class LRUCache {
        constructor(maxSize = 1000) {
            this.cache = new Map();
            this.maxSize = maxSize;
        }
        get(key) {
            if (!this.cache.has(key))
                return undefined;
            const value = this.cache.get(key);
            this.cache.delete(key);
            this.cache.set(key, value);
            return value;
        }
        set(key, value) {
            if (this.cache.has(key)) {
                this.cache.delete(key);
            }
            else if (this.cache.size >= this.maxSize) {
                const firstKey = this.cache.keys().next().value;
                this.cache.delete(firstKey);
            }
            this.cache.set(key, value);
        }
        has(key) {
            return this.cache.has(key);
        }
        clear() {
            this.cache.clear();
        }
        size() {
            return this.cache.size;
        }
    }
    const brandColorCache = new LRUCache(1000);
    const brandColorInflight = new Map();
    const pendingBrandResolvers = new Map();
    let batchBrandScheduled = false;
    const productBrandCache = new LRUCache(1000);
    const productBrandInflight = new Map();
    const pendingProductResolvers = new Map();
    let batchProductScheduled = false;
    function splitIntoChunks(items, size) {
        const chunks = [];
        for (let i = 0; i < items.length; i += size) {
            chunks.push(items.slice(i, i + size));
        }
        return chunks;
    }
    function extractSrcFromPicture(picture) {
        const match = picture.match(/<img\b[^>]*\bsrc\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'=<>`]+))/i);
        return match?.[1] || match?.[2] || match?.[3];
    }
    async function runWithConcurrency(items, limit, worker) {
        const workerCount = Math.min(limit, items.length);
        let index = 0;
        const workers = Array.from({ length: workerCount }, async () => {
            while (true) {
                const currentIndex = index;
                index += 1;
                if (currentIndex >= items.length)
                    return;
                await worker(items[currentIndex]);
            }
        });
        await Promise.all(workers);
    }
    const userInfoCache = new LRUCache(1000);
    const userInfoInflight = new Map();
    const pendingUserResolvers = new Map();
    let batchUserScheduled = false;
    async function resolveUserInfo(userId) {
        const cacheKey = userId.toString();
        if (userInfoCache.has(cacheKey)) {
            return userInfoCache.get(cacheKey);
        }
        if (userInfoInflight.has(cacheKey)) {
            return userInfoInflight.get(cacheKey);
        }
        let resolve;
        const promise = new Promise(res => { resolve = res; });
        userInfoInflight.set(cacheKey, promise);
        pendingUserResolvers.set(cacheKey, resolve);
        if (!batchUserScheduled) {
            batchUserScheduled = true;
            queueMicrotask(async () => {
                batchUserScheduled = false;
                const ids = [...pendingUserResolvers.keys()];
                const resolvers = new Map(pendingUserResolvers);
                pendingUserResolvers.clear();
                const results = new Map();
                const chunks = splitIntoChunks(ids, 200);
                await runWithConcurrency(chunks, 4, async (chunk) => {
                    try {
                        const view = new ECP.EC_TableView("Users");
                        view.SetFormat("json");
                        view.AddColumn("UserID");
                        view.AddColumn("Picture");
                        view.AddColumn("Name");
                        view.AddFilter("UserID", chunk.join("^"), ECP.EC_Operator.In);
                        view.SetMaxRecords(chunk.length);
                        const data = await view.GetResults();
                        const rs = new ECP.EC_Recordset(data);
                        while (!rs.EOF) {
                            const id = (rs.Item("UserID_DBValue") || rs.Item("UserID"))?.toString();
                            if (id)
                                results.set(id, { picture: rs.Item("Picture"), name: rs.Item("Name") });
                            rs.MoveNext();
                        }
                    }
                    catch { }
                });
                for (const [id, res] of resolvers) {
                    const info = results.get(id) || { picture: "", name: "" };
                    if (results.has(id)) {
                        userInfoCache.set(id, info);
                    }
                    userInfoInflight.delete(id);
                    res(info);
                }
            });
        }
        return promise;
    }
    async function resolveBrandColor(brandId) {
        const cacheKey = brandId.toString();
        if (brandColorCache.has(cacheKey)) {
            return brandColorCache.get(cacheKey);
        }
        if (brandColorInflight.has(cacheKey)) {
            return brandColorInflight.get(cacheKey);
        }
        let resolve;
        const promise = new Promise(res => { resolve = res; });
        brandColorInflight.set(cacheKey, promise);
        pendingBrandResolvers.set(cacheKey, resolve);
        if (!batchBrandScheduled) {
            batchBrandScheduled = true;
            queueMicrotask(async () => {
                batchBrandScheduled = false;
                const ids = [...pendingBrandResolvers.keys()];
                const resolvers = new Map(pendingBrandResolvers);
                pendingBrandResolvers.clear();
                const results = new Map();
                const chunks = splitIntoChunks(ids, 200);
                await runWithConcurrency(chunks, 4, async (chunk) => {
                    try {
                        const view = new ECP.EC_TableView("Brands");
                        view.SetFormat("json");
                        view.AddColumn("BrandID");
                        view.AddColumn("Color");
                        view.AddFilter("BrandID", chunk.join("^"), ECP.EC_Operator.In);
                        view.SetMaxRecords(chunk.length);
                        const data = await view.GetResults();
                        const rs = new ECP.EC_Recordset(data);
                        while (!rs.EOF) {
                            const id = (rs.Item("BrandID_DBValue") || rs.Item("BrandID"))?.toString();
                            if (id)
                                results.set(id, rs.Item("Color") || "");
                            rs.MoveNext();
                        }
                    }
                    catch { }
                });
                for (const [id, res] of resolvers) {
                    const color = results.get(id) || "";
                    if (results.has(id)) {
                        brandColorCache.set(id, color);
                    }
                    brandColorInflight.delete(id);
                    res(color);
                }
            });
        }
        return promise;
    }
    async function resolveProductBrand(productId) {
        const cacheKey = productId.toString();
        if (productBrandCache.has(cacheKey)) {
            return productBrandCache.get(cacheKey);
        }
        if (productBrandInflight.has(cacheKey)) {
            return productBrandInflight.get(cacheKey);
        }
        let resolve;
        const promise = new Promise(res => { resolve = res; });
        productBrandInflight.set(cacheKey, promise);
        pendingProductResolvers.set(cacheKey, resolve);
        if (!batchProductScheduled) {
            batchProductScheduled = true;
            queueMicrotask(async () => {
                batchProductScheduled = false;
                const ids = [...pendingProductResolvers.keys()];
                const resolvers = new Map(pendingProductResolvers);
                pendingProductResolvers.clear();
                const results = new Map();
                const chunks = splitIntoChunks(ids, 200);
                await runWithConcurrency(chunks, 4, async (chunk) => {
                    try {
                        const view = new ECP.EC_TableView("Products");
                        view.SetFormat("json");
                        view.AddColumn("ProductID");
                        view.AddColumn("BrandID");
                        view.AddColumn("BrandID_DBValue");
                        view.AddFilter("ProductID", chunk.join("^"), ECP.EC_Operator.In);
                        view.SetMaxRecords(chunk.length);
                        const data = await view.GetResults();
                        const rs = new ECP.EC_Recordset(data);
                        while (!rs.EOF) {
                            const id = (rs.Item("ProductID_DBValue") || rs.Item("ProductID"))?.toString();
                            if (id) {
                                const rawBrandId = (rs.Item("BrandID_DBValue") || rs.Item("BrandID") || "").toString();
                                const normalizedBrandId = rawBrandId.includes(",") ? rawBrandId.split(",")[0].trim() : rawBrandId.trim();
                                results.set(id, normalizedBrandId);
                            }
                            rs.MoveNext();
                        }
                    }
                    catch { }
                });
                for (const [id, res] of resolvers) {
                    const brandId = results.get(id) || "";
                    if (results.has(id)) {
                        productBrandCache.set(id, brandId);
                    }
                    productBrandInflight.delete(id);
                    res(brandId);
                }
            });
        }
        return promise;
    }
    let ECPIdentifier = class ECPIdentifier extends ECP.Component {
        constructor() {
            super(...arguments);
            this.rendered = false;
            this.infoRequestVersion = 0;
            this.typeNormalized = null;
        }
        beginInfoRequest() {
            this.infoRequestVersion += 1;
            return this.infoRequestVersion;
        }
        invalidateInfoRequest() {
            this.infoRequestVersion += 1;
        }
        isCurrentInfoRequest(requestVersion) {
            return this.infoRequestVersion === requestVersion;
        }
        created() {
            this.typeNormalized = this.type?.toLowerCase() || null;
            if (!this.rendered)
                this.render();
        }
        render() {
            const root = this.shadowRoot;
            root.querySelectorAll(".avatar-container, .brand-container").forEach(el => el.remove());
            if (this.isBrandType()) {
                const container = document.createElement("div");
                container.className = "brand-container";
                const icon = document.createElement("span");
                icon.className = "brand-icon ews-icon-product";
                container.appendChild(icon);
                root.appendChild(container);
            }
            else {
                const container = document.createElement("div");
                container.className = "avatar-container";
                const img = document.createElement("img");
                img.className = "avatar hidden";
                const i = document.createElement("i");
                i.className = "default ews-icon-user";
                container.appendChild(img);
                container.appendChild(i);
                root.appendChild(container);
            }
            this.rendered = true;
        }
        keyvalueChanged(oldValue, newValue) {
            if (!this.rendered)
                return;
            if (newValue) {
                this.getInfo();
            }
            else {
                this.invalidateInfoRequest();
                if (this.isBrandType()) {
                    this.resetBrand();
                }
                else {
                    const avatarEl = this.shadowRoot?.querySelector(".avatar");
                    const defaultEl = this.shadowRoot?.querySelector(".default");
                    if (avatarEl)
                        avatarEl.classList.add("hidden");
                    if (defaultEl)
                        defaultEl.className = "default ews-icon-user";
                }
            }
        }
        typeChanged(oldValue, newValue) {
            this.typeNormalized = newValue?.toLowerCase() || null;
            this.render();
            if (this.keyvalue)
                this.getInfo();
            else {
                this.invalidateInfoRequest();
                if (this.isBrandType())
                    this.resetBrand();
            }
        }
        isBrandType() {
            return this.typeNormalized === "brand" || this.typeNormalized === "product";
        }
        resetBrand() {
            let container = this.shadowRoot?.querySelector(".brand-container");
            if (!container) {
                container = document.createElement("div");
                container.className = "brand-container";
                const icon = document.createElement("span");
                icon.className = "brand-icon ews-icon-product";
                container.appendChild(icon);
                this.shadowRoot?.appendChild(container);
            }
            const icon = container?.querySelector(".brand-icon");
            if (icon) {
                const tokens = getBrandTokens("gray");
                container.style.background = tokens.bg;
                icon.style.color = tokens.icon;
            }
        }
        applyBrandColor(colorValue) {
            const colorName = colorValue.split(",").pop()?.trim() || colorValue;
            const identifierColor = brandColorMap[colorName] || "gray";
            const tokens = getBrandTokens(identifierColor);
            const container = this.shadowRoot?.querySelector(".brand-container");
            const icon = this.shadowRoot?.querySelector(".brand-icon");
            if (container && icon) {
                container.style.background = tokens.bg;
                icon.style.color = tokens.icon;
            }
        }
        async getInfo() {
            const requestVersion = this.beginInfoRequest();
            if (this.typeNormalized === "brand") {
                await this.getBrandInfo(requestVersion);
            }
            else if (this.typeNormalized === "product") {
                await this.getProductInfo(requestVersion);
            }
            else {
                await this.getUserInfo(requestVersion);
            }
        }
        async getBrandInfo(requestVersion) {
            try {
                const colorValue = await resolveBrandColor(this.keyvalue);
                if (!this.isCurrentInfoRequest(requestVersion))
                    return;
                if (colorValue) {
                    this.applyBrandColor(colorValue);
                }
                else {
                    this.resetBrand();
                }
            }
            catch {
                if (!this.isCurrentInfoRequest(requestVersion))
                    return;
                this.resetBrand();
            }
        }
        async getProductInfo(requestVersion) {
            try {
                const brandId = await resolveProductBrand(this.keyvalue);
                if (!this.isCurrentInfoRequest(requestVersion))
                    return;
                if (!brandId) {
                    this.resetBrand();
                    return;
                }
                const colorValue = await resolveBrandColor(brandId);
                if (!this.isCurrentInfoRequest(requestVersion))
                    return;
                if (colorValue) {
                    this.applyBrandColor(colorValue);
                }
                else {
                    this.resetBrand();
                }
            }
            catch {
                if (!this.isCurrentInfoRequest(requestVersion))
                    return;
                this.resetBrand();
            }
        }
        async getUserInfo(requestVersion) {
            const userInfo = await resolveUserInfo(this.keyvalue);
            if (!this.isCurrentInfoRequest(requestVersion))
                return;
            const avatarEl = this.shadowRoot?.querySelector(".avatar");
            const defaultEl = this.shadowRoot?.querySelector(".default");
            if (!avatarEl || !defaultEl)
                return;
            if (userInfo.picture) {
                const src = extractSrcFromPicture(userInfo.picture);
                if (src) {
                    avatarEl.src = src;
                    avatarEl.classList.remove("hidden");
                    defaultEl.classList.add("hidden");
                }
                else {
                    avatarEl.classList.add("hidden");
                    defaultEl.className = "default ews-icon-user";
                }
            }
            else {
                avatarEl.classList.add("hidden");
                defaultEl.className = "default ews-icon-user";
            }
        }
        srcChanged(oldValue, newValue) {
            if (this.isBrandType() || this.keyvalue)
                return;
            const avatarEl = this.shadowRoot?.querySelector(".avatar");
            const defaultEl = this.shadowRoot?.querySelector(".default");
            if (!avatarEl || !defaultEl)
                return;
            if (newValue) {
                avatarEl.src = newValue;
                avatarEl.classList.remove("hidden");
                defaultEl.classList.add("hidden");
            }
            else {
                avatarEl.classList.add("hidden");
                defaultEl.classList.remove("hidden");
            }
        }
        iconChanged(oldValue, newValue) {
            if (this.isBrandType() || this.keyvalue || this.src)
                return;
            const defaultEl = this.shadowRoot?.querySelector(".default");
            const avatarEl = this.shadowRoot?.querySelector(".avatar");
            if (!defaultEl || !avatarEl)
                return;
            if (newValue) {
                defaultEl.className = `default ${newValue}`;
                defaultEl.classList.remove("hidden");
                avatarEl.classList.add("hidden");
            }
            else {
                defaultEl.classList.add("hidden");
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPIdentifier.prototype, "keyvalue", void 0);
    __decorate([
        ECP.attr
    ], ECPIdentifier.prototype, "src", void 0);
    __decorate([
        ECP.attr
    ], ECPIdentifier.prototype, "type", void 0);
    __decorate([
        ECP.attr
    ], ECPIdentifier.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], ECPIdentifier.prototype, "shape", void 0);
    ECPIdentifier = __decorate([
        ECP.customElement({
            name: "ecp-identifier",
            template: ``,
            styles: `
:host{
display:inline-flex
}
.avatar-container{
width:40px;
height:40px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
line-height:1;
background:var(--bg-object)
}
.avatar{
width:100%;
height:100%;
border-radius:50%
}
.default{
color:var(--text-secondary)
}
.brand-container{
width:24px;
height:24px;
border-radius:4px;
display:flex;
align-items:center;
justify-content:center;
position:relative;
background:var(--bg-accent-gray)
}
.brand-icon{
position:absolute;
top:50%;
left:50%;
transform:translate(-50%,-50%);
line-height:1!important;
color:var(--icon-accent-gray-bold)
}
.hidden{
display:none!important
}`,
            enableIcon: true
        })
    ], ECPIdentifier);
    ECP.ECPIdentifier = ECPIdentifier;
    let ECPChatSection = class ECPChatSection extends ECP.Component {
        created() {
            if (this.UserID && this.Sender && this.Sender.toLowerCase() !== "agent") {
                this.getInfo();
            }
        }
        UserIDChanged(oldValue, newValue) {
            if (newValue && this.Sender && this.Sender.toLowerCase() !== "agent") {
                this.getInfo();
            }
        }
        async getInfo() {
            const userInfo = await resolveUserInfo(this.UserID);
            const identifiedEl = this.shadowRoot?.querySelector("ecp-identifier");
            const dotEl = this.shadowRoot?.querySelector(".dot");
            const usernameEl = this.shadowRoot?.querySelector(".username");
            if (!identifiedEl || !dotEl || !usernameEl)
                return;
            if (userInfo.picture) {
                const src = extractSrcFromPicture(userInfo.picture);
                if (src) {
                    identifiedEl.src = src;
                }
                dotEl.classList.remove("hidden");
            }
            else {
                identifiedEl.src = "";
                if (!userInfo.name) {
                    dotEl.classList.add("hidden");
                }
            }
            usernameEl.textContent = userInfo.name || "";
            if (!userInfo.name) {
                dotEl.classList.add("hidden");
            }
        }
        TimestampChanged(oldValue, newValue) {
            if (newValue) {
                this.shadowRoot.querySelector(".time").textContent = newValue;
            }
        }
        SenderChanged(oldValue, newValue) {
            const messageEl = this.shadowRoot.querySelector(".message");
            if (newValue) {
                messageEl.classList.remove("other", "self");
                this.shadowRoot.querySelector(".chat-container").classList.remove("reverse");
                this.shadowRoot.querySelector(".title").classList.remove("reverse");
                this.shadowRoot.querySelector(".AI").classList.add("hidden");
                if (newValue.toLowerCase() === "other") {
                    messageEl.classList.add("other");
                }
                else if (newValue.toLowerCase() === "self") {
                    messageEl.classList.add("self");
                    this.shadowRoot.querySelector(".chat-container").classList.add("reverse");
                    this.shadowRoot.querySelector(".title").classList.add("reverse");
                }
                else {
                    this.shadowRoot.querySelector("ecp-identifier").classList.add("hidden");
                    this.shadowRoot.querySelector(".AI").classList.remove("hidden");
                    this.shadowRoot.querySelector(".username").textContent = "Agent";
                }
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPChatSection.prototype, "UserID", void 0);
    __decorate([
        ECP.attr
    ], ECPChatSection.prototype, "Sender", void 0);
    __decorate([
        ECP.attr
    ], ECPChatSection.prototype, "Timestamp", void 0);
    ECPChatSection = __decorate([
        ECP.customElement({
            name: "ecp-chatmessage",
            template: `<div class=chat-container><ecp-identifier></ecp-identifier><ecp-chip icon="ews-icon-spark" color="teal" class="AI hidden">AI</ecp-chip><div><div class=title><div class=username></div><div class=dot></div><div class=time></div></div><div class=message><slot></slot></div></div></div>`,
            styles: `
:host{
display:block
}
.chat-container{
display:flex;
gap:16px
}
.title{
display:flex;
gap:8px;
align-items:center
}
.username{
color:var(--text);
font-size:var(--body-font-size);
font-weight:var(--semibold-weight);
line-height:var(--body-line-height)
}
.dot{
width:2px;
height:2px;
background:var(--text-secondary);
border-radius:50%;
}
.time{
color:var(--text-secondary);
font-size:var(--bodysm-font-size);
font-weight:var(--regular-weight);
line-height:var(--bodysm-line-height)
}
.message{
color:var(--text);
font-size:var(--body-font-size);
font-weight:var(--regular-weight);
line-height:var(--body-line-height);
border-radius:4px;
margin-top:8px
}
.self{
background:var(--layer-special);
padding:12px 16px
}
.other{
background:var(--layer-1);
padding:12px 16px
}
.hidden{
display:none!important
}
.reverse{
flex-direction:row-reverse
}`,
            enableIcon: true
        })
    ], ECPChatSection);
    ECP.ECPChatSection = ECPChatSection;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPShortcutGroup = class ECPShortcutGroup extends ECP.Component {
        constructor() {
            super(...arguments);
            this.type = "default";
        }
        typeChanged(oldValue, newValue) {
            const defaultEl = this.shadowRoot.querySelector(".group");
            if (newValue.toLocaleLowerCase() === "button") {
                defaultEl.classList.add("margin-left");
            }
            else if (newValue.toLocaleLowerCase() === "input") {
                defaultEl.classList.add("margin-left");
                this.setAttribute("slot", "shortcut");
            }
            else if (!newValue || newValue.toLocaleLowerCase() === "default") {
                defaultEl.classList.remove("margin-left");
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPShortcutGroup.prototype, "type", void 0);
    ECPShortcutGroup = __decorate([
        ECP.customElement({
            name: "ecp-shortcut-group",
            template: `<div class="group"><slot></slot></div>`,
            styles: `
:host{
display:inline-flex;
align-items:center;
vertical-align:middle;
width:fit-content
}
.group{
display:inline-flex;
align-items:center;
gap:1px
}
.margin-left{
margin-left:10px
}
::slotted(ecp-shortcut:first-child){
border-radius: 9999px 0 0 9999px;
}
::slotted(ecp-shortcut:last-child){
border-radius: 0 9999px 9999px 0;
}
::slotted(ecp-shortcut:not(:first-child):not(:last-child)){
border-radius:0;
}`
        })
    ], ECPShortcutGroup);
    ECP.ECPShortcutGroup = ECPShortcutGroup;
    let ECPShortcut = class ECPShortcut extends ECP.Component {
        constructor() {
            super(...arguments);
            this.type = "default";
        }
        typeChanged(oldValue, newValue) {
            const node = this.parentElement;
            if (newValue && node.tagName.toLocaleLowerCase() !== "ecp-shortcut-group") {
                if (newValue.toLocaleLowerCase() === "button") {
                    this.classList.add("margin-left-10");
                }
                else if (newValue.toLocaleLowerCase() === "input") {
                    this.classList.add("margin-left-10");
                    this.setAttribute("slot", "shortcut");
                }
                else if (!newValue || newValue.toLocaleLowerCase() === "default") {
                    this.classList.remove("margin-left-10");
                }
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPShortcut.prototype, "type", void 0);
    ECPShortcut = __decorate([
        ECP.customElement({
            name: "ecp-shortcut",
            template: `<div class=container><slot></slot></div>`,
            styles: `
:host{
border-radius:9999px;
border:1px solid var(--divider);
background:linear-gradient(0deg, var(--bg-object) 0%, var(--bg-object) 100%), var(--bg);;
box-sizing:border-box!important;
display:inline-flex;
vertical-align:middle;
height:20px;
width:fit-content;
padding:2px 8px;
justify-content:center;
align-items:center;
color:var(--text);
font-size:var(--bodysm-font-size);
font-weight:var(--semibold-weight);
line-height:var(--bodysm-line-height)
}
.container{
display:inline-flex;
align-items:center;
justify-content:center;
}
::slotted([class*="ews-icon-"]){
display:inline-flex;
align-items:center;
justify-content:center;
line-height:1
}`,
            enableIcon: true
        })
    ], ECPShortcut);
    ECP.ECPShortcut = ECPShortcut;
})(ECP || (ECP = {}));
var ECP;
(function (ECP) {
    let ECPMapPin = class ECPMapPin extends ECP.Component {
        constructor() {
            super(...arguments);
            this.color = "action";
            this.selected = false;
        }
        colorChanged(oldValue, newValue) {
            this.color = newValue ? newValue.toLowerCase() : "action";
            const div = this.shadowRoot.querySelector(".chips");
            div?.setAttribute("color", this.color);
        }
        iconChanged(oldValue, newValue) {
            const iconEl = this.shadowRoot.querySelector(".icon");
            iconEl.setAttribute("class", `icon ${EC_Fmt.isNull(newValue) ? "ews-icon-location" : newValue}`);
        }
        labelChanged(oldValue, newValue) {
            const labelEl = this.shadowRoot.querySelector(".label-text");
            if (EC_Fmt.isNull(newValue)) {
                labelEl.classList.add("hidden");
            }
            else {
                labelEl.textContent = newValue;
                labelEl.classList.remove("hidden");
                if (this.selected) {
                    labelEl.classList.add("selected-label-text");
                }
                else {
                    labelEl.classList.remove("selected-label-text");
                }
            }
        }
        attributeChanged(oldValue, newValue) {
            const attributeEl = this.shadowRoot.querySelector(".content");
            const div = this.shadowRoot.querySelector(".chip");
            if (EC_Fmt.isNull(newValue)) {
                attributeEl.classList.add("hidden");
                div.classList.add("icon-width");
            }
            else {
                attributeEl.textContent = newValue;
                attributeEl.classList.remove("hidden");
                div.classList.remove("icon-width");
            }
        }
        selectedChanged(oldValue, newValue) {
            const div = this.shadowRoot.querySelector(".selected-border");
            const labelEl = this.shadowRoot.querySelector(".label-text");
            if (newValue) {
                div.classList.add("selected");
                if (this.label) {
                    labelEl.classList.add("selected-label-text");
                }
            }
            else {
                div.classList.remove("selected");
                labelEl.classList.remove("selected-label-text");
            }
        }
    };
    __decorate([
        ECP.attr
    ], ECPMapPin.prototype, "color", void 0);
    __decorate([
        ECP.attr
    ], ECPMapPin.prototype, "icon", void 0);
    __decorate([
        ECP.attr
    ], ECPMapPin.prototype, "label", void 0);
    __decorate([
        ECP.attr
    ], ECPMapPin.prototype, "attribute", void 0);
    __decorate([
        ECP.attr({ mode: "boolean" })
    ], ECPMapPin.prototype, "selected", void 0);
    ECPMapPin = __decorate([
        ECP.customElement({
            name: "ecp-map-pin",
            template: `<div class=pin><div class="chips"><div class="selected-border"><div class="chip icon-width"><div class="icon"></div><div class="content ecp-bodysm hidden"></div></div>
<div class="badge"><slot></slot></div></div><div class="triangle"></div><div class="dot"></div></div><div class="label-text hidden"></div></div>`,
            styles: `
:host{
display:inline-flex
}
.hidden{
display:none
}
.pin{
display:flex;
gap:8px
}
.icon-width{
width:24px
}
.chip{
height:24px;
padding:1px 0px;
gap:0px;
align-items:center;
border-radius:4px;
overflow:hidden;
box-sizing:border-box;
display:inline-flex;
line-height:18px;
font-size:var(--bodysm-font-size);
font-weight:var(--semibold-weight);
border:1px solid transparent;
justify-content:center;
background:var(--bg-action)
}
.content{
background:var(--bg);
color:var(--text);
padding:0px 8px;
height:22px;
line-height:22px;
box-sizing:border-box;
border-radius:3px
}
.chip .icon{
width:16px;
height:16px;
margin:0px 4px;
flex:0 0 auto;
display:flex;
align-items:center;
justify-content:center;
font-size:var(--body-font-size);
line-height:0;
color:var(--text-onbg-action)
}
.chip:not(.icon-width) .icon::before{
transform:translateX(-1px)
}
.chips[color="action"] .chip{
background:var(--bg-action)
}
.chips[color="error"] .chip{
background:var(--bg-error)
}
.chips[color="error"] .triangle{
border-top:4px solid var(--bg-error)
}
.chips[color="error"] .dot{
border:1px solid var(--bg-error)
}
.chips[color="error"] .selected{
border:2px solid var(--bg-error);
}
.chips[color="warning"] .chip{
background:var(--bg-warning);
}
.chips[color="warning"] .triangle{
border-top:4px solid var(--bg-warning)
}
.chips[color="warning"] .dot{
border:1px solid var(--bg-warning)
}
.chips[color="warning"] .selected{
border:2px solid var(--bg-warning);
}
.chips[color="success"] .chip{
background:var(--bg-success)
}
.chips[color="success"] .triangle{
border-top:4px solid var(--bg-success)
}
.chips[color="success"] .dot{
border:1px solid var(--bg-success)
}
.chips[color="success"] .selected{
border:2px solid var(--bg-success);
}
.chips[color="gray"] .chip{
background:var(--bg-accent-gray-bolder)
}
.chips[color="gray"] .triangle{
border-top:4px solid var(--bg-accent-gray-bolder)
}
.chips[color="gray"] .dot{
border:1px solid var(--bg-accent-gray-bolder)
}
.chips[color="gray"] .selected{
border:2px solid var(--bg-accent-gray-bolder);
}
.chips[color="orange"] .chip{
background:var(--bg-accent-orange-bolder)
}
.chips[color="orange"] .triangle{
border-top:4px solid var(--bg-accent-orange-bolder)
}
.chips[color="orange"] .dot{
border:1px solid var(--bg-accent-orange-bolder)
}
.chips[color="orange"] .selected{
border:2px solid var(--bg-accent-orange-bolder);
}
.chips[color="green"] .chip{
background:var(--bg-accent-green-bolder)
}
.chips[color="green"] .triangle{
border-top:4px solid var(--bg-accent-green-bolder)
}
.chips[color="green"] .dot{
border:1px solid var(--bg-accent-green-bolder)
}
.chips[color="green"] .selected{
border:2px solid var(--bg-accent-green-bolder);
}
.chips[color="teal"] .chip{
background:var(--bg-accent-teal-bolder)
}
.chips[color="teal"] .triangle{
border-top:4px solid var(--bg-accent-teal-bolder)
}
.chips[color="teal"] .dot{
border:1px solid var(--bg-accent-teal-bolder)
}
.chips[color="teal"] .selected{
border:2px solid var(--bg-accent-teal-bolder);
}
.chips[color="blue"] .chip{
background:var(--bg-accent-blue-bolder);
}
.chips[color="blue"] .triangle{
border-top:4px solid var(--bg-accent-blue-bolder)
}
.chips[color="blue"] .dot{
border:1px solid var(--bg-accent-blue-bolder)
}
.chips[color="blue"] .selected{
border:2px solid var(--bg-accent-blue-bolder);
}
.chips[color="navy"] .chip{
background:var(--bg-accent-navy-bolder)
}
.chips[color="navy"] .triangle{
border-top:4px solid var(--bg-accent-navy-bolder)
}
.chips[color="navy"] .dot{
border:1px solid var(--bg-accent-navy-bolder)
}
.chips[color="navy"] .selected{
border:2px solid var(--bg-accent-navy-bolder);
}
.chips[color="purple"] .chip{
background:var(--bg-accent-purple-bolder)
}
.chips[color="purple"] .triangle{
border-top:4px solid var(--bg-accent-purple-bolder)
}
.chips[color="purple"] .dot{
border:1px solid var(--bg-accent-purple-bolder)
}
.chips[color="purple"] .selected{
border:2px solid var(--bg-accent-purple-bolder);
}
.chips[color="magenta"] .chip{
background:var(--bg-accent-magenta-bolder);
}
.chips[color="magenta"] .triangle{
border-top:4px solid var(--bg-accent-magenta-bolder)
}
.chips[color="magenta"] .dot{
border:1px solid var(--bg-accent-magenta-bolder)
}
.chips[color="magenta"] .selected{
border:2px solid var(--bg-accent-magenta-bolder);
}
.selected-border{
box-shadow:0px 3px 5px 0px rgba(0, 0, 0, 0.2);
position:relative;
border-radius:4px
}
.selected{
border:2px solid var(--bg-action);
padding:0 2px;
border-radius:8px;
height:28px;
box-sizing:border-box;
display:flex;
align-items:center
}
.dot{
width:4px;
height:4px;
border-radius:50%;
background:var(--bg);
border:1px solid var(--bg-action);
margin:0 auto;
box-sizing:border-box
}
.triangle{
width:0px;
height:0px;
border-left:4px solid transparent;
border-right:4px solid transparent;
border-top:4px solid var(--bg-action);
margin:0px auto 2px
}
.label-text{
height:20px;
background:transparent;
color:var(--text);
font-size:var(--body-font-size);
font-weight:var(--semibold-weight);
line-height:var(--body-line-height);
box-sizing:border-box;
white-space:nowrap;
text-stroke:3px var(--bg);
-webkit-text-stroke:3px var(--bg);
paint-order:stroke fill;
text-shadow:0px 4px 8px rgba(0,0,0,.24)
}
.selected-label-text{
height:28px;
line-height:28px
}
.badge{
position:absolute;
top:-8px;
left:100%;
margin-left:-7px
}`,
            enableIcon: true
        })
    ], ECPMapPin);
    ECP.ECPMapPin = ECPMapPin;
})(ECP || (ECP = {}));
//# sourceMappingURL=ECP.js.map